import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client/react';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
};

export type AcceptOrderInput = {
  acceptedPONumber?: InputMaybe<Scalars['String']['input']>;
  acceptedProducts?: InputMaybe<Array<AcceptedProductInput>>;
  chatId: Scalars['String']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  deliveryDate: Scalars['AWSTimestamp']['input'];
  /** Reviewer marks the order as a top-up order on approve; persisted on the omnichannel order and forwarded to orderCreateV2. */
  isTopUp?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['ID']['input'];
  /** @deprecated use acceptedProducts */
  products?: InputMaybe<Array<OrderedProductInput>>;
  supplierId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  validationMode?: InputMaybe<OrderValidationMode | '%future added value'>;
};

export type AcceptOrderResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | InvalidProductsFailure | MinimumOrderableAmountFailure | Order | OrderAlreadyAccepted | OrderCreatedError | OrderMinimumOrderValueFailure | OrderValidationFailures | ProductLeadTimeFailure | ProductsUnavailableFailure;

/**
 * Filter options for accepted order search
 * All filters are optional and applied with AND logic
 * All date fields use YYYY-MM-DD format (e.g., "2025-12-25")
 */
export type AcceptedOrderSearchFilter = {
  /** Filter by acceptance context */
  acceptedByContext?: InputMaybe<OrderAcceptedByContext | '%future added value'>;
  /** Filter by whether order was accepted with exceptions */
  acceptedWithExceptions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by chat IDs */
  chatIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by UUID of user who confirmed the order */
  confirmedBy?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter orders created after this date (inclusive)
   * Format: YYYY-MM-DD (e.g., "2025-12-20")
   */
  createdAfter?: InputMaybe<Scalars['AWSDate']['input']>;
  /**
   * Filter orders created before this date (exclusive)
   * Format: YYYY-MM-DD (e.g., "2025-12-31")
   */
  createdBefore?: InputMaybe<Scalars['AWSDate']['input']>;
  /** Filter by UUID of user who created the order */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** Filter by customer labels assigned to the chat */
  customerLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * Filter orders with delivery date after this date (inclusive)
   * Format: YYYY-MM-DD (e.g., "2025-12-25")
   */
  deliveryDateAfter?: InputMaybe<Scalars['AWSDate']['input']>;
  /**
   * Filter orders with delivery date before this date (exclusive)
   * Format: YYYY-MM-DD (e.g., "2025-12-31")
   */
  deliveryDateBefore?: InputMaybe<Scalars['AWSDate']['input']>;
  /** Filter by whether order has delivery comment/notes */
  hasDeliveryComment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether the order has a reported error */
  hasReportedError?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by whether the order has been edited */
  isEdited?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by order creation context (see OrderCreatedContext enum) */
  orderedVia?: InputMaybe<Array<InputMaybe<OrderCreatedContext | '%future added value'>>>;
  /** Filter by the original sender of the order */
  originalSender?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter orders received after this date (inclusive)
   * Format: YYYY-MM-DD (e.g., "2025-12-20")
   */
  receivedAfter?: InputMaybe<Scalars['AWSDate']['input']>;
  /**
   * Filter orders received before this date (exclusive)
   * Format: YYYY-MM-DD (e.g., "2025-12-30")
   */
  receivedBefore?: InputMaybe<Scalars['AWSDate']['input']>;
  /** Filter by order status */
  status?: InputMaybe<OrderStatus | '%future added value'>;
  /** Filter by supplier ID */
  supplierId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by supplier reference ID */
  supplierRefId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Complete input for accepted order search
 * Searches across: chat.restaurantName, chat.chatName, buyer.name, poNumber, referenceId, buyerRefId
 * Uses prefix matching and fuzzy matching for typo tolerance
 * All fields are optional - if no filters are provided, returns all orders belonging to the logged in user's supplier
 */
export type AcceptedOrderSearchInput = {
  /** Filter options to narrow results (optional) */
  filter?: InputMaybe<AcceptedOrderSearchFilter>;
  /** Pagination configuration (optional, defaults to first: 10) */
  pagination?: InputMaybe<AcceptedOrderSearchPagination>;
  /**
   * Search term - will match across restaurant name, chat name, buyer name, PO number, reference ID, and buyer ref ID
   * Optional - if omitted, returns all orders matching the filter criteria
   * Minimum length: 2 characters, Maximum length: 100 characters
   */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** Sort configuration (optional, defaults to createdAt desc) */
  sort?: InputMaybe<AcceptedOrderSearchSort>;
};

/** Pagination input for cursor-based pagination */
export type AcceptedOrderSearchPagination = {
  /** Cursor to fetch results after this position */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * Number of results to return
   * Must be between 1-300 (default: 10)
   */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Sort configuration for accepted order search */
export type AcceptedOrderSearchSort = {
  /** Field to sort by */
  field: AcceptedOrderSearchSortField | '%future added value';
  /** Sort order (ascending or descending) */
  order: SortOrder | '%future added value';
};

/** Sort fields available for accepted order search */
export const AcceptedOrderSearchSortField = {
  /** Sort by order creation time */
  CreatedAt: 'createdAt',
  /** Sort by order creation context (see OrderCreatedContext enum) */
  CreatedContext: 'createdContext',
  /** Sort by customer name */
  CustomerName: 'customerName',
  /** Sort by delivery date */
  DeliveryDate: 'deliveryDate',
  /** Sort by number of products in the order */
  NumberOfProducts: 'numberOfProducts',
  /** Sort by original sender */
  OriginalSender: 'originalSender',
  /** Sort by purchase order number */
  PoNumber: 'poNumber',
  /** Sort by order received time */
  ReceivedAt: 'receivedAt',
  /** Sort by order status (see OrderStatus enum) */
  Status: 'status'
} as const;

export type AcceptedOrderSearchSortField = typeof AcceptedOrderSearchSortField[keyof typeof AcceptedOrderSearchSortField];
export type AcceptedProduct = {
  __typename?: 'AcceptedProduct';
  acceptedAmount: Scalars['Float']['output'];
  acceptedProductId: Scalars['String']['output'];
  acceptedProductPrice?: Maybe<Scalars['Int']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  lineItemId: Scalars['ID']['output'];
  omnichannelOrderId: Scalars['String']['output'];
};

export type AcceptedProductInput = {
  /**
   * Accepted base-unit price for catchweight/dual-unit products.
   * Same format as acceptedProductPrice (integer cents, currency inferred from the catalog).
   * Sent by the reviewer when the product has a per-lb/kg price distinct from the ordering-unit price.
   */
  acceptedBasePrice?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Base unit code (e.g. "lb", "kg") for catchweight/dual-unit products.
   * Sent by the reviewer to ensure WYSIWYG — the persisted value matches what was displayed during review.
   */
  acceptedBaseUnitCode?: InputMaybe<Scalars['String']['input']>;
  acceptedProductPrice?: InputMaybe<Scalars['Int']['input']>;
  acceptedPurchasedPrice?: InputMaybe<MoneyInput>;
  amount: Scalars['Float']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  ignoreEdits?: InputMaybe<Array<IgnoreEdits | '%future added value'>>;
  /**
   * Flag indicating whether the price for this product was edited by the vendor during order review.
   * When true, it means the vendor modified the original price of the product.
   * The price referenced here is the acceptedProductPrice.
   */
  isPriceEditedByVendor?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use lineItemId */
  parsedProductId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export const AccessPackage = {
  Free: 'free',
  LeadGen: 'leadGen',
  Premium: 'premium',
  Trial: 'trial',
  Verified: 'verified'
} as const;

export type AccessPackage = typeof AccessPackage[keyof typeof AccessPackage];
export type Account = {
  __typename?: 'Account';
  /** The ID of the account. */
  id: Scalars['ID']['output'];
  /** The account owner user. Null if no account owner is set. */
  owner?: Maybe<User>;
};

/** Account ownership related input to assign or remove relationships between chat and owner user. */
export type AccountOwnerAssignment = {
  /** The ID of the chat to assign an owner to */
  chatId: Scalars['ID']['input'];
  /**
   * The ID of the user to assign as owner (Sales Rep or Supplier Admin).
   * Null or empty to remove the owner.
   */
  ownerUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type ActionButton = {
  __typename?: 'ActionButton';
  /** The action button ID. */
  id: Scalars['ID']['output'];
  /** Button label. */
  label: Scalars['String']['output'];
  /** Position in the list (1, 2, 3, etc.) */
  listPosition: Scalars['Int']['output'];
  /** Button URL. */
  url: Scalars['String']['output'];
};

export type ActionButtonInput = {
  /** Button label. Max 30 characters. */
  label: Scalars['String']['input'];
  /** Position in the list (1, 2, 3, etc.) */
  listPosition: Scalars['Int']['input'];
  /** Button URL. */
  url: Scalars['String']['input'];
};

export const ActionExportMethod = {
  Polling: 'POLLING',
  Webhook: 'WEBHOOK'
} as const;

export type ActionExportMethod = typeof ActionExportMethod[keyof typeof ActionExportMethod];
/**
 * Returned when there is already an active magic code for this chat.
 * This occurs when:
 * - An existing magic code for this chat is not expired
 * - An existing magic code for this chat has not been invalidated
 * Only one active magic code can exist per chat at a time.
 */
export type ActiveMagicCodeAlreadyExistsError = AppsyncError & AppsyncResponse & {
  __typename?: 'ActiveMagicCodeAlreadyExistsError';
  /** Optional human-readable message describing the error */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to error */
  responseType: ResponseType | '%future added value';
};

export type Ad = AdInterface & {
  __typename?: 'Ad';
  adMetadata: AdMetadata;
  campaignId: Scalars['String']['output'];
  /** union type of all available ad type custom template contents */
  content: AdContent;
  id: Scalars['ID']['output'];
  /** Buyer segment ID */
  segmentId: Scalars['ID']['output'];
  /** Choco Ad type : Kevel custom template enum */
  tracking: AdTracking;
};

export const AdCategory = {
  Info: 'Info',
  Shoppable: 'Shoppable'
} as const;

export type AdCategory = typeof AdCategory[keyof typeof AdCategory];
export type AdContent = MobileHomePageBannerInfoFullWidthContent | MobileHomePageBannerShoppableFullWidthContent | MobileHomePagePopupInfoFullPageContent | MobileOrderGuideBannerShoppableFullWidthContent | MobilePostOrderPopupInfoFullPageContent | WebHomePageBannerInfoFullWidthContent | WebHomePageBannerInfoHalfWidthContent | WebHomePageBannerShoppableFullWidthContent | WebHomePageBannerShoppableHalfWidthContent | WebHomePagePopupInfoFullPageContent | WebPostOrderPopupInfoFullPageContent;

export type AdInterface = {
  adMetadata: AdMetadata;
  campaignId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AdMetadata = {
  __typename?: 'AdMetadata';
  /** URL to track ad clicks */
  clickUrl?: Maybe<Scalars['String']['output']>;
  /** URL to track ad impressions */
  impressionUrl?: Maybe<Scalars['String']['output']>;
};

export type AdTracking = {
  __typename?: 'AdTracking';
  clickUrl: Scalars['String']['output'];
  impressionUrl: Scalars['String']['output'];
  metadata: AdTrackingMetadata;
};

export type AdTrackingMetadata = {
  __typename?: 'AdTrackingMetadata';
  adCategory: AdCategory | '%future added value';
  adId: Scalars['String']['output'];
  adPlatform: Platform | '%future added value';
  adType: Scalars['String']['output'];
  adZone: AdZone | '%future added value';
  advertiserId: Scalars['String']['output'];
  appId: Scalars['String']['output'];
  buyerId: Scalars['String']['output'];
  campaignId: Scalars['String']['output'];
  creativeId: Scalars['String']['output'];
  flightId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export const AdZone = {
  /** LEGACY! Full page advertisement = PostOrderPopup */
  FullPageAd: 'FullPageAd',
  /** Banner ad displayed on the home page */
  HomePageBanner: 'HomePageBanner',
  /** Popup ad displayed on Home Page */
  HomePagePopup: 'HomePagePopup',
  /** Banner ad displayed in the order guide */
  OrderGuideBanner: 'OrderGuideBanner',
  /** Popup ad displayed after order is placed */
  PostOrderPopup: 'PostOrderPopup'
} as const;

export type AdZone = typeof AdZone[keyof typeof AdZone];
export type AddBuyerStockInventoryProductFailure = {
  __typename?: 'AddBuyerStockInventoryProductFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type AddBuyerStockInventoryProductInput = {
  buyerId: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price?: InputMaybe<MoneyInput>;
  productId?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type AddBuyerStockInventoryProductResponse = AddBuyerStockInventoryProductFailure | AuthorizationFailure | BuyerStockInventoryProduct | InputValidationFailure | ProductNotFoundError | SupplierNotFound;

export type AddMarketingProductsToCartInput = {
  /** The amounts of products items to add or remove from the cart */
  amount: Scalars['Float']['input'];
  /** The id of the product */
  productId: Scalars['ID']['input'];
};

export type AddMarketingProductsToCartResponse = AddMarketingProductsToCartSuccess | AuthorizationFailure | InputValidationFailure;

export type AddMarketingProductsToCartSuccess = {
  __typename?: 'AddMarketingProductsToCartSuccess';
  responseType: ResponseType | '%future added value';
  teamCartData: AddMarketingProductsToCartTeamCartData;
};

export type AddMarketingProductsToCartTeamCartData = TeamCartExists | TeamCartNotFound;

export type AddProductToOrderGuidesInput = {
  categoryName?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['ID']['input'];
};

export type AddProductsToOrderGuidesInput = {
  chatIds: Array<Scalars['ID']['input']>;
  products: Array<AddProductToOrderGuidesInput>;
  sourceChatId: Scalars['ID']['input'];
};

export type AddProductsToOrderGuidesResponse = AddProductsToOrderGuidesResult | AuthorizationFailure | InputValidationFailure;

export type AddProductsToOrderGuidesResult = AppsyncResponse & {
  __typename?: 'AddProductsToOrderGuidesResult';
  locations: Array<LocationProductsResult>;
  responseType: ResponseType | '%future added value';
  transactionId: Scalars['String']['output'];
};

export type AddQuoteItemCommandInput = {
  price: MoneyV2Input;
  quantity: DecimalInput;
  vendorItemUnitId: Scalars['ID']['input'];
};

export type AddSalesRepDetailsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderPreference: Array<AddSalesRepOrderPref | '%future added value'>;
  phoneNumber: Scalars['String']['input'];
};

export type AddSalesRepError = AppsyncError & AppsyncResponse & {
  __typename?: 'AddSalesRepError';
  errorCode?: Maybe<AddSalesRepErrorCode | '%future added value'>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export const AddSalesRepErrorCode = {
  GenericError: 'genericError',
  PhoneIsLandlineError: 'phoneIsLandlineError',
  UserExistsAndBelongsToBuyerError: 'userExistsAndBelongsToBuyerError',
  UserExistsAndBelongsToDifferentSupplierError: 'userExistsAndBelongsToDifferentSupplierError',
  UserExistsAndHasNoOrderPreferenceError: 'userExistsAndHasNoOrderPreferenceError'
} as const;

export type AddSalesRepErrorCode = typeof AddSalesRepErrorCode[keyof typeof AddSalesRepErrorCode];
export const AddSalesRepOrderPref = {
  Email: 'email',
  Sms: 'sms',
  WhatsApp: 'whatsApp'
} as const;

export type AddSalesRepOrderPref = typeof AddSalesRepOrderPref[keyof typeof AddSalesRepOrderPref];
export type AddSalesRepRequestToJoinInput = {
  chatId: Scalars['String']['input'];
  salesRepDetails: AddSalesRepDetailsInput;
};

export type AddSalesRepRequestToJoinResponse = AddSalesRepError | AddSalesRepSuccess | AuthorizationFailure | InputValidationFailure;

export type AddSalesRepSuccess = {
  __typename?: 'AddSalesRepSuccess';
  addSalesRepRequestId: Scalars['String']['output'];
  salesRepUserId: Scalars['String']['output'];
};

/**
 * Nested fees container; mirrors committed Order.additionalFees. Exposes
 * deliveryFee only today: add service/packing fields here later without
 * reshaping EvaluatedCart.
 */
export type AdditionalFees = {
  __typename?: 'AdditionalFees';
  /**
   * Delivery fee domain outcome (status/issues wrapper). A supplier with no
   * delivery fee configured is NOT_APPLICABLE with a null value; a reached
   * free-delivery tier is OK with amount 0.
   */
  deliveryFee: DeliveryFeeResult;
};

export const AddressSource = {
  Custom: 'custom',
  Google: 'google'
} as const;

export type AddressSource = typeof AddressSource[keyof typeof AddressSource];
export type AdminProductInput = {
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  baseUnit?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  buyerName?: InputMaybe<Scalars['String']['input']>;
  buyerPrice?: InputMaybe<MoneyInput>;
  category?: InputMaybe<Scalars['String']['input']>;
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Price in ¢
   *
   * have in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = '135'
   *    currency = 'USD'
   *
   * 1.35 € ->
   *    cost = '135'
   *    currency = 'EUR'
   *
   * 1.3 CLF ->
   *    cost = '1300'
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = '135'
   *    currency = 'GNF'
   *
   * Products with the cost:'135.45' will be considered invalid
   */
  cost?: InputMaybe<Scalars['String']['input']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: InputMaybe<Scalars['String']['input']>;
  cutOffTime?: InputMaybe<Scalars['AWSTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['ID']['input']>;
  imageUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  invoiceUnit?: InputMaybe<Scalars['String']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  listPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumFractionalAmount?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  packSize?: InputMaybe<Scalars['String']['input']>;
  par?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  primaryCatalogCategory?: InputMaybe<Scalars['String']['input']>;
  subCatalogs?: InputMaybe<Array<Scalars['ID']['input']>>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  variantTypes?: InputMaybe<Scalars['String']['input']>;
};

export type AdvanceSalesFunnelLeadInput = {
  leadId: Scalars['ID']['input'];
  /** Note, not the name, the unique identifier */
  newStateId: Scalars['ID']['input'];
};

export type AdvanceSalesFunnelLeadResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelLead;

/** An inbound phone number routed to a supplier's agent. */
export type AgentPhoneNumber = {
  __typename?: 'AgentPhoneNumber';
  id: Scalars['ID']['output'];
  /**
   * The number as provisioned, in E.164 form (e.g. +44756000999); the leading
   * `+` may be absent. Format it for display on the client.
   */
  phoneNumber: Scalars['String']['output'];
};

export const AgentProfileType = {
  VoiceOrderAgent: 'VoiceOrderAgent'
} as const;

export type AgentProfileType = typeof AgentProfileType[keyof typeof AgentProfileType];
export type AgentSession = {
  __typename?: 'AgentSession';
  agentProfileType: AgentProfileType | '%future added value';
  agentProfileVariant: Scalars['String']['output'];
  agentProfileVersion: Scalars['String']['output'];
  buyerId?: Maybe<Scalars['ID']['output']>;
  channel: AgentSessionChannel | '%future added value';
  chatId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  endedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['AWSJSON']['output']>;
  startedAt: Scalars['AWSTimestamp']['output'];
  state?: Maybe<Scalars['AWSJSON']['output']>;
  status: AgentSessionStatus | '%future added value';
  supplierId?: Maybe<Scalars['ID']['output']>;
  /**
   * Null when the session predates the classification or never reached the end
   * of the call.
   */
  supplierOutcome?: Maybe<AgentSessionSupplierOutcome | '%future added value'>;
  /**
   * Null when the outcome needs no explanation (a confirmed order, or an
   * identified caller who ordered nothing), or when no outcome was recorded.
   */
  supplierOutcomeDetail?: Maybe<AgentSessionSupplierOutcomeDetail | '%future added value'>;
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export const AgentSessionChannel = {
  Pstn: 'PSTN',
  Webrtc: 'WEBRTC'
} as const;

export type AgentSessionChannel = typeof AgentSessionChannel[keyof typeof AgentSessionChannel];
export type AgentSessionConnection = {
  __typename?: 'AgentSessionConnection';
  items: Array<AgentSession>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type AgentSessionGetError = {
  __typename?: 'AgentSessionGetError';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type AgentSessionGetResponse = AgentSessionGetError | AgentSessionGetSuccess | AuthorizationFailure | InputValidationFailure;

export type AgentSessionGetSuccess = {
  __typename?: 'AgentSessionGetSuccess';
  /** Null when no session exists for the given id. */
  agentSession?: Maybe<AgentSession>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type AgentSessionListError = {
  __typename?: 'AgentSessionListError';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type AgentSessionListInput = {
  agentProfileType?: InputMaybe<AgentProfileType | '%future added value'>;
  pagination?: InputMaybe<PaginationInputV2>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Returns sessions whose outcome is any of these. Omitted or empty means no
   * outcome filter; sessions without an outcome only appear when unfiltered.
   */
  supplierOutcomes?: InputMaybe<Array<AgentSessionSupplierOutcome | '%future added value'>>;
};

export type AgentSessionListResponse = AgentSessionListError | AgentSessionListSuccess | AuthorizationFailure | InputValidationFailure;

export type AgentSessionListSuccess = {
  __typename?: 'AgentSessionListSuccess';
  connection: AgentSessionConnection;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export const AgentSessionStatus = {
  Active: 'ACTIVE',
  Completed: 'COMPLETED',
  Failed: 'FAILED'
} as const;

export type AgentSessionStatus = typeof AgentSessionStatus[keyof typeof AgentSessionStatus];
/** How a call reads to the supplier: did it leave an order, and if not, why not. */
export const AgentSessionSupplierOutcome = {
  /** The caller confirmed the order. */
  Confirmed: 'CONFIRMED',
  /** No order exists. */
  Empty: 'EMPTY',
  /** The agent referred the caller to the supplier. */
  Fallback: 'FALLBACK',
  /** An order exists in review; the caller never confirmed it. */
  Unconfirmed: 'UNCONFIRMED'
} as const;

export type AgentSessionSupplierOutcome = typeof AgentSessionSupplierOutcome[keyof typeof AgentSessionSupplierOutcome];
/** Why a call got its `AgentSessionSupplierOutcome`. */
export const AgentSessionSupplierOutcomeDetail = {
  AbnormalEnd: 'ABNORMAL_END',
  CancelledByCaller: 'CANCELLED_BY_CALLER',
  FallbackNoMatch: 'FALLBACK_NO_MATCH',
  FallbackUnfulfillable: 'FALLBACK_UNFULFILLABLE',
  HumanRequested: 'HUMAN_REQUESTED',
  UnidentifiedCaller: 'UNIDENTIFIED_CALLER'
} as const;

export type AgentSessionSupplierOutcomeDetail = typeof AgentSessionSupplierOutcomeDetail[keyof typeof AgentSessionSupplierOutcomeDetail];
export type AliasAlreadyLinked = {
  __typename?: 'AliasAlreadyLinked';
  /** Indicates the email address or phone number that the alias is already linked to. Will always be masked (e.g. ab***@****.com, +123****5678) */
  linkedAccount?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type AliasExists = {
  __typename?: 'AliasExists';
  aliasType?: Maybe<AliasType | '%future added value'>;
  message?: Maybe<Scalars['String']['output']>;
};

export const AliasType = {
  Email: 'email',
  Phone: 'phone'
} as const;

export type AliasType = typeof AliasType[keyof typeof AliasType];
export type AllowedAutoPilotCustomersConnection = Connection & {
  __typename?: 'AllowedAutoPilotCustomersConnection';
  edges: Array<AllowedAutoPilotCustomersEdge>;
  pageInfo: PageInfo;
};

export type AllowedAutoPilotCustomersEdge = Edge & {
  __typename?: 'AllowedAutoPilotCustomersEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

export type ApplicationData = {
  __typename?: 'ApplicationData';
  appName: Scalars['String']['output'];
  data?: Maybe<CredentialsData>;
  status: Scalars['String']['output'];
};

export type AppliedChatDeliverySetting = {
  __typename?: 'AppliedChatDeliverySetting';
  /** Buffer time in minutes to extend cutoff time for OrderAgent orders. Range: 0-1440 minutes (24 hours). */
  bufferInMinutes?: Maybe<Scalars['Int']['output']>;
  cutoffTimes: WeekdayBasedCutoffSettings;
  exceptions?: Maybe<Array<DeliverySettingException>>;
  /** Whether the supplier has enabled the OrderAgent smart cutoff feature */
  orderAgentSmartCutoff?: Maybe<Scalars['Boolean']['output']>;
  /** Supplier time zone, defaults to America/Los_Angeles */
  timezone: Scalars['String']['output'];
};

export type AppliedChatDeliverySettingResponse = AppliedChatDeliverySetting | NotFoundError;

export type AppliedDeliveryFee = {
  __typename?: 'AppliedDeliveryFee';
  /** Applied delivery fee amount. Checkout owns placement on AdditionalFees. */
  amount: MoneyV2;
};

export type AppliedFreeUnitGrant = {
  __typename?: 'AppliedFreeUnitGrant';
  /**
   * Final free quantity calculated by Promotions. It already includes repeated
   * applications of the offer.
   */
  quantity: Decimal;
  /** Paid products that earned this free product. */
  sourceVendorItemUnitIds: Array<Scalars['ID']['output']>;
  /** Product granted for free. */
  vendorItemUnit: VendorItemUnitRef;
};

export type AppliedFreeUnitsEffect = AppliedPromotionEffect & {
  __typename?: 'AppliedFreeUnitsEffect';
  /**
   * Free products granted by this offer. Each grant names the free product, its
   * final quantity, and the paid products that earned it.
   */
  grants: Array<AppliedFreeUnitGrant>;
  /** Free-product rule that was applied. */
  offer: AppliedFreeUnitsOffer;
  sourceOfferId: Scalars['ID']['output'];
  sourceTierId: Scalars['ID']['output'];
};

/** Configured free-unit offer on an applied free-units effect. */
export type AppliedFreeUnitsOffer = VendorPromotionCartFreeExtraUnitsOffer | VendorPromotionFreeUnitsIncludedOffer;

/** Discount from one line-price effect allocated to one paid cart line. */
export type AppliedLinePriceAdjustment = {
  __typename?: 'AppliedLinePriceAdjustment';
  discountAmount: MoneyV2;
  vendorItemUnitId: Scalars['ID']['output'];
};

export type AppliedLinePriceEffect = AppliedPromotionEffect & {
  __typename?: 'AppliedLinePriceEffect';
  /**
   * Total discount from this offer. It equals the sum of lineAdjustments.
   * Promotions has already calculated both values; do not multiply them by
   * applicationCount.
   */
  discountAmount: MoneyV2;
  /**
   * Discount allocated to each paid cart line changed by this offer. Contains
   * one entry per affected line and at least one entry.
   */
  lineAdjustments: Array<AppliedLinePriceAdjustment>;
  /** Price rule that was applied: fixed price, reduced price, or percentage off. */
  offer: AppliedLinePriceOffer;
  sourceOfferId: Scalars['ID']['output'];
  sourceTierId: Scalars['ID']['output'];
};

/** Configured line-price offer on an applied line-price effect. */
export type AppliedLinePriceOffer = VendorPromotionDiscountPercentageOffer | VendorPromotionFixedPriceOffer | VendorPromotionReducedPriceOffer;

/**
 * Everything one promotion changed in this cart.
 *
 * Checkout matches this result to the Promotions summary using the promotion ID.
 * Each effect names the tier and offer that produced it; list positions have no
 * meaning. If the same offer applies more than once, its final amounts, quantities,
 * and affected products are combined into one effect.
 */
export type AppliedPromotion = {
  __typename?: 'AppliedPromotion';
  /**
   * Price changes and free products produced by this promotion. Read __typename
   * to determine the kind of change. There is one effect for each tier and offer.
   */
  effects: Array<AppliedPromotionEffect>;
  /** Promotion that produced these changes. */
  promotion: VendorPromotionRef;
};

/** Information shared by every price change or free-product effect. */
export type AppliedPromotionEffect = {
  /**
   * Offer that produced this effect. Always present. This ID changes when a
   * promotion is replaced or imported, so Orders must not store it permanently.
   */
  sourceOfferId: Scalars['ID']['output'];
  /** Tier that produced this effect. */
  sourceTierId: Scalars['ID']['output'];
};

/**
 * A synonym mapping that was applied to a search query, surfaced in
 * `CatalogSearchMetadata.appliedSynonyms`.
 */
export type AppliedSearchSynonym = {
  __typename?: 'AppliedSearchSynonym';
  mappedTerm: Scalars['String']['output'];
  rootTerm: Scalars['String']['output'];
};

/**
 * A count of everything matching a query, not just the page returned.
 *
 * Counting a large result set costs the same scan as reading it, so a service may
 * stop at a bound it configures and report a floor instead. The two members say
 * which you have, so a caller cannot read the number without deciding how to read
 * it — and renders "500+" from the type alone, never being told what the bound is.
 * Raising the bound is then a service config change, not a client release.
 */
export type ApproximateCount = AtLeastCount | ExactCount;

export type AppsyncError = {
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type AppsyncResponse = {
  responseType: ResponseType | '%future added value';
};

export type AssignOrderToUserForReviewInput = {
  /** Order to assign to the calling user for review. */
  omnichannelOrderId: Scalars['ID']['input'];
  /**
   * When true, take over an active review held by another user. Otherwise
   * the mutation returns OrderAlreadyInReview.
   */
  overrideExistingReviewer?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssignOrderToUserForReviewResponse = AssignOrderToUserForReviewResponseError | AssignOrderToUserForReviewResponseSuccess | InputValidationFailure | InternalServerError | OrderAlreadyInReview;

export type AssignOrderToUserForReviewResponseError = AppsyncError & AppsyncResponse & {
  __typename?: 'AssignOrderToUserForReviewResponseError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

/** Returned when the calling user is now assigned as the order's reviewer. */
export type AssignOrderToUserForReviewResponseSuccess = {
  __typename?: 'AssignOrderToUserForReviewResponseSuccess';
  /** Order that was assigned. */
  omnichannelOrderId: Scalars['ID']['output'];
  /** User now assigned as the reviewer (the caller). */
  userId: Scalars['ID']['output'];
};

export type AssignSalesFunnelLeadInput = {
  leadId: Scalars['ID']['input'];
  /** ID of the new sales rep owning this lead. */
  newAssigneeUserId: Scalars['ID']['input'];
};

export type AssignSalesFunnelLeadResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelLead;

/** Counting stopped at the service's bound, so at least this many match. */
export type AtLeastCount = {
  __typename?: 'AtLeastCount';
  count: Scalars['Int']['output'];
};

export type Attachment = BroadcastAttachment | Event | Media;

export type AttachmentOrderRef = AudioAttachmentRef | CsvAttachmentRef | HtmlAttachmentRef | ImageAttachmentRef | PdfAttachmentRef | TextAttachmentRef | XlsxAttachmentRef;

/** deprecated: use attachment.status instead */
export const AttachmentState = {
  Completed: 'completed',
  None: 'none',
  Pending: 'pending',
  Rejected: 'rejected'
} as const;

export type AttachmentState = typeof AttachmentState[keyof typeof AttachmentState];
export const AttachmentStatus = {
  Completed: 'completed',
  None: 'none',
  Pending: 'pending',
  Rejected: 'rejected'
} as const;

export type AttachmentStatus = typeof AttachmentStatus[keyof typeof AttachmentStatus];
export type AttemptToChangeAdapterAuthType = AppsyncError & AppsyncResponse & {
  __typename?: 'AttemptToChangeAdapterAuthType';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type AttemptToReduceIntegrationAdapterScope = AppsyncError & AppsyncResponse & {
  __typename?: 'AttemptToReduceIntegrationAdapterScope';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type AudioAttachmentRef = {
  __typename?: 'AudioAttachmentRef';
  omnichannelOrderId: Scalars['ID']['output'];
  timeRange: AudioTimeRange;
  transmissionAttachmentId?: Maybe<Scalars['ID']['output']>;
  transmissionId?: Maybe<Scalars['ID']['output']>;
};

export type AudioTimeRange = {
  __typename?: 'AudioTimeRange';
  endMilliseconds: Scalars['Int']['output'];
  startMilliseconds: Scalars['Int']['output'];
};

export type AudioTranscript = {
  __typename?: 'AudioTranscript';
  speaker?: Maybe<VoiceCallSpeaker | '%future added value'>;
  transcript: Scalars['String']['output'];
  words: Array<Word>;
};

export type AuthorizationFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'AuthorizationFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export const AutoPilotDefaultMode = {
  Allow: 'ALLOW',
  Block: 'BLOCK'
} as const;

export type AutoPilotDefaultMode = typeof AutoPilotDefaultMode[keyof typeof AutoPilotDefaultMode];
export type AutomaticOrderProcessingThresholdSetting = {
  __typename?: 'AutomaticOrderProcessingThresholdSetting';
  chatId?: Maybe<Scalars['ID']['output']>;
  confidenceSetting: Array<ConfidenceSetting>;
  message?: Maybe<Scalars['String']['output']>;
  supplierId: Scalars['ID']['output'];
};

export type AutomaticOrderProcessingThresholdSettingInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  confidenceSetting: Array<ConfidenceSettingInput>;
  supplierId: Scalars['ID']['input'];
};

export type AutomaticOrderProcessingThresholdSettingResponse = AuthorizationFailure | AutomaticOrderProcessingThresholdSetting | InputValidationFailure | InternalServerError | NotFoundError;

export const AutomationLevel = {
  Conservative: 'conservative',
  Optimized: 'optimized'
} as const;

export type AutomationLevel = typeof AutomationLevel[keyof typeof AutomationLevel];
export type AutomationLevelOption = {
  __typename?: 'AutomationLevelOption';
  key: AutomationLevel | '%future added value';
  value: Scalars['Float']['output'];
};

export type AutopilotOrderCreatedNotification = {
  __typename?: 'AutopilotOrderCreatedNotification';
  orderId: Scalars['ID']['output'];
  supplierId: Scalars['ID']['output'];
};

export type AutopilotSetting = {
  __typename?: 'AutopilotSetting';
  automationLevel?: Maybe<AutomationLevel | '%future added value'>;
  automationLevelOptions?: Maybe<Array<AutomationLevelOption>>;
  calibrationSampleRates?: Maybe<Array<CalibrationSampleRate>>;
  createdAt: Scalars['AWSDateTime']['output'];
  customerId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  supplierId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type AutopilotThreshold = {
  __typename?: 'AutopilotThreshold';
  createdAt: Scalars['String']['output'];
  options: Array<AutomationLevel | '%future added value'>;
  preference: AutomationLevel | '%future added value';
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export const Availability = {
  /** Product discontinued; StockValidationResult BLOCKED for paid lines. */
  Discontinued: 'DISCONTINUED',
  /** Product can be ordered for this chat/date. */
  InStock: 'IN_STOCK',
  /** Product currently unavailable; StockValidationResult BLOCKED for paid lines. */
  OutOfStock: 'OUT_OF_STOCK'
} as const;

export type Availability = typeof Availability[keyof typeof Availability];
export type AvailableDeliveryDate = {
  __typename?: 'AvailableDeliveryDate';
  /**
   * date is in format YYYY-MM-DD
   * dates are not subject to timezone conversion
   */
  date: Scalars['AWSDate']['output'];
  /**
   * leadTimeAdjustedCutoff is in format YYYY-MM-DDThh:mm:ss.sssZ
   * leadTimeAdjustedCutoff is created in supplier TZ, adjusted by leadTime and returned in UTC
   * leadTimeAdjustedCutoff is the deadline for the order submission
   */
  leadTimeAdjustedCutoff?: Maybe<Scalars['AWSDateTime']['output']>;
  type: CutOffTimeType | '%future added value';
};

export type BannerDistributorPromoAd = AdInterface & {
  __typename?: 'BannerDistributorPromoAd';
  /** Metadata for tracking and analytics */
  adMetadata: AdMetadata;
  /** Links to the campaign, used to fetch Promotion Page content */
  campaignId: Scalars['String']['output'];
  /** The primary/default chat for this distributor promo on the ad banner - made optional on purpose to support future checkout flow */
  chat?: Maybe<Chat>;
  /** The home page banner image like "Premium Sauces" */
  homePageBannerImageUrl: Scalars['String']['output'];
  /** Unique identifier for the ad */
  id: Scalars['ID']['output'];
  /** The promo page/easy ordering page banner image like "Premium Sauces" */
  promoPageBannerImageUrl: Scalars['String']['output'];
  /** The promo page description for extended information about the campaign */
  promoPageDescription: Scalars['String']['output'];
  /** The promo page title to show on home page and promo page */
  promoPageTitle: Scalars['String']['output'];
  /** The supplier of the VendorItemUnit */
  supplier: Supplier;
  /** Lists all promoted product variants. Always returns a list, which can be empty. */
  supplierVariants: Array<SupplierVendorItemUnitVariant>;
};

export type BannerInformationalAd = AdInterface & {
  __typename?: 'BannerInformationalAd';
  /** Metadata for tracking and analytics */
  adMetadata: AdMetadata;
  /** The main banner image URL like "Premium Frappe Mix" */
  bannerImageUrl: Scalars['String']['output'];
  /** ID of the campaign this ad belongs to */
  campaignId: Scalars['String']['output'];
  /** Hex value for the background color of the Call to Action button */
  ctaBackgroundColor: Scalars['String']['output'];
  /** Call to Action Label that the user will see */
  ctaLabel: Scalars['String']['output'];
  /** URL for the Call to Action button */
  ctaLink: Scalars['String']['output'];
  /** Unique identifier for the ad */
  id: Scalars['ID']['output'];
  /** ID of the buyer segment this ad targets */
  segmentId: Scalars['ID']['output'];
};

export type BannerShoppableAd = AdInterface & {
  __typename?: 'BannerShoppableAd';
  /** Metadata for tracking and analytics */
  adMetadata: AdMetadata;
  /** Links to the campaign, used to fetch Promotion Page content */
  campaignId: Scalars['String']['output'];
  /** The primary/default chat for this VIU on the ad card - made optional on purpose to support future checkout flow */
  chat?: Maybe<Chat>;
  /** The specific VendorItemUnit shown on the ad */
  featuredVendorItemUnitId: Scalars['ID']['output'];
  /** The home page banner image like "Premium Sauces" */
  homePageBannerImageUrl: Scalars['String']['output'];
  /** Unique identifier for the ad */
  id: Scalars['ID']['output'];
  /** The promo page banner image like "Premium Sauces" */
  promoPageBannerImageUrl: Scalars['String']['output'];
  /** The promo page description "Premium Sauces for your next meal bla bla bla" */
  promoPageDescription: Scalars['String']['output'];
  /** The promo page title "Brand Name" */
  promoPageTitle: Scalars['String']['output'];
  /** ID of the buyer segment this ad targets */
  segmentId: Scalars['ID']['output'];
  /** The supplier of the VendorItemUnit */
  supplier: Supplier;
  /** Lists all specific product variants. Always returns a list, which can be empty. */
  supplierVariants: Array<SupplierVendorItemUnitVariant>;
};

export type BatchOrderConfirmError = AppsyncError & AppsyncResponse & {
  __typename?: 'BatchOrderConfirmError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BatchOrderConfirmResponse = BatchOrderConfirmError | BatchOrderConfirmSuccess;

export type BatchOrderConfirmSuccess = AppsyncResponse & {
  __typename?: 'BatchOrderConfirmSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type BatchUpdateOrderSupplier = {
  __typename?: 'BatchUpdateOrderSupplier';
  chatId?: Maybe<Scalars['String']['output']>;
  /** Number of orders updated with new supplier */
  orderCount?: Maybe<Scalars['Int']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
};

export type BatchUpdateOrderSupplierInput = {
  chatId: Scalars['String']['input'];
  supplierId: Scalars['String']['input'];
  supplierPhone: Scalars['String']['input'];
  supplierRefId: Scalars['String']['input'];
};

export type BillingAddressInput = {
  city: Scalars['String']['input'];
  /** 2-letter country code as per ISO 3166 */
  countryCode: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  streetAddress: Scalars['String']['input'];
};

export type BillingDocument = {
  customer: BillingDocumentCustomer;
  dueAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  id: Scalars['ID']['output'];
  issuedAt: Scalars['AWSTimestamp']['output'];
  vendor: BillingDocumentVendor;
};

export type BillingDocumentCustomer = {
  __typename?: 'BillingDocumentCustomer';
  directPaymentCustomer?: Maybe<DirectPayPaymentCustomer>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<ProfileImage>;
};

export type BillingDocumentDownloadUrlFailure = {
  __typename?: 'BillingDocumentDownloadUrlFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BillingDocumentDownloadUrlFileDoesNotExistFailure = {
  __typename?: 'BillingDocumentDownloadUrlFileDoesNotExistFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BillingDocumentDownloadUrlInput = {
  documentId: Scalars['ID']['input'];
  format?: InputMaybe<BillingDocumentExportFormat | '%future added value'>;
};

export type BillingDocumentDownloadUrlResponse = AuthorizationFailure | BillingDocumentDownloadUrlFailure | BillingDocumentDownloadUrlFileDoesNotExistFailure | BillingDocumentDownloadUrlSuccess | InputValidationFailure;

export type BillingDocumentDownloadUrlSuccess = {
  __typename?: 'BillingDocumentDownloadUrlSuccess';
  downloadUrl: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type BillingDocumentExportCompleted = {
  __typename?: 'BillingDocumentExportCompleted';
  downloadUrl: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type BillingDocumentExportCreateFailure = {
  __typename?: 'BillingDocumentExportCreateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BillingDocumentExportCreateInput = {
  /**
   * Optional to allow for future expansion of additional filters
   * Can contain Invoice or Credit Note IDs
   */
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  format?: InputMaybe<BillingDocumentExportFormat | '%future added value'>;
};

export type BillingDocumentExportCreateResponse = AuthorizationFailure | BillingDocumentExportCreateFailure | BillingDocumentExportCreateSuccess | BillingDocumentExportInvalidDocumentsFailure | BillingDocumentExportSizeLimitExceededFailure | BillingDocumentExportTooManyDocsFailure | InputValidationFailure;

export type BillingDocumentExportCreateSuccess = {
  __typename?: 'BillingDocumentExportCreateSuccess';
  jobId: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type BillingDocumentExportFailure = {
  __typename?: 'BillingDocumentExportFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BillingDocumentExportFailureDocumentDetails = {
  __typename?: 'BillingDocumentExportFailureDocumentDetails';
  /** Missing when document itself could not be found */
  documentNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export const BillingDocumentExportFormat = {
  Csv: 'CSV',
  Pdf: 'PDF'
} as const;

export type BillingDocumentExportFormat = typeof BillingDocumentExportFormat[keyof typeof BillingDocumentExportFormat];
export type BillingDocumentExportInProgress = {
  __typename?: 'BillingDocumentExportInProgress';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type BillingDocumentExportInvalidDocumentsFailure = {
  __typename?: 'BillingDocumentExportInvalidDocumentsFailure';
  documents: Array<BillingDocumentExportFailureDocumentDetails>;
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BillingDocumentExportSizeLimitExceededFailure = {
  __typename?: 'BillingDocumentExportSizeLimitExceededFailure';
  maxSizeInBytes: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  requestedSizeInBytes: Scalars['Int']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BillingDocumentExportStatusInput = {
  jobId: Scalars['ID']['input'];
};

export type BillingDocumentExportStatusResponse = AuthorizationFailure | BillingDocumentExportCompleted | BillingDocumentExportFailure | BillingDocumentExportInProgress | InputValidationFailure;

export type BillingDocumentExportTooManyDocsFailure = {
  __typename?: 'BillingDocumentExportTooManyDocsFailure';
  maxDocumentCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  requestedDocumentCount: Scalars['Int']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BillingDocumentResultEdge = Edge & {
  __typename?: 'BillingDocumentResultEdge';
  cursor: Scalars['String']['output'];
  node: BillingDocumentResultNode;
};

export type BillingDocumentResultNode = Node & {
  __typename?: 'BillingDocumentResultNode';
  document: BillingDocument;
  id: Scalars['ID']['output'];
};

export type BillingDocumentSearchFailure = {
  __typename?: 'BillingDocumentSearchFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BillingDocumentSearchFilter = {
  documentType?: InputMaybe<Array<BillingDocumentType | '%future added value'>>;
  endDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  startDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type BillingDocumentSearchInput = {
  filter?: InputMaybe<BillingDocumentSearchFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type BillingDocumentSearchResponse = AuthorizationFailure | BillingDocumentSearchFailure | BillingDocumentSearchSuccess | InputValidationFailure;

export type BillingDocumentSearchSuccess = AppsyncResponse & Connection & Page & {
  __typename?: 'BillingDocumentSearchSuccess';
  edges: Array<BillingDocumentResultEdge>;
  pageInfo: PageInfo;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  total: Scalars['Int']['output'];
};

export const BillingDocumentType = {
  CreditNote: 'CREDIT_NOTE',
  Invoice: 'INVOICE'
} as const;

export type BillingDocumentType = typeof BillingDocumentType[keyof typeof BillingDocumentType];
export type BillingDocumentVendor = {
  __typename?: 'BillingDocumentVendor';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type BillingStatement = {
  __typename?: 'BillingStatement';
  buyerIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  statementNumber: Scalars['String']['output'];
  totalAmount: MoneyV2;
  vendorId: Scalars['ID']['output'];
};

export type BillingStatementResultEdge = Edge & {
  __typename?: 'BillingStatementResultEdge';
  cursor: Scalars['String']['output'];
  node: BillingStatementResultNode;
};

export type BillingStatementResultNode = Node & {
  __typename?: 'BillingStatementResultNode';
  id: Scalars['ID']['output'];
  statement: BillingStatement;
};

export type BillingStatementSearchFailure = {
  __typename?: 'BillingStatementSearchFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BillingStatementSearchInput = {
  buyerIds: Array<Scalars['ID']['input']>;
  pagination?: InputMaybe<PaginationInputV2>;
};

export type BillingStatementSearchResponse = AuthorizationFailure | BillingStatementSearchFailure | BillingStatementSearchSuccess | InputValidationFailure;

export type BillingStatementSearchSuccess = AppsyncResponse & Connection & Page & {
  __typename?: 'BillingStatementSearchSuccess';
  edges: Array<BillingStatementResultEdge>;
  pageInfo: PageInfo;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  total: Scalars['Int']['output'];
};

export type BlockedAutoPilotCustomersConnection = Connection & {
  __typename?: 'BlockedAutoPilotCustomersConnection';
  edges: Array<BlockedAutoPilotCustomersEdge>;
  pageInfo: PageInfo;
};

export type BlockedAutoPilotCustomersEdge = Edge & {
  __typename?: 'BlockedAutoPilotCustomersEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

export type BlockedEmail = Node & {
  __typename?: 'BlockedEmail';
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type BlockedEmailConnection = Connection & {
  __typename?: 'BlockedEmailConnection';
  edges?: Maybe<Array<BlockedEmailEdge>>;
};

export type BlockedEmailEdge = Edge & {
  __typename?: 'BlockedEmailEdge';
  cursor: Scalars['String']['output'];
  node: BlockedEmail;
};

export type BoundingBox = {
  __typename?: 'BoundingBox';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

/** Represents a circular geometry defined by a radius and a center point. */
export type BoundingCircleInput = {
  /** Center point of the circle around which we want to filter leads. */
  point: CoordinateInput;
  /** Radius of the circle around the center point. */
  radius: GeographicDistanceInput;
};

/**
 * Represents a rectangular geometry defined by two cartesian coordinate points.
 * Contains either exactly a top left and bottom right point or a southwest and northeast point.
 * Any other parameter combinations are invalid.
 */
export type BoundingRectangleInput = {
  /** Bottom right of the rectangle. */
  bottomRight?: InputMaybe<CoordinateInput>;
  /** Northeast or "top right" of the bounding rectangle. */
  northeast?: InputMaybe<CoordinateInput>;
  /**
   * Southwest or "bottom left" of the bounding rectangle.
   * Some APIs also call this "low".
   */
  southwest?: InputMaybe<CoordinateInput>;
  /** Top left of the rectangle. */
  topLeft?: InputMaybe<CoordinateInput>;
};

/** How to interpret the bounding rectangle search. */
export const BoundingRectangleSearchType = {
  /**
   * Bias the search towards the bounding input geometry. If the query is
   * clearly for a prospect outside the geometry, it will ignore
   * the geometry and return the best result.
   */
  Bias: 'Bias',
  /** Restrict the search to the bounding input geometry unconditionally. */
  Restriction: 'Restriction'
} as const;

export type BoundingRectangleSearchType = typeof BoundingRectangleSearchType[keyof typeof BoundingRectangleSearchType];
export type BroadCastEndsAt = {
  __typename?: 'BroadCastEndsAt';
  date?: Maybe<Scalars['AWSDate']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type Broadcast = Node & {
  __typename?: 'Broadcast';
  analytics?: Maybe<BroadcastAnalytics>;
  attachment?: Maybe<BroadcastMediaAttachment>;
  chatIds?: Maybe<Array<Scalars['ID']['output']>>;
  chatLabels?: Maybe<Array<Scalars['String']['output']>>;
  chats?: Maybe<Array<Chat>>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  customerPerformance?: Maybe<BroadcastCustomerPerformanceResult>;
  endsAt?: Maybe<BroadCastEndsAt>;
  id: Scalars['ID']['output'];
  media?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  nextScheduledDispatch?: Maybe<Scalars['AWSTimestamp']['output']>;
  pdfName?: Maybe<Scalars['String']['output']>;
  productIds?: Maybe<Array<Scalars['String']['output']>>;
  productPerformance?: Maybe<BroadcastProductPerformanceResult>;
  /** @deprecated This endpoint is in the maintenance mode. It works, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this field. */
  products?: Maybe<Array<Product>>;
  recipientCount?: Maybe<Scalars['Int']['output']>;
  schedule?: Maybe<OneTimeBroadcastSchedule>;
  sendToAll?: Maybe<Scalars['Boolean']['output']>;
  sender?: Maybe<User>;
  senderUserId?: Maybe<Scalars['ID']['output']>;
  status: BroadcastStatus | '%future added value';
  supplierEntityId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type BroadcastChatsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type BroadcastCustomerPerformanceArgs = {
  filter?: InputMaybe<BroadcastCustomerPerformanceFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Sort>;
};


export type BroadcastProductPerformanceArgs = {
  sort?: InputMaybe<Sort>;
};


export type BroadcastProductsArgs = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type BroadcastAnalytics = {
  __typename?: 'BroadcastAnalytics';
  hasProducts: Scalars['Boolean']['output'];
  numChats: Scalars['Int']['output'];
  numChatsAddedProductsToOrderGuide: Scalars['Int']['output'];
  numChatsClicked: Scalars['Int']['output'];
  numChatsOpened: Scalars['Int']['output'];
  numChatsProductsOrdered: Scalars['Int']['output'];
  reportUpdatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueCurrency?: Maybe<Scalars['String']['output']>;
};

export type BroadcastAttachment = {
  __typename?: 'BroadcastAttachment';
  attachment?: Maybe<BroadcastMediaAttachment>;
  broadcastId?: Maybe<Scalars['String']['output']>;
  chatId?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Media>;
  products?: Maybe<Array<Product>>;
};

export type BroadcastCustomerPerformance = {
  __typename?: 'BroadcastCustomerPerformance';
  chat: Chat;
  chatId: Scalars['String']['output'];
  countOrdersWithProducts: Scalars['Int']['output'];
  isChatFirstOrder: Scalars['Boolean']['output'];
  isClicked: Scalars['Boolean']['output'];
  isOpened: Scalars['Boolean']['output'];
  isReactivatedChat: Scalars['Boolean']['output'];
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueCurrency?: Maybe<Scalars['String']['output']>;
  sumProductAmount: Scalars['Float']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type BroadcastCustomerPerformanceFilterInput = {
  hasOrdersWithProducts?: InputMaybe<Scalars['Boolean']['input']>;
  isClicked?: InputMaybe<Scalars['Boolean']['input']>;
  isOpened?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BroadcastCustomerPerformanceResult = {
  __typename?: 'BroadcastCustomerPerformanceResult';
  data: Array<BroadcastCustomerPerformance>;
  total: Scalars['Int']['output'];
};

export type BroadcastFilter = {
  senderUserId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<InputMaybe<BroadcastStatus | '%future added value'>>>;
  supplierEntityId?: InputMaybe<Scalars['ID']['input']>;
};

export type BroadcastInput = {
  chatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  chatLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  endsAt?: InputMaybe<Scalars['AWSDate']['input']>;
  /**
   * Set as true to send a message with a media attachment
   * The message will only be sent after media is put
   * to the attachment { uploadUrl } from the response
   */
  media?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * A standard MIME type describing the format media attachment
   * see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.17
   */
  mediaContentType?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** name of PDF to be uploaded */
  pdfName?: InputMaybe<Scalars['String']['input']>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  purpose?: InputMaybe<BroadcastPurposeInput>;
  schedule?: InputMaybe<OneTimeBroadcastScheduleInput>;
  sendToAll?: InputMaybe<Scalars['Boolean']['input']>;
  status: BroadcastStatus | '%future added value';
  title?: InputMaybe<Scalars['String']['input']>;
};

export type BroadcastMedia = {
  __typename?: 'BroadcastMedia';
  uploadUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BroadcastMediaAttachment = {
  __typename?: 'BroadcastMediaAttachment';
  image?: Maybe<BroadcastMedia>;
  pdf?: Maybe<BroadcastPdfMedia>;
};

export type BroadcastPdfMedia = {
  __typename?: 'BroadcastPdfMedia';
  pdfName?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type BroadcastProductPerformance = {
  __typename?: 'BroadcastProductPerformance';
  countOrdersWithProducts: Scalars['Int']['output'];
  /** @deprecated This endpoint is in the maintenance mode. It works, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this field. */
  product?: Maybe<Product>;
  productId: Scalars['String']['output'];
  revenue?: Maybe<Scalars['Float']['output']>;
  revenueCurrency?: Maybe<Scalars['String']['output']>;
  sumProductAmount: Scalars['Float']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type BroadcastProductPerformanceResult = {
  __typename?: 'BroadcastProductPerformanceResult';
  data: Array<BroadcastProductPerformance>;
  total: Scalars['Int']['output'];
};

export type BroadcastPurposeInput = {
  customValue?: InputMaybe<Scalars['String']['input']>;
  predefinedValue: PredefinedBroadcastPurpose | '%future added value';
};

export const BroadcastScheduleType = {
  OneTimeBroadcast: 'oneTimeBroadcast'
} as const;

export type BroadcastScheduleType = typeof BroadcastScheduleType[keyof typeof BroadcastScheduleType];
export const BroadcastStatus = {
  Archived: 'archived',
  Cancelled: 'cancelled',
  Draft: 'draft',
  Processing: 'processing',
  Scheduled: 'scheduled',
  Sent: 'sent'
} as const;

export type BroadcastStatus = typeof BroadcastStatus[keyof typeof BroadcastStatus];
export type BroadcastUpdatePurposeResult = {
  __typename?: 'BroadcastUpdatePurposeResult';
  customValue?: Maybe<Scalars['String']['output']>;
  predefinedValue: PredefinedBroadcastPurpose | '%future added value';
};

export type BrowseCatalogFilterInput = {
  catalogCategory?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  subCatalogIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BrowseCatalogForChatFilterInput = {
  catalogCategory?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type BrowseCatalogForChatInput = {
  /** Cursor from a previous page to request the next one */
  after?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Chat */
  chatId: Scalars['String']['input'];
  /** Additional filters */
  filter?: InputMaybe<BrowseCatalogForChatFilterInput>;
  /** Maximum number of Products to return. Cannot exceed 50 */
  first?: InputMaybe<Scalars['Int']['input']>;
  /**
   * If true, returns unit variants grouped together with `variantsInCatalog` field.
   * Otherwise they are returned as separate entries.
   */
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to true, also returns products that are not available in the chat. Defaults to false */
  includeUnavailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order of the returned Products */
  sort?: InputMaybe<Sort>;
  /** If true, only returns products without categories */
  uncategorized?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to false, the `subCatalogs` field will not be returned. Defaults to true */
  withSubCatalogs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrowseCatalogForChatResponse = AuthorizationFailure | CatalogNotFound | CatalogProductsConnection;

export type BrowseCatalogInput = {
  /** Cursor from a previous page to request the next one */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Additional filters */
  filter?: InputMaybe<BrowseCatalogFilterInput>;
  /** Maximum number of Products to return. Cannot exceed 50 */
  first?: InputMaybe<Scalars['Int']['input']>;
  /**
   * If true, returns unit variants grouped together with `variantsInCatalog` field.
   * Otherwise they are returned as separate entries.
   */
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order of the returned Products */
  sort?: InputMaybe<Sort>;
  /** ID of the Supplier */
  supplierId: Scalars['String']['input'];
  /** If true, only returns products without categories */
  uncategorized?: InputMaybe<Scalars['Boolean']['input']>;
  /** When provided as `false`, the `subCatalogs` field is not returned */
  withSubCatalogs?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BrowseCatalogResponse = AuthorizationFailure | CatalogProductsConnection;

/**
 * Generic browse filter. Facet selections of different types are combined with
 * AND; the combination of values within a single selection is governed by its
 * `mode`.
 */
export type BrowseFilterInput = {
  facets?: InputMaybe<Array<FacetSelection>>;
};

export type BulkDeclineOrdersInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type BulkDeclineOrdersResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | OrdersBulkDeclined;

export type BulkInviteTransmissionFailure = {
  __typename?: 'BulkInviteTransmissionFailure';
  inviteeId: Scalars['String']['output'];
};

export type BulkInviteTransmissionSuccess = {
  __typename?: 'BulkInviteTransmissionSuccess';
  failures: Array<BulkInviteTransmissionFailure>;
  id: Scalars['ID']['output'];
};

export type BulkOrderRejectedNotification = {
  __typename?: 'BulkOrderRejectedNotification';
  ids: Array<Scalars['ID']['output']>;
  supplierId: Scalars['ID']['output'];
  user: User;
};

export type BulkOrderedProductDeliveryCheckSubmissionResponse = AuthorizationFailure | BulkOrderedProductDeliveryCheckSubmissionResult | InputValidationFailure | OrderDeliveryCheckAlreadyCompleted | OrderDeliveryItemsMismatched | OrderNotFound;

export type BulkOrderedProductDeliveryCheckSubmissionResult = {
  __typename?: 'BulkOrderedProductDeliveryCheckSubmissionResult';
  result: Array<Maybe<OrderedProductDeliveryCheck>>;
};

export type BulkSendInviteInvitee = {
  invitedToEntityId: Scalars['String']['input'];
  inviteeId: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type BulkSendInviteTransmissionInput = {
  channel: InviteChannel | '%future added value';
  invitees: Array<BulkSendInviteInvitee>;
  locale: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

export type BulkSendInviteTransmissionResponse = AuthorizationFailure | BulkInviteTransmissionSuccess | InputValidationFailure;

export type BulkSubmitOrderedProductDeliveryCheckInput = {
  deliveryCheckProducts?: InputMaybe<Array<InputMaybe<DeliveryCheckProductInput>>>;
  orderId: Scalars['ID']['input'];
};

export type BulkUpsertAccountOwnersFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'BulkUpsertAccountOwnersFailure';
  /** The failure message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

/** Input for bulk upserting account owners */
export type BulkUpsertAccountOwnersInput = {
  /**
   * Array of chat-owner assignments to upsert.
   * This is an atomic operation - either all succeed or all fail.
   */
  assignments: Array<AccountOwnerAssignment>;
};

export type BulkUpsertAccountOwnersResponse = AuthorizationFailure | BulkUpsertAccountOwnersFailure | BulkUpsertAccountOwnersSuccess | ForbiddenError | InputValidationFailure;

/**
 * Result for bulk upsert operation.
 * This operation is atomic - if successful, all assignments were processed.
 */
export type BulkUpsertAccountOwnersSuccess = AppsyncResponse & {
  __typename?: 'BulkUpsertAccountOwnersSuccess';
  /** The chat IDs that were successfully processed */
  processedChatIds: Array<Scalars['ID']['output']>;
  /** The chats that were successfully processed */
  processedChats: Array<Chat>;
  /** Response type will always be set to ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

/** Represents the business status of an prospect. */
export const BusinessStatus = {
  ClosedTemporarily: 'ClosedTemporarily',
  Open: 'Open'
} as const;

export type BusinessStatus = typeof BusinessStatus[keyof typeof BusinessStatus];
export type Buyer = Node & {
  __typename?: 'Buyer';
  addressSource: AddressSource | '%future added value';
  administrativeAreaLevelOne?: Maybe<Scalars['String']['output']>;
  chats?: Maybe<BuyerChatConnection>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  createdContext?: Maybe<BuyerCreatedContext | '%future added value'>;
  defaultCurrency?: Maybe<Scalars['String']['output']>;
  deliveryComment?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  fullAddress: Scalars['String']['output'];
  googlePlaceAddressId?: Maybe<Scalars['String']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceRecipientEmails?: Maybe<Array<Scalars['AWSEmail']['output']>>;
  /** True if buyer is a test buyer on Choco's Dogfood programme */
  isPuppy?: Maybe<Scalars['Boolean']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  loyalty?: Maybe<Loyalty>;
  name: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<ProfileImage>;
  referenceId?: Maybe<Scalars['String']['output']>;
  rolesEnabled?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<BuyerStatus | '%future added value'>;
  streetName?: Maybe<Scalars['String']['output']>;
  streetNumber?: Maybe<Scalars['String']['output']>;
  users?: Maybe<BuyerUserConnection>;
  /** offset from UTC in minutes */
  utcOffset?: Maybe<Scalars['Int']['output']>;
};


export type BuyerChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type BuyerUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type BuyerAddSupplier = {
  __typename?: 'BuyerAddSupplier';
  buyerId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  supplierId: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type BuyerAddSupplierError = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerAddSupplierError';
  errorCode?: Maybe<BuyerAddSupplierErrorCode | '%future added value'>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export const BuyerAddSupplierErrorCode = {
  DuplicateBuyerAddSupplierRequest: 'duplicateBuyerAddSupplierRequest',
  SupplierAlreadyConnected: 'supplierAlreadyConnected',
  SupplierNotAcceptingNewCustomers: 'supplierNotAcceptingNewCustomers',
  UserNotMemberOfBuyer: 'userNotMemberOfBuyer'
} as const;

export type BuyerAddSupplierErrorCode = typeof BuyerAddSupplierErrorCode[keyof typeof BuyerAddSupplierErrorCode];
export type BuyerAddSupplierInput = {
  buyerId: Scalars['String']['input'];
  requestType: BuyerAddSupplierRequestType | '%future added value';
  supplierId: Scalars['String']['input'];
};

export const BuyerAddSupplierRequestType = {
  ExistingCustomer: 'existingCustomer',
  NewCustomer: 'newCustomer'
} as const;

export type BuyerAddSupplierRequestType = typeof BuyerAddSupplierRequestType[keyof typeof BuyerAddSupplierRequestType];
export type BuyerAddSupplierResponse = AuthorizationFailure | BuyerAddSupplier | BuyerAddSupplierError | InputValidationFailure;

export type BuyerBillingDocumentSearchFailure = {
  __typename?: 'BuyerBillingDocumentSearchFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BuyerBillingDocumentSearchFilter = {
  documentType?: InputMaybe<Array<BillingDocumentType | '%future added value'>>;
  issueDate?: InputMaybe<DateFilter>;
};

export type BuyerBillingDocumentSearchInput = {
  buyerIds: Array<Scalars['ID']['input']>;
  filter?: InputMaybe<BuyerBillingDocumentSearchFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerBillingDocumentSearchResponse = AuthorizationFailure | BuyerBillingDocumentSearchFailure | BuyerBillingDocumentSearchSuccess | InputValidationFailure;

export type BuyerBillingDocumentSearchSuccess = AppsyncResponse & Connection & Page & {
  __typename?: 'BuyerBillingDocumentSearchSuccess';
  edges: Array<BillingDocumentResultEdge>;
  pageInfo: PageInfo;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  total: Scalars['Int']['output'];
};

export type BuyerChatConnection = Connection & {
  __typename?: 'BuyerChatConnection';
  edges: Array<BuyerChatEdge>;
};

export type BuyerChatEdge = Edge & {
  __typename?: 'BuyerChatEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

export type BuyerChatsConnection = {
  __typename?: 'BuyerChatsConnection';
  /** Null cursor indicates the end of the list. */
  cursor?: Maybe<Scalars['String']['output']>;
  edges: Array<BuyerChatsEdge>;
};

export type BuyerChatsEdge = {
  __typename?: 'BuyerChatsEdge';
  node: Chat;
};

export type BuyerChatsNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerChatsNotFound';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BuyerChatsProductListEmpty = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerChatsProductListEmpty';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

/**
 * A cart line carrying a buyer note where the supplier does not accept notes
 * (Supplier.allowBuyerComment false). One entry per commented line, BLOCKED on
 * every channel and not overrideable: the buyer clears the note and evaluates
 * again. The line itself is orderable, so the cart stays priced and the other
 * validations still report.
 */
export type BuyerCommentValidationResult = CartValidationResult & {
  __typename?: 'BuyerCommentValidationResult';
  overriddenBy?: Maybe<Scalars['String']['output']>;
  overrideable: Scalars['Boolean']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  source: ValidationSource | '%future added value';
  status: ValidationStatus | '%future added value';
  /** Cart line carrying the rejected note (join key). */
  vendorItemUnitId: Scalars['ID']['output'];
};

export type BuyerContactInfos = {
  __typename?: 'BuyerContactInfos';
  buyerContactInfos: Array<Scalars['String']['output']>;
};

export type BuyerCreateInput = {
  /**
   * Addresses with source 'google' must have a googlePlaceId, latitude and longitude;
   * addresses with source 'custom' must not have any of these.
   */
  addressSource: AddressSource | '%future added value';
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdContext?: InputMaybe<BuyerCreatedContext | '%future added value'>;
  deliveryComment?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fullAddress: Scalars['String']['input'];
  googlePlaceAddressId?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  invoiceRecipientEmails?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  /** set this flag to enroll this buyer as a test buyer on Choco's Dogfood programme */
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<BuyerStatus | '%future added value'>;
  /** offset from UTC in minutes */
  utcOffset?: InputMaybe<Scalars['Int']['input']>;
};

export const BuyerCreatedContext = {
  AddAnotherBusiness: 'addAnotherBusiness',
  BuyerConcierge: 'buyerConcierge',
  BuyerCreatedFromAdmin: 'buyerCreatedFromAdmin',
  BuyerCreatedFromChocoAi: 'buyerCreatedFromChocoAi',
  CustomerMassAccountCreator: 'customerMassAccountCreator',
  OrganicSignUp: 'organicSignUp',
  SupplierInvitesBuyer: 'supplierInvitesBuyer'
} as const;

export type BuyerCreatedContext = typeof BuyerCreatedContext[keyof typeof BuyerCreatedContext];
export type BuyerDeliveryFeesInput = {
  buyerId: Scalars['String']['input'];
  tiers: Array<DeliveryFeeTierInput>;
};

export type BuyerDisableRolesResponse = Buyer | NotFoundError;

export type BuyerEdge = Edge & {
  __typename?: 'BuyerEdge';
  cursor: Scalars['String']['output'];
  node: Buyer;
};

export type BuyerExists = {
  __typename?: 'BuyerExists';
  message?: Maybe<Scalars['String']['output']>;
};

export type BuyerFacetsResponse = {
  __typename?: 'BuyerFacetsResponse';
  cities?: Maybe<Array<CityWithOffsets>>;
  country?: Maybe<Scalars['String']['output']>;
};

export type BuyerFilter = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  utcOffset?: InputMaybe<Scalars['Int']['input']>;
};

export type BuyerInventoryProduct = {
  __typename?: 'BuyerInventoryProduct';
  chatId: Scalars['ID']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Money>;
  productId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
  versionTimestamp: Scalars['AWSTimestamp']['output'];
};

export type BuyerNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerNotFound';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type BuyerProductInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  par?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<MoneyInput>;
};

export type BuyerReport = {
  __typename?: 'BuyerReport';
  buyerReportUploadStatus: BuyerReportUploadStatus | '%future added value';
  createdAt: Scalars['AWSTimestamp']['output'];
  createdBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  reportDownloadUrl?: Maybe<Scalars['String']['output']>;
  type: BuyerReportType | '%future added value';
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type BuyerReportGenerationError = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerReportGenerationError';
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BuyerReportNotFoundError = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerReportNotFoundError';
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BuyerReportSchedule = {
  __typename?: 'BuyerReportSchedule';
  buyerIds: Array<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  createdBy: Scalars['String']['output'];
  emailBody?: Maybe<Scalars['String']['output']>;
  emailRecipients: Array<Scalars['String']['output']>;
  frequency: ScheduledBuyerReportFrequency | '%future added value';
  id: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  nextExecutionAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  startAt: Scalars['AWSTimestamp']['output'];
  supplierIds: Array<Scalars['String']['output']>;
  timeframe: ScheduledBuyerReportFrequency | '%future added value';
  timeframeType: ScheduledBuyerReportTimeframeType | '%future added value';
  title?: Maybe<Scalars['String']['output']>;
  type: BuyerReportType | '%future added value';
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type BuyerReportScheduleNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerReportScheduleNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BuyerReportSchedules = {
  __typename?: 'BuyerReportSchedules';
  result: Array<BuyerReportSchedule>;
};

export const BuyerReportType = {
  Delivery: 'delivery',
  Order: 'order',
  Product: 'product'
} as const;

export type BuyerReportType = typeof BuyerReportType[keyof typeof BuyerReportType];
export const BuyerReportUploadStatus = {
  Completed: 'completed',
  Failed: 'failed',
  Pending: 'pending'
} as const;

export type BuyerReportUploadStatus = typeof BuyerReportUploadStatus[keyof typeof BuyerReportUploadStatus];
export type BuyerSegmentContent = {
  __typename?: 'BuyerSegmentContent';
  chat?: Maybe<Chat>;
  featuredVendorItemUnitIds: Array<Scalars['ID']['output']>;
  supplier?: Maybe<Supplier>;
};

export const BuyerStatus = {
  Active: 'active',
  Pending: 'pending'
} as const;

export type BuyerStatus = typeof BuyerStatus[keyof typeof BuyerStatus];
export type BuyerStockCount = Node & {
  __typename?: 'BuyerStockCount';
  buyerId: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  countedProducts?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdBy?: Maybe<User>;
  createdById: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  status?: Maybe<BuyerStockCountStatus | '%future added value'>;
  totalProducts?: Maybe<Scalars['Int']['output']>;
};

export type BuyerStockCountConnection = Connection & {
  __typename?: 'BuyerStockCountConnection';
  edges?: Maybe<Array<BuyerStockCountEdge>>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type BuyerStockCountEdge = Edge & {
  __typename?: 'BuyerStockCountEdge';
  cursor: Scalars['String']['output'];
  node: BuyerStockCount;
};

export type BuyerStockCountFailure = {
  __typename?: 'BuyerStockCountFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BuyerStockCountProduct = {
  __typename?: 'BuyerStockCountProduct';
  buyerId: Scalars['ID']['output'];
  createdBy: Scalars['ID']['output'];
  /** @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code.  Use `VendorItemUnit.images` instead */
  displayImage?: Maybe<ProductImage>;
  estimatedTotalValue?: Maybe<Money>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price?: Maybe<Money>;
  productId?: Maybe<Scalars['ID']['output']>;
  status: BuyerStockCountStatus | '%future added value';
  stockCountId?: Maybe<Scalars['ID']['output']>;
  stockInventoryProductId: Scalars['ID']['output'];
  stockQuantity: Scalars['Float']['output'];
  supplierId?: Maybe<Scalars['ID']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type BuyerStockCountResponse = AuthorizationFailure | BuyerStockCountFailure | BuyerStockCountSuccess | InputValidationFailure;

export const BuyerStockCountStatus = {
  Completed: 'completed',
  Draft: 'draft'
} as const;

export type BuyerStockCountStatus = typeof BuyerStockCountStatus[keyof typeof BuyerStockCountStatus];
export type BuyerStockCountSuccess = {
  __typename?: 'BuyerStockCountSuccess';
  products?: Maybe<Array<BuyerStockCountProduct>>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type BuyerStockCountsFailure = {
  __typename?: 'BuyerStockCountsFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BuyerStockCountsResponse = AuthorizationFailure | BuyerStockCountsFailure | BuyerStockCountsSuccess | InputValidationFailure;

export type BuyerStockCountsSuccess = {
  __typename?: 'BuyerStockCountsSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  stockCounts: BuyerStockCountConnection;
};

export type BuyerStockInventory = {
  __typename?: 'BuyerStockInventory';
  buyerId: Scalars['String']['output'];
  lastCountDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  lastCountedBy?: Maybe<User>;
  lastCountedById?: Maybe<Scalars['ID']['output']>;
  products: BuyerStockInventoryProductConnection;
  status?: Maybe<BuyerStockInventoryGenerationStatus | '%future added value'>;
  totalProducts?: Maybe<Scalars['Int']['output']>;
};

export type BuyerStockInventoryExportUrlFailure = {
  __typename?: 'BuyerStockInventoryExportUrlFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BuyerStockInventoryExportUrlResponse = AuthorizationFailure | BuyerStockInventoryExportUrlFailure | BuyerStockInventoryExportUrlSuccess | BuyerStockInventoryNotFound | InputValidationFailure;

export type BuyerStockInventoryExportUrlSuccess = {
  __typename?: 'BuyerStockInventoryExportUrlSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  url: Scalars['String']['output'];
};

export type BuyerStockInventoryFailure = {
  __typename?: 'BuyerStockInventoryFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export const BuyerStockInventoryGenerationStatus = {
  Completed: 'completed',
  Failed: 'failed',
  Pending: 'pending'
} as const;

export type BuyerStockInventoryGenerationStatus = typeof BuyerStockInventoryGenerationStatus[keyof typeof BuyerStockInventoryGenerationStatus];
export type BuyerStockInventoryNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'BuyerStockInventoryNotFound';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type BuyerStockInventoryProduct = Node & {
  __typename?: 'BuyerStockInventoryProduct';
  buyerId: Scalars['ID']['output'];
  chatId?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['ID']['output']>;
  /** @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code.  Use `VendorItemUnit.images` instead */
  displayImage?: Maybe<ProductImage>;
  estimatedTotalValue?: Maybe<Money>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastCountDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Not returned anymore */
  orderGuideCategories: Array<ProductCategory>;
  price?: Maybe<Money>;
  productId?: Maybe<Scalars['ID']['output']>;
  stockQuantity?: Maybe<Scalars['Float']['output']>;
  supplier?: Maybe<Supplier>;
  type: BuyerStockInventoryProductType | '%future added value';
  unit?: Maybe<Scalars['String']['output']>;
};

export type BuyerStockInventoryProductConnection = Connection & {
  __typename?: 'BuyerStockInventoryProductConnection';
  edges?: Maybe<Array<BuyerStockInventoryProductEdge>>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type BuyerStockInventoryProductEdge = Edge & {
  __typename?: 'BuyerStockInventoryProductEdge';
  cursor: Scalars['String']['output'];
  node: BuyerStockInventoryProduct;
};

export const BuyerStockInventoryProductType = {
  CatalogProduct: 'catalogProduct',
  CustomInventoryProduct: 'customInventoryProduct',
  OrderGuideProduct: 'orderGuideProduct'
} as const;

export type BuyerStockInventoryProductType = typeof BuyerStockInventoryProductType[keyof typeof BuyerStockInventoryProductType];
export type BuyerStockInventoryResponse = AuthorizationFailure | BuyerStockInventory | BuyerStockInventoryFailure | BuyerStockInventoryNotFound | InputValidationFailure;

export type BuyerUpdateInput = {
  /**
   * Addresses with source 'google' must have a googlePlaceId, latitude and longitude;
   * addresses with source 'custom' must not have any of these.
   */
  addressSource?: InputMaybe<AddressSource | '%future added value'>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  deliveryComment?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  googlePlaceAddressId?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  invoiceRecipientEmails?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<BuyerStatus | '%future added value'>;
  /** offset from UTC in minutes */
  utcOffset?: InputMaybe<Scalars['Int']['input']>;
};

export type BuyerUser = {
  __typename?: 'BuyerUser';
  buyer?: Maybe<Buyer>;
  buyerId: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type BuyerUserConnection = Connection & {
  __typename?: 'BuyerUserConnection';
  edges: Array<BuyerUserEdge>;
};

export type BuyerUserEdge = Edge & {
  __typename?: 'BuyerUserEdge';
  cursor: Scalars['String']['output'];
  node: User;
  role?: Maybe<Scalars['String']['output']>;
};

export type BuyerUserInput = {
  /** role can be any of buyerAdmin, buyerStaff or buyerViewer */
  role: Scalars['String']['input'];
};

export type BuyerUserRoleInput = {
  /** role can be any of buyerAdmin, buyerStaff or buyerViewer */
  role: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type CalibrationSampleRate = {
  __typename?: 'CalibrationSampleRate';
  key: AutomationLevel | '%future added value';
  value: Scalars['Float']['output'];
};

/** Campaign attachment to be used for adding attachments to the channel message */
export type CampaignAttachment = {
  __typename?: 'CampaignAttachment';
  /** Attachment ID */
  id: Scalars['ID']['output'];
  /** Attachment file name */
  name: Scalars['String']['output'];
  /** Attachment file type e.g. pdf, png etc. */
  type: Scalars['String']['output'];
  /** Attachment file URI in S3 */
  uri: Scalars['String']['output'];
};

/** Input type for attachments of a marketing campaign */
export type CampaignAttachmentInput = {
  /** Attachment file Id used to identify the file in the bucket */
  fileId: Scalars['String']['input'];
  /** Attachment file name */
  name: Scalars['String']['input'];
  /** Attachment file type e.g. pdf, png etc. */
  type: Scalars['String']['input'];
  /** Attachment file URI in S3 */
  uri: Scalars['String']['input'];
};

export const CampaignChannel = {
  Chat: 'CHAT',
  Email: 'EMAIL',
  Promo: 'PROMO',
  PromoPreferredProducts: 'PROMO_PREFERRED_PRODUCTS',
  WelcomeBanner: 'WELCOME_BANNER'
} as const;

export type CampaignChannel = typeof CampaignChannel[keyof typeof CampaignChannel];
/** Campaign attachment to be used for adding attachments to the channel message */
export type CampaignChatAttachment = {
  __typename?: 'CampaignChatAttachment';
  /** Signed download URL for the attachment file */
  downloadUrl: Scalars['String']['output'];
  /** Attachment ID */
  id: Scalars['ID']['output'];
  /** Attachment file name */
  name: Scalars['String']['output'];
  /** Attachment file type e.g. pdf, png etc. */
  type: Scalars['String']['output'];
  /** Attachment file URI in S3 */
  uri: Scalars['String']['output'];
};

export type CampaignTarget = TargetAll | TargetChats;

export type CancelCartOptionsInput = {
  /**
   * This is the value of the `updatedAt` field of the cart object on the client to serves as a lock key to the cart submission,
   * only clients with the most recent value can submit the cart
   */
  cartVersionTimeStamp: Scalars['AWSTimestamp']['input'];
};

export type CancelCartResponse = AuthorizationFailure | CancelCartResult | CartAlreadyCancelledError | CartAlreadySubmittedError | CartNotFoundError | CartVersionConstraintError | InputValidationFailure;

export type CancelCartResult = {
  __typename?: 'CancelCartResult';
  /** the cart ID */
  id: Scalars['ID']['output'];
};

/** Input type for canceling a marketing campaign */
export type CancelMarketingCampaignInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
};

export const CardBrand = {
  Mastercard: 'MASTERCARD',
  Visa: 'VISA'
} as const;

export type CardBrand = typeof CardBrand[keyof typeof CardBrand];
export type CardPaymentMethod = {
  __typename?: 'CardPaymentMethod';
  brand: CardBrand | '%future added value';
  cardHolderName: Scalars['String']['output'];
  expirationMonth: Scalars['Int']['output'];
  expirationYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  lastFourDigits: Scalars['String']['output'];
  status: PaymentMethodStatus | '%future added value';
};

export type Cart = {
  __typename?: 'Cart';
  /** order-level comment from the buyer */
  body?: Maybe<Scalars['String']['output']>;
  /** One cart per chat. the cart id is the same as the id of its parent chat */
  id: Scalars['ID']['output'];
  /** computed field; returns true if the cart has non-empty lineItems */
  isOpen: Scalars['Boolean']['output'];
  lineItems: Array<Maybe<CartLineItem>>;
  /** Purchase Order number from the buyer */
  poNumber?: Maybe<Scalars['String']['output']>;
  /** the version number of the cart for managing concurrency */
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type CartAllProductsUnavailableError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartAllProductsUnavailableError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  unavailableProductCount: Scalars['Int']['output'];
  vendorItemUnits?: Maybe<Array<VendorItemUnitRef>>;
};

export type CartAlreadyCancelledError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartAlreadyCancelledError';
  latestCartOperation?: Maybe<UserCartItemOperation>;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CartAlreadySubmittedError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartAlreadySubmittedError';
  latestCartOperation?: Maybe<UserCartItemOperation>;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CartCanceled = {
  __typename?: 'CartCanceled';
  name?: Maybe<Scalars['String']['output']>;
};

export type CartEvaluateInput = {
  /**
   * Buyer-owned cart intent for evaluate (no poNumber and no order-level
   * buyerComment: those are commit-only persistence fields). Line-level
   * buyerComment is accepted for validation and never persisted here.
   */
  cart: CartEvaluateIntentInput;
  /**
   * Required explicitly. No default: prevents a per-edit call from
   * accidentally invoking the Review fan-out.
   */
  phase: CartEvaluatePhase | '%future added value';
};

export type CartEvaluateIntentInput = {
  /**
   * Optional cart analytics id. Omit on first evaluate; BE mints and returns
   * EvaluatedCart.cartId for the client to carry on later calls.
   */
  cartId?: InputMaybe<Scalars['ID']['input']>;
  /** Buyer↔supplier chat that scopes catalog visibility, pricing, and promotions eligibility. */
  chatId: Scalars['ID']['input'];
  /**
   * Requested delivery date on the cart intent. Used for delivery validation and
   * availability. May also be the evaluation reference date for pricing, tax, fee,
   * and promotions when those domains use delivery date. For promotions, whether
   * evaluation uses order date or delivery date is configurable; this field alone
   * does not choose that basis. Null when the client has not chosen one yet.
   * Missing date is not DeliveryDateValidationResult UNAVAILABLE_DATE
   * (that means a provided date is not bookable). Commit / channel rules decide
   * whether null is allowed; not a typed delivery validation code here.
   */
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  /**
   * Client requests the top-up path for deliveryDate. Intent only.
   * Commit impact comes from validationResults (BLOCKED vs PASSED/WARNING),
   * not from this flag alone. False/omitted uses normal new-order MOV.
   */
  isTopUp?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * One row per vendorItemUnitId (the client cart). Duplicate vendorItemUnitId
   * returns InputValidationFailure (shared AppSync input-failure result).
   * After a CART_FREE_EXTRA_UNITS claim, the selected gift unit is included here
   * like any other cart row (still requires matching promotionChoices CHOSEN).
   * FREE_UNITS_INCLUDED needs no claim; the server carves the existing unit
   * quantity into paidQuantity / freeQuantity on output.
   */
  lineItems: Array<CartEvaluateLineInput>;
  /**
   * Only for offer type CART_FREE_EXTRA_UNITS (claimable reward selection).
   * At most one entry per promotionId. Required when gift quantity is in the
   * cart via choices. Other offer types do not use this field.
   */
  promotionChoices?: Array<PromotionChoiceInput>;
};

export type CartEvaluateLineInput = {
  /**
   * Per-line buyer note the client holds for this cart row. Evaluate never
   * persists it: send it so a supplier that disallows notes reports
   * BuyerCommentValidationResult before the buyer reaches checkout. Blank or
   * whitespace-only reads as no note. Persisting it is CheckoutCartLineInput
   * .buyerComment on commit.
   */
  buyerComment?: InputMaybe<Scalars['String']['input']>;
  /**
   * Cart quantity for this vendorItemUnitId as shown/edited in the client cart
   * (must be positive). May include units that will be free on evaluate when a
   * CHOSEN choice covers them (gift added to cart from a claimable reward).
   */
  quantity: DecimalInput;
  /**
   * Catalog unit. Join key for promotion lists and validation (one row per
   * vendorItemUnitId).
   */
  vendorItemUnitId: Scalars['ID']['input'];
};

export const CartEvaluatePhase = {
  /** Analytics only. No Pricing / Promotions / Tax / fee fan-out. */
  Cancel: 'CANCEL',
  /**
   * Cart live edits before Checkout. Runs Pricing, Promotions,
   * stock/availability, MOV, and Cart delivery constraints. Tax, delivery
   * fee and loyalty are not evaluated.
   */
  Edit: 'EDIT',
  /**
   * Review / Checkout-tap evaluation. Everything in EDIT plus Tax, delivery
   * fee, payable, and the loyalty estimate. Required domains fail closed.
   */
  Review: 'REVIEW'
} as const;

export type CartEvaluatePhase = typeof CartEvaluatePhase[keyof typeof CartEvaluatePhase];
/**
 * EvaluatedCart includes business-policy blocks (out of stock, invalid product,
 * minimum order value, minimum orderable quantity, delivery) on
 * validationResults; those never appear in CartEvaluationFailedResult.errors.
 * AuthorizationFailure / InputValidationFailure are request-level failures.
 * CartEvaluationFailedResult means a required dependency did not complete
 * (same EvaluationDependencyFailure model as CheckoutFailedResult).
 */
export type CartEvaluateResponse = AuthorizationFailure | CartEvaluationFailedResult | EvaluatedCart | InputValidationFailure;

/**
 * Completeness of one domain result of cart evaluation
 * (promotions, tax, or delivery fee).
 */
export const CartEvaluationDomainStatus = {
  /**
   * This domain does not apply to the cart. Its result field is null. Issues may
   * explain why it does not apply.
   * Tax enabled without a chat profile is NOT_APPLICABLE and does not block.
   */
  NotApplicable: 'NOT_APPLICABLE',
  /**
   * This domain intentionally did not run for the current phase, context, or
   * configuration. Its result field is null.
   */
  NotEvaluated: 'NOT_EVALUATED',
  /**
   * This domain completed successfully. Its result field contains the outcome.
   * A complete zero/exempt Tax calculation is OK, not NOT_APPLICABLE.
   */
  Ok: 'OK',
  /**
   * This required domain could not produce a result. Its result field is null,
   * issues explain the failure, and checkout cannot commit.
   */
  Unavailable: 'UNAVAILABLE'
} as const;

export type CartEvaluationDomainStatus = typeof CartEvaluationDomainStatus[keyof typeof CartEvaluationDomainStatus];
export type CartEvaluationFailedResult = {
  __typename?: 'CartEvaluationFailedResult';
  /**
   * Dependency incompletenesses from this evaluate. Non-empty.
   * Policy failures such as out of stock or an unmet minimum order value are not
   * listed here: those are validationResults. MOV_UNAVAILABLE means the required
   * MOV dependency did not return a verdict.
   */
  errors: Array<EvaluationDependencyFailure>;
  /**
   * On this failed result: set for the fail-closed codes that keep the composed
   * cart (PROMOTIONS_UNAVAILABLE, MOV_UNAVAILABLE, TAX_UNAVAILABLE); null when
   * evaluation stopped before composition (PRICING_UNAVAILABLE). A successful
   * result carries the cart on its own field.
   */
  evaluatedCart?: Maybe<EvaluatedCart>;
  /**
   * Shared AppSync transport discriminator. Always error for this result
   * (dependency/system failure).
   */
  responseType: ResponseType | '%future added value';
};

/**
 * Non-fatal domain diagnostic on a domain result (e.g. TaxResult.issues).
 * Not a CartValidationResult entry and not EvaluationDependencyFailure
 * (those live on CartEvaluationFailedResult.errors[]).
 */
export type CartEvaluationIssue = {
  __typename?: 'CartEvaluationIssue';
  /** Stable domain issue code (e.g. timeout / incomplete apply). */
  code: Scalars['String']['output'];
  /** Optional human-readable detail for logs/support; not a primary UX string. */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether a later retry of the same evaluation may succeed. */
  retryable: Scalars['Boolean']['output'];
  /** Optional product addressability when the issue is line-scoped. */
  vendorItemUnitId?: Maybe<Scalars['ID']['output']>;
};

export type CartInvalidProductsError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartInvalidProductsError';
  invalidProductCount: Scalars['Int']['output'];
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  remainingProductsCount?: Maybe<Scalars['Int']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  vendorItemUnits?: Maybe<Array<VendorItemUnitRef>>;
};

export type CartLineItem = {
  __typename?: 'CartLineItem';
  amount: Scalars['Float']['output'];
  /** Optional comment from the buyer for this line item */
  buyerComment?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not returned anymore. Use `CartLineItem.vendorItemUnit` instead */
  product?: Maybe<Product>;
  productId: Scalars['ID']['output'];
  /** @deprecated is ignored in the backend, will always return null */
  productMeta?: Maybe<CartProductMetadata>;
  vendorItemUnit?: Maybe<VendorItemUnitRef>;
};

export type CartLineItemUpdateInput = {
  /** is this an operation to add or remove a product item */
  action: UserCartAction | '%future added value';
  /**
   * The amounts of products items to add or remove from the cart.
   * Set to 0 if you want to just update the buyer comment.
   */
  amount: Scalars['Float']['input'];
  /**
   * Optional comment from the buyer for this line item.
   * - If sent as undefined or null: will be ignored (preserves existing comment if any)
   * - If sent as empty string: removes the existing comment if any
   * - If provided with value: updates the existing comment
   */
  buyerComment?: InputMaybe<Scalars['String']['input']>;
  /** The id of the product */
  productId: Scalars['ID']['input'];
  /**
   * The meta data of the product
   * @deprecated is ignored in the backend
   */
  productMeta?: InputMaybe<CartProductMetadataInput>;
};

export type CartNotFoundError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartNotFoundError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CartOpened = {
  __typename?: 'CartOpened';
  /** @deprecated is ignored in the backend, will always return null */
  cartId?: Maybe<Scalars['String']['output']>;
  /** @deprecated is ignored in the backend, will always return null */
  modifiedBy?: Maybe<EventUser>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Totals sum per-line, per-tax-type half-up(2dp) values; no order-level rounding. */
export type CartPricing = {
  __typename?: 'CartPricing';
  /**
   * Flat, cart-level savings breakdown for the REVIEW savings sheet. Empty on EDIT
   * and on checkoutCreate. Σ entry.amount equals totalSavingsAmount when present;
   * empty when totalSavingsAmount is null. Catalog price discounts come first,
   * one entry per discounted line, then each promotion contributes its payable
   * price-discount entry (when it reduced price) plus one entry per free grant.
   * One field clients can render without walking the per-promotion list.
   */
  savingsBreakdown: Array<CartSavingsEntry>;
  /**
   * Merchandise amount before catalog price discounts and Checkout promotion
   * effects. Catalog price savings are added back for display; they remain baked
   * into the pricing basis used for MOV, Tax, fees, net, and payable. Free units a
   * promotion granted on top of the ordered quantity, gift lines included, are
   * added at their pre-promotion value, so subtotalAmount minus totalSavingsAmount
   * equals totalNetAmount for a single-currency, fully priced cart. Units a
   * promotion made free inside the ordered quantity are already counted and are
   * not added again. Equals the pricing basis when whole-cart savings are
   * unknowable.
   * Lines flagged by InvalidProductValidationResult are excluded, so the
   * subtotal resolves from the valid lines. For mixed currencies with an
   * applied MOV, contains only merchandise in the MOV currency.
   * Null when every paid line is unpriced, or mixed without an MOV currency;
   * never encoded as 0.
   */
  subtotalAmount?: Maybe<MoneyV2>;
  /**
   * Sum of line deposits (EMPTY_DEPOSIT rates), kept separate from taxes so it can
   * be shown as its own line. Null when the amount is zero, when the distributor
   * has taxes disabled, or when Tax did not complete. A null deposit still counts
   * as zero in totalGrossAmount. Deposits follow the tax setting; there is no
   * separate deposit switch.
   */
  totalDepositAmount?: Maybe<MoneyV2>;
  /**
   * Payable-reducing promotion discounts included in this evaluation.
   * Zero when no effects apply, including Promotions UNAVAILABLE.
   * Null when every paid line is unpriced: no discount can be computed on such
   * a cart.
   */
  totalDiscountAmount?: Maybe<MoneyV2>;
  /**
   * totalNetAmount + totalTaxAmount + totalDepositAmount. Resolves with zero Tax
   * when Tax is disabled or not applicable; otherwise null unless Tax completed
   * successfully.
   */
  totalGrossAmount?: Maybe<MoneyV2>;
  /**
   * Post-promotion merchandise net. On Promotions UNAVAILABLE, Checkout still
   * prices the no-promotion net; client renders it with promotions.status.
   * Invalid-product lines are excluded. For mixed currencies with an applied
   * MOV, contains only paid merchandise in the subtotal currency.
   * Null when every paid line is unpriced, or mixed without an MOV currency;
   * never encoded as 0.
   */
  totalNetAmount?: Maybe<MoneyV2>;
  /**
   * What the buyer pays: the gross total plus the delivery fee when one applies.
   *
   * Null when prices, an enabled tax calculation, or an enabled delivery fee did
   * not complete. Always null while the buyer is still editing the cart.
   *
   * A preview can still show the catalog-price total when promotions could not be
   * evaluated. Checkout will not create the order in that case.
   */
  totalPayableAmount?: Maybe<MoneyV2>;
  /**
   * Catalog price discounts on the paid quantities + payable promotion
   * discounts + normal pre-promotion value of free items:
   * Σ line (priceBeforeDiscount − price) × paidQuantity
   * + Σ line discountAmount + Σ (free-line unitPriceBeforePromotion × quantity).
   * A supplier without promotions contributes zero, so catalog price discounts
   * stand alone. Null when Promotions is UNAVAILABLE in preview.
   */
  totalSavingsAmount?: Maybe<MoneyV2>;
  /**
   * Sum of line taxes. Zero when nothing is taxed, including when the customer
   * has no tax profile and when the distributor has taxes disabled. Null when
   * Tax did not complete.
   */
  totalTaxAmount?: Maybe<MoneyV2>;
};

export type CartProductMetadata = {
  __typename?: 'CartProductMetadata';
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};

export type CartProductMetadataInput = {
  /** The external id of the product */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the product */
  name: Scalars['String']['input'];
  /** The unit of measurement of the product item */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CartRecommendation = {
  __typename?: 'CartRecommendation';
  vendorItemUnit: VendorItemUnitRef;
};

export type CartRecommendationMetadata = {
  __typename?: 'CartRecommendationMetadata';
  numberOfOrders: Scalars['Int']['output'];
  /**
   * Unique identifier for this recommendation request. Used to join backend
   * logs with client-side analytics events for relevance measurement.
   */
  queryId?: Maybe<Scalars['String']['output']>;
};

export type CartRecommendationsInput = {
  chatId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  vendorItemUnitIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CartRecommendationsResponse = AuthorizationFailure | CartRecommendationsResult | InputValidationFailure;

export type CartRecommendationsResult = {
  __typename?: 'CartRecommendationsResult';
  metadata: CartRecommendationMetadata;
  recommendations: Array<CartRecommendation>;
};

export type CartResponse = AuthorizationFailure | Cart;

/**
 * One line of CartPricing.savingsBreakdown. amount is positive money (the UI
 * prefixes −). label is the buyer-facing entry name, null when unavailable
 * (clients use generic fallback copy).
 */
export type CartSavingsEntry = {
  __typename?: 'CartSavingsEntry';
  amount: MoneyV2;
  label?: Maybe<Scalars['String']['output']>;
};

export type CartSubmissionError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartSubmissionError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CartSubmissionOptions = {
  /**
   * This parameter determines which order create version to use
   * @deprecated with orderCreateV2 being rolled out, we don't need to use the old version anymore and this will now be ignored.
   */
  apiVersion?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The body of the order message.
   * This is Optional order-level comment from the buyer.
   * - If sent as undefined or null: will be ignored (preserves existing comment if any)
   * - If sent as empty string: removes the existing comment if any
   * - If provided with value: updates the existing comment
   */
  body?: InputMaybe<Scalars['String']['input']>;
  /**
   * This is the value of the `updatedAt` field of the cart object on the client to serves as a lock key to the cart submission,
   * only clients with the most recent value can submit the cart
   */
  cartVersionTimeStamp: Scalars['AWSTimestamp']['input'];
  /** The requested delivery date for the order */
  deliveryDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** The estimated order value */
  estimatedOrderTotal?: InputMaybe<Scalars['Int']['input']>;
  /** Is this a test order */
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** The minimum order value currency */
  minOrderCurrency?: InputMaybe<Scalars['String']['input']>;
  /** The minimum order value set by the supplier */
  minOrderValue?: InputMaybe<Scalars['Int']['input']>;
  /** The estimated order value currency */
  orderCurrency?: InputMaybe<Scalars['String']['input']>;
  /** The id of the order to create from the cart */
  orderId: Scalars['ID']['input'];
  /**
   * The Purchase Order number from the buyer (optional).
   * - If sent as undefined or null: will be ignored (preserves existing poNumber if any)
   * - If sent as empty string: removes the existing poNumber if any
   * - If provided with value: updates the existing poNumber
   */
  poNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CartSubmissionResponse = AuthorizationFailure | CartAllProductsUnavailableError | CartAlreadyCancelledError | CartAlreadySubmittedError | CartInvalidProductsError | CartNotFoundError | CartSubmissionError | CartSubmissionResult | CartSubmittedEmptyError | CartVersionConstraintError | CreateMessageError | ExistingOrderError | ForbiddenError | InputValidationFailure | MinimumOrderableAmountError | ProductBuyerCommentsNotAllowedError | ProductLeadTimeError;

export type CartSubmissionResult = {
  __typename?: 'CartSubmissionResult';
  cart?: Maybe<Cart>;
  /** the cart ID */
  id: Scalars['ID']['output'];
  /** the message item created from the cart submission */
  message?: Maybe<Message>;
};

export type CartSubmitted = {
  __typename?: 'CartSubmitted';
  /** @deprecated is ignored in the backend, will always return null */
  cartId?: Maybe<Scalars['String']['output']>;
  /** @deprecated is ignored in the backend, will always return null */
  modifiedBy?: Maybe<EventUser>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CartSubmittedEmptyError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartSubmittedEmptyError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CartUpdateResponse = AuthorizationFailure | Cart | CartNotFoundError | CartVersionConstraintError | InputValidationFailure | NegativeAmountError;

export type CartUpdated = {
  __typename?: 'CartUpdated';
  /** @deprecated is ignored in the backend, will always return null */
  cartId?: Maybe<Scalars['String']['output']>;
  /** @deprecated is ignored in the backend, will always return null */
  modifiedBy?: Maybe<EventUser>;
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * Shared commit/policy surface. Domain facts live on implementors. Clients use
 * status (+ overrideable) for commit gating and __typename + domain fields for
 * display. Stock / invalid-product / delivery / product-delivery / gift codes
 * are typed enums on their implementors. Minimum orderable quantity and
 * single-unit variation have no check-owner code (single concern each). Minimum
 * order value has no check-owner code (decision + status only).
 */
export type CartValidationResult = {
  /**
   * Who overrode a BLOCKED outcome when status is OVERRIDDEN. Null otherwise.
   * Buyer GraphQL does not send override intent.
   */
  overriddenBy?: Maybe<Scalars['String']['output']>;
  /** Whether an authorized actor/channel may override a BLOCKED outcome. */
  overrideable: Scalars['Boolean']['output'];
  /**
   * Optional owning capability or check label for support/audit. Null when not
   * projected for this channel.
   */
  owner?: Maybe<Scalars['String']['output']>;
  /** Optional human-readable detail for logs/support; not primary display copy. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Whether the outcome came from supplier capability or channel policy. */
  source: ValidationSource | '%future added value';
  /** Policy outcome for this check. */
  status: ValidationStatus | '%future added value';
};

export type CartVersionConstraintError = AppsyncError & AppsyncResponse & {
  __typename?: 'CartVersionConstraintError';
  latestCartOperation?: Maybe<UserCartItemOperation>;
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CatalogAttribute = {
  __typename?: 'CatalogAttribute';
  id: Scalars['ID']['output'];
  type: CatalogAttributeType | '%future added value';
  values?: Maybe<Array<CatalogAttributeValue>>;
};

/** Input for filtering by attribute values. */
export type CatalogAttributeFilterItem = {
  /**
   * Mode for the attribute filter.
   * If set to `ANY`, the item will be included if any of the values match.
   * If set to `ALL`, the item will be included if all of the values match.
   */
  mode: CatalogAttributeFilterMode | '%future added value';
  type: CatalogAttributeType | '%future added value';
  /** List of value IDs for the attribute. */
  valueIds: Array<Scalars['ID']['input']>;
};

export const CatalogAttributeFilterMode = {
  All: 'ALL',
  Any: 'ANY'
} as const;

export type CatalogAttributeFilterMode = typeof CatalogAttributeFilterMode[keyof typeof CatalogAttributeFilterMode];
export const CatalogAttributeType = {
  AllergenContains: 'ALLERGEN_CONTAINS',
  AllergenFreeFrom: 'ALLERGEN_FREE_FROM',
  AllergenMayContain: 'ALLERGEN_MAY_CONTAIN',
  DietaryCertification: 'DIETARY_CERTIFICATION',
  DietaryLifestyle: 'DIETARY_LIFESTYLE'
} as const;

export type CatalogAttributeType = typeof CatalogAttributeType[keyof typeof CatalogAttributeType];
export type CatalogAttributeUpdateInput = {
  mode: CatalogAttributeUpdateMode | '%future added value';
  type: CatalogAttributeType | '%future added value';
  values: Array<CatalogAttributeValueInput>;
  vendorId: Scalars['ID']['input'];
};

export const CatalogAttributeUpdateMode = {
  Replace: 'Replace',
  Update: 'Update'
} as const;

export type CatalogAttributeUpdateMode = typeof CatalogAttributeUpdateMode[keyof typeof CatalogAttributeUpdateMode];
export type CatalogAttributeUpdateResponse = AuthorizationFailure | CatalogAttributeUpdateResult | InputValidationFailure;

export type CatalogAttributeUpdateResult = AppsyncResponse & {
  __typename?: 'CatalogAttributeUpdateResult';
  attribute: CatalogAttribute;
  responseType: ResponseType | '%future added value';
};

export type CatalogAttributeValue = Node & {
  __typename?: 'CatalogAttributeValue';
  /** Type of the attribute (allergen or dietary preference) */
  attributeType: CatalogAttributeType | '%future added value';
  /** Code of the attribute (e.g., "milk", "vegan") */
  code: Scalars['String']['output'];
  /** Unique identifier of the attribute */
  id: Scalars['ID']['output'];
  /** Best translation name based on Accept-Language header and locale preferences */
  name: Scalars['String']['output'];
  /** All available translations of the attribute name */
  translations?: Maybe<Array<CatalogAttributeValueTranslation>>;
};

export type CatalogAttributeValueInput = {
  code: Scalars['String']['input'];
  translations: Array<CatalogAttributeValueTranslationInput>;
};

export type CatalogAttributeValueRef = RefEdge & {
  __typename?: 'CatalogAttributeValueRef';
  /** Id of the referenced CatalogAttributeValue. */
  id: Scalars['ID']['output'];
  /** When requested, resolves the actual CatalogAttributeValue by its Id and allows to get its properties. */
  node?: Maybe<CatalogAttributeValue>;
};

export type CatalogAttributeValueTranslation = {
  __typename?: 'CatalogAttributeValueTranslation';
  /** Locale code (e.g., "en-US", "fr-FR") */
  locale: Scalars['String']['output'];
  /** Translated name of the attribute */
  name: Scalars['String']['output'];
};

export type CatalogAttributeValueTranslationInput = {
  /** Locale code (e.g., "en-US", "fr-FR") */
  locale: Scalars['String']['input'];
  /** Name in the specified locale */
  name: Scalars['String']['input'];
};

export type CatalogAttributeValuesInput = {
  /**
   * Ids to fetch catalog attribute values for.
   * Max-length: 200
   */
  ids: Array<Scalars['ID']['input']>;
  /** Id of the vendor whose attribute values are being fetched */
  vendorId: Scalars['ID']['input'];
};

export type CatalogAttributeValuesResponse = AuthorizationFailure | CatalogAttributeValuesResult | InputValidationFailure;

export type CatalogAttributeValuesResult = {
  __typename?: 'CatalogAttributeValuesResult';
  attributeValues: Array<CatalogAttributeValue>;
  responseType: ResponseType | '%future added value';
};

export type CatalogAttributesInput = {
  /** If provided, only returns selected attributes */
  types?: InputMaybe<Array<CatalogAttributeType | '%future added value'>>;
  vendorId: Scalars['ID']['input'];
};

export type CatalogAttributesResponse = AuthorizationFailure | CatalogAttributesResult | InputValidationFailure;

export type CatalogAttributesResult = {
  __typename?: 'CatalogAttributesResult';
  attributes: Array<CatalogAttribute>;
  responseType: ResponseType | '%future added value';
};

export type CatalogCategoriesResponse = {
  __typename?: 'CatalogCategoriesResponse';
  catalogCategories: Array<CatalogCategory>;
};

export type CatalogCategory = {
  __typename?: 'CatalogCategory';
  clientImageKey?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  primaryCatalogCategories?: Maybe<Array<Scalars['String']['output']>>;
};

export type CatalogExportJob = CatalogExportJobSucceeded | JobFailed | JobInProgress | JobQueued;

/** Represents a catalog export job that succeeded. */
export type CatalogExportJobSucceeded = {
  __typename?: 'CatalogExportJobSucceeded';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
  /** URL where the output file of the catalog export job can be downloaded from. */
  outputDownloadUrl: Scalars['String']['output'];
};

/** Input for the `catalogExportStart` mutation. */
export type CatalogExportStartInput = {
  /** Indicates whether the export should include items with all statuses (e.g. OutOfStock) or just the items in stock; the default is false. */
  exportWithAllStatuses?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the vendor for whom the catalog is being exported. */
  vendorId: Scalars['ID']['input'];
};

export type CatalogExportStartResponse = AuthorizationFailure | CatalogExportStartResult | InputValidationFailure;

export type CatalogExportStartResult = AppsyncResponse & {
  __typename?: 'CatalogExportStartResult';
  /** The catalog export job. */
  job: CatalogExportJob;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type CatalogExportStatusResponse = AuthorizationFailure | CatalogExportStatusResult | InputValidationFailure;

export type CatalogExportStatusResult = AppsyncResponse & {
  __typename?: 'CatalogExportStatusResult';
  /** The catalog export job. */
  job: CatalogExportJob;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

/**
 * Known failure codes:
 * - InvalidFile
 */
export type CatalogImportJob = CatalogImportJobSucceeded | JobFailed | JobInProgress | JobWaitingForInput;

/** Summarizes the import process, providing details about the items processed during the import. */
export type CatalogImportJobResponse = {
  __typename?: 'CatalogImportJobResponse';
  /** The number of new vendor item units created during the import. */
  itemsCreated: Scalars['Int']['output'];
  /** The number of vendor item units marked as out of stock during the import. */
  itemsMarkedOutOfStock: Scalars['Int']['output'];
  /** The number of vendor item units updated during the import. */
  itemsUpdated: Scalars['Int']['output'];
  /** The number of vendor item units that failed to import due to validation errors. */
  itemsWithErrors: Scalars['Int']['output'];
};

/** Represents a catalog import job that succeeded, including partial successes. */
export type CatalogImportJobSucceeded = {
  __typename?: 'CatalogImportJobSucceeded';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
  /** Indicates whether the import was a partial success, such as some items failing to import due to validation errors. */
  isPartialSuccess: Scalars['Boolean']['output'];
  /** URL where the output file of the import job can be downloaded. */
  outputDownloadUrl: Scalars['String']['output'];
  /** A summary response of the import job detailing the outcome of the import process. */
  response: CatalogImportJobResponse;
};

/** Mode of the CatalogImport defines how unmatched products are handled during the import process. */
export const CatalogImportMode = {
  /** New item units are created, matched item units are updated, and unmatched item units are marked as out of stock. */
  Replace: 'Replace',
  /** New item units are created, matched item units are updated, and unmatched item units are left unchanged. */
  Update: 'Update'
} as const;

export type CatalogImportMode = typeof CatalogImportMode[keyof typeof CatalogImportMode];
export type CatalogImportNode = Node & {
  __typename?: 'CatalogImportNode';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
  /** The details about the catalog import job. */
  job: CatalogImportJob;
};

/** Input for the `catalogImportStart` mutation. */
export type CatalogImportStartInput = {
  /** Indicates whether the import should be a dry run. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the job used in dry run mode to upload the input file for the actual import. */
  inputFromJobId?: InputMaybe<Scalars['ID']['input']>;
  /** The mode of the import, controlling the behavior of the import process. */
  mode: CatalogImportMode | '%future added value';
  /** The ID of the vendor for whom the catalog is being imported. */
  vendorId: Scalars['ID']['input'];
};

export type CatalogImportStartResponse = AuthorizationFailure | CatalogImportStartResult | InputValidationFailure;

/** The result of starting a catalog import job. */
export type CatalogImportStartResult = AppsyncResponse & {
  __typename?: 'CatalogImportStartResult';
  /** The catalog import job created as a result of the mutation. */
  job: CatalogImportJob;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type CatalogImportStatusResponse = AuthorizationFailure | CatalogImportStatusResult | InputValidationFailure;

export type CatalogImportStatusResult = AppsyncResponse & {
  __typename?: 'CatalogImportStatusResult';
  /** The catalog import job. */
  job: CatalogImportJob;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type CatalogImportTemplateResponse = AuthorizationFailure | CatalogImportTemplateResult;

/** The response type for CatalogImport Template. */
export type CatalogImportTemplateResult = AppsyncResponse & {
  __typename?: 'CatalogImportTemplateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** URL for the catalog import template. */
  url: Scalars['AWSURL']['output'];
};

export type CatalogImportsFilter = {
  status?: InputMaybe<Array<JobStatus | '%future added value'>>;
};

export type CatalogImportsInput = {
  /** Additional filters for the items to narrow down the output */
  filter?: InputMaybe<CatalogImportsFilter>;
  /** Pagination filter. */
  pagination?: InputMaybe<PaginationInputV2>;
  /** The ID of the vendor for whom the catalog is being imported. */
  vendorId: Scalars['ID']['input'];
};

export type CatalogImportsResponse = AuthorizationFailure | CatalogImportsResult | InputValidationFailure;

export type CatalogImportsResult = AppsyncResponse & Connection & Page & {
  __typename?: 'CatalogImportsResult';
  /** The edges of the response. */
  edges: Array<CatalogImportsResultEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type CatalogImportsResultEdge = Edge & {
  __typename?: 'CatalogImportsResultEdge';
  /**
   * The cursor for the current item.
   * This can be used to fetch the next page of items starting using this item as a reference.
   */
  cursor: Scalars['String']['output'];
  /** A "CatalogImportsResultEdge" node containing the actual data. */
  node: CatalogImportNode;
};

export type CatalogNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'CatalogNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CatalogProductsConnection = Connection & {
  __typename?: 'CatalogProductsConnection';
  edges: Array<CatalogProductsEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type CatalogProductsEdge = Edge & {
  __typename?: 'CatalogProductsEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

/**
 * Catalog attribute facet bucket (allergen / dietary). Only the id and doc count
 * are emitted here. The translated label and the rest of the CatalogAttributeValue
 * fields are resolved by CatalogAttributeValueRef.node (owned by catalogServiceK8s).
 */
export type CatalogSearchAttributeFacet = {
  __typename?: 'CatalogSearchAttributeFacet';
  count: Scalars['Int']['output'];
  ref: CatalogAttributeValueRef;
};

/** A single brand facet bucket: the brand string and the number of matching items. */
export type CatalogSearchBrandFacet = {
  __typename?: 'CatalogSearchBrandFacet';
  count: Scalars['Int']['output'];
  value: VendorBrand;
};

/**
 * Category facet bucket. Only the id and doc count are emitted here. The category
 * entity is resolved by the existing VendorItemCategoryRef.node resolver on
 * catalogServiceK8s (ResolverVendorItemCategoryRefNodeController.vendorItemCategoryBatch).
 */
export type CatalogSearchCategoryFacet = {
  __typename?: 'CatalogSearchCategoryFacet';
  count: Scalars['Int']['output'];
  ref: VendorItemCategoryRef;
};

/**
 * Faceted filter values with document counts for the current search.
 * Counts use "excluded-self" semantics: selecting a facet narrows the items list
 * but does not narrow its own facet values — selecting a brand still returns
 * every brand that matches the other active filters.
 */
export type CatalogSearchFacets = {
  __typename?: 'CatalogSearchFacets';
  allergenFreeFrom: Array<CatalogSearchAttributeFacet>;
  brands: Array<CatalogSearchBrandFacet>;
  /**
   * Null for order guide searches — the categories filter has been removed from
   * order guide search, so there are no category facets to compute.
   */
  categories?: Maybe<Array<CatalogSearchCategoryFacet>>;
  dietaryCertification: Array<CatalogSearchAttributeFacet>;
  dietaryLifestyle: Array<CatalogSearchAttributeFacet>;
};

/**
 * Metadata related to a search result set. Only present on search endpoints.
 * Owned by catalogSearchServiceK8s.
 */
export type CatalogSearchMetadata = {
  __typename?: 'CatalogSearchMetadata';
  /**
   * The custom synonym mappings that were applied to expand this query. Absent /
   * empty when no rule matched.
   */
  appliedSynonyms?: Maybe<Array<AppliedSearchSynonym>>;
  /**
   * Unique identifier for this search query. Used to join backend logs with
   * client-side analytics events for search relevance measurement.
   */
  queryId?: Maybe<Scalars['String']['output']>;
  /** The version used to return the result set. */
  searchVersion: Scalars['String']['output'];
};

export type CategoryInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryProducts = Node & {
  __typename?: 'CategoryProducts';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Product>>;
};

export type Chat = Node & {
  __typename?: 'Chat';
  /** The account of the chat. Null if no account is set. */
  account?: Maybe<Account>;
  activatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  additionalEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated use supplierEntityId instead */
  botUserId?: Maybe<Scalars['ID']['output']>;
  buyer?: Maybe<Buyer>;
  cart?: Maybe<Cart>;
  chatName?: Maybe<Scalars['String']['output']>;
  churn?: Maybe<ChatChurn>;
  contacts: Array<CustomerContact>;
  createdBy?: Maybe<CreatedBy>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  /** delivery settings of chat which was previously used from supplierDeliveryDateSettings query */
  deliveryDateSettings?: Maybe<SupplierDeliveryDateSettings>;
  enabled: Scalars['Boolean']['output'];
  hasMessages?: Maybe<Scalars['Boolean']['output']>;
  hasOrderTransmission?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this field. */
  hasProducts?: Maybe<Scalars['Boolean']['output']>;
  hasRequestedOrderGuide?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Set to true if there is at least one vendor catalog item in the scope of visibility of this chat.
   * This does not include custom vendor items.
   */
  hasVendorCatalog?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invite?: Maybe<InviteTransmission>;
  /** Status of the most advanced invite sent for this chat; there could be many invites for one chat, but we pick the most advanced invote */
  inviteStatus?: Maybe<InviteStatus | '%future added value'>;
  /** True if chat is a test chat on Choco's Dogfood programme */
  isPuppy?: Maybe<Scalars['Boolean']['output']>;
  isUserInChat?: Maybe<Scalars['Boolean']['output']>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  /** The active magic code associated with this chat. Null if no active code exists. */
  magicCode?: Maybe<MagicCode>;
  messages: ChatMessageConnection;
  /**
   * The note associated with the lead.
   * It is up to backend policy to determine which note this is.
   * Null if and only if there is no note attached to the lead.
   */
  note?: Maybe<DistributorNote>;
  omnichannelOrderCustomer?: Maybe<OmnichannelOrderCustomer>;
  /** @deprecated Use Chat.orderGuides instead */
  orderGuide?: Maybe<OrderGuideV2Ref>;
  /** All the order-guides attached to the chat */
  orderGuides?: Maybe<Array<OrderGuideV2Ref>>;
  orderingSettings?: Maybe<ChatOrderingSettings>;
  /** @deprecated Not returned anymore. Use `orderGuideV2ItemUnits` instead */
  products?: Maybe<Array<Product>>;
  restaurantName?: Maybe<Scalars['String']['output']>;
  sendBuyerOrderConfirmation?: Maybe<Scalars['Boolean']['output']>;
  status: ChatStatus | '%future added value';
  /** @deprecated Not returned anymore. See notice for `customCatalogsForChat` */
  subCatalog?: Maybe<SubCatalog>;
  subCatalogId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated use supplierEntity instead */
  supplier?: Maybe<User>;
  supplierCustomerName?: Maybe<Scalars['String']['output']>;
  supplierEntity?: Maybe<Supplier>;
  supplierEntityId?: Maybe<Scalars['ID']['output']>;
  /**
   * A task associated with the chat. It is up to backend policy to determine
   * which task this is.
   */
  task?: Maybe<DistributorTask>;
  type?: Maybe<ChatType | '%future added value'>;
  /**
   * Unread state for the current user.
   * Null when unread is not requested or not applicable.
   */
  unread?: Maybe<ChatUnreadState>;
  users: ChatUserConnection;
  usesExtendedCatalog?: Maybe<Scalars['Boolean']['output']>;
};


export type ChatIsUserInChatArgs = {
  userId: Scalars['ID']['input'];
};


export type ChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy?: InputMaybe<MessageGroupFilter>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ChatUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** Job already existed and is currently active (awaitingUpload or pending). */
export type ChatAssignmentImportJobActive = {
  __typename?: 'ChatAssignmentImportJobActive';
  status: ChatAssignmentImportJobActiveStatus | '%future added value';
};

export const ChatAssignmentImportJobActiveStatus = {
  AwaitingUpload: 'AwaitingUpload',
  Pending: 'Pending'
} as const;

export type ChatAssignmentImportJobActiveStatus = typeof ChatAssignmentImportJobActiveStatus[keyof typeof ChatAssignmentImportJobActiveStatus];
/** Job was just created. uploadUrl is valid for 1 hour. */
export type ChatAssignmentImportJobCreated = {
  __typename?: 'ChatAssignmentImportJobCreated';
  uploadUrl: Scalars['String']['output'];
};

/** Job already existed and processing failed. */
export type ChatAssignmentImportJobFailed = {
  __typename?: 'ChatAssignmentImportJobFailed';
  failureMessage?: Maybe<Scalars['String']['output']>;
  failureReason: ChatAssignmentImportJobFailureReason | '%future added value';
  processedAt: Scalars['AWSTimestamp']['output'];
};

export const ChatAssignmentImportJobFailureReason = {
  ConcurrentWrite: 'ConcurrentWrite',
  DocumentError: 'DocumentError',
  JobAlreadyCompleted: 'JobAlreadyCompleted',
  JobAlreadyProcessing: 'JobAlreadyProcessing',
  Unknown: 'Unknown'
} as const;

export type ChatAssignmentImportJobFailureReason = typeof ChatAssignmentImportJobFailureReason[keyof typeof ChatAssignmentImportJobFailureReason];
export type ChatAssignmentImportJobGetOrCreateInput = {
  costGuideExternalId: Scalars['String']['input'];
  externalJobId: Scalars['String']['input'];
  mode: ChatAssignmentImportJobWriteMode | '%future added value';
  supplierId: Scalars['ID']['input'];
};

export type ChatAssignmentImportJobInfo = {
  __typename?: 'ChatAssignmentImportJobInfo';
  costGuideExternalId: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  externalJobId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mode: ChatAssignmentImportJobWriteMode | '%future added value';
  status: ChatAssignmentImportJobStatus;
  supplierId: Scalars['ID']['output'];
};

export type ChatAssignmentImportJobStatus = ChatAssignmentImportJobActive | ChatAssignmentImportJobCreated | ChatAssignmentImportJobFailed | ChatAssignmentImportJobSucceeded;

/** Job already existed and processing completed successfully. */
export type ChatAssignmentImportJobSucceeded = {
  __typename?: 'ChatAssignmentImportJobSucceeded';
  processedAt: Scalars['AWSTimestamp']['output'];
};

export const ChatAssignmentImportJobWriteMode = {
  Replace: 'Replace',
  Upsert: 'Upsert'
} as const;

export type ChatAssignmentImportJobWriteMode = typeof ChatAssignmentImportJobWriteMode[keyof typeof ChatAssignmentImportJobWriteMode];
export type ChatChurn = {
  __typename?: 'ChatChurn';
  lastOrderDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  lastOrderDateLocal?: Maybe<Scalars['AWSDate']['output']>;
  lastOrderId?: Maybe<Scalars['String']['output']>;
  orderFrequency?: Maybe<ChatChurnOrderFrequency | '%future added value'>;
  orderingTrend?: Maybe<ChatChurnOrdersTrend | '%future added value'>;
  ordersTrend?: Maybe<Scalars['Float']['output']>;
  predictedNextOrderDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  predictedNextOrderDateLocal?: Maybe<Scalars['AWSDate']['output']>;
  status: ChatChurnStatus | '%future added value';
};

export const ChatChurnOrderFrequency = {
  BiMonthly: 'biMonthly',
  BiWeekly: 'biWeekly',
  Daily: 'daily',
  Monthly: 'monthly',
  Quarterly: 'quarterly',
  Weekly: 'weekly'
} as const;

export type ChatChurnOrderFrequency = typeof ChatChurnOrderFrequency[keyof typeof ChatChurnOrderFrequency];
export const ChatChurnOrdersTrend = {
  Decreasing: 'decreasing',
  Increasing: 'increasing',
  NoChange: 'noChange',
  SignificantDecrease: 'significantDecrease',
  SignificantIncrease: 'significantIncrease'
} as const;

export type ChatChurnOrdersTrend = typeof ChatChurnOrdersTrend[keyof typeof ChatChurnOrdersTrend];
export const ChatChurnStatus = {
  Active: 'active',
  ChurnRisk: 'churnRisk',
  Churned: 'churned',
  EarlyOrdering: 'earlyOrdering',
  FirstOrder: 'firstOrder',
  NoOrdersYet: 'noOrdersYet',
  NonActive: 'nonActive',
  Ordering: 'ordering'
} as const;

export type ChatChurnStatus = typeof ChatChurnStatus[keyof typeof ChatChurnStatus];
export type ChatCreateInput = {
  addBuyerTeam?: InputMaybe<Scalars['Boolean']['input']>;
  additionalEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  chatName?: InputMaybe<Scalars['String']['input']>;
  createdContext?: InputMaybe<CreatedContext | '%future added value'>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  /** set this flag to enroll this chat as a test chat on Choco's Dogfood programme */
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  products?: InputMaybe<Array<AdminProductInput>>;
  restaurantName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ChatStatus | '%future added value'>;
  subCatalogId?: InputMaybe<Scalars['ID']['input']>;
  supplierCustomerName?: InputMaybe<Scalars['String']['input']>;
  supplierEntityId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated use supplierEntityId instead */
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ChatType | '%future added value'>;
  userIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type ChatCreated = {
  __typename?: 'ChatCreated';
  name?: Maybe<Scalars['String']['output']>;
};

export type ChatEventTypes = CartCanceled | CartOpened | CartSubmitted | CartUpdated | ChatCreated | ChatNameUpdated | OrderEdited | OrderGuideCreated | OrderGuideRequested | ReconciliationRequestConfirmed | RequestedChatActivated | RequestedChatCreated | UserAddedToChat | UserRemovedFromChat;

export type ChatFilter = {
  additionalEmail?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['String']['input']>;
  chatName?: InputMaybe<Scalars['String']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreChatsWithStatus?: InputMaybe<Array<InputMaybe<ChatStatus | '%future added value'>>>;
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  restaurantName?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ChatStatus | '%future added value'>;
  /** used in conjunction with labels filter and used by infra to fetch supplier chatLabels */
  supplierEntityId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** userId for salesReps and botUserId for supplierAdmins; applicable for infra or admin */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChatHasSupplierEmailSupportResponse = AuthorizationFailure | ChatHasSupplierEmailSupportResult | ChatNotFoundError | InputValidationFailure;

export type ChatHasSupplierEmailSupportResult = {
  __typename?: 'ChatHasSupplierEmailSupportResult';
  hasEmailSupport: Scalars['Boolean']['output'];
};

export type ChatInviteInput = {
  channel?: InputMaybe<InviteChannel | '%future added value'>;
  /** existing chat id to use, a new chat will be created if not given */
  chatId?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  googlePlaceName?: InputMaybe<Scalars['String']['input']>;
  googlefullAddress?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<AdminProductInput>>;
  restaurantName?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use message and channel */
  smsMessage?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  subCatalogId?: InputMaybe<Scalars['ID']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['String']['input']>>;
  userName?: InputMaybe<Scalars['String']['input']>;
  /** offset from UTC in minutes */
  utcOffset?: InputMaybe<Scalars['Int']['input']>;
};

export const ChatInviteLoginMethod = {
  Email: 'Email',
  Phone: 'Phone'
} as const;

export type ChatInviteLoginMethod = typeof ChatInviteLoginMethod[keyof typeof ChatInviteLoginMethod];
export type ChatInviteRecipient = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};

/**
 * If type is Email, email is required and phone is optional.
 * If type is Phone, phone is required and email is optional.
 */
export type ChatInviteRecipientV2 = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  type: ChatInviteLoginMethod | '%future added value';
};

export type ChatLabel = {
  __typename?: 'ChatLabel';
  chatCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ChatLabelsResult = {
  __typename?: 'ChatLabelsResult';
  count?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/**
 * Mark-read was rejected because unread state changed since baseRev
 * (for example another device marked a message unread). Includes the current
 * unread state; do not retry with the same baseRev.
 */
export type ChatMarkReadConflict = AppsyncResponse & {
  __typename?: 'ChatMarkReadConflict';
  responseType: ResponseType | '%future added value';
  unread: ChatUnreadState;
};

export type ChatMarkReadInput = {
  /**
   * The unread state version the client last observed for this chat.
   * Prevents a stale mark-read from clearing an unread the client had not yet seen.
   */
  baseRev: Scalars['Int']['input'];
  chatId: Scalars['ID']['input'];
};

export type ChatMarkReadResponse = AuthorizationFailure | ChatMarkReadConflict | ChatMarkReadResult | InputValidationFailure;

export type ChatMarkReadResult = AppsyncResponse & {
  __typename?: 'ChatMarkReadResult';
  responseType: ResponseType | '%future added value';
  unread: ChatUnreadState;
};

export const ChatMatchedBy = {
  Cache: 'cache',
  OrderInput: 'orderInput',
  PhoneLookup: 'phoneLookup',
  Search: 'search'
} as const;

export type ChatMatchedBy = typeof ChatMatchedBy[keyof typeof ChatMatchedBy];
export type ChatMessageConnection = Connection & {
  __typename?: 'ChatMessageConnection';
  edges?: Maybe<Array<ChatMessageEdge>>;
};

export type ChatMessageEdge = Edge & {
  __typename?: 'ChatMessageEdge';
  cursor: Scalars['String']['output'];
  node: Message;
};

/**
 * Mark-read through this message was rejected because unread state changed
 * since baseRev (for example another device marked a message unread).
 * Includes the current unread state; do not retry with the same baseRev.
 */
export type ChatMessageMarkReadConflict = AppsyncResponse & {
  __typename?: 'ChatMessageMarkReadConflict';
  responseType: ResponseType | '%future added value';
  unread: ChatUnreadState;
};

export type ChatMessageMarkReadInput = {
  /**
   * The unread state version the client last observed for this chat.
   * Pass the last synced Chat.unread.rev so a stale request cannot undo
   * newer unread state from another device.
   */
  baseRev: Scalars['Int']['input'];
  chatId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
};

export type ChatMessageMarkReadResponse = AuthorizationFailure | ChatMessageMarkReadConflict | ChatMessageMarkReadResult | InputValidationFailure;

export type ChatMessageMarkReadResult = AppsyncResponse & {
  __typename?: 'ChatMessageMarkReadResult';
  responseType: ResponseType | '%future added value';
  unread: ChatUnreadState;
};

export type ChatMessageMarkUnreadInput = {
  chatId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
};

export type ChatMessageMarkUnreadResponse = AuthorizationFailure | ChatMessageMarkUnreadResult | InputValidationFailure;

export type ChatMessageMarkUnreadResult = AppsyncResponse & {
  __typename?: 'ChatMessageMarkUnreadResult';
  responseType: ResponseType | '%future added value';
  unread: ChatUnreadState;
};

/**
 * Hover: who is treated as having read this message.
 * Excludes the signed-in viewer. Candidates are this chat's unread audience
 * (assigned supplier members plus all supplier admins).
 */
export type ChatMessageReadersInput = {
  chatId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
};

export type ChatMessageReadersResponse = AuthorizationFailure | ChatMessageReadersResult | InputValidationFailure;

export type ChatMessageReadersResult = AppsyncResponse & {
  __typename?: 'ChatMessageReadersResult';
  responseType: ResponseType | '%future added value';
  /**
   * Unread-audience users for this chat, excluding the signed-in viewer,
   * who are treated as having read the message.
   * Empty if the viewer is the only audience member, or nobody else has read it yet.
   */
  users: Array<UserRef>;
};

export type ChatNameUpdated = {
  __typename?: 'ChatNameUpdated';
  /** @deprecated we no longer support it */
  name?: Maybe<Scalars['String']['output']>;
};

export type ChatNotFoundError = AppsyncError & AppsyncResponse & {
  __typename?: 'ChatNotFoundError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type ChatNotificationInput = {
  /** chat ID */
  id: Scalars['ID']['input'];
  newMessage?: InputMaybe<ChatNotificationUserListsInput>;
  newOrder?: InputMaybe<ChatNotificationUserListsInput>;
};

/** supplier new order and new message notification preferences on a chat level */
export type ChatNotificationPreferences = {
  __typename?: 'ChatNotificationPreferences';
  /** chat ID */
  id: Scalars['ID']['output'];
  /** API defaults this to newOrder prefs */
  newMessage?: Maybe<ChatNotificationUserLists>;
  newOrder?: Maybe<ChatNotificationUserLists>;
};

export type ChatNotificationUserLists = {
  __typename?: 'ChatNotificationUserLists';
  deselectedUsers: Array<User>;
  /** the users who are deselected from the supplier's chat-level notification preferences */
  deselectedUsersList: Array<Scalars['ID']['output']>;
  extraUsers?: Maybe<Array<User>>;
  /** the users who want to receive new order/message notifications but are not a supplier */
  extraUsersList?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ChatNotificationUserListsInput = {
  deselectedUsersList: Array<Scalars['ID']['input']>;
  extraUsersList?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ChatOrderingSettings = {
  __typename?: 'ChatOrderingSettings';
  /**
   * Whether the ecommerce PO number is enabled for the chat.
   * If not set specifically for this chat, supplier level settings will be returned.
   */
  isEcommercePoNumberEnabled: Scalars['Boolean']['output'];
  /** Whether the ecommerce PO number is required for the chat. This setting should only be used if isEcommercePoNumberEnabled is true. */
  isEcommercePoNumberRequired: Scalars['Boolean']['output'];
};

export type ChatOrderingSettingsInput = {
  chatId: Scalars['String']['input'];
  /**
   * Whether the ecommerce PO number is enabled for the chat.
   * If not set, the supplier level settings will be used.
   * If set, it will override supplier level settings.
   */
  isEcommercePoNumberEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the ecommerce PO number is required for the chat. This setting will only be used if isEcommercePoNumberEnabled is true. */
  isEcommercePoNumberRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatOrderingSettingsUpdateResponse = AuthorizationFailure | ChatOrderingSettings | InputValidationFailure;

export type ChatPricesVisibilityResponse = AuthorizationFailure | ChatPricesVisibilitySuccess | InputValidationFailure;

/** Success response of the `chatPricesVisibility` query */
export type ChatPricesVisibilitySuccess = AppsyncResponse & {
  __typename?: 'ChatPricesVisibilitySuccess';
  displayPricesOverride?: Maybe<Scalars['Boolean']['output']>;
  responseType: ResponseType | '%future added value';
};

export type ChatPricesVisibilityUpdateInput = {
  chatId: Scalars['ID']['input'];
  /**
   * The value of the override for the prices visibility of a chat.
   *
   * If the field is not sent, the prices visibility will be set to NULL and the prices
   * resolving will fallback to the Supplier-level settings.
   *
   * Otherwise, the override value will be set for the chat and takes priority
   * over the Supplier-level settings when resolving the prices.
   *
   * If set to `true`, the product prices will be displayed to the buyers.
   * If set to `false`, the product prices will not be displayed to the buyers.
   * In that case, buyers will only see their Buyer My Price values.
   */
  displayPricesOverride?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatPricesVisibilityUpdateResponse = AuthorizationFailure | ChatPricesVisibilitySuccess | InputValidationFailure;

export type ChatProductFeatures = {
  __typename?: 'ChatProductFeatures';
  currentPurchasingPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * Base unit code (e.g. "lb", "kg") if currentPurchasingPrice is base-unit denominated. Null = ordering unit (case).
   * Same free-form code space as OrderedProduct.baseUnitCode. Not the currency — see lastOrderCurrency.
   */
  currentPurchasingPriceBaseUnitCode?: Maybe<Scalars['String']['output']>;
  lastOrderBasePrice?: Maybe<Scalars['Float']['output']>;
  lastOrderCurrency?: Maybe<Scalars['String']['output']>;
  lastOrderDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  lastOrderPrice?: Maybe<Scalars['Float']['output']>;
  lastOrderPurchasingPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * Base unit code (e.g. "lb", "kg") if lastOrderPurchasingPrice is base-unit denominated. Null = ordering unit (case).
   * Same free-form code space as OrderedProduct.baseUnitCode. Not the currency — see lastOrderCurrency.
   */
  lastOrderPurchasingPriceBaseUnitCode?: Maybe<Scalars['String']['output']>;
  minProfitMargin?: Maybe<Scalars['Float']['output']>;
};

export type ChatRef = Node & RefEdge & {
  __typename?: 'ChatRef';
  /** Id of the referenced chat */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual chat by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<Chat>;
};

export const ChatStatus = {
  Active: 'active',
  Archived: 'archived',
  Pending: 'pending',
  Requested: 'requested'
} as const;

export type ChatStatus = typeof ChatStatus[keyof typeof ChatStatus];
export type ChatSubCatalogProductsError = AppsyncError & AppsyncResponse & {
  __typename?: 'ChatSubCatalogProductsError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type ChatSubCatalogProductsInput = {
  chatId: Scalars['ID']['input'];
  filter?: InputMaybe<ProductFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
};

export type ChatSubCatalogProductsResponse = ChatNotFoundError | ChatSubCatalogProductsError | ProductSearchResult | ValidationError;

export type ChatSuppliersByLocations = {
  __typename?: 'ChatSuppliersByLocations';
  result?: Maybe<Array<Maybe<SupplierDetails>>>;
  supplierIds: Array<Maybe<Scalars['ID']['output']>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ChatTaxProfile = Node & {
  __typename?: 'ChatTaxProfile';
  chat: ChatRef;
  /** Epoch seconds. */
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  jurisdiction: TaxJurisdictionRef;
  /** Epoch seconds. */
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type ChatTaxProfileListInput = {
  /**
   * Optional filter, 1 to 100 chats. Without it every profile of the vendor is
   * listed. Chats without a profile are absent from the result.
   */
  chatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<PaginationInputV2>;
  vendorId: Scalars['ID']['input'];
};

export type ChatTaxProfileListResponse = AuthorizationFailure | ChatTaxProfileListResult | InputValidationFailure;

export type ChatTaxProfileListResult = AppsyncResponse & Connection & Page & {
  __typename?: 'ChatTaxProfileListResult';
  edges: Array<ChatTaxProfileListResultEdge>;
  pageInfo: PageInfo;
  responseType: ResponseType | '%future added value';
};

export type ChatTaxProfileListResultEdge = Edge & {
  __typename?: 'ChatTaxProfileListResultEdge';
  cursor: Scalars['String']['output'];
  node: ChatTaxProfile;
};

export const ChatType = {
  Ordering: 'ordering',
  Support: 'support'
} as const;

export type ChatType = typeof ChatType[keyof typeof ChatType];
/**
 * Jump target for unread: opaque messages connection cursor.
 * Null wrapper means there is no jump target.
 * Pass `cursor` to `messages(before:, last:)`.
 * Do not select on chatsInbox — only when jumping.
 */
export type ChatUnreadJumpCursor = {
  __typename?: 'ChatUnreadJumpCursor';
  /** Opaque messages connection cursor. Pass to messages(before:, last:). */
  cursor: Scalars['String']['output'];
};

/** Per-user unread summary for a chat. */
export type ChatUnreadState = {
  __typename?: 'ChatUnreadState';
  /**
   * Start of the unread streak (same clock/scale as Message.createdAt).
   * Used to place the “new messages” delimiter among loaded timeline messages.
   * Null when there are no unreads.
   */
  firstUnreadAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /**
   * Jump target for unread. Null when there is no jump target.
   * Clients should not select this on chatsInbox — resolve only when jumping.
   * Selection: `firstUnreadMessageCursor { cursor }`, then
   * `messages(before: cursor, last: N)`.
   */
  firstUnreadMessageCursor?: Maybe<ChatUnreadJumpCursor>;
  /** Whether this chat has unread messages for the user. */
  hasUnread: Scalars['Boolean']['output'];
  /**
   * Version of this chat's unread state.
   * Increases when unread state changes. Pass the last observed value as
   * baseRev when marking the chat read.
   */
  rev: Scalars['Int']['output'];
  /** Number of unread messages. Capped at 9; a value of 9 means 9 or more. */
  unreadCount: Scalars['Int']['output'];
};

export type ChatUpdateCreatedByInput = {
  createdContext?: InputMaybe<CreatedContext | '%future added value'>;
};

export type ChatUpdateInput = {
  additionalEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  chatName?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<ChatUpdateCreatedByInput>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  restaurantName?: InputMaybe<Scalars['String']['input']>;
  sendBuyerOrderConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ChatStatus | '%future added value'>;
  subCatalogId?: InputMaybe<Scalars['ID']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type ChatUpdateSubscriptionResponse = AuthorizationFailure | ChatUpdatedNotification;

export type ChatUpdatedNotification = {
  __typename?: 'ChatUpdatedNotification';
  chatId: Scalars['ID']['output'];
  /**
   * Required for AppSync subscription routing against `chatUpdateSubscription(userId)`.
   * Clients may ignore this field and use `chatId` only.
   */
  userId: Scalars['ID']['output'];
};

export type ChatUser = {
  __typename?: 'ChatUser';
  chatId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ChatUserConnection = Connection & {
  __typename?: 'ChatUserConnection';
  edges?: Maybe<Array<ChatUserEdge>>;
};

export type ChatUserEdge = Edge & {
  __typename?: 'ChatUserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

/** Chat users of the supplier */
export type ChatUsers = {
  __typename?: 'ChatUsers';
  /** Chat ID of the users */
  chatId: Scalars['String']['output'];
  /** Chat user IDs to target for the campaign */
  userIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type ChatsConnection = Connection & {
  __typename?: 'ChatsConnection';
  edges: Array<ChatsEdge>;
};

export type ChatsEdge = Edge & {
  __typename?: 'ChatsEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

export type ChatsInboxFilter = {
  /** When true, only chats that have unread messages. */
  hasUnreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatsInboxInput = {
  filter?: InputMaybe<ChatsInboxFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  /**
   * Whose inbox to load.
   * Sales reps: the signed-in user. Supplier admins: the supplier bot user.
   */
  userId: Scalars['ID']['input'];
};

export type ChatsInboxResponse = AuthorizationFailure | InputValidationFailure | UserChatConnection;

export type CheckSupplierPhoneNumberConflictInput = {
  phoneNumber: Scalars['String']['input'];
};

export type CheckSupplierPhoneNumberConflictResponse = AuthorizationFailure | InputValidationFailure | SupplierPhoneNumberConflictResult;

/**
 * Commit cart intent. Same core fields as evaluate plus the persistence-only
 * fields: poNumber, order-level buyerComment, and per-line buyerComment.
 */
export type CheckoutCartIntentInput = {
  /**
   * Optional order-level buyer comment persisted on the committed order.
   * Persists to Order.body (the field orderCreateV2 takes as OrderCreateV2Input
   * .body); named buyerComment for symmetry with CheckoutCartLineInput.
   * Commit-only: not evaluated in cartEvaluate, no order-level validation today.
   */
  buyerComment?: InputMaybe<Scalars['String']['input']>;
  /** Cart analytics id from a prior evaluate when available. */
  cartId?: InputMaybe<Scalars['ID']['input']>;
  /** Buyer↔supplier chat scope. */
  chatId: Scalars['ID']['input'];
  /** Requested delivery date. */
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  /** Top-up intent. */
  isTopUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** One row per vendorItemUnitId. */
  lineItems: Array<CheckoutCartLineInput>;
  /** Optional purchase-order number persisted on commit. */
  poNumber?: InputMaybe<Scalars['String']['input']>;
  /** CART_FREE_EXTRA_UNITS reward selections. */
  promotionChoices?: Array<PromotionChoiceInput>;
};

export type CheckoutCartLineInput = {
  /**
   * Optional per-line buyer note persisted on commit. A supplier that disallows
   * notes (Supplier.allowBuyerComment false) blocks the commit with
   * BuyerCommentValidationResult naming each commented line.
   */
  buyerComment?: InputMaybe<Scalars['String']['input']>;
  /** Cart quantity (must be positive). */
  quantity: DecimalInput;
  /** Catalog unit. */
  vendorItemUnitId: Scalars['ID']['input'];
};

export type CheckoutCommittedResult = {
  __typename?: 'CheckoutCommittedResult';
  /**
   * Persisted order snapshot (receipt). No evaluatedCart on this result: it
   * would duplicate money/lines the client already has on Order.
   */
  order: Order;
  /** Shared AppSync transport discriminator. Always success for this result. */
  responseType: ResponseType | '%future added value';
};

export type CheckoutCorrectionRequiredResult = {
  __typename?: 'CheckoutCorrectionRequiredResult';
  /**
   * Fresh evaluation with line-repair BLOCKED entries (StockValidationResult,
   * InvalidProductValidationResult with NOT_FOUND, or
   * BuyerCommentValidationResult). Returned in preference to
   * CheckoutValidationBlockedResult when a line-repair block coexists with other
   * BLOCKED validations.
   */
  evaluatedCart: EvaluatedCart;
  /**
   * Shared AppSync transport discriminator. Always success (business block,
   * not transport error).
   */
  responseType: ResponseType | '%future added value';
};

export type CheckoutCreateInput = {
  /**
   * Commit cart intent. Includes the persistence-only poNumber / order and line
   * buyerComment, and is always re-evaluated at commit.
   */
  cart: CheckoutCartIntentInput;
  /**
   * Client-minted UUID for this Order Now attempt (UUID v4 required). The
   * server never issues it. Same-key retry returns the original commit result
   * instead of creating a duplicate order. Generate once when the buyer taps
   * submit, persist with the attempt, and reuse on network/timeout retries.
   * There is no client cache or pre-check that validates this key: only server
   * commit dedupe. Mint a new UUID only for a new buyer attempt.
   */
  idempotencyKey: Scalars['ID']['input'];
};

/**
 * Business + transport outcomes for checkoutCreate. No flat status enum or
 * nullable order/evaluatedCart/error sibling fields: the client switches on
 * __typename, the same pattern as CartValidationResult. No CHOICE_REQUIRED
 * union member (no choice = no gift). No IN_PROGRESS / UNKNOWN_OUTCOME /
 * IDEMPOTENCY_CONFLICT member: network/timeout retries reuse idempotencyKey;
 * Checkout/Order dedupe the commit.
 * AuthorizationFailure / InputValidationFailure are request-level failures
 * (same shared AppSync results as CartEvaluateResponse).
 */
export type CheckoutCreateResponse = AuthorizationFailure | CheckoutCommittedResult | CheckoutCorrectionRequiredResult | CheckoutFailedResult | CheckoutValidationBlockedResult | InputValidationFailure;

export type CheckoutFailedResult = {
  __typename?: 'CheckoutFailedResult';
  /**
   * Dependency incompletenesses from this commit attempt. Non-empty.
   * Same EvaluationDependencyFailure model as CartEvaluationFailedResult.
   * Codes include PRICING_UNAVAILABLE, PROMOTIONS_UNAVAILABLE, TAX_UNAVAILABLE,
   * MOV_UNAVAILABLE, and checkoutCreate-only ORDER_LOOKUP_UNAVAILABLE.
   */
  errors: Array<EvaluationDependencyFailure>;
  /**
   * On this failed result: set for the fail-closed codes that keep the composed
   * cart (PROMOTIONS_UNAVAILABLE, MOV_UNAVAILABLE, TAX_UNAVAILABLE); null for
   * codes that abort before composition (PRICING_UNAVAILABLE,
   * ORDER_LOOKUP_UNAVAILABLE). A successful result carries the cart on its own field.
   */
  evaluatedCart?: Maybe<EvaluatedCart>;
  /**
   * Shared AppSync transport discriminator. Always error for this result
   * (dependency/system failure, not business out of stock or minimum order
   * value).
   */
  responseType: ResponseType | '%future added value';
};

export type CheckoutValidationBlockedResult = {
  __typename?: 'CheckoutValidationBlockedResult';
  /**
   * Fresh evaluation with an active non-overridden BLOCKED validation
   * (e.g. MovValidationResult) and no coexisting line-repair block.
   */
  evaluatedCart: EvaluatedCart;
  /**
   * Shared AppSync transport discriminator. Always success (business block,
   * not transport error).
   */
  responseType: ResponseType | '%future added value';
};

export type ChocoEntityNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'ChocoEntityNotFound';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export const ChocoEntityType = {
  Supplier: 'SUPPLIER'
} as const;

export type ChocoEntityType = typeof ChocoEntityType[keyof typeof ChocoEntityType];
export type CityWithOffsets = {
  __typename?: 'CityWithOffsets';
  city?: Maybe<Scalars['String']['output']>;
  utcOffsets?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type ClaimOnboardingChecklistRewardError = AppsyncError & AppsyncResponse & {
  __typename?: 'ClaimOnboardingChecklistRewardError';
  errorCode?: Maybe<ClaimOnboardingChecklistRewardErrorCode | '%future added value'>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export const ClaimOnboardingChecklistRewardErrorCode = {
  GenericError: 'genericError',
  NoMonetizedChatPresent: 'noMonetizedChatPresent',
  NotCompletedChecklist: 'notCompletedChecklist',
  NotFoundChecklist: 'notFoundChecklist',
  RewardAlreadyClaimed: 'rewardAlreadyClaimed'
} as const;

export type ClaimOnboardingChecklistRewardErrorCode = typeof ClaimOnboardingChecklistRewardErrorCode[keyof typeof ClaimOnboardingChecklistRewardErrorCode];
export type ClaimOnboardingChecklistRewardResponse = AuthorizationFailure | ClaimOnboardingChecklistRewardError | ClaimOnboardingChecklistRewardSuccess;

export type ClaimOnboardingChecklistRewardSuccess = {
  __typename?: 'ClaimOnboardingChecklistRewardSuccess';
  id: Scalars['ID']['output'];
  isRewardClaimed: Scalars['Boolean']['output'];
};

export type ClaimableReward = {
  __typename?: 'ClaimableReward';
  /**
   * Which tier granted the entitlement (picker is tier-scoped). Stays
   * singular: the claimable reward is for the current entitlement tier;
   * STACKABLE repeats show in quantityOffered, not a multi-tier picker.
   */
  appliedTierId: Scalars['ID']['output'];
  /**
   * Gift option ids for the claimable reward. Evaluate returns ids only;
   * render rows via existing VendorItemUnitRef.node.
   */
  offeredUnits: Array<VendorItemUnitRef>;
  /**
   * Which CART_FREE_EXTRA_UNITS promotion this claimable reward is for
   * (claim key via promotion.id). Sheet title via promotion.node when browsing;
   * cart display uses evaluate facts (quantityOffered / offeredUnits).
   */
  promotion: VendorPromotionRef;
  /**
   * Current maximum free units for this entitlement (stackable / partial
   * claims).
   */
  quantityOffered: Decimal;
  /**
   * Contributor vendorItemUnitId values for this claimable entitlement
   * (item association / multi-product attribution). One row per unit on the
   * cart. Echoed back verbatim as
   * PromotionChoiceInput.sourceVendorItemUnitIds on claim.
   */
  sourceVendorItemUnitIds: Array<Scalars['ID']['output']>;
};

export type CognitoAttribute = {
  __typename?: 'CognitoAttribute';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CognitoStateUser = {
  __typename?: 'CognitoStateUser';
  attributes: Array<Maybe<CognitoAttribute>>;
  groups: Array<Maybe<Scalars['String']['output']>>;
  status: CognitoSyncStatus | '%future added value';
};

export type CognitoStateUsers = {
  __typename?: 'CognitoStateUsers';
  email?: Maybe<CognitoStateUser>;
  phone?: Maybe<CognitoStateUser>;
};

/**
 * The status of the user in cognito.
 *   NotCreated - user not created in cognito
 *   Created - user created in cognito, but not synced
 *   Synced - user synced correctly in cognito, including attributes and groups
 *   Corrupted - user exists in cognito, but attributes or groups are incorrect
 *   Federated - federated (SSO) user backed by an external identity provider, not created via signup
 */
export const CognitoSyncStatus = {
  Corrupted: 'Corrupted',
  Created: 'Created',
  Federated: 'Federated',
  NotCreated: 'NotCreated',
  Synced: 'Synced'
} as const;

export type CognitoSyncStatus = typeof CognitoSyncStatus[keyof typeof CognitoSyncStatus];
export type CompanyDetailsInput = {
  companyAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  copyrightText?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyDetailsTwoIncProxy = {
  __typename?: 'CompanyDetailsTwoIncProxy';
  /** Returns full address details for the company or null if any of the fields are missing. */
  address?: Maybe<CompanyDetailsTwoIncProxyAddress>;
  /** Country code as alpha-2 ISO 3166 */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** The unique canonical ID for the company defined by two.inc */
  id: Scalars['String']['output'];
  /** Legal name of the company */
  name: Scalars['String']['output'];
};

export type CompanyDetailsTwoIncProxyAddress = {
  __typename?: 'CompanyDetailsTwoIncProxyAddress';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  /** State/Region/Province. */
  region?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
};

export type CompanyDetailsTwoIncProxyFailure = {
  __typename?: 'CompanyDetailsTwoIncProxyFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CompanyDetailsTwoIncProxyResponse = AuthorizationFailure | CompanyDetailsTwoIncProxyFailure | CompanyDetailsTwoIncProxySuccess | InputValidationFailure;

export type CompanyDetailsTwoIncProxySuccess = {
  __typename?: 'CompanyDetailsTwoIncProxySuccess';
  companyDetails: CompanyDetailsTwoIncProxy;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type ComplementaryRecommendation = {
  __typename?: 'ComplementaryRecommendation';
  vendorItemUnit: VendorItemUnit;
};

/** Response level metadata for `complementaryRecommendations`. */
export type ComplementaryRecommendationMetadata = {
  __typename?: 'ComplementaryRecommendationMetadata';
  /**
   * Unique identifier for this recommendation request. Used to join backend
   * logs with client-side analytics events for relevance measurement.
   */
  queryId?: Maybe<Scalars['String']['output']>;
};

/**
 * Complementary ("often bought with") request. `vendorItems` is a LIST to future-proof for
 * multi-product surfaces: a cart screen would pass every cart line and get complements for the
 * whole basket. On the PDP the list always contains exactly ONE entry (the viewed product).
 */
export type ComplementaryRecommendationsInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
  /** Seed products to recommend complements for. PDP: exactly 1 item; cart (future): many. */
  vendorItems: Array<ComplementaryRecommendationsItemInput>;
};

export type ComplementaryRecommendationsItemInput = {
  vendorItemId: Scalars['ID']['input'];
  vendorItemUnitId: Scalars['ID']['input'];
};

export type ComplementaryRecommendationsResponse = AuthorizationFailure | ComplementaryRecommendationsResult | InputValidationFailure;

export type ComplementaryRecommendationsResult = {
  __typename?: 'ComplementaryRecommendationsResult';
  /**
   * Metadata related to the result set. Absent when nothing response level was
   * determined for this request.
   */
  metadata?: Maybe<ComplementaryRecommendationMetadata>;
  recommendations: Array<ComplementaryRecommendation>;
};

export type ConfidenceSetting = {
  __typename?: 'ConfidenceSetting';
  threshold: Scalars['Float']['output'];
  type: ConfidenceThresholdType | '%future added value';
};

export type ConfidenceSettingInput = {
  threshold: Scalars['Float']['input'];
  type: ConfidenceThresholdType | '%future added value';
};

export const ConfidenceThresholdType = {
  Customer: 'customer',
  Order: 'order',
  Product: 'product',
  ProductQuantity: 'productQuantity'
} as const;

export type ConfidenceThresholdType = typeof ConfidenceThresholdType[keyof typeof ConfidenceThresholdType];
export type ConfirmAccountLinkingError = AppsyncError & AppsyncResponse & {
  __typename?: 'ConfirmAccountLinkingError';
  errorCode?: Maybe<ConfirmAccountLinkingErrorCode | '%future added value'>;
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export const ConfirmAccountLinkingErrorCode = {
  InvalidOtp: 'INVALID_OTP',
  OtpExpired: 'OTP_EXPIRED',
  SourceUserNotFound: 'SOURCE_USER_NOT_FOUND',
  TargetUserNotFound: 'TARGET_USER_NOT_FOUND',
  UserMergeFailed: 'USER_MERGE_FAILED',
  VerificationNotFound: 'VERIFICATION_NOT_FOUND'
} as const;

export type ConfirmAccountLinkingErrorCode = typeof ConfirmAccountLinkingErrorCode[keyof typeof ConfirmAccountLinkingErrorCode];
export type ConfirmAccountLinkingInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  otpCode: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmAccountLinkingResponse = AuthorizationFailure | ConfirmAccountLinkingError | ConfirmAccountLinkingSuccess | InputValidationFailure;

export type ConfirmAccountLinkingSuccess = {
  __typename?: 'ConfirmAccountLinkingSuccess';
  message: Scalars['String']['output'];
};

export type ConfirmDeliveryCheckReconciliationResponse = AuthorizationFailure | DeliveryCheckReconciliationRequest | DeliveryCheckReconciliationRequestAlreadyConfirmed | DeliveryCheckReconciliationRequestNotFound | InputValidationFailure | OrderDeliveryCheckReconciliationRequestIdNotMatched;

/** Input type for confirming the save of the email editor state. */
export type ConfirmSaveEmailEditorStateInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** The S3 URI of the saved email editor state. */
  editorStateUri: Scalars['String']['input'];
  /** The S3 URI of the email template preview image. */
  previewImageUri: Scalars['String']['input'];
};

/** Response type for confirming the save of the email editor state. */
export type ConfirmSaveEmailEditorStateResponse = AuthorizationFailure | ConfirmSaveEmailEditorStateResult | InputValidationFailure;

/** Success result indicating the confirmation of the email editor state save. */
export type ConfirmSaveEmailEditorStateResult = AppsyncResponse & {
  __typename?: 'ConfirmSaveEmailEditorStateResult';
  /** The pre-signed download URL for the email editor state. */
  editorStateDownloadUrl: Scalars['String']['output'];
  /** The pre-signed download URL for the email template preview image. */
  previewImageDownloadUrl: Scalars['String']['output'];
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** Indicates whether the confirmation was successful. */
  success: Scalars['Boolean']['output'];
};

export type ConfirmTransmissionNotAnOrderInput = {
  id: Scalars['ID']['input'];
};

export type ConfirmTransmissionNotAnOrderResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | TransmissionConfirmedNotAnOrder;

export const ConfirmationSource = {
  Android: 'android',
  Email: 'email',
  Ios: 'ios',
  Lobster: 'lobster',
  Sms: 'sms',
  Web: 'web',
  Whatsapp: 'whatsapp'
} as const;

export type ConfirmationSource = typeof ConfirmationSource[keyof typeof ConfirmationSource];
export type ConnectAccountError = AppsyncError & AppsyncResponse & {
  __typename?: 'ConnectAccountError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type ConnectAccountResponse = ConnectAccountError | ConnectAccountUrl;

export type ConnectAccountUrl = {
  __typename?: 'ConnectAccountUrl';
  clientSecret?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ConnectIntegrationAdapterInput = {
  adapterId: Scalars['ID']['input'];
  chocoEntityId?: InputMaybe<Scalars['ID']['input']>;
  chocoEntityType?: InputMaybe<ChocoEntityType | '%future added value'>;
  webhookDeliveryUrl?: InputMaybe<Scalars['String']['input']>;
  webhookFields?: InputMaybe<IntegrationAdapterConnectionWebhookFieldsInput>;
};

export type ConnectIntegrationAdapterResponse = AuthorizationFailure | ChocoEntityNotFound | InputValidationFailure | IntegrationAdapterConnectionAdminResult | IntegrationAdapterConnectionBaseResult | IntegrationAdapterNotFound | UnsupportedIntegrationAdapterType;

export type ConnectedAccount = Node & {
  __typename?: 'ConnectedAccount';
  appName: Scalars['String']['output'];
  errorReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type ConnectedAccountConnection = Connection & {
  __typename?: 'ConnectedAccountConnection';
  edges: Array<ConnectedAccountEdge>;
};

export type ConnectedAccountEdge = Edge & {
  __typename?: 'ConnectedAccountEdge';
  cursor: Scalars['String']['output'];
  node: ConnectedAccount;
};

export type ConnectedAccountInput = {
  refId: Scalars['ID']['input'];
};

export type Connection = {
  edges?: Maybe<Array<Edge>>;
};

/** Represents a contact's information including their contact details and communication channel */
export type ContactDetail = {
  __typename?: 'ContactDetail';
  /** The buyer contact ID (for buyer contacts only) */
  buyerContactId?: Maybe<Scalars['ID']['output']>;
  /** The communication channel type (e.g., email, sms, whatsApp) */
  channel: Scalars['String']['output'];
  /** The contact information (e.g., email address, phone number) */
  contactInfo: Scalars['String']['output'];
  /** The supplier order channel ID (for supplier channels only) */
  supplierOrderChannelId?: Maybe<Scalars['ID']['output']>;
};

export type ContactInfos = {
  __typename?: 'ContactInfos';
  /** List of contact details including both contact info and channel */
  contacts: Array<ContactDetail>;
};

/** Input for retrieving contact information with filtering and search capabilities */
export type ContactInfosInput = {
  /**
   * The type of contacts to include in the search results.
   * When not specified, the system defaults to Both.
   */
  contactType?: InputMaybe<ContactType | '%future added value'>;
  /** The search term to filter contact information */
  searchTerm: Scalars['String']['input'];
  /** The ID of the supplier to search contact information for */
  supplierId: Scalars['ID']['input'];
};

/** Enumeration of contact types that can be filtered when searching for contact information */
export const ContactType = {
  /** Include both buyer and supplier contacts */
  Both: 'Both',
  /** Filter for buyer contacts only */
  Buyer: 'Buyer',
  /** Filter for supplier contacts only */
  Supplier: 'Supplier'
} as const;

export type ContactType = typeof ContactType[keyof typeof ContactType];
/** Input type for getting content upload link */
export type ContentLinkInput = {
  /** File ID used to identify the file in the bucket */
  fileId: Scalars['String']['input'];
  /** Content file name */
  name: Scalars['String']['input'];
  /** Content file type */
  type: Scalars['String']['input'];
};

/** Content upload link to be used for uploading html content */
export type ContentUploadLink = {
  __typename?: 'ContentUploadLink';
  /** Media ID used to identify the file in frontend and in bucket */
  fileId: Scalars['String']['output'];
  /** S3 upload URL for the media file, to extract and attach in the email */
  uploadUrl: Scalars['String']['output'];
  /** S3 URI for the content file */
  uri: Scalars['String']['output'];
};

/** Success result containing content upload link */
export type ContentUploadLinkResult = AppsyncResponse & {
  __typename?: 'ContentUploadLinkResult';
  /** Content upload link */
  link: ContentUploadLink;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type ConversationTranscript = {
  __typename?: 'ConversationTranscript';
  segments: Array<Maybe<AudioTranscript>>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CoordinateInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

/** Job already existed and is currently active (awaitingUpload or pending). */
export type CostDataImportJobActive = {
  __typename?: 'CostDataImportJobActive';
  status: CostDataImportJobActiveStatus | '%future added value';
};

export const CostDataImportJobActiveStatus = {
  AwaitingUpload: 'AwaitingUpload',
  Pending: 'Pending'
} as const;

export type CostDataImportJobActiveStatus = typeof CostDataImportJobActiveStatus[keyof typeof CostDataImportJobActiveStatus];
/** Job was just created. uploadUrl is valid for 1 hour. */
export type CostDataImportJobCreated = {
  __typename?: 'CostDataImportJobCreated';
  uploadUrl: Scalars['String']['output'];
};

/** Job already existed and processing failed. */
export type CostDataImportJobFailed = {
  __typename?: 'CostDataImportJobFailed';
  failureMessage?: Maybe<Scalars['String']['output']>;
  failureReason: CostDataImportJobFailureReason | '%future added value';
  processedAt: Scalars['AWSTimestamp']['output'];
};

export const CostDataImportJobFailureReason = {
  ConcurrentWrite: 'ConcurrentWrite',
  DocumentError: 'DocumentError',
  JobAlreadyCompleted: 'JobAlreadyCompleted',
  JobAlreadyProcessing: 'JobAlreadyProcessing',
  Unknown: 'Unknown'
} as const;

export type CostDataImportJobFailureReason = typeof CostDataImportJobFailureReason[keyof typeof CostDataImportJobFailureReason];
export type CostDataImportJobGetOrCreateInput = {
  costGuideExternalId: Scalars['String']['input'];
  externalJobId: Scalars['String']['input'];
  mode: CostDataImportJobWriteMode | '%future added value';
  supplierId: Scalars['ID']['input'];
};

export type CostDataImportJobInfo = {
  __typename?: 'CostDataImportJobInfo';
  costGuideExternalId: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  externalJobId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mode: CostDataImportJobWriteMode | '%future added value';
  status: CostDataImportJobStatus;
  supplierId: Scalars['ID']['output'];
};

export type CostDataImportJobStatus = CostDataImportJobActive | CostDataImportJobCreated | CostDataImportJobFailed | CostDataImportJobSucceeded;

/** Job already existed and processing completed successfully. */
export type CostDataImportJobSucceeded = {
  __typename?: 'CostDataImportJobSucceeded';
  processedAt: Scalars['AWSTimestamp']['output'];
};

export const CostDataImportJobWriteMode = {
  Replace: 'Replace',
  Upsert: 'Upsert'
} as const;

export type CostDataImportJobWriteMode = typeof CostDataImportJobWriteMode[keyof typeof CostDataImportJobWriteMode];
/** Job already existed and is currently active (awaitingUpload or pending). */
export type CostGuideImportJobActive = {
  __typename?: 'CostGuideImportJobActive';
  status: CostGuideImportJobActiveStatus | '%future added value';
};

export const CostGuideImportJobActiveStatus = {
  AwaitingUpload: 'AwaitingUpload',
  Pending: 'Pending'
} as const;

export type CostGuideImportJobActiveStatus = typeof CostGuideImportJobActiveStatus[keyof typeof CostGuideImportJobActiveStatus];
/** Job was just created. uploadUrl is valid for 1 hour. */
export type CostGuideImportJobCreated = {
  __typename?: 'CostGuideImportJobCreated';
  uploadUrl: Scalars['String']['output'];
};

/** Job already existed and processing failed. */
export type CostGuideImportJobFailed = {
  __typename?: 'CostGuideImportJobFailed';
  failureMessage?: Maybe<Scalars['String']['output']>;
  failureReason: CostGuideImportJobFailureReason | '%future added value';
  processedAt: Scalars['AWSTimestamp']['output'];
};

export const CostGuideImportJobFailureReason = {
  ConcurrentWrite: 'ConcurrentWrite',
  DocumentError: 'DocumentError',
  JobAlreadyCompleted: 'JobAlreadyCompleted',
  JobAlreadyProcessing: 'JobAlreadyProcessing',
  Unknown: 'Unknown'
} as const;

export type CostGuideImportJobFailureReason = typeof CostGuideImportJobFailureReason[keyof typeof CostGuideImportJobFailureReason];
export type CostGuideImportJobGetOrCreateInput = {
  externalJobId: Scalars['String']['input'];
  supplierId: Scalars['ID']['input'];
};

export type CostGuideImportJobInfo = {
  __typename?: 'CostGuideImportJobInfo';
  createdAt: Scalars['AWSTimestamp']['output'];
  externalJobId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: CostGuideImportJobStatus;
  supplierId: Scalars['ID']['output'];
};

export type CostGuideImportJobStatus = CostGuideImportJobActive | CostGuideImportJobCreated | CostGuideImportJobFailed | CostGuideImportJobSucceeded;

/** Job already existed and processing completed successfully. */
export type CostGuideImportJobSucceeded = {
  __typename?: 'CostGuideImportJobSucceeded';
  processedAt: Scalars['AWSTimestamp']['output'];
};

export type CreateBuyerReportScheduleInput = {
  buyerIds: Array<Scalars['String']['input']>;
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailRecipients: Array<Scalars['String']['input']>;
  frequency: ScheduledBuyerReportFrequency | '%future added value';
  locale?: InputMaybe<Scalars['String']['input']>;
  startAt: Scalars['AWSTimestamp']['input'];
  supplierIds: Array<Scalars['String']['input']>;
  timeframe: ScheduledBuyerReportFrequency | '%future added value';
  timeframeType: ScheduledBuyerReportTimeframeType | '%future added value';
  title?: InputMaybe<Scalars['String']['input']>;
  type: BuyerReportType | '%future added value';
};

export type CreateBuyerReportScheduleResponse = AuthorizationFailure | BuyerReportSchedule | InputValidationFailure;

export const CreateCustomerImportJobErrorCode = {
  JobsLimitExceededError: 'JobsLimitExceededError',
  UnknownError: 'UnknownError'
} as const;

export type CreateCustomerImportJobErrorCode = typeof CreateCustomerImportJobErrorCode[keyof typeof CreateCustomerImportJobErrorCode];
export type CreateCustomerImportJobFailure = {
  __typename?: 'CreateCustomerImportJobFailure';
  /** The error code for the failure. */
  errorCode: CreateCustomerImportJobErrorCode | '%future added value';
  /** A human-readable message describing the error. */
  message: Scalars['String']['output'];
};

export type CreateCustomerImportJobInput = {
  /** The supplier ID for whom the customers are being imported. */
  supplierId: Scalars['ID']['input'];
  /** The targets for the customer import job. */
  targets: Array<CustomerImportJobEmailTarget>;
};

export type CreateCustomerImportJobResponse = AuthorizationFailure | CreateCustomerImportJobFailure | CreateCustomerImportJobSuccess | InputValidationFailure;

export type CreateCustomerImportJobSuccess = {
  __typename?: 'CreateCustomerImportJobSuccess';
  /** The created customer import job waiting for upload. */
  job: CustomerImportJobWaitingForUpload;
  /** A pre-signed URL to upload the customer import file to. */
  uploadUrl: Scalars['String']['output'];
};

/** Input for creating a new note. */
export type CreateDistributorNoteInput = {
  /** The plain-text content of the note */
  noteBody: Scalars['String']['input'];
  /** The entity this note will be associated with */
  target: DistributorNoteTargetEntity;
  /** Optional title for the note */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDistributorNoteResponse = AuthorizationFailure | DistributorNote | InputValidationFailure | NotFoundError;

/** Input for creating a new distributor task */
export type CreateDistributorTaskInput = {
  /** Optional objective/goal */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** When the task is due */
  dueAt: DistributorTaskDueAtInput;
  /** Entity to associate the task with */
  targetEntity: DistributorTaskTargetEntityInput;
  /** Title of the task */
  title: Scalars['String']['input'];
};

export type CreateDistributorTaskResponse = AuthorizationFailure | DistributorTask | InputValidationFailure | NotFoundError;

export type CreateDocumentScanInput = {
  leadId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
  /** Logged in user id, not bot user id. */
  userId: Scalars['ID']['input'];
};

export type CreateDocumentScanResponse = AuthorizationFailure | DocumentScanUpdateResult | InputValidationFailure;

export type CreateEmailListResponse = AuthorizationFailure | EmailListCreated | InputValidationFailure;

/** Input type for creating a new marketing campaign */
export type CreateMarketingCampaignInput = {
  /** Channels to be used for the marketing campaign */
  channels: Array<CampaignChannel | '%future added value'>;
  /** Title of the marketing campaign as seen by the supplier */
  title: Scalars['String']['input'];
};

export type CreateMenuScanInput = {
  /**
   * The id of the chat to create the menu scan for.
   * Exactly one of leadId or chatId must be supplied.
   */
  chatId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The id of the lead to create the menu scan for.
   * Exactly one of leadId or chatId must be supplied.
   */
  leadId?: InputMaybe<Scalars['ID']['input']>;
  supplierId: Scalars['ID']['input'];
  /** Logged in user id, not bot user id. */
  userId: Scalars['ID']['input'];
};

export type CreateMenuScanResponse = AuthorizationFailure | InputValidationFailure | MenuScanUpdateResult;

export type CreateMessageError = AppsyncError & AppsyncResponse & {
  __typename?: 'CreateMessageError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CreateOmnichannelOrderInput = {
  draft?: InputMaybe<OmnichannelOrderDraftInput>;
  supplierId: Scalars['ID']['input'];
  transmissionId: Scalars['ID']['input'];
};

export type CreateOmnichannelOrderResponse = AuthorizationFailure | CreateOmnichannelOrderSuccess | InputValidationFailure | NotFoundError;

export type CreateOmnichannelOrderSuccess = {
  __typename?: 'CreateOmnichannelOrderSuccess';
  order: OmnichannelOrder;
};

export type CreateOrderDeliveryCheckInput = {
  orderId: Scalars['ID']['input'];
};

export type CreateOrderDeskEmailList = {
  clearListsBeforeUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  emailList: Array<OrderDeskEmail>;
  supplierId: Scalars['ID']['input'];
  type: OrderDestEmailListType | '%future added value';
};

export type CreateOrderUploadFailure = {
  __typename?: 'CreateOrderUploadFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CreateOrderUploadInput = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  mediaElements: Array<OrderUploadMediaElementInput>;
};

export type CreateOrderUploadResponse = AuthorizationFailure | CreateOrderUploadFailure | CreateOrderUploadSuccess | InputValidationFailure;

export type CreateOrderUploadSuccess = {
  __typename?: 'CreateOrderUploadSuccess';
  mediaElements: Array<UploadedOrderMediaElement>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  uploadedOrderId: Scalars['String']['output'];
};

export type CreateProfileError = AppsyncError & AppsyncResponse & {
  __typename?: 'CreateProfileError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CreateProfileInput = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProfileResponse = AliasAlreadyLinked | AliasExists | BuyerExists | CreateProfileError | User;

export type CreatePushEndpointInput = {
  /** indicates whether a user would like to recieve message notifications */
  message: Scalars['Boolean']['input'];
  /** indicates whether a user would like to recieve order notifications */
  order: Scalars['Boolean']['input'];
  /** unique identifier created by the notification service for an app on a device */
  token: Scalars['String']['input'];
  type: PushNotificationPlatform | '%future added value';
};

export type CreateReferralInput = {
  referrerUserId: Scalars['ID']['input'];
};

export type CreateReferralResponse = AuthorizationFailure | InputValidationFailure | Referral | ReferralCodeGenerationError | UserHasReferralCode;

export type CreateSalesFunnelInput = {
  name: Scalars['String']['input'];
  /** Names of the states in the sales funnel. This can be appended later. */
  stateNames: Array<Scalars['String']['input']>;
  /**
   * The supplier who will own the sales funnel.
   * For supplier admins, this should be their own supplierId (provided by frontend).
   * For Choco admins, this can be any supplierId.
   */
  supplierId: Scalars['ID']['input'];
};

export type CreateSalesFunnelLeadInput = {
  /**
   * The user ID of the sales rep assigned to this lead.
   * If a sales rep is creating a lead, this must be their own user ID.
   */
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional name of the contact person at the business */
  businessContactName?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the business */
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  /** The name of the business */
  businessName: Scalars['String']['input'];
  /** The phone number of the business */
  businessPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Optional comment text to add more context to the lead. */
  commentText?: InputMaybe<Scalars['String']['input']>;
  /** The geographic identifier for the lead. */
  geographicIdentifier: SalesFunnelLeadGeographicIdentifierInput;
  /** Optional alias for the lead */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional possible revenue of the lead */
  revenue?: InputMaybe<MoneyV2Input>;
  salesFunnelId: Scalars['ID']['input'];
};

export type CreateSalesFunnelLeadResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelLead;

export type CreateSalesFunnelResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelAlreadyExistsError | SalesFunnelDefinition;

export type CreateSalesFunnelStateInput = {
  name: Scalars['String']['input'];
  salesFunnelId: Scalars['ID']['input'];
};

export type CreateSalesFunnelStateResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelDefinition;

export type CreateSubCatalogError = AppsyncError & AppsyncResponse & {
  __typename?: 'CreateSubCatalogError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CreateSupplierContactInput = {
  phoneNumber: Scalars['String']['input'];
  requireOrderReview?: InputMaybe<Scalars['Boolean']['input']>;
  supplierEntityId: Scalars['ID']['input'];
};

export type CreateSupplierContactResponse = AuthorizationFailure | InputValidationFailure | SupplierContact;

export type CreateTransmissionInput = {
  buyerContactId?: InputMaybe<Scalars['ID']['input']>;
  metadata: VoiceCallMetadataInput;
  supplierId: Scalars['ID']['input'];
  supplierOrderChannelId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTransmissionResponse = AuthorizationFailure | CreateTransmissionSuccess | InputValidationFailure | NotFoundError;

export type CreateTransmissionSuccess = {
  __typename?: 'CreateTransmissionSuccess';
  transmission: Transmission;
};

export type CreateUpdateSupplierProductResponse = DuplicateProductError | InputValidationFailure | Product | ProductNotFoundError;

export type CreatedBy = {
  __typename?: 'CreatedBy';
  createdContext?: Maybe<CreatedContext | '%future added value'>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export const CreatedContext = {
  AddAnotherBusiness: 'addAnotherBusiness',
  BuyerAddSupplier: 'buyerAddSupplier',
  BuyerAddsVerifiedSupplierNewCustomer: 'buyerAddsVerifiedSupplierNewCustomer',
  BuyerRequestsSupplierExistingCustomer: 'buyerRequestsSupplierExistingCustomer',
  BuyerRequestsSupplierNewCustomer: 'buyerRequestsSupplierNewCustomer',
  ChatCreatedFromAdmin: 'chatCreatedFromAdmin',
  ChatCreatedFromBuyerConcierge: 'chatCreatedFromBuyerConcierge',
  ChatCreatedFromChocoAi: 'chatCreatedFromChocoAi',
  CustomerMassAccountCreator: 'customerMassAccountCreator',
  InviteLink: 'inviteLink',
  SupplierInvitesBuyer: 'supplierInvitesBuyer'
} as const;

export type CreatedContext = typeof CreatedContext[keyof typeof CreatedContext];
export type CreatedOrCompletedByNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'CreatedOrCompletedByNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CredentialsData = QbdCredentials;

export type CreditCheckApproved = {
  __typename?: 'CreditCheckApproved';
  monthlyCreditLimit: MoneyV2;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  /** Always CreditCheckStatus.APPROVED */
  status: CreditCheckStatus | '%future added value';
};

export type CreditCheckClientFailure = {
  __typename?: 'CreditCheckClientFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CreditCheckDeclined = {
  __typename?: 'CreditCheckDeclined';
  minimumCreditAmount?: Maybe<MoneyV2>;
  monthlyCreditLimit?: Maybe<MoneyV2>;
  reasonCode: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  /** Always CreditCheckStatus.DECLINED */
  status: CreditCheckStatus | '%future added value';
};

export type CreditCheckFailure = {
  __typename?: 'CreditCheckFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CreditCheckInput = {
  organizationNumber: Scalars['ID']['input'];
};

export type CreditCheckResponse = AuthorizationFailure | CreditCheckApproved | CreditCheckClientFailure | CreditCheckDeclined | CreditCheckFailure | CreditCheckTooManyRequestsFailure | InputValidationFailure;

export const CreditCheckStatus = {
  Approved: 'APPROVED',
  Declined: 'DECLINED'
} as const;

export type CreditCheckStatus = typeof CreditCheckStatus[keyof typeof CreditCheckStatus];
export type CreditCheckTooManyRequestsFailure = {
  __typename?: 'CreditCheckTooManyRequestsFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CreditNoteAlreadyExistsFailure = {
  __typename?: 'CreditNoteAlreadyExistsFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CreditNoteBillingDocument = BillingDocument & {
  __typename?: 'CreditNoteBillingDocument';
  creditNoteNumber: Scalars['String']['output'];
  customer: BillingDocumentCustomer;
  dueAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Reference to the invoice this credit note was issued against.
   * Null when the credit note has no associated invoice.
   */
  invoice?: Maybe<InvoiceRef>;
  issuedAt: Scalars['AWSTimestamp']['output'];
  totalGrossAmount: MoneyV2;
  vendor: BillingDocumentVendor;
};

export type CreditNoteCreateFailure = {
  __typename?: 'CreditNoteCreateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type CreditNoteCreateInput = {
  buyerId: Scalars['ID']['input'];
  creditNoteNumber: Scalars['String']['input'];
  invoiceNumber: Scalars['String']['input'];
  issuedAt: Scalars['AWSTimestamp']['input'];
  items: Array<CreditNoteLineItemInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  taxSubtotals: Array<CreditNoteTaxSubtotalInput>;
  totalGrossAmount: MoneyV2Input;
  totalNetAmount: MoneyV2Input;
  totalTaxAmount: MoneyV2Input;
  vendorId: Scalars['ID']['input'];
};

export type CreditNoteCreateResponse = AuthorizationFailure | CreditNoteAlreadyExistsFailure | CreditNoteCreateFailure | CreditNoteCreateSuccess | InputValidationFailure;

export type CreditNoteCreateSuccess = {
  __typename?: 'CreditNoteCreateSuccess';
  creditNoteId: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type CreditNoteLineItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  grossAmount: MoneyV2Input;
  name: Scalars['String']['input'];
  netAmount: MoneyV2Input;
  position: Scalars['Int']['input'];
  productRef: InvoiceProductRefInput;
  quantity: Scalars['Float']['input'];
  taxDetails: CreditNoteLineItemTaxDetailsInput;
  unit: Scalars['String']['input'];
  unitPrice: MoneyV2Input;
};

export type CreditNoteLineItemTaxDetailsInput = {
  taxAmount: MoneyV2Input;
  taxClassName: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
};

export type CreditNoteTaxSubtotalInput = {
  taxAmount: MoneyV2Input;
  taxClassName: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
};

/**
 * Returned when one or more transmissions fail validation. The mutation is
 * all-or-nothing: when this is returned, NO reprocess was triggered for ANY
 * transmission in the batch. `rejections` lists every failed id with its reason so
 * the operator can fix them and resubmit.
 */
export type CrossWorkflowReprocessRejected = {
  __typename?: 'CrossWorkflowReprocessRejected';
  /** Every transmission that failed validation, with the reason it failed. */
  rejections: Array<CrossWorkflowReprocessRejection>;
};

export type CrossWorkflowReprocessRejection = {
  __typename?: 'CrossWorkflowReprocessRejection';
  /** Human-readable detail for the reason. */
  message?: Maybe<Scalars['String']['output']>;
  /** Why this transmission cannot be reprocessed. */
  reason: CrossWorkflowReprocessRejectionReason | '%future added value';
  /** The transmission that failed validation. */
  transmissionId: Scalars['ID']['output'];
};

/** Why a single transmission in a cross-workflow reprocess batch was rejected. */
export const CrossWorkflowReprocessRejectionReason = {
  /** No transmission exists for the given id. */
  TransmissionNotFound: 'transmissionNotFound',
  /** The caller is not authorized to reprocess this transmission's supplier. */
  Unauthorized: 'unauthorized',
  /** The transmission's actual engine does not match the requested `fromVersion`. */
  VersionMismatch: 'versionMismatch'
} as const;

export type CrossWorkflowReprocessRejectionReason = typeof CrossWorkflowReprocessRejectionReason[keyof typeof CrossWorkflowReprocessRejectionReason];
/**
 * Returned when every transmission passed validation and a reprocess execution was
 * started for the whole batch.
 */
export type CrossWorkflowReprocessStarted = {
  __typename?: 'CrossWorkflowReprocessStarted';
  /** The workflow engine the batch was reprocessed on. */
  targetVersion: OrderAgentWorkflowVersion | '%future added value';
  /** The transmissions for which a reprocess execution was started. */
  transmissionIds: Array<Scalars['ID']['output']>;
};

/**
 * Identifies the transmission to reprocess and the workflow version to run it on.
 * Provide exactly one of `transmissionId` / `originalMediaLink`.
 */
export type CrossWorkflowReprocessTransmissionsInput = {
  /**
   * The workflow engine that currently owns these transmissions, validated against
   * each transmission's stored media link. A mismatch rejects the batch.
   */
  fromVersion: OrderAgentWorkflowVersion | '%future added value';
  /**
   * When true (the default), orders already in a terminal state keep their status
   * and are neither reverted to review nor duplicated. When false, all orders for
   * the transmissions are rebuilt fresh (to review).
   */
  preserveStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The workflow engine to reprocess on. Use `V2` to roll transmissions that were
   * processed by a buggy `V3` back through the legacy engine. May equal
   * `fromVersion` for a same-engine retry.
   */
  targetVersion: OrderAgentWorkflowVersion | '%future added value';
  /**
   * The transmissions to reprocess. Every id is validated before any reprocess is
   * triggered (see the mutation's all-or-nothing semantics). Must be non-empty.
   */
  transmissionIds: Array<Scalars['ID']['input']>;
};

export type CrossWorkflowReprocessTransmissionsResponse = AuthorizationFailure | CrossWorkflowReprocessRejected | CrossWorkflowReprocessStarted | InputValidationFailure | InternalServerError;

export type CsvAttachmentRef = {
  __typename?: 'CsvAttachmentRef';
  hasHeaders?: Maybe<Scalars['Boolean']['output']>;
  omnichannelOrderId: Scalars['ID']['output'];
  transmissionAttachmentId?: Maybe<Scalars['ID']['output']>;
  transmissionId?: Maybe<Scalars['ID']['output']>;
};

export type CustomCatalog = Node & {
  __typename?: 'CustomCatalog';
  id: Scalars['ID']['output'];
  /** Whether the custom catalog is assigned to the web shop */
  isAssignedToWebshop?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  /** Number of units in the custom catalog */
  unitsCount?: Maybe<Scalars['Int']['output']>;
  /** Vendor owning the custom catalog */
  vendor: SupplierRef;
};

/** Input parameters for the `customCatalogChats` query */
export type CustomCatalogChatsInput = {
  /** Id of the vendor whose custom catalogs are being queried */
  customCatalogId: Scalars['ID']['input'];
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
};

export type CustomCatalogChatsResponse = AuthorizationFailure | CustomCatalogChatsResult | InputValidationFailure;

export type CustomCatalogChatsResult = AppsyncResponse & Connection & Page & {
  __typename?: 'CustomCatalogChatsResult';
  edges: Array<CustomCatalogChatsResultEdge>;
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type CustomCatalogChatsResultEdge = Edge & {
  __typename?: 'CustomCatalogChatsResultEdge';
  cursor: Scalars['String']['output'];
  node: ChatRef;
};

export type CustomCatalogFullImportJob = CustomCatalogFullImportJobSucceeded | JobFailed | JobInProgress | JobWaitingForInput;

/** Summarizes the import process, providing details about the items processed during the import. */
export type CustomCatalogFullImportJobResponse = {
  __typename?: 'CustomCatalogFullImportJobResponse';
  /** The number of vendor item units assigned to the customCatalog during the import. */
  itemsAssigned: Scalars['Int']['output'];
  /** The number of new vendor item units created during the import. */
  itemsCreated: Scalars['Int']['output'];
  /** The number of vendor item units unassigned to the customCatalog during the import. */
  itemsUnassigned: Scalars['Int']['output'];
  /** The number of vendor item units unchanged during the import. */
  itemsUnchanged: Scalars['Int']['output'];
  /** The number of vendor item units updated during the import. */
  itemsUpdated: Scalars['Int']['output'];
  /** The number of vendor item units that failed to import due to validation errors. */
  itemsWithErrors: Scalars['Int']['output'];
};

/** Represents a customCatalog import job that succeeded, including partial successes. */
export type CustomCatalogFullImportJobSucceeded = {
  __typename?: 'CustomCatalogFullImportJobSucceeded';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
  /** Indicates whether the import was a partial success, such as some items failing to import due to validation errors. */
  isPartialSuccess: Scalars['Boolean']['output'];
  /** URL where the output file of the import job can be downloaded. */
  outputDownloadUrl: Scalars['String']['output'];
  /** A summary response of the import job detailing the outcome of the import process. */
  response: CustomCatalogFullImportJobResponse;
};

export type CustomCatalogFullImportStartResponse = AuthorizationFailure | CustomCatalogFullImportStartResult | InputValidationFailure;

/** The result of starting a catalog import job. */
export type CustomCatalogFullImportStartResult = AppsyncResponse & {
  __typename?: 'CustomCatalogFullImportStartResult';
  /** The catalog import job created as a result of the mutation. */
  job: CustomCatalogFullImportJob;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type CustomCatalogFullImportStatusResponse = AuthorizationFailure | CustomCatalogFullImportStatusResult | InputValidationFailure;

export type CustomCatalogFullImportStatusResult = AppsyncResponse & {
  __typename?: 'CustomCatalogFullImportStatusResult';
  /** The catalog import job. */
  job: CustomCatalogFullImportJob;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

/** Input for the `customCatalogFullImportStart` mutation. */
export type CustomCatalogFullStartInput = {
  /** The ID of the customCatalog to which the catalog is been assigned to. */
  customCatalogId: Scalars['ID']['input'];
  /** Indicates whether the import should be a dry run. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the job used in dry run mode to upload the input file for the actual import. */
  inputFromJobId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the vendor for whom the catalog is being imported. */
  vendorId: Scalars['ID']['input'];
};

/** Error details for a failed update operation */
export type CustomCatalogItemUnitsBatchUpdateError = {
  __typename?: 'CustomCatalogItemUnitsBatchUpdateError';
  /** Error code for programmatic handling */
  code: Scalars['String']['output'];
  /** ID of the custom catalog where the error occurred */
  customCatalogId: Scalars['String']['output'];
  /** Path to the element that caused the error, e.g. 'customCatalogs[2].add[4]' */
  path: Scalars['String']['output'];
  /** Human-readable description of the error */
  reason: Scalars['String']['output'];
  /** ID of the vendor item unit that couldn't be added or removed */
  vendorItemUnitId: Scalars['String']['output'];
};

/** Input parameters for a single custom catalog update */
export type CustomCatalogItemUnitsBatchUpdateInputItem = {
  /** Array of vendor item unit IDs to add to the custom catalog */
  add: Array<Scalars['String']['input']>;
  /** ID of the custom catalog to update */
  customCatalogId: Scalars['String']['input'];
  /** Array of vendor item unit IDs to remove from the custom catalog */
  remove: Array<Scalars['String']['input']>;
};

/** Filter input for the `customCatalogsForVendor` query */
export type CustomCatalogsForVendorFilter = {
  /** If provided, only returns custom catalogs that are assigned to the given chat. */
  chatId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by whether the custom catalog is assigned to the web shop */
  isAssignedToWebShop?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Search filter on custom catalogs name (case-insensitive substring).
   * When the search term is a custom catalog id, the custom catalog with exactly this id is matched as well.
   */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Input parameters for the `customCatalogsForVendor` query */
export type CustomCatalogsForVendorInput = {
  /** Additional filter to narrow down the list of the returned custom catalogs */
  filter?: InputMaybe<CustomCatalogsForVendorFilter>;
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
  /**
   * Sorting of the returned custom catalogs. Defaults to `createdAt` ascending.
   * Ties are broken by the custom catalog id.
   * A pagination cursor is only valid with the sort it was issued for.
   */
  sort?: InputMaybe<CustomCatalogsForVendorSort>;
  /** Id of the vendor whose custom catalogs are being queried */
  vendorId: Scalars['ID']['input'];
};

export type CustomCatalogsForVendorResponse = AuthorizationFailure | CustomCatalogsForVendorResult | InputValidationFailure;

export type CustomCatalogsForVendorResult = AppsyncResponse & Connection & Page & {
  __typename?: 'CustomCatalogsForVendorResult';
  edges: Array<CustomCatalogsForVendorResultEdge>;
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type CustomCatalogsForVendorResultEdge = Edge & {
  __typename?: 'CustomCatalogsForVendorResultEdge';
  cursor: Scalars['String']['output'];
  node: CustomCatalog;
};

/** Sorting parameters for the `customCatalogsForVendor` query */
export type CustomCatalogsForVendorSort = {
  field: CustomCatalogsForVendorSortField | '%future added value';
  order: SortOrder | '%future added value';
};

/** Sort fields available for the `customCatalogsForVendor` query */
export const CustomCatalogsForVendorSortField = {
  CreatedAt: 'createdAt',
  Name: 'name'
} as const;

export type CustomCatalogsForVendorSortField = typeof CustomCatalogsForVendorSortField[keyof typeof CustomCatalogsForVendorSortField];
/** Input parameters for the `CustomCatalogs` query */
export type CustomCatalogsInput = {
  /**
   * An array of the custom catalog ids to fetch.
   * Maximum of 50 ids can be fetched at once.
   */
  ids: Array<Scalars['ID']['input']>;
  /** If provided, only returns custom catalogs owned by the given vendor. */
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input parameters for batch updating items in custom catalogs */
export type CustomCatalogsItemUnitsBatchUpdateInput = {
  /** Array of custom catalogs to update with their respective item units to add and remove */
  customCatalogs: Array<CustomCatalogItemUnitsBatchUpdateInputItem>;
};

/** Response for the customCatalogItemUnitsBatchUpdate mutation */
export type CustomCatalogsItemUnitsBatchUpdateResponse = AuthorizationFailure | CustomCatalogsItemUnitsBatchUpdateResult | InputValidationFailure;

/** Result of a successful batch update operation */
export type CustomCatalogsItemUnitsBatchUpdateResult = AppsyncResponse & {
  __typename?: 'CustomCatalogsItemUnitsBatchUpdateResult';
  /** Errors that occurred during the update operation */
  errors: Array<CustomCatalogItemUnitsBatchUpdateError>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type CustomCatalogsResponse = AuthorizationFailure | CustomCatalogsResult | InputValidationFailure;

export type CustomCatalogsResult = {
  __typename?: 'CustomCatalogsResult';
  customCatalogs: Array<CustomCatalog>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type CustomCatalogsToWebShopAssignmentUpdateError = {
  __typename?: 'CustomCatalogsToWebShopAssignmentUpdateError';
  /** ID of the custom catalog that caused the error */
  customCatalogId: Scalars['ID']['output'];
  /** Error message */
  error: Scalars['String']['output'];
};

export type CustomCatalogsToWebShopAssignmentUpdateInput = {
  /**
   * Array of custom catalogs to update with their respective assignment to the web shop.
   * Maximum 100 custom catalogs can be updated at once.
   * Either all the custom catalogs will be updated or none of them will be updated if an error occurs.
   */
  customCatalogs: Array<CustomCatalogsToWebShopAssignmentUpdateItemInput>;
};

export type CustomCatalogsToWebShopAssignmentUpdateItemInput = {
  /** ID of the custom catalog to update */
  customCatalogId: Scalars['ID']['input'];
  /**
   * If true, the custom catalog will be assigned to the web shop
   * If false, the custom catalog will be unassigned from the web shop
   */
  isAssignedToWebshop: Scalars['Boolean']['input'];
};

export type CustomCatalogsToWebShopAssignmentUpdateResponse = AuthorizationFailure | CustomCatalogsToWebShopAssignmentUpdateResult | InputValidationFailure;

export type CustomCatalogsToWebShopAssignmentUpdateResult = AppsyncResponse & {
  __typename?: 'CustomCatalogsToWebShopAssignmentUpdateResult';
  /** Array of custom catalogs that were updated */
  customCatalogs?: Maybe<Array<CustomCatalogsToWebShopAssignmentUpdateResultItem>>;
  /** Array of errors that occurred during the update */
  errors?: Maybe<Array<CustomCatalogsToWebShopAssignmentUpdateError>>;
  responseType: ResponseType | '%future added value';
};

export type CustomCatalogsToWebShopAssignmentUpdateResultItem = {
  __typename?: 'CustomCatalogsToWebShopAssignmentUpdateResultItem';
  /** ID of the custom catalog */
  customCatalogId: Scalars['ID']['output'];
  /** Whether the custom catalog is assigned to the web shop */
  isAssignedToWebshop: Scalars['Boolean']['output'];
};

export type CustomerChatsConnection = Connection & {
  __typename?: 'CustomerChatsConnection';
  edges: Array<CustomerChatsEdge>;
  total: Scalars['Int']['output'];
};

export type CustomerChatsEdge = Edge & {
  __typename?: 'CustomerChatsEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

/** Contact data representing a customer who may or may not be on the platform yet. */
export type CustomerContact = {
  __typename?: 'CustomerContact';
  /**  Email of the contact  */
  email: Scalars['AWSEmail']['output'];
  /**  Name of the contact  */
  name?: Maybe<Scalars['String']['output']>;
};

/** Columns available for customer export */
export const CustomerExportColumn = {
  AccountName: 'ACCOUNT_NAME',
  AccountOwnerId: 'ACCOUNT_OWNER_ID',
  Address: 'ADDRESS',
  ChurnStatus: 'CHURN_STATUS',
  CustomerNumber: 'CUSTOMER_NUMBER',
  ExpectedOrderDate: 'EXPECTED_ORDER_DATE',
  Labels: 'LABELS',
  LastOrderDate: 'LAST_ORDER_DATE',
  OrderingTrend: 'ORDERING_TREND',
  OrderFrequency: 'ORDER_FREQUENCY'
} as const;

export type CustomerExportColumn = typeof CustomerExportColumn[keyof typeof CustomerExportColumn];
/** Export file format options */
export const CustomerExportFormat = {
  Csv: 'CSV',
  Xlsx: 'XLSX'
} as const;

export type CustomerExportFormat = typeof CustomerExportFormat[keyof typeof CustomerExportFormat];
export type CustomerImportJobEmailTarget = {
  /** The emails of the customers to be imported. */
  email: Scalars['String']['input'];
};

export const CustomerImportJobErrorCode = {
  FileItemsExceededError: 'FileItemsExceededError',
  FileParsingError: 'FileParsingError',
  FileSizeExceededError: 'FileSizeExceededError',
  UnknownError: 'UnknownError'
} as const;

export type CustomerImportJobErrorCode = typeof CustomerImportJobErrorCode[keyof typeof CustomerImportJobErrorCode];
export type CustomerImportJobFailed = Node & {
  __typename?: 'CustomerImportJobFailed';
  /** The time the job was completed, if applicable. */
  completedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** The time the job was created. */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** Error code if the job failed. */
  errorCode?: Maybe<CustomerImportJobErrorCode | '%future added value'>;
  /** The ID of the job. */
  id: Scalars['ID']['output'];
};

export type CustomerImportJobProcessing = Node & {
  __typename?: 'CustomerImportJobProcessing';
  /** The time the job was created. */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The ID of the job. */
  id: Scalars['ID']['output'];
};

export const CustomerImportJobStatus = {
  Failed: 'Failed',
  Processing: 'Processing',
  Succeeded: 'Succeeded',
  WaitingForUpload: 'WaitingForUpload'
} as const;

export type CustomerImportJobStatus = typeof CustomerImportJobStatus[keyof typeof CustomerImportJobStatus];
export type CustomerImportJobSucceeded = Node & {
  __typename?: 'CustomerImportJobSucceeded';
  /** The time the job was completed, if applicable. */
  completedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** The time the job was created. */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The ID of the job. */
  id: Scalars['ID']['output'];
};

export type CustomerImportJobWaitingForUpload = Node & {
  __typename?: 'CustomerImportJobWaitingForUpload';
  /** The time the job was created. */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The ID of the job. */
  id: Scalars['ID']['output'];
};

export type CustomerInsights = {
  __typename?: 'CustomerInsights';
  averageLineItemsByMonth?: Maybe<CustomerInsightsAverageLineItemsByMonth>;
  chatId: Scalars['ID']['output'];
  grossProfitMarginTrend?: Maybe<CustomerInsightsOrderingTrend | '%future added value'>;
  hasGrossProfitMarginInformation?: Maybe<Scalars['Boolean']['output']>;
  hasRevenueInformation?: Maybe<Scalars['Boolean']['output']>;
  healthMetrics?: Maybe<CustomerInsightsHealthMetrics>;
  isFullErpChat?: Maybe<Scalars['Boolean']['output']>;
  last6OrdersAvgGrossProfitMargin?: Maybe<MoneyV2>;
  last6OrdersAvgLineItems?: Maybe<Scalars['Float']['output']>;
  last6OrdersAvgRevenue?: Maybe<MoneyV2>;
  lastOrderGrossProfitMargin?: Maybe<MoneyV2>;
  lastOrderLineItems?: Maybe<Scalars['Float']['output']>;
  lastOrderRevenue?: Maybe<MoneyV2>;
  lineItemsTrend?: Maybe<CustomerInsightsOrderingTrend | '%future added value'>;
  revenueTrend?: Maybe<CustomerInsightsOrderingTrend | '%future added value'>;
  totalsByMonth?: Maybe<CustomerInsightsTotalsByMonth>;
};

export type CustomerInsightsAverageLineItemsByMonth = {
  __typename?: 'CustomerInsightsAverageLineItemsByMonth';
  averageLineItemsMonth1?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth2?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth3?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth4?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth5?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth6?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth7?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth8?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth9?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth10?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth11?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonth12?: Maybe<Scalars['Float']['output']>;
  averageLineItemsMonthCurrent?: Maybe<Scalars['Float']['output']>;
};

export type CustomerInsightsHealthMetrics = CustomerInsightsTotalGrossProfitMargin | CustomerInsightsTotalRevenue;

export type CustomerInsightsNotification = Node & {
  __typename?: 'CustomerInsightsNotification';
  chat: Chat;
  chatId: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  data: CustomerInsightsNotificationData;
  id: Scalars['ID']['output'];
  markedReadAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  read: Scalars['Boolean']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
  userId: Scalars['String']['output'];
};

export type CustomerInsightsNotificationConnection = Connection & {
  __typename?: 'CustomerInsightsNotificationConnection';
  cursor?: Maybe<Scalars['String']['output']>;
  edges: Array<CustomerInsightsNotificationsEdge>;
  total: Scalars['Int']['output'];
};

export type CustomerInsightsNotificationData = CustomerOrderingTrendChangeNotificationData | CustomerStatusChangeNotificationData;

export type CustomerInsightsNotificationFilter = {
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<CustomerInsightsNotificationType | '%future added value'>;
};

export type CustomerInsightsNotificationSubscriptionResponse = AuthorizationFailure | CustomerInsightsNotification;

export const CustomerInsightsNotificationType = {
  CustomerChurnStatusChangeNotification: 'CustomerChurnStatusChangeNotification',
  CustomerOrderingTrendChangeNotification: 'CustomerOrderingTrendChangeNotification'
} as const;

export type CustomerInsightsNotificationType = typeof CustomerInsightsNotificationType[keyof typeof CustomerInsightsNotificationType];
export type CustomerInsightsNotificationsEdge = Edge & {
  __typename?: 'CustomerInsightsNotificationsEdge';
  cursor: Scalars['String']['output'];
  node: CustomerInsightsNotification;
};

export const CustomerInsightsOrderingTrend = {
  Decreasing: 'decreasing',
  Increasing: 'increasing',
  NoChange: 'noChange',
  SignificantlyDecrease: 'significantlyDecrease',
  SignificantlyIncrease: 'significantlyIncrease'
} as const;

export type CustomerInsightsOrderingTrend = typeof CustomerInsightsOrderingTrend[keyof typeof CustomerInsightsOrderingTrend];
export type CustomerInsightsResponse = AuthorizationFailure | CustomerInsightsResponseFailure | CustomerInsightsResponseSuccess | InputValidationFailure;

export type CustomerInsightsResponseFailure = {
  __typename?: 'CustomerInsightsResponseFailure';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type CustomerInsightsResponseSuccess = {
  __typename?: 'CustomerInsightsResponseSuccess';
  customerInsights: CustomerInsights;
  responseType: ResponseType | '%future added value';
};

export type CustomerInsightsTotalGrossProfitMargin = {
  __typename?: 'CustomerInsightsTotalGrossProfitMargin';
  currentMonthTotalGrossProfitMargin?: Maybe<MoneyV2>;
  currentMonthTotalGrossProfitMarginPercent?: Maybe<Scalars['Float']['output']>;
  lastMonthTotalGrossProfitMargin?: Maybe<MoneyV2>;
  lastMonthTotalGrossProfitMarginPercent?: Maybe<Scalars['Float']['output']>;
  lastYearSameMonthTotalGrossProfitMargin?: Maybe<MoneyV2>;
  lastYearSameMonthTotalGrossProfitMarginPercent?: Maybe<Scalars['Float']['output']>;
};

export type CustomerInsightsTotalGrossProfitMarginByMonth = {
  __typename?: 'CustomerInsightsTotalGrossProfitMarginByMonth';
  totalGrossProfitMarginMonth1?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth2?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth3?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth4?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth5?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth6?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth7?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth8?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth9?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth10?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth11?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonth12?: Maybe<MoneyV2>;
  totalGrossProfitMarginMonthCurrent?: Maybe<MoneyV2>;
};

export type CustomerInsightsTotalRevenue = {
  __typename?: 'CustomerInsightsTotalRevenue';
  currentMonthTotalRevenue?: Maybe<MoneyV2>;
  lastMonthTotalRevenue?: Maybe<MoneyV2>;
  lastYearSameMonthTotalRevenue?: Maybe<MoneyV2>;
};

export type CustomerInsightsTotalRevenueByMonth = {
  __typename?: 'CustomerInsightsTotalRevenueByMonth';
  totalRevenueMonth1?: Maybe<MoneyV2>;
  totalRevenueMonth2?: Maybe<MoneyV2>;
  totalRevenueMonth3?: Maybe<MoneyV2>;
  totalRevenueMonth4?: Maybe<MoneyV2>;
  totalRevenueMonth5?: Maybe<MoneyV2>;
  totalRevenueMonth6?: Maybe<MoneyV2>;
  totalRevenueMonth7?: Maybe<MoneyV2>;
  totalRevenueMonth8?: Maybe<MoneyV2>;
  totalRevenueMonth9?: Maybe<MoneyV2>;
  totalRevenueMonth10?: Maybe<MoneyV2>;
  totalRevenueMonth11?: Maybe<MoneyV2>;
  totalRevenueMonth12?: Maybe<MoneyV2>;
  totalRevenueMonthCurrent?: Maybe<MoneyV2>;
};

export type CustomerInsightsTotalsByMonth = CustomerInsightsTotalGrossProfitMarginByMonth | CustomerInsightsTotalRevenueByMonth;

export type CustomerMatchCacheEntries = {
  __typename?: 'CustomerMatchCacheEntries';
  entries: Array<CustomerMatchCacheEntry>;
};

/** All fields are optional and combined with AND. */
export type CustomerMatchCacheEntriesFilter = {
  /** Chat (customer) the entry resolves to. */
  chatId?: InputMaybe<Scalars['ID']['input']>;
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  /** Order whose acceptance last wrote the entry. */
  omnichannelOrderId?: InputMaybe<Scalars['ID']['input']>;
  /** Exact (case-sensitive) sender the entry key was built from. */
  sender?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerMatchCacheEntriesInput = {
  filter?: InputMaybe<CustomerMatchCacheEntriesFilter>;
  /** Maximum number of entries to return. Defaults to 20, capped at 100. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  supplierId: Scalars['ID']['input'];
};

export type CustomerMatchCacheEntriesResponse = AuthorizationFailure | CustomerMatchCacheEntries | InputValidationFailure | InternalServerError;

export type CustomerMatchCacheEntry = {
  __typename?: 'CustomerMatchCacheEntry';
  /** Chat (customer) the key resolves to. */
  chat: ChatRef;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  key: CustomerMatchCacheEntryKey;
  lastUsedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** Order whose acceptance last wrote the entry. */
  omnichannelOrderId: Scalars['ID']['output'];
  source: CustomerMatchCacheEntrySource | '%future added value';
  supplierId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

/** The extracted order fields that form the cache key. Empty key parts are null. */
export type CustomerMatchCacheEntryKey = {
  __typename?: 'CustomerMatchCacheEntryKey';
  customerEmailAddress?: Maybe<Scalars['String']['output']>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  customerPhoneNumber?: Maybe<Scalars['String']['output']>;
  customerRepresentative?: Maybe<Scalars['String']['output']>;
  restaurantAddress?: Maybe<Scalars['String']['output']>;
  restaurantName?: Maybe<Scalars['String']['output']>;
  sender: Scalars['String']['output'];
};

export type CustomerMatchCacheEntryRemoveInput = {
  id: Scalars['ID']['input'];
};

export type CustomerMatchCacheEntryRemoveResponse = AuthorizationFailure | CustomerMatchCacheEntryRemoved | InputValidationFailure | InternalServerError | NotFoundError;

export type CustomerMatchCacheEntryRemoved = {
  __typename?: 'CustomerMatchCacheEntryRemoved';
  /** The entry as it was before removal. */
  entry: CustomerMatchCacheEntry;
};

export const CustomerMatchCacheEntrySource = {
  OrderAgent: 'orderAgent',
  VoiceAgent: 'voiceAgent'
} as const;

export type CustomerMatchCacheEntrySource = typeof CustomerMatchCacheEntrySource[keyof typeof CustomerMatchCacheEntrySource];
export type CustomerMatchingConfidence = {
  __typename?: 'CustomerMatchingConfidence';
  isCustomerCorrect?: Maybe<Scalars['Boolean']['output']>;
  isPONumberCorrect?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Customer number validation: order-scoped (no line join).
 *
 * A supplier may mark the customer number mandatory
 * (Supplier.customerNumberMandatory). When it is mandatory and the chat carries no
 * customer number, this warns — the buyer/desk should set one — without blocking
 * the cart.
 */
export type CustomerNumberValidationResult = CartValidationResult & {
  __typename?: 'CustomerNumberValidationResult';
  overriddenBy?: Maybe<Scalars['String']['output']>;
  overrideable: Scalars['Boolean']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  source: ValidationSource | '%future added value';
  status: ValidationStatus | '%future added value';
};

export type CustomerOrderInsight = {
  __typename?: 'CustomerOrderInsight';
  status?: Maybe<InsightsStatus | '%future added value'>;
  text?: Maybe<Scalars['String']['output']>;
};

export type CustomerOrderInsightsResponseFailure = {
  __typename?: 'CustomerOrderInsightsResponseFailure';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type CustomerOrderInsightsResponseSuccess = {
  __typename?: 'CustomerOrderInsightsResponseSuccess';
  customerOrderInsights: Array<Maybe<CustomerOrderInsight>>;
  responseType: ResponseType | '%future added value';
};

export type CustomerOrderInsightsResponseSuccessV2 = {
  __typename?: 'CustomerOrderInsightsResponseSuccessV2';
  averageBasketSizeTrend: Scalars['String']['output'];
  fallOffProducts: Array<Maybe<FallOffProduct>>;
  productGrowthRates: Array<Maybe<ProductGrowthRate>>;
  responseType: ResponseType | '%future added value';
};

export type CustomerOrderInsightsResponseSuccessV3 = {
  __typename?: 'CustomerOrderInsightsResponseSuccessV3';
  averageBasketSizeTrend: Scalars['String']['output'];
  fallOffProducts: Array<Maybe<FallOffProductV3>>;
  productGrowthRates: Array<Maybe<ProductGrowthRate>>;
  responseType: ResponseType | '%future added value';
};

export type CustomerOrderingTrendChangeNotificationData = {
  __typename?: 'CustomerOrderingTrendChangeNotificationData';
  orderingTrend: ChatChurnOrdersTrend | '%future added value';
  ordersTrend: Scalars['Float']['output'];
};

export type CustomerOrdersInsightsInput = {
  chatId: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerOrdersInsightsInputV2 = {
  chatId: Scalars['ID']['input'];
};

export type CustomerOrdersInsightsInputV3 = {
  chatId: Scalars['ID']['input'];
};

export type CustomerOrdersInsightsResponse = AuthorizationFailure | CustomerOrderInsightsResponseFailure | CustomerOrderInsightsResponseSuccess | InputValidationFailure;

export type CustomerOrdersInsightsResponseV2 = AuthorizationFailure | CustomerOrderInsightsResponseFailure | CustomerOrderInsightsResponseSuccessV2 | InputValidationFailure;

export type CustomerOrdersInsightsResponseV3 = AuthorizationFailure | CustomerOrderInsightsResponseFailure | CustomerOrderInsightsResponseSuccessV3 | InputValidationFailure;

export type CustomerStatusChangeNotificationData = {
  __typename?: 'CustomerStatusChangeNotificationData';
  churnStatus: ChatChurnStatus | '%future added value';
  lastOrderDate: Scalars['AWSTimestamp']['output'];
};

export type CutOffTime = {
  __typename?: 'CutOffTime';
  /** 24 hour format UTC clock */
  time: Scalars['AWSTime']['output'];
  type: CutOffTimeType | '%future added value';
};

export type CutOffTimeInput = {
  /** 24 hour format UTC clock */
  time: Scalars['AWSTime']['input'];
  type: CutOffTimeType | '%future added value';
};

export const CutOffTimeType = {
  Flexible: 'flexible',
  NoCutoff: 'noCutoff',
  Strict: 'strict'
} as const;

export type CutOffTimeType = typeof CutOffTimeType[keyof typeof CutOffTimeType];
export type CutoffSetting = NoCutoffSetting | WithCutoffSetting;

export type CutoffSettingInput = {
  /** An extended ISO 8601 time string in the format hh:mm. Times are in supplier timezones. */
  cutoffTime?: InputMaybe<Scalars['AWSTime']['input']>;
  /** in days */
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  type: CutOffTimeType | '%future added value';
};

export type DataWidgetDataInput = {
  filterValues?: InputMaybe<Array<DataWidgetFilterValueInput>>;
  widgetId: Scalars['String']['input'];
};

export type DataWidgetDataResult = {
  __typename?: 'DataWidgetDataResult';
  computedAt?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
  widgetId: Scalars['String']['output'];
  widgetType?: Maybe<Scalars['String']['output']>;
};

export type DataWidgetFilterDefinition = {
  __typename?: 'DataWidgetFilterDefinition';
  defaultValue?: Maybe<Scalars['String']['output']>;
  filterId: Scalars['String']['output'];
  filterType: DataWidgetFilterType | '%future added value';
  label: Scalars['String']['output'];
  options?: Maybe<Array<DataWidgetFilterOption>>;
  scope: DataWidgetFilterScope | '%future added value';
  widgetId?: Maybe<Scalars['String']['output']>;
};

export type DataWidgetFilterOption = {
  __typename?: 'DataWidgetFilterOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export const DataWidgetFilterScope = {
  Dashboard: 'DASHBOARD',
  Widget: 'WIDGET'
} as const;

export type DataWidgetFilterScope = typeof DataWidgetFilterScope[keyof typeof DataWidgetFilterScope];
export const DataWidgetFilterType = {
  DateRange: 'DATE_RANGE',
  MultiSelect: 'MULTI_SELECT',
  NumberRange: 'NUMBER_RANGE',
  Select: 'SELECT',
  Text: 'TEXT'
} as const;

export type DataWidgetFilterType = typeof DataWidgetFilterType[keyof typeof DataWidgetFilterType];
export type DataWidgetFilterValueInput = {
  filterId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type DataWidgetSection = {
  __typename?: 'DataWidgetSection';
  label: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  sectionId: Scalars['String']['output'];
  widgets: Array<DataWidgetSkeleton>;
};

export type DataWidgetSkeleton = {
  __typename?: 'DataWidgetSkeleton';
  appliedDashboardFilterIds?: Maybe<Array<Scalars['String']['output']>>;
  position: Scalars['Int']['output'];
  span: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  widgetFilters?: Maybe<Array<DataWidgetFilterDefinition>>;
  widgetId: Scalars['String']['output'];
  widgetType: Scalars['String']['output'];
};

export type DataWidgetsInput = {
  placement: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
};

export type DataWidgetsResult = {
  __typename?: 'DataWidgetsResult';
  filters?: Maybe<Array<DataWidgetFilterDefinition>>;
  responseType: ResponseType | '%future added value';
  sections: Array<DataWidgetSection>;
};

export type DateFilter = {
  endDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  startDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

/**
 * Represents a date range filter for querying records within a specific date window.
 * Both bounds are optional, allowing for open-ended ranges (e.g., "after X" or "before Y").
 * Uses ISO 8601 date-only values without time components.
 */
export type DateRange = {
  /**
   * Lower bound of the date range (inclusive). Records must be on or after this date.
   * Format: ISO 8601 date (e.g., "2025-01-15").
   */
  after?: InputMaybe<Scalars['AWSDate']['input']>;
  /**
   * Upper bound of the date range (inclusive). Records must be on or before this date.
   * Format: ISO 8601 date (e.g., "2025-01-15").
   */
  before?: InputMaybe<Scalars['AWSDate']['input']>;
};

/**
 * Represents a date-time range filter for querying records within a specific time window.
 * Both bounds are optional, allowing for open-ended ranges (e.g., "after X" or "before Y").
 * Uses ISO 8601 date-time format.
 */
export type DateTimeRange = {
  /**
   * Lower bound of the date-time range (inclusive). Records must be on or after this timestamp.
   * Format: ISO 8601 date-time (e.g., "2025-01-15T09:30:00Z").
   */
  after?: InputMaybe<Scalars['AWSDateTime']['input']>;
  /**
   * Upper bound of the date-time range (inclusive). Records must be on or before this timestamp.
   * Format: ISO 8601 date-time (e.g., "2025-01-15T09:30:00Z").
   */
  before?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type DeactivateSalesFunnelStateInput = {
  salesFunnelStateId: Scalars['ID']['input'];
};

export type DeactivateSalesFunnelStateResponse = AuthorizationFailure | InputValidationFailure | LastActiveSalesFunnelStateError | NotFoundError | SalesFunnelDefinition | SalesFunnelStateNotEmptyError;

/**
 * Represents a fixed-point decimal number, e.g. 12.34
 * Please take care when parsing this string to not lose the precision
 */
export type Decimal = {
  __typename?: 'Decimal';
  /** Regex: /^[+-]?\d+(\.\d+)?$/ */
  amount: Scalars['String']['output'];
};

/**
 * Represents a fixed-point decimal number, e.g. 12.34
 * Please take care when parsing this string to not lose the precision
 */
export type DecimalInput = {
  /** Regex: /^[+-]?\d+(\.\d+)?$/ */
  amount: Scalars['String']['input'];
};

export type DeclineOrderInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type DeclineOrderResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | OrderDeclined;

export type DeleteBuyerReportScheduleError = AppsyncError & AppsyncResponse & {
  __typename?: 'DeleteBuyerReportScheduleError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type DeleteBuyerReportScheduleResponse = AuthorizationFailure | BuyerReportScheduleNotFound | DeleteBuyerReportScheduleError | DeleteBuyerReportScheduleSuccess | InputValidationFailure;

export type DeleteBuyerReportScheduleSuccess = AppsyncResponse & {
  __typename?: 'DeleteBuyerReportScheduleSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type DeleteBuyerStockInventoryProductsFailure = {
  __typename?: 'DeleteBuyerStockInventoryProductsFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type DeleteBuyerStockInventoryProductsInput = {
  buyerId: Scalars['ID']['input'];
  stockInventoryProductIds: Array<Scalars['ID']['input']>;
};

export type DeleteBuyerStockInventoryProductsResponse = AuthorizationFailure | DeleteBuyerStockInventoryProductsFailure | DeleteBuyerStockInventoryProductsSuccess | InputValidationFailure;

export type DeleteBuyerStockInventoryProductsSuccess = AppsyncResponse & {
  __typename?: 'DeleteBuyerStockInventoryProductsSuccess';
  /** Always ResponseType.success */
  responseType: ResponseType | '%future added value';
};

/** Input for deleting an existing note. */
export type DeleteDistributorNoteInput = {
  /** The ID of the note to delete */
  noteId: Scalars['ID']['input'];
};

export type DeleteDistributorNoteResponse = AuthorizationFailure | DistributorNote | InputValidationFailure | NotFoundError;

export type DeleteDistributorTaskResponse = AuthorizationFailure | DistributorTask | InputValidationFailure | NotFoundError;

export type DeleteProductImageInput = {
  productId: Scalars['ID']['input'];
};

export type DeleteSubCatalogError = AppsyncError & AppsyncResponse & {
  __typename?: 'DeleteSubCatalogError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type DeleteSubCatalogSuccess = AppsyncResponse & {
  __typename?: 'DeleteSubCatalogSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type DeletedChatSetting = {
  __typename?: 'DeletedChatSetting';
  /** chat ID of the deleted deliverySetting */
  id: Scalars['ID']['output'];
};

export type DeliveryCheckProblem = {
  __typename?: 'DeliveryCheckProblem';
  /** @deprecated use value instead */
  amountDelivered?: Maybe<Scalars['Float']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  /** @deprecated use imageUrls instead */
  image?: Maybe<Scalars['String']['output']>;
  problemType?: Maybe<OrderedProductDeliveryCheckProblemType | '%future added value'>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type DeliveryCheckProblemInput = {
  /** @deprecated use value instead */
  amountDelivered?: InputMaybe<Scalars['Float']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use imageIds instead */
  image?: InputMaybe<Scalars['String']['input']>;
  problemType?: InputMaybe<OrderedProductDeliveryCheckProblemType | '%future added value'>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type DeliveryCheckProductInput = {
  amountDelivered?: InputMaybe<Scalars['Float']['input']>;
  amountOrdered?: InputMaybe<Scalars['Float']['input']>;
  deliveryCheckProblems?: InputMaybe<Array<InputMaybe<DeliveryCheckProblemInput>>>;
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderedProductMetadata?: InputMaybe<OrderedProductMetadataInput>;
  productId: Scalars['ID']['input'];
};

export type DeliveryCheckReconciliationRequest = {
  __typename?: 'DeliveryCheckReconciliationRequest';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  dateOfDelivery?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** @deprecated use dateOfDelivery instead */
  deliveryDate?: Maybe<Scalars['String']['output']>;
  externalInvoiceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: DeliveryCheckReconciliationRequestStatus | '%future added value';
  statusHistory?: Maybe<Array<Maybe<DeliveryCheckReconciliationRequestStatusHistory>>>;
  type: DeliveryCheckReconciliationRequestType | '%future added value';
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type DeliveryCheckReconciliationRequestAlreadyConfirmed = AppsyncError & AppsyncResponse & {
  __typename?: 'DeliveryCheckReconciliationRequestAlreadyConfirmed';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type DeliveryCheckReconciliationRequestInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  dateOfDelivery?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** @deprecated use dateOfDelivery instead */
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  externalInvoiceId?: InputMaybe<Scalars['String']['input']>;
  type: DeliveryCheckReconciliationRequestType | '%future added value';
};

export type DeliveryCheckReconciliationRequestNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'DeliveryCheckReconciliationRequestNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export const DeliveryCheckReconciliationRequestStatus = {
  Confirmed: 'confirmed',
  Requested: 'requested'
} as const;

export type DeliveryCheckReconciliationRequestStatus = typeof DeliveryCheckReconciliationRequestStatus[keyof typeof DeliveryCheckReconciliationRequestStatus];
export type DeliveryCheckReconciliationRequestStatusHistory = {
  __typename?: 'DeliveryCheckReconciliationRequestStatusHistory';
  status: DeliveryCheckReconciliationRequestStatus | '%future added value';
  timestamp: Scalars['AWSTimestamp']['output'];
};

export const DeliveryCheckReconciliationRequestType = {
  CreditNote: 'creditNote',
  Other: 'other',
  Replacement: 'replacement'
} as const;

export type DeliveryCheckReconciliationRequestType = typeof DeliveryCheckReconciliationRequestType[keyof typeof DeliveryCheckReconciliationRequestType];
export const DeliveryDateContext = {
  Checkout: 'checkout',
  OrderAgent: 'orderAgent',
  OrderDesk: 'orderDesk'
} as const;

export type DeliveryDateContext = typeof DeliveryDateContext[keyof typeof DeliveryDateContext];
export const DeliveryDateValidationCode = {
  /**
   * Order placed after supplier delivery cutoff for the selected date.
   * Order-scoped: no line join.
   */
  OrderCutoff: 'ORDER_CUTOFF',
  /**
   * Requested delivery date is not in the available-delivery-dates set for the
   * chat. Causes include schedule changes and chat-level delivery settings.
   * One code for all unavailable-date cases.
   */
  UnavailableDate: 'UNAVAILABLE_DATE'
} as const;

export type DeliveryDateValidationCode = typeof DeliveryDateValidationCode[keyof typeof DeliveryDateValidationCode];
/**
 * Order-scoped delivery date validation (no line join).
 * Missing deliveryDate on evaluate/create cart intent is not this type (see input comment).
 */
export type DeliveryDateValidationResult = CartValidationResult & {
  __typename?: 'DeliveryDateValidationResult';
  /** Which order-level delivery fact failed. */
  code: DeliveryDateValidationCode | '%future added value';
  /**
   * Cutoff policy label from supplier delivery date (e.g. strict / flexible).
   * Null unless code is ORDER_CUTOFF.
   */
  cutOffTimeType?: Maybe<Scalars['String']['output']>;
  /**
   * Earliest bookable date when the requested date is not available.
   * Null unless code is UNAVAILABLE_DATE.
   */
  earliestAvailableDate?: Maybe<Scalars['AWSDate']['output']>;
  /**
   * Supplier cutoff instant (lead-time adjusted) that the order missed.
   * Null unless code is ORDER_CUTOFF.
   */
  leadTimeAdjustedCutoff?: Maybe<Scalars['AWSDateTime']['output']>;
  overriddenBy?: Maybe<Scalars['String']['output']>;
  overrideable: Scalars['Boolean']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /**
   * Intent delivery date that was evaluated.
   * Null when code is ORDER_CUTOFF.
   */
  requestedDate?: Maybe<Scalars['AWSDate']['output']>;
  source: ValidationSource | '%future added value';
  status: ValidationStatus | '%future added value';
};

export type DeliveryExceptionCutoffSettingInput = {
  leadTimeAdjustedCutoff?: InputMaybe<Scalars['AWSDateTime']['input']>;
  type: CutOffTimeType | '%future added value';
};

export type DeliveryExceptionInput = {
  cutoff?: InputMaybe<DeliveryExceptionCutoffSettingInput>;
  date: Scalars['AWSDate']['input'];
  type: DeliveryExceptionInputType | '%future added value';
};

export const DeliveryExceptionInputType = {
  NoDeliveryException: 'noDeliveryException',
  SingleDayDeliveryException: 'singleDayDeliveryException'
} as const;

export type DeliveryExceptionInputType = typeof DeliveryExceptionInputType[keyof typeof DeliveryExceptionInputType];
export type DeliveryFeeResult = {
  __typename?: 'DeliveryFeeResult';
  /** Why the fee is missing. Empty when the status is OK. */
  issues: Array<CartEvaluationIssue>;
  /**
   * How far we got working out the delivery fee.
   *
   * OK carries a fee. NOT_APPLICABLE means this order has no delivery fee, for
   * example because the supplier does not charge one. NOT_EVALUATED means the
   * stage intentionally did not run. UNAVAILABLE means an enabled fee could not
   * be calculated; REVIEW leaves payable null and checkoutCreate does not commit.
   */
  status: CartEvaluationDomainStatus | '%future added value';
  /**
   * The fee, once we have one. Null unless status is OK.
   *
   * Free delivery is an amount of 0, not a missing value. A buyer who spends over
   * the supplier's threshold sees zero rather than nothing.
   */
  value?: Maybe<AppliedDeliveryFee>;
};

export type DeliveryFeeTier = {
  __typename?: 'DeliveryFeeTier';
  fee: MoneyV2;
  /** Minimum subtotal for this tier, inclusive. */
  startValue: MoneyV2;
};

/**
 * Delivery fee tiers define the fee by the lower bound only:
 * - the first tier must start at zero
 * - two tiers can't start at the same amount
 * This covers all possible subtotals; the upper bound of a tier is implied by the start of the next one.
 */
export type DeliveryFeeTierInput = {
  fee: MoneyV2Input;
  /** Minimum subtotal for this tier, inclusive. */
  startValue: MoneyV2Input;
};

export type DeliverySettingException = NoDeliveryException | SingleDayDeliveryExceptionWithCutoff | SingleDayDeliveryExceptionWithoutCutoff;

export const DeliverySettingExceptionUpdateBehavior = {
  AdditionalDelivery: 'additionalDelivery',
  CutoffChanged: 'cutoffChanged'
} as const;

export type DeliverySettingExceptionUpdateBehavior = typeof DeliverySettingExceptionUpdateBehavior[keyof typeof DeliverySettingExceptionUpdateBehavior];
export type DeliveryZone = {
  __typename?: 'DeliveryZone';
  name: Scalars['String']['output'];
  points: Array<Coordinate>;
};

export type DeliveryZoneInput = {
  name: Scalars['String']['input'];
  points: Array<CoordinateInput>;
};

export type DerivedPriceForOrderGuide = {
  __typename?: 'DerivedPriceForOrderGuide';
  price: Money;
  priceBeforeDiscount?: Maybe<Money>;
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type DerivedPriceForOrderGuideResponse = AuthorizationFailure | DerivedPriceForOrderGuide | InputValidationFailure;

export const DirectPayActivationStatus = {
  Active: 'ACTIVE',
  Disabled: 'DISABLED'
} as const;

export type DirectPayActivationStatus = typeof DirectPayActivationStatus[keyof typeof DirectPayActivationStatus];
export type DirectPayCustomerAlreadyOnboardedFailure = {
  __typename?: 'DirectPayCustomerAlreadyOnboardedFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type DirectPayCustomerDetailsInput = {
  buyerId: Scalars['ID']['input'];
  contacts: Array<PaymentCustomerContactInput>;
  name: Scalars['String']['input'];
  shippingAddress?: InputMaybe<ShippingAddressInput>;
};

export type DirectPayCustomerOnboardFailure = {
  __typename?: 'DirectPayCustomerOnboardFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type DirectPayCustomerOnboardInput = {
  customerDetails: DirectPayCustomerDetailsInput;
  profileDetails: DirectPayProfileDetailsInput;
  vendorId: Scalars['ID']['input'];
};

export type DirectPayCustomerOnboardResponse = AuthorizationFailure | DirectPayCustomerAlreadyOnboardedFailure | DirectPayCustomerOnboardFailure | DirectPayCustomerOnboardSuccess | InputValidationFailure;

export type DirectPayCustomerOnboardSuccess = {
  __typename?: 'DirectPayCustomerOnboardSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type DirectPayCustomerStatusUpdateFailure = {
  __typename?: 'DirectPayCustomerStatusUpdateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type DirectPayCustomerStatusUpdateInput = {
  paymentCustomerId: Scalars['ID']['input'];
  status: DirectPayActivationStatus | '%future added value';
  vendorId: Scalars['ID']['input'];
};

export type DirectPayCustomerStatusUpdateResponse = AuthorizationFailure | DirectPayCustomerStatusUpdateFailure | DirectPayCustomerStatusUpdateSuccess | InputValidationFailure | PaymentCustomerNotFound;

export type DirectPayCustomerStatusUpdateSuccess = {
  __typename?: 'DirectPayCustomerStatusUpdateSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export const DirectPayDeclineReasonCode = {
  AuthenticationFailed: 'AUTHENTICATION_FAILED',
  BankIssue: 'BANK_ISSUE',
  Cancelled: 'CANCELLED',
  CardIssue: 'CARD_ISSUE',
  GenericDecline: 'GENERIC_DECLINE',
  InsufficientFunds: 'INSUFFICIENT_FUNDS',
  Unspecified: 'UNSPECIFIED'
} as const;

export type DirectPayDeclineReasonCode = typeof DirectPayDeclineReasonCode[keyof typeof DirectPayDeclineReasonCode];
export type DirectPayPaymentCustomer = {
  __typename?: 'DirectPayPaymentCustomer';
  activationStatus: DirectPayActivationStatus | '%future added value';
  contacts: Array<PaymentCustomerContact>;
  id: Scalars['ID']['output'];
  paymentMethods: Array<PaymentMethod>;
  paymentProfileId: Scalars['ID']['output'];
};

export type DirectPayPaymentMethodDeleteFailure = {
  __typename?: 'DirectPayPaymentMethodDeleteFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type DirectPayPaymentMethodDeleteInput = {
  paymentMethodId: Scalars['ID']['input'];
  paymentProfileId: Scalars['ID']['input'];
};

export type DirectPayPaymentMethodDeleteResponse = AuthorizationFailure | DirectPayPaymentMethodDeleteFailure | DirectPayPaymentMethodDeleteSuccess | InputValidationFailure;

export type DirectPayPaymentMethodDeleteSuccess = {
  __typename?: 'DirectPayPaymentMethodDeleteSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type DirectPayPaymentMethodSetDefaultFailure = {
  __typename?: 'DirectPayPaymentMethodSetDefaultFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type DirectPayPaymentMethodSetDefaultInput = {
  paymentMethodId: Scalars['ID']['input'];
  paymentProfileId: Scalars['ID']['input'];
};

export type DirectPayPaymentMethodSetDefaultResponse = AuthorizationFailure | DirectPayPaymentMethodSetDefaultFailure | DirectPayPaymentMethodSetDefaultSuccess | InputValidationFailure;

export type DirectPayPaymentMethodSetDefaultSuccess = {
  __typename?: 'DirectPayPaymentMethodSetDefaultSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type DirectPayPaymentSubmitDeclinedFailure = {
  __typename?: 'DirectPayPaymentSubmitDeclinedFailure';
  message: Scalars['String']['output'];
  reasonCode: DirectPayDeclineReasonCode | '%future added value';
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type DirectPayPaymentSubmitFailure = {
  __typename?: 'DirectPayPaymentSubmitFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type DirectPayPaymentSubmitInput = {
  billingDocumentId: Scalars['ID']['input'];
  paymentMethodId: Scalars['ID']['input'];
};

export type DirectPayPaymentSubmitResponse = AuthorizationFailure | DirectPayPaymentSubmitDeclinedFailure | DirectPayPaymentSubmitFailure | DirectPayPaymentSubmitSuccess | InputValidationFailure | PaymentCustomerNotFound;

export type DirectPayPaymentSubmitSuccess = {
  __typename?: 'DirectPayPaymentSubmitSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type DirectPayProfileDetailsInput = {
  chatCustomerNumber: Scalars['String']['input'];
  chatId: Scalars['ID']['input'];
};

export type DisconnectAccountError = AppsyncError & AppsyncResponse & {
  __typename?: 'DisconnectAccountError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type DisconnectAccountResponse = DisconnectAccountError | DisconnectAccountStatus;

export type DisconnectAccountStatus = {
  __typename?: 'DisconnectAccountStatus';
  appName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type DisconnectIntegrationAdapterInput = {
  id: Scalars['ID']['input'];
};

export type DisconnectIntegrationAdapterResponse = AuthorizationFailure | InputValidationFailure | IntegrationAdapterConnectionAdminResult | IntegrationAdapterConnectionBaseResult | IntegrationAdapterConnectionNotFound;

export const DistanceUnitOfMeasure = {
  Feet: 'Feet',
  Meters: 'Meters'
} as const;

export type DistanceUnitOfMeasure = typeof DistanceUnitOfMeasure[keyof typeof DistanceUnitOfMeasure];
export type DistributorNote = {
  __typename?: 'DistributorNote';
  /** The date that the note was created. */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The user who created the note. */
  createdByUser: User;
  /** The user who created the note. */
  createdByUserId: Scalars['String']['output'];
  /**
   * The last date that the note text was edited, or the time
   * that the note was created.
   */
  editedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** The user who last edited the note text or title. */
  editedByUser?: Maybe<User>;
  /** The user who last edited the note text or title. */
  editedByUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * The body content of the note. Currently only supports plain text.
   * Future support for rich text and other formats should be added through
   * a union type on this field (e.g., union NoteBody = PlainTextBody | RichTextBody)
   */
  noteBody: PlainTextBody;
  /** Optional title for the note */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * The last date that any operation was performed on the note,
   * or the time that the note was created.
   */
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type DistributorNoteConnection = {
  __typename?: 'DistributorNoteConnection';
  /**
   * The cursor at the end of the connection. Null if and only if there are no more notes
   * to retrieve.
   */
  cursor?: Maybe<Scalars['String']['output']>;
  notes: Array<DistributorNote>;
};

export const DistributorNoteEntityType = {
  Customer: 'CUSTOMER',
  Lead: 'LEAD'
} as const;

export type DistributorNoteEntityType = typeof DistributorNoteEntityType[keyof typeof DistributorNoteEntityType];
/**
 * Represents the entity (e.g., LEAD, CUSTOMER) that a note is or will be associated with.
 * This type is used only in operations where a specific note is not yet identified
 * (like creation or querying all notes for an entity).
 */
export type DistributorNoteTargetEntity = {
  /** The ID of the entity (e.g., the lead ID or customer ID) */
  entityId: Scalars['ID']['input'];
  /** The type of entity this ID refers to */
  entityType: DistributorNoteEntityType | '%future added value';
};

export type DistributorNoteUpdateResult = AppsyncResponse & {
  __typename?: 'DistributorNoteUpdateResult';
  /** Updated distributor note */
  distributorNote: DistributorNote;
  /** Message in case of failure while updating */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type */
  responseType: ResponseType | '%future added value';
};

/** Promo preferred products content */
export type DistributorPromoPreferredProducts = {
  __typename?: 'DistributorPromoPreferredProducts';
  /** Marketing campaign ID associated with this promotion */
  campaignId: Scalars['String']['output'];
  /** The primary/default chat for this preferred products, kept optional to support future checkout flow */
  chat?: Maybe<Chat>;
  /** Unique identifier for the promoted content target */
  id: Scalars['ID']['output'];
  /** Lists all promoted product variants. Always returns a list, which can be empty. */
  promotedSupplierVariants: Array<PromotedVendorItemUnitVariant>;
  /** The promoted title for the preferred products */
  promotedTitle: Scalars['String']['output'];
  /** The supplier of the promoted products */
  supplier: Supplier;
};

/** A single welcome banner promotion returned to buyer apps */
export type DistributorPromoWelcomeBanner = {
  __typename?: 'DistributorPromoWelcomeBanner';
  /** Marketing campaign ID associated with this promotion */
  campaignId: Scalars['String']['output'];
  /** The buyer's chat with this supplier, if applicable */
  chat?: Maybe<Chat>;
  /** Pre-signed download URL for the image displayed on the campaign detail screen */
  detailsImageUrl?: Maybe<Scalars['String']['output']>;
  /** Message displayed on the campaign detail screen */
  detailsMessage?: Maybe<Scalars['String']['output']>;
  /** Pre-signed download URL for the banner image displayed on the home screen */
  displayImageUrl?: Maybe<Scalars['String']['output']>;
  /** Title displayed over the banner image on the home screen */
  displayTitle?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this promotion target */
  id: Scalars['ID']['output'];
  /** Promoted product variants for this supplier, may be empty */
  promotedSupplierVariants: Array<PromotedVendorItemUnitVariant>;
  /** The supplier running this welcome banner */
  supplier: Supplier;
};

/** Union type for distributor promoted content, allowing for future extensibility */
export type DistributorPromotedContent = DistributorPromoPreferredProducts;

/** Returned when no distributor promoted content is found */
export type DistributorPromotedContentNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'DistributorPromotedContentNotFound';
  /** Optional message explaining why no content was found */
  message?: Maybe<Scalars['String']['output']>;
  /** Type of response returned */
  responseType: ResponseType | '%future added value';
};

/** Represents a task created by a distributor user, associated with either a customer or lead */
export type DistributorTask = {
  __typename?: 'DistributorTask';
  /** Optional objective/goal of the task */
  comment?: Maybe<Scalars['String']['output']>;
  /** When the task was created */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** User who created the task */
  createdByUser: User;
  /** ID of the user who created the task */
  createdByUserId: Scalars['String']['output'];
  /** When the task is due */
  dueAt: DistributorTaskDueAt;
  id: Scalars['ID']['output'];
  /** Current status of the task */
  status: DistributorTaskStatus | '%future added value';
  /** The entity this task is associated with */
  targetEntity: DistributorTaskTargetEntity;
  /**
   * Target entity details to be displayed (lead or customer)
   * @deprecated Use targetEntity.entityDetails instead
   */
  targetEntityDetails: DistributorTaskTargetEntityDetails;
  /** Title of the task */
  title: Scalars['String']['output'];
};

/** Connection type for paginated task results */
export type DistributorTaskConnection = {
  __typename?: 'DistributorTaskConnection';
  /** Cursor for pagination. If null, there are no more tasks to retrieve. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** The tasks */
  tasks: Array<DistributorTask>;
};

/**
 * When a task is due, represented as a date plus an optional time. Both
 * values are local to the specified timezone.
 */
export type DistributorTaskDueAt = {
  __typename?: 'DistributorTaskDueAt';
  /** The date the task is due. Relative to the provided timezone. */
  date: Scalars['AWSDate']['output'];
  /**
   * Optional time the task is due. Provided as local time (HH:mm).
   * Relative to the provided timezone.
   */
  time?: Maybe<Scalars['AWSTime']['output']>;
  /**
   * The timezone to which the task has been localized. Provided
   * in IANA format.
   */
  timezone: Scalars['String']['output'];
};

/** Input for specifying when a task is due */
export type DistributorTaskDueAtInput = {
  /**
   * Context for the due date and due time.
   * Default is SupplierTimezone.
   */
  context?: InputMaybe<DistributorTaskDueAtTimeContext | '%future added value'>;
  /** Local date in the supplier's timezone that task is due. */
  date: Scalars['AWSDate']['input'];
  /**
   * Local time in the supplier's timezone that the task is due.
   * Provided as HH:mm.
   */
  time?: InputMaybe<Scalars['AWSTime']['input']>;
};

/** Provides context for the due date and due time of a task. */
export const DistributorTaskDueAtTimeContext = {
  /** The date and time are relative to the supplier's timezone */
  SupplierTimezone: 'SupplierTimezone'
} as const;

export type DistributorTaskDueAtTimeContext = typeof DistributorTaskDueAtTimeContext[keyof typeof DistributorTaskDueAtTimeContext];
/** Types of entities that can have tasks */
export const DistributorTaskEntityType = {
  Customer: 'CUSTOMER',
  Lead: 'LEAD'
} as const;

export type DistributorTaskEntityType = typeof DistributorTaskEntityType[keyof typeof DistributorTaskEntityType];
/** Available task statuses */
export const DistributorTaskStatus = {
  Completed: 'COMPLETED',
  Outstanding: 'OUTSTANDING'
} as const;

export type DistributorTaskStatus = typeof DistributorTaskStatus[keyof typeof DistributorTaskStatus];
/** The entity a task is associated with */
export type DistributorTaskTargetEntity = {
  __typename?: 'DistributorTaskTargetEntity';
  /** Entity details to be displayed (lead or customer) */
  entityDetails: DistributorTaskTargetEntityDetails;
  /** ID of the entity (customer or lead) */
  entityId: Scalars['ID']['output'];
  /** Type of entity */
  entityType: DistributorTaskEntityType | '%future added value';
};

export type DistributorTaskTargetEntityDetails = {
  __typename?: 'DistributorTaskTargetEntityDetails';
  /**
   * Whether the requesting user is allowed to edit tasks on this entity.
   * Nullable until the resolver populating it (choco-backend#29789) ships;
   * treat null the same as an unknown/false value.
   */
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
};

/** Input for specifying which entity to associate a task with */
export type DistributorTaskTargetEntityInput = {
  /** ID of the entity (customer or lead) */
  entityId: Scalars['ID']['input'];
  /** Type of entity */
  entityType: DistributorTaskEntityType | '%future added value';
};

export type DocumentScan = Node & {
  __typename?: 'DocumentScan';
  /** Timestamp of when the document scan job was started */
  activatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /**
   * The list of files attached to this scan
   * We only support one file for now
   * Can be empty if no files have been uploaded yet
   */
  attachments?: Maybe<Array<DocumentScanAttachment>>;
  /** Timestamp of when the scan was created */
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  /** The id of the lead associated with the scan */
  leadId: Scalars['ID']['output'];
  /** File scan result */
  scanResult?: Maybe<DocumentScanResult>;
  /** Job processing status */
  status: DocumentScanStatus | '%future added value';
  /** The supplier related to the document scan */
  supplierId: Scalars['ID']['output'];
  /** Timestamp of when the scan was last updated */
  updatedAt: Scalars['AWSTimestamp']['output'];
  /** The user who activated the document scan job */
  userId: Scalars['ID']['output'];
};

export type DocumentScanAttachment = {
  __typename?: 'DocumentScanAttachment';
  /** The file type MIME (e.g., image/jpeg, image/png) */
  contentType: Scalars['String']['output'];
  /** Timestamp of when the file was uploaded */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The scan this file belongs to */
  documentScanId: Scalars['ID']['output'];
  /** The signed URL to download the file */
  downloadUrl: Scalars['String']['output'];
  /** The original file name uploaded */
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DocumentScanAttachmentInput = {
  contentType: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type DocumentScanAttachmentUploadLink = {
  __typename?: 'DocumentScanAttachmentUploadLink';
  /** Attachment file type e.g. pdf, png etc. */
  contentType: Scalars['String']['output'];
  /** Attachment ID used to identify the file in the bucket */
  fileId: Scalars['String']['output'];
  /** Attachment file name */
  fileName: Scalars['String']['output'];
  /** S3 upload URL for the media file, to extract and attach in the email */
  uploadUrl: Scalars['String']['output'];
};

export type DocumentScanAttachmentUploadLinkInput = {
  /** Attachment file type e.g. pdf, png etc. */
  contentType: Scalars['String']['input'];
  /** Attachment file name */
  fileName: Scalars['String']['input'];
};

export type DocumentScanAttachmentUploadLinkResult = AppsyncResponse & {
  __typename?: 'DocumentScanAttachmentUploadLinkResult';
  /** Updated links for the document scan attachments */
  links?: Maybe<Array<DocumentScanAttachmentUploadLink>>;
  responseType: ResponseType | '%future added value';
};

export type DocumentScanConnection = Connection & {
  __typename?: 'DocumentScanConnection';
  edges: Array<DocumentScanEdge>;
  total: Scalars['Int']['output'];
};

export type DocumentScanEdge = Edge & {
  __typename?: 'DocumentScanEdge';
  cursor: Scalars['String']['output'];
  node: DocumentScan;
};

export type DocumentScanResult = {
  __typename?: 'DocumentScanResult';
  /** The file type MIME (e.g., image/jpeg, image/png) */
  contentType: Scalars['String']['output'];
  /** Timestamp of when the file was uploaded */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The signed URL to download the file */
  downloadUrl: Scalars['String']['output'];
  /** The original file name uploaded */
  fileName: Scalars['String']['output'];
};

export const DocumentScanStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Pending: 'PENDING',
  Processing: 'PROCESSING'
} as const;

export type DocumentScanStatus = typeof DocumentScanStatus[keyof typeof DocumentScanStatus];
export type DocumentScanUpdateResult = AppsyncResponse & {
  __typename?: 'DocumentScanUpdateResult';
  /** Updated document scan */
  documentScan: DocumentScan;
  /** Message in case of failure while updating */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type */
  responseType: ResponseType | '%future added value';
};

/** Campaign attachment to be used for adding attachments to the channel message */
export type DownloadableCampaignAttachment = {
  __typename?: 'DownloadableCampaignAttachment';
  /** Signed download URL for the attachment file */
  downloadUrl: Scalars['String']['output'];
  /** Attachment ID */
  id: Scalars['ID']['output'];
  /** Attachment file name */
  name: Scalars['String']['output'];
  /** File size in bytes */
  size: Scalars['Int']['output'];
  /** Attachment file type e.g. pdf, png etc. */
  type: Scalars['String']['output'];
  /** Attachment file URI in S3 */
  uri: Scalars['String']['output'];
};

export type DuplicateProductError = AppsyncError & AppsyncResponse & {
  __typename?: 'DuplicateProductError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type DuplicateVendorItemError = {
  __typename?: 'DuplicateVendorItemError';
  quoteItemIds: Array<Scalars['ID']['output']>;
  vendorItemUnit: VendorItemUnitRef;
};

export type EchoInput = {
  message: Scalars['String']['input'];
};

export type EchoResponse = {
  __typename?: 'EchoResponse';
  message: Scalars['String']['output'];
};

export type Edge = {
  cursor: Scalars['String']['output'];
  node: Node;
};

export type EditBuyerReportScheduleInput = {
  buyerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  emailBody?: InputMaybe<Scalars['String']['input']>;
  emailRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  frequency?: InputMaybe<ScheduledBuyerReportFrequency | '%future added value'>;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  supplierIds?: InputMaybe<Array<Scalars['String']['input']>>;
  timeframe?: InputMaybe<ScheduledBuyerReportFrequency | '%future added value'>;
  timeframeType?: InputMaybe<ScheduledBuyerReportTimeframeType | '%future added value'>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<BuyerReportType | '%future added value'>;
};

export type EditBuyerReportScheduleResponse = AuthorizationFailure | BuyerReportSchedule | BuyerReportScheduleNotFound | InputValidationFailure;

/** Input for the editSalesFunnelLead mutation. */
export type EditSalesFunnelLeadInput = {
  /** Optional name of the contact person at the business */
  businessContactName?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the business */
  businessEmail?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name of the business. Cannot be cleared: omit the field to leave it
   * unchanged, but null or blank is rejected.
   */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the business */
  businessPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Optional comment text to add more context to the lead. */
  commentText?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the lead to edit */
  id: Scalars['ID']['input'];
  /** Optional possible revenue of the lead */
  revenue?: InputMaybe<MoneyV2Input>;
};

export type EditSalesFunnelLeadResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelLead;

/** order editing Input */
export type EditedOrderProductsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated use derivedPriceForOrderGuideUpdatedAt instead */
  buyerUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  derivedPriceForOrderGuideUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /**
   * Position of the line within the order. When omitted, the edit targets the
   * product by productId (legacy). When provided, it targets a single line variant
   * of a product that appears multiple times in the order.
   */
  listPosition?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['String']['input'];
  /** @deprecated use derivedPriceForOrderGuideUpdatedAt instead */
  supplierNegotiatedPriceUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** @deprecated use derivedPriceForOrderGuideUpdatedAt instead */
  supplierUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

/** Email content to be used for sending emails */
export type EmailContent = {
  __typename?: 'EmailContent';
  /** Email body message */
  bodyMessage: Scalars['String']['output'];
  /** Email image URL */
  imageURL?: Maybe<Scalars['String']['output']>;
  /** Email subject */
  subject: Scalars['String']['output'];
  /** Email title */
  title: Scalars['String']['output'];
};

export type EmailEditorStateFileInput = {
  /** Content file name */
  name: Scalars['String']['input'];
  /** Content file type */
  type: Scalars['String']['input'];
};

/** Response type for when the email editor state is not found. */
export type EmailEditorStateNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'EmailEditorStateNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to `error` */
  responseType: ResponseType | '%future added value';
};

export type EmailFromBuyerReportScheduleRemoved = AppsyncError & AppsyncResponse & {
  __typename?: 'EmailFromBuyerReportScheduleRemoved';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type EmailInBuyerReportScheduleNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'EmailInBuyerReportScheduleNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type EmailList = {
  __typename?: 'EmailList';
  emails: Array<Scalars['String']['output']>;
  type: OrderDestEmailListType | '%future added value';
};

export type EmailListCreated = {
  __typename?: 'EmailListCreated';
  message?: Maybe<Scalars['String']['output']>;
  supplierId: Scalars['ID']['output'];
  type: OrderDestEmailListType | '%future added value';
};

export type EmailLists = {
  __typename?: 'EmailLists';
  emailLists: Array<EmailList>;
};

/** Email HTML and template to be used for compiling the emails */
export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  /** S3 URI for the email HTML content */
  htmlUri: Scalars['String']['output'];
};

export type EmbedDashboardUrlResponse = {
  __typename?: 'EmbedDashboardUrlResponse';
  embedUrl: Scalars['String']['output'];
};

export type EntityIdentity = IntegrationEntityIdentity | InternalEntityIdentity;

/** Authentication methods supported for SFTP user access */
export const ErpSftpAuthMethod = {
  /** Username and password authentication */
  Password: 'PASSWORD',
  /** Either SSH public key or Password authentication */
  PasswordSshKey: 'PASSWORD_SSH_KEY',
  /** SSH public key authentication */
  SshKey: 'SSH_KEY'
} as const;

export type ErpSftpAuthMethod = typeof ErpSftpAuthMethod[keyof typeof ErpSftpAuthMethod];
/** Defines permission settings for a specific folder path, including the user's role within that folder */
export type ErpSftpFolderPermission = {
  __typename?: 'ErpSftpFolderPermission';
  /** Timestamp when this permission was granted in ISO 8601 format */
  createdAt: Scalars['String']['output'];
  /** The folder path for which the permission applies. for example "edeka" will give access for "/edeka". */
  folderPath: Scalars['String']['output'];
  /** The role/permission level the user has for this specific folder */
  role: ErpSftpUserRole | '%future added value';
  /** Timestamp when this permission was last updated in ISO 8601 format */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Input parameters for defining folder-level permissions */
export type ErpSftpFolderPermissionInput = {
  /** The folder path for which to set permissions. Should be an absolute path starting with '/'. */
  folderPath: Scalars['String']['input'];
  /** The role/permission level to grant for this folder */
  role: ErpSftpUserRole | '%future added value';
};

/**
 * Represents an ERP SFTP user with authentication credentials and folder permissions.
 * Users can authenticate via password or SSH key and have role-based access to specific folders.
 */
export type ErpSftpUser = Node & {
  __typename?: 'ErpSftpUser';
  /** Authentication method configured for this user */
  authMethod: ErpSftpAuthMethod | '%future added value';
  /** Timestamp when the user was created in ISO 8601 format */
  createdAt: Scalars['String']['output'];
  /** Unique identifier for the SFTP user */
  id: Scalars['ID']['output'];
  /** Indicate if the user account is active and can be used for SFTP access */
  isActive: Scalars['Boolean']['output'];
  /**
   * List of folder permissions defining which folders the user can access and their role in each folder.
   * The maximum size is 100.
   */
  permissions: Array<ErpSftpFolderPermission>;
  /**
   * SSH public key for authentication when using SSH_KEY auth method.
   * Required when authMethod is SSH_KEY, null when using PASSWORD.
   */
  sshPublicKey?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the user was last updated in ISO 8601 format */
  updatedAt?: Maybe<Scalars['String']['output']>;
  /** Username for SFTP login. Must be unique across all SFTP users. */
  username: Scalars['String']['output'];
};

/** Input parameters for creating a new SFTP user */
export type ErpSftpUserCreateInput = {
  /** Authentication method to configure for this user */
  authMethod: ErpSftpAuthMethod | '%future added value';
  /**
   * Whether the user should be created in an active state.
   *
   * If the user is not active, the user will not get access to the sftp server
   *
   * Defaults to true if not specified.
   */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Password for authentication when using PASSWORD auth method.
   * Required when authMethod is PASSWORD, ignored when using SSH_KEY.
   */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Initial folder permissions to grant to the user. */
  permissions: Array<ErpSftpFolderPermissionInput>;
  /**
   * SSH public key for authentication when using SSH_KEY auth method.
   * Required when authMethod is SSH_KEY, ignored when using PASSWORD.
   */
  sshPublicKey?: InputMaybe<Scalars['String']['input']>;
  /** Desired username for the new user. Must be unique and follow system naming conventions. */
  username: Scalars['String']['input'];
};

export type ErpSftpUserCreateResponse = AuthorizationFailure | ErpSftpUserCreateSuccess | ErpSftpUserDuplicateError | InputValidationFailure;

export type ErpSftpUserCreateSuccess = AppsyncResponse & {
  __typename?: 'ErpSftpUserCreateSuccess';
  /** The newly created SFTP user */
  erpSftpUser: ErpSftpUser;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type ErpSftpUserDuplicateError = AppsyncError & AppsyncResponse & {
  __typename?: 'ErpSftpUserDuplicateError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type ErpSftpUserNotFound = AppsyncResponse & {
  __typename?: 'ErpSftpUserNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to `ResponseType.Error` */
  responseType: ResponseType | '%future added value';
};

/** Role-based permissions for SFTP users determining their access level */
export const ErpSftpUserRole = {
  /** Full read-write access to folders and files */
  Editor: 'EDITOR',
  /** Read-only access to folders and files */
  Viewer: 'VIEWER'
} as const;

export type ErpSftpUserRole = typeof ErpSftpUserRole[keyof typeof ErpSftpUserRole];
/** Input parameters for updating an existing SFTP user */
export type ErpSftpUserUpdateInput = {
  /**
   * Authentication method to update for this user.
   * Changing this will require appropriate password or sshPublicKey to be provided.
   */
  authMethod?: InputMaybe<ErpSftpAuthMethod | '%future added value'>;
  /** Whether the user account should be active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** New password for the user (will be securely hashed). */
  password?: InputMaybe<Scalars['String']['input']>;
  /**
   * Sets folder permissions for the user.
   * If an empty array is passed, no changes will be made to existing permissions.
   * This will replace the entire permission set for the user
   */
  permissions?: InputMaybe<Array<ErpSftpFolderPermissionInput>>;
  /**
   * New SSH public key for the user.
   * Only processed when authMethod is SSH_KEY.
   */
  sshPublicKey?: InputMaybe<Scalars['String']['input']>;
  /** Username of the user to update. Used to identify the target user. */
  username: Scalars['String']['input'];
};

export type ErpSftpUserUpdateResponse = AuthorizationFailure | ErpSftpUserNotFound | ErpSftpUserUpdateSuccess | InputValidationFailure;

export type ErpSftpUserUpdateSuccess = AppsyncResponse & {
  __typename?: 'ErpSftpUserUpdateSuccess';
  /** The updated SFTP user with current data */
  erpSftpUser: ErpSftpUser;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

/** Filter criteria for querying SFTP users */
export type ErpSftpUsersFilterInput = {
  /** Filter by specific usernames. If provided, only users with these exact usernames will be returned. */
  usernames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ErpSftpUsersInput = {
  /** Optional filter criteria to narrow down the results */
  filter?: InputMaybe<ErpSftpUsersFilterInput>;
  /** Pagination parameters to control result set size and offset */
  pagination?: InputMaybe<PaginationInputV2>;
};

export type ErpSftpUsersResponse = AuthorizationFailure | ErpSftpUsersSuccess;

export type ErpSftpUsersResultEdge = Edge & {
  __typename?: 'ErpSftpUsersResultEdge';
  /** Pagination cursor for this edge */
  cursor: Scalars['String']['output'];
  /** The SFTP user data for this edge */
  node: ErpSftpUser;
};

/** Successful response for SFTP users query containing paginated results */
export type ErpSftpUsersSuccess = AppsyncResponse & Page & {
  __typename?: 'ErpSftpUsersSuccess';
  /** List of SFTP user result edges containing the actual user data */
  edges: Array<ErpSftpUsersResultEdge>;
  /** Pagination information for the result set */
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type EstimatedDeliveryFee = {
  __typename?: 'EstimatedDeliveryFee';
  fee: MoneyV2;
};

/**
 * Estimate the delivery fee that would apply to an order of the given subtotal.
 * The fee is resolved server-side from the applicable tier configuration (customer
 * override when present, otherwise the supplier default). Used by the buyer apps to
 * render the fee line on the order confirmation screen.
 */
export type EstimatedDeliveryFeeInput = {
  buyerId: Scalars['String']['input'];
  /** Order subtotal the fee should be estimated against. */
  estimatedTotalAmount: MoneyV2Input;
  supplierId: Scalars['String']['input'];
};

export type EstimatedDeliveryFeeResponse = AuthorizationFailure | EstimatedDeliveryFee | InputValidationFailure;

export type EvaluatedCart = {
  __typename?: 'EvaluatedCart';
  /**
   * Nested fees container: delivery fee today, extensible to service/packing,
   * alongside pricing / tax / promotions.
   */
  additionalFees: AdditionalFees;
  /** Cart analytics id. Minted on first evaluate when omitted; echoed thereafter. */
  cartId: Scalars['ID']['output'];
  /**
   * One evaluated line per vendorItemUnitId. Paid and free quantities for the
   * same unit are composed on that line.
   */
  lines: Array<EvaluatedLine>;
  /**
   * Loyalty points estimate for this cart, mirroring the Order.loyalty shape.
   * Only REVIEW evaluates it, and only when a loyalty program applies.
   * EDIT never evaluates loyalty. Null otherwise, or when no estimate is
   * available. Loyalty is enrichment: it never blocks evaluation or checkout.
   */
  loyalty?: Maybe<LoyaltyPointsBreakdown>;
  /** Cart-level money roll-ups (subtotal through payable). */
  pricing: CartPricing;
  /**
   * Promotions domain outcome. UNAVAILABLE is fail-closed (non-committable).
   * Empty applicable offers with status OK is success.
   */
  promotions: PromotionsResult;
  /**
   * Tax domain outcome. Switch on __typename.
   * EDIT: TaxNotEvaluatedResult.
   * REVIEW/commit: TaxSuccessResult, TaxNotApplicableResult (no tax profile),
   * TaxNotEvaluatedResult (Tax disabled), or TaxUnavailableResult (fail-closed).
   */
  tax: TaxResult;
  /**
   * Typed policy outcomes. Stock, invalid product, MOQ, order/product delivery,
   * single-unit variation, MOV, buyer comments, and gift claims are different
   * CartValidationResult implementors. Commit only when no active non-overridden
   * BLOCKED entry remains. No corrections list and no root movStatus: MOV
   * amounts live on MovValidationResult (cart money; not per-unit min qty).
   */
  validationResults: Array<CartValidationResult>;
};

/**
 * One GraphQL line per vendorItemUnitId (client cart). Paid and free quantity
 * for the same unit live on one row via paidQuantity / freeQuantity: no
 * PaidLine/FreeLine split, no isFree boolean (cannot express partial free).
 * UI shows one line per unit.
 */
export type EvaluatedLine = {
  __typename?: 'EvaluatedLine';
  /**
   * Stock / discontinued for this cart line (feeds StockValidationResult).
   * Always evaluated for cartEvaluate and checkoutCreate.
   */
  availability: Availability | '%future added value';
  /**
   * Free grant units on this vendorItemUnitId (FREE_UNITS_INCLUDED carve
   * and/or CART_FREE claim). Zero when none.
   */
  freeQuantity: Decimal;
  /**
   * Units the buyer pays for, after any promotion carve-out. A pure gift line
   * has paidQuantity 0 and freeQuantity greater than 0.
   */
  paidQuantity: Decimal;
  /**
   * All pre/post promotion money on the line in one object so the client can
   * select pricing {…} without a flat sibling field set. Free portion
   * contributes 0 to net; unitPriceBeforePromotion remains the savings basis
   * for free quantity.
   */
  pricing: LinePricing;
  /**
   * Product identity for the line. Evaluate/checkout return id only;
   * cart/product rows (name, image, unit) use existing VendorItemUnitRef.node.
   */
  vendorItemUnit: VendorItemUnitRef;
};

/**
 * Required domain that could not be completed for evaluate or create.
 * Not used for unmet minimum order value or other policy failures: those are
 * validationResults on EvaluatedCart. A MOV dependency outage is different and
 * uses MOV_UNAVAILABLE here.
 */
export type EvaluationDependencyFailure = {
  __typename?: 'EvaluationDependencyFailure';
  /**
   * Stable code (PRICING_UNAVAILABLE, PROMOTIONS_UNAVAILABLE, TAX_UNAVAILABLE,
   * MOV_UNAVAILABLE, or checkoutCreate-only ORDER_LOOKUP_UNAVAILABLE).
   */
  code: Scalars['String']['output'];
  /** Optional detail for logs / support. */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether retrying this dependency may succeed. */
  retryable: Scalars['Boolean']['output'];
};

export type Event = {
  __typename?: 'Event';
  chatEventType: ChatEventTypes;
  /** @deprecated use chatEventType instead */
  eventType?: Maybe<EventType | '%future added value'>;
  target?: Maybe<Array<Maybe<EventTarget>>>;
};

export type EventChat = {
  __typename?: 'EventChat';
  chatId?: Maybe<Scalars['ID']['output']>;
  chatName?: Maybe<Scalars['String']['output']>;
  restaurantName?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<EventUser>;
};

export type EventDeliveryCheckReconciliationRequest = {
  __typename?: 'EventDeliveryCheckReconciliationRequest';
  orderId?: Maybe<Scalars['ID']['output']>;
  orderReferenceId?: Maybe<Scalars['String']['output']>;
  reconciliationRequestType?: Maybe<DeliveryCheckReconciliationRequestType | '%future added value'>;
};

export type EventOrder = {
  __typename?: 'EventOrder';
  comment?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  orderCreatedAt?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  orderReferenceId?: Maybe<Scalars['String']['output']>;
};

export type EventTarget = EventChat | EventDeliveryCheckReconciliationRequest | EventOrder | EventUser;

export const EventType = {
  ChatCreated: 'chatCreated',
  ChatNameUpdated: 'chatNameUpdated',
  ReconciliationRequestConfirmed: 'reconciliationRequestConfirmed',
  UserAddedToChat: 'userAddedToChat',
  UserRemovedFromChat: 'userRemovedFromChat'
} as const;

export type EventType = typeof EventType[keyof typeof EventType];
export type EventUser = {
  __typename?: 'EventUser';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

/** Everything matching was counted. */
export type ExactCount = {
  __typename?: 'ExactCount';
  count: Scalars['Int']['output'];
};

export type ExecutionUrlOutput = {
  __typename?: 'ExecutionUrlOutput';
  url: Scalars['String']['output'];
};

export type ExistingInvitedUser = AppsyncError & AppsyncResponse & {
  __typename?: 'ExistingInvitedUser';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type ExistingOrderError = AppsyncError & AppsyncResponse & {
  __typename?: 'ExistingOrderError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** ID of Existing Order */
  orderId?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type ExportCustomersInput = {
  columns: Array<CustomerExportColumn | '%future added value'>;
  filter?: InputMaybe<SearchCustomerV2Filter>;
  format: CustomerExportFormat | '%future added value';
};

export type ExportCustomersResponse = AuthorizationFailure | ExportCustomersSuccess | InputValidationFailure;

export type ExportCustomersSuccess = {
  __typename?: 'ExportCustomersSuccess';
  downloadUrl: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  totalRecords: Scalars['Int']['output'];
};

export type ExportQuoteInput = {
  /**
   * When true, a quote that is otherwise blocked from export because some of its
   * items have not met their margin requirement can still be exported. The export
   * contains only the items that have a margin and meet it; below-/no-margin items
   * are excluded, not added.
   */
  allowExportWithUnmetMargins?: InputMaybe<Scalars['Boolean']['input']>;
  currencyConversion?: InputMaybe<QuoteExportCurrencyConversionInput>;
  /**
   * Pdf and Csv produce a downloadable file (`ExportQuoteResult`).
   * Erp upserts the export set as customer-specific prices
   * (`ExportQuoteToErpResult` / `ExportQuoteToErpPartialResult`).
   * `currencyConversion` and `suppressTotalCost` apply only to Pdf/Csv.
   */
  format: QuoteExportFormat | '%future added value';
  quoteId: Scalars['ID']['input'];
  /**
   * PDF: When true, the total cost is not included in the export.
   * CSV and Erp: Ignored.
   * Default is false.
   */
  suppressTotalCost?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExportQuoteResponse = AuthorizationFailure | ExportQuoteResult | ExportQuoteToErpPartialResult | ExportQuoteToErpResult | InputValidationFailure | NotFoundError | QuoteValidationFailedResult;

/** Successful Pdf/Csv export with a download URL for the generated file. */
export type ExportQuoteResult = {
  __typename?: 'ExportQuoteResult';
  downloadUrl: Scalars['AWSURL']['output'];
  responseType: ResponseType | '%future added value';
};

/** Catalog per-item failure reasons from customer-specific price batch update. */
export const ExportQuoteToErpFailureCode = {
  InternalServerError: 'InternalServerError',
  InvalidInput: 'InvalidInput',
  VendorItemUnitNotFound: 'VendorItemUnitNotFound'
} as const;

export type ExportQuoteToErpFailureCode = typeof ExportQuoteToErpFailureCode[keyof typeof ExportQuoteToErpFailureCode];
export type ExportQuoteToErpPartialFailureItem = {
  __typename?: 'ExportQuoteToErpPartialFailureItem';
  code: ExportQuoteToErpFailureCode | '%future added value';
  message?: Maybe<Scalars['String']['output']>;
  vendorItemUnitId: Scalars['ID']['output'];
};

/**
 * Catalog batch ran with one or more per-item failures (including zero successes).
 * `responseType` is success; distinguish from full success via `__typename`.
 */
export type ExportQuoteToErpPartialResult = {
  __typename?: 'ExportQuoteToErpPartialResult';
  failedUpdates: Scalars['Int']['output'];
  failures: Array<ExportQuoteToErpPartialFailureItem>;
  responseType: ResponseType | '%future added value';
  successfulUpdates: Scalars['Int']['output'];
};

/** All catalog price writes for the export set succeeded. `responseType` is success. */
export type ExportQuoteToErpResult = {
  __typename?: 'ExportQuoteToErpResult';
  responseType: ResponseType | '%future added value';
  successfulUpdates: Scalars['Int']['output'];
};

/** Input for exporting sales funnel leads. */
export type ExportSalesFunnelLeadsInput = {
  /** Columns to include, in output order. At least one column is required. */
  columns: Array<SalesFunnelLeadExportColumn | '%future added value'>;
  /** Filters applied to the exported leads. */
  filter?: InputMaybe<SalesFunnelLeadFilterInput>;
  /** Export file format. */
  format: SalesFunnelLeadExportFormat | '%future added value';
  /** ID of the sales funnel whose leads are exported. */
  salesFunnelId: Scalars['ID']['input'];
};

export type ExportSalesFunnelLeadsResponse = AuthorizationFailure | ExportSalesFunnelLeadsSuccess | InputValidationFailure;

/** Successful sales funnel lead export. */
export type ExportSalesFunnelLeadsSuccess = {
  __typename?: 'ExportSalesFunnelLeadsSuccess';
  /** Presigned URL for downloading the generated file. */
  downloadUrl: Scalars['String']['output'];
  /** Suggested download filename. */
  filename: Scalars['String']['output'];
  /** Number of leads included in the generated file. */
  totalRecords: Scalars['Int']['output'];
};

/** The available values for a single facet type, returned alongside browse results. */
export type FacetGroup = {
  __typename?: 'FacetGroup';
  type: FacetType | '%future added value';
  values: Array<FacetValue>;
};

/** A selected facet within a browse filter. */
export type FacetSelection = {
  /** IDs / keys for the chosen values within the facet type. */
  keys: Array<Scalars['String']['input']>;
  /**
   * Combination mode for the selected values.
   * `ANY`: include items matching any of the keys.
   * `ALL`: include items matching all of the keys.
   */
  mode: CatalogAttributeFilterMode | '%future added value';
  /** The facet type the `keys` belong to. */
  type: FacetType | '%future added value';
};

/** The type of a browse facet. */
export const FacetType = {
  AllergenFreeFrom: 'ALLERGEN_FREE_FROM',
  Brand: 'BRAND',
  CatalogCategory: 'CATALOG_CATEGORY',
  DietaryCertification: 'DIETARY_CERTIFICATION',
  DietaryLifestyle: 'DIETARY_LIFESTYLE',
  OgCategory: 'OG_CATEGORY',
  /**
   * Products carrying a promotion that is active, in its time window, and
   * applicable to the chat. The dimension is boolean, so its only key is `"true"`;
   * select it with `{ type: PROMOTION, mode: ANY, keys: ["true"] }`.
   */
  Promotion: 'PROMOTION'
} as const;

export type FacetType = typeof FacetType[keyof typeof FacetType];
/**
 * A single facet value bucket. Only the stable key is returned — human-readable
 * labels are resolved client-side via the `catalogAttributeValues` query.
 */
export type FacetValue = {
  __typename?: 'FacetValue';
  /** ID / key of a facet value associated with a specific facet type. */
  key: Scalars['String']['output'];
};

export type FallOffProduct = {
  __typename?: 'FallOffProduct';
  lastOrderDate: Scalars['AWSDate']['output'];
  lastOrderDateTimestamp: Scalars['AWSTimestamp']['output'];
  orderedProductPrice?: Maybe<MoneyV2>;
  product: ProductRef;
  productId: Scalars['ID']['output'];
};

export type FallOffProductV3 = {
  __typename?: 'FallOffProductV3';
  lastOrderDate: Scalars['AWSDate']['output'];
  lastOrderDateTimestamp: Scalars['AWSTimestamp']['output'];
  orderedProductPrice?: Maybe<MoneyV2>;
  product: ProductRef;
  productFallback: ProductFallback;
  productId: Scalars['ID']['output'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  key: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type FeatureFlagControlClause = {
  __typename?: 'FeatureFlagControlClause';
  attribute: Scalars['String']['output'];
  contextKind?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  negate: Scalars['Boolean']['output'];
  op: Scalars['String']['output'];
  values: Array<Scalars['AWSJSON']['output']>;
};

export type FeatureFlagControlConfig = {
  __typename?: 'FeatureFlagControlConfig';
  environmentKey: Scalars['String']['output'];
  isProduction: Scalars['Boolean']['output'];
  projectKey: Scalars['String']['output'];
  /** The provider backing this surface, e.g. launchDarkly. */
  provider: Scalars['String']['output'];
};

export type FeatureFlagControlConfigResponse = AuthorizationFailure | FeatureFlagControlConfig | InternalServerError;

export type FeatureFlagControlEntityInput = {
  id: Scalars['ID']['input'];
  kind: FeatureFlagControlEntityKind | '%future added value';
};

export const FeatureFlagControlEntityKind = {
  Buyer: 'buyer',
  Supplier: 'supplier',
  User: 'user'
} as const;

export type FeatureFlagControlEntityKind = typeof FeatureFlagControlEntityKind[keyof typeof FeatureFlagControlEntityKind];
/**
 * The value the backend's own flag SDK evaluates for an entity, built with the
 * same context the services use.
 */
export type FeatureFlagControlEvaluation = {
  __typename?: 'FeatureFlagControlEvaluation';
  reason?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['AWSJSON']['output']>;
  variationIndex?: Maybe<Scalars['Int']['output']>;
};

export type FeatureFlagControlFallthrough = {
  __typename?: 'FeatureFlagControlFallthrough';
  rollout?: Maybe<FeatureFlagControlRollout>;
  variation?: Maybe<Scalars['Int']['output']>;
};

export type FeatureFlagControlFlag = {
  __typename?: 'FeatureFlagControlFlag';
  archived: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Targeting in the environment named by featureFlagControlConfig. */
  environment: FeatureFlagControlFlagEnvironment;
  /** Set only when the query was given an entity. */
  evaluation?: Maybe<FeatureFlagControlEvaluation>;
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  temporary: Scalars['Boolean']['output'];
  variations: Array<FeatureFlagControlVariation>;
};

export type FeatureFlagControlFlagClauseValuesUpdateInput = {
  clauseId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Must be true when the environment is production. */
  confirmProduction?: InputMaybe<Scalars['Boolean']['input']>;
  flagKey: Scalars['String']['input'];
  operation: FeatureFlagControlValuesOperation | '%future added value';
  ruleId: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type FeatureFlagControlFlagEnvironment = {
  __typename?: 'FeatureFlagControlFlagEnvironment';
  archived: Scalars['Boolean']['output'];
  contextTargets: Array<FeatureFlagControlTarget>;
  /** Whether targeting is on. Off serves offVariation to everyone. */
  enabled: Scalars['Boolean']['output'];
  fallthrough?: Maybe<FeatureFlagControlFallthrough>;
  offVariation?: Maybe<Scalars['Int']['output']>;
  prerequisites: Array<FeatureFlagControlPrerequisite>;
  rules: Array<FeatureFlagControlRule>;
  targets: Array<FeatureFlagControlTarget>;
};

export type FeatureFlagControlFlagToggleInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Must be true when the environment is production. */
  confirmProduction?: InputMaybe<Scalars['Boolean']['input']>;
  enabled: Scalars['Boolean']['input'];
  flagKey: Scalars['String']['input'];
};

export type FeatureFlagControlFlagWriteResponse = AuthorizationFailure | FeatureFlagControlFlag | InputValidationFailure | InternalServerError | NotFoundError;

export type FeatureFlagControlFlags = {
  __typename?: 'FeatureFlagControlFlags';
  flags: Array<FeatureFlagControlFlag>;
};

export type FeatureFlagControlFlagsInput = {
  entity?: InputMaybe<FeatureFlagControlEntityInput>;
  tagMatch?: InputMaybe<FeatureFlagControlTagMatch | '%future added value'>;
  /** Empty returns every non-archived flag. */
  tags: Array<Scalars['String']['input']>;
};

export type FeatureFlagControlFlagsResponse = AuthorizationFailure | FeatureFlagControlFlags | InputValidationFailure | InternalServerError;

export type FeatureFlagControlPrerequisite = {
  __typename?: 'FeatureFlagControlPrerequisite';
  key: Scalars['String']['output'];
  variation: Scalars['Int']['output'];
};

export type FeatureFlagControlRollout = {
  __typename?: 'FeatureFlagControlRollout';
  contextKind?: Maybe<Scalars['String']['output']>;
  variations: Array<FeatureFlagControlWeightedVariation>;
};

export type FeatureFlagControlRule = {
  __typename?: 'FeatureFlagControlRule';
  clauses: Array<FeatureFlagControlClause>;
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  rollout?: Maybe<FeatureFlagControlRollout>;
  variation?: Maybe<Scalars['Int']['output']>;
};

export type FeatureFlagControlSegment = {
  __typename?: 'FeatureFlagControlSegment';
  description?: Maybe<Scalars['String']['output']>;
  excluded: Array<Scalars['String']['output']>;
  included: Array<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rules: Array<FeatureFlagControlRule>;
  tags: Array<Scalars['String']['output']>;
  /** Big segment: membership is not returned by the API. */
  unbounded: Scalars['Boolean']['output'];
};

export type FeatureFlagControlSegmentClauseValuesUpdateInput = {
  clauseId: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Must be true when the environment is production. */
  confirmProduction?: InputMaybe<Scalars['Boolean']['input']>;
  operation: FeatureFlagControlValuesOperation | '%future added value';
  ruleId: Scalars['String']['input'];
  segmentKey: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export const FeatureFlagControlSegmentTargetList = {
  Excluded: 'excluded',
  Included: 'included'
} as const;

export type FeatureFlagControlSegmentTargetList = typeof FeatureFlagControlSegmentTargetList[keyof typeof FeatureFlagControlSegmentTargetList];
export type FeatureFlagControlSegmentTargetsUpdateInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Must be true when the environment is production. */
  confirmProduction?: InputMaybe<Scalars['Boolean']['input']>;
  contextKind: Scalars['String']['input'];
  list?: InputMaybe<FeatureFlagControlSegmentTargetList | '%future added value'>;
  operation: FeatureFlagControlValuesOperation | '%future added value';
  segmentKey: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type FeatureFlagControlSegmentWriteResponse = AuthorizationFailure | FeatureFlagControlSegment | InputValidationFailure | InternalServerError | NotFoundError;

export type FeatureFlagControlSegments = {
  __typename?: 'FeatureFlagControlSegments';
  segments: Array<FeatureFlagControlSegment>;
};

export type FeatureFlagControlSegmentsResponse = AuthorizationFailure | FeatureFlagControlSegments | InternalServerError;

export const FeatureFlagControlTagMatch = {
  /** Flags carrying every given tag. */
  All: 'all',
  /** Flags carrying at least one given tag. */
  Any: 'any'
} as const;

export type FeatureFlagControlTagMatch = typeof FeatureFlagControlTagMatch[keyof typeof FeatureFlagControlTagMatch];
export type FeatureFlagControlTags = {
  __typename?: 'FeatureFlagControlTags';
  tags: Array<Scalars['String']['output']>;
};

export type FeatureFlagControlTagsResponse = AuthorizationFailure | FeatureFlagControlTags | InternalServerError;

export type FeatureFlagControlTarget = {
  __typename?: 'FeatureFlagControlTarget';
  contextKind?: Maybe<Scalars['String']['output']>;
  values: Array<Scalars['String']['output']>;
  variation: Scalars['Int']['output'];
};

export const FeatureFlagControlValuesOperation = {
  Add: 'add',
  Remove: 'remove'
} as const;

export type FeatureFlagControlValuesOperation = typeof FeatureFlagControlValuesOperation[keyof typeof FeatureFlagControlValuesOperation];
export type FeatureFlagControlVariation = {
  __typename?: 'FeatureFlagControlVariation';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value: Scalars['AWSJSON']['output'];
};

export type FeatureFlagControlWeightedVariation = {
  __typename?: 'FeatureFlagControlWeightedVariation';
  variation: Scalars['Int']['output'];
  weight: Scalars['Int']['output'];
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  flags: Array<Maybe<FeatureFlag>>;
};

export type FetchBuyerReportDownloadUrlInput = {
  id: Scalars['String']['input'];
};

export type FetchBuyerReportDownloadUrlResponse = AuthorizationFailure | BuyerReport | BuyerReportGenerationError | BuyerReportNotFoundError | InputValidationFailure;

export type FetchCatalogCategoriesForChatResponse = CatalogCategoriesResponse | CatalogNotFound;

export type FieldValidationError = {
  __typename?: 'FieldValidationError';
  fieldName: Scalars['String']['output'];
  /** Computer readable error message */
  reason: Scalars['String']['output'];
};

export type FixedAmountTaxRate = {
  __typename?: 'FixedAmountTaxRate';
  /** The fixed per-unit tax amount, e.g. EUR 0.50. */
  fixedAmount: MoneyV2;
};

export type FixedAmountValue = {
  __typename?: 'FixedAmountValue';
  /** The fixed money amount. */
  fixedAmount: MoneyV2;
};

export type FooterLink = {
  __typename?: 'FooterLink';
  id: Scalars['ID']['output'];
  listPosition: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FooterLinkInput = {
  listPosition: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type FooterSection = {
  __typename?: 'FooterSection';
  id: Scalars['ID']['output'];
  links: Array<FooterLink>;
  sectionNumber: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type FooterSectionInput = {
  links: Array<FooterLinkInput>;
  sectionNumber: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type ForbiddenError = AppsyncError & AppsyncResponse & {
  __typename?: 'ForbiddenError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

/**
 * For queries that only support pagination in one direction.
 *
 * Could be expanded to support a limit count on the page, but the only use
 * case requires a full enumeration of the data set, so there is no need to
 * add that complexity.
 */
export type ForwardPaginationInput = {
  /** The cursor to start the query from. Provide null to start from the beginning. */
  startCursor?: InputMaybe<Scalars['String']['input']>;
};

export type FreeItemChoiceOption = {
  __typename?: 'FreeItemChoiceOption';
  quantity: Decimal;
  /** The granted free unit, exposed as a ref so callers can resolve the unit. */
  vendorItemUnit?: Maybe<VendorItemUnitRef>;
};

export type FullPageInformationalAd = AdInterface & {
  __typename?: 'FullPageInformationalAd';
  /** Metadata for tracking and analytics */
  adMetadata: AdMetadata;
  /** ID of the campaign this ad belongs to */
  campaignId: Scalars['String']['output'];
  /** Hex value for the background color of the Call to Action button (optional) */
  ctaBackgroundColor?: Maybe<Scalars['String']['output']>;
  /** Call to Action Label that the user will see */
  ctaLabel: Scalars['String']['output'];
  /** URL for the Call to Action button */
  ctaLink: Scalars['String']['output'];
  /** The main full page image URL like "Premium Frappe Mix" */
  fullPageImageUrl: Scalars['String']['output'];
  /** Title displayed on the full page ad, e.g., "Premium Frappe Mix" */
  fullPageTitle?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the ad */
  id: Scalars['ID']['output'];
  /** ID of the buyer segment this ad targets */
  segmentId: Scalars['ID']['output'];
};

export type GenerateBuyerReportInput = {
  buyerIds: Array<Scalars['String']['input']>;
  from: Scalars['AWSTimestamp']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  supplierIds: Array<Scalars['String']['input']>;
  to: Scalars['AWSTimestamp']['input'];
  type: BuyerReportType | '%future added value';
};

export type GenerateBuyerReportResponse = AuthorizationFailure | BuyerReport | InputValidationFailure;

export type GenerateMagicCodeInput = {
  /** The ID of the chat to associate with the magic code. */
  chatId: Scalars['ID']['input'];
};

export type GenerateMagicCodeResponse = ActiveMagicCodeAlreadyExistsError | AuthorizationFailure | GenerateMagicCodeResult | GenerateMagicCodeUnexpectedError | InputValidationFailure | MagicCodeChatDisabledError | MagicCodeChatNotFoundError | MagicCodeSupplierNotWhitelabelError;

export type GenerateMagicCodeResult = AppsyncResponse & {
  __typename?: 'GenerateMagicCodeResult';
  /** The generated magic code */
  magicCode: MagicCode;
  /** Response type will always be set to success */
  responseType: ResponseType | '%future added value';
};

/**
 * Returned when an unexpected error occurs during magic code generation.
 * Use this as a fallback error type for proper error handling.
 */
export type GenerateMagicCodeUnexpectedError = AppsyncError & AppsyncResponse & {
  __typename?: 'GenerateMagicCodeUnexpectedError';
  /** A human-readable message describing the error */
  message: Scalars['String']['output'];
  /** Response type will always be set to error */
  responseType: ResponseType | '%future added value';
};

/** Represents a distance in a geography. */
export type GeographicDistanceInput = {
  /** The distance value. */
  distance: Scalars['Float']['input'];
  /** The distance unit of measure. */
  unitOfMeasure: DistanceUnitOfMeasure | '%future added value';
};

export const GeographicIdentifierInputType = {
  GooglePlace: 'GooglePlace'
} as const;

export type GeographicIdentifierInputType = typeof GeographicIdentifierInputType[keyof typeof GeographicIdentifierInputType];
export type GetAdContextFilterInput = {
  /** Optional: for Order Guide ads to filter by chat context */
  chatId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetAdContextInput = {
  /** The zone of the ad, e.g. Banner, FullPage */
  adZone: AdZone | '%future added value';
  /** The ID of the current buyer */
  currentBuyerId: Scalars['ID']['input'];
  /** Optional: for context-specific filtering */
  filter?: InputMaybe<GetAdContextFilterInput>;
  /** Mobile or WEB defaults to Mobile */
  platform?: InputMaybe<Platform | '%future added value'>;
};

export type GetAdContextResponse = AuthorizationFailure | GetAdContextResult | InputValidationFailure;

export type GetAdContextResult = AppsyncResponse & {
  __typename?: 'GetAdContextResult';
  /** List of ads matching the criteria */
  ads?: Maybe<Array<AdInterface>>;
  /** Optional message providing additional context */
  message?: Maybe<Scalars['String']['output']>;
  /** Type of response returned */
  responseType: ResponseType | '%future added value';
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type GetAllBuyerReportSchedulesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['ID']['input'];
};

export type GetAllBuyerReportSchedulesResponse = AuthorizationFailure | BuyerReportSchedules | InputValidationFailure;

export type GetAllChatsByBuyerFilter = {
  buyerId: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<ChatStatus | '%future added value'>>;
};

export type GetAllChatsByBuyerInput = {
  filter: GetAllChatsByBuyerFilter;
  pagination?: InputMaybe<ForwardPaginationInput>;
};

export type GetAllChatsByBuyerResponse = AuthorizationFailure | BuyerChatsConnection | InputValidationFailure;

export type GetAllChatsBySupplierFilter = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Array<ChatStatus | '%future added value'>>;
  supplierEntityId: Scalars['String']['input'];
};

export type GetAllChatsBySupplierInput = {
  filter: GetAllChatsBySupplierFilter;
  pagination?: InputMaybe<ForwardPaginationInput>;
};

export type GetAllChatsBySupplierResponse = AuthorizationFailure | InputValidationFailure | SupplierChatsConnection;

export type GetBuyerContactInfosInput = {
  search: Scalars['String']['input'];
  supplierId: Scalars['ID']['input'];
};

export type GetBuyerContactInfosResponse = AuthorizationFailure | BuyerContactInfos | InputValidationFailure | InternalServerError | NotFoundError;

export type GetBuyerSegmentContentByChatInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  segmentId: Scalars['ID']['input'];
};

export type GetBuyerSegmentContentByChatResponse = AuthorizationFailure | GetBuyerSegmentContentByChatResult | InputValidationFailure;

export type GetBuyerSegmentContentByChatResult = AppsyncResponse & {
  __typename?: 'GetBuyerSegmentContentByChatResult';
  content: BuyerSegmentContent;
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
  success: Scalars['Boolean']['output'];
};

export type GetBuyerStockCountFilterInput = {
  buyerId: Scalars['ID']['input'];
  status: Array<BuyerStockCountStatus | '%future added value'>;
};

export type GetBuyerStockCountInput = {
  buyerId: Scalars['String']['input'];
  status: Array<BuyerStockCountStatus | '%future added value'>;
  stockCountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetBuyerStockCountsInput = {
  filter: GetBuyerStockCountFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Sort>;
};

export type GetBuyerStockInventoryExportUrlInput = {
  buyerId: Scalars['ID']['input'];
};

export type GetBuyerStockInventoryProductsFilterInput = {
  buyerId: Scalars['ID']['input'];
};

export type GetCatalogUploadUrlResponse = GetCatalogUploadUrlResult | SupplierNotFound;

export type GetCatalogUploadUrlResult = {
  __typename?: 'GetCatalogUploadUrlResult';
  catalogUploadToken?: Maybe<Scalars['String']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type GetChatCountByCcEmailReport = {
  __typename?: 'GetChatCountByCCEmailReport';
  numberOfChats: Scalars['Int']['output'];
};

export type GetChatCountByCcEmailResponse = AuthorizationFailure | GetChatCountByCcEmailReport;

export type GetChatSuppliersByLocationsInput = {
  buyerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GetChatSuppliersByLocationsResponse = AuthorizationFailure | ChatSuppliersByLocations | InputValidationFailure;

export type GetChatsByChatIdsResponse = AuthorizationFailure | ChatsConnection | InputValidationFailure;

export type GetChatsForSubCatalogResponse = AuthorizationFailure | GetChatsForSubCatalogResult | SubCatalogNotFoundError;

export type GetChatsForSubCatalogResult = {
  __typename?: 'GetChatsForSubCatalogResult';
  chatIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type GetConnectedAccountsResponse = AuthorizationFailure | ConnectedAccountConnection | InputValidationFailure;

export type GetConnectedIntegrationAdaptersInput = {
  chocoEntityId?: InputMaybe<Scalars['ID']['input']>;
  chocoEntityType?: InputMaybe<ChocoEntityType | '%future added value'>;
};

export type GetConnectedIntegrationAdaptersResponse = AuthorizationFailure | InputValidationFailure | IntegrationAdapterConnectionAdminResultConnection | IntegrationAdapterConnectionBaseResultConnection;

export type GetContactInfosResponse = AuthorizationFailure | ContactInfos | InputValidationFailure | InternalServerError;

export type GetCustomerImportJobResponse = AuthorizationFailure | CustomerImportJobFailed | CustomerImportJobProcessing | CustomerImportJobSucceeded | CustomerImportJobWaitingForUpload | InputValidationFailure | NotFoundError;

export type GetCustomerInsightsInput = {
  chatId: Scalars['ID']['input'];
};

export type GetCustomerInsightsNotificationInput = {
  id: Scalars['ID']['input'];
};

export type GetCustomerInsightsNotificationResponse = AuthorizationFailure | CustomerInsightsNotification | InputValidationFailure;

export type GetCustomerInsightsNotificationsInput = {
  chatId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CustomerInsightsNotificationFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
};

export type GetCustomerInsightsNotificationsResponse = AuthorizationFailure | CustomerInsightsNotificationConnection | InputValidationFailure;

export type GetCustomerLabelsV2Input = {
  after?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input for querying a specific note by its ID.
 * Note: target entity is not needed as the note already contains this information.
 */
export type GetDistributorNoteQueryInput = {
  /** The ID of the specific note to retrieve */
  noteId: Scalars['ID']['input'];
};

export type GetDistributorNoteQueryResponse = AuthorizationFailure | DistributorNote | InputValidationFailure | NotFoundError;

/** Input for querying all notes associated with a specific entity. */
export type GetDistributorNotesQueryInput = {
  /** The cursor to start from. If not provided, the query will start from the beginning. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** The maximum number of notes to retrieve */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The entity whose notes we want to retrieve */
  target: DistributorNoteTargetEntity;
};

export type GetDistributorNotesQueryResponse = AuthorizationFailure | DistributorNoteConnection | InputValidationFailure | NotFoundError;

/** Input for retrieving distributor promoted content for display in buyer apps */
export type GetDistributorPromotedContentInput = {
  /** The ID of the buyer requesting the content */
  buyerId: Scalars['ID']['input'];
  /** Supplier IDs: Mandatory for white label apps, Optional for choco app, to filter content by specific suppliers */
  supplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Response containing distributor promoted content */
export type GetDistributorPromotedContentResponse = AuthorizationFailure | DistributorPromotedContentNotFound | GetDistributorPromotedContentResult | InputValidationFailure;

/** Successful result containing distributor promoted content */
export type GetDistributorPromotedContentResult = AppsyncResponse & {
  __typename?: 'GetDistributorPromotedContentResult';
  /** Optional message providing additional context */
  message?: Maybe<Scalars['String']['output']>;
  /**
   * Promoted content for the buyer
   * @deprecated Use promotedContents instead, which supports up to 3 campaigns.
   */
  promotedContent: DistributorPromotedContent;
  /**
   * Up to 3 preferred products campaigns, sorted by activatedAt DESC.
   * Use this field instead of the deprecated promotedContent.
   */
  promotedContents?: Maybe<Array<DistributorPromotedContent>>;
  /** Type of response returned */
  responseType: ResponseType | '%future added value';
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type GetDistributorTaskResponse = AuthorizationFailure | DistributorTask | InputValidationFailure | NotFoundError;

/** Input for getting tasks by filters */
export type GetDistributorTasksInput = {
  /** Filter by the user who created the task */
  createdByUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Pagination cursor. Null starts at the beginning */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Filter by entity type */
  entityType?: InputMaybe<DistributorTaskEntityType | '%future added value'>;
  /** Maximum number of tasks to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Filter for tasks due before this date/time (inclusive) */
  maxDueAt?: InputMaybe<DistributorTaskDueAtInput>;
  /** Filter for tasks due after this date/time (inclusive) */
  minDueAt?: InputMaybe<DistributorTaskDueAtInput>;
  /** Filter by status */
  status?: InputMaybe<Array<DistributorTaskStatus | '%future added value'>>;
  /** Filter by target entity */
  targetEntity?: InputMaybe<DistributorTaskTargetEntityInput>;
};

export type GetDistributorTasksResponse = AuthorizationFailure | DistributorTaskConnection | InputValidationFailure | NotFoundError;

export type GetDocumentScanAttachmentUploadLinkInput = {
  attachments: Array<DocumentScanAttachmentUploadLinkInput>;
  documentScanId: Scalars['ID']['input'];
};

export type GetDocumentScanAttachmentUploadLinkResponse = AuthorizationFailure | DocumentScanAttachmentUploadLinkResult | InputValidationFailure | NotFoundError;

export type GetDocumentScanListInput = {
  /** The id of the lead associated with the scan */
  leadId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetDocumentScanListResponse = AuthorizationFailure | DocumentScanConnection | InputValidationFailure;

export type GetDocumentScanResponse = AuthorizationFailure | DocumentScan | InputValidationFailure | NotFoundError;

/** Input type for retrieving the email editor state download URL. */
export type GetEmailEditorStateInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
};

/** Response type for retrieving the email editor state download URL. */
export type GetEmailEditorStateResponse = AuthorizationFailure | EmailEditorStateNotFound | GetEmailEditorStateResult | InputValidationFailure;

/** Success result containing the download URL for the email editor state. */
export type GetEmailEditorStateResult = AppsyncResponse & {
  __typename?: 'GetEmailEditorStateResult';
  /** The pre-signed download URL for the email editor state. */
  editorStateDownloadUrl: Scalars['String']['output'];
  /** The pre-signed download URL for the email template preview image. */
  previewImageDownloadUrl: Scalars['String']['output'];
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type GetEmailListsInput = {
  supplierId: Scalars['String']['input'];
  types: Array<OrderDestEmailListType | '%future added value'>;
};

export type GetEmailListsResponse = AuthorizationFailure | EmailLists;

export type GetFeatureFlagsResponse = AuthorizationFailure | FeatureFlags;

export type GetIntegrationAdaptersInput = {
  type: IntegrationAdapterType | '%future added value';
};

export type GetIntegrationAdaptersResponse = AuthorizationFailure | InputValidationFailure | IntegrationAdapterAdminResultConnection | IntegrationAdapterBaseResultConnection;

export type GetInviteTransmissionStatus = {
  chatId: Scalars['ID']['input'];
};

export type GetInviteTransmissionStatusResponse = AuthorizationFailure | InputValidationFailure | InviteTransmissionStatus;

export type GetInviteeBuyersResponse = InviteeBuyers | InviteeNotFound;

/** Input type for getting content upload url */
export type GetMarketingCampaignContentUploadLinkInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Content to be uploaded */
  content: ContentLinkInput;
};

/** Response type for getting the content upload link */
export type GetMarketingCampaignContentUploadLinkResponse = AuthorizationFailure | ContentUploadLinkResult | InputValidationFailure;

/** Response type for getting a marketing campaign email sender */
export type GetMarketingCampaignEmailSenderResponse = AuthorizationFailure | MarketingCampaignEmailSenderNotFound | MarketingCampaignEmailSenderResult;

/** Input type for getting a marketing campaign details */
export type GetMarketingCampaignInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
};

/** Response type for getting a marketing campaign */
export type GetMarketingCampaignResponse = AuthorizationFailure | GetMarketingCampaignResult | InputValidationFailure;

/** Result containing the marketing campaign information */
export type GetMarketingCampaignResult = AppsyncResponse & {
  __typename?: 'GetMarketingCampaignResult';
  /** Marketing campaign information */
  marketingCampaign: MarketingCampaign;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

/** Input type for getting media upload url in CDN */
export type GetMediaUploadLinkInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Media to be uploaded */
  medias: Array<MediaLinkInput>;
};

/** Response type for getting media upload links in CDN */
export type GetMediaUploadLinkResponse = AuthorizationFailure | InputValidationFailure | MediaUploadLinkResult;

export type GetMenuScanAttachmentUploadLinkInput = {
  attachments: Array<MenuScanAttachmentUploadLinkInput>;
  menuScanId: Scalars['ID']['input'];
};

export type GetMenuScanAttachmentUploadLinkResponse = AuthorizationFailure | InputValidationFailure | MenuScanAttachmentUploadLinkResult | NotFoundError;

export type GetMenuScanListInput = {
  /**
   * The id of the chat associated with the scan.
   * Provide leadId or chatId, not both.
   */
  chatId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The id of the lead associated with the scan.
   * Provide leadId or chatId, not both.
   */
  leadId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetMenuScanListResponse = AuthorizationFailure | InputValidationFailure | MenuScanConnection;

export type GetMenuScanResponse = AuthorizationFailure | InputValidationFailure | MenuScan | NotFoundError;

export type GetOcoRerankedProductsInput = {
  chatId: Scalars['String']['input'];
  /**
   * Optional subset of line-item IDs to return suggestions for.
   * When omitted, suggestions for every line item are returned.
   * Clients should use this to fetch suggestions in batches and
   * avoid hitting the AppSync resolver-invocation limit on large orders.
   */
  lineItemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  omnichannelOrderId: Scalars['ID']['input'];
};

export type GetOcoRerankedProductsResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | OcoRerankedProducts;

export type GetOmniChannelOrderInput = {
  omnichannelOrderId?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetOmniChannelOrderResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | OmnichannelOrder;

export type GetOnboardingChecklistResponse = AuthorizationFailure | OnboardingChecklist;

export type GetOrderChannelContactInfosInput = {
  supplierId: Scalars['ID']['input'];
};

export type GetOrderChannelContactInfosResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | OrderChannelContactInfos;

export type GetOrderDeliveryCheckResponse = AuthorizationFailure | CreatedOrCompletedByNotFound | InputValidationFailure | OrderDeliveryCheckDetails;

export type GetOrderGuideUploadUrl = {
  __typename?: 'GetOrderGuideUploadUrl';
  buyerId?: Maybe<Scalars['String']['output']>;
  downloadUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type GetOrderGuideUploadUrlError = AppsyncError & AppsyncResponse & {
  __typename?: 'GetOrderGuideUploadUrlError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type GetOrderGuideUploadUrlInput = {
  filename: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GetOrderGuideUploadUrlResponse = GetOrderGuideUploadUrl | GetOrderGuideUploadUrlError;

export type GetOrderInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetProductsForChatFilter = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetProductsForChatInput = {
  chatId: Scalars['ID']['input'];
  filter?: InputMaybe<GetProductsForChatFilter>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetProductsForChatResponse = AuthorizationFailure | ChatNotFoundError | GetProductsForChatResult | SupplierNotFound;

export type GetProductsForChatResult = {
  __typename?: 'GetProductsForChatResult';
  invalidProducts?: Maybe<Array<InvalidProduct>>;
  products?: Maybe<Array<Product>>;
  productsNotFound?: Maybe<Array<Scalars['ID']['output']>>;
};

export type GetQboCustomersAndOrderGuidesToImportResponse = AuthorizationFailure | InputValidationFailure | QboCustomersAndOrderGuidesToImport;

export type GetReconciliationRequestPlanBySupplierIdResponse = InputValidationFailure | ReconciliationRequestPlan | ReconciliationRequestPlanBySupplierIdNotFound;

export type GetReferralInput = {
  referralCode?: InputMaybe<Scalars['String']['input']>;
  referrerUserId?: InputMaybe<Scalars['String']['input']>;
};

export type GetReferralResponse = NotFoundError | Referral;

export type GetRequestsToJoinFilter = {
  status?: InputMaybe<JoinRequestStatus | '%future added value'>;
};

export type GetRequestsToJoinInput = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<GetRequestsToJoinFilter>;
  /** One of the following two parameters must be provided */
  supplierEntityId?: InputMaybe<Scalars['String']['input']>;
};

export type GetRequestsToJoinResponse = AuthorizationFailure | InputValidationFailure | RequestsToJoinConnection;

export type GetSalesFunnelDefinitionInput = {
  /** If not provided, will return the default sales funnel */
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GetSalesFunnelDefinitionQueryResponse = {
  __typename?: 'GetSalesFunnelDefinitionQueryResponse';
  salesFunnel: SalesFunnelDefinition;
};

export type GetSalesFunnelLeadQueryInput = {
  /** ID of the lead to get */
  id: Scalars['ID']['input'];
};

export type GetSalesFunnelLeadQueryResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelLead;

export type GetSalesFunnelLeadTransitionsConnection = Connection & {
  __typename?: 'GetSalesFunnelLeadTransitionsConnection';
  count: Scalars['Int']['output'];
  edges: Array<GetSalesFunnelLeadTransitionsEdge>;
  pageInfo: PageInfo;
};

export type GetSalesFunnelLeadTransitionsEdge = Edge & {
  __typename?: 'GetSalesFunnelLeadTransitionsEdge';
  cursor: Scalars['String']['output'];
  node: SalesFunnelLeadTransition;
};

/** Input for the getSalesFunnelLeadTransitions query. */
export type GetSalesFunnelLeadTransitionsQueryInput = {
  /**
   * Allows you to filter by assignee, i.e. only see transitions for leads assigned to
   * a specified list of users. Supports multiselect. Both no value and an empty
   * array indicate no filtering.
   * Note: If a supplier sales rep is querying, they must either provide their
   * own userId or not provide any value. Both cases return the same result.
   * And any other userId value will trigger an access exception.
   */
  assigneeFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** End date of the date range (inclusive). */
  endDate: Scalars['AWSDate']['input'];
  /**
   * Allows you to filter by end state, i.e. only see transitions that ended in
   * a specified list of states.
   */
  endStateIdFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Information for paginating the results. If not provided, reads the first page. */
  paginationInput?: InputMaybe<PaginationInputV2>;
  /** ID of the sales funnel to get lead transitions for. */
  salesFunnelId: Scalars['ID']['input'];
  /** Allows you to filter by search term. */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the date range (inclusive). */
  startDate: Scalars['AWSDate']['input'];
};

export type GetSalesFunnelLeadTransitionsQueryResponse = AuthorizationFailure | GetSalesFunnelLeadTransitionsConnection | InputValidationFailure;

export type GetSalesFunnelLeadsConnection = Connection & {
  __typename?: 'GetSalesFunnelLeadsConnection';
  count: Scalars['Int']['output'];
  edges: Array<GetSalesFunnelLeadsEdge>;
  pageInfo: PageInfo;
};

export type GetSalesFunnelLeadsEdge = Edge & {
  __typename?: 'GetSalesFunnelLeadsEdge';
  cursor: Scalars['String']['output'];
  node: SalesFunnelLead;
};

export type GetSalesFunnelLeadsForMapConnection = Connection & {
  __typename?: 'GetSalesFunnelLeadsForMapConnection';
  count: Scalars['Int']['output'];
  edges: Array<GetSalesFunnelLeadsForMapEdge>;
  pageInfo: PageInfo;
};

export type GetSalesFunnelLeadsForMapEdge = Edge & {
  __typename?: 'GetSalesFunnelLeadsForMapEdge';
  cursor: Scalars['String']['output'];
  node: SalesFunnelLeadForMap;
};

export type GetSalesFunnelLeadsForMapQueryResponse = AuthorizationFailure | GetSalesFunnelLeadsForMapConnection | InputValidationFailure;

/** Input for the getSalesFunnelLeads query. */
export type GetSalesFunnelLeadsQueryInput = {
  /**
   * Allows you to filter by assignee, i.e. only see tickets assigned to
   * a specified list of users. Supports multiselect. Both no value and an empty
   * array indicate no filtering.
   * Note: If a supplier sales rep is querying, they must either provide their
   * own userId or not provide any value. Both cases return the same result.
   * And any other userId value will trigger an access exception.
   * @deprecated use filter.assigneeFilter instead
   */
  assigneeFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters applied to the lead results. */
  filter?: InputMaybe<SalesFunnelLeadFilterInput>;
  /**
   * Filter to limit leads which satisfy some geographic criteria.
   * @deprecated use filter.geographicFilter instead
   */
  geographicFilter?: InputMaybe<SalesFunnelLeadGeographicFilterInput>;
  /**
   * Optional filter to show only archived or non-archived leads. If not provided, shows all leads.
   * @deprecated use filter.isArchivedFilter instead
   */
  isArchivedFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Requested ordering of the lead results. */
  orderBy?: InputMaybe<LeadOrderBy | '%future added value'>;
  /** Information for paginating the results. If not provided, reads the first page. */
  paginationInput?: InputMaybe<PaginationInputV2>;
  /** ID of the sales funnel to get leads for. */
  salesFunnelId: Scalars['ID']['input'];
  /**
   * Allows you to filter by search term.
   * @deprecated use filter.searchTerm instead
   */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /**
   * Allows you to filter by state, i.e. only see tickets in a specified list of states.
   * @deprecated use filter.stateIdFilter instead
   */
  stateIdFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetSalesFunnelLeadsQueryResponse = AuthorizationFailure | GetSalesFunnelLeadsConnection | InputValidationFailure;

export type GetSalesFunnelProspectFromPlaceIdQueryInput = {
  /** Place ID from Google Places API. */
  googlePlaceId: Scalars['String']['input'];
  /** Language code for query results. */
  language?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the funnel to get prospects for. */
  salesFunnelId?: InputMaybe<Scalars['ID']['input']>;
};

/** Filter for the getSalesFunnelProspectsFromFreeText query. */
export type GetSalesFunnelProspectsFromFreeTextQueryFilter = {
  /** Whether to exclude existing accounts and leads from the search results. */
  excludeExistingAccountsAndLeads: Scalars['Boolean']['input'];
  /** The ID of the funnel to get prospects for. */
  salesFunnelId: Scalars['ID']['input'];
};

/** Input to the getProspects query. */
export type GetSalesFunnelProspectsFromFreeTextQueryInput = {
  /** How to interpret the viewport search. */
  boundingRectangleSearchType: BoundingRectangleSearchType | '%future added value';
  /** Filter for the search results. Null/unspecified means no filter. */
  filter?: InputMaybe<GetSalesFunnelProspectsFromFreeTextQueryFilter>;
  /** Language code for query results. */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Free text search query. */
  queryText: Scalars['String']['input'];
  /** The area to which the query should be restricted. */
  viewport: BoundingRectangleInput;
};

export type GetSalesFunnelProspectsFromFreeTextQueryResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelProspectsResults;

export type GetSalesFunnelProspectsFromPlaceIdQueryResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelProspect;

export type GetSalesFunnelStatisticsHistoryQueryInput = {
  /**
   * Optional scope to filter by assignee, i.e. only statistics scoped to
   * the provided user.
   * null or empty array indicates no filtering.
   * must be provided by supplier sales reps and set to their own userId
   */
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  /** End date of the date range (inclusive). */
  endDate: Scalars['AWSDate']['input'];
  /** ID of the sales funnel to get statistics history for. */
  salesFunnelId: Scalars['ID']['input'];
  /** Start date of the date range (inclusive). */
  startDate: Scalars['AWSDate']['input'];
};

export type GetSalesFunnelStatisticsHistoryQueryResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelStatisticsHistory;

/** The input to the getSalesFunnelStatesStatistics query. */
export type GetSalesFunnelStatisticsQueryInput = {
  /**
   * Optional scope to filter by assignee, i.e. only statistics scoped to
   * the provided user.
   * null or empty array indicates no filtering.
   * must be provided by supplier sales reps and set to their own userId
   */
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional filter to show only archived or non-archived leads. If not provided, shows all leads. */
  isArchivedFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the sales funnel to get statistics for. */
  salesFunnelId: Scalars['ID']['input'];
};

export type GetSalesFunnelStatisticsQueryResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelStatistics;

export type GetSalesFunnelTotalsHistoryQueryInput = {
  /**
   * Optional scope to filter by assignee, i.e. only statistics scoped to
   * the provided user.
   * null or empty array indicates no filtering.
   * must be provided by supplier sales reps and set to their own userId
   */
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  /** End date of the date range (inclusive). */
  endDate: Scalars['AWSDate']['input'];
  /** ID of the sales funnel to get statistics history for. */
  salesFunnelId: Scalars['ID']['input'];
  /** Start date of the date range (inclusive). */
  startDate: Scalars['AWSDate']['input'];
};

export type GetSalesFunnelTotalsHistoryQueryResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelTotalsHistory;

/** Here are all functions for managing and accessing sales funnels and distributor notes */
export type GetSalesFunnelsQueryInput = {
  supplierId: Scalars['ID']['input'];
};

export type GetSalesFunnelsQueryResponse = {
  __typename?: 'GetSalesFunnelsQueryResponse';
  defaultSalesFunnel?: Maybe<SalesFunnelDefinition>;
  salesFunnels: Array<SalesFunnelDefinition>;
};

export type GetSimilarSalesFunnelLeadsConnection = {
  __typename?: 'GetSimilarSalesFunnelLeadsConnection';
  count: Scalars['Int']['output'];
  edges: Array<GetSimilarSalesFunnelLeadsEdge>;
};

export type GetSimilarSalesFunnelLeadsEdge = {
  __typename?: 'GetSimilarSalesFunnelLeadsEdge';
  node: SalesFunnelLead;
};

/** Input for the getSimilarSalesFunnelLeads query. */
export type GetSimilarSalesFunnelLeadsQueryInput = {
  /** The customer defined business name for the new lead. */
  businessName: Scalars['String']['input'];
  /** The external geographic identifier for the new lead. */
  geographicIdentifier: SalesFunnelLeadGeographicIdentifierInput;
  /** ID of the sales funnel to get leads for. */
  salesFunnelId: Scalars['ID']['input'];
};

export type GetSmsMessageByMessageSidResponse = AuthorizationFailure | GetSmsMessageByMessageSidSuccess;

export type GetSmsMessageByMessageSidSuccess = AppsyncResponse & {
  __typename?: 'GetSmsMessageByMessageSidSuccess';
  responseType: ResponseType | '%future added value';
  smsMessage?: Maybe<SmsMessage>;
};

export type GetSmsMessagesFromPhoneNumberResponse = AuthorizationFailure | GetSmsMessagesFromPhoneNumberSuccess;

export type GetSmsMessagesFromPhoneNumberSuccess = AppsyncResponse & {
  __typename?: 'GetSmsMessagesFromPhoneNumberSuccess';
  messages?: Maybe<Array<SmsMessage>>;
  responseType: ResponseType | '%future added value';
};

export type GetSubCatalogResponse = NotFoundError | SubCatalog;

export type GetSubCatalogsForChatResponse = AuthorizationFailure | ChatNotFoundError | GetSubCatalogsForChatResult;

export type GetSubCatalogsForChatResult = {
  __typename?: 'GetSubCatalogsForChatResult';
  subCatalogs: Array<SubCatalog>;
};

export type GetSuggestedProductsErrorResponse = AppsyncError & {
  __typename?: 'GetSuggestedProductsErrorResponse';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type GetSupplierApplicationsInput = {
  refId: Scalars['ID']['input'];
};

export type GetSupplierApplicationsResponse = AuthorizationFailure | InputValidationFailure | SupplierApplications;

export type GetSupplierProductsInput = {
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetSupplierProductsResponse = AuthorizationFailure | GetSupplierProductsResult;

export type GetSupplierProductsResult = {
  __typename?: 'GetSupplierProductsResult';
  invalidProducts?: Maybe<Array<InvalidProduct>>;
  products?: Maybe<Array<Product>>;
  productsNotFound?: Maybe<Array<Scalars['ID']['output']>>;
};

export type GetTransmissionBySesMessageIdInput = {
  sesMessageId: Scalars['ID']['input'];
};

export type GetTransmissionBySesMessageIdResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | Transmission;

export type GetTransmissionInput = {
  id: Scalars['ID']['input'];
};

export type GetTransmissionResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | Transmission;

export type GetUnconnectedBuyerIdsResult = NoUnconnectedBuyers | UnconnectedBuyers;

export type GetUploadedOrderResponse = AuthorizationFailure | GetUploadedOrderSuccess | InputValidationFailure;

export type GetUploadedOrderSuccess = {
  __typename?: 'GetUploadedOrderSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  uploadedOrder?: Maybe<UploadedOrder>;
};

/** Input for fetching welcome banner promotions in buyer apps */
export type GetWelcomeBannerPromosInput = {
  /** The buyer to fetch promotions for */
  buyerId: Scalars['ID']['input'];
  /** Supplier IDs to filter by. Mandatory for whitelabel apps. */
  supplierIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GetWelcomeBannerPromosResponse = AuthorizationFailure | GetWelcomeBannerPromosResult | InputValidationFailure | WelcomeBannerPromosNotFound;

/** Successful result for getWelcomeBannerPromos */
export type GetWelcomeBannerPromosResult = AppsyncResponse & {
  __typename?: 'GetWelcomeBannerPromosResult';
  /** Optional message providing additional context */
  message?: Maybe<Scalars['String']['output']>;
  /** Type of response returned */
  responseType: ResponseType | '%future added value';
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
  /** Up to 3 active welcome banner campaigns for the buyer, sorted by activatedAt DESC */
  welcomeBanners: Array<DistributorPromoWelcomeBanner>;
};

export type GetWhatsAppMessageByMessageSidResponse = AuthorizationFailure | GetWhatsAppMessageByMessageSidSuccess;

export type GetWhatsAppMessageByMessageSidSuccess = AppsyncResponse & {
  __typename?: 'GetWhatsAppMessageByMessageSidSuccess';
  responseType: ResponseType | '%future added value';
  whatsAppMessage?: Maybe<WhatsAppMessage>;
};

export type GooglePlaceEstablishment = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
};

/** Represents the details of a Google prospect photo. */
export type GoogleProspectPhotoDetails = {
  __typename?: 'GoogleProspectPhotoDetails';
  /** The reference to the photo. */
  resourceName: Scalars['String']['output'];
};

export type GroupIdsInput = {
  /** Id representing a delivery check reconciliation request */
  reconciliationRequestId?: InputMaybe<Scalars['String']['input']>;
};

export type HtmlAttachmentRef = {
  __typename?: 'HTMLAttachmentRef';
  omnichannelOrderId: Scalars['ID']['output'];
  selector?: Maybe<Scalars['String']['output']>;
  transmissionAttachmentId?: Maybe<Scalars['ID']['output']>;
  transmissionId?: Maybe<Scalars['ID']['output']>;
};

export type HasCompletedDeliveryCheckResult = {
  __typename?: 'HasCompletedDeliveryCheckResult';
  earliestOrderId?: Maybe<Scalars['ID']['output']>;
  hasCompletedDeliveryCheck: Scalars['Boolean']['output'];
  latestOrderId?: Maybe<Scalars['ID']['output']>;
};

export type HasUserCompletedDeliveryCheckResponse = AuthorizationFailure | HasCompletedDeliveryCheckResult | InputValidationFailure | OrderNotFound;

/**
 * Represents the lifecycle of a historicalOrdersPurge job.
 * Mirrors the `CatalogExportJob` union shape.
 */
export type HistoricalOrdersPurgeJob = HistoricalOrdersPurgeJobSucceeded | JobFailed | JobInProgress | JobQueued;

/** Represents a historicalOrdersPurge job that succeeded. */
export type HistoricalOrdersPurgeJobSucceeded = {
  __typename?: 'HistoricalOrdersPurgeJobSucceeded';
  /** Number of historical_order rows that were deleted. */
  deletedHistoricalOrderCount: Scalars['Int']['output'];
  /** Number of historical_ordered_product (line item) rows that were deleted. */
  deletedHistoricalOrderedProductCount: Scalars['Int']['output'];
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
};

/** Input for the `historicalOrdersPurgeStart` mutation. */
export type HistoricalOrdersPurgeStartInput = {
  /** The ID of the vendor whose historical orders should be purged. */
  vendorId: Scalars['ID']['input'];
};

export type HistoricalOrdersPurgeStartResponse = AuthorizationFailure | HistoricalOrdersPurgeStartResult | InputValidationFailure;

export type HistoricalOrdersPurgeStartResult = AppsyncResponse & {
  __typename?: 'HistoricalOrdersPurgeStartResult';
  /** The queued historicalOrdersPurge job. */
  job: HistoricalOrdersPurgeJob;
  /** Response type will always be set to `success`. */
  responseType: ResponseType | '%future added value';
};

export type HistoricalOrdersPurgeStatusResponse = AuthorizationFailure | HistoricalOrdersPurgeStatusResult | InputValidationFailure | NotFoundError;

export type HistoricalOrdersPurgeStatusResult = AppsyncResponse & {
  __typename?: 'HistoricalOrdersPurgeStatusResult';
  /** Current state of the historicalOrdersPurge job. */
  job: HistoricalOrdersPurgeJob;
  /** Response type will always be set to `success`. */
  responseType: ResponseType | '%future added value';
};

export const IgnoreEdits = {
  ProductId: 'productId',
  ProductQuantity: 'productQuantity'
} as const;

export type IgnoreEdits = typeof IgnoreEdits[keyof typeof IgnoreEdits];
export type ImageAsset = {
  __typename?: 'ImageAsset';
  /**
   * The resolver returns a read URL of the image asset for a given size and device pixel ratio.
   * The image is resized in the 'contain' mode, preserving the aspect-ratio, so the final image size might not match the requested size.
   * If none of the parameters are passed, the default size is returned.
   * In case of an error, null can be returned in which case the client should handle gracefully e.g. by falling back to a default broken image icon.
   */
  url?: Maybe<ImageAssetUrl>;
};


export type ImageAssetUrlArgs = {
  devicePixelRatio?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageAssetUrl = {
  __typename?: 'ImageAssetUrl';
  /** The URL of the image asset */
  url: Scalars['AWSURL']['output'];
};

export type ImageAttachmentRef = {
  __typename?: 'ImageAttachmentRef';
  boundingBox: BoundingBox;
  omnichannelOrderId: Scalars['ID']['output'];
  transmissionAttachmentId?: Maybe<Scalars['ID']['output']>;
  transmissionId?: Maybe<Scalars['ID']['output']>;
};

export type ImportSupplierProductsReport = {
  __typename?: 'ImportSupplierProductsReport';
  /** Number of products that will be disabled */
  disabled?: Maybe<Scalars['Int']['output']>;
  /** Number of products that have failed validation */
  invalid?: Maybe<Scalars['Int']['output']>;
  /** Number of products that will be created */
  new?: Maybe<Scalars['Int']['output']>;
  /** Number of products that will not be affected */
  unchanged?: Maybe<Scalars['Int']['output']>;
  /** Number of products that will be updated */
  updated?: Maybe<Scalars['Int']['output']>;
};

export type InitiateAccountLinkingError = AppsyncError & AppsyncResponse & {
  __typename?: 'InitiateAccountLinkingError';
  errorCode?: Maybe<InitiateAccountLinkingErrorCode | '%future added value'>;
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export const InitiateAccountLinkingErrorCode = {
  AlreadyLinked: 'ALREADY_LINKED',
  OtpSendFailure: 'OTP_SEND_FAILURE',
  PhoneNumberInvalid: 'PHONE_NUMBER_INVALID',
  TargetAccountNotFound: 'TARGET_ACCOUNT_NOT_FOUND',
  UserNotFound: 'USER_NOT_FOUND'
} as const;

export type InitiateAccountLinkingErrorCode = typeof InitiateAccountLinkingErrorCode[keyof typeof InitiateAccountLinkingErrorCode];
export type InitiateAccountLinkingInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InitiateAccountLinkingResponse = AuthorizationFailure | InitiateAccountLinkingError | InitiateAccountLinkingSuccess | InputValidationFailure;

export type InitiateAccountLinkingSuccess = {
  __typename?: 'InitiateAccountLinkingSuccess';
  message?: Maybe<Scalars['String']['output']>;
};

export type InputValidationFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'InputValidationFailure';
  invalidFields?: Maybe<Array<FieldValidationError>>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type InsertOrUpdateSupplierContactInput = {
  /**  Chat ID which owns the contact  */
  chatId: Scalars['String']['input'];
  /**  Email of the contact  */
  email: Scalars['AWSEmail']['input'];
  /**  Name of the contact  */
  name?: InputMaybe<Scalars['String']['input']>;
  /**  ID of the owner of the contact  */
  supplierId: Scalars['ID']['input'];
};

export type InsertOrUpdateSupplierContactResponse = AuthorizationFailure | CustomerContact | InputValidationFailure;

export const InsightsStatus = {
  Fall: 'fall',
  Growth: 'growth',
  Unchanged: 'unchanged'
} as const;

export type InsightsStatus = typeof InsightsStatus[keyof typeof InsightsStatus];
export type InstantPayCustomerAlreadyOnboardedFailure = {
  __typename?: 'InstantPayCustomerAlreadyOnboardedFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type InstantPayCustomerInvitationSendFailure = {
  __typename?: 'InstantPayCustomerInvitationSendFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type InstantPayCustomerInvitationSendInput = {
  invitationType?: InputMaybe<InstantPayCustomerInvitationType | '%future added value'>;
  paymentCustomerId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

export type InstantPayCustomerInvitationSendResponse = AuthorizationFailure | InputValidationFailure | InstantPayCustomerInvitationSendFailure | InstantPayCustomerInvitationSendSuccess;

export type InstantPayCustomerInvitationSendSuccess = {
  __typename?: 'InstantPayCustomerInvitationSendSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export const InstantPayCustomerInvitationType = {
  AccountBuilder: 'ACCOUNT_BUILDER',
  UserVerification: 'USER_VERIFICATION'
} as const;

export type InstantPayCustomerInvitationType = typeof InstantPayCustomerInvitationType[keyof typeof InstantPayCustomerInvitationType];
export type InstantPayCustomerOnboardFailure = {
  __typename?: 'InstantPayCustomerOnboardFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type InstantPayCustomerOnboardInput = {
  customerDetails: PaymentCustomerDetailsInput;
  legalEntityDetails: LegalEntityDetailsInput;
  options?: InputMaybe<InstantPayProfileOptionsInput>;
  profileDetails: InstantPayProfileDetailsInput;
  vendorId: Scalars['ID']['input'];
};

export type InstantPayCustomerOnboardResponse = AuthorizationFailure | InputValidationFailure | InstantPayCustomerAlreadyOnboardedFailure | InstantPayCustomerOnboardFailure | InstantPayCustomerOnboardSuccess | LegalEntityAlreadyExistsFailure;

export type InstantPayCustomerOnboardSuccess = {
  __typename?: 'InstantPayCustomerOnboardSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type InstantPayProfileDetailsInput = {
  /** The ERP customer number */
  chatCustomerNumber: Scalars['String']['input'];
  chatId: Scalars['ID']['input'];
  paymentTerms?: InputMaybe<InstantPayVendorConfigPaymentTermInput>;
};

export type InstantPayProfileOptionsInput = {
  sendInvitationEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export const InstantPayTermSchedule = {
  Biweekly: 'BIWEEKLY',
  Daily: 'DAILY',
  Monthly: 'MONTHLY',
  Weekly: 'WEEKLY'
} as const;

export type InstantPayTermSchedule = typeof InstantPayTermSchedule[keyof typeof InstantPayTermSchedule];
export type InstantPayVendorConfig = {
  __typename?: 'InstantPayVendorConfig';
  allowedPaymentTerms: Array<InstantPayVendorConfigPaymentTerm>;
};

export type InstantPayVendorConfigPaymentTerm = {
  __typename?: 'InstantPayVendorConfigPaymentTerm';
  dueInDays: Scalars['Int']['output'];
  schedule: InstantPayTermSchedule | '%future added value';
};

export type InstantPayVendorConfigPaymentTermInput = {
  dueInDays: Scalars['Int']['input'];
  schedule: InstantPayTermSchedule | '%future added value';
};

export type InstantPaymentCustomerProfile = {
  __typename?: 'InstantPaymentCustomerProfile';
  chatCustomerNumber: Scalars['String']['output'];
  lastStatusUpdate: Scalars['AWSTimestamp']['output'];
  status: InstantPaymentProfileStatus | '%future added value';
};

export const InstantPaymentProfileStatus = {
  Active: 'ACTIVE',
  Declined: 'DECLINED',
  Disabled: 'DISABLED',
  OnHold: 'ON_HOLD',
  PendingVerification: 'PENDING_VERIFICATION',
  RiskOfAccountHold: 'RISK_OF_ACCOUNT_HOLD'
} as const;

export type InstantPaymentProfileStatus = typeof InstantPaymentProfileStatus[keyof typeof InstantPaymentProfileStatus];
export type IntegrationAdapterApiKeyAuth = {
  __typename?: 'IntegrationAdapterAPIKeyAuth';
  apiKey: Scalars['String']['output'];
  type: IntegrationAdapterAuthenticationType | '%future added value';
};

export type IntegrationAdapterApiKeyAuthBase = {
  __typename?: 'IntegrationAdapterAPIKeyAuthBase';
  type: IntegrationAdapterAuthenticationType | '%future added value';
};

export type IntegrationAdapterAdminResult = Node & {
  __typename?: 'IntegrationAdapterAdminResult';
  actionExportDeadlineMinutes?: Maybe<Scalars['Int']['output']>;
  actionExportMethod?: Maybe<ActionExportMethod | '%future added value'>;
  auth: IntegrationAdapterAuth;
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scope: Array<Maybe<Scalars['String']['output']>>;
  type: IntegrationAdapterType | '%future added value';
  updatedAt: Scalars['AWSTimestamp']['output'];
  webhook?: Maybe<IntegrationAdapterWebhook>;
};

export type IntegrationAdapterAdminResultConnection = Connection & {
  __typename?: 'IntegrationAdapterAdminResultConnection';
  edges: Array<IntegrationAdapterAdminResultEdge>;
};

export type IntegrationAdapterAdminResultEdge = Edge & {
  __typename?: 'IntegrationAdapterAdminResultEdge';
  cursor: Scalars['String']['output'];
  node: IntegrationAdapterAdminResult;
};

export type IntegrationAdapterAuth = IntegrationAdapterApiKeyAuth | IntegrationAdapterAuthorizationCodeAuth | IntegrationAdapterClientCredentialsAuth;

export type IntegrationAdapterAuthBase = IntegrationAdapterApiKeyAuthBase | IntegrationAdapterAuthorizationCodeAuthBase | IntegrationAdapterClientCredentialsAuthBase;

export type IntegrationAdapterAuthInput = {
  /**  TODO: remove apiKey after MVP  */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  connectUrl?: InputMaybe<Scalars['String']['input']>;
  redirectUrls?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signoutUrl?: InputMaybe<Scalars['String']['input']>;
  type: IntegrationAdapterAuthenticationType | '%future added value';
};

export const IntegrationAdapterAuthenticationType = {
  ApiKey: 'API_KEY',
  AuthorizationCode: 'AUTHORIZATION_CODE',
  ClientCredentials: 'CLIENT_CREDENTIALS'
} as const;

export type IntegrationAdapterAuthenticationType = typeof IntegrationAdapterAuthenticationType[keyof typeof IntegrationAdapterAuthenticationType];
export type IntegrationAdapterAuthorizationCodeAuth = {
  __typename?: 'IntegrationAdapterAuthorizationCodeAuth';
  connectUrl: Scalars['String']['output'];
  redirectUrls: Array<Maybe<Scalars['String']['output']>>;
  secret: Scalars['String']['output'];
  signoutUrl: Scalars['String']['output'];
  type: IntegrationAdapterAuthenticationType | '%future added value';
};

export type IntegrationAdapterAuthorizationCodeAuthBase = {
  __typename?: 'IntegrationAdapterAuthorizationCodeAuthBase';
  connectUrl: Scalars['String']['output'];
  redirectUrls: Array<Scalars['String']['output']>;
  signoutUrl: Scalars['String']['output'];
  type: IntegrationAdapterAuthenticationType | '%future added value';
};

export type IntegrationAdapterBaseResult = Node & {
  __typename?: 'IntegrationAdapterBaseResult';
  actionExportDeadlineMinutes?: Maybe<Scalars['Int']['output']>;
  actionExportMethod?: Maybe<ActionExportMethod | '%future added value'>;
  auth: IntegrationAdapterAuthBase;
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  scope: Array<Maybe<Scalars['String']['output']>>;
  type: IntegrationAdapterType | '%future added value';
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type IntegrationAdapterBaseResultConnection = Connection & {
  __typename?: 'IntegrationAdapterBaseResultConnection';
  edges: Array<IntegrationAdapterBaseResultEdge>;
};

export type IntegrationAdapterBaseResultEdge = Edge & {
  __typename?: 'IntegrationAdapterBaseResultEdge';
  cursor: Scalars['String']['output'];
  node: IntegrationAdapterBaseResult;
};

export type IntegrationAdapterClientCredentialsAuth = {
  __typename?: 'IntegrationAdapterClientCredentialsAuth';
  secret: Scalars['String']['output'];
  type: IntegrationAdapterAuthenticationType | '%future added value';
};

export type IntegrationAdapterClientCredentialsAuthBase = {
  __typename?: 'IntegrationAdapterClientCredentialsAuthBase';
  type: IntegrationAdapterAuthenticationType | '%future added value';
};

export type IntegrationAdapterConnectionAdminResult = Node & {
  __typename?: 'IntegrationAdapterConnectionAdminResult';
  actionExportDeadlineMinutes?: Maybe<Scalars['Int']['output']>;
  actionExportMethod?: Maybe<ActionExportMethod | '%future added value'>;
  adapterId: Scalars['ID']['output'];
  chocoEntityId: Scalars['ID']['output'];
  chocoEntityType: ChocoEntityType | '%future added value';
  createdAt: Scalars['AWSTimestamp']['output'];
  creatorUserId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  scope?: Maybe<Array<Scalars['String']['output']>>;
  status: IntegrationAdapterConnectionStatus | '%future added value';
  updatedAt: Scalars['AWSTimestamp']['output'];
  webhook?: Maybe<IntegrationAdapterConnectionWebhook>;
  webhookFields?: Maybe<IntegrationAdapterConnectionWebhookFields>;
};

export type IntegrationAdapterConnectionAdminResultConnection = Connection & {
  __typename?: 'IntegrationAdapterConnectionAdminResultConnection';
  edges: Array<IntegrationAdapterConnectionAdminResultEdge>;
};

export type IntegrationAdapterConnectionAdminResultEdge = Edge & {
  __typename?: 'IntegrationAdapterConnectionAdminResultEdge';
  cursor: Scalars['String']['output'];
  node: IntegrationAdapterConnectionAdminResult;
};

export type IntegrationAdapterConnectionAuthInput = {
  loginChallenge: Scalars['String']['input'];
};

export type IntegrationAdapterConnectionAuthRedirect = {
  __typename?: 'IntegrationAdapterConnectionAuthRedirect';
  redirectUrl: Scalars['String']['output'];
};

export type IntegrationAdapterConnectionAuthResponse = AuthorizationFailure | InputValidationFailure | IntegrationAdapterConnectionAuthRedirect;

export type IntegrationAdapterConnectionBaseResult = Node & {
  __typename?: 'IntegrationAdapterConnectionBaseResult';
  actionExportDeadlineMinutes?: Maybe<Scalars['Int']['output']>;
  actionExportMethod?: Maybe<ActionExportMethod | '%future added value'>;
  adapterId: Scalars['ID']['output'];
  authorizationCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  scope?: Maybe<Array<Scalars['String']['output']>>;
  status: IntegrationAdapterConnectionStatus | '%future added value';
  updatedAt: Scalars['AWSTimestamp']['output'];
  webhookFields?: Maybe<IntegrationAdapterConnectionWebhookFields>;
};

export type IntegrationAdapterConnectionBaseResultConnection = Connection & {
  __typename?: 'IntegrationAdapterConnectionBaseResultConnection';
  edges: Array<IntegrationAdapterConnectionBaseResultEdge>;
};

export type IntegrationAdapterConnectionBaseResultEdge = Edge & {
  __typename?: 'IntegrationAdapterConnectionBaseResultEdge';
  cursor: Scalars['String']['output'];
  node: IntegrationAdapterConnectionBaseResult;
};

export type IntegrationAdapterConnectionConsentChallenge = {
  __typename?: 'IntegrationAdapterConnectionConsentChallenge';
  adapterId: Scalars['String']['output'];
  consentChallenge: Scalars['String']['output'];
  requestedScopes: Array<Scalars['String']['output']>;
};

export type IntegrationAdapterConnectionConsentInput = {
  consentChallenge: Scalars['String']['input'];
  grantedScopes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type IntegrationAdapterConnectionConsentRedirect = {
  __typename?: 'IntegrationAdapterConnectionConsentRedirect';
  connectionId: Scalars['String']['output'];
  redirectUrl: Scalars['String']['output'];
};

export type IntegrationAdapterConnectionConsentResponse = AuthorizationFailure | InputValidationFailure | IntegrationAdapterConnectionConsentChallenge | IntegrationAdapterConnectionConsentRedirect;

export type IntegrationAdapterConnectionCreateInput = {
  actionExportDeadlineMinutes?: InputMaybe<Scalars['Int']['input']>;
  actionExportMethod?: InputMaybe<ActionExportMethod | '%future added value'>;
  adapterId: Scalars['ID']['input'];
  chocoEntityId: Scalars['ID']['input'];
  chocoEntityType: ChocoEntityType | '%future added value';
  scope: Array<Scalars['String']['input']>;
  webhookDeliveryUrl?: InputMaybe<Scalars['String']['input']>;
  webhookFields?: InputMaybe<IntegrationAdapterConnectionWebhookFieldsInput>;
};

export type IntegrationAdapterConnectionCreateResponse = AuthorizationFailure | ChocoEntityNotFound | InputValidationFailure | IntegrationAdapterConnectionAdminResult | IntegrationAdapterNotFound | IntegrationAdapterScopeInsufficient | UnsupportedIntegrationAdapterType;

export type IntegrationAdapterConnectionNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'IntegrationAdapterConnectionNotFound';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export const IntegrationAdapterConnectionStatus = {
  /**  Connection is live and operational. Can transition to DISCONNECTED or ERROR  */
  Connected: 'CONNECTED',
  /**  Connection was disconnected by user. Final state  */
  Disconnected: 'DISCONNECTED',
  /**  There is a problem with this connection and it needs to be reconnected. Final state  */
  Error: 'ERROR',
  /**  Connection was stuck in a pending state for too long. Final state  */
  Expired: 'EXPIRED',
  /**  Connection has been initiated but has not finished yet. Can transition to any other state  */
  Pending: 'PENDING'
} as const;

export type IntegrationAdapterConnectionStatus = typeof IntegrationAdapterConnectionStatus[keyof typeof IntegrationAdapterConnectionStatus];
export type IntegrationAdapterConnectionUpdateInput = {
  actionExportDeadlineMinutes?: InputMaybe<Scalars['Int']['input']>;
  actionExportMethod?: InputMaybe<ActionExportMethod | '%future added value'>;
  id: Scalars['ID']['input'];
  scope?: InputMaybe<Array<Scalars['String']['input']>>;
  scopeAdd?: InputMaybe<Array<Scalars['String']['input']>>;
  webhookDeliveryUrl?: InputMaybe<Scalars['String']['input']>;
  webhookFields?: InputMaybe<IntegrationAdapterConnectionWebhookFieldsInput>;
};

export type IntegrationAdapterConnectionUpdateResponse = AuthorizationFailure | InputValidationFailure | IntegrationAdapterConnectionAdminResult | IntegrationAdapterConnectionNotFound | IntegrationAdapterScopeInsufficient;

export type IntegrationAdapterConnectionWebhook = {
  __typename?: 'IntegrationAdapterConnectionWebhook';
  deliveryUrl: Scalars['String']['output'];
};

export type IntegrationAdapterConnectionWebhookFields = {
  __typename?: 'IntegrationAdapterConnectionWebhookFields';
  orderCreated?: Maybe<IntegrationAdapterConnectionWebhookFieldsOrderEvent>;
  orderUpdated?: Maybe<IntegrationAdapterConnectionWebhookFieldsOrderEvent>;
};

export type IntegrationAdapterConnectionWebhookFieldsInput = {
  orderCreated?: InputMaybe<IntegrationAdapterConnectionWebhookFieldsOrderEventInput>;
  orderUpdated?: InputMaybe<IntegrationAdapterConnectionWebhookFieldsOrderEventInput>;
};

export type IntegrationAdapterConnectionWebhookFieldsOrder = {
  __typename?: 'IntegrationAdapterConnectionWebhookFieldsOrder';
  products?: Maybe<IntegrationAdapterConnectionWebhookFieldsOrderProducts>;
};

export type IntegrationAdapterConnectionWebhookFieldsOrderEvent = {
  __typename?: 'IntegrationAdapterConnectionWebhookFieldsOrderEvent';
  order?: Maybe<IntegrationAdapterConnectionWebhookFieldsOrder>;
};

export type IntegrationAdapterConnectionWebhookFieldsOrderEventInput = {
  order?: InputMaybe<IntegrationAdapterConnectionWebhookFieldsOrderInput>;
};

export type IntegrationAdapterConnectionWebhookFieldsOrderInput = {
  products?: InputMaybe<IntegrationAdapterConnectionWebhookFieldsOrderProductsInput>;
};

export type IntegrationAdapterConnectionWebhookFieldsOrderProducts = {
  __typename?: 'IntegrationAdapterConnectionWebhookFieldsOrderProducts';
  description?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationAdapterConnectionWebhookFieldsOrderProductsInput = {
  description?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IntegrationAdapterCreateInput = {
  actionExportDeadlineMinutes?: InputMaybe<Scalars['Int']['input']>;
  actionExportMethod?: InputMaybe<ActionExportMethod | '%future added value'>;
  auth: IntegrationAdapterAuthInput;
  developerName?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  scope: Array<Scalars['String']['input']>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
  type: IntegrationAdapterType | '%future added value';
  webhook?: InputMaybe<IntegrationAdapterCreateWebhookInput>;
};

export type IntegrationAdapterCreateResponse = AuthorizationFailure | InputValidationFailure | IntegrationAdapterAdminResult | IntegrationAdapterExists;

export type IntegrationAdapterCreateWebhookInput = {
  auth: WebhookAuthenticationInput;
  deliveryUrl: Scalars['String']['input'];
};

export type IntegrationAdapterExists = AppsyncError & AppsyncResponse & {
  __typename?: 'IntegrationAdapterExists';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type IntegrationAdapterNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'IntegrationAdapterNotFound';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type IntegrationAdapterScopeInsufficient = AppsyncError & AppsyncResponse & {
  __typename?: 'IntegrationAdapterScopeInsufficient';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export const IntegrationAdapterType = {
  Custom: 'CUSTOM',
  Plugin: 'PLUGIN'
} as const;

export type IntegrationAdapterType = typeof IntegrationAdapterType[keyof typeof IntegrationAdapterType];
export type IntegrationAdapterUpdateInput = {
  actionExportDeadlineMinutes?: InputMaybe<Scalars['Int']['input']>;
  actionExportMethod?: InputMaybe<ActionExportMethod | '%future added value'>;
  auth?: InputMaybe<IntegrationAdapterAuthInput>;
  developerName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Array<Scalars['String']['input']>>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
  webhook?: InputMaybe<IntegrationAdapterUpdateWebhookInput>;
};

export type IntegrationAdapterUpdateResponse = AttemptToChangeAdapterAuthType | AttemptToReduceIntegrationAdapterScope | AuthorizationFailure | InputValidationFailure | IntegrationAdapterAdminResult | IntegrationAdapterNotFound;

export type IntegrationAdapterUpdateWebhookInput = {
  auth?: InputMaybe<WebhookAuthenticationInput>;
  deliveryUrl?: InputMaybe<Scalars['String']['input']>;
};

export type IntegrationAdapterWebhook = {
  __typename?: 'IntegrationAdapterWebhook';
  auth: IntegrationAdapterWebhookAuth;
  deliveryUrl: Scalars['String']['output'];
};

export type IntegrationAdapterWebhookAuth = IntegrationAdapterWebhookBasicAuth | IntegrationAdapterWebhookSignatureAuth;

export type IntegrationAdapterWebhookBasicAuth = {
  __typename?: 'IntegrationAdapterWebhookBasicAuth';
  password: Scalars['String']['output'];
  type: WebhookAuthenticationType | '%future added value';
  username: Scalars['String']['output'];
};

export type IntegrationAdapterWebhookSignatureAuth = {
  __typename?: 'IntegrationAdapterWebhookSignatureAuth';
  token: Scalars['String']['output'];
  type: WebhookAuthenticationType | '%future added value';
};

export type IntegrationEmailOption = {
  __typename?: 'IntegrationEmailOption';
  complaintEmails?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated emailAddress is deprecated and will be removed in the future; use complaintEmails, orderEmails or messageEmails */
  emailAddress?: Maybe<Scalars['String']['output']>;
  messageEmails?: Maybe<Array<Scalars['String']['output']>>;
  orderEmails?: Maybe<Array<Scalars['String']['output']>>;
  pdf: Scalars['Boolean']['output'];
  type: IntegrationType | '%future added value';
  xlsx: Scalars['Boolean']['output'];
};

export type IntegrationEmailOptionInput = {
  complaintEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** @deprecated emailAddress is deprecated and will be removed in the future; use complaintEmails, orderEmails or messageEmails */
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  messageEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  orderEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  pdf: Scalars['Boolean']['input'];
  type: IntegrationType | '%future added value';
  xlsx: Scalars['Boolean']['input'];
};

export type IntegrationEntityIdentity = {
  __typename?: 'IntegrationEntityIdentity';
  appName: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  type: IntegrationEntityIdentityType | '%future added value';
};

export const IntegrationEntityIdentityType = {
  Integration: 'integration'
} as const;

export type IntegrationEntityIdentityType = typeof IntegrationEntityIdentityType[keyof typeof IntegrationEntityIdentityType];
export type IntegrationFaxOption = {
  __typename?: 'IntegrationFaxOption';
  phone: Scalars['String']['output'];
  type: IntegrationType | '%future added value';
};

export type IntegrationFaxOptionInput = {
  phone: Scalars['String']['input'];
  type: IntegrationType | '%future added value';
};

export type IntegrationOption = IntegrationEmailOption | IntegrationFaxOption | IntegrationSmsOption | IntegrationWhatsAppOption;

export type IntegrationOptionInput = {
  email?: InputMaybe<IntegrationEmailOptionInput>;
  /** @deprecated fax is no longer supported */
  fax?: InputMaybe<IntegrationFaxOptionInput>;
  sms?: InputMaybe<IntegrationSmsOptionInput>;
  whatsApp?: InputMaybe<IntegrationWhatsAppOptionInput>;
};

export type IntegrationSmsOption = {
  __typename?: 'IntegrationSmsOption';
  phone: Scalars['String']['output'];
  type: IntegrationType | '%future added value';
};

export type IntegrationSmsOptionInput = {
  phone: Scalars['String']['input'];
  type: IntegrationType | '%future added value';
};

export const IntegrationType = {
  Email: 'email',
  Fax: 'fax',
  Sms: 'sms',
  WhatsApp: 'whatsApp'
} as const;

export type IntegrationType = typeof IntegrationType[keyof typeof IntegrationType];
export type IntegrationWebhookRetryFailure = {
  __typename?: 'IntegrationWebhookRetryFailure';
  entitySyncActionId: Scalars['ID']['output'];
  errorCode: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
};

export type IntegrationWebhookRetryInput = {
  entitySyncActionIds: Array<Scalars['ID']['input']>;
};

export type IntegrationWebhookRetryResponse = AuthorizationFailure | InputValidationFailure | IntegrationWebhookRetryResults;

export type IntegrationWebhookRetryResult = IntegrationWebhookRetryFailure | IntegrationWebhookRetrySuccess;

export type IntegrationWebhookRetryResults = {
  __typename?: 'IntegrationWebhookRetryResults';
  results: Array<IntegrationWebhookRetryResult>;
};

export type IntegrationWebhookRetrySuccess = {
  __typename?: 'IntegrationWebhookRetrySuccess';
  entitySyncActionId: Scalars['ID']['output'];
};

export type IntegrationWhatsAppOption = {
  __typename?: 'IntegrationWhatsAppOption';
  phone: Scalars['String']['output'];
  type: IntegrationType | '%future added value';
};

export type IntegrationWhatsAppOptionInput = {
  phone: Scalars['String']['input'];
  type: IntegrationType | '%future added value';
};

export type InternalEntityIdentity = {
  __typename?: 'InternalEntityIdentity';
  type?: Maybe<InternalEntityIdentityType | '%future added value'>;
  userId: Scalars['String']['output'];
};

export const InternalEntityIdentityType = {
  User: 'user'
} as const;

export type InternalEntityIdentityType = typeof InternalEntityIdentityType[keyof typeof InternalEntityIdentityType];
export type InternalInviteUsersResponse = AuthorizationFailure | UsersList | ValidationError;

export type InternalServerError = {
  __typename?: 'InternalServerError';
  message: Scalars['String']['output'];
};

export type InvalidCursor = AppsyncError & AppsyncResponse & {
  __typename?: 'InvalidCursor';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type InvalidInvitedPhoneNumber = AppsyncError & AppsyncResponse & {
  __typename?: 'InvalidInvitedPhoneNumber';
  message?: Maybe<Scalars['String']['output']>;
  phoneNumber: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type InvalidProduct = {
  __typename?: 'InvalidProduct';
  id: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export const InvalidProductValidationCode = {
  /**
   * The catalog returned the product without a resolved price. WARNING for every
   * supplier: the line stays in the cart with null pricing, is excluded from
   * promotions, tax, delivery fee and cart totals, and the order can still be
   * placed with it unpriced.
   */
  MissingPrice: 'MISSING_PRICE',
  /**
   * The vendorItemUnitId could not be resolved in the supplier catalog for this
   * chat. Excluded from evaluation. Blocks commit.
   */
  NotFound: 'NOT_FOUND'
} as const;

export type InvalidProductValidationCode = typeof InvalidProductValidationCode[keyof typeof InvalidProductValidationCode];
/**
 * A paid cart line whose product cannot be ordered as sent. Distinct from stock
 * (the product may exist and be in stock) and from minimum orderable quantity.
 * One entry per failing paid line, not overrideable on any channel. The status
 * depends on the code: NOT_FOUND is BLOCKED and the buyer removes the line;
 * MISSING_PRICE is a WARNING for every supplier; the line stays and the order
 * can be placed.
 */
export type InvalidProductValidationResult = CartValidationResult & {
  __typename?: 'InvalidProductValidationResult';
  /** Why the product is invalid. */
  code: InvalidProductValidationCode | '%future added value';
  overriddenBy?: Maybe<Scalars['String']['output']>;
  overrideable: Scalars['Boolean']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  source: ValidationSource | '%future added value';
  status: ValidationStatus | '%future added value';
  /**
   * Cart line vendorItemUnitId (join key). For MISSING_PRICE the EvaluatedLine
   * is still returned with null pricing so the client can render the row. For
   * NOT_FOUND there is no EvaluatedLine: nothing could be resolved to price.
   */
  vendorItemUnitId: Scalars['ID']['output'];
};

export type InvalidProductsFailure = {
  __typename?: 'InvalidProductsFailure';
  message: Scalars['String']['output'];
  productIds: Array<Scalars['String']['output']>;
};

export type InvalidSubCatalogChat = {
  __typename?: 'InvalidSubCatalogChat';
  chatId: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  subCatalogId: Scalars['ID']['output'];
};

export type InvalidateMagicCodeInput = {
  /** The magic code to invalidate (case-insensitive). */
  code: Scalars['String']['input'];
};

export type InvalidateMagicCodeResponse = AuthorizationFailure | InputValidationFailure | InvalidateMagicCodeResult | InvalidateMagicCodeUnexpectedError | MagicCodeNotFoundError;

export type InvalidateMagicCodeResult = AppsyncResponse & {
  __typename?: 'InvalidateMagicCodeResult';
  /** Response type will always be set to success */
  responseType: ResponseType | '%future added value';
  /** Whether the invalidation was successful */
  success: Scalars['Boolean']['output'];
};

/**
 * Returned when an unexpected error occurs during magic code invalidation.
 * Use this as a fallback error type for proper error handling.
 */
export type InvalidateMagicCodeUnexpectedError = AppsyncError & AppsyncResponse & {
  __typename?: 'InvalidateMagicCodeUnexpectedError';
  /** A human-readable message describing the error */
  message: Scalars['String']['output'];
  /** Response type will always be set to error */
  responseType: ResponseType | '%future added value';
};

export const InviteChannel = {
  Email: 'Email',
  Sms: 'SMS',
  Whatsapp: 'Whatsapp'
} as const;

export type InviteChannel = typeof InviteChannel[keyof typeof InviteChannel];
export type InviteInfo = {
  __typename?: 'InviteInfo';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  googleFullAddress?: Maybe<Scalars['String']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  googlePlaceName?: Maybe<Scalars['String']['output']>;
  inviterUserId?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export const InviteStatus = {
  Delivered: 'delivered',
  Failed: 'failed',
  Initiated: 'initiated',
  Sent: 'sent'
} as const;

export type InviteStatus = typeof InviteStatus[keyof typeof InviteStatus];
export type InviteTransmission = Node & {
  __typename?: 'InviteTransmission';
  channel: InviteChannel | '%future added value';
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  invitedToEntityId: Scalars['String']['output'];
  inviteeEntityId?: Maybe<Scalars['String']['output']>;
  inviteeEntityName?: Maybe<Scalars['String']['output']>;
  inviteeId: Scalars['String']['output'];
  inviteeName?: Maybe<Scalars['String']['output']>;
  invitorEntityName: Scalars['String']['output'];
  invitorId?: Maybe<Scalars['String']['output']>;
  invitorUserName?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  status: InviteStatus | '%future added value';
  to?: Maybe<Scalars['String']['output']>;
  transmissionEvents: Array<TransmissionEvent>;
};

export type InviteTransmissionStatus = {
  __typename?: 'InviteTransmissionStatus';
  inviteStatus?: Maybe<InviteStatus | '%future added value'>;
};

export type InviteUserToBuyerError = AppsyncError & AppsyncResponse & {
  __typename?: 'InviteUserToBuyerError';
  errorCode?: Maybe<InviteUserToBuyerErrorCode | '%future added value'>;
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export const InviteUserToBuyerErrorCode = {
  GenericError: 'genericError',
  UserIsASupplierError: 'userIsASupplierError',
  UserIsAlreadyConnectedToBuyerError: 'userIsAlreadyConnectedToBuyerError'
} as const;

export type InviteUserToBuyerErrorCode = typeof InviteUserToBuyerErrorCode[keyof typeof InviteUserToBuyerErrorCode];
export type InviteUserToBuyerInput = {
  /** role can be any of buyerAdmin, buyerStaff or buyerViewer */
  role: Scalars['String']['input'];
};

export type InviteUserToBuyerInputV2 = {
  /** List of buyer chats to add the user to */
  chatIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  /** role can be any of buyerAdmin, buyerStaff or buyerViewer */
  role: Scalars['String']['input'];
};

export type InviteUserToBuyerResponse = AuthorizationFailure | BuyerUser | InputValidationFailure | InviteUserToBuyerError;

export type InviteeBuyers = {
  __typename?: 'InviteeBuyers';
  /** User Id of Invitee */
  id: Scalars['ID']['output'];
  /**
   * Invitee Buyers which the invitor does not have a chat with
   * Param first: number of user's buyers to check for connections
   * Param after: pagination cursor from UserBuyerEdge
   */
  unconnectedBuyers: UserBuyerConnection;
};


export type InviteeBuyersUnconnectedBuyersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Error thrown by getInviteeBuyers when user is not found
 * Be sure to always implement AppsyncError when creating
 * Error type
 */
export type InviteeNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'InviteeNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type InvitorNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'InvitorNotFound';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type Invoice = Node & {
  __typename?: 'Invoice';
  attachment: InvoiceAttachment;
  /** @deprecated use attachment.status instead */
  attachmentState: AttachmentState | '%future added value';
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  issueDate: Scalars['AWSTimestamp']['output'];
  modifiedAt: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /**
   * Possible values:
   *   - none
   *   - paid
   *   - scheduled
   *   - processing
   *   - failed
   *   - canceled
   *   - returned
   */
  paymentStatus: Scalars['String']['output'];
  paymentTerms: Scalars['AWSTimestamp']['output'];
  /** @deprecated use attachment instead */
  pdfAttachment: InvoiceFileUrls;
  /** total amount of invoice in cents */
  total: Scalars['Int']['output'];
  uploadedAt: Scalars['String']['output'];
};

export type InvoiceAddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  organizationName?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type InvoiceAlreadyExistsFailure = {
  __typename?: 'InvoiceAlreadyExistsFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type InvoiceAttachment = {
  __typename?: 'InvoiceAttachment';
  /** signed url to download attachment */
  downloadUrl: Scalars['String']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  /** status of attachment */
  status: AttachmentStatus | '%future added value';
  /** signed url to upload attachment */
  uploadUrl: Scalars['String']['output'];
};

export type InvoiceBillingDocument = BillingDocument & {
  __typename?: 'InvoiceBillingDocument';
  buyerPaymentStatus: InvoiceBuyerPaymentStatus | '%future added value';
  customer: BillingDocumentCustomer;
  dueAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  issuedAt: Scalars['AWSTimestamp']['output'];
  totalGrossAmount: MoneyV2;
  vendor: BillingDocumentVendor;
  vendorPaymentStatus: InvoiceVendorPaymentStatus | '%future added value';
};

export const InvoiceBuyerPaymentStatus = {
  NotPaid: 'NOT_PAID',
  Paid: 'PAID',
  Processing: 'PROCESSING',
  Unknown: 'UNKNOWN'
} as const;

export type InvoiceBuyerPaymentStatus = typeof InvoiceBuyerPaymentStatus[keyof typeof InvoiceBuyerPaymentStatus];
export type InvoiceCreateFailure = {
  __typename?: 'InvoiceCreateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type InvoiceCreateInput = {
  buyerId: Scalars['ID']['input'];
  dueAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  invoiceNumber: Scalars['String']['input'];
  issuedAt: Scalars['AWSTimestamp']['input'];
  items: Array<InvoiceLineItemInput>;
  orderReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  shippedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  shippingAddress: InvoiceAddressInput;
  taxSubtotals: Array<InvoiceTaxSubtotalInput>;
  totalGrossAmount: MoneyV2Input;
  totalNetAmount: MoneyV2Input;
  totalTaxAmount: MoneyV2Input;
  vendorId: Scalars['ID']['input'];
};

export type InvoiceCreateResponse = AuthorizationFailure | InputValidationFailure | InvoiceAlreadyExistsFailure | InvoiceCreateFailure | InvoiceCreateSuccess;

export type InvoiceCreateSuccess = {
  __typename?: 'InvoiceCreateSuccess';
  invoiceId: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type InvoiceFileUrls = {
  __typename?: 'InvoiceFileUrls';
  pdfUploadUrl: Scalars['String']['output'];
  pdfUrl?: Maybe<Scalars['String']['output']>;
};

export type InvoiceLineItemDiscountInput = {
  amount: MoneyV2Input;
};

export type InvoiceLineItemInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<InvoiceLineItemDiscountInput>;
  grossAmount: MoneyV2Input;
  name: Scalars['String']['input'];
  netAmount: MoneyV2Input;
  position: Scalars['Int']['input'];
  productRef: InvoiceProductRefInput;
  quantity: Scalars['Float']['input'];
  taxDetails: InvoiceLineItemTaxDetailsInput;
  unit: Scalars['String']['input'];
  unitPrice: MoneyV2Input;
};

export type InvoiceLineItemTaxDetailsInput = {
  taxAmount: MoneyV2Input;
  taxClassName: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
};

/**
 * Identifies a product using an external reference, such as an ERP or
 * third-party catalog identifier, along with its unit.
 *
 * Use this when the product does **not** yet exist in Choco.
 *
 * This input is used within `InvoiceProductRefInput`. You must provide **either**
 * `byId` or `byExternalId` — not both.
 */
export type InvoiceProductRefByExternalIdInput = {
  externalId: Scalars['String']['input'];
  unit: Scalars['String']['input'];
};

/**
 * Identifies a product using its Choco ID.
 *
 * This input is used within `InvoiceProductRefInput`. You must provide **either**
 * `byId` or `byExternalId` — not both.
 */
export type InvoiceProductRefByIdInput = {
  id: Scalars['ID']['input'];
};

/**
 * Represents a reference to a product, either by internal ID or by external identifier.
 *
 * Only **one** of the two fields should be provided per request:
 * - Use `byId` if the product exists in Choco
 * - Use `byExternalId` if the product is identified in the vendor's ERP system
 *
 * Providing both will result in a validation error.
 */
export type InvoiceProductRefInput = {
  byExternalId?: InputMaybe<InvoiceProductRefByExternalIdInput>;
  byId?: InputMaybe<InvoiceProductRefByIdInput>;
};

/**
 * A reference to an invoice. The node field lazily resolves the InvoiceSummary
 * when requested. The reference may be stale — node returns null if the invoice
 * no longer exists.
 */
export type InvoiceRef = RefEdge & {
  __typename?: 'InvoiceRef';
  /** Id of the referenced invoice */
  id: Scalars['ID']['output'];
  /** Resolves the invoice by its id. */
  node?: Maybe<InvoiceSummary>;
};

/** A lightweight invoice representation used for reference resolution. */
export type InvoiceSummary = Node & {
  __typename?: 'InvoiceSummary';
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
};

export type InvoiceTaxSubtotalInput = {
  taxAmount: MoneyV2Input;
  taxClassName: Scalars['String']['input'];
  taxRate: Scalars['Float']['input'];
};

export const InvoiceVendorPaymentStatus = {
  NotPaid: 'NOT_PAID',
  Paid: 'PAID',
  Unknown: 'UNKNOWN'
} as const;

export type InvoiceVendorPaymentStatus = typeof InvoiceVendorPaymentStatus[keyof typeof InvoiceVendorPaymentStatus];
export type InvoicedProduct = {
  __typename?: 'InvoicedProduct';
  createdAt: Scalars['AWSTimestamp']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoicedPrice?: Maybe<Money>;
  orderId: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type InvoicedProductInput = {
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  invoicedPrice?: InputMaybe<MoneyInput>;
  orderId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};

export type InvoicedProducts = AppsyncResponse & {
  __typename?: 'InvoicedProducts';
  invoicedProducts: Array<InvoicedProduct>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type IsSelectedInOrderGuide = {
  __typename?: 'IsSelectedInOrderGuide';
  value: Scalars['Boolean']['output'];
};

export type IsSelectedInOrderGuideResponse = AuthorizationFailure | InputValidationFailure | IsSelectedInOrderGuide;

export type ItemReplacementRecommendation = {
  __typename?: 'ItemReplacementRecommendation';
  /** Replacement candidate */
  candidateProduct: VendorItemUnitForChat;
  /**
   * Relevance rank from the ranking model.Rank 1 is the best match.
   * Recommendations are already returned in rank order, but clients that re-order them should sort by `rank` ascending (smallest first).
   */
  rank: Scalars['Int']['output'];
};

/** Response level metadata for `itemReplacementRecommendations`. */
export type ItemReplacementRecommendationMetadata = {
  __typename?: 'ItemReplacementRecommendationMetadata';
  /**
   * Unique identifier for this recommendation request. Used to join backend
   * logs with client-side analytics events for relevance measurement.
   */
  queryId?: Maybe<Scalars['String']['output']>;
};

export type ItemReplacementRecommendationsInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  /** Max recommendations to return for the initial modal. Default 10. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  productName: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
  /** The out-of-stock product. */
  vendorItemId: Scalars['ID']['input'];
  vendorItemUnitId: Scalars['ID']['input'];
};

export type ItemReplacementRecommendationsResponse = AuthorizationFailure | InputValidationFailure | ItemReplacementRecommendationsResult;

export type ItemReplacementRecommendationsResult = {
  __typename?: 'ItemReplacementRecommendationsResult';
  /**
   * Metadata related to the result set. Absent when nothing response level was
   * determined for this request.
   */
  metadata?: Maybe<ItemReplacementRecommendationMetadata>;
  recommendations: Array<ItemReplacementRecommendation>;
  /**
   * OOS product name resolved server-side. The client uses this to prefill the
   * search box when user taps "Find More".
   */
  searchPrefillTerm: Scalars['String']['output'];
};

/** Represents a job that has failed completely. */
export type JobFailed = {
  __typename?: 'JobFailed';
  /** Detailed information about the failure of the job, including a failure code and message. */
  failure: JobFailure;
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
};

/** Provides detailed information about the failure of a job, including a specific error code and message. */
export type JobFailure = {
  __typename?: 'JobFailure';
  /** A code that identifies the type of failure that occurred. */
  code: Scalars['String']['output'];
  /** Additional JSON-formatted information about the failure, which may include details such as the fields that caused validation errors. */
  extra?: Maybe<Scalars['AWSJSON']['output']>;
  /** A human-readable message describing the failure. */
  message: Scalars['String']['output'];
};

/** Represents a job that is currently in progress. */
export type JobInProgress = {
  __typename?: 'JobInProgress';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
};

/** Represents a job that is queued. */
export type JobQueued = {
  __typename?: 'JobQueued';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
};

/** JobStatus enum */
export const JobStatus = {
  /** Job has failed. */
  Failed: 'Failed',
  /** Job is in progress. */
  InProgress: 'InProgress',
  /** Job is queued and will soon be executed. */
  Queued: 'Queued',
  /** Job has succeeded. */
  Succeeded: 'Succeeded',
  /** Job is waiting for input file to be uploaded. */
  WaitingForInput: 'WaitingForInput'
} as const;

export type JobStatus = typeof JobStatus[keyof typeof JobStatus];
/** Represents a job waiting for the input file upload to start the process. */
export type JobWaitingForInput = {
  __typename?: 'JobWaitingForInput';
  /** The unique identifier of the job. */
  id: Scalars['ID']['output'];
  /** URL where the input file for the job should be uploaded. */
  inputUploadUrl: Scalars['String']['output'];
};

export type JoinLoyaltyInput = {
  buyerId: Scalars['ID']['input'];
};

export type JoinLoyaltyResponse = AuthorizationFailure | InputValidationFailure | JoinLoyaltySuccess | LoyaltyProviderTemporarilyUnavailable;

export type JoinLoyaltySuccess = {
  __typename?: 'JoinLoyaltySuccess';
  status: LoyaltyState | '%future added value';
  success: Scalars['Boolean']['output'];
};

export const JoinRequestAllowedUpdateStatus = {
  Approved: 'approved',
  Denied: 'denied'
} as const;

export type JoinRequestAllowedUpdateStatus = typeof JoinRequestAllowedUpdateStatus[keyof typeof JoinRequestAllowedUpdateStatus];
export const JoinRequestStatus = {
  Approved: 'approved',
  AutoApproved: 'autoApproved',
  Denied: 'denied',
  Pending: 'pending'
} as const;

export type JoinRequestStatus = typeof JoinRequestStatus[keyof typeof JoinRequestStatus];
/**
 * Returned when attempting to deactivate the funnel's only remaining active state.
 * A funnel must always keep at least one active state.
 */
export type LastActiveSalesFunnelStateError = {
  __typename?: 'LastActiveSalesFunnelStateError';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

/** Here are all functions for accessing and managing leads */
export const LeadOrderBy = {
  CreatedAt: 'CreatedAt',
  Name: 'Name',
  UpdatedAt: 'UpdatedAt'
} as const;

export type LeadOrderBy = typeof LeadOrderBy[keyof typeof LeadOrderBy];
export type LeaveLoyaltyInput = {
  buyerId: Scalars['ID']['input'];
};

export type LeaveLoyaltyResponse = AuthorizationFailure | InputValidationFailure | LeaveLoyaltySuccess | LoyaltyProviderTemporarilyUnavailable;

export type LeaveLoyaltySuccess = {
  __typename?: 'LeaveLoyaltySuccess';
  status: LoyaltyState | '%future added value';
  success: Scalars['Boolean']['output'];
};

export type LegalContactInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type LegalEntityAddInstantPayCustomerFailure = {
  __typename?: 'LegalEntityAddInstantPayCustomerFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type LegalEntityAddInstantPayCustomerInput = {
  customerDetails: PaymentCustomerDetailsInput;
  legalEntityId: Scalars['ID']['input'];
  options?: InputMaybe<InstantPayProfileOptionsInput>;
  profileDetails: InstantPayProfileDetailsInput;
  vendorId: Scalars['ID']['input'];
};

export type LegalEntityAddInstantPayCustomerResponse = AuthorizationFailure | InputValidationFailure | InstantPayCustomerAlreadyOnboardedFailure | LegalEntityAddInstantPayCustomerFailure | LegalEntityAddInstantPayCustomerSuccess;

export type LegalEntityAddInstantPayCustomerSuccess = {
  __typename?: 'LegalEntityAddInstantPayCustomerSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type LegalEntityAlreadyExistsFailure = {
  __typename?: 'LegalEntityAlreadyExistsFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type LegalEntityDetailsInput = {
  address: BillingAddressInput;
  contact: LegalContactInput;
  /** 2-letter country code as per ISO 3166 */
  countryCode: Scalars['String']['input'];
  externalLegalId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type LinePricing = {
  __typename?: 'LinePricing';
  /**
   * Unit price before catalog discount and before promotions.
   * Null unless different from netUnitPrice.
   */
  displayPriceBeforeDiscount?: Maybe<MoneyV2>;
  /** Unit price after discounts and promotions. */
  netUnitPrice?: Maybe<MoneyV2>;
  /**
   * (paidQuantity + freeQuantity) × unit price before discounts and promotions.
   * Null unless different from totalNetAmount.
   */
  totalAmountBeforeDiscount?: Maybe<MoneyV2>;
  /** paidQuantity × unit price after discounts and promotions. */
  totalNetAmount?: Maybe<MoneyV2>;
  /** Unit price after the catalog discount, before promotions. */
  unitPriceBeforePromotion?: Maybe<MoneyV2>;
};

export type ListMasterProductUnitsInput = {
  pagination?: InputMaybe<PaginationInputV2>;
};

export type ListProcessingTransmissionsInput = {
  filter?: InputMaybe<ProcessingTransmissionFilter>;
  supplierEntityId: Scalars['ID']['input'];
};

export type ListProcessingTransmissionsResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | TransmissionConnection;

export type ListSubCatalogProductsError = AppsyncError & AppsyncResponse & {
  __typename?: 'ListSubCatalogProductsError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type ListSubCatalogProductsInput = {
  /**
   * Additional filters to narrow down the list
   * @deprecated Not supported anymore
   */
  filter?: InputMaybe<ProductFilter>;
  /**
   * Starting offset for the pagination
   * @deprecated Not supported anymore
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Search query to look for a specific product
   * @deprecated Not supported anymore
   */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Size of a single page
   * @deprecated Not supported anymore
   */
  size?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Order of the returned products
   * @deprecated Not supported anymore
   */
  sort?: InputMaybe<Sort>;
  /** ID of the Custom Catalog whose products are fetched */
  subCatalogId: Scalars['ID']['input'];
};

export type ListSubCatalogProductsResponse = ListSubCatalogProductsError | ProductSearchResult;

export type ListSubCatalogsResponse = SubCatalogConnection | ValidationError;

export type ListTransmissionsInput = {
  filter?: InputMaybe<TransmissionFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  /** Only support PO number keyword search for now */
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<TransmissionSortFields | '%future added value'>;
  sortDirection?: InputMaybe<SortDirection | '%future added value'>;
  supplierEntityId: Scalars['ID']['input'];
};

export type ListTransmissionsResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | TransmissionConnection;

export type LobbyBuyer = Node & {
  __typename?: 'LobbyBuyer';
  buyer: Buyer;
  chatIds: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type LocationBySupplier = {
  __typename?: 'LocationBySupplier';
  buyerEntityId: Scalars['ID']['output'];
  chatId: Scalars['ID']['output'];
  chatName?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  /**
   * All the order-guides attached to the location's chat.
   * If no order guide exists, a fallback order guide is created.
   */
  orderGuides?: Maybe<Array<OrderGuideV2>>;
};

export type LocationProductResult = {
  __typename?: 'LocationProductResult';
  errorCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  productId: Scalars['String']['output'];
  successfulOperation: Scalars['Boolean']['output'];
};

export type LocationProductsResult = {
  __typename?: 'LocationProductsResult';
  locationId: Scalars['String']['output'];
  products: Array<LocationProductResult>;
};

export type LocationsBySupplierResponse = AuthorizationFailure | InputValidationFailure | LocationsBySupplierSuccess;

export type LocationsBySupplierSuccess = {
  __typename?: 'LocationsBySupplierSuccess';
  result?: Maybe<Array<Maybe<LocationBySupplier>>>;
};

export const LoginMethod = {
  Email: 'email',
  EmailAndPhone: 'emailAndPhone',
  Federated: 'federated',
  Phone: 'phone'
} as const;

export type LoginMethod = typeof LoginMethod[keyof typeof LoginMethod];
export type LookupPhoneNumbersError = AppsyncError & AppsyncResponse & {
  __typename?: 'LookupPhoneNumbersError';
  errorCode?: Maybe<LookupPhoneNumbersErrorCode | '%future added value'>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export const LookupPhoneNumbersErrorCode = {
  GenericError: 'genericError'
} as const;

export type LookupPhoneNumbersErrorCode = typeof LookupPhoneNumbersErrorCode[keyof typeof LookupPhoneNumbersErrorCode];
export type LookupPhoneNumbersResponse = LookupPhoneNumbersError | LookupPhoneNumbersSuccess;

export type LookupPhoneNumbersSuccess = {
  __typename?: 'LookupPhoneNumbersSuccess';
  lookups: Array<PhoneNumberLookup>;
};

export type Loyalty = {
  __typename?: 'Loyalty';
  activePoints: Scalars['Int']['output'];
  /** Unrounded Talon active balance. `activePoints` is this amount floored for display. */
  activePointsDecimal: Decimal;
  pendingPoints: Scalars['Int']['output'];
  /** Unrounded Talon pending balance. `pendingPoints` is this amount floored for display. */
  pendingPointsDecimal: Decimal;
  settings: LoyaltySettings;
  state: LoyaltyState | '%future added value';
};

export type LoyaltyGetInput = {
  buyerId: Scalars['ID']['input'];
};

export type LoyaltyGetResponse = AuthorizationFailure | InputValidationFailure | LoyaltyGetSuccess | LoyaltyProviderTemporarilyUnavailable;

export type LoyaltyGetSuccess = {
  __typename?: 'LoyaltyGetSuccess';
  /**
   * Null only when no loyalty program applies in this context (e.g. loyalty not configured for this current whitelabel config).
   * A buyer for whom a program applies but who hasn't joined returns a Loyalty with state NOT_ENROLLED - not null.
   * Top-level upstream outages return LoyaltyProviderTemporarilyUnavailable instead, so null still unambiguously means "no program in this context".
   */
  loyalty?: Maybe<Loyalty>;
};

/** Kind of loyalty notification. Clients use it to pick an icon; the text comes from `message`. */
export const LoyaltyNotificationKind = {
  PointsReversed: 'POINTS_REVERSED',
  TierDowngraded: 'TIER_DOWNGRADED',
  TierDowngradeUpcoming: 'TIER_DOWNGRADE_UPCOMING',
  TierUpgraded: 'TIER_UPGRADED',
  VoucherRedeemed: 'VOUCHER_REDEEMED'
} as const;

export type LoyaltyNotificationKind = typeof LoyaltyNotificationKind[keyof typeof LoyaltyNotificationKind];
export type LoyaltyPoints = {
  __typename?: 'LoyaltyPoints';
  points: Scalars['Int']['output'];
  /** Unrounded Talon amount. `points` is this amount floored for display. */
  pointsDecimal: Decimal;
};

export type LoyaltyPointsBreakdown = {
  __typename?: 'LoyaltyPointsBreakdown';
  /**
   * Per-line loyalty points. The set of lines depends on the context this
   * breakdown is read from: for the cart estimation it is one entry per requested
   * cart line (in input order); for Order.loyalty it is one entry per line in the
   * order's committed loyalty session, so it reflects what was actually earned.
   */
  items: Array<UnitLoyaltyPoints>;
  session: Array<SessionLoyaltyPoints>;
  /**
   * Talon.One customer-session state. Null on cart estimates (no persisted
   * session). On Order.loyalty, only CLOSED and PARTIALLY_RETURNED are returned;
   * open, cancelled, and missing sessions still resolve Order.loyalty to null.
   */
  sessionStatus?: Maybe<LoyaltySessionStatus | '%future added value'>;
  totalPoints: Scalars['Int']['output'];
  /** Unrounded sum of item + real session awards (not a re-sum of floored Ints). */
  totalPointsDecimal: Decimal;
};

export type LoyaltyPointsEstimationForCartInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  items: Array<LoyaltyPointsEstimationForCartItemInput>;
  vendorId: Scalars['ID']['input'];
};

export type LoyaltyPointsEstimationForCartItemInput = {
  quantity: DecimalInput;
  vendorItemUnitId: Scalars['ID']['input'];
};

export type LoyaltyPointsEstimationForCartResponse = AuthorizationFailure | InputValidationFailure | LoyaltyPointsBreakdown | LoyaltyProviderTemporarilyUnavailable;

export type LoyaltyProviderTemporarilyUnavailable = AppsyncError & AppsyncResponse & {
  __typename?: 'LoyaltyProviderTemporarilyUnavailable';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type LoyaltyRedemption = {
  __typename?: 'LoyaltyRedemption';
  brand?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  pointsCost: Scalars['Int']['output'];
  redeemedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  redemptionId: Scalars['ID']['output'];
  rewardId: Scalars['ID']['output'];
  status: RedemptionStatus | '%future added value';
  subtitle?: Maybe<Scalars['String']['output']>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use termsAndConditions (content, not a URL) */
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** When the buyer marked the voucher as used. Null while the voucher is unused. */
  usedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  voucherUrl?: Maybe<Scalars['String']['output']>;
};

export type LoyaltyRedemptionCreateInput = {
  buyerId: Scalars['ID']['input'];
  idempotencyKey: Scalars['String']['input'];
  rewardId: Scalars['ID']['input'];
};

/** Points could not be deducted (e.g. insufficient balance); no points were spent. */
export type LoyaltyRedemptionCreateInsufficientPoints = AppsyncResponse & {
  __typename?: 'LoyaltyRedemptionCreateInsufficientPoints';
  currentBalance: Scalars['Int']['output'];
  /** Unrounded Talon balance. `currentBalance` is this amount floored for display. */
  currentBalanceDecimal: Decimal;
  pointsCost: Scalars['Int']['output'];
  responseType: ResponseType | '%future added value';
};

export type LoyaltyRedemptionCreateResponse = AuthorizationFailure | InputValidationFailure | LoyaltyRedemptionCreateInsufficientPoints | LoyaltyRedemptionCreateSuccess | LoyaltyRedemptionCreateUnavailable;

/** Synchronous result: the mutation blocks until the redemption saga resolves. */
export type LoyaltyRedemptionCreateSuccess = AppsyncResponse & {
  __typename?: 'LoyaltyRedemptionCreateSuccess';
  expiresAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  redemptionId: Scalars['ID']['output'];
  responseType: ResponseType | '%future added value';
  status: RedemptionStatus | '%future added value';
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  voucherUrl: Scalars['String']['output'];
};

/** Voucher could not be created (e.g. out of stock); the point deduction was reversed. */
export type LoyaltyRedemptionCreateUnavailable = AppsyncResponse & {
  __typename?: 'LoyaltyRedemptionCreateUnavailable';
  redemptionId: Scalars['ID']['output'];
  responseType: ResponseType | '%future added value';
  status: RedemptionStatus | '%future added value';
};

export type LoyaltyRedemptionUpdateInput = {
  buyerId: Scalars['ID']['input'];
  options: LoyaltyRedemptionUpdateOptionsInput;
  redemptionId: Scalars['ID']['input'];
};

/** Omitted fields stay unchanged. At least one field must be set. */
export type LoyaltyRedemptionUpdateOptionsInput = {
  /** true = used (sets usedAt), false = unused (clears usedAt). */
  used?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoyaltyRedemptionUpdateResponse = AuthorizationFailure | InputValidationFailure | LoyaltyRedemptionUpdateSuccess;

export type LoyaltyRedemptionUpdateSuccess = AppsyncResponse & {
  __typename?: 'LoyaltyRedemptionUpdateSuccess';
  redemption: LoyaltyRedemption;
  responseType: ResponseType | '%future added value';
};

export type LoyaltyRedemptionsFilters = {
  /** true = only used vouchers, false = only unused vouchers, omitted = both. */
  used?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoyaltyRedemptionsGetInput = {
  buyerId: Scalars['ID']['input'];
  filters?: InputMaybe<LoyaltyRedemptionsFilters>;
  pagination?: InputMaybe<PaginationInputV2>;
  statuses?: InputMaybe<Array<RedemptionStatus | '%future added value'>>;
};

export type LoyaltyRedemptionsGetResponse = AuthorizationFailure | InputValidationFailure | LoyaltyRedemptionsGetSuccess;

export type LoyaltyRedemptionsGetSuccess = AppsyncResponse & {
  __typename?: 'LoyaltyRedemptionsGetSuccess';
  items: Array<LoyaltyRedemption>;
  pageInfo: PageInfo;
  responseType: ResponseType | '%future added value';
  totalCount: Scalars['Int']['output'];
};

export type LoyaltyReward = {
  __typename?: 'LoyaltyReward';
  /**
   * Other voucher point denominations available for the same brand as this reward,
   * excluding `pointsCost`, sorted ascending. Populated for `view: BRAND_TILES`.
   * Empty for `view: REWARDS` (or when the brand has no sibling denominations).
   */
  additionalValues: Array<Scalars['Int']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  isRedeemable: Scalars['Boolean']['output'];
  pointsCost: Scalars['Int']['output'];
  rewardId: Scalars['ID']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use termsAndConditions (content, not a URL) */
  termsAndConditionsUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type LoyaltyRewardsCatalogFilters = {
  brand?: InputMaybe<Scalars['String']['input']>;
};

export type LoyaltyRewardsCatalogGetInput = {
  buyerId: Scalars['ID']['input'];
  filters?: InputMaybe<LoyaltyRewardsCatalogFilters>;
  pagination?: InputMaybe<PaginationInputV2>;
  /** Defaults to REWARDS when omitted. */
  view?: InputMaybe<LoyaltyRewardsCatalogView | '%future added value'>;
};

export type LoyaltyRewardsCatalogGetResponse = AuthorizationFailure | InputValidationFailure | LoyaltyRewardsCatalogGetSuccess;

export type LoyaltyRewardsCatalogGetSuccess = AppsyncResponse & {
  __typename?: 'LoyaltyRewardsCatalogGetSuccess';
  items: Array<LoyaltyReward>;
  pageInfo: PageInfo;
  responseType: ResponseType | '%future added value';
  totalCount: Scalars['Int']['output'];
};

export const LoyaltyRewardsCatalogView = {
  /**
   * One reward per distinct brand — the brand's cheapest — for the brand-tile
   * view. totalCount then counts distinct brands, and isRedeemable on a returned
   * item means the brand has at least one affordable reward.
   */
  BrandTiles: 'BRAND_TILES',
  /** Flat reward list, sorted by pointsCost ascending (default). */
  Rewards: 'REWARDS'
} as const;

export type LoyaltyRewardsCatalogView = typeof LoyaltyRewardsCatalogView[keyof typeof LoyaltyRewardsCatalogView];
/**
 * Talon.One customer-session states. Order.loyalty currently only emits CLOSED
 * and PARTIALLY_RETURNED; OPEN and CANCELLED still resolve Order.loyalty to null.
 */
export const LoyaltySessionStatus = {
  Cancelled: 'CANCELLED',
  Closed: 'CLOSED',
  Open: 'OPEN',
  PartiallyReturned: 'PARTIALLY_RETURNED'
} as const;

export type LoyaltySessionStatus = typeof LoyaltySessionStatus[keyof typeof LoyaltySessionStatus];
export type LoyaltySettings = {
  __typename?: 'LoyaltySettings';
  allowNonAdminLoyaltyAccess: Scalars['Boolean']['output'];
};

export const LoyaltyState = {
  Active: 'ACTIVE',
  Left: 'LEFT',
  NotEnrolled: 'NOT_ENROLLED'
} as const;

export type LoyaltyState = typeof LoyaltyState[keyof typeof LoyaltyState];
export type MagicCode = {
  __typename?: 'MagicCode';
  /** The magic code (uppercase alphanumeric). */
  code: Scalars['String']['output'];
  /** When the code was created. */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The date when the code expires. */
  expiresAtDate: Scalars['AWSDate']['output'];
  /** The ID of the magic code. */
  id: Scalars['ID']['output'];
  /** The current status of the magic code. */
  status: MagicCodeStatus | '%future added value';
  /** Number of times the code has been used. */
  useCount: Scalars['Int']['output'];
};

/** Returned when the chat exists but is disabled. */
export type MagicCodeChatDisabledError = AppsyncError & AppsyncResponse & {
  __typename?: 'MagicCodeChatDisabledError';
  /** Optional human-readable message describing the error */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to error */
  responseType: ResponseType | '%future added value';
};

/** Returned when the specified chat does not exist in the system. */
export type MagicCodeChatNotFoundError = AppsyncError & AppsyncResponse & {
  __typename?: 'MagicCodeChatNotFoundError';
  /** Optional human-readable message describing the error */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to error */
  responseType: ResponseType | '%future added value';
};

/** Returned when the submitted magic code was valid but has now expired. */
export type MagicCodeExpiredError = AppsyncError & AppsyncResponse & {
  __typename?: 'MagicCodeExpiredError';
  /** Optional human-readable message describing the error */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to error */
  responseType: ResponseType | '%future added value';
};

/** Returned when the submitted magic code has been manually invalidated/deactivated by the supplier */
export type MagicCodeInvalidatedError = AppsyncError & AppsyncResponse & {
  __typename?: 'MagicCodeInvalidatedError';
  /** Optional human-readable message describing the error */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to error */
  responseType: ResponseType | '%future added value';
};

/** Returned when the submitted magic code has reached its maximum number of uses. */
export type MagicCodeMaxUsesReachedError = AppsyncError & AppsyncResponse & {
  __typename?: 'MagicCodeMaxUsesReachedError';
  /** Optional human-readable message describing the error */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to error */
  responseType: ResponseType | '%future added value';
};

/**
 * Returned when the submitted magic code does not exist in the system.
 * This occurs when:
 * - The user enters a code that was never generated
 * - The user is using a different whitelabel app from the one the code was generated for
 */
export type MagicCodeNotFoundError = AppsyncError & AppsyncResponse & {
  __typename?: 'MagicCodeNotFoundError';
  /** Optional human-readable message describing the error */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to error */
  responseType: ResponseType | '%future added value';
};

/** Returned when a user tries to submit a magic code from a non-whitelabel app. */
export type MagicCodeNotWhitelabelAppError = AppsyncError & AppsyncResponse & {
  __typename?: 'MagicCodeNotWhitelabelAppError';
  /** Optional human-readable message describing the error */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to error */
  responseType: ResponseType | '%future added value';
};

export const MagicCodeStatus = {
  Active: 'Active',
  Expired: 'Expired',
  ExpiresSoon: 'ExpiresSoon'
} as const;

export type MagicCodeStatus = typeof MagicCodeStatus[keyof typeof MagicCodeStatus];
/** Returned when a supplier user attempts to submit a magic code. Since its only allowed for buyer users. */
export type MagicCodeSupplierNotAllowedError = AppsyncError & AppsyncResponse & {
  __typename?: 'MagicCodeSupplierNotAllowedError';
  /** Optional human-readable message describing the error */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to error */
  responseType: ResponseType | '%future added value';
};

/** Returned when the supplier associated with this chat is not a whitelabel supplier. */
export type MagicCodeSupplierNotWhitelabelError = AppsyncError & AppsyncResponse & {
  __typename?: 'MagicCodeSupplierNotWhitelabelError';
  /** Optional human-readable message describing the error */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to error */
  responseType: ResponseType | '%future added value';
};

/**
 * Returned when an unexpected error occurs during magic code submission.
 * Use this as a fallback error type for proper error handling.
 */
export type MagicCodeUnexpectedError = AppsyncError & AppsyncResponse & {
  __typename?: 'MagicCodeUnexpectedError';
  /** A human-readable message describing the error */
  message: Scalars['String']['output'];
  /** Response type will always be set to error */
  responseType: ResponseType | '%future added value';
};

/** Returned when a user attempts to submit a magic code but is already part of the chat associated with that code. */
export type MagicCodeUserAlreadyInChatError = AppsyncError & AppsyncResponse & {
  __typename?: 'MagicCodeUserAlreadyInChatError';
  /** Optional human-readable message describing the error */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to error */
  responseType: ResponseType | '%future added value';
};

export type MarkCustomerInsightsNotificationAsReadInput = {
  id: Scalars['ID']['input'];
};

export type MarkCustomerInsightsNotificationAsReadResponse = AuthorizationFailure | CustomerInsightsNotification | InputValidationFailure;

/** Marketing campaign node containing marketing campaign information */
export type MarketingCampaign = Node & {
  __typename?: 'MarketingCampaign';
  /** Marketing campaign activated date time */
  activatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** The user who activated/sent the campaign. */
  activatedByUser?: Maybe<User>;
  /** Marketing campaign performance for the sent campaigns */
  analytics?: Maybe<MarketingCampaignAnalytics>;
  /** Marketing campaign attachments to be used for sending emails */
  attachments: Array<CampaignAttachment>;
  /** Marketing campaign cancelled date time */
  cancelledAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** Marketing campaign channels to be used for the campaign */
  channels: Array<CampaignChannel | '%future added value'>;
  /** Marketing campaign chat message content to be used for sending chat messages */
  chatMessageContent?: Maybe<MarketingCampaignChatMessageContent>;
  /** Marketing campaign chat target count */
  chatTargetCount?: Maybe<Scalars['Int']['output']>;
  /** Marketing campaign created date time */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The user who created the campaign. */
  createdByUser: User;
  /** Marketing campaign email content to be used for sending emails */
  emailContent?: Maybe<EmailContent>;
  /** Marketing campaign email target count */
  emailTargetCount?: Maybe<Scalars['Int']['output']>;
  /** Marketing campaign expiration date time. Returned as a Unix timestamp (UTC). */
  expiresAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** Marketing campaign home promo content to be used for home promotions */
  homePromoContent?: Maybe<MarketingCampaignPromoContent>;
  /** Marketing campaign ID */
  id: Scalars['ID']['output'];
  /** Marketing campaign preferred products content to be used for preferred products promotions */
  promoPreferredProductsContent?: Maybe<MarketingCampaignPromoPreferredProductsContent>;
  /** Marketing campaign promo target count */
  promoTargetCount?: Maybe<Scalars['Int']['output']>;
  /** Marketing campaign state to show the current state of the campaign e.g. draft, active, finished etc. */
  state: MarketingCampaignState | '%future added value';
  /** Marketing campaign target rules to be used for sending emails */
  target?: Maybe<CampaignTarget>;
  /** Marketing campaign template to be used for sending emails */
  template?: Maybe<EmailTemplate>;
  /** Marketing campaign title for the supplier */
  title: Scalars['String']['output'];
  /** Marketing campaign vendor item units to be used for the campaign */
  vendorItemUnits: Array<VendorItemUnitRef>;
  /** Marketing campaign welcome banner content for the welcome banner */
  welcomeBannerContent?: Maybe<MarketingCampaignWelcomeBannerContent>;
};

export type MarketingCampaignAnalytics = {
  __typename?: 'MarketingCampaignAnalytics';
  /** Marketing campaign chat message clicked count */
  chatMessageClickedCount: Scalars['Int']['output'];
  /** Marketing campaign chat message clicked rate based on the sent count */
  chatMessageClickedRate: Scalars['Float']['output'];
  /** Marketing campaign chat message conversion count */
  chatMessageConversionCount: Scalars['Int']['output'];
  /** Marketing campaign chat message conversion rate based on the sent count */
  chatMessageConversionRate: Scalars['Float']['output'];
  /** Marketing campaign chat message revenue */
  chatMessageRevenue: MoneyV2;
  /** Marketing campaign chat message sent count */
  chatMessageSentCount: Scalars['Int']['output'];
  /** Marketing campaign chat message viewed count */
  chatMessageViewedCount: Scalars['Int']['output'];
  /** Marketing campaign chat message viewed rate based on the sent count */
  chatMessageViewedRate: Scalars['Float']['output'];
  /** Marketing campaign conversion count from all channels */
  conversionCount: Scalars['Int']['output'];
  /** Marketing campaign conversion rate based on the sent count from all channels */
  conversionRate: Scalars['Float']['output'];
  /** Marketing campaign email bounced count */
  emailBouncedCount: Scalars['Int']['output'];
  /** Marketing campaign email bounced rate based on the sent count */
  emailBouncedRate: Scalars['Float']['output'];
  /** Marketing campaign email clicked count */
  emailClickedCount: Scalars['Int']['output'];
  /** Marketing campaign email clicked rate based on the delivered count */
  emailClickedRate: Scalars['Float']['output'];
  /** Marketing campaign email conversion count */
  emailConversionCount: Scalars['Int']['output'];
  /** Marketing campaign email conversion rate based on the delivered count */
  emailConversionRate: Scalars['Float']['output'];
  /** Marketing campaign email delivered count */
  emailDeliveredCount: Scalars['Int']['output'];
  /** Marketing campaign email delivered rate based on the sent count */
  emailDeliveredRate: Scalars['Float']['output'];
  /** Marketing campaign email opened count */
  emailOpenedCount: Scalars['Int']['output'];
  /** Marketing campaign email opened rate based on the delivered count */
  emailOpenedRate: Scalars['Float']['output'];
  /** Count of ordered products from the email marketing campaign */
  emailProductOrdersCount: Scalars['Int']['output'];
  /** Marketing campaign revenue from email channel */
  emailRevenue: MoneyV2;
  /** Marketing campaign email sent count */
  emailSentCount: Scalars['Int']['output'];
  /** Marketing campaign email reported spam count */
  emailSpamReportedCount: Scalars['Int']['output'];
  /** Marketing campaign email reported spam rate based on the delivered count */
  emailSpamReportedRate: Scalars['Float']['output'];
  /** Marketing campaign email unsubscribed count */
  emailUnsubscribedCount: Scalars['Int']['output'];
  /** Marketing campaign email unsubscribed rate based on the delivered count */
  emailUnsubscribedRate: Scalars['Float']['output'];
  /** Marketing campaign preferred products added to order guide of chats count */
  preferredProductsAddedToChatOrderGuideCount: Scalars['Int']['output'];
  /** Marketing campaign preferred products click count */
  preferredProductsClickedCount: Scalars['Int']['output'];
  /** Marketing campaign preferred products clicked rate based on the target count */
  preferredProductsClickedRate: Scalars['Float']['output'];
  /** Marketing campaign preferred products conversion count */
  preferredProductsConversionCount: Scalars['Int']['output'];
  /** Marketing campaign preferred products conversion rate based on the view count */
  preferredProductsConversionRate: Scalars['Float']['output'];
  /** Marketing campaign preferred products revenue */
  preferredProductsRevenue: MoneyV2;
  /** Marketing campaign preferred products initial target count */
  preferredProductsTargetCount: Scalars['Int']['output'];
  /** Marketing campaign preferred products view count */
  preferredProductsViewedCount: Scalars['Int']['output'];
  /** Marketing campaign preferred products viewed rate based on the target count */
  preferredProductsViewedRate: Scalars['Float']['output'];
  /** Marketing campaign promo click count */
  promoClickedCount: Scalars['Int']['output'];
  /** Marketing campaign promo clicked rate based on the target count */
  promoClickedRate: Scalars['Float']['output'];
  /** Marketing campaign promo conversion count */
  promoConversionCount: Scalars['Int']['output'];
  /** Marketing campaign promo conversion rate based on the view count */
  promoConversionRate: Scalars['Float']['output'];
  /** Marketing campaign promo revenue */
  promoRevenue: MoneyV2;
  /** Marketing campaign promo initial target count */
  promoTargetCount: Scalars['Int']['output'];
  /** Marketing campaign promo view count */
  promoViewedCount: Scalars['Int']['output'];
  /** Marketing campaign promo viewed rate based on the target count */
  promoViewedRate: Scalars['Float']['output'];
  /** Marketing campaign revenue from all channels */
  revenue: MoneyV2;
  /** Marketing campaign welcome banner click count */
  welcomeBannerClickedCount?: Maybe<Scalars['Int']['output']>;
  /** Marketing campaign welcome banner clicked rate based on the target count */
  welcomeBannerClickedRate?: Maybe<Scalars['Float']['output']>;
  /** Marketing campaign welcome banner conversion count */
  welcomeBannerConversionCount?: Maybe<Scalars['Int']['output']>;
  /** Marketing campaign welcome banner conversion rate based on the view count */
  welcomeBannerConversionRate?: Maybe<Scalars['Float']['output']>;
  /** Marketing campaign welcome banner revenue */
  welcomeBannerRevenue?: Maybe<MoneyV2>;
  /**
   * Marketing campaign welcome banner initial target count
   * All welcome banner fields will always be populated, but they are kept nullable to avoid a breaking change.
   */
  welcomeBannerTargetCount?: Maybe<Scalars['Int']['output']>;
  /** Marketing campaign welcome banner view count */
  welcomeBannerViewedCount?: Maybe<Scalars['Int']['output']>;
  /** Marketing campaign welcome banner viewed rate based on the target count */
  welcomeBannerViewedRate?: Maybe<Scalars['Float']['output']>;
};

export type MarketingCampaignBuyerChatInput = {
  buyerId: Scalars['String']['input'];
  chatId: Scalars['String']['input'];
};

export type MarketingCampaignChannelTargetInput = {
  /** Chat IDs to be used for the marketing campaign. Required if the type is `TargetChats` */
  chatIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Campaign target type to be used for the marketing campaign, either all recipients or specific ones */
  type: MarketingCampaignTarget | '%future added value';
};

export type MarketingCampaignChatMessageContent = {
  __typename?: 'MarketingCampaignChatMessageContent';
  /** Chat message attachments */
  attachments?: Maybe<Array<CampaignChatAttachment>>;
  /** Chat message content */
  message: Scalars['String']['output'];
};

export const MarketingCampaignChatTarget = {
  All: 'ALL',
  Chats: 'CHATS'
} as const;

export type MarketingCampaignChatTarget = typeof MarketingCampaignChatTarget[keyof typeof MarketingCampaignChatTarget];
export type MarketingCampaignChatTargetInput = {
  /** Chat IDs to be used for the marketing campaign. Required if the type is `TargetChats` */
  chatIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Campaign target type to be used for the marketing campaign, either all recipients or specific ones */
  type: MarketingCampaignChatTarget | '%future added value';
};

export type MarketingCampaignChatUsersInput = {
  /** Chat ID to be used for the marketing campaign */
  chatId: Scalars['String']['input'];
  /** Chat user IDs to be used for the marketing campaign */
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Connection type to list marketing campaign edges */
export type MarketingCampaignConnection = Connection & {
  __typename?: 'MarketingCampaignConnection';
  /** List of marketing campaign edges */
  edges: Array<MarketingCampaignEdge>;
  /** Total number of marketing campaign edges under this connection */
  total: Scalars['Int']['output'];
};

/** Edge type to show marketing campaign node and pagination cursor */
export type MarketingCampaignEdge = Edge & {
  __typename?: 'MarketingCampaignEdge';
  /** Pagination cursor */
  cursor: Scalars['String']['output'];
  /** Marketing campaign node containing marketing campaign information */
  node: MarketingCampaign;
};

export type MarketingCampaignEmailSender = {
  __typename?: 'MarketingCampaignEmailSender';
  /** Marketing campaign email sender company legal details for footer */
  companyDetails: Scalars['String']['output'];
  /** Marketing campaign email sender address */
  email: Scalars['String']['output'];
  /** Marketing campaign email sender footer links, can be empty array */
  footerLinks: Array<MarketingCampaignEmailSenderFooterLink>;
  /** Marketing campaign email sender */
  name: Scalars['String']['output'];
  /** Marketing campaign email reply to address for the sender */
  replyToEmail: Scalars['String']['output'];
  /** Marketing campaign email reply to name */
  replyToName: Scalars['String']['output'];
  /** The status of sender configuration (generated, submitted, verified, active) */
  status?: Maybe<MarketingEmailSenderStatus | '%future added value'>;
};

/** Marketing campaign email sender footer link */
export type MarketingCampaignEmailSenderFooterLink = {
  __typename?: 'MarketingCampaignEmailSenderFooterLink';
  /** Marketing campaign email sender footer link name */
  name: Scalars['String']['output'];
  /** Marketing campaign email sender footer link URL */
  url: Scalars['String']['output'];
};

export type MarketingCampaignEmailSenderNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'MarketingCampaignEmailSenderNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Response type will always be set to `error` */
  responseType: ResponseType | '%future added value';
};

/** Email sender information to be used for sending emails */
export type MarketingCampaignEmailSenderResult = AppsyncResponse & {
  __typename?: 'MarketingCampaignEmailSenderResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** Email sender for the marketing campaigns */
  sender: MarketingCampaignEmailSender;
};

export const MarketingCampaignEmailTarget = {
  All: 'ALL',
  ChatUsers: 'CHAT_USERS'
} as const;

export type MarketingCampaignEmailTarget = typeof MarketingCampaignEmailTarget[keyof typeof MarketingCampaignEmailTarget];
export type MarketingCampaignEmailTargetInput = {
  /** Chat users to be used for email marketing campaign. Required if the type is `TargetChatUsers` */
  chatUsers?: InputMaybe<Array<MarketingCampaignChatUsersInput>>;
  /** Campaign target type to be used for the marketing campaign, either all recipients or specific ones */
  type: MarketingCampaignEmailTarget | '%future added value';
};

/** Input type for filtering campaigns by expiration date */
export type MarketingCampaignExpirationFilter = {
  /** Filter campaigns expiring after this date */
  from?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** Filter campaigns expiring before this date */
  to?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

/** Input type for filtering a list of marketing campaigns */
export type MarketingCampaignListFilter = {
  /** Filter by activatedUserId date range */
  activatedByUserId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by channel type */
  channel?: InputMaybe<Array<CampaignChannel | '%future added value'>>;
  /** Filter by createdByUserId */
  createdByUserId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by expiration date range */
  expiration?: InputMaybe<MarketingCampaignExpirationFilter>;
  /** Filter by state */
  state?: InputMaybe<Array<MarketingCampaignState | '%future added value'>>;
};

/** Input type for getting a list of marketing campaigns */
export type MarketingCampaignListInput = {
  /** Filters campaign by different values */
  filter?: InputMaybe<MarketingCampaignListFilter>;
  /**
   * Filters campaign by state
   * @deprecated use filter instead
   */
  stateFilter?: InputMaybe<Array<MarketingCampaignState | '%future added value'>>;
};

/** Response to list all marketing campaigns of a supplier or return error */
export type MarketingCampaignListResponse = AuthorizationFailure | InputValidationFailure | MarketingCampaignConnection;

/** Home promo content for marketing campaigns */
export type MarketingCampaignPromoContent = {
  __typename?: 'MarketingCampaignPromoContent';
  /** Home promo display image for the banner */
  displayImage?: Maybe<DownloadableCampaignAttachment>;
  /** Home promo display title shown to buyers */
  displayTitle?: Maybe<Scalars['String']['output']>;
  /** Home promo ordering image for the detail page */
  orderingImage?: Maybe<DownloadableCampaignAttachment>;
  /** Home promo ordering message for the detail page */
  orderingMessage?: Maybe<Scalars['String']['output']>;
};

/** Preferred products content for marketing campaigns */
export type MarketingCampaignPromoPreferredProductsContent = {
  __typename?: 'MarketingCampaignPromoPreferredProductsContent';
  /** Preferred products title shown to buyers */
  title: Scalars['String']['output'];
};

export const MarketingCampaignPromoTarget = {
  All: 'ALL',
  BuyerChats: 'BUYER_CHATS'
} as const;

export type MarketingCampaignPromoTarget = typeof MarketingCampaignPromoTarget[keyof typeof MarketingCampaignPromoTarget];
export type MarketingCampaignPromoTargetInput = {
  /** Buyer chat pairs to be used for home promo marketing campaign. Required if the type is `BUYER_CHATS` */
  buyerChats?: InputMaybe<Array<MarketingCampaignBuyerChatInput>>;
  /** Campaign target type to be used for the marketing campaign, either all recipients or specific ones */
  type: MarketingCampaignPromoTarget | '%future added value';
};

export const MarketingCampaignState = {
  Active: 'ACTIVE',
  Cancelled: 'CANCELLED',
  Draft: 'DRAFT',
  Finished: 'FINISHED'
} as const;

export type MarketingCampaignState = typeof MarketingCampaignState[keyof typeof MarketingCampaignState];
export const MarketingCampaignTarget = {
  All: 'ALL',
  Chats: 'CHATS'
} as const;

export type MarketingCampaignTarget = typeof MarketingCampaignTarget[keyof typeof MarketingCampaignTarget];
/** Input type for targeting specific channels in a marketing campaign. At least one channel must be specified */
export type MarketingCampaignTargetInput = {
  /** Chat targeting rules */
  chat?: InputMaybe<MarketingCampaignChannelTargetInput>;
  /** Email targeting rules */
  email?: InputMaybe<MarketingCampaignChannelTargetInput>;
};

/** Input type for targeting specific channels in a marketing campaign. At least one channel must be specified */
export type MarketingCampaignTargetInputV2 = {
  /** Chat targeting rules */
  chat?: InputMaybe<MarketingCampaignChatTargetInput>;
  /** Email targeting rules */
  email?: InputMaybe<MarketingCampaignEmailTargetInput>;
  /** Home promo targeting rules */
  homePromo?: InputMaybe<MarketingCampaignPromoTargetInput>;
  /** Preferred products targeting rules, same as home promo targeting rules */
  promoPreferredProducts?: InputMaybe<MarketingCampaignPromoTargetInput>;
  /** Welcome banner targeting rules */
  welcomeBanner?: InputMaybe<MarketingCampaignPromoTargetInput>;
};

/** Response type for a marketing campaign update mutation or error */
export type MarketingCampaignUpdateResponse = AuthorizationFailure | InputValidationFailure | MarketingCampaignUpdateResult;

/** Success result of a marketing campaign update mutation */
export type MarketingCampaignUpdateResult = AppsyncResponse & {
  __typename?: 'MarketingCampaignUpdateResult';
  /** Updated marketing campaign information */
  marketingCampaign: MarketingCampaign;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

/** Welcome banner content for the WELCOME_BANNER campaign channel (supplier-facing) */
export type MarketingCampaignWelcomeBannerContent = {
  __typename?: 'MarketingCampaignWelcomeBannerContent';
  /**
   * Image displayed on the campaign detail screen.
   * it is optional, because we allow updating the draft campaigns with incomplete content.
   */
  detailsImage?: Maybe<DownloadableCampaignAttachment>;
  /** Message displayed on the campaign detail screen */
  detailsMessage?: Maybe<Scalars['String']['output']>;
  /**
   * Banner image displayed on the home screen.
   * it is optional, because we allow updating the draft campaigns with incomplete content.
   */
  displayImage?: Maybe<DownloadableCampaignAttachment>;
  /** Title displayed over the banner image on the home screen */
  displayTitle?: Maybe<Scalars['String']['output']>;
};

/** Input type for marketing email sender footer link */
export type MarketingEmailSenderFooterLinkInput = {
  /** Footer link name */
  name: Scalars['String']['input'];
  /** Footer link URL */
  url: Scalars['String']['input'];
};

export const MarketingEmailSenderStatus = {
  Active: 'ACTIVE',
  Generated: 'GENERATED',
  Submitted: 'SUBMITTED',
  Verified: 'VERIFIED'
} as const;

export type MarketingEmailSenderStatus = typeof MarketingEmailSenderStatus[keyof typeof MarketingEmailSenderStatus];
export type MarketingMessageRefinementTip = {
  __typename?: 'MarketingMessageRefinementTip';
  tip: Scalars['String']['output'];
};

export type MarketingMessageSuggestionsError = AppsyncError & {
  __typename?: 'MarketingMessageSuggestionsError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type MarketingMessageSuggestionsErrorNoSuggestions = AppsyncError & {
  __typename?: 'MarketingMessageSuggestionsErrorNoSuggestions';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type MarketingMessageSuggestionsErrorThrottling = AppsyncError & {
  __typename?: 'MarketingMessageSuggestionsErrorThrottling';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type MarketingMessageSuggestionsResult = InputValidationFailure | MarketingMessageSuggestionsError | MarketingMessageSuggestionsErrorNoSuggestions | MarketingMessageSuggestionsErrorThrottling | MarketingMessageSuggestionsSuccess;

export type MarketingMessageSuggestionsSuccess = AppsyncResponse & {
  __typename?: 'MarketingMessageSuggestionsSuccess';
  improvedText: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  tips: Array<MarketingMessageRefinementTip>;
};

export type MasterProductUnit = Node & {
  __typename?: 'MasterProductUnit';
  code: Scalars['String']['output'];
  dimension: UnitDimension | '%future added value';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MasterProductUnitConnection = Connection & {
  __typename?: 'MasterProductUnitConnection';
  edges: Array<MasterProductUnitEdge>;
  pageInfo: PageInfo;
};

export type MasterProductUnitEdge = Edge & {
  __typename?: 'MasterProductUnitEdge';
  cursor: Scalars['String']['output'];
  node: MasterProductUnit;
};

export type MatchingConfidence = {
  __typename?: 'MatchingConfidence';
  customer?: Maybe<CustomerMatchingConfidence>;
  order?: Maybe<OrderMatchingConfidence>;
  products?: Maybe<Array<ProductMatchingConfidence>>;
};

export type Media = {
  __typename?: 'Media';
  contentType?: Maybe<Scalars['String']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Media link to be used for uploading and accessing media from the CDN */
export type MediaLink = {
  __typename?: 'MediaLink';
  /** Media ID used to identify the media in frontend */
  fileId: Scalars['String']['output'];
  /** Public CDN URL for the media file, to be used in emails */
  publicUrl: Scalars['String']['output'];
  /** S3 upload URL for the media file, to extract and attach in the email */
  uploadUrl: Scalars['String']['output'];
  /** S3 URI for the media file */
  uri: Scalars['String']['output'];
};

/** Input type for getting media upload link */
export type MediaLinkInput = {
  /** File ID used to identify the file in the bucket */
  fileId: Scalars['String']['input'];
  /** Media file name */
  name: Scalars['String']['input'];
  /** Media file type */
  type: Scalars['String']['input'];
};

/** Success result containing media upload links */
export type MediaUploadLinkResult = AppsyncResponse & {
  __typename?: 'MediaUploadLinkResult';
  /** Media upload and access links */
  links: Array<MediaLink>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type MenuScan = Node & {
  __typename?: 'MenuScan';
  /** Timestamp of when the menu scan job was started */
  activatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /**
   * The list of files attached to this scan
   * We only support one file for now
   * Can be empty if no files have been uploaded yet
   */
  attachments?: Maybe<Array<MenuScanAttachment>>;
  /**
   * The id of the chat associated with the scan.
   * Null for lead-scoped menu scans.
   */
  chatId?: Maybe<Scalars['ID']['output']>;
  /** Timestamp of when the scan was created */
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  /**
   * The id of the lead associated with the scan.
   * Null for customer-scoped menu scans.
   */
  leadId?: Maybe<Scalars['ID']['output']>;
  /** File scan result */
  scanResult?: Maybe<MenuScanResult>;
  /** Job processing status */
  status: MenuScanStatus | '%future added value';
  /** The supplier related to the menu scan */
  supplierId: Scalars['ID']['output'];
  /** Timestamp of when the scan was last updated */
  updatedAt: Scalars['AWSTimestamp']['output'];
  /** The user who activated the menu scan job */
  userId: Scalars['ID']['output'];
};

export type MenuScanAttachment = {
  __typename?: 'MenuScanAttachment';
  /** The file type MIME (e.g., image/jpeg, image/png) */
  contentType: Scalars['String']['output'];
  /** Timestamp of when the file was uploaded */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The signed URL to download the file */
  downloadUrl: Scalars['String']['output'];
  /** The original file name uploaded */
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The scan this file belongs to */
  menuScanId: Scalars['ID']['output'];
};

export type MenuScanAttachmentInput = {
  contentType: Scalars['String']['input'];
  fileId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type MenuScanAttachmentUploadLink = {
  __typename?: 'MenuScanAttachmentUploadLink';
  /** Attachment file type e.g. pdf, png etc. */
  contentType: Scalars['String']['output'];
  /** Attachment ID used to identify the file in the bucket */
  fileId: Scalars['String']['output'];
  /** Attachment file name */
  fileName: Scalars['String']['output'];
  /** S3 upload URL for the media file, to extract and attach in the email */
  uploadUrl: Scalars['String']['output'];
};

export type MenuScanAttachmentUploadLinkInput = {
  /** Attachment file type e.g. pdf, png etc. */
  contentType: Scalars['String']['input'];
  /** Attachment file name */
  fileName: Scalars['String']['input'];
};

export type MenuScanAttachmentUploadLinkResult = AppsyncResponse & {
  __typename?: 'MenuScanAttachmentUploadLinkResult';
  /** Updated links for the menu scan attachments */
  links?: Maybe<Array<MenuScanAttachmentUploadLink>>;
  responseType: ResponseType | '%future added value';
};

export type MenuScanConnection = Connection & {
  __typename?: 'MenuScanConnection';
  edges: Array<MenuScanEdge>;
  total: Scalars['Int']['output'];
};

export type MenuScanEdge = Edge & {
  __typename?: 'MenuScanEdge';
  cursor: Scalars['String']['output'];
  node: MenuScan;
};

export type MenuScanResult = {
  __typename?: 'MenuScanResult';
  /** The file type MIME (e.g., image/jpeg, image/png) */
  contentType: Scalars['String']['output'];
  /** Timestamp of when the file was uploaded */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The signed URL to download the file */
  downloadUrl: Scalars['String']['output'];
  /** The original file name uploaded */
  fileName: Scalars['String']['output'];
};

export const MenuScanStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Pending: 'PENDING',
  Processing: 'PROCESSING'
} as const;

export type MenuScanStatus = typeof MenuScanStatus[keyof typeof MenuScanStatus];
export type MenuScanUpdateResult = AppsyncResponse & {
  __typename?: 'MenuScanUpdateResult';
  /** Updated menu scan */
  menuScan: MenuScan;
  /** Message in case of failure while updating */
  message?: Maybe<Scalars['String']['output']>;
  /** Response type */
  responseType: ResponseType | '%future added value';
};

export type Message = Node & {
  __typename?: 'Message';
  attachment?: Maybe<Attachment>;
  body: Scalars['String']['output'];
  broadcastId?: Maybe<Scalars['ID']['output']>;
  chat: Chat;
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The sender user of the message to display in chat timeline. */
  displayUser: User;
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  /**
   * The order this message is about, for order event messages (e.g. order confirmed).
   * Unlike `order`, it does not mark the message as an order message.
   */
  relatedOrder?: Maybe<Order>;
  /**
   * Per-message unread, same idea as Chat.unread. Null when unread does not apply.
   * Opted in reads the shared team unread. A send by any opted-in user is not unread.
   * A personal viewer skips only their own send.
   */
  unread?: Maybe<MessageUnreadState>;
  /** The sender user of the message. */
  user: User;
};

export type MessageEvent = {
  __typename?: 'MessageEvent';
  eventType?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Array<Maybe<EventTarget>>>;
};

export type MessageGroupFilter = {
  orderId?: InputMaybe<Scalars['String']['input']>;
};

export type MessageInput = {
  body: Scalars['String']['input'];
  broadcastId?: InputMaybe<Scalars['String']['input']>;
  /** Used to group messages, e.g email replies to delivery check reconciliation requests */
  groupIds?: InputMaybe<GroupIdsInput>;
  id: Scalars['ID']['input'];
  /**
   * Set as true to send a message with a media attachment
   * The message will only be sent after media is put
   * to the attachment { uploadUrl } from the response
   */
  media?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * A standard MIME type describing the format media attachment
   * see https://www.w3.org/Protocols/rfc2616/rfc2616-sec14.html#sec14.17
   */
  mediaContentType?: InputMaybe<Scalars['String']['input']>;
  /** Flag to prevent message from sending to chat supplier */
  supplierOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only infra request can set the value, otherwise it should be undefined */
  type?: InputMaybe<Scalars['String']['input']>;
};

export const MessageStatus = {
  Delivered: 'delivered',
  PendingAttachment: 'pendingAttachment',
  ReadyForDelivery: 'readyForDelivery'
} as const;

export type MessageStatus = typeof MessageStatus[keyof typeof MessageStatus];
export const MessageType = {
  Broadcast: 'broadcast',
  DeliveryCheckReconciliationRequestConfirmed: 'deliveryCheckReconciliationRequestConfirmed',
  EmailMessage: 'emailMessage',
  Event: 'event',
  Media: 'media',
  Order: 'order',
  OrderConfirmation: 'orderConfirmation',
  Text: 'text'
} as const;

export type MessageType = typeof MessageType[keyof typeof MessageType];
export type MessageUnreadState = {
  __typename?: 'MessageUnreadState';
  /** Whether this message currently counts as unread for the viewer. */
  hasUnread: Scalars['Boolean']['output'];
};

/**
 * For internal use,
 * This type is kept exactly similar to the message table schema since it is used as is in choco-notification
 */
export type MessagesFromChatResult = {
  __typename?: 'MessagesFromChatResult';
  body: Scalars['String']['output'];
  broadcastId?: Maybe<Scalars['String']['output']>;
  chatId: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  event?: Maybe<MessageEvent>;
  id: Scalars['String']['output'];
  media?: Maybe<Scalars['Boolean']['output']>;
  mediaContentType?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  recipients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<MessageStatus | '%future added value'>;
  supplierOptIn?: Maybe<Scalars['Boolean']['output']>;
  type?: Maybe<MessageType | '%future added value'>;
  userId: Scalars['String']['output'];
};

export type MetaLobbyResponse = InvalidCursor | MetaLobbyResult;

export type MetaLobbyResult = {
  __typename?: 'MetaLobbyResult';
  buyers: UserLobbyBuyerConnection;
  others?: Maybe<Array<Scalars['String']['output']>>;
};

export type MinOrder = {
  __typename?: 'MinOrder';
  /** Whether the supplier accepts top-up orders for delivery dates with a qualifying existing order. Null means unset / feature unavailable. */
  acceptTopUp?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Order Agent (Choco AI) enforces this MOV. Null means unset / feature unavailable. */
  enforcedByOrderAgent?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Money>;
  strict?: Maybe<Scalars['Boolean']['output']>;
};

export type MinOrderInput = {
  acceptTopUp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the Order Agent (Choco AI) should enforce this MOV. If not set, the existing value is left unchanged. */
  enforcedByOrderAgent?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<MoneyInput>;
  strict?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Per paid-line minimum order quantity miss (quantity floor, not cart money
 * minimum order value). One entry per failing paid line.
 */
export type MinOrderableAmountValidationResult = CartValidationResult & {
  __typename?: 'MinOrderableAmountValidationResult';
  /**
   * Quantity on the cart line (paid + free display total, or paid portion
   * when free quantity is carved on the same line).
   */
  orderedQuantity: Decimal;
  overriddenBy?: Maybe<Scalars['String']['output']>;
  overrideable: Scalars['Boolean']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /** Catalog minimum orderable quantity for this unit. */
  requiredQuantity: Decimal;
  source: ValidationSource | '%future added value';
  status: ValidationStatus | '%future added value';
  /** Sellable unit on the under-min cart line (join key). */
  vendorItemUnitId: Scalars['ID']['output'];
};

export type MinimumOrderValue = {
  __typename?: 'MinimumOrderValue';
  formattedMinimumOrderValue?: Maybe<Scalars['String']['output']>;
  minimumOrderValue?: Maybe<MinOrder>;
  type?: Maybe<MinimumOrderValueType | '%future added value'>;
};

export type MinimumOrderValueFailure = {
  __typename?: 'MinimumOrderValueFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type MinimumOrderValueResponse = AuthorizationFailure | InputValidationFailure | MinimumOrderValue | MinimumOrderValueFailure;

export const MinimumOrderValueType = {
  CustomerLevel: 'customerLevel',
  SupplierLevel: 'supplierLevel'
} as const;

export type MinimumOrderValueType = typeof MinimumOrderValueType[keyof typeof MinimumOrderValueType];
export type MinimumOrderValueUpdate = {
  __typename?: 'MinimumOrderValueUpdate';
  success: Scalars['Boolean']['output'];
};

export type MinimumOrderValueUpdateResponse = AuthorizationFailure | InputValidationFailure | MinimumOrderValueFailure | MinimumOrderValueUpdate;

export type MinimumOrderableAmountDetail = {
  __typename?: 'MinimumOrderableAmountDetail';
  minimumOrderableAmount: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
};

export type MinimumOrderableAmountError = AppsyncError & AppsyncResponse & {
  __typename?: 'MinimumOrderableAmountError';
  message?: Maybe<Scalars['String']['output']>;
  /** The products that have ordered amount less than product minimum orderable amount */
  noMinimumOrderableAmountProducts: Array<NoMinimumOrderableAmountProduct>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type MinimumOrderableAmountFailure = {
  __typename?: 'MinimumOrderableAmountFailure';
  details: Array<MinimumOrderableAmountDetail>;
  message: Scalars['String']['output'];
};

export type MobileHomePageBannerInfoFullWidthContent = {
  __typename?: 'MobileHomePageBannerInfoFullWidthContent';
  ctaBackgroundColor: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaLink: Scalars['String']['output'];
  horizontalBannerImageUrl: Scalars['String']['output'];
};

export type MobileHomePageBannerShoppableFullWidthContent = {
  __typename?: 'MobileHomePageBannerShoppableFullWidthContent';
  chat?: Maybe<Chat>;
  featuredVendorItemUnitId: Scalars['ID']['output'];
  horizontalBannerImageUrl: Scalars['String']['output'];
  promoPageContent: PromoPageContent;
  supplier: Supplier;
  unitVariants: Array<SupplierVendorItemUnitVariant>;
};

export type MobileHomePagePopupInfoFullPageContent = {
  __typename?: 'MobileHomePagePopupInfoFullPageContent';
  ctaBackgroundColor: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaLink: Scalars['String']['output'];
  fullPageImageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type MobileOrderGuideBannerShoppableFullWidthContent = {
  __typename?: 'MobileOrderGuideBannerShoppableFullWidthContent';
  orderGuideBannerImageUrl: Scalars['String']['output'];
  unitVariants: Array<SupplierVendorItemUnitVariant>;
};

export type MobilePostOrderPopupInfoFullPageContent = {
  __typename?: 'MobilePostOrderPopupInfoFullPageContent';
  ctaBackgroundColor: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaLink: Scalars['String']['output'];
  fullPageImageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Money = {
  __typename?: 'Money';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  decimalPlaces?: Maybe<Scalars['Int']['output']>;
};

/** Amount should be passed with the lowest denominations/cents */
export type MoneyInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type MoneyV2 = {
  __typename?: 'MoneyV2';
  /** The amount without decimal point, e.g. 1234 for $12.34 */
  amount: Scalars['Int']['output'];
  /** The currency code, e.g. "USD" */
  currency: Scalars['String']['output'];
  /** The number of decimal places in the amount, e.g. 2 for $12.34 */
  decimalPlaces: Scalars['Int']['output'];
};

export type MoneyV2Input = {
  /** The amount without decimal point, e.g. 1234 for $12.34 */
  amount: Scalars['Int']['input'];
  /** The currency code, e.g. "USD" */
  currency: Scalars['String']['input'];
  /** The number of decimal places in the amount, e.g. 2 for $12.34 */
  decimalPlaces: Scalars['Int']['input'];
};

export type MoneyV2InputOptional = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  decimalPlaces?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Minimum order value decision.
 *
 * Decision by scenario, with the status it carries. Same rule in every phase:
 * - check did not run -> NOT_EVALUATED, status SKIPPED
 * - no minimum applies -> PASSED, status SKIPPED
 * - required but could not be computed -> UNAVAILABLE, status SKIPPED
 * - the cart clears the minimum -> PASSED, status PASSED
 * - below a minimum the supplier does not enforce -> PASSED, status WARNING
 * - below, supplier does not accept top-up -> BLOCKED, status BLOCKED
 * - below, accepts top-up, delivery date is a top-up day -> TOP_UP_SATISFIABLE, status PASSED
 * - below, accepts top-up, delivery date is not -> TOP_UP_SATISFIABLE, status BLOCKED
 * - below, accepts top-up, EDIT with no date chosen yet -> TOP_UP_SATISFIABLE, status BLOCKED
 */
export const MovDecision = {
  /** The cart is below the minimum order value and there is no top-up path. */
  Blocked: 'BLOCKED',
  /** The minimum order value check did not run for this cart. */
  NotEvaluated: 'NOT_EVALUATED',
  /**
   * Nothing stops the cart on minimum order value: it meets the minimum, or it is
   * below one the supplier does not enforce. The status beside it separates the
   * two — PASSED when the minimum is met, WARNING when the cart is short but may
   * still be ordered, and the amounts then say by how much.
   */
  Passed: 'PASSED',
  /**
   * The cart is below the minimum order value and the supplier accepts top-up, so a
   * top-up could clear it. It does not mean there are eligible dates to top up on —
   * those need to be fetched from a separate endpoint. The status beside it says
   * whether this cart is already that top-up.
   */
  TopUpSatisfiable: 'TOP_UP_SATISFIABLE',
  /** The minimum order value check was required but could not be computed. */
  Unavailable: 'UNAVAILABLE'
} as const;

export type MovDecision = typeof MovDecision[keyof typeof MovDecision];
export type MovValidationResult = CartValidationResult & {
  __typename?: 'MovValidationResult';
  /**
   * Cart amount compared against the minimum order value. Present exactly when
   * requiredAmount is.
   */
  cartAmount?: Maybe<MoneyV2>;
  /**
   * Minimum order value decision for display. Commit impact is status
   * (+ isTopUp intent), not decision alone.
   */
  decision: MovDecision | '%future added value';
  overriddenBy?: Maybe<Scalars['String']['output']>;
  overrideable: Scalars['Boolean']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /** max(0, requiredAmount - cartAmount), preserving currency. */
  remainingAmount?: Maybe<MoneyV2>;
  /**
   * Configured minimum order value. Present only while the cart is below it,
   * whether that blocks or only warns. Null once the cart clears the minimum,
   * when the supplier has none, and when the check did not run.
   */
  requiredAmount?: Maybe<MoneyV2>;
  source: ValidationSource | '%future added value';
  status: ValidationStatus | '%future added value';
};

export type MultiLocationOrderGuidesV2ItemUnitsRemoveInput = {
  /**
   * The chats that the items will be removed from their orderGuides.
   * Include the source chat if the items are to be removed from it as well.
   */
  chatIds: Array<Scalars['ID']['input']>;
  /** If set to true, the operation will be validated but not executed. */
  dryRun: Scalars['Boolean']['input'];
  /** The product IDs to be removed. */
  vendorItemUnitIds: Array<Scalars['ID']['input']>;
};

export type MultiLocationOrderGuidesV2ItemUnitsRemoveResponse = AuthorizationFailure | InputValidationFailure | MultiLocationOrderGuidesV2ItemUnitsRemoveResult;

export type MultiLocationOrderGuidesV2ItemUnitsRemoveResult = {
  __typename?: 'MultiLocationOrderGuidesV2ItemUnitsRemoveResult';
  /** The removed order guide item units. */
  locations: Array<MultiLocationOrderGuidesV2ItemUnitsUpdateResultLocation>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type MultiLocationOrderGuidesV2ItemUnitsUpdateInput = {
  /**
   * The destination chats that the items will be copied to their orderGuides.
   * Returns an error for any chat that has multiple order guides.
   * Ignored when orderGuideIds is provided.
   * @deprecated Use orderGuideIds instead
   */
  chatIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If set to true, the operation will be validated but not executed. */
  dryRun: Scalars['Boolean']['input'];
  /** The items to update. */
  items: Array<MultiLocationOrderGuidesV2ItemUnitsUpdateInputItem>;
  /**
   * The destination order guides that the items will be copied to.
   * When provided, chatIds is ignored.
   */
  orderGuideIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The source chat that the items will be copied from its orderGuide.
   * Ignored when sourceOrderGuideId is provided.
   * @deprecated Use sourceOrderGuideId instead
   */
  sourceChatId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The source order guide that the items will be copied from.
   * When provided, sourceChatId is ignored.
   */
  sourceOrderGuideId?: InputMaybe<Scalars['ID']['input']>;
};

export type MultiLocationOrderGuidesV2ItemUnitsUpdateInputItem = {
  /**
   * The category name in the source order guide
   * If not provided, the item will be added/updated as uncategorized.
   */
  orderGuideCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the vendor item unit to update/add to the order guide. */
  vendorItemUnitId: Scalars['ID']['input'];
};

export type MultiLocationOrderGuidesV2ItemUnitsUpdateResponse = AuthorizationFailure | InputValidationFailure | MultiLocationOrderGuidesV2ItemUnitsUpdateResult;

export type MultiLocationOrderGuidesV2ItemUnitsUpdateResult = {
  __typename?: 'MultiLocationOrderGuidesV2ItemUnitsUpdateResult';
  /** The updated order guide item units. */
  locations: Array<MultiLocationOrderGuidesV2ItemUnitsUpdateResultLocation>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type MultiLocationOrderGuidesV2ItemUnitsUpdateResultLocation = {
  __typename?: 'MultiLocationOrderGuidesV2ItemUnitsUpdateResultLocation';
  chatId: Scalars['ID']['output'];
  /** The updated order guide item units. */
  items: Array<MultiLocationOrderGuidesV2ItemUnitsUpdateResultLocationItem>;
  orderGuideId: Scalars['ID']['output'];
};

export type MultiLocationOrderGuidesV2ItemUnitsUpdateResultLocationItem = {
  __typename?: 'MultiLocationOrderGuidesV2ItemUnitsUpdateResultLocationItem';
  /**
   * Should be one of the following:
   * - `Added`
   * - `Updated`
   * - `Removed`
   * If the operation was not successful, this field will no be returned.
   */
  action?: Maybe<Scalars['String']['output']>;
  /**
   * The error code if the operation was not successful.
   * Should be one of the following:
   * - `OG_NOT_FOUND`: The order guide was not found for the input chat, and can not be created.
   * - `ORDER_GUIDE_VENDOR_MISMATCH`: The destination order guide exists but belongs to a different vendor than the source chat.
   * - `VENDOR_ITEM_UNIT_NOT_FOUND`: The vendor item unit is not available or invalid for the destination chat.
   * - `BUYER_PROPERTIES_UPDATE_FAILED`: The vendor item unit was added/removed to/from the order guide, but the buyer properties update failed.
   */
  errorCode?: Maybe<Scalars['String']['output']>;
  /**
   * The buyer properties that failed to update, if any.
   * Only present for update operation (not remove) and while errorCode is `BUYER_PROPERTIES_UPDATE_FAILED`.
   */
  failedBuyerProperties?: Maybe<VendorItemUnitBuyerPropertiesWithPrice>;
  /** The error message if the operation was not successful. */
  message?: Maybe<Scalars['String']['output']>;
  /** Whether or not the operation was successful. */
  successfulOperation: Scalars['Boolean']['output'];
  /** The vendor item unit ID. */
  vendorItemUnitId: Scalars['ID']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptOrder: AcceptOrderResponse;
  addBuyerStockInventoryProduct: AddBuyerStockInventoryProductResponse;
  /** @deprecated Does not work anymore. Use `orderGuideV2ItemUnitsAdd` or `orderGuideV2BatchUpdate` instead */
  addCatalogProductsToProductList: Array<CategoryProducts>;
  addLabelToChats: Scalars['Boolean']['output'];
  /** Ensure that products are in catalog, then add them */
  addMarketingProductsToCart?: Maybe<AddMarketingProductsToCartResponse>;
  /** @deprecated Does not work anymore. Use `multiLocationOrderGuidesV2ItemUnitsUpdate` instead */
  addProductsToOrderGuides: AddProductsToOrderGuidesResponse;
  addSalesRep: AddSalesRepRequestToJoinResponse;
  /** Buyer Add Supplier Request */
  addSupplierRequest: BuyerAddSupplierResponse;
  addUserToChats: Scalars['Boolean']['output'];
  /** Move a lead to a different state in the sales funnel. */
  advanceSalesFunnelLead: AdvanceSalesFunnelLeadResponse;
  approveOrder: AcceptOrderResponse;
  assignOrderToUserForReview: AssignOrderToUserForReviewResponse;
  /** Assign a lead to a sales rep. */
  assignSalesFunnelLead: AssignSalesFunnelLeadResponse;
  automaticOrderProcessingThresholdSetting: AutomaticOrderProcessingThresholdSettingResponse;
  batchOrderConfirm?: Maybe<BatchOrderConfirmResponse>;
  /**
   * For internal use, to update the supplier of
   * all orders associated with a chat
   */
  batchUpdateOrderSupplier?: Maybe<BatchUpdateOrderSupplier>;
  billingDocumentExportCreate: BillingDocumentExportCreateResponse;
  broadcastCreate: Broadcast;
  broadcastUpdate: Broadcast;
  broadcastUpdatePurpose?: Maybe<BroadcastUpdatePurposeResult>;
  bulkDeclineOrders: BulkDeclineOrdersResponse;
  bulkSendInviteTransmission: BulkSendInviteTransmissionResponse;
  bulkSubmitOrderedProductDeliveryCheck?: Maybe<BulkOrderedProductDeliveryCheckSubmissionResponse>;
  /** Bulk upsert account owners for multiple chats */
  bulkUpsertAccountOwners: BulkUpsertAccountOwnersResponse;
  buyerAddUser: BuyerUser;
  buyerBulkAddUser: Array<Maybe<BuyerUser>>;
  buyerCreate: Buyer;
  buyerDisableRoles: BuyerDisableRolesResponse;
  buyerRemoveUser: BuyerUser;
  buyerUpdate: Buyer;
  /** Cancel the cart. This empties out the lineItems. */
  cancelCart?: Maybe<CancelCartResponse>;
  /** Cancel an active marketing campaign */
  cancelMarketingCampaign: MarketingCampaignUpdateResponse;
  /**
   * Evaluation of buyer cart intent. Never persists an order.
   * Mutation because BE may emit analytics/events. Phase selects the fan-out.
   * Merchandise (and REVIEW tax/fee) always run. Loyalty is estimated on
   * REVIEW only, with a longer Talon budget so points are present when the
   * buyer decides. EDIT leaves `loyalty` null so the cart screen is not held.
   */
  cartEvaluate: CartEvaluateResponse;
  /**
   * Edits the values of a product attribute (allergen or dietary preference).
   * Can be called by: Choco Admins, users of the Supplier.
   */
  catalogAttributeUpdate: CatalogAttributeUpdateResponse;
  /** Mutation to start a catalog export job. */
  catalogExportStart: CatalogExportStartResponse;
  /** Mutation to start a catalog import job. */
  catalogImportStart: CatalogImportStartResponse;
  /** @deprecated Does not work anymore. Use `orderGuideV2CategoriesUpdate` instead */
  categoryCreate: ProductCategory;
  /** @deprecated Does not work anymore. Use `orderGuideV2CategoriesUpdate` instead */
  categoryDelete: Array<Maybe<Scalars['ID']['output']>>;
  /** @deprecated Does not work anymore. Use `orderGuideV2BatchUpdate` or `orderGuideV2ItemUnitsUpdate` instead */
  categoryProductSort: Array<CategoryProducts>;
  /** @deprecated Does not work anymore. Use `orderGuideV2CategoriesUpdate` instead */
  categoryUpdate: ProductCategory;
  chatAssignmentImportJobGetOrCreate: ChatAssignmentImportJobInfo;
  chatCreate: Chat;
  chatDisable: Scalars['Boolean']['output'];
  chatInviteUsers: Chat;
  chatLeave?: Maybe<Scalars['ID']['output']>;
  /**
   * Admin only,
   * to update the main supplier of a chat
   * - migrate order to new supplier (bot user)
   * - add the new supplier into the chat
   * - remove the old supplier out the chat
   */
  chatMainSupplierMigrate: Scalars['Boolean']['output'];
  /** Mark all messages in a chat as read for the current user. */
  chatMarkRead: ChatMarkReadResponse;
  /**
   * Mark the chat read through this message for the current user.
   * Later unreads remain. Requires baseRev from the last observed Chat.unread.rev.
   */
  chatMessageMarkRead: ChatMessageMarkReadResponse;
  /** Mark a message and all later messages as unread for the current user. */
  chatMessageMarkUnread: ChatMessageMarkUnreadResponse;
  /**
   * Update chat prices visibility settings for a given chat.
   * Can be called by: Choco Admins, users of the Supplier to whom the chat belongs.
   */
  chatPricesVisibilityUpdate: ChatPricesVisibilityUpdateResponse;
  chatRemoveUsers: Chat;
  chatUpdate: Chat;
  /**
   * For internal use, to update the supplier of
   * a chat
   */
  chatUpdateMainSupplier: Scalars['Boolean']['output'];
  /** Commits a fresh server-authoritative evaluation when all commit rules pass. */
  checkoutCreate: CheckoutCreateResponse;
  claimOnboardingChecklistReward: ClaimOnboardingChecklistRewardResponse;
  confirmAccountLinking: ConfirmAccountLinkingResponse;
  confirmDeliveryCheckReconciliationRequest?: Maybe<ConfirmDeliveryCheckReconciliationResponse>;
  /** Confirm that the email editor state has been saved using the provided S3 key and version ID. */
  confirmSaveEmailEditorState: ConfirmSaveEmailEditorStateResponse;
  /**
   * Confirm that a transmission classified as `notAnOrder` is indeed not an order.
   * Transitions `classification` to `confirmedNotAnOrder`. No reprocessing.
   * Only valid when the current `classification` is `notAnOrder`.
   */
  confirmTransmissionNotAnOrder: ConfirmTransmissionNotAnOrderResponse;
  connectAccount: ConnectAccountResponse;
  /**
   * connectIntegrationAdapter is legacy mutation that should be used only by Harel untill end of Hydra migration
   * In order to create new Lobster and other CUSTOM integration connections use integrationAdapterConnectionCreate instead
   */
  connectIntegrationAdapter: ConnectIntegrationAdapterResponse;
  contactsCreate?: Maybe<Array<Maybe<User>>>;
  /**
   * This is an API for Choco AI users to correct an order.
   *
   * It will create a new correction order entry information and update cache and other dependencies.
   * It will also send a event of OrderCorrected to other listeners.
   */
  correctOrder: OrderCorrectionResponse;
  costDataImportJobGetOrCreate: CostDataImportJobInfo;
  costGuideImportJobGetOrCreate: CostGuideImportJobInfo;
  /** Create buyer report schedule */
  createBuyerReportSchedule: CreateBuyerReportScheduleResponse;
  /** Create a customer import job. */
  createCustomerImportJob: CreateCustomerImportJobResponse;
  /** Create a new distributor note. */
  createDistributorNote: CreateDistributorNoteResponse;
  /** Create a new distributor task */
  createDistributorTask: CreateDistributorTaskResponse;
  /** Creates a document scan entity for a lead */
  createDocumentScan: CreateDocumentScanResponse;
  /** Create marketing campaign with different channels */
  createMarketingCampaign: MarketingCampaignUpdateResponse;
  /** Creates a menu scan entity for a lead or customer */
  createMenuScan: CreateMenuScanResponse;
  createOmnichannelOrder: CreateOmnichannelOrderResponse;
  createOrderDeliveryCheck?: Maybe<OrderDeliveryCheckCreationResponse>;
  createOrderDeliveryCheckImageUploadUrl?: Maybe<OrderDeliveryCheckImageUploadUrlResponse>;
  createOrderDeskEmailList: CreateEmailListResponse;
  createOrderUpload: CreateOrderUploadResponse;
  createProfile: CreateProfileResponse;
  /** create endpoint for receiving mobile push notifications */
  createPushEndpoint?: Maybe<PushEndpointResponse>;
  /** Create endpoint for receiving mobile push notifications */
  createPushEndpointV2?: Maybe<PushEndpointResponse>;
  createReferral?: Maybe<CreateReferralResponse>;
  /** Create a new sales funnel. */
  createSalesFunnel: CreateSalesFunnelResponse;
  /**
   * Create a new lead in a sales funnel, including data about the lead, its
   * initial state, and the sales rep assigned to it.
   */
  createSalesFunnelLead: CreateSalesFunnelLeadResponse;
  /** Add an additional state at the end of the sales funnel */
  createSalesFunnelState: CreateSalesFunnelStateResponse;
  /**
   * Creates a new Custom Catalog for a given Supplier.
   * Can be called by: Choco Admin or Supplier user with the same id
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this mutation.
   */
  createSubCatalog?: Maybe<CreateSubCatalogResponse>;
  createSupplierContact: CreateSupplierContactResponse;
  /**
   * Creates new Catalog Product.
   * Does not support unit variants (will fail if there is already a product with the same `externalId`).
   * See `createSupplierProductV2` for the updated version.
   * `par` and `category` fields are ignored.
   * Can be called by: Choco Admin or Supplier user
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. See notice for `createSupplierProductV2`
   */
  createSupplierProduct: CreateUpdateSupplierProductResponse;
  /**
   * Creates new Catalog Product for a given Supplier.
   * Supports creating unit variants for Suppliers who are not in the UOM Exclusion List.
   * Can be called by: Choco Admin, Supplier User
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this mutation.
   */
  createSupplierProductV2: CreateUpdateSupplierProductResponse;
  /** Voice call order drafting workflow */
  createTransmission: CreateTransmissionResponse;
  creditNoteCreate: CreditNoteCreateResponse;
  /**
   * Incident-recovery reprocess of one or more transmissions on a chosen workflow
   * version — e.g. rolling transmissions processed by a buggy `V3` back through the
   * legacy `V2` engine. `fromVersion` asserts the engine that currently owns the
   * transmissions (validated against each stored media link); `targetVersion` is the
   * engine to reprocess on. Honors `preserveStatus` so orders already in a terminal
   * state are neither duplicated nor reverted, and is idempotent via the order-agent
   * claim store.
   *
   * Validation is all-or-nothing: every transmission is validated first, and if any
   * one fails NOTHING is triggered — the whole batch is rejected with
   * `CrossWorkflowReprocessRejected`, which returns every failed id and its reason.
   * Only when all pass are the reprocesses started. Intended for on-call use via Retool.
   */
  crossWorkflowReprocessTransmissions: CrossWorkflowReprocessTransmissionsResponse;
  /** Mutation to start a customCatalogFull import job. */
  customCatalogFullImportStart: CatalogImportStartResponse;
  /**
   * Updates the assignment of vendor item units to custom catalogs.
   * Can be called by: Choco Admins, users of the Supplier owning the custom catalog.
   */
  customCatalogsItemUnitsBatchUpdate: CustomCatalogsItemUnitsBatchUpdateResponse;
  /**
   * Updates the assignment of custom catalogs to the web shop.
   * The custom catalogs that are assigned to web shop will be publicly visible for anonymous users.
   * Can be called by: Choco Admins, users of the Supplier owning the custom catalogs.
   * All the custom catalog should be owned by the same supplier.
   */
  customCatalogsToWebShopAssignmentUpdate: CustomCatalogsToWebShopAssignmentUpdateResponse;
  /**
   * API for Choco admins to remove a single customer match cache entry, e.g. one that
   * maps a customer key to the wrong chat. The next order with the same key falls
   * back to customer search.
   */
  customerMatchCacheEntryRemove: CustomerMatchCacheEntryRemoveResponse;
  /**
   * Deactivate (archive) a state in the sales funnel. Only succeeds when the
   * state holds no leads and is not the funnel's last active state.
   */
  deactivateSalesFunnelState: DeactivateSalesFunnelStateResponse;
  declineOrder: DeclineOrderResponse;
  /** Delete buyer report schedule */
  deleteBuyerReportSchedule: DeleteBuyerReportScheduleResponse;
  deleteBuyerStockInventoryProducts: DeleteBuyerStockInventoryProductsResponse;
  /**
   * Deletes a deliverySetting if it is scoped to a specific chat.
   * If the mutation was a success, it returns the ID of the deleted deliverySetting.
   * If the deliverySetting was not scoped to a chat, it will return an error.
   */
  deleteChatDeliverySetting?: Maybe<DeletedChatSetting>;
  /** Delete a distributor note. */
  deleteDistributorNote: DeleteDistributorNoteResponse;
  /** Delete a distributor task */
  deleteDistributorTask: DeleteDistributorTaskResponse;
  /**
   * Completely deletes all Catalog Products for a given Supplier.
   * The operation is processed asynchronously. The products will be removed in background one by one.
   * The return number is meaningless.
   * Note that the Products may still be visible in the Order Guide it was added to as unavailable for a short period of time after the deletion.
   * Can be called by: Choco Admin to clean catalogs.
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this mutation.
   */
  deleteEntireSupplierProduct?: Maybe<Scalars['Int']['output']>;
  /**
   * Deletes attached image of a given Catalog Product
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Use `vendorItemUnitUpdate` instead
   */
  deleteProductImage?: Maybe<Scalars['Int']['output']>;
  deleteProfileImage?: Maybe<User>;
  /**
   * Deletes the provided Custom Catalog.
   * Can be called by: Choco Admin or user of a Supplier to whom the Custom Catalog belongs
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this mutation.
   */
  deleteSubCatalog?: Maybe<DeleteSubCatalogResponse>;
  /**
   * Deletes a given Catalog Product.
   * Note that the Products may still be visible in the Order Guide it was added to as unavailable for a short period of time after the deletion.
   * Can be called by: Choco Admin to clean catalogs.
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this mutation.
   */
  deleteSupplierProduct?: Maybe<Array<Scalars['ID']['output']>>;
  directPayCustomerOnboard: DirectPayCustomerOnboardResponse;
  directPayCustomerStatusUpdate: DirectPayCustomerStatusUpdateResponse;
  directPayPaymentMethodDelete: DirectPayPaymentMethodDeleteResponse;
  directPayPaymentMethodSetDefault: DirectPayPaymentMethodSetDefaultResponse;
  directPayPaymentSubmit: DirectPayPaymentSubmitResponse;
  disconnectAccount: DisconnectAccountResponse;
  disconnectIntegrationAdapter: DisconnectIntegrationAdapterResponse;
  /** Edit buyer report schedule */
  editBuyerReportSchedule: EditBuyerReportScheduleResponse;
  /** Edit a new lead in a sales funnel. */
  editSalesFunnelLead: EditSalesFunnelLeadResponse;
  /** Creates a new SFTP user with the specified credentials and permissions. */
  erpSftpUserCreate: ErpSftpUserCreateResponse;
  /** Updates an existing SFTP user's credentials, permissions, or activation status. */
  erpSftpUserUpdate: ErpSftpUserUpdateResponse;
  exportCustomers: ExportCustomersResponse;
  exportQuote: ExportQuoteResponse;
  /** Export filtered sales funnel leads to a downloadable file. */
  exportSalesFunnelLeads: ExportSalesFunnelLeadsResponse;
  /**
   * Choco admins only. Adds or removes values in one clause of a flag rule, e.g.
   * a supplierId in an `in` clause on the supplierId attribute.
   */
  featureFlagControlFlagClauseValuesUpdate: FeatureFlagControlFlagWriteResponse;
  /** Choco admins only. Turns a flag's targeting on or off in this environment. */
  featureFlagControlFlagToggle: FeatureFlagControlFlagWriteResponse;
  /** Choco admins only. Adds or removes values in one clause of a segment rule. */
  featureFlagControlSegmentClauseValuesUpdate: FeatureFlagControlSegmentWriteResponse;
  /**
   * Choco admins only. Adds or removes context keys in a segment's included or
   * excluded list.
   */
  featureFlagControlSegmentTargetsUpdate: FeatureFlagControlSegmentWriteResponse;
  /** Generate buyer report */
  generateBuyerReport: GenerateBuyerReportResponse;
  /** Generate a magic code for a chat. DX users only. */
  generateMagicCode: GenerateMagicCodeResponse;
  getOrderGuideUploadUrl: GetOrderGuideUploadUrlResponse;
  /**
   * Starts an async job that hard-deletes ALL imported historical orders and
   * their line items for a given vendor.
   *
   * This is destructive and removes the entire historical-orders dataset for
   * the vendor. Returns the queued job. Poll `historicalOrdersPurgeStatus`
   * with the returned `job.id` to observe progress and the final result.
   *
   * Can be called by: Choco Admin.
   */
  historicalOrdersPurgeStart: HistoricalOrdersPurgeStartResponse;
  /** @deprecated Does not work anymore. See notice for `importSupplierProductsV2` */
  importSupplierProducts: ImportSupplierProductsReport;
  /** @deprecated Does not work anymore. Use `catalogImportStart` instead */
  importSupplierProductsV2: ImportSupplierProductsReport;
  initiateAccountLinking: InitiateAccountLinkingResponse;
  insertOrUpdateSupplierContact?: Maybe<InsertOrUpdateSupplierContactResponse>;
  instantPayCustomerInvitationSend: InstantPayCustomerInvitationSendResponse;
  instantPayCustomerOnboard: InstantPayCustomerOnboardResponse;
  integrationAdapterConnectionAuth: IntegrationAdapterConnectionAuthResponse;
  integrationAdapterConnectionConsent: IntegrationAdapterConnectionConsentResponse;
  integrationAdapterConnectionCreate: IntegrationAdapterConnectionCreateResponse;
  integrationAdapterConnectionUpdate: IntegrationAdapterConnectionUpdateResponse;
  integrationAdapterCreate: IntegrationAdapterCreateResponse;
  integrationAdapterUpdate: IntegrationAdapterUpdateResponse;
  integrationWebhookRetry: IntegrationWebhookRetryResponse;
  internalInviteUsers: InternalInviteUsersResponse;
  /** Invalidate a magic code. DX users only. */
  invalidateMagicCode: InvalidateMagicCodeResponse;
  /** @deprecated use inviteUserToBuyer instead */
  inviteNonChocoUserToBuyer?: Maybe<InviteNonChocoUserToBuyerResponse>;
  inviteNonChocoUserToChat?: Maybe<Chat>;
  inviteUserToBuyer: InviteUserToBuyerResponse;
  invoiceCreate: InvoiceCreateResponse;
  joinLoyalty: JoinLoyaltyResponse;
  leaveLoyalty: LeaveLoyaltyResponse;
  legalEntityAddInstantPayCustomer: LegalEntityAddInstantPayCustomerResponse;
  loyaltyRedemptionCreate: LoyaltyRedemptionCreateResponse;
  loyaltyRedemptionUpdate: LoyaltyRedemptionUpdateResponse;
  markCustomerInsightsNotificationAsRead: MarkCustomerInsightsNotificationAsReadResponse;
  messageCreate: Message;
  multiLocationOrderGuidesV2ItemUnitsRemove: MultiLocationOrderGuidesV2ItemUnitsRemoveResponse;
  multiLocationOrderGuidesV2ItemUnitsUpdate: MultiLocationOrderGuidesV2ItemUnitsUpdateResponse;
  notificationCreate?: Maybe<Notification>;
  /** Marks the given notifications as read for the current user. */
  notificationInboxMarkRead: NotificationInboxMarkReadResponse;
  /** Internal (IAM only): sends an inbox update to `onNotificationInboxUpdateSubscription`. */
  notificationInboxUpdatePublish: NotificationInboxUpdate;
  notificationPreferencesUpdate?: Maybe<NotificationPreferences>;
  /** autopilotSubscription related mutation */
  notifyAutopilotOrderCreated: AutopilotSubscriptionResponse;
  notifyBulkOrderRejected: OmnichannelOrderStatusSubscriptionResponse;
  /**
   * Notify subscribers that a chat changed for a user.
   * Backend-only; not for client use.
   */
  notifyChatUpdated: ChatUpdateSubscriptionResponse;
  notifyCustomerInsightsNotificationCreated: CustomerInsightsNotificationSubscriptionResponse;
  notifyOmnichannelOrderCreated: OmnichannelOrderStatusSubscriptionResponse;
  notifyOmnichannelOrderDraftUpdated: OmnichannelOrderStatusSubscriptionResponse;
  notifyOrderAccepted: OmnichannelOrderStatusSubscriptionResponse;
  notifyOrderConfirmed: OmnichannelOrderStatusSubscriptionResponse;
  notifyOrderRejected: OmnichannelOrderStatusSubscriptionResponse;
  notifyTransmissionCreated: OmnichannelOrderStatusSubscriptionResponse;
  /** transmissionEventSubscription related mutation */
  notifyTransmissionEventCreated: TransmissionEventSubscriptionResponse;
  notifyTransmissionReceived: OmnichannelOrderStatusSubscriptionResponse;
  notifyTransmissionV2OrdersFullyProcessed: TransmissionV2SubscriptionResponse;
  notifyTransmissionV2Processed: TransmissionV2SubscriptionResponse;
  /** transmissionV2Subscription related mutations */
  notifyTransmissionV2Received: TransmissionV2SubscriptionResponse;
  orderConfirm?: Maybe<Message>;
  orderCreate: Order;
  orderCreateV2?: Maybe<OrderCreatedResponse>;
  orderEdit?: Maybe<OrderEditedResponse>;
  orderGuideCreated: OrderGuideCreatedResponse;
  orderGuideRequest: OrderGuideRequestResponse;
  orderGuideV2BatchUpdate: OrderGuideV2BatchUpdateResponse;
  orderGuideV2CategoriesUpdate: OrderGuideV2CategoriesUpdateResponse;
  orderGuideV2CategoryItemUnitsUpdateAll: OrderGuideV2CategoryItemUnitsUpdateAllResponse;
  orderGuideV2ItemUnitOrderGuidesUpdate: OrderGuideV2ItemUnitOrderGuidesUpdateResponse;
  orderGuideV2ItemUnitsAdd: OrderGuideV2ItemUnitsAddResponse;
  orderGuideV2ItemUnitsRemove: OrderGuideV2ItemUnitsRemoveResponse;
  orderGuideV2ItemUnitsUpdate: OrderGuideV2ItemUnitsUpdateResponse;
  orderGuideV2OrderGuideCreate: OrderGuideV2OrderGuideCreateResponse;
  orderGuideV2OrderGuideRemove: OrderGuideV2OrderGuideRemoveResponse;
  orderGuideV2OrderGuideUpdate: OrderGuideV2OrderGuideUpdateResponse;
  paymentCustomerContactsUpdate: PaymentCustomerContactsUpdateResponse;
  paymentCustomerUpdateAllForLegalEntity: PaymentCustomerUpdateAllForLegalEntityResponse;
  paymentLegalEntityUpdate: PaymentLegalEntityUpdateResponse;
  paymentLinkGenerate: PaymentLinkGenerateResponse;
  paymentMethodRequest: PaymentMethodRequestResponse;
  paymentMethodRequestResend: PaymentMethodRequestResendResponse;
  /** Prepare to save the email editor state by generating an upload URL and S3 key. */
  prepareSaveEmailEditorState: PrepareSaveEmailEditorStateResponse;
  /** @deprecated Does not work anymore. Use `orderGuideV2BatchUpdate` instead */
  productBatchCreate: Scalars['String']['output'];
  /** @deprecated Does not work anymore. Use `orderGuideV2BatchUpdate` instead */
  productCreate: Product;
  /** @deprecated Does not work anymore. Use `orderGuideV2BatchUpdate` instead */
  productDelete: Array<Maybe<Scalars['ID']['output']>>;
  /**
   * API for Choco admins to remove product match cache entries, e.g. ones that map
   * a product key to the wrong product. The next order line with a removed key falls
   * back to product search.
   */
  productMatchCacheEntriesRemove: ProductMatchCacheEntriesRemoveResponse;
  /**
   * API for Choco admins to clear the learned quantity coefficient of a product match
   * cache entry while keeping its matched product.
   */
  productMatchCacheEntryCoefficientClear: ProductMatchCacheEntryCoefficientClearResponse;
  /** @deprecated Does not work anymore. Use `orderGuideV2BatchUpdate` instead */
  productSort: Array<Maybe<Scalars['ID']['output']>>;
  /** @deprecated Does not work anymore. Use `orderGuideV2BatchUpdate` instead */
  productUpdate: Product;
  /** @deprecated Does not work anymore. Use `orderGuideV2BatchUpdate` instead */
  productUpdateCategory: UpdatedCategoryProduct;
  /**
   * Updates the externalId of a given Custom Product.
   * Can be called by: Choco Admin or Buyer user
   * Buyer user must be in the chat
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Use `vendorItemUnitUpdate` instead
   */
  productUpdateExternalId: Product;
  /**
   * Upserts (creates or updates) punchout configurations in batch.
   * Uses chatId as natural key for upsert operations.
   * Can be called by: Choco Admins
   */
  punchoutConfigurationsUpsert: PunchoutConfigurationsUpsertResponse;
  quoteArchive: QuoteArchiveResponse;
  /**
   * Adds a new comment to a quote row under the chosen role. The submitted
   * content is validated against the role's active RoleCommentSettings.
   */
  quoteCommentAdd: QuoteCommentAddResponse;
  /**
   * Soft-deletes a comment. The row remains in storage for backend audit and
   * is filtered from every read path. Same-role rule applies: `role` must
   * match the comment's createdByRole.
   */
  quoteCommentDelete: QuoteCommentDeleteResponse;
  /**
   * Full-replacement update of an existing comment. The client always sends
   * both content fields (each may be null); the resulting pair is re-validated
   * against the role's current settings. Last write wins — no etag is required.
   * Same-role rule applies: `role` must match the comment's createdByRole.
   */
  quoteCommentUpdate: QuoteCommentUpdateResponse;
  quoteConflictsResolve: QuoteConflictsResolveResponse;
  quoteCreate: QuoteCreateResponse;
  /**
   * Evaluates the provided edits against the current quote state without persisting.
   * Intended for clients to re-evaluate quote-level view data as they make edits.
   */
  quoteEditsEvaluate: QuoteEditsEvaluateResponse;
  quoteEditsSubmit: QuoteEditsSubmitResponse;
  quoteGenerationJobAttachmentUploadLinkCreate: QuoteGenerationJobAttachmentUploadLinkCreateResponse;
  quoteGenerationJobCreate: QuoteGenerationJobCreateResponse;
  quoteGenerationJobRemove: QuoteGenerationJobRemoveResponse;
  quoteGenerationJobRetry: QuoteGenerationJobRetryResponse;
  quoteGenerationJobStart: QuoteGenerationJobStartResponse;
  /** Submits reviewer decisions for quote items under review. */
  quoteReviewSubmit: QuoteReviewSubmitResponse;
  /** Submits a draft quote into the approval flow. */
  quoteSubmitForReview: QuoteSubmitForReviewResponse;
  quoteUnarchive: QuoteUnarchiveResponse;
  referUser?: Maybe<ReferUserResponse>;
  refreshOrderDesk: OmnichannelOrdersSubcriptionResponse;
  rejectOrder: RejectOrderResponse;
  rejectOrdersById: RejectOrdersByIdResponse;
  /** Only admin can remove the blocked email and the return is a null */
  removeBlockedEmail?: Maybe<Scalars['Int']['output']>;
  /** Remove an email from the 'chat.additionalEmails' list across all chats */
  removeCCEmailFromChats: RemoveCcEmailFromChatsReport;
  removeEmailFromBuyerReportSchedule?: Maybe<RemoveEmailFromBuyerReportScheduleResponse>;
  removeLabelFromChats: Scalars['Boolean']['output'];
  removeOrderDeskEmail: OrderDeskRemovedEmailResponse;
  /** @deprecated Does not work anymore. Use `multiLocationOrderGuidesV2ItemUnitsRemove` instead */
  removeProductsFromOrderGuides: RemoveProductsFromOrderGuidesResponse;
  removeSupplierBuyerMov?: Maybe<MinimumOrderValueUpdateResponse>;
  removeUserFromChats: Scalars['Boolean']['output'];
  /** Rename an existing state in the sales funnel */
  renameSalesFunnelState: RenameSalesFunnelStateResponse;
  /** Reopens a settled quote so the sales rep can make edits. */
  reopenQuote: ReopenQuoteResponse;
  /**
   * Reprocess a transmission. Use when a user contests a `notAnOrder`
   * classification or when retrying any other transmission.
   */
  reprocessTransmission: ReprocessTransmissionResponse;
  requestToJoinBuyer: RequestToJoinBuyerResponse;
  retryOrderProcessing: RetryOrderProcessingResponse;
  /**
   * Add a phone number to Twilio's Safelist.
   * A phone number that is safe listed will be able to receive OTPs from Twilio
   *   even if its country is geo-blocked and will never be blocked by Twilio's FraudGuard.
   */
  safelistTwilioUser: SafelistTwilioUserResponse;
  /** @deprecated Does not work anymore. Use `orderGuideV2BatchUpdate` or `orderGuideV2ItemUnitsAdd` instead */
  selectProductForOrderGuide: SelectProductForOrderGuideResponse;
  selectProductsForOrderGuide: SelectProductsForOrderGuideResponse;
  /**
   * Send email marketing campaign to all contacts, to be deprecated when other channels are supported
   * @deprecated use sendMarketingCampaign instead
   */
  sendEmailMarketingCampaignToAll: MarketingCampaignUpdateResponse;
  /**
   * Send email marketing campaign to specific chats, to be deprecated when other channels are supported
   * @deprecated use sendMarketingCampaign instead
   */
  sendEmailMarketingCampaignToChats: MarketingCampaignUpdateResponse;
  /** Invite Transmission */
  sendInviteTransmission: SendInviteTransmissionResponse;
  /** Send marketing campaign to different channels */
  sendMarketingCampaign: MarketingCampaignUpdateResponse;
  /** Send marketing campaign to different channels */
  sendMarketingCampaignV2: MarketingCampaignUpdateResponse;
  sendSyntheticSmsMessage: SendSyntheticSmsMessageResponse;
  sendSyntheticWhatsAppMessage: SendSyntheticWhatsAppMessageResponse;
  /** Create or update marketing email sender configuration */
  setMarketingEmailSender: SetMarketingEmailSenderResponse;
  /**
   * Sets the isTest field of order to true. You cannot set the value back to false.
   * Is accessible only by admin
   */
  setOrderAsTest: SetOrderAsTestResponse;
  /**
   * Sets the isTest field of orders to true. You cannot set the value back to false.
   * Is accessible only by admin
   */
  setOrderAsTestBulk: SetOrderAsTestResponse;
  /**
   * Set or update order override permissions for a user in a specific supplier context.
   * This allows admins to configure which validation rules a user can bypass when reviewing orders.
   */
  setUserOrderOverridePermissions: SetUserOrderOverridePermissionsResponse;
  settlementReportCreate: SettlementReportCreateResponse;
  shortenUrl: Scalars['String']['output'];
  signupFormConfigUpdate: SignupFormConfigUpdateResponse;
  /** Set whether one email domain of an SSO connection allows local sign-up. */
  ssoEmailDomainExclusivitySet: SsoEmailDomainExclusivitySetResponse;
  /** Map one role asserted by an identity provider onto a supplier and a Choco role. */
  ssoRoleMappingCreate: SsoRoleMappingCreateResponse;
  /** Remove one role mapping. Users holding the role stop resolving to the supplier. */
  ssoRoleMappingDelete: SsoRoleMappingDeleteResponse;
  /** Starts a document scan */
  startDocumentScan: UpdateDocumentScanResponse;
  /** Starts a menu scan */
  startMenuScan: UpdateMenuScanResponse;
  submitBuyerStockCount: BuyerStockCountResponse;
  /** Submit the cart for checkout. This creates an order from the line items in the cart. */
  submitCart?: Maybe<CartSubmissionResponse>;
  /** Submit a magic code to join a buyer and chat. Buyer users only. */
  submitMagicCode: SubmitMagicCodeResponse;
  submitOrderDeliveryCheck?: Maybe<OrderDeliveryCheckSubmissionResponse>;
  submitOrderedProductDeliveryCheck?: Maybe<OrderedProductDeliveryCheckSubmissionResponse>;
  /**
   * Create or update supplier agent settings for a given supplier and agent profile type.
   * Uses the (supplierId, agentProfileType) pair as the natural key for upsert.
   */
  supplierAgentSettingsUpsert: SupplierAgentSettingsUpsertResponse;
  /** Atomically insert/overwrite/clear customer-level delivery-fee tiers for 1–50 buyers. Allowed for Choco admins and supplier users of the same supplier. */
  supplierBuyerDeliveryFeeUpsert: SupplierBuyerDeliveryFeeUpsertResponse;
  supplierCreate: Supplier;
  /** Insert/overwrite the supplier-default delivery-fee tiers, or clear them with an empty `tiers` list. Allowed for Choco admins and supplier users of the same supplier. */
  supplierDeliveryFeeUpsert: SupplierDeliveryFeeUpsertResponse;
  /** Get in touch form for suppliers to request a callback from Ops for contracts. */
  supplierGetInTouchRequest?: Maybe<SupplierGetInTouchRequestResponse>;
  /**
   * Changes a supplier's place in the multi-entity hierarchy, and updates its
   * children accordingly.
   *
   * A null `parentId` detaches the supplier, which becomes its own hierarchy root.
   *
   * `hierarchyType` may only be changed while the supplier has no parent and no
   * children.
   *
   * Admin only.
   */
  supplierHierarchyUpdate: SupplierHierarchyUpdateResponse;
  /** @deprecated use supplierInviteUsersV2 instead */
  supplierInviteUser: SupplierInviteUserResponse;
  /** @deprecated use supplierInviteUsersV2 instead */
  supplierInviteUsers: SupplierInviteUserResponse;
  supplierInviteUsersV2: SupplierInviteUserResponse;
  /** Allow SupplierAdmins to remove user (supplierAdmin/SalesReps) from team */
  supplierRemoveUser: User;
  /** smart order specific supplier settings */
  supplierSetting: SupplierSettingResponse;
  supplierUpdate: Supplier;
  /** API for vendor team management */
  supplierUserCreate?: Maybe<User>;
  supplierUserRemove: SupplierUserRemoveResponse;
  /** @deprecated Use switchAndSaveMappingUpsert instead. */
  switchAndSaveMappingCreate: SwitchAndSaveMappingCreateResponse;
  switchAndSaveMappingDelete: SwitchAndSaveMappingDeleteResponse;
  switchAndSaveMappingUpsert: SwitchAndSaveMappingUpsertResponse;
  /**
   * Sync user data to Cognito. To be used when a user state on Cognito is not properly synced after an organic signup or admin creation.
   * Be careful when triggering this mutation, as it executes admin operations towards Cognito's API.
   *  When used to sync inactive users, Cognito will start treating them as active for a billing month, which will incur additional costs.
   */
  syncCognitoUser: SyncCognitoUserResponse;
  /**
   * Add an existing Choco user to the workspace as a member with no roles.
   * Eventually moves behind the admin and invite workflows.
   */
  teamMemberAdd: TeamMemberAddResponse;
  /**
   * Apply explicit Upsert and Delete commands to workspace members' location
   * assignments atomically. Each command requires the caller's permission for
   * that action at that location; unmentioned assignments are not changed or
   * reauthorized. Any validation or authorization failure leaves the batch unapplied.
   */
  teamMemberLocationAssignmentsBatchMutate: TeamMemberLocationAssignmentsBatchMutateResponse;
  /** Remove one role a member holds at one location. */
  teamMemberRemoveLocationAssignment: TeamMemberRemoveLocationAssignmentResponse;
  /** Remove the member from the workspace, dropping every role they hold. */
  teamMemberRevokeAllWorkspaceAccess: TeamMemberRevokeAllWorkspaceAccessResponse;
  /** Grant a member a role at each of the given locations, in one transaction. */
  teamMemberSetLocationAssignments: TeamMemberSetLocationAssignmentsResponse;
  /** Update team notification preferences for the supplier account. Admins write. */
  teamNotificationPreferencesUpdate: TeamNotificationPreferencesResponse;
  triggerProductMatching: TriggerProductMatchingResponse;
  unassignUserFromOrderToReview: UnassignUserFromOrderToReviewResponse;
  /** @deprecated Does not work anymore */
  undoMultiLocationOrderGuideTransaction: UndoMultiLocationOrderGuideTransactionResponse;
  /** @deprecated Does not work anymore. Use `orderGuideV2BatchUpdate` instead */
  updateBuyerInventoryProduct: UpdateBuyerInventoryProductResponse;
  updateBuyerStockInventoryProduct: UpdateBuyerStockInventoryProductResponse;
  updateBuyerUserChats: UpdateBuyerUserChatsResponse;
  /** update the cart items. */
  updateCart?: Maybe<CartUpdateResponse>;
  updateChatEnabled: Scalars['Boolean']['output'];
  updateChatNotificationPreferences?: Maybe<ChatNotificationPreferences>;
  /** Update supplier chat-level notification preferences */
  updateChatNotificationPreferencesV2?: Maybe<ChatNotificationPreferences>;
  updateChatOrderingSettings?: Maybe<ChatOrderingSettingsUpdateResponse>;
  /** Update a distributor note. */
  updateDistributorNote: UpdateDistributorNoteResponse;
  /** Update an existing distributor task */
  updateDistributorTask: UpdateDistributorTaskResponse;
  /** Update the status of an existing distributor task */
  updateDistributorTaskStatus: UpdateDistributorTaskStatusResponse;
  /** Update document scan attachments */
  updateDocumentScanAttachments: UpdateDocumentScanResponse;
  /**
   * Update invoiced product
   * @deprecated No longer supported since Jun 2024
   */
  updateInvoicedProduct: UpdateInvoicedProductResponse;
  updateLoyaltySettings: UpdateLoyaltySettingsResponse;
  /** Update marketing campaign with attachments which are already uploaded in S3 */
  updateMarketingCampaignAttachments: MarketingCampaignUpdateResponse;
  /** Update chat message content for the marketing campaign */
  updateMarketingCampaignChatMessageContent: MarketingCampaignUpdateResponse;
  /** Update email content for the marketing campaign */
  updateMarketingCampaignEmailContent: MarketingCampaignUpdateResponse;
  /** Update the email HTML and template URI for the campaign, to be used for email compilation in backend */
  updateMarketingCampaignEmailTemplateUri: MarketingCampaignUpdateResponse;
  /**
   * Set or clear the end date for a DRAFT marketing campaign.
   * If endDate is omitted or null, the campaign will run indefinitely once published.
   */
  updateMarketingCampaignEndDate: MarketingCampaignUpdateResponse;
  /** Update home promo content for the marketing campaign */
  updateMarketingCampaignHomePromoContent: MarketingCampaignUpdateResponse;
  /** Update marketing campaign title and channels */
  updateMarketingCampaignInfo: MarketingCampaignUpdateResponse;
  /** Update preferred products content for the marketing campaign */
  updateMarketingCampaignPreferredProductsContent: MarketingCampaignUpdateResponse;
  /** Update marketing campaign with vendor item units */
  updateMarketingCampaignVendorItemUnits: MarketingCampaignUpdateResponse;
  /** Update welcome banner content for the marketing campaign */
  updateMarketingCampaignWelcomeBannerContent: MarketingCampaignUpdateResponse;
  /** Update menu scan attachments */
  updateMenuScanAttachments: UpdateMenuScanResponse;
  /**
   * For internal use, to update a users
   * notificationPreferences ID when a users role is updated
   */
  updateNotificationUserId?: Maybe<NotificationPreferences>;
  updateOmnichannelOrderCustomer: UpdateOmnichannelOrderCustomerResponse;
  updateOmnichannelOrderDeliveryDate: UpdateOmnichannelOrderDeliveryDateResponse;
  updateOmnichannelOrderProducts: UpdateOmnichannelOrderProductsResponse;
  updatePendingUser: UpdatePendingUserResponse;
  /** @deprecated Does not work anymore. Use `orderGuideV2ItemUnitsUpdate` or `orderGuideV2BatchUpdate` instead */
  updateProductVariantsInOrderGuide: UpdateProductVariantsInOrderGuideResponse;
  updateRequestToJoin: UpdateJoinRequestResponse;
  /** Update the archive status of a lead in a sales funnel. */
  updateSalesFunnelLeadArchiveStatus: UpdateSalesFunnelLeadArchiveStatusResponse;
  /** Updates the order of the states in the sales funnel. */
  updateSalesFunnelStateOrder: UpdateSalesFunnelStateOrderResponse;
  /**
   * Updates the name of a given Custom Catalog.
   * Can be called by: Choco Admin or user of a Supplier to whom the Custom Catalog belongs
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this mutation.
   */
  updateSubCatalog?: Maybe<UpdateSubCatalogResponse>;
  /**
   * Changes the set of Chats assigned to a given Custom Catalog.
   * Can be called by: Choco Admin, Supplier User
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this mutation.
   */
  updateSubCatalogChats: UpdateSubCatalogChatsResponse;
  updateSupplierAccessPackage: SupplierUpdateAccessPackageResponse;
  updateSupplierBuyerMov?: Maybe<MinimumOrderValueUpdateResponse>;
  /** @deprecated Use supplierSetting mutation with isOrderAgentEnabled field instead. This mutation will be removed in a future release. */
  updateSupplierContact: UpdateSupplierContactResponse;
  /** Admin/Supplier Admin only */
  updateSupplierDeliverySetting?: Maybe<SupplierDeliverySetting>;
  /**
   * Changes a specific field of a given Supplier Product.
   * Assumes that the supplier is not in the UOM Exclusion List, allows multiple products to have the same externalId if they have different units.
   * Can be called by: Choco Admin, Supplier User
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Use `vendorItemUnitUpdate` instead
   */
  updateSupplierProduct: CreateUpdateSupplierProductResponse;
  /**
   * Partially updates a given Supplier Product.
   * Refer to the input type documentation for the specific field by field information.
   * Assumes that the supplier is not in the UOM Exclusion List, allows multiple products to have the same externalId if they have different units.
   * Can be called by: Choco Admin, Supplier User
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Use `vendorItemUnitUpdate` instead
   */
  updateSupplierProductV2: CreateUpdateSupplierProductResponse;
  updateSupplierUserChats: SupplierUserUpdateChatsResponse;
  updateSupplierUserRoles?: Maybe<User>;
  /**
   * This is an API for Choco admins to update the "progressStatus" of transmissions.
   *
   * When "processed"" is selected, it transitions to "progressStatus" to "processed",
   * When "failed" OR "partiallyFailed" is selected and no order already exist for the transmission, it transitions to "failed",
   * When "failed" OR "partiallyFailed" is selected and at least one order already exist for the transmission, it transitions to "partiallyFailed",
   * Else, a "Unsupported" warning is returned
   */
  updateTransmissionProgressStatus: ListProcessingTransmissionsResponse;
  /** @deprecated Does not work anymore. See notice for `uploadSubCatalogProductsV2` */
  uploadSubCatalogProducts: UploadSubCatalogProductsResponse;
  /** @deprecated Does not work anymore */
  uploadSubCatalogProductsV2: UploadSubCatalogProductsResponse;
  /** @deprecated use updateSupplierUserRoles instead */
  userAddRole?: Maybe<User>;
  /** Admin Only, confirm pending users on cognito */
  userConfirm: Scalars['Boolean']['output'];
  userCreate?: Maybe<User>;
  userLeadCreate?: Maybe<UserLead>;
  /**
   * Clear the per-chat personal notification preference override
   * (chat falls back to profile-level preferences).
   */
  userNotificationPreferencesForChatClear: UserNotificationPreferencesForChatResponse;
  /** Create or replace the per-chat personal notification preference override. */
  userNotificationPreferencesForChatUpdate: UserNotificationPreferencesForChatResponse;
  /** Update profile-level personal notification preferences for the current user. */
  userNotificationPreferencesUpdate: UserNotificationPreferencesResponse;
  /** @deprecated use updateSupplierUserRoles instead */
  userRemoveRole?: Maybe<User>;
  userRequestToDelete: UserRequestToDeleteResponse;
  /** Opt the signed-in supplier user in or out of team chat notifications. */
  userTeamChatNotificationsOptInUpdate: UserTeamChatNotificationsOptInResponse;
  userUpdate?: Maybe<User>;
  /**
   * Create new image identifiers and prepares the image upload links for given categories.
   * Each category can only have a single image.
   * Note that the image is category-specific and cannot be shared between categories.
   * The image upload process works like this:
   * 1. Use this mutation to request image ids and upload urls.
   * 2. Upload images to the provided urls (check the docs for `uploadUrl` response field for more info).
   * 3. Call `vendorItemCategoriesUpdate` to associate the uploaded images with the categories.
   * Unassigned images will be eventually deleted.
   * Can be called by: Choco Admins, users of the Supplier owning the categories.
   */
  vendorItemCategoriesImagesUpload: VendorItemCategoriesImagesUploadResponse;
  /**
   * Partially updates given catalog categories.
   * Can be called by: Choco Admins, users of the Supplier owning the categories.
   */
  vendorItemCategoriesUpdate: VendorItemCategoriesUpdateResponse;
  /**
   * Creates a new Custom Product with additional buyer properties.
   * Can be called by: Choco Admins, users of this Buyer.
   */
  vendorItemCustomCreate: VendorItemCustomCreateResponse;
  /**
   * Updates a Custom Product with its buyer properties.
   * Can be called by: Choco Admins, users of the Buyer that owns the custom product.
   */
  vendorItemCustomUpdate: VendorItemCustomUpdateResponse;
  /**
   * Update specific buyer properties of a vendor item unit.
   * Can be called by: Choco Admins, users of this Buyer
   */
  vendorItemUnitBuyerPropertiesUpdate: VendorItemUnitBuyerPropertiesUpdateResponse;
  /**
   * Partially updates given vendor item unit buyer properties in batch.
   * Can be called by: Choco Admins, users of Buyer to whom the properties belong.
   */
  vendorItemUnitBuyerPropertiesUpdateBatch: VendorItemUnitBuyerPropertiesUpdateBatchResponse;
  /**
   * Changes the customer-specific price of the vendor item unit for a given buyer.
   * Can be called by: Choco Admins, users of the Supplier owning the vendor item unit.
   */
  vendorItemUnitCustomerSpecificPriceUpdate: VendorItemUnitCustomerSpecificPriceUpdateResponse;
  /**
   * Partially updates a given vendor item unit.
   * Can be called by: Choco Admins, users of the Supplier owning the item unit.
   */
  vendorItemUnitUpdate: VendorItemUnitUpdateResponse;
  /**
   * Create new image identifiers and prepares the image upload links for given vendor item units.
   * Note that the image is unit-specific and cannot be shared between units.
   * The image upload process works like this:
   * 1. Use this mutation to request image ids and upload urls.
   * 2. Upload images to the provided urls (check the docs for `uploadUrl` response field for more info)
   * 3. Call `vendorItemUnitsUpdate` to associate the uploaded images with the vendor item units and specify the correct order.
   * Unassigned images will be eventually deleted.
   * Can be called by: Choco Admins, users of the Supplier owning the vendor item units.
   */
  vendorItemUnitsImagesUpload: VendorItemUnitsImagesUploadResponse;
  /**
   * Partially updates given vendor item units.
   * Can be called by: Choco Admins, users of the Supplier owning the vendor item units.
   */
  vendorItemUnitsUpdate: VendorItemUnitsUpdateResponse;
  /**
   * Sets the boost status of one or more of a vendor's brands. Accepts any
   * `brandKey`, including one absent from the vendor's catalog.
   * Can be called by supplier admins associated with the vendor.
   */
  vendorPreferredBrandsUpdate: VendorPreferredBrandsUpdateResponse;
  /**
   * Sets the Choco-side display overrides of a promotion's copy per locale.
   * Can be called by: Choco admins.
   */
  vendorPromotionMarketingUpdate: VendorPromotionMarketingUpdateResponse;
  /**
   * Creates a custom search synonym rule for a vendor.
   * Can be called by supplier admins associated with the vendor.
   */
  vendorSearchSynonymCreate: VendorSearchSynonymResponse;
  /**
   * Updates a custom search synonym rule for a vendor.
   * Can be called by supplier admins associated with the vendor.
   */
  vendorSearchSynonymUpdate: VendorSearchSynonymResponse;
  /**
   * Deletes custom search synonym rules for a vendor.
   * Can be called by supplier admins associated with the vendor.
   */
  vendorSearchSynonymsDelete: VendorSearchSynonymsDeleteResponse;
  /**
   * Start a WebRTC session with a voice agent.
   * The service will help negotiate the WebRTC connection by transmitting SDP offers/answers.
   * The client can use the returned SDP to establish a WebRTC connection with the voice agent.
   * Simultaneously we will listen for events that occur during the session and process them accordingly.
   */
  voiceAgentWebRTCSessionStart: VoiceAgentWebRtcSessionStartResponse;
  webshopCatalogSync: WebshopCatalogSyncResponse;
  webshopConfigUpdate: WebshopConfigUpdateResponse;
  /**
   * Batch create or update product collections for a vendor's webshop.
   * This is a DECLARATIVE API that replaces the full state of each collection.
   *
   * UI USAGE:
   * - Called when user clicks "SAVE CHANGES" button
   * - Sends ALL collections (both new and existing) in single request
   * - Each collection's products array replaces existing products
   * - Supports partial success (some collections update, others fail)
   *
   * OPERATIONS:
   * - Create: Pass collection with id: null
   * - Update: Pass collection with existing id
   * - Delete: Omit collection from array
   * - Reorder: Change displayOrder values
   *
   * LIMITS:
   * - Maximum 50 collections per request
   * - Maximum 15 products per collection
   *
   * Can be called by: Choco Admins, Supplier Users
   */
  webshopProductCollectionsBatchUpdate: WebshopProductCollectionsBatchUpdateResponse;
  webshopWelcomeBannerImageUpload: WebshopWelcomeBannerImageUploadResponse;
  /**
   * Create or update a welcome banner for a vendor's webshop.
   * If a banner already exists for the vendor, it will be updated.
   * If no banner exists, a new one will be created.
   *
   * UI USAGE:
   * - Called when user saves the welcome banner form
   * - No separate create vs update logic needed
   * - Idempotent: Can call multiple times with same data
   *
   * Can be called by: Choco Admins, Supplier Users
   */
  webshopWelcomeBannerUpdate: WebshopWelcomeBannerUpdateResponse;
  wholesailBuyerSessionStart: WholesailBuyerSessionStartResponse;
  /** Create a wholesail vendor, or update its config if one already exists for the vendorId. Admin only. */
  wholesailVendorCreate: WholesailVendorCreateResponse;
  /**
   * Create a workspace holding the given location as its first root. Choco
   * admin only.
   */
  workspaceCreate: WorkspaceCreateResponse;
};


export type MutationAcceptOrderArgs = {
  acceptedOrder: AcceptOrderInput;
  id: Scalars['ID']['input'];
};


export type MutationAddBuyerStockInventoryProductArgs = {
  input: AddBuyerStockInventoryProductInput;
};


export type MutationAddCatalogProductsToProductListArgs = {
  catalogProductList: Array<ProductsCategoryInput>;
  chatId: Scalars['ID']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddLabelToChatsArgs = {
  chatIds: Array<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
};


export type MutationAddMarketingProductsToCartArgs = {
  chatId: Scalars['ID']['input'];
  products: Array<AddMarketingProductsToCartInput>;
};


export type MutationAddProductsToOrderGuidesArgs = {
  input: AddProductsToOrderGuidesInput;
};


export type MutationAddSalesRepArgs = {
  input?: InputMaybe<AddSalesRepRequestToJoinInput>;
};


export type MutationAddSupplierRequestArgs = {
  input: BuyerAddSupplierInput;
};


export type MutationAddUserToChatsArgs = {
  chatIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationAdvanceSalesFunnelLeadArgs = {
  input: AdvanceSalesFunnelLeadInput;
};


export type MutationApproveOrderArgs = {
  approvedOrder: AcceptOrderInput;
  id: Scalars['ID']['input'];
};


export type MutationAssignOrderToUserForReviewArgs = {
  input: AssignOrderToUserForReviewInput;
};


export type MutationAssignSalesFunnelLeadArgs = {
  input: AssignSalesFunnelLeadInput;
};


export type MutationAutomaticOrderProcessingThresholdSettingArgs = {
  input: AutomaticOrderProcessingThresholdSettingInput;
};


export type MutationBatchOrderConfirmArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationBatchUpdateOrderSupplierArgs = {
  input: BatchUpdateOrderSupplierInput;
};


export type MutationBillingDocumentExportCreateArgs = {
  input: BillingDocumentExportCreateInput;
};


export type MutationBroadcastCreateArgs = {
  broadcastInput: BroadcastInput;
};


export type MutationBroadcastUpdateArgs = {
  broadcastInput: BroadcastInput;
  id: Scalars['ID']['input'];
};


export type MutationBroadcastUpdatePurposeArgs = {
  id: Scalars['ID']['input'];
  purpose: BroadcastPurposeInput;
};


export type MutationBulkDeclineOrdersArgs = {
  input: BulkDeclineOrdersInput;
};


export type MutationBulkSendInviteTransmissionArgs = {
  input: BulkSendInviteTransmissionInput;
};


export type MutationBulkSubmitOrderedProductDeliveryCheckArgs = {
  input?: InputMaybe<BulkSubmitOrderedProductDeliveryCheckInput>;
};


export type MutationBulkUpsertAccountOwnersArgs = {
  input: BulkUpsertAccountOwnersInput;
};


export type MutationBuyerAddUserArgs = {
  buyerId: Scalars['ID']['input'];
  input?: InputMaybe<BuyerUserInput>;
  userId: Scalars['ID']['input'];
};


export type MutationBuyerBulkAddUserArgs = {
  buyerId: Scalars['ID']['input'];
  userRoles: Array<BuyerUserRoleInput>;
};


export type MutationBuyerCreateArgs = {
  buyer: BuyerCreateInput;
};


export type MutationBuyerDisableRolesArgs = {
  buyerId: Scalars['ID']['input'];
};


export type MutationBuyerRemoveUserArgs = {
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationBuyerUpdateArgs = {
  buyer: BuyerUpdateInput;
  id: Scalars['ID']['input'];
};


export type MutationCancelCartArgs = {
  chatId: Scalars['ID']['input'];
  options: CancelCartOptionsInput;
};


export type MutationCancelMarketingCampaignArgs = {
  input: CancelMarketingCampaignInput;
};


export type MutationCartEvaluateArgs = {
  input: CartEvaluateInput;
};


export type MutationCatalogAttributeUpdateArgs = {
  input: CatalogAttributeUpdateInput;
};


export type MutationCatalogExportStartArgs = {
  input: CatalogExportStartInput;
};


export type MutationCatalogImportStartArgs = {
  input: CatalogImportStartInput;
};


export type MutationCategoryCreateArgs = {
  category: CategoryInput;
  chatId: Scalars['ID']['input'];
};


export type MutationCategoryDeleteArgs = {
  categoryIds: Array<Scalars['ID']['input']>;
  chatId: Scalars['ID']['input'];
};


export type MutationCategoryProductSortArgs = {
  categorizedProductList: Array<ProductsCategoryInput>;
  chatId: Scalars['ID']['input'];
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCategoryUpdateArgs = {
  category: CategoryInput;
  chatId: Scalars['ID']['input'];
};


export type MutationChatAssignmentImportJobGetOrCreateArgs = {
  input: ChatAssignmentImportJobGetOrCreateInput;
};


export type MutationChatCreateArgs = {
  chat: ChatCreateInput;
};


export type MutationChatDisableArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChatInviteUsersArgs = {
  id: Scalars['ID']['input'];
  userIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationChatLeaveArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChatMainSupplierMigrateArgs = {
  chatId: Scalars['ID']['input'];
  supplierUserId: Scalars['ID']['input'];
};


export type MutationChatMarkReadArgs = {
  input: ChatMarkReadInput;
};


export type MutationChatMessageMarkReadArgs = {
  input: ChatMessageMarkReadInput;
};


export type MutationChatMessageMarkUnreadArgs = {
  input: ChatMessageMarkUnreadInput;
};


export type MutationChatPricesVisibilityUpdateArgs = {
  input: ChatPricesVisibilityUpdateInput;
};


export type MutationChatRemoveUsersArgs = {
  id: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']>;
};


export type MutationChatUpdateArgs = {
  chat: ChatUpdateInput;
  id: Scalars['ID']['input'];
};


export type MutationChatUpdateMainSupplierArgs = {
  chatId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
};


export type MutationCheckoutCreateArgs = {
  input: CheckoutCreateInput;
};


export type MutationClaimOnboardingChecklistRewardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConfirmAccountLinkingArgs = {
  input: ConfirmAccountLinkingInput;
};


export type MutationConfirmDeliveryCheckReconciliationRequestArgs = {
  deliveryCheckReconciliationRequestId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationConfirmSaveEmailEditorStateArgs = {
  input: ConfirmSaveEmailEditorStateInput;
};


export type MutationConfirmTransmissionNotAnOrderArgs = {
  input: ConfirmTransmissionNotAnOrderInput;
};


export type MutationConnectAccountArgs = {
  appName: Scalars['String']['input'];
};


export type MutationConnectIntegrationAdapterArgs = {
  input: ConnectIntegrationAdapterInput;
};


export type MutationContactsCreateArgs = {
  numbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCorrectOrderArgs = {
  input: OrderCorrectionInput;
};


export type MutationCostDataImportJobGetOrCreateArgs = {
  input: CostDataImportJobGetOrCreateInput;
};


export type MutationCostGuideImportJobGetOrCreateArgs = {
  input: CostGuideImportJobGetOrCreateInput;
};


export type MutationCreateBuyerReportScheduleArgs = {
  input: CreateBuyerReportScheduleInput;
};


export type MutationCreateCustomerImportJobArgs = {
  input: CreateCustomerImportJobInput;
};


export type MutationCreateDistributorNoteArgs = {
  input: CreateDistributorNoteInput;
};


export type MutationCreateDistributorTaskArgs = {
  input: CreateDistributorTaskInput;
};


export type MutationCreateDocumentScanArgs = {
  input: CreateDocumentScanInput;
};


export type MutationCreateMarketingCampaignArgs = {
  input: CreateMarketingCampaignInput;
};


export type MutationCreateMenuScanArgs = {
  input: CreateMenuScanInput;
};


export type MutationCreateOmnichannelOrderArgs = {
  input: CreateOmnichannelOrderInput;
};


export type MutationCreateOrderDeliveryCheckArgs = {
  input: CreateOrderDeliveryCheckInput;
};


export type MutationCreateOrderDeliveryCheckImageUploadUrlArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationCreateOrderDeskEmailListArgs = {
  input: CreateOrderDeskEmailList;
};


export type MutationCreateOrderUploadArgs = {
  input: CreateOrderUploadInput;
};


export type MutationCreateProfileArgs = {
  user: CreateProfileInput;
};


export type MutationCreatePushEndpointArgs = {
  input?: InputMaybe<CreatePushEndpointInput>;
};


export type MutationCreatePushEndpointV2Args = {
  input?: InputMaybe<CreatePushEndpointInput>;
};


export type MutationCreateReferralArgs = {
  input: CreateReferralInput;
};


export type MutationCreateSalesFunnelArgs = {
  input: CreateSalesFunnelInput;
};


export type MutationCreateSalesFunnelLeadArgs = {
  input: CreateSalesFunnelLeadInput;
};


export type MutationCreateSalesFunnelStateArgs = {
  input: CreateSalesFunnelStateInput;
};


export type MutationCreateSubCatalogArgs = {
  name: Scalars['String']['input'];
  supplierEntityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateSupplierContactArgs = {
  supplierContact: CreateSupplierContactInput;
};


export type MutationCreateSupplierProductArgs = {
  product: ProductInput;
};


export type MutationCreateSupplierProductV2Args = {
  product: SupplierProductInput;
};


export type MutationCreateTransmissionArgs = {
  input: CreateTransmissionInput;
};


export type MutationCreditNoteCreateArgs = {
  input: CreditNoteCreateInput;
};


export type MutationCrossWorkflowReprocessTransmissionsArgs = {
  input: CrossWorkflowReprocessTransmissionsInput;
};


export type MutationCustomCatalogFullImportStartArgs = {
  input: CustomCatalogFullStartInput;
};


export type MutationCustomCatalogsItemUnitsBatchUpdateArgs = {
  input: CustomCatalogsItemUnitsBatchUpdateInput;
};


export type MutationCustomCatalogsToWebShopAssignmentUpdateArgs = {
  input: CustomCatalogsToWebShopAssignmentUpdateInput;
};


export type MutationCustomerMatchCacheEntryRemoveArgs = {
  input: CustomerMatchCacheEntryRemoveInput;
};


export type MutationDeactivateSalesFunnelStateArgs = {
  input: DeactivateSalesFunnelStateInput;
};


export type MutationDeclineOrderArgs = {
  input: DeclineOrderInput;
};


export type MutationDeleteBuyerReportScheduleArgs = {
  scheduleId: Scalars['ID']['input'];
};


export type MutationDeleteBuyerStockInventoryProductsArgs = {
  input: DeleteBuyerStockInventoryProductsInput;
};


export type MutationDeleteChatDeliverySettingArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationDeleteDistributorNoteArgs = {
  input: DeleteDistributorNoteInput;
};


export type MutationDeleteDistributorTaskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEntireSupplierProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProductImageArgs = {
  input: DeleteProductImageInput;
};


export type MutationDeleteProfileImageArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationDeleteSubCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSupplierProductArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationDirectPayCustomerOnboardArgs = {
  input: DirectPayCustomerOnboardInput;
};


export type MutationDirectPayCustomerStatusUpdateArgs = {
  input: DirectPayCustomerStatusUpdateInput;
};


export type MutationDirectPayPaymentMethodDeleteArgs = {
  input: DirectPayPaymentMethodDeleteInput;
};


export type MutationDirectPayPaymentMethodSetDefaultArgs = {
  input: DirectPayPaymentMethodSetDefaultInput;
};


export type MutationDirectPayPaymentSubmitArgs = {
  input: DirectPayPaymentSubmitInput;
};


export type MutationDisconnectAccountArgs = {
  appName: Scalars['String']['input'];
};


export type MutationDisconnectIntegrationAdapterArgs = {
  input: DisconnectIntegrationAdapterInput;
};


export type MutationEditBuyerReportScheduleArgs = {
  input: EditBuyerReportScheduleInput;
};


export type MutationEditSalesFunnelLeadArgs = {
  input: EditSalesFunnelLeadInput;
};


export type MutationErpSftpUserCreateArgs = {
  input: ErpSftpUserCreateInput;
};


export type MutationErpSftpUserUpdateArgs = {
  input: ErpSftpUserUpdateInput;
};


export type MutationExportCustomersArgs = {
  input: ExportCustomersInput;
};


export type MutationExportQuoteArgs = {
  input: ExportQuoteInput;
};


export type MutationExportSalesFunnelLeadsArgs = {
  input: ExportSalesFunnelLeadsInput;
};


export type MutationFeatureFlagControlFlagClauseValuesUpdateArgs = {
  input: FeatureFlagControlFlagClauseValuesUpdateInput;
};


export type MutationFeatureFlagControlFlagToggleArgs = {
  input: FeatureFlagControlFlagToggleInput;
};


export type MutationFeatureFlagControlSegmentClauseValuesUpdateArgs = {
  input: FeatureFlagControlSegmentClauseValuesUpdateInput;
};


export type MutationFeatureFlagControlSegmentTargetsUpdateArgs = {
  input: FeatureFlagControlSegmentTargetsUpdateInput;
};


export type MutationGenerateBuyerReportArgs = {
  input: GenerateBuyerReportInput;
};


export type MutationGenerateMagicCodeArgs = {
  input: GenerateMagicCodeInput;
};


export type MutationGetOrderGuideUploadUrlArgs = {
  getOrderGuideUploadUrl: GetOrderGuideUploadUrlInput;
};


export type MutationHistoricalOrdersPurgeStartArgs = {
  input: HistoricalOrdersPurgeStartInput;
};


export type MutationImportSupplierProductsArgs = {
  catalogUploadToken?: InputMaybe<Scalars['String']['input']>;
  csv?: InputMaybe<Scalars['String']['input']>;
  dryRun: Scalars['Boolean']['input'];
  products?: InputMaybe<Array<AdminProductInput>>;
  supplierId: Scalars['ID']['input'];
};


export type MutationImportSupplierProductsV2Args = {
  catalogUploadToken?: InputMaybe<Scalars['String']['input']>;
  csv?: InputMaybe<Scalars['String']['input']>;
  dryRun: Scalars['Boolean']['input'];
  supplierId: Scalars['ID']['input'];
};


export type MutationInitiateAccountLinkingArgs = {
  input: InitiateAccountLinkingInput;
};


export type MutationInsertOrUpdateSupplierContactArgs = {
  input: InsertOrUpdateSupplierContactInput;
};


export type MutationInstantPayCustomerInvitationSendArgs = {
  input: InstantPayCustomerInvitationSendInput;
};


export type MutationInstantPayCustomerOnboardArgs = {
  input: InstantPayCustomerOnboardInput;
};


export type MutationIntegrationAdapterConnectionAuthArgs = {
  input: IntegrationAdapterConnectionAuthInput;
};


export type MutationIntegrationAdapterConnectionConsentArgs = {
  input: IntegrationAdapterConnectionConsentInput;
};


export type MutationIntegrationAdapterConnectionCreateArgs = {
  input: IntegrationAdapterConnectionCreateInput;
};


export type MutationIntegrationAdapterConnectionUpdateArgs = {
  input: IntegrationAdapterConnectionUpdateInput;
};


export type MutationIntegrationAdapterCreateArgs = {
  input: IntegrationAdapterCreateInput;
};


export type MutationIntegrationAdapterUpdateArgs = {
  input: IntegrationAdapterUpdateInput;
};


export type MutationIntegrationWebhookRetryArgs = {
  input: IntegrationWebhookRetryInput;
};


export type MutationInternalInviteUsersArgs = {
  botUserId?: InputMaybe<Scalars['String']['input']>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  invitorUserId: Scalars['ID']['input'];
  phoneNumbers: Array<Scalars['String']['input']>;
};


export type MutationInvalidateMagicCodeArgs = {
  input: InvalidateMagicCodeInput;
};


export type MutationInviteNonChocoUserToBuyerArgs = {
  buyerId: Scalars['ID']['input'];
  input?: InputMaybe<InviteUserToBuyerInput>;
  phone: Scalars['String']['input'];
};


export type MutationInviteNonChocoUserToChatArgs = {
  chatId: Scalars['ID']['input'];
  phoneNumbers: Array<Scalars['String']['input']>;
};


export type MutationInviteUserToBuyerArgs = {
  buyerId: Scalars['ID']['input'];
  input: InviteUserToBuyerInputV2;
};


export type MutationInvoiceCreateArgs = {
  input: InvoiceCreateInput;
};


export type MutationJoinLoyaltyArgs = {
  input: JoinLoyaltyInput;
};


export type MutationLeaveLoyaltyArgs = {
  input: LeaveLoyaltyInput;
};


export type MutationLegalEntityAddInstantPayCustomerArgs = {
  input: LegalEntityAddInstantPayCustomerInput;
};


export type MutationLoyaltyRedemptionCreateArgs = {
  input: LoyaltyRedemptionCreateInput;
};


export type MutationLoyaltyRedemptionUpdateArgs = {
  input: LoyaltyRedemptionUpdateInput;
};


export type MutationMarkCustomerInsightsNotificationAsReadArgs = {
  input: MarkCustomerInsightsNotificationAsReadInput;
};


export type MutationMessageCreateArgs = {
  chatId: Scalars['ID']['input'];
  message: MessageInput;
  order?: InputMaybe<OrderInput>;
  senderId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMultiLocationOrderGuidesV2ItemUnitsRemoveArgs = {
  input: MultiLocationOrderGuidesV2ItemUnitsRemoveInput;
};


export type MutationMultiLocationOrderGuidesV2ItemUnitsUpdateArgs = {
  input: MultiLocationOrderGuidesV2ItemUnitsUpdateInput;
};


export type MutationNotificationCreateArgs = {
  messageId: Scalars['ID']['input'];
  notificationDirectives?: InputMaybe<NotificationDirectivesInput>;
  userId: Scalars['ID']['input'];
};


export type MutationNotificationInboxMarkReadArgs = {
  input: NotificationInboxMarkReadInput;
};


export type MutationNotificationInboxUpdatePublishArgs = {
  input: NotificationInboxUpdatePublishInput;
};


export type MutationNotificationPreferencesUpdateArgs = {
  input?: InputMaybe<NotificationPreferencesInput>;
};


export type MutationNotifyAutopilotOrderCreatedArgs = {
  orderId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
};


export type MutationNotifyBulkOrderRejectedArgs = {
  omnichannelOrderIds: Array<Scalars['ID']['input']>;
  supplierId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationNotifyChatUpdatedArgs = {
  input: NotifyChatUpdatedInput;
};


export type MutationNotifyCustomerInsightsNotificationCreatedArgs = {
  id: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
};


export type MutationNotifyOmnichannelOrderCreatedArgs = {
  omnichannelOrderId: Scalars['ID']['input'];
};


export type MutationNotifyOmnichannelOrderDraftUpdatedArgs = {
  input: NotifyOmnichannelOrderDraftUpdatedInput;
};


export type MutationNotifyOrderAcceptedArgs = {
  omnichannelOrderId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationNotifyOrderConfirmedArgs = {
  omnichannelOrderId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationNotifyOrderRejectedArgs = {
  omnichannelOrderId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationNotifyTransmissionCreatedArgs = {
  supplierId: Scalars['ID']['input'];
  transmissionId: Scalars['ID']['input'];
};


export type MutationNotifyTransmissionEventCreatedArgs = {
  input: NotifyTransmissionEventCreatedInput;
};


export type MutationNotifyTransmissionReceivedArgs = {
  supplierId: Scalars['ID']['input'];
  transmissionId: Scalars['ID']['input'];
};


export type MutationNotifyTransmissionV2OrdersFullyProcessedArgs = {
  supplierId: Scalars['ID']['input'];
  transmissionIds: Array<Scalars['ID']['input']>;
};


export type MutationNotifyTransmissionV2ProcessedArgs = {
  supplierId: Scalars['ID']['input'];
  transmissionId: Scalars['ID']['input'];
};


export type MutationNotifyTransmissionV2ReceivedArgs = {
  supplierId: Scalars['ID']['input'];
  transmissionId: Scalars['ID']['input'];
};


export type MutationOrderConfirmArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrderCreateArgs = {
  chatId: Scalars['ID']['input'];
  order: OrderInput;
};


export type MutationOrderCreateV2Args = {
  chatId: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  order: OrderCreateV2Input;
};


export type MutationOrderEditArgs = {
  editedOrderInput: OrderEditInput;
  message?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};


export type MutationOrderGuideCreatedArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationOrderGuideRequestArgs = {
  orderGuideRequest: OrderGuideRequestInput;
};


export type MutationOrderGuideV2BatchUpdateArgs = {
  input: OrderGuideV2BatchUpdateInput;
};


export type MutationOrderGuideV2CategoriesUpdateArgs = {
  input: OrderGuideV2CategoryUpdateInput;
};


export type MutationOrderGuideV2CategoryItemUnitsUpdateAllArgs = {
  input: OrderGuideV2CategoryItemUnitsUpdateAllInput;
};


export type MutationOrderGuideV2ItemUnitOrderGuidesUpdateArgs = {
  input: OrderGuideV2ItemUnitOrderGuidesUpdateInput;
};


export type MutationOrderGuideV2ItemUnitsAddArgs = {
  input: OrderGuideV2ItemUnitsAddInput;
};


export type MutationOrderGuideV2ItemUnitsRemoveArgs = {
  input: OrderGuideV2ItemUnitsRemoveInput;
};


export type MutationOrderGuideV2ItemUnitsUpdateArgs = {
  input: OrderGuideV2ItemUnitsUpdateInput;
};


export type MutationOrderGuideV2OrderGuideCreateArgs = {
  input: OrderGuideV2OrderGuideCreateInput;
};


export type MutationOrderGuideV2OrderGuideRemoveArgs = {
  input: OrderGuideV2OrderGuideRemoveInput;
};


export type MutationOrderGuideV2OrderGuideUpdateArgs = {
  input: OrderGuideV2OrderGuideUpdateInput;
};


export type MutationPaymentCustomerContactsUpdateArgs = {
  input: PaymentCustomerContactsUpdateInput;
};


export type MutationPaymentCustomerUpdateAllForLegalEntityArgs = {
  input: PaymentCustomerUpdateAllForLegalEntityInput;
};


export type MutationPaymentLegalEntityUpdateArgs = {
  input: PaymentLegalEntityUpdateInput;
};


export type MutationPaymentLinkGenerateArgs = {
  input: PaymentLinkGenerateInput;
};


export type MutationPaymentMethodRequestArgs = {
  input: PaymentMethodRequestInput;
};


export type MutationPaymentMethodRequestResendArgs = {
  input: PaymentMethodRequestResendInput;
};


export type MutationPrepareSaveEmailEditorStateArgs = {
  input: PrepareSaveEmailEditorStateInput;
};


export type MutationProductBatchCreateArgs = {
  chatId: Scalars['ID']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  enableCatalogProducts?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<Array<AdminProductInput>>;
};


export type MutationProductCreateArgs = {
  chatId: Scalars['ID']['input'];
  product: ProductInput;
};


export type MutationProductDeleteArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationProductMatchCacheEntriesRemoveArgs = {
  input: ProductMatchCacheEntriesRemoveInput;
};


export type MutationProductMatchCacheEntryCoefficientClearArgs = {
  input: ProductMatchCacheEntryCoefficientClearInput;
};


export type MutationProductSortArgs = {
  chatId: Scalars['ID']['input'];
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationProductUpdateArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  fieldName: Scalars['String']['input'];
  fieldValue: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationProductUpdateCategoryArgs = {
  categoryId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};


export type MutationProductUpdateExternalIdArgs = {
  chatId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationPunchoutConfigurationsUpsertArgs = {
  input: PunchoutConfigurationsByChatUpsertInput;
};


export type MutationQuoteArchiveArgs = {
  input: QuoteArchiveInput;
};


export type MutationQuoteCommentAddArgs = {
  input: QuoteCommentAddInput;
};


export type MutationQuoteCommentDeleteArgs = {
  input: QuoteCommentDeleteInput;
};


export type MutationQuoteCommentUpdateArgs = {
  input: QuoteCommentUpdateInput;
};


export type MutationQuoteConflictsResolveArgs = {
  input: QuoteConflictsResolveInput;
};


export type MutationQuoteCreateArgs = {
  input: QuoteCreateInput;
};


export type MutationQuoteEditsEvaluateArgs = {
  input: QuoteEditsEvaluateInput;
};


export type MutationQuoteEditsSubmitArgs = {
  input: QuoteEditsSubmitInput;
};


export type MutationQuoteGenerationJobAttachmentUploadLinkCreateArgs = {
  input: QuoteGenerationJobAttachmentUploadLinkCreateInput;
};


export type MutationQuoteGenerationJobCreateArgs = {
  input: QuoteGenerationJobCreateInput;
};


export type MutationQuoteGenerationJobRemoveArgs = {
  input: QuoteGenerationJobRemoveInput;
};


export type MutationQuoteGenerationJobRetryArgs = {
  input: QuoteGenerationJobRetryInput;
};


export type MutationQuoteGenerationJobStartArgs = {
  input: QuoteGenerationJobStartInput;
};


export type MutationQuoteReviewSubmitArgs = {
  input: QuoteReviewSubmitInput;
};


export type MutationQuoteSubmitForReviewArgs = {
  input: QuoteSubmitForReviewInput;
};


export type MutationQuoteUnarchiveArgs = {
  input: QuoteUnarchiveInput;
};


export type MutationReferUserArgs = {
  input: ReferUserInput;
};


export type MutationRefreshOrderDeskArgs = {
  omnichannelOrderId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
};


export type MutationRejectOrderArgs = {
  input: RejectOrderInput;
};


export type MutationRejectOrdersByIdArgs = {
  input: RejectOrdersByIdInput;
};


export type MutationRemoveBlockedEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationRemoveCcEmailFromChatsArgs = {
  email: Scalars['AWSEmail']['input'];
};


export type MutationRemoveEmailFromBuyerReportScheduleArgs = {
  emailToRemove: Scalars['AWSEmail']['input'];
  scheduleId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveLabelFromChatsArgs = {
  chatIds: Array<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
};


export type MutationRemoveOrderDeskEmailArgs = {
  input: RemoveOrderDeskEmail;
};


export type MutationRemoveProductsFromOrderGuidesArgs = {
  input: RemoveProductsFromOrderGuidesInput;
};


export type MutationRemoveSupplierBuyerMovArgs = {
  input: Array<RemoveSupplierBuyerMovInput>;
};


export type MutationRemoveUserFromChatsArgs = {
  chatIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationRenameSalesFunnelStateArgs = {
  input: RenameSalesFunnelStateInput;
};


export type MutationReopenQuoteArgs = {
  input: ReopenQuoteInput;
};


export type MutationReprocessTransmissionArgs = {
  input: ReprocessTransmissionInput;
};


export type MutationRequestToJoinBuyerArgs = {
  buyerId: Scalars['String']['input'];
};


export type MutationRetryOrderProcessingArgs = {
  forceSingleOrder?: InputMaybe<Scalars['Boolean']['input']>;
  omnichannelOrderId?: InputMaybe<Scalars['ID']['input']>;
  shouldPreserveStatus?: InputMaybe<Scalars['Boolean']['input']>;
  transmissionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSafelistTwilioUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSelectProductForOrderGuideArgs = {
  input: SelectProductForOrderGuideInput;
};


export type MutationSelectProductsForOrderGuideArgs = {
  input: SelectProductsForOrderGuideInput;
};


export type MutationSendEmailMarketingCampaignToAllArgs = {
  input: SendEmailCampaignToAllInput;
};


export type MutationSendEmailMarketingCampaignToChatsArgs = {
  input: SendEmailCampaignToChatsInput;
};


export type MutationSendInviteTransmissionArgs = {
  input: SendInviteTransmissionRequest;
};


export type MutationSendMarketingCampaignArgs = {
  input: SendMarketingCampaignInput;
};


export type MutationSendMarketingCampaignV2Args = {
  input: SendMarketingCampaignInputV2;
};


export type MutationSendSyntheticSmsMessageArgs = {
  input: SendSyntheticSmsMessageInput;
};


export type MutationSendSyntheticWhatsAppMessageArgs = {
  input: SendSyntheticWhatsAppMessageInput;
};


export type MutationSetMarketingEmailSenderArgs = {
  input: SetMarketingEmailSenderInput;
};


export type MutationSetOrderAsTestArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationSetOrderAsTestBulkArgs = {
  orderIds: Array<Scalars['ID']['input']>;
  reason: Scalars['String']['input'];
};


export type MutationSetUserOrderOverridePermissionsArgs = {
  input: SetUserOrderOverridePermissionsInput;
};


export type MutationSettlementReportCreateArgs = {
  input: SettlementReportCreateInput;
};


export type MutationShortenUrlArgs = {
  longUrl: Scalars['String']['input'];
};


export type MutationSignupFormConfigUpdateArgs = {
  input: SignupFormConfigUpdateInput;
};


export type MutationSsoEmailDomainExclusivitySetArgs = {
  input: SsoEmailDomainExclusivitySetInput;
};


export type MutationSsoRoleMappingCreateArgs = {
  input: SsoRoleMappingCreateInput;
};


export type MutationSsoRoleMappingDeleteArgs = {
  input: SsoRoleMappingDeleteInput;
};


export type MutationStartDocumentScanArgs = {
  input: StartDocumentScanInput;
};


export type MutationStartMenuScanArgs = {
  input: StartMenuScanInput;
};


export type MutationSubmitBuyerStockCountArgs = {
  input: SubmitBuyerStockCountInput;
};


export type MutationSubmitCartArgs = {
  chatId: Scalars['ID']['input'];
  options: CartSubmissionOptions;
};


export type MutationSubmitMagicCodeArgs = {
  input: SubmitMagicCodeInput;
};


export type MutationSubmitOrderDeliveryCheckArgs = {
  input: SubmitOrderDeliveryCheckInput;
};


export type MutationSubmitOrderedProductDeliveryCheckArgs = {
  input?: InputMaybe<SubmitOrderedProductDeliveryCheckInput>;
};


export type MutationSupplierAgentSettingsUpsertArgs = {
  input: SupplierAgentSettingsUpsertInput;
};


export type MutationSupplierBuyerDeliveryFeeUpsertArgs = {
  input: SupplierBuyerDeliveryFeeUpsertInput;
};


export type MutationSupplierCreateArgs = {
  supplier: SupplierCreateInput;
};


export type MutationSupplierDeliveryFeeUpsertArgs = {
  input: SupplierDeliveryFeeUpsertInput;
};


export type MutationSupplierGetInTouchRequestArgs = {
  input: SupplierGetInTouchRequestInput;
};


export type MutationSupplierHierarchyUpdateArgs = {
  input: SupplierHierarchyUpdateInput;
};


export type MutationSupplierInviteUserArgs = {
  chat: ChatInviteInput;
  invitee: ChatInviteRecipient;
};


export type MutationSupplierInviteUsersArgs = {
  chat: ChatInviteInput;
  phoneNumbers: Array<Scalars['String']['input']>;
};


export type MutationSupplierInviteUsersV2Args = {
  chat: ChatInviteInput;
  invitees: Array<ChatInviteRecipientV2>;
};


export type MutationSupplierRemoveUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationSupplierSettingArgs = {
  input: SupplierSettingInput;
};


export type MutationSupplierUpdateArgs = {
  supplier: SupplierUpdateInput;
};


export type MutationSupplierUserCreateArgs = {
  input: SupplierUserCreateInput;
};


export type MutationSupplierUserRemoveArgs = {
  input: SupplierUserRemoveInput;
};


export type MutationSwitchAndSaveMappingCreateArgs = {
  input: SwitchAndSaveMappingCreateInput;
};


export type MutationSwitchAndSaveMappingDeleteArgs = {
  input: SwitchAndSaveMappingDeleteInput;
};


export type MutationSwitchAndSaveMappingUpsertArgs = {
  input: SwitchAndSaveMappingUpsertInput;
};


export type MutationSyncCognitoUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationTeamMemberAddArgs = {
  input: TeamMemberAddInput;
};


export type MutationTeamMemberLocationAssignmentsBatchMutateArgs = {
  input: TeamMemberLocationAssignmentsBatchMutateInput;
};


export type MutationTeamMemberRemoveLocationAssignmentArgs = {
  input: TeamMemberRemoveLocationAssignmentInput;
};


export type MutationTeamMemberRevokeAllWorkspaceAccessArgs = {
  input: TeamMemberRevokeAllWorkspaceAccessInput;
};


export type MutationTeamMemberSetLocationAssignmentsArgs = {
  input: TeamMemberSetLocationAssignmentsInput;
};


export type MutationTeamNotificationPreferencesUpdateArgs = {
  input: TeamNotificationPreferencesUpdateInput;
};


export type MutationTriggerProductMatchingArgs = {
  input: TriggerProductMatchingInput;
};


export type MutationUnassignUserFromOrderToReviewArgs = {
  input: UnassignUserFromOrderToReviewInput;
};


export type MutationUndoMultiLocationOrderGuideTransactionArgs = {
  input: UndoMultiLocationOrderGuideTransactionInput;
};


export type MutationUpdateBuyerInventoryProductArgs = {
  input: UpdateBuyerInventoryProductInput;
};


export type MutationUpdateBuyerStockInventoryProductArgs = {
  input: UpdateBuyerStockInventoryProductInput;
};


export type MutationUpdateBuyerUserChatsArgs = {
  input: UpdateBuyerUserChatsInput;
};


export type MutationUpdateCartArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  chatId: Scalars['ID']['input'];
  lineItems: Array<CartLineItemUpdateInput>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateChatEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateChatNotificationPreferencesArgs = {
  input?: InputMaybe<ChatNotificationInput>;
};


export type MutationUpdateChatNotificationPreferencesV2Args = {
  input?: InputMaybe<ChatNotificationInput>;
};


export type MutationUpdateChatOrderingSettingsArgs = {
  input: ChatOrderingSettingsInput;
};


export type MutationUpdateDistributorNoteArgs = {
  input: UpdateDistributorNoteInput;
};


export type MutationUpdateDistributorTaskArgs = {
  input: UpdateDistributorTaskInput;
};


export type MutationUpdateDistributorTaskStatusArgs = {
  input: UpdateDistributorTaskStatusInput;
};


export type MutationUpdateDocumentScanAttachmentsArgs = {
  input: UpdateDocumentScanAttachmentsInput;
};


export type MutationUpdateInvoicedProductArgs = {
  input: Array<InputMaybe<InvoicedProductInput>>;
};


export type MutationUpdateLoyaltySettingsArgs = {
  input: UpdateLoyaltySettingsInput;
};


export type MutationUpdateMarketingCampaignAttachmentsArgs = {
  input: UpdateCampaignAttachmentInput;
};


export type MutationUpdateMarketingCampaignChatMessageContentArgs = {
  input: UpdateMarketingCampaignChatMessageContentInput;
};


export type MutationUpdateMarketingCampaignEmailContentArgs = {
  input: UpdateEmailContentInput;
};


export type MutationUpdateMarketingCampaignEmailTemplateUriArgs = {
  input: UpdateEmailTemplateUriInput;
};


export type MutationUpdateMarketingCampaignEndDateArgs = {
  input: UpdateMarketingCampaignEndDateInput;
};


export type MutationUpdateMarketingCampaignHomePromoContentArgs = {
  input: UpdateMarketingCampaignHomePromoContentInput;
};


export type MutationUpdateMarketingCampaignInfoArgs = {
  input: UpdateMarketingCampaignInfoInput;
};


export type MutationUpdateMarketingCampaignPreferredProductsContentArgs = {
  input: UpdateMarketingCampaignPreferredProductsContentInput;
};


export type MutationUpdateMarketingCampaignVendorItemUnitsArgs = {
  input: UpdateVendorItemUnitsInput;
};


export type MutationUpdateMarketingCampaignWelcomeBannerContentArgs = {
  input: UpdateMarketingCampaignWelcomeBannerContentInput;
};


export type MutationUpdateMenuScanAttachmentsArgs = {
  input: UpdateMenuScanAttachmentsInput;
};


export type MutationUpdateNotificationUserIdArgs = {
  newUserId: Scalars['ID']['input'];
  oldUserId: Scalars['ID']['input'];
};


export type MutationUpdateOmnichannelOrderCustomerArgs = {
  input: UpdateOmnichannelOrderCustomerInput;
};


export type MutationUpdateOmnichannelOrderDeliveryDateArgs = {
  input: UpdateOmnichannelOrderDeliveryDateInput;
};


export type MutationUpdateOmnichannelOrderProductsArgs = {
  input: UpdateOmnichannelOrderProductsInput;
};


export type MutationUpdatePendingUserArgs = {
  input: UpdatePendingUserInput;
};


export type MutationUpdateProductVariantsInOrderGuideArgs = {
  input: UpdateProductVariantsInOrderGuideInput;
};


export type MutationUpdateRequestToJoinArgs = {
  input: UpdateJoinRequestInput;
};


export type MutationUpdateSalesFunnelLeadArchiveStatusArgs = {
  input: UpdateSalesFunnelLeadArchiveStatusInput;
};


export type MutationUpdateSalesFunnelStateOrderArgs = {
  input: UpdateSalesFunnelStateOrderInput;
};


export type MutationUpdateSubCatalogArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateSubCatalogChatsArgs = {
  create: Array<SubCatalogChatInput>;
  remove: Array<SubCatalogChatInput>;
};


export type MutationUpdateSupplierAccessPackageArgs = {
  suppliers: Array<SupplierUpdateAccessPackageInput>;
};


export type MutationUpdateSupplierBuyerMovArgs = {
  input: Array<UpdateSupplierBuyerMovInput>;
};


export type MutationUpdateSupplierContactArgs = {
  input: UpdateSupplierContactInput;
};


export type MutationUpdateSupplierDeliverySettingArgs = {
  input: SupplierDeliverySettingInput;
};


export type MutationUpdateSupplierProductArgs = {
  fieldName: Scalars['String']['input'];
  fieldValue: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateSupplierProductV2Args = {
  product: UpdateSupplierProductV2Input;
};


export type MutationUpdateSupplierUserChatsArgs = {
  input: SupplierUserUpdateChatsInput;
};


export type MutationUpdateSupplierUserRolesArgs = {
  input?: InputMaybe<UpdateSupplierUserRolesInput>;
};


export type MutationUpdateTransmissionProgressStatusArgs = {
  input: UpdateTransmissionProgressStatusInput;
};


export type MutationUploadSubCatalogProductsArgs = {
  csv: Scalars['String']['input'];
  subCatalogId: Scalars['ID']['input'];
};


export type MutationUploadSubCatalogProductsV2Args = {
  csv: Scalars['String']['input'];
  subCatalogId: Scalars['ID']['input'];
};


export type MutationUserAddRoleArgs = {
  role: Role;
  userId: Scalars['String']['input'];
};


export type MutationUserConfirmArgs = {
  newUserPool: Scalars['Boolean']['input'];
  phone: Scalars['String']['input'];
};


export type MutationUserCreateArgs = {
  user: UserCreateInput;
};


export type MutationUserLeadCreateArgs = {
  userLead: UserLeadInput;
};


export type MutationUserNotificationPreferencesForChatClearArgs = {
  input: UserNotificationPreferencesForChatClearInput;
};


export type MutationUserNotificationPreferencesForChatUpdateArgs = {
  input: UserNotificationPreferencesForChatUpdateInput;
};


export type MutationUserNotificationPreferencesUpdateArgs = {
  input: UserNotificationPreferencesUpdateInput;
};


export type MutationUserRemoveRoleArgs = {
  role: Role;
  userId: Scalars['String']['input'];
};


export type MutationUserRequestToDeleteArgs = {
  input: UserRequestToDeleteInput;
};


export type MutationUserTeamChatNotificationsOptInUpdateArgs = {
  input: UserTeamChatNotificationsOptInUpdateInput;
};


export type MutationUserUpdateArgs = {
  user: UserUpdateInput;
};


export type MutationVendorItemCategoriesImagesUploadArgs = {
  input: VendorItemCategoriesImagesUploadInput;
};


export type MutationVendorItemCategoriesUpdateArgs = {
  input: VendorItemCategoriesUpdateInput;
};


export type MutationVendorItemCustomCreateArgs = {
  input: VendorItemCustomCreateInput;
};


export type MutationVendorItemCustomUpdateArgs = {
  input: VendorItemCustomUpdateInput;
};


export type MutationVendorItemUnitBuyerPropertiesUpdateArgs = {
  input: VendorItemUnitBuyerPropertiesUpdateInput;
};


export type MutationVendorItemUnitBuyerPropertiesUpdateBatchArgs = {
  input: Array<VendorItemUnitBuyerPropertiesUpdateInput>;
};


export type MutationVendorItemUnitCustomerSpecificPriceUpdateArgs = {
  input: VendorItemUnitCustomerSpecificPriceUpdateInput;
};


export type MutationVendorItemUnitUpdateArgs = {
  input: VendorItemUnitUpdateInput;
};


export type MutationVendorItemUnitsImagesUploadArgs = {
  input: VendorItemUnitsImagesUploadInput;
};


export type MutationVendorItemUnitsUpdateArgs = {
  input: VendorItemUnitsUpdateInput;
};


export type MutationVendorPreferredBrandsUpdateArgs = {
  input: VendorPreferredBrandsUpdateInput;
};


export type MutationVendorPromotionMarketingUpdateArgs = {
  input: VendorPromotionMarketingUpdateInput;
};


export type MutationVendorSearchSynonymCreateArgs = {
  input: VendorSearchSynonymCreateInput;
};


export type MutationVendorSearchSynonymUpdateArgs = {
  input: VendorSearchSynonymUpdateInput;
};


export type MutationVendorSearchSynonymsDeleteArgs = {
  input: VendorSearchSynonymsDeleteInput;
};


export type MutationVoiceAgentWebRtcSessionStartArgs = {
  input: VoiceAgentWebRtcSessionStartInput;
};


export type MutationWebshopCatalogSyncArgs = {
  input: WebshopCatalogSyncInput;
};


export type MutationWebshopConfigUpdateArgs = {
  input: WebshopConfigUpdateInput;
};


export type MutationWebshopProductCollectionsBatchUpdateArgs = {
  input: WebshopProductCollectionsBatchUpdateInput;
};


export type MutationWebshopWelcomeBannerImageUploadArgs = {
  input: WebshopWelcomeBannerImageUploadInput;
};


export type MutationWebshopWelcomeBannerUpdateArgs = {
  input: WebshopWelcomeBannerUpdateInput;
};


export type MutationWholesailBuyerSessionStartArgs = {
  input: WholesailBuyerSessionStartInput;
};


export type MutationWholesailVendorCreateArgs = {
  input: WholesailVendorCreateInput;
};


export type MutationWorkspaceCreateArgs = {
  input: WorkspaceCreateInput;
};

export type MyWorkspacesResponse = AuthorizationFailure | MyWorkspacesResult;

export type MyWorkspacesResult = AppsyncResponse & {
  __typename?: 'MyWorkspacesResult';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  workspaces: Array<Workspace>;
};

export type NegativeAmountError = AppsyncError & AppsyncResponse & {
  __typename?: 'NegativeAmountError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type NoCutoffSetting = {
  __typename?: 'NoCutoffSetting';
  type: NoCutoffType | '%future added value';
};

export const NoCutoffType = {
  NoCutoff: 'noCutoff'
} as const;

export type NoCutoffType = typeof NoCutoffType[keyof typeof NoCutoffType];
export type NoDeliveryException = {
  __typename?: 'NoDeliveryException';
  date: Scalars['AWSDate']['output'];
  type: NoDeliveryExceptionType | '%future added value';
};

export const NoDeliveryExceptionType = {
  NoDeliveryException: 'noDeliveryException'
} as const;

export type NoDeliveryExceptionType = typeof NoDeliveryExceptionType[keyof typeof NoDeliveryExceptionType];
export type NoMinimumOrderableAmountProduct = {
  __typename?: 'NoMinimumOrderableAmountProduct';
  /** The product id */
  id: Scalars['String']['output'];
  /** The unit minimumFractionalAmount for this product */
  minimumOrderableAmount: Scalars['Float']['output'];
};

export type NoOrderChange = {
  __typename?: 'NoOrderChange';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type NoUnconnectedBuyers = AppsyncError & AppsyncResponse & {
  __typename?: 'NoUnconnectedBuyers';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type NotFoundError = AppsyncError & AppsyncResponse & {
  __typename?: 'NotFoundError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type Notification = Node & {
  __typename?: 'Notification';
  id: Scalars['ID']['output'];
  message: Message;
  /** NOTE: Resolved via response mapping template on notificationCreate!!! */
  notificationDirectives?: Maybe<NotificationDirectives>;
  userId: Scalars['ID']['output'];
};

/**
 * NOTE: All fields must match between this type and NotificationDirectivesInput.
 * NOTE: This property is resolved on notificationCreate via VTL template. The
 * response mapping template simply copies the entire value from
 * arguments.notificationDirectives on the input to the output.
 * Additional context on how the Notification should be processed by the frontend.
 */
export type NotificationDirectives = {
  __typename?: 'NotificationDirectives';
  /**
   * The frontend should not update message inbox count in response to receiving
   * this notification.
   */
  suppressInboxCountUpdate?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * NOTE: All fields must match between this type and NotificationDirectives.
 * Additional context on how the Notification should be processed by the frontend.
 */
export type NotificationDirectivesInput = {
  /**
   * The frontend should not update message inbox count in response to receiving
   * this notification.
   */
  suppressInboxCountUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A loyalty notification in a buyer's inbox. */
export type NotificationInboxItem = Node & {
  __typename?: 'NotificationInboxItem';
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  kind: LoyaltyNotificationKind | '%future added value';
  /** Final text, already translated into the user's language by the backend. */
  message: Scalars['String']['output'];
  /** Whether the current user has read it. */
  read: Scalars['Boolean']['output'];
};

export type NotificationInboxListInput = {
  buyerId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInputV2>;
};

export type NotificationInboxListResponse = AuthorizationFailure | InputValidationFailure | NotificationInboxListSuccess;

export type NotificationInboxListSuccess = AppsyncResponse & {
  __typename?: 'NotificationInboxListSuccess';
  items: Array<NotificationInboxItem>;
  pageInfo: PageInfo;
  responseType: ResponseType | '%future added value';
};

export type NotificationInboxMarkReadInput = {
  buyerId: Scalars['ID']['input'];
  /** 1–100 unique IDs. Marking an already-read notification does nothing. */
  notificationIds: Array<Scalars['ID']['input']>;
};

export type NotificationInboxMarkReadResponse = AuthorizationFailure | InputValidationFailure | NotificationInboxMarkReadSuccess;

export type NotificationInboxMarkReadSuccess = AppsyncResponse & {
  __typename?: 'NotificationInboxMarkReadSuccess';
  /** Whether any notifications for this buyer are still unread. */
  hasUnread: Scalars['Boolean']['output'];
  /** The given notifications after the update. */
  notifications: Array<NotificationInboxItem>;
  responseType: ResponseType | '%future added value';
};

export type NotificationInboxUnreadGetInput = {
  buyerId: Scalars['ID']['input'];
};

export type NotificationInboxUnreadGetResponse = AuthorizationFailure | InputValidationFailure | NotificationInboxUnreadGetSuccess;

export type NotificationInboxUnreadGetSuccess = AppsyncResponse & {
  __typename?: 'NotificationInboxUnreadGetSuccess';
  /** True if the current user has at least one unread notification for this buyer. */
  hasUnread: Scalars['Boolean']['output'];
  responseType: ResponseType | '%future added value';
};

/** Signals that a user's inbox changed. Clients refetch the list and unread state; it carries no read state or counts. */
export type NotificationInboxUpdate = {
  __typename?: 'NotificationInboxUpdate';
  /** Buyer whose inbox changed. */
  buyerId: Scalars['ID']['output'];
  /** Notifications that changed. */
  notificationIds: Array<Scalars['ID']['output']>;
  reason: NotificationInboxUpdateReason | '%future added value';
  userId: Scalars['ID']['output'];
};

export type NotificationInboxUpdatePublishInput = {
  buyerId: Scalars['ID']['input'];
  notificationIds: Array<Scalars['ID']['input']>;
  reason: NotificationInboxUpdateReason | '%future added value';
  userId: Scalars['ID']['input'];
};

/** Why a user's inbox changed. */
export const NotificationInboxUpdateReason = {
  Created: 'CREATED',
  MarkedRead: 'MARKED_READ'
} as const;

export type NotificationInboxUpdateReason = typeof NotificationInboxUpdateReason[keyof typeof NotificationInboxUpdateReason];
export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  message?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationPreferencesInput = {
  message: Scalars['Boolean']['input'];
  order: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type NotifyChatUpdatedInput = {
  chatId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type NotifyOmnichannelOrderDraftUpdatedInput = {
  omnichannelOrderId: Scalars['ID']['input'];
  supplierId: Scalars['ID']['input'];
  transmissionId: Scalars['ID']['input'];
};

export type NotifyTransmissionEventCreatedInput = {
  supplierId: Scalars['ID']['input'];
  transmissionEvent: NotifyTransmissionEventInput;
};

export type NotifyTransmissionEventInput = {
  id: Scalars['ID']['input'];
  isDeliveryEvent?: InputMaybe<Scalars['Boolean']['input']>;
  isFailureEvent?: InputMaybe<Scalars['Boolean']['input']>;
  metaData?: InputMaybe<Scalars['AWSJSON']['input']>;
  newState: Scalars['String']['input'];
  ofId: Scalars['ID']['input'];
  ofIdType: TransmissionOfType | '%future added value';
  timestamp: Scalars['AWSDateTime']['input'];
  to: Scalars['String']['input'];
  toType: TransmissionToType | '%future added value';
};

/**
 * This input type can be used for create, update, or delete a MoneyV2 object
 * If NullableMoneyV2Input sent as `null`/`undefined`, it won't be touched/updated
 * If NullableMoneyV2Input sent as `{ value: null | undefined }`, it will be deleted
 * If NullableMoneyV2Input sent as `{ value : MoneyV2Input }`, it will be updated
 */
export type NullableMoneyV2Input = {
  value?: InputMaybe<MoneyV2Input>;
};

/**
 * If NullableMoneyV2InputOptional sent as null/undefined, it won't be touched/updated
 * If NullableMoneyV2InputOptional sent as { value: null/undefined }, it will be deleted
 * If NullableMoneyV2InputOptional sent as {value : MoneyV2InputOptional }, it will be updated
 */
export type NullableMoneyV2InputOptional = {
  value?: InputMaybe<MoneyV2InputOptional>;
};

export type OcoRerankedProducts = {
  __typename?: 'OCORerankedProducts';
  rankedProductsByLineItem?: Maybe<Array<RerankedLineItemProducts>>;
};

export const OfferType = {
  CartFreeExtraUnits: 'CART_FREE_EXTRA_UNITS',
  DiscountPercentage: 'DISCOUNT_PERCENTAGE',
  FixedPrice: 'FIXED_PRICE',
  FreeUnitsIncluded: 'FREE_UNITS_INCLUDED',
  ReducedPrice: 'REDUCED_PRICE'
} as const;

export type OfferType = typeof OfferType[keyof typeof OfferType];
export type OmnichannelOrder = Node & {
  __typename?: 'OmnichannelOrder';
  acceptedBy?: Maybe<User>;
  acceptedContext?: Maybe<OrderAcceptedByContext | '%future added value'>;
  acceptedProducts?: Maybe<Array<AcceptedProduct>>;
  attachmentRefs?: Maybe<Array<Maybe<AttachmentOrderRef>>>;
  attachments?: Maybe<Array<OmnichannelOrderAttachment>>;
  chat?: Maybe<Chat>;
  /** OrderCorrection resolved through K8s service */
  correction?: Maybe<OrderCorrection>;
  createdAt: Scalars['AWSTimestamp']['output'];
  forwardedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPerfectOrder?: Maybe<Scalars['Boolean']['output']>;
  lastReprocessedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  matchingConfidence?: Maybe<MatchingConfidence>;
  order?: Maybe<Order>;
  orderChannel?: Maybe<SupplierOrderChannel | '%future added value'>;
  /** @deprecated Use `reviewer` instead. Will be removed in a future release. */
  orderDeskReviewer?: Maybe<OrderDeskReviewer>;
  orderExtractionConfidenceScore?: Maybe<Scalars['Float']['output']>;
  originalOrderMediaLink: Scalars['String']['output'];
  parsedOrder: ParsedOrder;
  retryCount?: Maybe<Scalars['Int']['output']>;
  /** Reference to the order desk user that is currently reviewing the order. */
  reviewer?: Maybe<UserRef>;
  sender?: Maybe<Scalars['String']['output']>;
  status: OmnichannelOrderStatus | '%future added value';
  supplier: Supplier;
  transmissionId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type OmnichannelOrderAttachment = Node & {
  __typename?: 'OmnichannelOrderAttachment';
  contentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  transcript?: Maybe<AudioTranscript>;
  url: Scalars['String']['output'];
};

export type OmnichannelOrderCreatedNotification = {
  __typename?: 'OmnichannelOrderCreatedNotification';
  order: OmnichannelOrder;
};

export type OmnichannelOrderCustomer = {
  __typename?: 'OmnichannelOrderCustomer';
  autopilotEnabled?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  customerCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  supplierId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type OmnichannelOrderDetail = {
  __typename?: 'OmnichannelOrderDetail';
  /**
   * Who/what accepted the order (autopilot, order reviewer). Null if the order
   * has not been accepted yet.
   */
  acceptedContext?: Maybe<OrderAcceptedByContext | '%future added value'>;
  /**
   * Reference to the related chat (customer), if one was extracted for this order.
   * This can be different for different orders in the same transmission.
   */
  chat?: Maybe<ChatRef>;
  /**
   * Id of the order.
   * This is different from Choco orderId.
   */
  id: Scalars['ID']['output'];
  /** Reasons that prevented the order from being accepted automatically. */
  orderReviewReason?: Maybe<Array<ReviewReason | '%future added value'>>;
  /** The requested delivery date for this the orders, in ISO 8601 format. */
  requestedDeliveryDate?: Maybe<Scalars['String']['output']>;
  /**
   * Reference to the order desk user that is currently reviewing the order.
   * This can be different for different orders in the same transmission.
   */
  reviewer?: Maybe<UserRef>;
  /** The status of the order */
  status: OmnichannelOrderStatus | '%future added value';
};

export type OmnichannelOrderDraftInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  deliveryTimezone?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<OmnichannelOrderProductDraftInput>>;
  requestedDeliveryDate?: InputMaybe<Scalars['String']['input']>;
};

export type OmnichannelOrderDraftUpdatedNotification = {
  __typename?: 'OmnichannelOrderDraftUpdatedNotification';
  order: OmnichannelOrder;
  transmissionId: Scalars['ID']['output'];
};

export type OmnichannelOrderProduct = {
  __typename?: 'OmnichannelOrderProduct';
  amount: Scalars['Float']['output'];
  extractedAmount?: Maybe<Scalars['Float']['output']>;
  product: OmnichannelProduct;
};

export type OmnichannelOrderProductDraftInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  lineItemId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['ID']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export const OmnichannelOrderProductsUpdateMode = {
  Merge: 'MERGE',
  Replace: 'REPLACE'
} as const;

export type OmnichannelOrderProductsUpdateMode = typeof OmnichannelOrderProductsUpdateMode[keyof typeof OmnichannelOrderProductsUpdateMode];
export const OmnichannelOrderStatus = {
  Accepted: 'accepted',
  Archived: 'archived',
  Blocked: 'blocked',
  Declined: 'declined',
  InProgress: 'inProgress',
  Retrying: 'retrying',
  ToReview: 'toReview',
  UnderReview: 'underReview'
} as const;

export type OmnichannelOrderStatus = typeof OmnichannelOrderStatus[keyof typeof OmnichannelOrderStatus];
export type OmnichannelOrdersSubcriptionResponse = AuthorizationFailure | OrderDeskNotification;

export type OmnichannelProduct = {
  __typename?: 'OmnichannelProduct';
  additionalAttributes?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use amount in OmnichannelOrderProduct */
  amount: Scalars['Float']['output'];
  /** @deprecated Not returned anymore. Use `OmnichannelProduct.vendorItemUnit` instead */
  catalogProduct?: Maybe<Product>;
  /** @deprecated Not returned anymore. Use `OmnichannelProduct.vendorItemUnit` instead */
  chatProduct?: Maybe<Product>;
  /**
   * Order the product-match cache recorded for the learned coefficient that
   * scaled this line's predicted amount. The coefficient is not stored; derive it
   * as OmnichannelOrderProduct.amount / OmnichannelOrderProduct.extractedAmount,
   * which is approximate (amount is rounded to 2 decimals) and only holds while
   * the predicted amount is unedited. Snapshotted when the order is processed;
   * later relearning does not change it. Not necessarily the order that first
   * taught the coefficient: an accept that confirms an unchanged coefficient also
   * becomes its source. Null when no coefficient scaled the amount.
   */
  coefficientSourceOrderId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use `comments` for more flexibility */
  comment?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<Scalars['String']['output']>>;
  /** original untranslated name extracted from the order */
  extractedName?: Maybe<Scalars['String']['output']>;
  extractedPrice?: Maybe<MoneyV2>;
  id?: Maybe<Scalars['ID']['output']>;
  isProductAmountCorrect?: Maybe<Scalars['Boolean']['output']>;
  isProductCorrect?: Maybe<Scalars['Boolean']['output']>;
  lineItemId: Scalars['ID']['output'];
  matchedBy?: Maybe<ProductMatchedBy | '%future added value'>;
  /** translated version of extracted name */
  name: Scalars['String']['output'];
  packSize?: Maybe<Scalars['String']['output']>;
  parsedProductId: Scalars['ID']['output'];
  replacedProduct?: Maybe<ReplacedProduct>;
  /**
   * Why the Order Agent matcher dropped this line's local match: set with
   * replacedProduct when the product was replaced or left for the reviewer, and
   * alone for notFound, whose dropped id resolves to no product.
   */
  replacementReason?: Maybe<ProductReplacementReason | '%future added value'>;
  supplierProductId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  vendorItemUnit?: Maybe<VendorItemUnitRef>;
};

export type OnboardingChecklist = {
  __typename?: 'OnboardingChecklist';
  buyerId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  items: Array<OnboardingChecklistItem>;
  rewardClaimedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  version: Scalars['String']['output'];
};

export type OnboardingChecklistBooleanValue = {
  __typename?: 'OnboardingChecklistBooleanValue';
  booleanCurrent: Scalars['Boolean']['output'];
};

export type OnboardingChecklistItem = {
  __typename?: 'OnboardingChecklistItem';
  articleId: Scalars['String']['output'];
  fallbackTranslation: Scalars['String']['output'];
  key: Scalars['String']['output'];
  value: OnboardingChecklistItemValue;
};

export type OnboardingChecklistItemValue = OnboardingChecklistBooleanValue | OnboardingChecklistNumericValue;

export type OnboardingChecklistNumericValue = {
  __typename?: 'OnboardingChecklistNumericValue';
  numericCurrent: Scalars['Int']['output'];
  target: Scalars['Int']['output'];
};

export type OneTimeBroadcastSchedule = {
  __typename?: 'OneTimeBroadcastSchedule';
  broadcastScheduleType: BroadcastScheduleType | '%future added value';
  nextScheduledTimestamp: Scalars['AWSTimestamp']['output'];
  timezone: Scalars['String']['output'];
};

export type OneTimeBroadcastScheduleInput = {
  nextScheduledTimestamp: Scalars['AWSTimestamp']['input'];
};

/** Represents the opening hours of an prospect. */
export type OpeningHours = {
  __typename?: 'OpeningHours';
  daysOfWeekDescriptions: Array<Scalars['String']['output']>;
};

export type Order = Node & {
  __typename?: 'Order';
  acceptedByContext?: Maybe<OrderAcceptedByContext | '%future added value'>;
  /** Additional order-level fees such as delivery fee (checkout v3). */
  additionalFees?: Maybe<OrderAdditionalFees>;
  body?: Maybe<Scalars['String']['output']>;
  buyer?: Maybe<Buyer>;
  chat?: Maybe<Chat>;
  chatId?: Maybe<Scalars['String']['output']>;
  /** Origin of the committed snapshot. Absent means a legacy (v2) order. */
  commitSource?: Maybe<OrderCommitSource | '%future added value'>;
  confirmationSource?: Maybe<ConfirmationSource | '%future added value'>;
  confirmationTime?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** OrderCorrection resolved through K8s service */
  correction?: Maybe<OrderCorrection>;
  createdAt: Scalars['AWSTimestamp']['output'];
  createdContext?: Maybe<OrderCreatedContext | '%future added value'>;
  deliveryDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  /**
   * The total the buyer pays: net after promotions, plus tax and fees, for an
   * order committed with pricing. Older orders sum the catalog price of the
   * ordered products, without tax or fees.
   */
  estimatedOrderTotal?: Maybe<Money>;
  id: Scalars['ID']['output'];
  /** @deprecated No longer supported since Jun 2024 */
  invoice: OrderInvoice;
  /** @deprecated No longer supported since Jun 2024 */
  invoicedProducts?: Maybe<Array<Maybe<InvoicedProduct>>>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  /** Reason why the order was marked as a test order */
  isTestReason?: Maybe<Scalars['String']['output']>;
  /** Whether this order is a top-up order (added to a delivery date that already has a qualifying order). */
  isTopUp?: Maybe<Scalars['Boolean']['output']>;
  /** Loyalty points breakdown for this order, mirroring the cart estimation shape. Null if no loyalty program applies to this order. */
  loyalty?: Maybe<LoyaltyPointsBreakdown>;
  numberOfProducts?: Maybe<Scalars['Int']['output']>;
  omnichannelOrder?: Maybe<OmnichannelOrder>;
  /** omnichannel order resolved through K8s service */
  omnichannelOrderV2?: Maybe<OmnichannelOrder>;
  orderChanges?: Maybe<OrderChangeResponse>;
  orderDeliveryCheck?: Maybe<GetOrderDeliveryCheckResponse>;
  orderProducts?: Maybe<Array<Maybe<OrderProduct>>>;
  /** @deprecated use status instead */
  orderSupplierStatus?: Maybe<Scalars['String']['output']>;
  orderedProducts?: Maybe<Array<Maybe<OrderedProduct>>>;
  /**
   * AWS S3 signed-url associated with the pdf for the order.
   * If a PDF already exists, it will be used; otherwise, a new one will be created.
   */
  pdf?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Order-level pricing. An order with a committed rollup serves it as committed.
   * An order without one gets a pricing derived on read: subtotalAmount is the
   * products total (the value of estimatedOrderTotal, at the currency's digits),
   * totalFeesAmount is the persisted additionalFees.totalFees, totalPayableAmount
   * is their sum, or the subtotal alone when no fee applied. Every other field is
   * null. All three are encoded at the currency's digits; a fee finer than that or
   * in another currency nulls the fee and payable. Pricing is null when the
   * products total cannot be computed.
   */
  pricing?: Maybe<OrderPricing>;
  /**
   * Timestamp when the order was received
   * For ChocoAI orders, this is the time the order was received by the ChocoAI system for processing.
   * For all other orders, this is the time the order was created in Choco.
   */
  receivedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  restaurant?: Maybe<OrderRestaurant>;
  status?: Maybe<OrderStatus | '%future added value'>;
  supplier?: Maybe<User>;
  supplierRefId?: Maybe<Scalars['String']['output']>;
  /**
   * Retrieves transmission events for status display.
   *
   * Returns transmission events associated with this order, ordered from latest to earliest.
   * This field is accessible by Choco Admin and DX users.
   *
   * Use the input parameter to filter events:
   * - toType: Filter by recipient type (e.g., "integration" for integration events)
   * - limitPerTo: Limit the number of events returned per unique recipient (useful for pages with multiple orders)
   */
  transmissionEvents: Array<TransmissionEvent>;
  user?: Maybe<User>;
  /**
   * Validation failures that were overridden during order creation.
   * Despite these failures, the order was approved with explicit override.
   *
   * Note: The type is OrderValidationFailure, but these are RESOLVED failures
   * (not blocking) because they were explicitly overridden by the user.
   */
  validationOverrides?: Maybe<Array<OrderValidationFailure>>;
};


export type OrderPdfArgs = {
  downloadable?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
};


export type OrderTransmissionEventsArgs = {
  input?: InputMaybe<TransmissionEventsInput>;
};

export const OrderAcceptedByContext = {
  AutoPilot: 'autoPilot',
  OrderReviewer: 'orderReviewer'
} as const;

export type OrderAcceptedByContext = typeof OrderAcceptedByContext[keyof typeof OrderAcceptedByContext];
export type OrderAcceptedNotification = {
  __typename?: 'OrderAcceptedNotification';
  id: Scalars['ID']['output'];
  supplierId: Scalars['ID']['output'];
  user: User;
};

export type OrderAdditionalFees = {
  __typename?: 'OrderAdditionalFees';
  /** Delivery fee applied to the order. Null when no delivery fee applies. */
  deliveryFee?: Maybe<MoneyV2>;
  /** Sum of all itemized fees. Source of truth for the fee total; OrderPricing.totalFeesAmount mirrors this value. */
  totalFees?: Maybe<MoneyV2>;
};

/** The order-agent workflow engine that processes a transmission. */
export const OrderAgentWorkflowVersion = {
  /** Legacy V2 (smartOrderService Step Functions). */
  V2: 'V2',
  /** V3 (orderAgentService Step Functions). */
  V3: 'V3'
} as const;

export type OrderAgentWorkflowVersion = typeof OrderAgentWorkflowVersion[keyof typeof OrderAgentWorkflowVersion];
export type OrderAlreadyAccepted = {
  __typename?: 'OrderAlreadyAccepted';
  acceptedBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

/**
 * Returned when the order is already being actively reviewed by a different
 * user. The client should surface the existing reviewer to the caller and
 * require an explicit user action before retrying with overrideExistingReviewer=true.
 */
export type OrderAlreadyInReview = {
  __typename?: 'OrderAlreadyInReview';
  /** User who currently holds the active review. */
  currentReviewer: UserRef;
  /** Order that the caller attempted to claim. */
  omnichannelOrderId: Scalars['ID']['output'];
};

export type OrderChange = Node & {
  __typename?: 'OrderChange';
  changeData?: Maybe<OrderChangeData>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  editVersion: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type OrderChangeData = {
  __typename?: 'OrderChangeData';
  addedProducts?: Maybe<Array<OrderProduct>>;
  orderProducts?: Maybe<Array<OrderProduct>>;
  originalProductCount?: Maybe<Scalars['Int']['output']>;
  removedProducts?: Maybe<Array<OrderProduct>>;
};

export type OrderChangeError = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderChangeError';
  errorCode?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type OrderChangeResponse = NoOrderChange | OrderChange | OrderChangeError | OrderChangeReverted;

export type OrderChangeReverted = {
  __typename?: 'OrderChangeReverted';
  responseType: ResponseType | '%future added value';
};

export type OrderChannelContactInfos = {
  __typename?: 'OrderChannelContactInfos';
  orderChannelContactInfos: Array<Scalars['String']['output']>;
};

export const OrderClass = {
  Multiple: 'Multiple',
  Single: 'Single'
} as const;

export type OrderClass = typeof OrderClass[keyof typeof OrderClass];
export const OrderCommitSource = {
  CheckoutV3: 'CHECKOUT_V3',
  LegacyV2: 'LEGACY_V2'
} as const;

export type OrderCommitSource = typeof OrderCommitSource[keyof typeof OrderCommitSource];
export type OrderConfirmedNotification = {
  __typename?: 'OrderConfirmedNotification';
  id: Scalars['ID']['output'];
  supplierId: Scalars['ID']['output'];
  user: User;
};

export type OrderCorrection = {
  __typename?: 'OrderCorrection';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  customer?: Maybe<ChatRef>;
  deliveryDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invalidOrder?: Maybe<OrderCorrectionInvalidOrderType | '%future added value'>;
  omnichannelOrderId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  poNumber?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<OrderedProductCorrection>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type OrderCorrectionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  invalidOrder?: InputMaybe<OrderCorrectionInvalidOrderType | '%future added value'>;
  omnichannelOrderId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<OrderedProductCorrectionInput>>;
};

export const OrderCorrectionInvalidOrderType = {
  Duplicate: 'duplicate',
  MultiOrder: 'multiOrder',
  NotAnOrder: 'notAnOrder',
  Other: 'other',
  PartOfExistingOrder: 'partOfExistingOrder'
} as const;

export type OrderCorrectionInvalidOrderType = typeof OrderCorrectionInvalidOrderType[keyof typeof OrderCorrectionInvalidOrderType];
export type OrderCorrectionResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | OrderCorrection;

export type OrderCreateV2Input = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated no longer needed as part of orderCreateV2 */
  chatId?: InputMaybe<Scalars['ID']['input']>;
  deliveryDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  estimatedOrderTotal?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this order is a top-up order (added to a delivery date that already has a qualifying order). */
  isTopUp?: InputMaybe<Scalars['Boolean']['input']>;
  minOrderCurrency?: InputMaybe<Scalars['String']['input']>;
  minOrderValue?: InputMaybe<Scalars['Int']['input']>;
  orderCurrency?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use { orderedProducts } instead */
  orderProducts?: InputMaybe<Array<InputMaybe<OrderProductInput>>>;
  orderedProducts?: InputMaybe<Array<InputMaybe<OrderedProductInput>>>;
  poNumber?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated no longer needed as part of orderCreateV2 */
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated no longer needed as part of orderCreateV2 */
  supplierRefId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated no longer needed as part of orderCreateV2 */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export const OrderCreatedContext = {
  ChocoAi: 'chocoAi',
  ChocoApp: 'chocoApp',
  ChocoWeb: 'chocoWeb',
  IntegrationPublicApi: 'integrationPublicApi',
  TeamOrder: 'teamOrder',
  VoiceAgent: 'voiceAgent',
  WhiteLabelApp: 'whiteLabelApp',
  WhiteLabelWeb: 'whiteLabelWeb'
} as const;

export type OrderCreatedContext = typeof OrderCreatedContext[keyof typeof OrderCreatedContext];
export type OrderCreatedError = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderCreatedError';
  errorCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated use invalidProductIds instead */
  invalidBuyerProductIds?: Maybe<Array<Scalars['String']['output']>>;
  invalidProductIds?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  noMinimumOrderableAmountProducts?: Maybe<Array<NoMinimumOrderableAmountProduct>>;
  productBuyerCommentsNotAllowed?: Maybe<Array<Scalars['String']['output']>>;
  /** Products with price edits attempted by a buyer (non-supplier) user */
  productsWithBuyerPriceEdits?: Maybe<Array<ProductPriceEditInfo>>;
  /** Products with negative prices */
  productsWithNegativePrices?: Maybe<Array<ProductPriceEditInfo>>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  unavailableProducts?: Maybe<Array<UnavailableProductType>>;
};

export type OrderCreatedResponse = AuthorizationFailure | Order | OrderCreatedError;

export type OrderDeclined = {
  __typename?: 'OrderDeclined';
  id: Scalars['ID']['output'];
};

export type OrderDeliveryCheckAlreadyCompleted = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderDeliveryCheckAlreadyCompleted';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type OrderDeliveryCheckCreationResponse = AuthorizationFailure | InputValidationFailure | OrderDeliveryCheckAlreadyCompleted | OrderDeliveryCheckDetails | OrderDeliveryCheckExists | OrderNotFound;

export type OrderDeliveryCheckDetails = {
  __typename?: 'OrderDeliveryCheckDetails';
  completedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  completedBy?: Maybe<User>;
  deliveryCheckReconciliationRequest?: Maybe<DeliveryCheckReconciliationRequest>;
  deliveryNote?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['ID']['output'];
  orderedProducts: Array<Maybe<OrderedProductDeliveryCheck>>;
  status?: Maybe<OrderDeliveryCheckStatus | '%future added value'>;
};

export type OrderDeliveryCheckExists = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderDeliveryCheckExists';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type OrderDeliveryCheckImage = {
  __typename?: 'OrderDeliveryCheckImage';
  imageId: Scalars['String']['output'];
  imageUploadStatus: OrderDeliveryCheckImageUploadStatus | '%future added value';
  imageUrl?: Maybe<Scalars['String']['output']>;
};

export type OrderDeliveryCheckImageNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderDeliveryCheckImageNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export const OrderDeliveryCheckImageUploadStatus = {
  Completed: 'completed',
  Pending: 'pending'
} as const;

export type OrderDeliveryCheckImageUploadStatus = typeof OrderDeliveryCheckImageUploadStatus[keyof typeof OrderDeliveryCheckImageUploadStatus];
export type OrderDeliveryCheckImageUploadUrlResponse = AuthorizationFailure | InputValidationFailure | OrderDeliveryCheckAlreadyCompleted | OrderDeliveryCheckImageNotFound | OrderDeliveryCheckImageUploadUrlResult | OrderNotFound;

export type OrderDeliveryCheckImageUploadUrlResult = {
  __typename?: 'OrderDeliveryCheckImageUploadUrlResult';
  imageId: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type OrderDeliveryCheckNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderDeliveryCheckNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type OrderDeliveryCheckReconciliationRequestIdNotMatched = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderDeliveryCheckReconciliationRequestIdNotMatched';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

/** Order delivery check service definitions. */
export const OrderDeliveryCheckStatus = {
  Completed: 'completed',
  Draft: 'draft'
} as const;

export type OrderDeliveryCheckStatus = typeof OrderDeliveryCheckStatus[keyof typeof OrderDeliveryCheckStatus];
export type OrderDeliveryCheckSubmissionResponse = AuthorizationFailure | InputValidationFailure | OrderDeliveryCheckAlreadyCompleted | OrderDeliveryCheckDetails | OrderDeliveryCheckNotFound | OrderDeliveryItemsMismatched | OrderNotFound;

export type OrderDeliveryDateAvailabilityFailure = {
  __typename?: 'OrderDeliveryDateAvailabilityFailure';
  earliestAvailableDate?: Maybe<Scalars['AWSDate']['output']>;
  message: Scalars['String']['output'];
};

export type OrderDeliveryDateCutoffTimeFailure = {
  __typename?: 'OrderDeliveryDateCutoffTimeFailure';
  cutoffTimeType: CutOffTimeType | '%future added value';
  leadTimeAdjustedCutoff: Scalars['AWSDateTime']['output'];
  message: Scalars['String']['output'];
};

export type OrderDeliveryItemsMismatched = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderDeliveryItemsMismatched';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type OrderDeskChatsConnection = Connection & {
  __typename?: 'OrderDeskChatsConnection';
  edges: Array<OrderDeskChatsEdge>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type OrderDeskChatsEdge = Edge & {
  __typename?: 'OrderDeskChatsEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

export type OrderDeskEmail = {
  email: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type OrderDeskEmailRemoved = {
  __typename?: 'OrderDeskEmailRemoved';
  email: Scalars['String']['output'];
  supplierId: Scalars['ID']['output'];
  type: OrderDestEmailListType | '%future added value';
};

export type OrderDeskNotification = {
  __typename?: 'OrderDeskNotification';
  omnichannelOrder: OmnichannelOrder;
  supplierId: Scalars['ID']['output'];
};

export type OrderDeskRemovedEmailResponse = AuthorizationFailure | InputValidationFailure | OrderDeskEmailRemoved;

export type OrderDeskReviewer = {
  __typename?: 'OrderDeskReviewer';
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  reviewer?: Maybe<User>;
  reviewerId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export const OrderDestEmailListType = {
  Allow: 'allow',
  Block: 'block'
} as const;

export type OrderDestEmailListType = typeof OrderDestEmailListType[keyof typeof OrderDestEmailListType];
export type OrderEditInput = {
  productsList?: InputMaybe<Array<EditedOrderProductsInput>>;
};

export type OrderEdited = {
  __typename?: 'OrderEdited';
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderEditedError = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderEditedError';
  errorCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated use invalidProductIds instead */
  invalidBuyerProductIds?: Maybe<Array<Scalars['String']['output']>>;
  invalidProductIds?: Maybe<Array<Scalars['String']['output']>>;
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
  unavailableProducts?: Maybe<Array<UnavailableProductType>>;
};

export type OrderEditedResponse = AuthorizationFailure | Order | OrderEditedError;

export type OrderFilter = {
  endDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  startDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  status?: InputMaybe<OrderStatus | '%future added value'>;
};

export type OrderGuide = {
  __typename?: 'OrderGuide';
  categories?: Maybe<Array<OrderGuideCategory>>;
  hasProducts?: Maybe<Scalars['Boolean']['output']>;
  products: OrderGuideProduct;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type OrderGuideBannerShoppableAd = AdInterface & {
  __typename?: 'OrderGuideBannerShoppableAd';
  /** Metadata for tracking and analytics */
  adMetadata: AdMetadata;
  /** ID of the campaign this ad belongs to */
  campaignId: Scalars['String']['output'];
  /** Unique identifier for the ad */
  id: Scalars['ID']['output'];
  /** The Order Guide banner image */
  orderGuideBannerImageUrl: Scalars['String']['output'];
  /** ID of the buyer segment this ad targets */
  segmentId: Scalars['ID']['output'];
  /** Variants from the DX owns the OG */
  unitVariants: Array<SupplierVendorItemUnitVariant>;
};

export type OrderGuideCategory = Node & {
  __typename?: 'OrderGuideCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderGuideCreated = {
  __typename?: 'OrderGuideCreated';
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderGuideCreatedError = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderGuideCreatedError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type OrderGuideCreatedResponse = OrderGuideCreatedError | OrderGuideCreatedSuccess;

export type OrderGuideCreatedSuccess = AppsyncResponse & {
  __typename?: 'OrderGuideCreatedSuccess';
  /** Always ResponseType.success */
  responseType: ResponseType | '%future added value';
};

/**
 * Input for `orderGuideCustomItemUnitsForAdminSearch`. Reuses `VendorItemUnitsForAdminSearchField` /
 * `VendorItemUnitsForAdminSearchFilterGroup` / `VendorItemUnitsForAdminSearchSort` as-is — the
 * order-guide index carries identical `vendorItem.*` / `vendorItemUnit.*` embeds to the catalog
 * index, so the same field registry, filter tree, and sort shape apply unchanged. No OG-specific
 * filter/sort types are introduced.
 */
export type OrderGuideCustomItemUnitsForAdminSearchInput = {
  /**
   * Always implicitly scoped to custom products only — buyer-created units that exist only in the
   * order-guide index and never appear in the catalog index. This query exists specifically to
   * cover that gap: standard catalog products are already searchable via `vendorItemUnitsForAdminSearch`,
   * whose filter/sort types this input reuses. Callers layer additional filtering on top via `filter`
   * (e.g. VENDOR_ID to scope to one vendor).
   */
  filter?: InputMaybe<VendorItemUnitsForAdminSearchFilterGroup>;
  pagination?: InputMaybe<PaginationInputV2>;
  /**
   * Free-text keyword search. When omitted, results are unranked (match_all) and ordered by `sort`
   * or relevance-independent default order.
   */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<VendorItemUnitsForAdminSearchSort>>;
};

export type OrderGuideFailure = {
  __typename?: 'OrderGuideFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type OrderGuideItemUnitsBrowseInput = {
  filter?: InputMaybe<BrowseFilterInput>;
  orderGuideId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInputV2>;
  /**
   * Sort field for the results.
   * `CustomSort` (default, via listPosition), `Name`, or `ProductCode`.
   */
  sort?: InputMaybe<OrderGuideV2SortField | '%future added value'>;
};

export type OrderGuideItemUnitsBrowseResponse = AuthorizationFailure | InputValidationFailure | OrderGuideItemUnitsBrowseSuccess;

export type OrderGuideItemUnitsBrowseResultEdge = Edge & {
  __typename?: 'OrderGuideItemUnitsBrowseResultEdge';
  cursor: Scalars['String']['output'];
  node: OrderGuideV2ItemUnit;
};

export type OrderGuideItemUnitsBrowseSuccess = AppsyncResponse & Connection & Page & {
  __typename?: 'OrderGuideItemUnitsBrowseSuccess';
  edges: Array<OrderGuideItemUnitsBrowseResultEdge>;
  facets: Array<FacetGroup>;
  pageInfo: PageInfo;
  responseType: ResponseType | '%future added value';
};

export type OrderGuideProduct = {
  __typename?: 'OrderGuideProduct';
  items?: Maybe<Array<OrderGuideProductItem>>;
  nextCursors?: Maybe<Array<Scalars['String']['output']>>;
};

export type OrderGuideProductArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  batchSize: Scalars['Int']['input'];
};

export type OrderGuideProductInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  productId: Scalars['ID']['input'];
};

export type OrderGuideProductItem = Node & {
  __typename?: 'OrderGuideProductItem';
  /** @deprecated Not returned anymore. Use `VendorItemUnit.price` or `VendorItemUnit.displayProperties` or `VendorItemUnit.buyerProperties` instead */
  buyerInventoryProduct?: Maybe<BuyerInventoryProduct>;
  categoryId?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  cutOffTime?: Maybe<Scalars['AWSTime']['output']>;
  /** @deprecated Not returned anymore. Use `Product.deliveryDateConditions` or `VendorItemUnitOrderingProperties.deliveryDateConditions` instead */
  deliveryDateConditions?: Maybe<ProductDeliveryDateCondition>;
  /** @deprecated Not returned anymore. Use `VendorItemUnit.price` instead */
  derivedPriceForOrderGuide?: Maybe<DerivedPriceForOrderGuideResponse>;
  /** @deprecated Not returned anymore. Use `VendorItemUnit.images` instead */
  displayImage?: Maybe<ProductImage>;
  enabled: Scalars['Boolean']['output'];
  externalID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  leadTime?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packSize?: Maybe<Scalars['String']['output']>;
  par?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};


export type OrderGuideProductItemBuyerInventoryProductArgs = {
  chatId: Scalars['ID']['input'];
};


export type OrderGuideProductItemDeliveryDateConditionsArgs = {
  chatId: Scalars['ID']['input'];
};


export type OrderGuideProductItemDerivedPriceForOrderGuideArgs = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
  chatId: Scalars['ID']['input'];
};

export type OrderGuideRequest = {
  __typename?: 'OrderGuideRequest';
  chatId: Scalars['String']['output'];
  createOrderGuideMethod: OrderGuideRequestMethod | '%future added value';
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  filesComment?: Maybe<Scalars['String']['output']>;
  requestId: Scalars['String']['output'];
  requestRefId?: Maybe<Scalars['String']['output']>;
  type: OrderGuideRequestType | '%future added value';
  uploadedFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userId: Scalars['String']['output'];
};

export type OrderGuideRequestError = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderGuideRequestError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type OrderGuideRequestInput = {
  chatId: Scalars['String']['input'];
  createOrderGuideMethod: OrderGuideRequestMethod | '%future added value';
  filesComment?: InputMaybe<Scalars['String']['input']>;
  requestId: Scalars['String']['input'];
  requestRefId?: InputMaybe<Scalars['String']['input']>;
  type: OrderGuideRequestType | '%future added value';
  uploadedFiles?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};

export const OrderGuideRequestMethod = {
  EmailChoco: 'emailChoco',
  PhotoUpload: 'photoUpload'
} as const;

export type OrderGuideRequestMethod = typeof OrderGuideRequestMethod[keyof typeof OrderGuideRequestMethod];
export type OrderGuideRequestResponse = OrderGuideRequest | OrderGuideRequestError;

export const OrderGuideRequestType = {
  Create: 'create',
  Update: 'update'
} as const;

export type OrderGuideRequestType = typeof OrderGuideRequestType[keyof typeof OrderGuideRequestType];
export type OrderGuideRequested = {
  __typename?: 'OrderGuideRequested';
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderGuideResponse = AuthorizationFailure | InputValidationFailure | OrderGuide | OrderGuideFailure;

/** Order guide */
export type OrderGuideV2 = Node & {
  __typename?: 'OrderGuideV2';
  /** We are only exposing the Id for now */
  id: Scalars['ID']['output'];
  /** Count of all the products in the order-guide */
  itemsCount?: Maybe<Scalars['Int']['output']>;
  /** # Non-unique human readable name of the order guide. */
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderGuideV2BatchUpdateInput = {
  /**
   * The ID of the chat to update the order guide for.
   * If no order guide exists for the chat, one will be created.
   * If more than one order guide exists for the chat - the fallback order guide will be used.
   * It is strongly recommended to use the orderGuideId instead of the chatId to control the order guide that is updated.
   * Either chatId or orderGuideId must be provided.
   */
  chatId?: InputMaybe<Scalars['ID']['input']>;
  /** If set to true, the operation will be validated but not executed. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** The items to update. */
  items: Array<OrderGuideV2BatchUpdateInputItem>;
  /** The mode of the batch update. */
  mode: OrderGuideV2BatchUpdateMode | '%future added value';
  /** If set to true, all the input will be created as custom products */
  onlyCreateCustomProducts?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The ID of the order guide to update.
   * Either chatId or orderGuideId must be provided.
   */
  orderGuideId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderGuideV2BatchUpdateInputItem = {
  /** Will be used for VendorItemUnitBuyerProperties */
  displayItemName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Will be used for VendorItemUnitBuyerProperties
   * @deprecated Use myPriceV2 instead
   */
  myPrice?: InputMaybe<NullableMoneyV2Input>;
  myPriceV2?: InputMaybe<NullableMoneyV2InputOptional>;
  /**
   * The name of the vendor item.
   * This will only be used if we are creating a new custom product and in that case it will be mandatory.
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The order guide category name
   * If the provided order guide category name exist this item will be added to it
   * else a new order guide category will be created with this name (name preserved as-is) and the item will be added to it.,
   */
  orderGuideCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** Will be used for VendorItemUnitBuyerProperties */
  par?: InputMaybe<Scalars['String']['input']>;
  /**
   * Will be used to match vendor item in the catalog.
   * Mapped to vendorItem.productCode
   */
  productCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Used to match vendor item unit in the catalog.
   * Mapped to vendorItemUnit.code
   */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type OrderGuideV2BatchUpdateInvalidInputItem = {
  __typename?: 'OrderGuideV2BatchUpdateInvalidInputItem';
  errorCode: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  item: OrderGuideV2BatchUpdateInvalidInputItemParams;
  reason: Scalars['String']['output'];
};

export type OrderGuideV2BatchUpdateInvalidInputItemParams = {
  __typename?: 'OrderGuideV2BatchUpdateInvalidInputItemParams';
  displayItemName?: Maybe<Scalars['String']['output']>;
  myPrice?: Maybe<MoneyV2>;
  name?: Maybe<Scalars['String']['output']>;
  orderGuideCategoryName?: Maybe<Scalars['String']['output']>;
  par?: Maybe<Scalars['String']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  unit: Scalars['String']['output'];
};

export const OrderGuideV2BatchUpdateMode = {
  AddOnly: 'AddOnly',
  Replace: 'Replace',
  Update: 'Update'
} as const;

export type OrderGuideV2BatchUpdateMode = typeof OrderGuideV2BatchUpdateMode[keyof typeof OrderGuideV2BatchUpdateMode];
export type OrderGuideV2BatchUpdateParams = {
  __typename?: 'OrderGuideV2BatchUpdateParams';
  chatId?: Maybe<Scalars['ID']['output']>;
  /** Whether or not the dryRun flag was set */
  dryRun: Scalars['Boolean']['output'];
  /** Whether or not the onlyAddMissingItems flag was passed */
  mode: OrderGuideV2BatchUpdateMode | '%future added value';
  /** Whether or not the onlyCreateCustomProducts flag was set */
  onlyCreateCustomProducts: Scalars['Boolean']['output'];
  orderGuideId?: Maybe<Scalars['ID']['output']>;
};

export type OrderGuideV2BatchUpdateResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2BatchUpdateResult;

export type OrderGuideV2BatchUpdateResult = AppsyncResponse & {
  __typename?: 'OrderGuideV2BatchUpdateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** Summary of the updated order guide items. */
  summary: OrderGuideV2BatchUpdateSummary;
};

export type OrderGuideV2BatchUpdateSummary = {
  __typename?: 'OrderGuideV2BatchUpdateSummary';
  batchUpdateParams: OrderGuideV2BatchUpdateParams;
  /** No of VendorItems created after the update */
  createdCustomVendorItems: Scalars['Int']['output'];
  /** list of items that failed validation */
  errors: Array<OrderGuideV2BatchUpdateInvalidInputItem>;
  /** No. of items existing in the order guide before the update */
  existingOrderGuideItems: Scalars['Int']['output'];
  /** No. of new items that were added to the order guide after the update */
  newOrderGuideItems: Scalars['Int']['output'];
  /** No. of items that were removed from the order guide after the update */
  removedOrderGuideItems: Scalars['Int']['output'];
  /**
   * No. of items that were updated in the order guide after the update
   * This include update of buyer properties
   */
  updatedOrderGuideItems: Scalars['Int']['output'];
};

export type OrderGuideV2CategoriesInput = {
  excludeEmptyCategories?: InputMaybe<Scalars['Boolean']['input']>;
  includeOrderGuideSummary?: InputMaybe<Scalars['Boolean']['input']>;
  orderGuideId: Scalars['ID']['input'];
  pagination?: InputMaybe<PaginationInputV2>;
};

export type OrderGuideV2CategoriesResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2CategoriesResult;

export type OrderGuideV2CategoriesResult = AppsyncResponse & Connection & Page & {
  __typename?: 'OrderGuideV2CategoriesResult';
  edges: Array<OrderGuideV2CategoriesResultEdge>;
  orderGuideSummary?: Maybe<OrderGuideV2Summary>;
  pageInfo: PageInfo;
  responseType: ResponseType | '%future added value';
};

export type OrderGuideV2CategoriesResultEdge = Edge & {
  __typename?: 'OrderGuideV2CategoriesResultEdge';
  cursor: Scalars['String']['output'];
  node: OrderGuideV2Category;
};

export type OrderGuideV2CategoriesUpdateResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2CategoriesUpdateResult;

/** Success response of the `OrderGuideV2CategoriesUpdate` query */
export type OrderGuideV2CategoriesUpdateResult = AppsyncResponse & {
  __typename?: 'OrderGuideV2CategoriesUpdateResult';
  /** list of categories added to the order guide */
  added: Array<OrderGuideV2Category>;
  /** list of categories not found in the order guide. */
  notFound: Array<Scalars['ID']['output']>;
  /** list of categories removed from the order guide */
  removed: Array<OrderGuideV2Category>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** list of categories updated in the order guide */
  updated: Array<OrderGuideV2Category>;
};

/** Represents a category in the order guide. */
export type OrderGuideV2Category = Node & {
  __typename?: 'OrderGuideV2Category';
  /** The unique identifier for the order guide category. */
  id: Scalars['ID']['output'];
  /** The number of vendor item units in this category. */
  itemsCount: Scalars['Int']['output'];
  /** The position of the category in the order guide. */
  listPosition?: Maybe<Rational>;
  /** The name of the order guide category. */
  name: Scalars['String']['output'];
};

export type OrderGuideV2CategoryAddInputItem = {
  /**
   * The ID of the order guide category to add to the order guide category after.
   * 0-uuid can be provided to add the category to the front.
   * if not provided the category is added to the end
   */
  afterOrderGuideCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /** The order guide category name to be created */
  name: Scalars['String']['input'];
};

export const OrderGuideV2CategoryItemUnitsUpdateAllAction = {
  Move: 'Move',
  Remove: 'Remove'
} as const;

export type OrderGuideV2CategoryItemUnitsUpdateAllAction = typeof OrderGuideV2CategoryItemUnitsUpdateAllAction[keyof typeof OrderGuideV2CategoryItemUnitsUpdateAllAction];
export type OrderGuideV2CategoryItemUnitsUpdateAllInput = {
  /**
   * The action to perform on the vendor item units.
   * For the 'Move' action, All the item units in the source category will be moved to the target category.
   * For the 'Remove' action, All the item units in the source category will be removed from the order guide.
   */
  action: OrderGuideV2CategoryItemUnitsUpdateAllAction | '%future added value';
  /** The item units to exclude from the update. */
  excludeItemUnitIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The order guide to update the item units in. */
  orderGuideId: Scalars['ID']['input'];
  /** The source category to update the item units from. */
  sourceCategoryId: Scalars['ID']['input'];
  /**
   * The target category ID to move the item units to only relevant for the Move action.
   * For the 'Move' either targetCategoryId or targetCategoryName must be provided.
   */
  targetCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The target category name to move the item units to only relevant for the Move action.
   * If the a category of this name cannot be found, a new category will be created with this name.
   * For the 'Move' either targetCategoryId or targetCategoryName must be provided.
   */
  targetCategoryName?: InputMaybe<Scalars['String']['input']>;
};

export type OrderGuideV2CategoryItemUnitsUpdateAllResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2CategoryItemUnitsUpdateAllResult;

export type OrderGuideV2CategoryItemUnitsUpdateAllResult = {
  __typename?: 'OrderGuideV2CategoryItemUnitsUpdateAllResult';
  /** The action that was performed. */
  action: OrderGuideV2CategoryItemUnitsUpdateAllAction | '%future added value';
  /** The category that was created, if any. */
  createdCategory?: Maybe<OrderGuideV2Category>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** The number of units that were updated. */
  updatedUnits: Scalars['Int']['output'];
};

/**
 * Reference to the OrderGuideV2Category.
 * This type is returned when only the ID of the referenced object is known without additional querying.
 * If the object fields are needed, they can be fetched using the `node` field.
 */
export type OrderGuideV2CategoryRef = RefEdge & {
  __typename?: 'OrderGuideV2CategoryRef';
  /** The ID of the referenced object. */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<OrderGuideV2Category>;
};

export type OrderGuideV2CategoryUpdateInput = {
  /**
   * list of categories to add in the order guide, the maximum size should be 50
   * non-existing items are ignored.
   * Add are applied after updates
   */
  add?: InputMaybe<Array<OrderGuideV2CategoryAddInputItem>>;
  /** The order guide to add the category items to. */
  orderGuideId: Scalars['ID']['input'];
  /**
   * list of categories to remove from the order guide, the maximum size should be 50
   * non-existing items are ignored.
   * Remove are applied after add.
   * "The products from removed categories will become uncategorized"
   */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * list of categories to re-arrange in the order guide, the maximum size should be 50
   * non-existing items are ignored.
   * Updates are first applied
   */
  update?: InputMaybe<Array<OrderGuideV2CategoryUpdateInputItem>>;
};

export type OrderGuideV2CategoryUpdateInputItem = {
  /**
   * The ID of the order guide category to add to the order guide category after.
   * 0-uuid can be provided to add the category to the front.
   * if not provided the category maintains the same position
   */
  afterOrderGuideCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /** If provided the category name will be updated */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The order guide categories ID to update. */
  orderGuideCategoryId: Scalars['ID']['input'];
};

/** Represents a vendor item unit. */
export type OrderGuideV2ItemUnit = Node & {
  __typename?: 'OrderGuideV2ItemUnit';
  /** The unique identifier for the vendor item unit. */
  id: Scalars['ID']['output'];
  /** The position of the item in the order guide. */
  listPosition?: Maybe<Rational>;
  /** The order guide that this item belongs to. */
  orderGuide?: Maybe<OrderGuideV2Ref>;
  /** The vendor item unit. */
  orderGuideCategory?: Maybe<OrderGuideV2CategoryRef>;
  /** The eagerly resolved order guide that this item belongs to. */
  orderGuideNode?: Maybe<OrderGuideV2>;
  vendorItemUnit: VendorItemUnitRef;
};

export type OrderGuideV2ItemUnitOrderGuidesAddInput = {
  /**
   * The order guide category name to add the vendor item unit to.
   * If not provided or an empty string; the item will be added as uncategorized.
   * If the provided and an order guide with the same name exists; the item will be added to it.
   * else a new order guide category will be created with the name (name preserved as-is) and the item will be added to it.
   */
  orderGuideCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** The order guide to add the vendor item unit to. */
  orderGuideId: Scalars['ID']['input'];
};

export type OrderGuideV2ItemUnitOrderGuidesUpdateInput = {
  /**
   * The list of order guide IDs to add the vendor item unit to.
   * Any order-guides that already contain the vendor item unit will be ignored.
   */
  add?: InputMaybe<Array<OrderGuideV2ItemUnitOrderGuidesAddInput>>;
  /**
   * The list of order guide IDs to remove the vendor item unit from.
   * Any order-guides that do not contain the vendor item unit will be ignored.
   */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The vendor item unit to update the order-guides for. */
  vendorItemUnitId: Scalars['ID']['input'];
};

export type OrderGuideV2ItemUnitOrderGuidesUpdateResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2ItemUnitOrderGuidesUpdateResult;

export type OrderGuideV2ItemUnitOrderGuidesUpdateResult = AppsyncResponse & {
  __typename?: 'OrderGuideV2ItemUnitOrderGuidesUpdateResult';
  /** List of order guide item units representing the order-guides the vendor item units was added to. */
  added?: Maybe<Array<OrderGuideV2ItemUnit>>;
  /** List of order guide item units representing the order-guides the vendor item units was removed from. */
  removed?: Maybe<Array<OrderGuideV2ItemUnit>>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

/** Input parameters for adding an item (unit) to an order guide. */
export type OrderGuideV2ItemUnitsAddInput = {
  /**
   * The order guide unit items to add.
   * The maximum number of items that can be added in a single request is 50.
   */
  items: Array<OrderGuideV2ItemUnitsAddInputItem>;
  /** The order guide to add the vendor item unit to. */
  orderGuideId: Scalars['ID']['input'];
};

/**
 * OrderGuideV2ItemUnitsAddInput item
 * If orderGuideCategoryId is provided, the item will be added to the specified category.
 * If orderGuideCategoryName is provided, the item will be added to the category with the provided name (case insensitive).
 * If both orderGuideCategoryId and orderGuideCategoryName are provided, the orderGuideCategoryId takes precedence.
 * If neither is provided, the item will be added as uncategorized.
 */
export type OrderGuideV2ItemUnitsAddInputItem = {
  /**
   * The ID of the order guide vendor item unit to add to the order guide vendor item unit after.
   * 0-uuid can be provided to move the item to the front of its category.
   * if provided the vendor unit item will belong to the same category as this
   * if the item doesn't belong to the same category, then nothing happens
   */
  afterOrderGuideItemUnitId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The order guide category to add the vendor item unit to.
   * If not provided, the item will be added as uncategorized.
   * If 0-uuid is provided, the item will be added as uncategorized.
   */
  orderGuideCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The order guide category name
   * If the provided order guide category name exist this item is added to it
   * If the new order guide category is an empty string the item will be added as uncategorized.
   * else a new order guide category is created with this name (name preserved as-is) and the item is added to it.
   */
  orderGuideCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the vendor item unit to add to the order guide. */
  vendorItemUnitId: Scalars['ID']['input'];
};

export type OrderGuideV2ItemUnitsAddResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2ItemUnitsAddResult;

/** Success response of the `OrderGuideV2ItemUnitsAdd` query */
export type OrderGuideV2ItemUnitsAddResult = AppsyncResponse & {
  __typename?: 'OrderGuideV2ItemUnitsAddResult';
  /** The added order guide item units. */
  items: Array<OrderGuideV2ItemUnit>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

/** Filter input for the `OrderGuideV2ItemUnits` query */
export type OrderGuideV2ItemUnitsFilter = {
  /**
   * If provided, only items in the category with the specified ID will be returned.
   * If the value is "00000000-0000-0000-0000-000000000000", only uncategorized items are returned.
   */
  orderGuideCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If provided, only items in the category with the specified IDs will be returned.
   * The value "00000000-0000-0000-0000-000000000000" could be used to return uncategorized items.
   */
  orderGuideCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** If provided and set to true, only items without a category are returned. */
  uncategorized?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for the `orderGuideItemUnits` query */
export type OrderGuideV2ItemUnitsInput = {
  /** Additional filters to narrow down the output */
  filter?: InputMaybe<OrderGuideV2ItemUnitsFilter>;
  /** The ID of the order guide to get the units for. */
  orderGuideId: Scalars['ID']['input'];
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
  /** Optional sorting parameters for the output */
  sort?: InputMaybe<OrderGuideV2SortParamsInput>;
};

/** Input parameters for removing an item (unit) to an order guide. */
export type OrderGuideV2ItemUnitsRemoveInput = {
  /** The order guide to add the vendor item unit to. */
  orderGuideId: Scalars['ID']['input'];
  /**
   * The order guide unit items to add.
   * The maximum number of items that can be added in a single request is 50.
   */
  vendorItemUnitIds: Array<Scalars['ID']['input']>;
};

export type OrderGuideV2ItemUnitsRemoveResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2ItemUnitsRemoveResult;

/** Success response of the `orderGuideItemUnitsRemove` query */
export type OrderGuideV2ItemUnitsRemoveResult = AppsyncResponse & {
  __typename?: 'OrderGuideV2ItemUnitsRemoveResult';
  /** The removed order guide item units. */
  items: Array<OrderGuideV2ItemUnit>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /**
   * Whether or not the operation was successful.
   * This will always be set to `true`.
   */
  success: Scalars['Boolean']['output'];
};

export type OrderGuideV2ItemUnitsResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2ItemUnitsResult;

/** Success response of the `OrderGuideV2ItemUnits` query */
export type OrderGuideV2ItemUnitsResult = AppsyncResponse & Connection & Page & {
  __typename?: 'OrderGuideV2ItemUnitsResult';
  /** The edges of the response. */
  edges: Array<OrderGuideV2ItemUnitsResultEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** Sorting information */
  sortedBy?: Maybe<OrderGuideV2SortParams>;
};

/** One item of the `OrderGuideV2ItemUnits` query result page */
export type OrderGuideV2ItemUnitsResultEdge = Edge & {
  __typename?: 'OrderGuideV2ItemUnitsResultEdge';
  /**
   * The cursor for the current item.
   * This can be used to fetch the next page of items starting using this item as a reference.
   */
  cursor: Scalars['String']['output'];
  /** An order guide item unit reference */
  node: OrderGuideV2ItemUnit;
};

export type OrderGuideV2ItemUnitsUpdateInput = {
  /**
   * list of items to add to the order guide, the maximum size should be 50
   * existing items are not changed.
   * Add are applied after updates
   */
  add?: InputMaybe<Array<OrderGuideV2ItemUnitsAddInputItem>>;
  /** The order guide to update the vendor item unit to. */
  orderGuideId: Scalars['ID']['input'];
  /**
   * list of items to remove from the order guide, the maximum size should be 50
   * non-existing items are ignored.
   * Remove are applied after add
   */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * list of items to re-arrange in the order guide, the maximum size should be 50
   * non-existing items are ignored.
   * Updates are first applied
   */
  update?: InputMaybe<Array<OrderGuideV2ItemUnitsUpdateInputItem>>;
};

export type OrderGuideV2ItemUnitsUpdateInputItem = {
  /**
   * The ID of the order guide vendor item unit to add to the order guide vendor item unit after.
   * 0-uuid can be provided to move the item to the front of its category.
   * if provided the vendor unit item will belong to the same category as this
   * if the item doesn't belong to the same category, then nothing happens
   */
  afterOrderGuideItemUnitId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The order guide category to add the vendor item unit to.
   * If not provided for add operation, the item will be added as uncategorized.
   * If not provided for update operation, the item maintains the same category.
   * 0-uuid can be provided to move item to uncategorized.
   */
  orderGuideCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The order guide category name
   * If the provided order guide category name exist this item is added to it
   * else a new order guide category is created with this name (name preserved as-is) and the item is added to it.
   * If both this and orderGuideCategoryId are provided, the orderGuideCategoryId takes precedence.
   * Empty string can be provided to move item to uncategorized.
   */
  orderGuideCategoryName?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the vendor item unit to add to the order guide. */
  vendorItemUnitId: Scalars['ID']['input'];
};

export type OrderGuideV2ItemUnitsUpdateResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2ItemUnitsUpdateResult;

export type OrderGuideV2ItemUnitsUpdateResult = AppsyncResponse & {
  __typename?: 'OrderGuideV2ItemUnitsUpdateResult';
  /** vendor unit items added to the order guide */
  added: Array<OrderGuideV2ItemUnit>;
  /** vendor unit items not found in the order guide */
  notFound: Array<Scalars['ID']['output']>;
  /** vendor unit items  removed from the order guide */
  removed: Array<OrderGuideV2ItemUnit>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** vendor unit items updated in the order guide */
  updated: Array<OrderGuideV2ItemUnit>;
};

export type OrderGuideV2OrderGuideCreateInput = {
  chatId: Scalars['ID']['input'];
  isFallback?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type OrderGuideV2OrderGuideCreateResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2Ref;

export type OrderGuideV2OrderGuideRemoveInput = {
  orderGuideId: Scalars['ID']['input'];
};

export type OrderGuideV2OrderGuideRemoveResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2OrderGuideRemoveResult;

export type OrderGuideV2OrderGuideRemoveResult = AppsyncResponse & {
  __typename?: 'OrderGuideV2OrderGuideRemoveResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /**
   * Whether or not the operation was successful.
   * This will always be set to `true`.
   */
  success: Scalars['Boolean']['output'];
};

export type OrderGuideV2OrderGuideUpdateInput = {
  isFallback?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderGuideId: Scalars['ID']['input'];
};

export type OrderGuideV2OrderGuideUpdateResponse = AuthorizationFailure | InputValidationFailure | OrderGuideV2Ref;

/** Order guide reference */
export type OrderGuideV2Ref = RefEdge & {
  __typename?: 'OrderGuideV2Ref';
  id: Scalars['ID']['output'];
  node?: Maybe<OrderGuideV2>;
};

export const OrderGuideV2SortField = {
  AddedToOrderGuide: 'AddedToOrderGuide',
  CustomSort: 'CustomSort',
  Name: 'Name',
  ProductCode: 'ProductCode'
} as const;

export type OrderGuideV2SortField = typeof OrderGuideV2SortField[keyof typeof OrderGuideV2SortField];
export type OrderGuideV2SortParams = {
  __typename?: 'OrderGuideV2SortParams';
  /** The direction results were sorted by. */
  direction: SortDirection | '%future added value';
  /** The field to results were sorted by. */
  field: OrderGuideV2SortField | '%future added value';
};

export type OrderGuideV2SortParamsInput = {
  direction: SortDirection | '%future added value';
  field: OrderGuideV2SortField | '%future added value';
};

export type OrderGuideV2Summary = {
  __typename?: 'OrderGuideV2Summary';
  allItemsCount: Scalars['Int']['output'];
  uncategorizedItemsCount: Scalars['Int']['output'];
};

export type OrderHasNoInvoice = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderHasNoInvoice';
  attachment?: Maybe<InvoiceAttachment>;
  /** Always null */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type OrderHasOnlyAttachment = AppsyncResponse & {
  __typename?: 'OrderHasOnlyAttachment';
  attachment?: Maybe<InvoiceAttachment>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type OrderInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTeamOrder?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  orderProducts?: InputMaybe<Array<InputMaybe<OrderProductInput>>>;
};

export type OrderInvoice = AuthorizationFailure | InputValidationFailure | Invoice | OrderHasNoInvoice | OrderHasOnlyAttachment;

export type OrderMatchingConfidence = {
  __typename?: 'OrderMatchingConfidence';
  isDeliveryDateCorrect?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Returned when the order total is below the supplier's minimum order value.
 * Surfaced on approve because orderCreateV2 enforces the MOV rule.
 */
export type OrderMinimumOrderValueFailure = {
  __typename?: 'OrderMinimumOrderValueFailure';
  /** Current order total, in minor units (e.g. cents). */
  cartAmount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  message: Scalars['String']['output'];
  /** Required minimum order value, in minor units (e.g. cents). */
  requiredAmount: Scalars['Int']['output'];
};

export type OrderMinimumOrderableAmountFailure = {
  __typename?: 'OrderMinimumOrderableAmountFailure';
  message: Scalars['String']['output'];
  minimumOrderableAmount: Scalars['Float']['output'];
  productId: Scalars['String']['output'];
};

export type OrderNoDeliveryDateFailure = {
  __typename?: 'OrderNoDeliveryDateFailure';
  message: Scalars['String']['output'];
};

export type OrderNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'OrderNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type OrderPreference = {
  __typename?: 'OrderPreference';
  /** @deprecated fax is no longer supported */
  fax?: Maybe<Scalars['String']['output']>;
  pdf?: Maybe<Scalars['Boolean']['output']>;
  sms?: Maybe<Scalars['String']['output']>;
  welcomeNotificationSent?: Maybe<Scalars['AWSTimestamp']['output']>;
  whatsApp?: Maybe<Scalars['String']['output']>;
  xlsx?: Maybe<Scalars['Boolean']['output']>;
};

export type OrderPreferenceInput = {
  /** @deprecated fax is no longer supported */
  fax?: InputMaybe<Scalars['String']['input']>;
  pdf?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['String']['input']>;
  welcomeNotificationSent?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  whatsApp?: InputMaybe<Scalars['String']['input']>;
  xlsx?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Committed order pricing. Every amount is nullable because absent and zero are
 * different facts: the engine omits a total it could not compute (the row stores
 * it as absent since PRO-276), while 0 is a real computed zero. Never coerce a
 * missing amount to 0 on the way out.
 */
export type OrderPricing = {
  __typename?: 'OrderPricing';
  /**
   * The rows behind totalSavingsAmount, so a client can show the savings directly.
   * Checkout emits one row per line with a catalog price discount, then one row per
   * promotion. It computes totalSavingsAmount as their sum. This mirrors the rows
   * the cart serves in CartPricing.savingsBreakdown. The order service returns the
   * rows as checkout sent them, in order. Null when nothing saved the buyer money,
   * where totalSavingsAmount is zero, and when the order was committed without the
   * rows. If Choco cannot read one stored row, the whole list is null.
   */
  savingsBreakdown?: Maybe<Array<OrderSavingsEntry>>;
  /** Merchandise amount before catalog price discounts and Checkout promotion effects. Equals the pricing basis when whole-cart savings are unknowable. */
  subtotalAmount?: Maybe<MoneyV2>;
  /**
   * The order's tax grouped by tax rate, so a client can show it without adding up
   * the lines. Checkout writes it when it commits the order. Deposit amounts are
   * not listed here, they are in totalDepositAmount, so these rows add up to
   * totalTaxAmount. An empty list means the tax engine ran and no rate applied.
   * Null when the tax engine produced no result, and when the order was committed
   * without it. If Choco cannot read one stored row, the whole list is null.
   */
  taxSummary?: Maybe<Array<OrderTaxSummaryLine>>;
  /**
   * Refundable deposit the buyer pays on returnable packaging, such as crates and
   * bottles. Choco keeps it out of totalTaxAmount so a client can show it as its
   * own line. It is part of the gross total: totalGrossAmount = totalNetAmount +
   * totalTaxAmount + totalDepositAmount, where a null deposit counts as zero.
   * Null when the deposit is zero, when the distributor has taxes disabled, and
   * when the order was committed without it.
   */
  totalDepositAmount?: Maybe<MoneyV2>;
  totalDiscountAmount?: Maybe<MoneyV2>;
  totalFeesAmount?: Maybe<MoneyV2>;
  /** Goods including tax, before fees. Equals the sum of the line gross totals. */
  totalGrossAmount?: Maybe<MoneyV2>;
  totalNetAmount?: Maybe<MoneyV2>;
  /** Grand total the buyer pays: gross plus fees. */
  totalPayableAmount?: Maybe<MoneyV2>;
  /**
   * What the buyer saved: the catalog price discounts plus the promotion savings.
   * Promotion savings are the discounts plus the value of the free items granted.
   * Checkout computes the figure when it commits the order, mirroring
   * CartPricing.totalSavingsAmount. It comes out at least as large as
   * totalDiscountAmount, which counts the promotion discounts alone. Zero when
   * nothing saved the buyer money, which includes a supplier whose promotions are
   * off. Null only when the saving is unknowable: no single priced subtotal, a
   * granted free item Choco could not price, or two lines discounted in different
   * currencies. Also null when the order was committed without it.
   */
  totalSavingsAmount?: Maybe<MoneyV2>;
  /**
   * Tax charged to the buyer. Zero when nothing is taxed, including a missing
   * tax profile and taxes disabled, and when Tax did not return an amount on an
   * order that still has a subtotal. Null when the order has no subtotal. A null
   * tax counts as zero in totalGrossAmount.
   */
  totalTaxAmount?: Maybe<MoneyV2>;
};

export type OrderProcessingRetrying = {
  __typename?: 'OrderProcessingRetrying';
  message?: Maybe<Scalars['String']['output']>;
  omnichannelOrderId: Scalars['ID']['output'];
};

export type OrderProduct = {
  __typename?: 'OrderProduct';
  amount: Scalars['Float']['output'];
  /** Product-level comment from the buyer */
  buyerComment?: Maybe<Scalars['String']['output']>;
  product: Product;
};

export type OrderProductAvailabilityFailure = {
  __typename?: 'OrderProductAvailabilityFailure';
  message: Scalars['String']['output'];
  productId: Scalars['String']['output'];
  stockStatus: VendorItemUnitStockStatus | '%future added value';
};

export type OrderProductCutoffTimeFailure = {
  __typename?: 'OrderProductCutoffTimeFailure';
  cutoffTime: Scalars['AWSTime']['output'];
  message: Scalars['String']['output'];
  productId: Scalars['String']['output'];
};

export type OrderProductEarnedBy = {
  __typename?: 'OrderProductEarnedBy';
  /** Position of that paid line within the order. */
  listPosition?: Maybe<Scalars['Int']['output']>;
  /** The paid line that earned the grant, exposed as a ref so callers can resolve its name and unit. */
  vendorItemUnit?: Maybe<VendorItemUnitRef>;
};

export type OrderProductInput = {
  amount: Scalars['Int']['input'];
  product: ProductInput;
};

export type OrderProductLeadTimeFailure = {
  __typename?: 'OrderProductLeadTimeFailure';
  leadTimeDays: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  productId: Scalars['String']['output'];
};

export type OrderProductPromotion = {
  __typename?: 'OrderProductPromotion';
  /** The tiers of this promotion that applied to the line, in application order. */
  appliedTiers: Array<OrderProductPromotionTier>;
  /** External promotion code from the vendor's ERP, e.g. 'PROMO-2026-SUMMER-10'. Null when the promotion has no external code. */
  promotionCode?: Maybe<Scalars['String']['output']>;
  /** Choco promotion entity id. */
  promotionId: Scalars['ID']['output'];
  /** Buyer-facing promotion name, as shown on the cart. Null on orders persisted before it. */
  shortDescription?: Maybe<Scalars['String']['output']>;
};

export type OrderProductPromotionTier = {
  __typename?: 'OrderProductPromotionTier';
  discountAmount?: Maybe<MoneyV2>;
  /** Discount percentage as a decimal, e.g. '10.00'. */
  discountPercentage?: Maybe<Decimal>;
  /** Buyer-selectable free item options granted by this tier. */
  freeItemChoiceOptions?: Maybe<Array<FreeItemChoiceOption>>;
  offerType: OfferType | '%future added value';
  /** External tier code from the vendor's ERP. Null when the tier has no external code. */
  promotionTierCode?: Maybe<Scalars['String']['output']>;
  /** Identifier of the promotion tier that was applied. */
  promotionTierId: Scalars['ID']['output'];
};

export type OrderProductTax = {
  __typename?: 'OrderProductTax';
  appliesToFreeProducts: Scalars['Boolean']['output'];
  isExempt: Scalars['Boolean']['output'];
  /** Jurisdiction the tax rate belongs to, as a country/region code, e.g. 'FR', 'DE'. */
  jurisdictionCode: Scalars['String']['output'];
  /** Human-readable tax label, e.g. 'TVA 20%', 'KDV %18'. */
  label?: Maybe<Scalars['String']['output']>;
  taxAmount: MoneyV2;
  taxBasis: MoneyV2;
  /** Denormalized ERP code for round-trip export, e.g. 'S1'. Null when the rate has no ERP code. */
  taxRateCode?: Maybe<Scalars['String']['output']>;
  /** Identifier of the tax rate this snapshot was taken from. */
  taxRateId: Scalars['ID']['output'];
  /** The rate's value: either a percentage or a fixed per-unit amount. */
  value: PercentageOrFixedAmount;
};

export type OrderRejected = {
  __typename?: 'OrderRejected';
  id: Scalars['ID']['output'];
};

export type OrderRejectedNotification = {
  __typename?: 'OrderRejectedNotification';
  id: Scalars['ID']['output'];
  supplierId: Scalars['ID']['output'];
  user: User;
};

export type OrderRestaurant = Node & {
  __typename?: 'OrderRestaurant';
  customerNumber?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  restaurantName?: Maybe<Scalars['String']['output']>;
};

/**
 * One thing that saved the buyer money, captured when checkout committed the order.
 * It is either a catalog price discount on one line, or one promotion. Mirrors the
 * cart's CartSavingsEntry.
 */
export type OrderSavingsEntry = {
  __typename?: 'OrderSavingsEntry';
  /** The amount this row saved. Checkout emits it as a positive figure, which a client displays as a reduction. */
  amount: MoneyV2;
  /** Buyer-facing description of what saved the money, set by Choco. Null when there is none, so a client uses its own wording. */
  label?: Maybe<Scalars['String']['output']>;
};

export const OrderStatus = {
  /** Approval cycle: the order was cancelled and will not be fulfilled */
  Cancelled: 'cancelled',
  Confirmed: 'confirmed',
  Created: 'created',
  Delivered: 'delivered',
  /** Delivery cycle: a delivery date has been planned for the order */
  DeliveryPlanned: 'deliveryPlanned',
  /** Delivery cycle: the order is on its way to the customer */
  InDelivery: 'inDelivery',
  /** Invoicing cycle: an invoice has been issued for the order */
  Invoiced: 'invoiced',
  Pending: 'pending',
  /** Order is awaiting buyer approval (PunchOut integration flow) */
  PendingBuyerApproval: 'pendingBuyerApproval',
  /** Approval cycle: the order has been received by the supplier's system */
  Received: 'received',
  /** Order is rejected by the buyer (PunchOut integration flow) */
  RejectedByBuyer: 'rejectedByBuyer'
} as const;

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];
/**
 * Every line tax of one rate, added up for the order and captured at commit. Field
 * names follow the per-line OrderProductTax row. The cart calls the same shape
 * TaxSummaryLine, where taxBasis is named taxableAmount.
 */
export type OrderTaxSummaryLine = {
  __typename?: 'OrderTaxSummaryLine';
  /** Buyer-facing label for the rate, for example 'TVA 20%'. The tax engine localizes it when it has a translation. An empty string means it had none. */
  label?: Maybe<Scalars['String']['output']>;
  /** The tax this rate produced, added up across the order's lines. */
  taxAmount: MoneyV2;
  /** The amount this rate was charged on, added up across the order's lines. */
  taxBasis: MoneyV2;
  /** Identifier of the tax rate this row covers. The same identifier appears on the matching OrderProductTax rows, so a client can join them. */
  taxRateId: Scalars['ID']['output'];
  /** The rate's value: either a percentage or a fixed per-unit amount. */
  value: PercentageOrFixedAmount;
};

/**
 * Order transmission validation: order-scoped (no line join).
 *
 * A chat with no order-transmission channel — no supplier order transmission, no
 * additional emails, and no supplier user with an order preference — cannot
 * receive an order, so this blocks the cart.
 */
export type OrderTransmissionValidationResult = CartValidationResult & {
  __typename?: 'OrderTransmissionValidationResult';
  overriddenBy?: Maybe<Scalars['String']['output']>;
  overrideable: Scalars['Boolean']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  source: ValidationSource | '%future added value';
  status: ValidationStatus | '%future added value';
};

export type OrderUploadMediaElementInput = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type OrderValidationFailure = InvalidProductsFailure | OrderDeliveryDateAvailabilityFailure | OrderDeliveryDateCutoffTimeFailure | OrderMinimumOrderValueFailure | OrderMinimumOrderableAmountFailure | OrderNoDeliveryDateFailure | OrderProductAvailabilityFailure | OrderProductCutoffTimeFailure | OrderProductLeadTimeFailure;

export type OrderValidationFailures = {
  __typename?: 'OrderValidationFailures';
  validationFailures?: Maybe<Array<OrderValidationFailure>>;
};

export const OrderValidationMode = {
  Strict: 'strict',
  WithOverrides: 'withOverrides'
} as const;

export type OrderValidationMode = typeof OrderValidationMode[keyof typeof OrderValidationMode];
export type OrderedProduct = {
  __typename?: 'OrderedProduct';
  amount: Scalars['Float']['output'];
  /** Base unit code (e.g. "lb", "kg") for catchweight/dual-unit products. */
  baseUnitCode?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  /** Product-level comment from the buyer */
  buyerComment?: Maybe<Scalars['String']['output']>;
  buyerPrice?: Maybe<Money>;
  /** Product specific instructions from the supplier */
  comment?: Maybe<Scalars['String']['output']>;
  conversionFactor?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Display base price for catchweight/dual-unit products.
   * When the reviewer provides an acceptedBasePrice, it is used here; otherwise sourced from the catalog snapshot.
   */
  displayBasePrice?: Maybe<MoneyV2>;
  displayPrice?: Maybe<Money>;
  /**
   * If the property 'displayPriceBeforeDiscount' is undefined, there is no discount.
   * If it is present, the discounted price can be read from the 'displayPrice' property.
   */
  displayPriceBeforeDiscount?: Maybe<Money>;
  ean?: Maybe<Scalars['String']['output']>;
  /** The paid lines that earned this free grant. Empty for a basket reward not tied to specific lines. */
  earnedBy?: Maybe<Array<OrderProductEarnedBy>>;
  externalId?: Maybe<Scalars['String']['output']>;
  grossUnitPrice?: Maybe<MoneyV2>;
  invoiceUnit?: Maybe<Scalars['String']['output']>;
  /** Whether this line is an engine-derived free item. */
  isFreeItem?: Maybe<Scalars['Boolean']['output']>;
  /** Payable discount attributed to this line. */
  lineDiscountAmount?: Maybe<MoneyV2>;
  listPosition?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use Order.loyalty instead */
  loyalty?: Maybe<LoyaltyPoints>;
  name?: Maybe<Scalars['String']['output']>;
  netUnitPrice?: Maybe<MoneyV2>;
  orderId: Scalars['String']['output'];
  origin?: Maybe<Scalars['String']['output']>;
  packSize?: Maybe<Scalars['String']['output']>;
  /** Whether the persisted unit prices are net or gross of tax (checkout v3). */
  priceSemantics?: Maybe<PriceSemantics | '%future added value'>;
  productId: Scalars['String']['output'];
  /** Line-level promotion effects. */
  promotions?: Maybe<Array<OrderProductPromotion>>;
  supplierId?: Maybe<Scalars['String']['output']>;
  supplierPrice?: Maybe<Money>;
  /** Line-level tax snapshot, one entry per tax type. */
  taxes?: Maybe<Array<OrderProductTax>>;
  /**
   * (paidQuantity + freeQuantity) × unit price before discounts and promotions;
   * the strikethrough amount for the line. Null unless different from
   * totalNetAmount.
   */
  totalAmountBeforeDiscount?: Maybe<MoneyV2>;
  totalGrossAmount?: Maybe<MoneyV2>;
  totalNetAmount?: Maybe<MoneyV2>;
  totalTaxAmount?: Maybe<MoneyV2>;
  unit?: Maybe<Scalars['String']['output']>;
  /** Unit price basis before promotion effects. */
  unitPriceBeforePromotion?: Maybe<MoneyV2>;
  upc?: Maybe<Scalars['String']['output']>;
  /**
   * Reference to the ordered product unit in the live catalog.
   * May be null if the product is no longer available in the live catalog.
   */
  vendorItemUnit?: Maybe<VendorItemUnitRef>;
};

export type OrderedProductCorrection = {
  __typename?: 'OrderedProductCorrection';
  /** A comment to further express the correction. */
  comment?: Maybe<Scalars['String']['output']>;
  /** External ID from Supplier ERP system or similar external system for product identification */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Line item ID from CAI context to identify a specific product on a list of products */
  lineItemId?: Maybe<Scalars['String']['output']>;
  /** Name of the product */
  name: Scalars['String']['output'];
  /** The corrected price */
  price?: Maybe<MoneyV2>;
  /** Product ID from the Choco product context */
  productId: Scalars['String']['output'];
  /** Corrected quantity value for this product line item */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** Unit of measurement for the product quantity (e.g., pieces, kg, liters) */
  unit?: Maybe<Scalars['String']['output']>;
};

export type OrderedProductCorrectionInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  lineItemId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  price?: InputMaybe<MoneyV2Input>;
  productId: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type OrderedProductDeliveryCheck = {
  __typename?: 'OrderedProductDeliveryCheck';
  /** @deprecated use deliveryCheckProblems[<item.amountDelivered>] instead */
  amountDelivered?: Maybe<Scalars['Float']['output']>;
  amountOrdered?: Maybe<Scalars['Float']['output']>;
  deliveryCheckProblems?: Maybe<Array<Maybe<DeliveryCheckProblem>>>;
  images?: Maybe<Array<Maybe<OrderDeliveryCheckImage>>>;
  orderId: Scalars['ID']['output'];
  orderedProductMetadata?: Maybe<OrderedProductMetadata>;
  productId: Scalars['ID']['output'];
};

export const OrderedProductDeliveryCheckProblemType = {
  Defected: 'defected',
  Defective: 'defective',
  IncorrectQuantity: 'incorrectQuantity',
  Missing: 'missing',
  Other: 'other'
} as const;

export type OrderedProductDeliveryCheckProblemType = typeof OrderedProductDeliveryCheckProblemType[keyof typeof OrderedProductDeliveryCheckProblemType];
export type OrderedProductDeliveryCheckSubmissionResponse = AuthorizationFailure | InputValidationFailure | OrderDeliveryCheckAlreadyCompleted | OrderDeliveryItemsMismatched | OrderNotFound | OrderedProductDeliveryCheck;

export type OrderedProductInput = {
  /** Unit price in cents that the supplier accepted/set for this product */
  acceptedProductPrice?: InputMaybe<Scalars['Int']['input']>;
  amount: Scalars['Float']['input'];
  /** product-level comment from the buyer */
  buyerComment?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Not used anymore */
  buyerUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** @deprecated Not used anymore */
  derivedPriceForOrderGuideUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** @deprecated Obtained from productId automatically */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Flag indicating whether the price for this product was edited by the vendor during order review */
  isPriceEditedByVendor?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Obtained from productId automatically */
  name?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['String']['input'];
  /** @deprecated Not used anymore */
  supplierNegotiatedPriceUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** @deprecated Not used anymore */
  supplierUpdatedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** @deprecated Obtained from productId automatically */
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type OrderedProductMetadata = {
  __typename?: 'OrderedProductMetadata';
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};

export type OrderedProductMetadataInput = {
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type OrdersBulkDeclined = {
  __typename?: 'OrdersBulkDeclined';
  ids: Array<Scalars['ID']['output']>;
};

export type OrdersRejected = {
  __typename?: 'OrdersRejected';
  ids: Array<Scalars['ID']['output']>;
};

export type OrdersToReviewConnection = Connection & {
  __typename?: 'OrdersToReviewConnection';
  edges: Array<OrdersToReviewEdge>;
  pageInfo: PageInfo;
};

export type OrdersToReviewEdge = Edge & {
  __typename?: 'OrdersToReviewEdge';
  cursor: Scalars['String']['output'];
  node: OmnichannelOrder;
};

export type OrdersToReviewInput = {
  paginationInput?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Sort>;
  supplierEntityId: Scalars['ID']['input'];
};

export type OrdersToReviewResponse = InputValidationFailure | OrdersToReviewConnection;

/** A single page response for a paginated query */
export type Page = {
  /** Items included in the page */
  edges: Array<Edge>;
  /** Information about the page */
  pageInfo: PageInfo;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type PageRange = {
  __typename?: 'PageRange';
  endPage: Scalars['Int']['output'];
  startPage: Scalars['Int']['output'];
};

export const PaginationDirection = {
  Backward: 'backward',
  Forward: 'forward'
} as const;

export type PaginationDirection = typeof PaginationDirection[keyof typeof PaginationDirection];
/**
 * Input parameters for a cursor paginated query that can be traversed in both directions.
 * Only provide the parameters for the direction you want to traverse:
 * - when querying the next page, provide `first` and `after`
 * - when querying the previous page, provide `last` and `before`
 */
export type PaginationInput = {
  /**
   * Cursor from which the query should start when querying forward.
   * Normally would be set to the `endCursor` of the previous page or the cursor of the last item.
   */
  after?: InputMaybe<Scalars['String']['input']>;
  /**
   * Cursor from which the query should start when querying backward.
   * Normally would be set to the `startCursor` of the next page or the cursor of the first item.
   */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Maximum number of items to return in the page when querying forward */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum number of items to return in the page when querying backward */
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Input parameters for a cursor paginated query that can be traversed in both directions. */
export type PaginationInputV2 = {
  /**
   * Cursor from which the query should start querying.
   * Normally would be set to the `endCursor` of the previous page or the cursor of the last item for the forward direction,
   * or to the `startCursor` of the next page or the cursor of the first item for the backward direction.
   * If not provided, the query starts from the beginning or end depending on the direction.
   */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Direction of the query: forward to get the next page, backward to get the previous page. */
  direction?: InputMaybe<PaginationDirection | '%future added value'>;
  /** Maximum number of items to return in the page. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ParsedOrder = {
  __typename?: 'ParsedOrder';
  PONumber?: Maybe<Scalars['String']['output']>;
  chatMatchedBy?: Maybe<ChatMatchedBy | '%future added value'>;
  comment?: Maybe<Scalars['String']['output']>;
  customerEmailAddress?: Maybe<Scalars['String']['output']>;
  customerNumber?: Maybe<Scalars['String']['output']>;
  customerPhoneNo?: Maybe<Scalars['String']['output']>;
  customerRepresentative?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use deliveryDateLocal */
  deliveryDate?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** Delivery date as a local calendar date; supersedes the AWSTimestamp `deliveryDate`. */
  deliveryDateLocal?: Maybe<Scalars['AWSDate']['output']>;
  /** @deprecated Moved to OmnichannelOrderProduct */
  extractedAmount?: Maybe<Scalars['Float']['output']>;
  isCustomerCorrect?: Maybe<Scalars['Boolean']['output']>;
  isDeliveryDateCorrect?: Maybe<Scalars['Boolean']['output']>;
  isPONumberCorrect?: Maybe<Scalars['Boolean']['output']>;
  matchedChatId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use products */
  matchedProducts: Array<OmnichannelProduct>;
  nearestAvailableDeliveryDate?: Maybe<Scalars['String']['output']>;
  orderReviewReason: Array<ReviewReason | '%future added value'>;
  productCount?: Maybe<Scalars['Int']['output']>;
  products: Array<OmnichannelOrderProduct>;
  requestedDeliveryDate?: Maybe<Scalars['String']['output']>;
  restaurantAddress?: Maybe<Scalars['String']['output']>;
  restaurantName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use products */
  unmatchedProducts: Array<OmnichannelProduct>;
};

export type PartialLegalContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentCustomerContact = {
  __typename?: 'PaymentCustomerContact';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  role: PaymentCustomerContactRole | '%future added value';
};

export type PaymentCustomerContactInput = {
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role: PaymentCustomerContactRole | '%future added value';
};

export const PaymentCustomerContactRole = {
  Additional: 'ADDITIONAL',
  Main: 'MAIN'
} as const;

export type PaymentCustomerContactRole = typeof PaymentCustomerContactRole[keyof typeof PaymentCustomerContactRole];
export type PaymentCustomerContactsUpdateFailure = {
  __typename?: 'PaymentCustomerContactsUpdateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type PaymentCustomerContactsUpdateInput = {
  contacts: Array<PaymentCustomerContactInput>;
  paymentCustomerId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

export type PaymentCustomerContactsUpdateResponse = AuthorizationFailure | InputValidationFailure | PaymentCustomerContactsUpdateFailure | PaymentCustomerContactsUpdateSuccess | PaymentCustomerNotFound;

export type PaymentCustomerContactsUpdateSuccess = {
  __typename?: 'PaymentCustomerContactsUpdateSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type PaymentCustomerCredit = {
  __typename?: 'PaymentCustomerCredit';
  availableBalance: MoneyV2;
  limit: MoneyV2;
};

export type PaymentCustomerDetailsInput = {
  buyerId: Scalars['ID']['input'];
  contacts: Array<PaymentCustomerContactInput>;
  name: Scalars['String']['input'];
  shippingAddress: ShippingAddressInput;
};

export type PaymentCustomerDirectPayFailure = {
  __typename?: 'PaymentCustomerDirectPayFailure';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type PaymentCustomerDirectPayInput = {
  buyerId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

export type PaymentCustomerDirectPayResponse = AuthorizationFailure | InputValidationFailure | PaymentCustomerDirectPayFailure | PaymentCustomerDirectPaySuccess | PaymentCustomerNotFound;

export type PaymentCustomerDirectPaySuccess = {
  __typename?: 'PaymentCustomerDirectPaySuccess';
  customer: DirectPayPaymentCustomer;
  responseType: ResponseType | '%future added value';
};

export type PaymentCustomerNotFound = {
  __typename?: 'PaymentCustomerNotFound';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type PaymentCustomerProfiles = {
  __typename?: 'PaymentCustomerProfiles';
  instantPayment?: Maybe<InstantPaymentCustomerProfile>;
};

export type PaymentCustomerResultEdge = {
  __typename?: 'PaymentCustomerResultEdge';
  cursor: Scalars['String']['output'];
  node: PaymentCustomerResultNode;
};

export type PaymentCustomerResultNode = {
  __typename?: 'PaymentCustomerResultNode';
  buyerId?: Maybe<Scalars['ID']['output']>;
  credit?: Maybe<PaymentCustomerCredit>;
  id: Scalars['ID']['output'];
  legalEntity?: Maybe<PaymentLegalEntity>;
  name: Scalars['String']['output'];
  profiles: PaymentCustomerProfiles;
  shippingAddress?: Maybe<Scalars['String']['output']>;
  shippingAddressStructured?: Maybe<PaymentShippingAddress>;
};

export type PaymentCustomerSearchFilterInput = {
  externalLegalEntityId?: InputMaybe<Scalars['ID']['input']>;
  instantPaymentProfileStatus?: InputMaybe<Array<InstantPaymentProfileStatus | '%future added value'>>;
};

export type PaymentCustomerSearchInput = {
  filter?: InputMaybe<PaymentCustomerSearchFilterInput>;
  pagination?: InputMaybe<PaginationInputV2>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['String']['input'];
};

export type PaymentCustomerSearchResponse = AuthorizationFailure | InputValidationFailure | PaymentCustomerSearchSuccess;

export type PaymentCustomerSearchSuccess = {
  __typename?: 'PaymentCustomerSearchSuccess';
  edges: Array<PaymentCustomerResultEdge>;
  pageInfo: PageInfo;
  responseType: ResponseType | '%future added value';
  total: Scalars['Int']['output'];
};

export type PaymentCustomerUpdateAllForLegalEntityFailure = {
  __typename?: 'PaymentCustomerUpdateAllForLegalEntityFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type PaymentCustomerUpdateAllForLegalEntityInput = {
  legalEntityId: Scalars['ID']['input'];
  update: PaymentCustomerUpdateDetailsInput;
};

export type PaymentCustomerUpdateAllForLegalEntityResponse = AuthorizationFailure | InputValidationFailure | PaymentCustomerUpdateAllForLegalEntityFailure | PaymentCustomerUpdateAllForLegalEntitySuccess;

export type PaymentCustomerUpdateAllForLegalEntitySuccess = {
  __typename?: 'PaymentCustomerUpdateAllForLegalEntitySuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type PaymentCustomerUpdateDetailsInput = {
  contacts: Array<PaymentCustomerContactInput>;
};

export const PaymentFeature = {
  BuyerPaymentsPortal: 'BuyerPaymentsPortal',
  BuyerWholesailPage: 'BuyerWholesailPage'
} as const;

export type PaymentFeature = typeof PaymentFeature[keyof typeof PaymentFeature];
export type PaymentLegalAddress = {
  __typename?: 'PaymentLegalAddress';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
};

export type PaymentLegalContact = {
  __typename?: 'PaymentLegalContact';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

export type PaymentLegalEntity = {
  __typename?: 'PaymentLegalEntity';
  address: PaymentLegalAddress;
  contact: PaymentLegalContact;
  id: Scalars['ID']['output'];
};

export type PaymentLegalEntityUpdateDetailsInput = {
  contact?: InputMaybe<PartialLegalContactInput>;
};

export type PaymentLegalEntityUpdateFailure = {
  __typename?: 'PaymentLegalEntityUpdateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type PaymentLegalEntityUpdateInput = {
  /** On behalf of which buyer this update is taking place */
  buyerId: Scalars['ID']['input'];
  /** The legal entity id */
  id: Scalars['ID']['input'];
  options?: InputMaybe<PaymentLegalEntityUpdateOptionsInput>;
  update: PaymentLegalEntityUpdateDetailsInput;
  vendorId: Scalars['ID']['input'];
};

export type PaymentLegalEntityUpdateOptionsInput = {
  sendInvitationEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentLegalEntityUpdateResponse = AuthorizationFailure | InputValidationFailure | PaymentLegalEntityUpdateFailure | PaymentLegalEntityUpdateSuccess;

export type PaymentLegalEntityUpdateSuccess = {
  __typename?: 'PaymentLegalEntityUpdateSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type PaymentLinkGenerateFailure = {
  __typename?: 'PaymentLinkGenerateFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type PaymentLinkGenerateInput = {
  billingDocumentId: Scalars['ID']['input'];
};

export type PaymentLinkGenerateResponse = AuthorizationFailure | InputValidationFailure | PaymentLinkGenerateFailure | PaymentLinkGenerateSuccess;

export type PaymentLinkGenerateSuccess = {
  __typename?: 'PaymentLinkGenerateSuccess';
  paymentUrl: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type PaymentMethod = CardPaymentMethod | PendingPaymentMethod;

export type PaymentMethodRequestConflictFailure = {
  __typename?: 'PaymentMethodRequestConflictFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type PaymentMethodRequestFailure = {
  __typename?: 'PaymentMethodRequestFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type PaymentMethodRequestInput = {
  buyerId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

export type PaymentMethodRequestResendConflict = {
  __typename?: 'PaymentMethodRequestResendConflict';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type PaymentMethodRequestResendFailure = {
  __typename?: 'PaymentMethodRequestResendFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type PaymentMethodRequestResendInput = {
  paymentMethodId: Scalars['ID']['input'];
  paymentProfileId: Scalars['ID']['input'];
};

export type PaymentMethodRequestResendResponse = AuthorizationFailure | InputValidationFailure | PaymentMethodRequestResendConflict | PaymentMethodRequestResendFailure | PaymentMethodRequestResendSuccess;

export type PaymentMethodRequestResendSuccess = {
  __typename?: 'PaymentMethodRequestResendSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type PaymentMethodRequestResponse = AuthorizationFailure | InputValidationFailure | PaymentMethodRequestConflictFailure | PaymentMethodRequestFailure | PaymentMethodRequestSuccess;

export type PaymentMethodRequestSuccess = {
  __typename?: 'PaymentMethodRequestSuccess';
  paymentMethodId: Scalars['ID']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export const PaymentMethodStatus = {
  Accepted: 'ACCEPTED'
} as const;

export type PaymentMethodStatus = typeof PaymentMethodStatus[keyof typeof PaymentMethodStatus];
export type PaymentShippingAddress = {
  __typename?: 'PaymentShippingAddress';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  organizationName: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
};

export type PaymentVendor = {
  __typename?: 'PaymentVendor';
  id: Scalars['ID']['output'];
  instantPayVendorConfig?: Maybe<InstantPayVendorConfig>;
  vendorId: Scalars['ID']['output'];
};

export type PaymentVendorInput = {
  vendorId: Scalars['ID']['input'];
};

export type PaymentVendorNotFound = {
  __typename?: 'PaymentVendorNotFound';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type PaymentVendorResponse = AuthorizationFailure | InputValidationFailure | PaymentVendorNotFound | PaymentVendorSuccess;

export type PaymentVendorSuccess = {
  __typename?: 'PaymentVendorSuccess';
  paymentVendor: PaymentVendor;
};

export type PaymentsConfigSuccess = {
  __typename?: 'PaymentsConfigSuccess';
  enabledFeatures: Array<PaymentFeature | '%future added value'>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type PaymentsFeaturesConfigResponse = AuthorizationFailure | InputValidationFailure | PaymentsFeaturesConfigSuccess;

export type PaymentsFeaturesConfigSuccess = {
  __typename?: 'PaymentsFeaturesConfigSuccess';
  enabledFeatures: Array<PaymentFeature | '%future added value'>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type PdfAttachmentRef = {
  __typename?: 'PdfAttachmentRef';
  omnichannelOrderId: Scalars['ID']['output'];
  pageRange: PageRange;
  transmissionAttachmentId?: Maybe<Scalars['ID']['output']>;
  transmissionId?: Maybe<Scalars['ID']['output']>;
};

export type PendingOrdersFilterInput = {
  customerId?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerNotMatched?: InputMaybe<Scalars['Boolean']['input']>;
  forwardedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  originalSender?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierOrderChannel?: InputMaybe<Array<SupplierOrderChannel | '%future added value'>>;
};

export type PendingOrdersInput = {
  fetchParsedProductInfo?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PendingOrdersFilterInput>;
  pagination?: InputMaybe<PaginationInputV2>;
  sortBy?: InputMaybe<PendingOrdersSortFields | '%future added value'>;
  /** @deprecated Use sortBy instead. */
  sortByDeliveryDate?: InputMaybe<Scalars['Boolean']['input']>;
  sortDirection?: InputMaybe<SortDirection | '%future added value'>;
  supplierEntityId: Scalars['ID']['input'];
};

export const PendingOrdersSortFields = {
  CreatedAt: 'createdAt',
  DeliveryDate: 'deliveryDate'
} as const;

export type PendingOrdersSortFields = typeof PendingOrdersSortFields[keyof typeof PendingOrdersSortFields];
/**
 * This represents the case before we receive the approval from the buyer.
 * This means we have not yet received the token via a webhook.
 * We don't yet know which type of method it will be so we cannot include any other information.
 */
export type PendingPaymentMethod = {
  __typename?: 'PendingPaymentMethod';
  id: Scalars['ID']['output'];
};

export type PendingUserInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/**
 * A value expressed either as a percentage or a fixed money amount.
 * Exactly one variant applies, resolved via `__typename`.
 */
export type PercentageOrFixedAmount = FixedAmountValue | PercentageValue;

export type PercentageTaxRate = {
  __typename?: 'PercentageTaxRate';
  /** The rate as a percentage, e.g. 20.0 for 20%. */
  percentage: Decimal;
};

export type PercentageValue = {
  __typename?: 'PercentageValue';
  /** The value as a percentage, e.g. '20.0000' for 20%. */
  percentage: Decimal;
};

export const PhoneNumberLineType = {
  LandLine: 'landLine',
  Mobile: 'mobile',
  Unsupported: 'unsupported',
  Voip: 'voip'
} as const;

export type PhoneNumberLineType = typeof PhoneNumberLineType[keyof typeof PhoneNumberLineType];
export type PhoneNumberLookup = PhoneNumberLookupError | PhoneNumberLookupSuccess;

export type PhoneNumberLookupError = {
  __typename?: 'PhoneNumberLookupError';
  errorCode: PhoneNumberLookupErrorCode | '%future added value';
  message: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export const PhoneNumberLookupErrorCode = {
  GenericError: 'genericError',
  InvalidPhoneNumber: 'invalidPhoneNumber'
} as const;

export type PhoneNumberLookupErrorCode = typeof PhoneNumberLookupErrorCode[keyof typeof PhoneNumberLookupErrorCode];
export type PhoneNumberLookupSuccess = {
  __typename?: 'PhoneNumberLookupSuccess';
  lineType: PhoneNumberLineType | '%future added value';
  phoneNumber: Scalars['String']['output'];
};

/** Distributor Notes related types */
export type PlainTextBody = {
  __typename?: 'PlainTextBody';
  text: Scalars['String']['output'];
};

export const Platform = {
  Mobile: 'Mobile',
  Web: 'Web'
} as const;

export type Platform = typeof Platform[keyof typeof Platform];
export const PredefinedBroadcastPurpose = {
  Custom: 'custom',
  ExpiringProducts: 'expiringProducts',
  OfferDiscounts: 'offerDiscounts',
  PromoteProducts: 'promoteProducts',
  StockClearance: 'stockClearance'
} as const;

export type PredefinedBroadcastPurpose = typeof PredefinedBroadcastPurpose[keyof typeof PredefinedBroadcastPurpose];
/** Input type for preparing to save the email editor state. */
export type PrepareSaveEmailEditorStateInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Email editor state file details */
  emailEditorState: EmailEditorStateFileInput;
};

/** Response type for preparing to save the email editor state. */
export type PrepareSaveEmailEditorStateResponse = AuthorizationFailure | InputValidationFailure | PrepareSaveEmailEditorStateResult;

/** Success result containing the upload URL and S3 key for saving the email editor state. */
export type PrepareSaveEmailEditorStateResult = AppsyncResponse & {
  __typename?: 'PrepareSaveEmailEditorStateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** The pre-signed upload URL for the email editor state. */
  uploadUrl: Scalars['String']['output'];
  /** The S3 URI for the email editor state. */
  uri: Scalars['String']['output'];
};

/** Represents the price level of an prospect. */
export const PriceLevel = {
  Expensive: 'Expensive',
  Free: 'Free',
  Inexpensive: 'Inexpensive',
  Moderate: 'Moderate',
  Unspecified: 'Unspecified',
  VeryExpensive: 'VeryExpensive'
} as const;

export type PriceLevel = typeof PriceLevel[keyof typeof PriceLevel];
export const PriceSemantics = {
  /** Unit prices are inclusive of tax (gross). */
  Gross: 'GROSS',
  /** Unit prices are exclusive of tax (net). */
  Net: 'NET'
} as const;

export type PriceSemantics = typeof PriceSemantics[keyof typeof PriceSemantics];
export type PriceSetting = {
  __typename?: 'PriceSetting';
  /** displays price of catalog products to potential buyer(s) on the Marketplace */
  displayInMarketplace: Scalars['Boolean']['output'];
  /** displays price of catalog products to buyer(s) in same chat with supplier */
  displayToCustomers: Scalars['Boolean']['output'];
};

export type PriceSettingInput = {
  displayInMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  displayToCustomers?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Which date drives ordering-stage price/promotion/tax evaluation. Unset is treated as ORDER_DATE. */
export const PricingDateSource = {
  DeliveryDate: 'DELIVERY_DATE',
  OrderDate: 'ORDER_DATE'
} as const;

export type PricingDateSource = typeof PricingDateSource[keyof typeof PricingDateSource];
export type ProcessingTransmissionFilter = {
  forwardedBy?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Product = Node & {
  __typename?: 'Product';
  /** price either for chat or catalog depending on the context it is returned */
  appliedCatalogPrice?: Maybe<Scalars['Int']['output']>;
  basePrice?: Maybe<Scalars['Int']['output']>;
  baseUnit?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  /** @deprecated Does not work anymore. Use `VendorItemUnit.price` or `VendorItemUnit.displayProperties` or `VendorItemUnit.buyerProperties` instead */
  buyerInventoryProduct?: Maybe<BuyerInventoryProduct>;
  category?: Maybe<ProductCategory>;
  /**
   * Retrieves chat product features based on:
   * 1. Provided chatId.
   * 2. If not provided, uses context.source._chatId.
   * Returns null if no chatId is found.
   */
  chatProductFeatures?: Maybe<ChatProductFeatures>;
  conversionFactor?: Maybe<Scalars['Float']['output']>;
  /**
   * Price in ¢
   *
   * have in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = 135
   *    currency = 'USD'
   *
   * 1.35 € ->
   *    cost = 135
   *    currency = 'EUR'
   *
   * 1.3 CLF ->
   *    cost = 1300
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = 135
   *    currency = 'GNF'
   */
  cost?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: Maybe<Scalars['String']['output']>;
  /** Place order for product on or before cutOffTime to ensure next day delivery */
  cutOffTime?: Maybe<Scalars['AWSTime']['output']>;
  /**
   * Shows the earliest delivery date of a product and whether the clients should display it.
   * Can be calculate as 'earliestDeliveryDate = today + leadTime'
   * I.e. if today is the 2023-01-01 and leadTime is 2 days, then the
   * earliestDeliveryDate would be 2023-01-03.
   * If a product can not be delivered at the first available delivery date,
   * according to a supplier's delivery settings, 'showEarliestDeliveryDate' will be true.
   */
  deliveryDateConditions?: Maybe<ProductDeliveryDateCondition>;
  /** @deprecated Not returned anymore. Use `VendorItemUnit.price` instead */
  derivedPriceForOrderGuide?: Maybe<DerivedPriceForOrderGuideResponse>;
  /** An optional description of the product */
  description?: Maybe<Scalars['String']['output']>;
  /** discounted price for catalog product */
  discountedPrice?: Maybe<Scalars['Int']['output']>;
  /** resolved in getProductsForChat */
  discountedPriceVersionTimestamp?: Maybe<Scalars['AWSTimestamp']['output']>;
  /**
   * Returns the URL to view the main Product image.
   * For the Supplier user, also returns the URL to upload a new Product image.
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Use `VendorItemUnit.images` or `vendorItemUnitsImagesUpload` instead
   */
  displayImage?: Maybe<ProductImage>;
  ean?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  hasVariantsInCatalog?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['AWSURL']['output']>;
  inProductList?: Maybe<Scalars['Boolean']['output']>;
  invoiceUnit?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not returned anymore. Use `VendorItemUnit.isInOrderGuide` instead */
  isSelectedInOrderGuide?: Maybe<IsSelectedInOrderGuideResponse>;
  /**
   * The number of days required for a supplier to first order a product
   * from a manufacturer before it can become available for order fulfilment
   */
  leadTime?: Maybe<Scalars['Int']['output']>;
  /** Price of item in catalog and not price that buyer will pay */
  listPrice?: Maybe<Scalars['Float']['output']>;
  minimumFractionalAmount?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** resolved in getProductsForChat */
  negotiatedPriceVersionTimestamp?: Maybe<Scalars['AWSTimestamp']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  packSize?: Maybe<Scalars['String']['output']>;
  par?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  primaryCatalogCategory?: Maybe<Scalars['String']['output']>;
  subCatalogs?: Maybe<Array<Scalars['String']['output']>>;
  subCategory?: Maybe<Scalars['String']['output']>;
  /**
   * Adding supplier here as we need to obtain supplier details of each catalog product
   * This is meant to be used only Marketplace for now.
   */
  supplier?: Maybe<Supplier>;
  supplierId?: Maybe<Scalars['ID']['output']>;
  /**
   * Returns the value of the Customer-Specific Price for a given Buyer.
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Use `VendorItemUnit.price` instead
   */
  supplierNegotiatedPrice?: Maybe<SupplierNegotiatedPrice>;
  unit?: Maybe<Scalars['String']['output']>;
  upc?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  uploadID?: Maybe<Scalars['String']['output']>;
  variantTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** resolved in getProductsForChat */
  variantsInCatalog?: Maybe<Array<Product>>;
  variantsInProductList?: Maybe<Array<Product>>;
  /** Bridge from the old catalog Product type to the new VendorItemUnit type. */
  vendorItemUnit?: Maybe<VendorItemUnit>;
  /** Timestamps to verify product version for order creation */
  versionTimestamp?: Maybe<Scalars['AWSTimestamp']['output']>;
};


export type ProductBuyerInventoryProductArgs = {
  chatId: Scalars['ID']['input'];
};


export type ProductChatProductFeaturesArgs = {
  chatId?: InputMaybe<Scalars['String']['input']>;
};


export type ProductDeliveryDateConditionsArgs = {
  chatId: Scalars['ID']['input'];
};


export type ProductDerivedPriceForOrderGuideArgs = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
};


export type ProductIsSelectedInOrderGuideArgs = {
  chatId: Scalars['ID']['input'];
};


export type ProductSupplierNegotiatedPriceArgs = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductBuyerCommentsNotAllowedError = AppsyncError & AppsyncResponse & {
  __typename?: 'ProductBuyerCommentsNotAllowedError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** IDs of the products that have buyer comments */
  productIds: Array<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type ProductCategory = Node & {
  __typename?: 'ProductCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductConnection = Connection & {
  __typename?: 'ProductConnection';
  edges: Array<ProductEdge>;
};

export const ProductDeliveryConstraintCode = {
  /** Product lead time does not allow the selected delivery date. */
  LeadTime: 'LEAD_TIME',
  /**
   * Product-level cutoff already passed for this line.
   * Distinct from order-level ORDER_CUTOFF.
   */
  ProductCutoff: 'PRODUCT_CUTOFF'
} as const;

export type ProductDeliveryConstraintCode = typeof ProductDeliveryConstraintCode[keyof typeof ProductDeliveryConstraintCode];
/**
 * Cart-line delivery constraints vs selected delivery date.
 * Distinct from order-level DeliveryDateValidationResult.
 */
export type ProductDeliveryConstraintValidationResult = CartValidationResult & {
  __typename?: 'ProductDeliveryConstraintValidationResult';
  /** Which product-level delivery constraint failed. */
  code: ProductDeliveryConstraintCode | '%future added value';
  /**
   * Earliest date this product can be delivered, honouring its lead time and
   * cutoff.
   */
  earliestAvailableDate?: Maybe<Scalars['AWSDate']['output']>;
  /**
   * Product lead time in days that was not met.
   * Null when code is PRODUCT_CUTOFF.
   */
  leadTimeDays?: Maybe<Scalars['Int']['output']>;
  overriddenBy?: Maybe<Scalars['String']['output']>;
  overrideable: Scalars['Boolean']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  /**
   * Product-level cutoff time that was missed.
   * Null when code is LEAD_TIME.
   */
  productCutoffTime?: Maybe<Scalars['AWSTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  /**
   * Selected delivery date that failed the product lead-time check.
   * Null when code is PRODUCT_CUTOFF.
   */
  requestedDate?: Maybe<Scalars['AWSDate']['output']>;
  source: ValidationSource | '%future added value';
  status: ValidationStatus | '%future added value';
  /** Sellable unit on the failing cart line (join key). */
  vendorItemUnitId: Scalars['ID']['output'];
};

export type ProductDeliveryDateCondition = {
  __typename?: 'ProductDeliveryDateCondition';
  /** earliestDeliveryDate is sent in the timezone of the supplier */
  earliestDeliveryDate?: Maybe<Scalars['AWSDate']['output']>;
  showEarliestDeliveryDate: Scalars['Boolean']['output'];
};

export type ProductEdge = Edge & {
  __typename?: 'ProductEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type ProductFallback = {
  __typename?: 'ProductFallback';
  name?: Maybe<Scalars['String']['output']>;
  productId: Scalars['ID']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};

export type ProductFilter = {
  catalogCategory?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  subCatalogs?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductGrowthRate = {
  __typename?: 'ProductGrowthRate';
  growthRate: Scalars['String']['output'];
  orderAmountsHistory: Array<Maybe<Scalars['Int']['output']>>;
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
};

export type ProductImage = {
  __typename?: 'ProductImage';
  /** url of 900x900 pixel crop of product image */
  largeSquare?: Maybe<Scalars['String']['output']>;
  /** url of 600x600 pixel crop of product image */
  mediumSquare?: Maybe<Scalars['String']['output']>;
  /** url of 300x300 pixel crop of product image */
  smallSquare?: Maybe<Scalars['String']['output']>;
  /** url to put new product image file to */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** url of originally uploaded product image */
  url?: Maybe<Scalars['String']['output']>;
};

export type ProductInput = {
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  baseUnit?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<CategoryInput>;
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Price in ¢
   *
   * have in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = 135
   *    currency = 'USD'
   *
   * 1.35 € ->
   *    cost = 135
   *    currency = 'EUR'
   *
   * 1.3 CLF ->
   *    cost = 1300
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = 135
   *    currency = 'GNF'
   */
  cost?: InputMaybe<Scalars['Int']['input']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: InputMaybe<Scalars['String']['input']>;
  cutOffTime?: InputMaybe<Scalars['AWSTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with UPC */
  ean?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** url to download product image */
  imageUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  invoiceUnit?: InputMaybe<Scalars['String']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  listPrice?: InputMaybe<Scalars['Float']['input']>;
  minimumFractionalAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** Country code in ISO alpha2Code e.g. DE for Germany */
  origin?: InputMaybe<Scalars['String']['input']>;
  packSize?: InputMaybe<Scalars['String']['input']>;
  par?: InputMaybe<Scalars['String']['input']>;
  /** ExternalId of parent product */
  parentId?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  primaryCatalogCategory?: InputMaybe<Scalars['String']['input']>;
  subCatalogs?: InputMaybe<Array<Scalars['ID']['input']>>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with EAN */
  upc?: InputMaybe<Scalars['String']['input']>;
  /** Product variants provided like variant1;variant2;variant3 */
  variantTypes?: InputMaybe<Scalars['String']['input']>;
};

export type ProductLeadTimeError = AppsyncError & AppsyncResponse & {
  __typename?: 'ProductLeadTimeError';
  /** IDs of the products that cannot be delivered within the selected delivery date */
  invalidProductIds: Array<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type ProductLeadTimeFailure = {
  __typename?: 'ProductLeadTimeFailure';
  message: Scalars['String']['output'];
  productIds: Array<Scalars['String']['output']>;
};

export type ProductMatchCacheEntries = {
  __typename?: 'ProductMatchCacheEntries';
  entries: Array<ProductMatchCacheEntry>;
};

/**
 * Fields are combined with AND. At least one of `chatId`, `productId`,
 * `supplierProductId` or `omnichannelOrderId` is required.
 */
export type ProductMatchCacheEntriesFilter = {
  /** Chat (customer) the entry was learned for. */
  chatId?: InputMaybe<Scalars['ID']['input']>;
  isCorrectedLineItem?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order whose acceptance last wrote the entry. */
  omnichannelOrderId?: InputMaybe<Scalars['ID']['input']>;
  /** Case-insensitive substring of the entry key (`name#unit#packSize`). Requires `chatId`. */
  productDataContains?: InputMaybe<Scalars['String']['input']>;
  /** Product the entry resolves to. */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** Supplier product code of the product the entry resolves to. */
  supplierProductId?: InputMaybe<Scalars['String']['input']>;
};

export type ProductMatchCacheEntriesInput = {
  filter: ProductMatchCacheEntriesFilter;
  /** Maximum number of entries to return. Defaults to 20, capped at 100. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  supplierId: Scalars['ID']['input'];
};

export type ProductMatchCacheEntriesRemoveInput = {
  /** Ids of the entries to remove, 1 to 100. */
  ids: Array<Scalars['ID']['input']>;
};

export type ProductMatchCacheEntriesRemoveResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | ProductMatchCacheEntriesRemoved;

export type ProductMatchCacheEntriesRemoved = {
  __typename?: 'ProductMatchCacheEntriesRemoved';
  /** Requested ids that matched no entry. */
  notFoundIds: Array<Scalars['ID']['output']>;
  /** The removed entries as they were before removal. */
  removed: Array<ProductMatchCacheEntry>;
};

export type ProductMatchCacheEntriesResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | ProductMatchCacheEntries;

export type ProductMatchCacheEntry = {
  __typename?: 'ProductMatchCacheEntry';
  /** Chat (customer) the entry was learned for. */
  chat: ChatRef;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  /** Whether the entry was last written from a reviewer correction. */
  isCorrectedLineItem: Scalars['Boolean']['output'];
  lastUsedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lineItemId?: Maybe<Scalars['ID']['output']>;
  /** Learned factor applied to the extracted quantity. Null when none is learned. */
  linearCoefficient?: Maybe<Scalars['Float']['output']>;
  /** Order whose acceptance last wrote the entry. */
  omnichannelOrderId?: Maybe<Scalars['ID']['output']>;
  /** Normalized extracted product the entry is keyed on: `name#unit#packSize`. */
  productData: Scalars['String']['output'];
  /** Product the key resolves to. */
  productId: Scalars['ID']['output'];
  supplierId: Scalars['ID']['output'];
  /** Supplier product code of the product the key resolves to, when known. */
  supplierProductId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ProductMatchCacheEntryCoefficientClearInput = {
  id: Scalars['ID']['input'];
};

export type ProductMatchCacheEntryCoefficientClearResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | ProductMatchCacheEntryCoefficientCleared;

export type ProductMatchCacheEntryCoefficientCleared = {
  __typename?: 'ProductMatchCacheEntryCoefficientCleared';
  /** The entry after its coefficient was cleared. */
  entry: ProductMatchCacheEntry;
};

export const ProductMatchedBy = {
  Cache: 'cache',
  CacheV2: 'cacheV2',
  ExternalId: 'externalId',
  Name: 'name',
  Search: 'search'
} as const;

export type ProductMatchedBy = typeof ProductMatchedBy[keyof typeof ProductMatchedBy];
export type ProductMatchingConfidence = {
  __typename?: 'ProductMatchingConfidence';
  isProductAmountCorrect?: Maybe<Scalars['Boolean']['output']>;
  isProductCorrect?: Maybe<Scalars['Boolean']['output']>;
  productId: Scalars['ID']['output'];
};

export type ProductNotFoundError = AppsyncError & AppsyncResponse & {
  __typename?: 'ProductNotFoundError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type ProductPriceEditInfo = {
  __typename?: 'ProductPriceEditInfo';
  acceptedProductPrice: Scalars['Int']['output'];
  productId: Scalars['String']['output'];
};

export type ProductRef = {
  __typename?: 'ProductRef';
  id: Scalars['ID']['output'];
  /** @deprecated This endpoint is in the maintenance mode. It works, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this field. */
  node?: Maybe<Product>;
};

/** Why the Order Agent matcher dropped a line's local match. */
export const ProductReplacementReason = {
  /** The catalog could not resolve the matched product id. */
  NotFound: 'notFound',
  /** The product exists but is not in this customer's catalog. */
  NotInCustomerCatalog: 'notInCustomerCatalog',
  /** Out of stock; replaced only when automatic replacement is enabled. */
  OutOfStock: 'outOfStock'
} as const;

export type ProductReplacementReason = typeof ProductReplacementReason[keyof typeof ProductReplacementReason];
export type ProductSearchResult = {
  __typename?: 'ProductSearchResult';
  /** @deprecated Not returned anymore */
  hits: Array<Product>;
  total: Scalars['Int']['output'];
};

export type ProductsCategoryInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productIds: Array<Scalars['ID']['input']>;
};

export type ProductsUnavailableFailure = {
  __typename?: 'ProductsUnavailableFailure';
  message: Scalars['String']['output'];
  productIds: Array<Scalars['String']['output']>;
};

export type ProfileImage = {
  __typename?: 'ProfileImage';
  /** url of 1125 x 600 crop of cover photo, this is only valid for supplier coverPhoto */
  largeRectangle?: Maybe<Scalars['String']['output']>;
  /** url of 900x900 pixel crop of profile image */
  largeSquare?: Maybe<Scalars['String']['output']>;
  /** url of 180x180 pixel crop of profile image */
  largeThumbnail?: Maybe<Scalars['String']['output']>;
  /** url of 750 x 400 crop of cover photo, this is only valid for supplier coverPhoto */
  mediumRectangle?: Maybe<Scalars['String']['output']>;
  /** url of 600x600 pixel crop of profile image */
  mediumSquare?: Maybe<Scalars['String']['output']>;
  /** url of 120x120 pixel crop of profile image */
  mediumThumbnail?: Maybe<Scalars['String']['output']>;
  /** url of 375 x 200 crop of cover photo, this is only valid for supplier coverPhoto */
  smallRectangle?: Maybe<Scalars['String']['output']>;
  /** url of 300x300 pixel crop of profile image */
  smallSquare?: Maybe<Scalars['String']['output']>;
  /** url of 60x60 pixel crop of profile image */
  smallThumbnail?: Maybe<Scalars['String']['output']>;
  /** url to put new profile image file to */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  /** url of originally uploaded profile image */
  url?: Maybe<Scalars['String']['output']>;
};

export type PromoPageContent = {
  __typename?: 'PromoPageContent';
  promoPageBannerImageUrl: Scalars['String']['output'];
  promoPageDescription: Scalars['String']['output'];
  promoPageTitle: Scalars['String']['output'];
};

export type PromotedVendorItemUnitVariant = {
  __typename?: 'PromotedVendorItemUnitVariant';
  /** ID of the chat context */
  chatId: Scalars['ID']['output'];
  /** ID of the supplier */
  supplierId: Scalars['ID']['output'];
  /** The specific ID of this product variant from this supplier in this chat */
  vendorItemUnitId: Scalars['ID']['output'];
};

/**
 * Buyer claim for one claimable choosable promotion (cart-scoped).
 * Only for CART_FREE_EXTRA_UNITS. Promotions re-checks that the promotion is
 * unlocked and validates the selected products and quantities against the
 * available free grant.
 */
export type PromotionChoiceInput = {
  /** Promotion definition id the choice applies to. */
  promotionId: Scalars['ID']['input'];
  /**
   * Buyer-requested allocation of the unlocked free grant across offered
   * products. Non-empty for CHOSEN; empty for DECLINED / NOT_PRESENTED.
   */
  selections?: Array<PromotionChoiceSelectionInput>;
  /**
   * Contributor vendorItemUnitIds for this claimable reward. Echo
   * claimableRewards.sourceVendorItemUnitIds. Not gift product ids (those are
   * selections).
   */
  sourceVendorItemUnitIds: Array<Scalars['ID']['input']>;
  /** Whether the buyer chose, explicitly declined, or did not present a choice. */
  state: PromotionChoiceState | '%future added value';
};

export type PromotionChoiceSelectionInput = {
  /**
   * Requested free quantity for this product. Must be positive. Promotions
   * validates the aggregate request against the current entitlement.
   */
  quantity: DecimalInput;
  /** Offered free product selected by the buyer. */
  vendorItemUnitId: Scalars['ID']['input'];
};

export const PromotionChoiceState = {
  /** Buyer claimed the unlocked reward. Requires one or more selections. */
  Chosen: 'CHOSEN',
  /**
   * Explicit decline CTA. Distinct from omitting the choice or NOT_PRESENTED.
   * Only set when the client has an explicit decline action. No gift; non-blocking.
   */
  Declined: 'DECLINED',
  /**
   * Choice closed / continue without choosing, or no choice recorded.
   * No gift; non-blocking. Default when cart promotionChoices omit the promotion.
   */
  NotPresented: 'NOT_PRESENTED'
} as const;

export type PromotionChoiceState = typeof PromotionChoiceState[keyof typeof PromotionChoiceState];
export const PromotionGiftValidationCode = {
  /**
   * CHOSEN free grant cannot be applied as requested: the applied free product
   * or quantity differs from the requested allocation. Display only: does not
   * block commit.
   */
  FreeLineChanged: 'FREE_LINE_CHANGED',
  /**
   * CHOSEN gift is no longer grantable (inactive, expired, or not entitled).
   * Display only: does not block commit (no gift applied).
   */
  PromotionExpired: 'PROMOTION_EXPIRED',
  /**
   * Promotions rejected the submitted reward choice: stale, invalid, or
   * selecting a product that is no longer offered. A WARNING on cart
   * evaluation; blocks checkout commit until the choice is corrected or removed.
   */
  RewardChoiceInvalid: 'REWARD_CHOICE_INVALID'
} as const;

export type PromotionGiftValidationCode = typeof PromotionGiftValidationCode[keyof typeof PromotionGiftValidationCode];
export type PromotionGiftValidationResult = CartValidationResult & {
  __typename?: 'PromotionGiftValidationResult';
  /** Soft-fail reason for a claimable gift choice. */
  code: PromotionGiftValidationCode | '%future added value';
  overriddenBy?: Maybe<Scalars['String']['output']>;
  overrideable: Scalars['Boolean']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  /**
   * Which promotion this soft-fail is about (join/claim key via promotion.id).
   * Needed when multiple choices exist, or when PROMOTION_EXPIRED leaves no
   * freeQuantity on any EvaluatedLine.
   */
  promotion: VendorPromotionRef;
  reason?: Maybe<Scalars['String']['output']>;
  source: ValidationSource | '%future added value';
  status: ValidationStatus | '%future added value';
  /** Optional when the soft-fail is product-scoped (FREE_LINE_CHANGED). */
  vendorItemUnitId?: Maybe<Scalars['ID']['output']>;
};

export type PromotionMilestone = {
  __typename?: 'PromotionMilestone';
  state: PromotionMilestoneState | '%future added value';
  tierId: Scalars['ID']['output'];
};

export const PromotionMilestoneState = {
  NotReached: 'NOT_REACHED',
  Reached: 'REACHED'
} as const;

export type PromotionMilestoneState = typeof PromotionMilestoneState[keyof typeof PromotionMilestoneState];
/** Promotion progress for the current cart. */
export type PromotionProgress = {
  __typename?: 'PromotionProgress';
  /** Localized progress label. */
  label?: Maybe<Scalars['String']['output']>;
  /** Milestones in display order, or null when no ladder applies. */
  milestones?: Maybe<Array<PromotionMilestone>>;
  promotion: VendorPromotionRef;
  /** Localized short description. */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** Products contributing to the promotion. */
  sourceVendorItemUnitIds: Array<Scalars['ID']['output']>;
  state: PromotionProgressState | '%future added value';
};

export const PromotionProgressState = {
  InProgress: 'IN_PROGRESS',
  MaximumReached: 'MAXIMUM_REACHED'
} as const;

export type PromotionProgressState = typeof PromotionProgressState[keyof typeof PromotionProgressState];
export type PromotionsResult = {
  __typename?: 'PromotionsResult';
  /**
   * Diagnostics for UNAVAILABLE (timeouts, incomplete apply). Non-empty issues
   * with UNAVAILABLE mean non-committable.
   */
  issues: Array<CartEvaluationIssue>;
  /**
   * Domain completeness. UNAVAILABLE is fail-closed (non-committable).
   * Empty applicable offers with OK is success: not a dependency failure.
   */
  status: CartEvaluationDomainStatus | '%future added value';
  /**
   * single home for cart promotion surfaces; null when the domain did not
   * produce a value.
   */
  value?: Maybe<PromotionsValue>;
};

export type PromotionsValue = {
  __typename?: 'PromotionsValue';
  /**
   * Promotions that changed the cart, grouped by promotion.
   * Empty producer summaries and effects mean no promotion applied. If summaries
   * exist but effects are empty or incomplete, Promotions becomes UNAVAILABLE
   * with RESULT_INCOMPLETE. Checkout never reconstructs effects from legacy
   * appliedPromotions or freeLines and never returns only some effects.
   * Line-price adjustments identify each paid line whose price changed. A free
   * grant's vendorItemUnit is the free product, while sourceVendorItemUnitIds are
   * the paid products that earned it.
   */
  appliedPromotions: Array<AppliedPromotion>;
  /**
   * CART_FREE_EXTRA_UNITS claimable rewards. Cart-level because entitlement can
   * depend on multiple products. Each entry carries sourceVendorItemUnitIds for
   * item association. Preview-only; [] on checkoutCreate. Omit / NOT_PRESENTED is
   * equivalent to DECLINED (no gift, never blocks); CHOSEN is required to apply
   * free quantity.
   */
  claimableRewards: Array<ClaimableReward>;
  /** Promotion progress for cart evaluation; empty on checkoutCreate. */
  promotionProgress: Array<PromotionProgress>;
};

export type PunchoutConfiguration = {
  __typename?: 'PunchoutConfiguration';
  /** Chat ID - Reference to the Choco chat entity */
  chatId: Scalars['ID']['output'];
  /**
   * Credential ID - Reference to the authentication credential
   * Multiple configurations can share the same credential
   */
  credentialId: Scalars['ID']['output'];
  /** Customer Number - Optional DX location identifier */
  customerNumber?: Maybe<Scalars['String']['output']>;
  /** Destination URL where buyers are redirected */
  destinationUrl: Scalars['String']['output'];
  /** DX ID - Reference to the Choco supplier entity */
  dxId: Scalars['ID']['output'];
  /** Configuration ID */
  id: Scalars['ID']['output'];
  /** Whether this configuration is enabled */
  isEnabled: Scalars['Boolean']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['AWSTimestamp']['output'];
};

/**
 * Input for upserting a punchout configuration by chatId.
 * Uses chatId as natural key - creates if not exists, updates if exists.
 * This is idempotent - safe to run multiple times with same input.
 */
export type PunchoutConfigurationByChatUpsertInput = {
  /** Buyer ID - Reference to the Choco buyer entity */
  buyerId: Scalars['ID']['input'];
  /**
   * Chat ID - Natural key for upsert operation
   * If configuration exists for this chat, it will be updated
   * If not, a new configuration will be created
   */
  chatId: Scalars['ID']['input'];
  /**
   * Customer Number - Optional DX location identifier for scoped shopping
   * Examples: "GFS001", "GFS002", null (wildcard - any location)
   */
  customerNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * Destination URL - The e-commerce URL where buyers are redirected
   * Example: "https://gfs-ordering.choco.com"
   */
  destinationUrl: Scalars['String']['input'];
  /** DX ID - Reference to the Choco supplier (DX) entity */
  dxId: Scalars['ID']['input'];
  /**
   * Internal User Email - Email address of the internal user
   * This will be used as the sender identity in cXML credentials
   * Example: "user-uuid+punchou@choco.com"
   */
  internalUserEmail: Scalars['String']['input'];
  /**
   * Internal User ID - Cognito user ID for PunchOut authentication
   * Must be a valid pre-created Choco internal user
   */
  internalUserId: Scalars['ID']['input'];
  /**
   * Whether this configuration should be enabled
   * - true: Configuration is active and can be used
   * - false: Configuration is disabled (credential will be deleted for security)
   * Default: true
   */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Sender Domain - The domain of the e-procurement system
   * This is used for authentication of incoming cXML requests
   * Default: "birchstreet.com" (currently the only supported provider)
   */
  senderDomain?: InputMaybe<Scalars['String']['input']>;
};

export const PunchoutConfigurationOperationType = {
  /** New configuration and credential created */
  Created: 'created',
  /** Existing configuration updated */
  Updated: 'updated'
} as const;

export type PunchoutConfigurationOperationType = typeof PunchoutConfigurationOperationType[keyof typeof PunchoutConfigurationOperationType];
export type PunchoutConfigurationUpsertError = {
  __typename?: 'PunchoutConfigurationUpsertError';
  /** Buyer ID (for easier identification) */
  buyerId?: Maybe<Scalars['ID']['output']>;
  /** Chat ID (for easier identification) */
  chatId?: Maybe<Scalars['ID']['output']>;
  /**
   * Error message describing what went wrong
   * Examples:
   * - "Buyer ID abc-123 not found"
   * - "Chat ID def-789 not found"
   * - "Internal User ID xyz-456 not found"
   * - "Invalid destination URL format"
   * - "Credential with sender identity already exists"
   * - "Failed to generate shared secret"
   */
  error: Scalars['String']['output'];
  /** Index of the operation that caused the error */
  index: Scalars['Int']['output'];
};

export type PunchoutConfigurationUpserted = {
  __typename?: 'PunchoutConfigurationUpserted';
  /** The configuration for this location/chat */
  configuration: PunchoutConfiguration;
  /** The credential used for authentication */
  credential: PunchoutCredential;
  /** Operation performed */
  operation: PunchoutConfigurationOperationType | '%future added value';
};

export type PunchoutConfigurationsByChatUpsertInput = {
  /**
   * Array of configurations to upsert (create or update).
   * Uses chatId as natural key - creates if not exists, updates if exists.
   * This is idempotent - safe to run multiple times with same input.
   * Maximum 50 configurations can be processed at once.
   */
  configurations: Array<PunchoutConfigurationByChatUpsertInput>;
};

export type PunchoutConfigurationsUpsertResponse = AuthorizationFailure | InputValidationFailure | PunchoutConfigurationsUpsertResult;

export type PunchoutConfigurationsUpsertResult = AppsyncResponse & {
  __typename?: 'PunchoutConfigurationsUpsertResult';
  /** Array of successfully upserted punchout configurations */
  configurations: Array<PunchoutConfigurationUpserted>;
  /** Array of errors that occurred during processing */
  errors: Array<PunchoutConfigurationUpsertError>;
  responseType: ResponseType | '%future added value';
};

export type PunchoutCredential = {
  __typename?: 'PunchoutCredential';
  /** Buyer ID */
  buyerId: Scalars['ID']['output'];
  /** Creation timestamp */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** Credential ID */
  id: Scalars['ID']['output'];
  /** Internal User ID */
  internalUserId: Scalars['ID']['output'];
  /**
   * Sender domain (e-procurement system domain)
   * Example: "birchstreet.com"
   */
  senderDomain: Scalars['String']['output'];
  /**
   * Sender identity (internal user's email address)
   * Example: "john.doe@restaurant.com"
   */
  senderIdentity: Scalars['String']['output'];
  /**
   * Shared secret for authentication
   *
   * IMPORTANT: Store this securely and provide it to the e-procurement system.
   * This secret is generated on credential creation and returned in the response.
   */
  sharedSecret: Scalars['String']['output'];
};

export type PuppyValidationFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'PuppyValidationFailure';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type PushEndpointResponse = NotificationPreferences;

export const PushNotificationPlatform = {
  Android: 'android',
  Ios: 'ios'
} as const;

export type PushNotificationPlatform = typeof PushNotificationPlatform[keyof typeof PushNotificationPlatform];
export type QbdCredentials = {
  __typename?: 'QbdCredentials';
  fileUrl: Scalars['String']['output'];
  password: Scalars['String']['output'];
};

export type QboCustomersAndOrderGuidesToImport = {
  __typename?: 'QboCustomersAndOrderGuidesToImport';
  fileUrl: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /**
   * Search accepted orders with restricted field matching
   * Only searches across: chat.restaurantName, chat.chatName, buyer.name, poNumber, referenceId, buyerRefId
   * Uses cursor-based pagination for efficient result navigation
   */
  acceptedOrderSearch: SearchOrderResponse;
  /**
   * Fetch a single agent session by id.
   * Returns null agentSession within the success response if no session exists for the given id.
   */
  agentSessionGet: AgentSessionGetResponse;
  /**
   * List agent sessions, optionally filtered by supplier and agent profile type.
   * Uses cursor-based pagination via PaginationInputV2.
   */
  agentSessionsList: AgentSessionListResponse;
  billingDocumentDownloadUrl: BillingDocumentDownloadUrlResponse;
  billingDocumentExportStatus: BillingDocumentExportStatusResponse;
  billingDocumentSearch: BillingDocumentSearchResponse;
  billingStatementSearch: BillingStatementSearchResponse;
  /** only admin can access the blocked email */
  blockedEmail?: Maybe<BlockedEmail>;
  /** The max number of first is 30 */
  blockedEmails?: Maybe<BlockedEmailConnection>;
  broadcast: Broadcast;
  /**
   * Returns and searches Products in a given Supplier's catalog.
   * Can be called by: Choco Admin, user of this Supplier
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Use `vendorItemsForVendor` or `vendorItemUnitsForVendorSearch` instead
   */
  browseCatalog: BrowseCatalogResponse;
  /**
   * Returns and searches Products for a given Chat.
   * Can be called by: Choco Admin, Supplier User or Buyer User
   * Supplier/Buyer users must be in the chat
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Use `vendorItemsForChat` or `vendorItemsForChatSearch` instead
   */
  browseCatalogForChat: BrowseCatalogForChatResponse;
  bulkOrderPdf: Scalars['String']['output'];
  buyer?: Maybe<Buyer>;
  buyerBillingDocumentSearch: BuyerBillingDocumentSearchResponse;
  buyerFacets?: Maybe<Array<BuyerFacetsResponse>>;
  buyerStockCount: BuyerStockCountResponse;
  buyerStockCounts: BuyerStockCountsResponse;
  buyerStockInventory: BuyerStockInventoryResponse;
  buyerStockInventoryExportUrl: BuyerStockInventoryExportUrlResponse;
  buyerUser?: Maybe<BuyerUser>;
  buyerUsers: Array<BuyerUser>;
  /** get the cart */
  cart?: Maybe<CartResponse>;
  cartRecommendations: CartRecommendationsResponse;
  /** Resolve list of catalog attribute values from their ids */
  catalogAttributeValues: CatalogAttributeValuesResponse;
  /**
   * Get list of available product attributes (allergens and dietary preferences) and their possible values for a vendor.
   * Can be called by: Choco Admins, users of the Supplier.
   */
  catalogAttributes: CatalogAttributesResponse;
  /** Query to get the current status of a catalog export job. */
  catalogExportStatus: CatalogExportStatusResponse;
  /** Query to get the current status of a catalog import job. */
  catalogImportStatus: CatalogImportStatusResponse;
  /** Query to get the catalog import template. */
  catalogImportTemplate: CatalogImportTemplateResponse;
  /** Query to get the list of catalog imports. */
  catalogImports: CatalogImportsResponse;
  /** @deprecated Does not work anymore. Use `orderGuideV2Categories` or `orderGuideV2ItemUnits` instead */
  categoryProducts: Array<CategoryProducts>;
  chat?: Maybe<Chat>;
  chatHasSupplierEmailSupport: ChatHasSupplierEmailSupportResponse;
  /** Who is treated as having read this message, excluding the signed-in viewer. */
  chatMessageReaders: ChatMessageReadersResponse;
  /** Get supplier chat-level notification preferences */
  chatNotificationPreferences?: Maybe<ChatNotificationPreferences>;
  /** Get supplier chat-level notification preferences */
  chatNotificationPreferencesV2?: Maybe<ChatNotificationPreferences>;
  /**
   * Get the prices visibility override for a chat.
   * Can be called by: Choco Admins, users of the Supplier to whom the chat belongs.
   */
  chatPricesVisibility: ChatPricesVisibilityResponse;
  /** @deprecated Does not work anymore. Use `orderGuideV2ItemUnits` instead */
  chatProducts?: Maybe<Array<Product>>;
  /**
   * return a sub catalog of chat, ACL: chat user
   * @deprecated Does not work anymore. Use browseCatalogForChat query instead
   */
  chatSubCatalogProducts: ChatSubCatalogProductsResponse;
  /**
   * Lists which jurisdiction each chat of a vendor is taxed under.
   * Can be called by: Choco admins.
   */
  chatTaxProfileList: ChatTaxProfileListResponse;
  /** Get chatUsers by chatId XOR userId */
  chatUsers: Array<ChatUser>;
  /**
   * If you're logged in as an admin you need to provide a userId
   * If you're logged in as a Choco user, it returns the requested chats for _your_ userId
   */
  chats: UserChatConnection;
  /** Supplier inbox, including unread state. */
  chatsInbox: ChatsInboxResponse;
  /**
   * For use during the by a supplier invitation flow
   * Returns true if there is no buyer with a matching googlePlaceId
   * Returns true if there is a buyer with a matching googlePlaceId
   * and the supplier does not have a chat with that buyer
   * Returns false if a buyer exists with a matching googlePlaceId
   * and the supplier already has a chat with that buyer
   */
  checkInviteeGooglePlace: Scalars['Boolean']['output'];
  checkSupplierPhoneNumberConflict: CheckSupplierPhoneNumberConflictResponse;
  /**
   * Returns company legal details.
   * This query relies on the external Two.inc lookup ID, making it specific to Two.inc implementation.
   */
  companyDetailsTwoIncProxy: CompanyDetailsTwoIncProxyResponse;
  complementaryRecommendations: ComplementaryRecommendationsResponse;
  countSupplierChats: Scalars['Int']['output'];
  creditCheck: CreditCheckResponse;
  /**
   * Get chats assigned to a custom catalog. The result set is paginated.
   * Maximum and default page size is 50 items.
   * Can be called by: Choco Admins, users of the Supplier owning the custom catalog.
   */
  customCatalogChats: CustomCatalogChatsResponse;
  /** Query to get the current status of a customCatalog import job. */
  customCatalogFullImportStatus: CustomCatalogFullImportStatusResponse;
  /**
   * Get custom catalogs by ids, optionally narrowed down to a single vendor.
   * Can be called by: Choco Admins, users of the Supplier owning the custom catalog.
   */
  customCatalogs: CustomCatalogsResponse;
  /**
   * Get custom catalogs for a particular vendor.
   * This result set is paginated and you can also filter by chatId, search on name or exact id and whether the custom catalog is assigned to the web shop.
   * The result can be sorted by creation time (default) or alphabetically by name.
   * Maximum and default page size is 100 items.
   * Can be called by: Choco Admins, users of this Supplier.
   */
  customCatalogsForVendor: CustomCatalogsForVendorResponse;
  /**
   * API for Choco admins to inspect the customer match cache entries of a supplier,
   * most recently updated first.
   */
  customerMatchCacheEntries: CustomerMatchCacheEntriesResponse;
  dataWidgetData: DataWidgetDataResult;
  dataWidgets: DataWidgetsResult;
  echo: EchoResponse;
  /**
   * Retrieves SFTP users based on the provided filter and pagination parameters.
   * Can be called by: Authorized users with appropriate SFTP management permissions.
   */
  erpSftpUser: ErpSftpUsersResponse;
  /** Estimates the delivery fee for an order of the given subtotal, for rendering on the order confirmation screen. */
  estimatedDeliveryFee: EstimatedDeliveryFeeResponse;
  /** @deprecated Does not work anymore. Use `catalogExportStart` instead */
  exportSupplierProducts: Array<Product>;
  /**
   * Choco admins only. The feature-flag provider, project and environment this
   * AppSync environment reads and writes (production for choprd, staging otherwise).
   */
  featureFlagControlConfig: FeatureFlagControlConfigResponse;
  /**
   * Choco admins only. Non-archived flags matching the given tags, with their
   * targeting in this environment. When `entity` is set, each flag also carries
   * the value the backend evaluates for that entity.
   */
  featureFlagControlFlags: FeatureFlagControlFlagsResponse;
  /**
   * Choco admins only. Segments in this environment, for resolving segmentMatch
   * clauses.
   */
  featureFlagControlSegments: FeatureFlagControlSegmentsResponse;
  /** Choco admins only. Every flag tag defined in the provider project. */
  featureFlagControlTags: FeatureFlagControlTagsResponse;
  fetchBuyerReportDownloadUrl: FetchBuyerReportDownloadUrlResponse;
  /** @deprecated Does not work anymore. Use `vendorItemCategoriesForVendor` instead */
  fetchCatalogCategories: Array<CatalogCategory>;
  /** @deprecated Does not work anymore. Use `vendorItemCategoriesForChat` instead */
  fetchCatalogCategoriesForChat: FetchCatalogCategoriesForChatResponse;
  /** @deprecated Does not work anymore. Use `orderGuideV2Categories` or `orderGuideV2ItemUnits` instead */
  fetchOrderGuide: OrderGuideResponse;
  /** @deprecated Does not work anymore. Use `VendorItem.units` instead */
  fetchProductVariantsForBuyer?: Maybe<Array<Product>>;
  /** Generate the quicksight embed dashboard url for an anonymous user */
  generateEmbedDashboardUrl: EmbedDashboardUrlResponse;
  /** Get ad context for a specific buyer and ad zone */
  getAdContext?: Maybe<GetAdContextResponse>;
  /** Fetch all buyer report schedules created by user */
  getAllBuyerReportSchedules: GetAllBuyerReportSchedulesResponse;
  /**
   * Admin only!
   *
   * Get all chats by buyer. Supports pagination, but only in one direction.
   */
  getAllChatsByBuyer: GetAllChatsByBuyerResponse;
  /**
   * Admin only!
   *
   * Get all chats by supplier. Supports pagination, but only in one direction.
   */
  getAllChatsBySupplier: GetAllChatsBySupplierResponse;
  /**
   * Returns the deliverySetting that is used for a specific chat.
   * This query is used by mobile applications.
   *
   * If there is only a chat setting, the chat setting will be returned.
   * If there is only a supplier setting, the supplier setting will be returned.
   * if there are both, a supplier and a chat setting, the cutoffTimes will correspond to the chat setting,
   * while the exceptions will be an aggregate of supplier and chat setting.
   *
   * If no setting exists for this chat, a default setting will be returned.
   * On this default setting, every weekday will be of type 'NoCutoff'
   */
  getAppliedChatDeliverySetting?: Maybe<AppliedChatDeliverySettingResponse>;
  /** Accepts promotion title and message and returns a list of suggested by AI products */
  getBroadcastProductsSuggestions?: Maybe<SuggestedProductResult>;
  /** @deprecated Use getContactInfos query with contactType: Buyer instead */
  getBuyerContactInfos: GetBuyerContactInfosResponse;
  getBuyerSegmentContentByChat?: Maybe<GetBuyerSegmentContentByChatResponse>;
  /** @deprecated Does not work anymore. Use `catalogImportStart` instead */
  getCatalogUploadUrl: GetCatalogUploadUrlResponse;
  /** Get the number of chats that have an email as an additionalEmail */
  getChatCountByCCEmail: GetChatCountByCcEmailResponse;
  getChatSuppliersByLocations: GetChatSuppliersByLocationsResponse;
  getChatsByChatIds: GetChatsByChatIdsResponse;
  /**
   * Returns Chats assigned to a given Custom Catalog
   * Can be called by: Choco Admin, Supplier User
   * Supplier must own the Custom Catalog
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Use `customCatalogChats` instead
   */
  getChatsForSubCatalog: GetChatsForSubCatalogResponse;
  getConnectedAccounts: GetConnectedAccountsResponse;
  getConnectedIntegrationAdapters: GetConnectedIntegrationAdaptersResponse;
  /**
   * Retrieve contact information for a specific supplier with filtering and search capabilities.
   * Supports filtering by contact type (buyer, supplier, or both) and searching by contact details.
   */
  getContactInfos: GetContactInfosResponse;
  /** Get a customer import job by ID. */
  getCustomerImportJob: GetCustomerImportJobResponse;
  getCustomerInsights?: Maybe<CustomerInsightsResponse>;
  getCustomerInsightsNotification?: Maybe<GetCustomerInsightsNotificationResponse>;
  getCustomerInsightsNotifications: GetCustomerInsightsNotificationsResponse;
  getCustomerLabelsV2: SupplierLabelsResponse;
  getCustomerOrdersInsights?: Maybe<CustomerOrdersInsightsResponse>;
  getCustomerOrdersInsightsV2?: Maybe<CustomerOrdersInsightsResponseV2>;
  getCustomerOrdersInsightsV3?: Maybe<CustomerOrdersInsightsResponseV3>;
  /** Get a single distributor note by ID */
  getDistributorNote?: Maybe<GetDistributorNoteQueryResponse>;
  /** Get all distributor notes for a customer */
  getDistributorNotes?: Maybe<GetDistributorNotesQueryResponse>;
  /** Get promoted content from Dx for display in buyer apps */
  getDistributorPromotedContent: GetDistributorPromotedContentResponse;
  /** Get a single distributor task by ID */
  getDistributorTask: GetDistributorTaskResponse;
  /** Get distributor tasks based on filters */
  getDistributorTasks: GetDistributorTasksResponse;
  /** Get a document scan by id */
  getDocumentScan: GetDocumentScanResponse;
  /** get signed URL for uploading attachments */
  getDocumentScanAttachmentUploadLink: GetDocumentScanAttachmentUploadLinkResponse;
  /** Get a document scan by lead id */
  getDocumentScanList: GetDocumentScanListResponse;
  /** Retrieve the download URL for the email editor state associated with a campaign. */
  getEmailEditorState: GetEmailEditorStateResponse;
  getEmailLists: GetEmailListsResponse;
  getFeatureFlags: GetFeatureFlagsResponse;
  getIntegrationAdapters: GetIntegrationAdaptersResponse;
  /** Invite Transmission Status */
  getInviteTransmissionStatus: GetInviteTransmissionStatusResponse;
  /**
   * As a supplier: check if an invitee already has a choco account
   * If no: returns UserNotFound type
   * If yes: returns paginated list of buyers the invitee is connected to
   * that the supplier does not have a chat with.
   */
  getInviteeBuyers?: Maybe<GetInviteeBuyersResponse>;
  /** @deprecated No longer supported since Jun 2024 */
  getInvoiceAttachment?: Maybe<InvoiceAttachment>;
  getLastMessageFromChat?: Maybe<MessagesFromChatResult>;
  getLocationsBySupplier: LocationsBySupplierResponse;
  /** Retrieve a marketing campaign */
  getMarketingCampaign: GetMarketingCampaignResponse;
  /** Generate signed URLs for uploading html templates */
  getMarketingCampaignContentUploadLink: GetMarketingCampaignContentUploadLinkResponse;
  /** Retrieve a marketing campaign email sender for a specific supplier */
  getMarketingCampaignEmailSender: GetMarketingCampaignEmailSenderResponse;
  /** Generate signed URLs for uploading and accessing media files in the CDN */
  getMarketingCampaignMediaUploadLink: GetMediaUploadLinkResponse;
  getMarketingMessageSuggestions: MarketingMessageSuggestionsResult;
  /** Get a menu scan by id */
  getMenuScan: GetMenuScanResponse;
  /** get signed URL for uploading attachments */
  getMenuScanAttachmentUploadLink: GetMenuScanAttachmentUploadLinkResponse;
  /** Get the latest menu scan for a lead or customer */
  getMenuScanList: GetMenuScanListResponse;
  getOCORerankedProducts: GetOcoRerankedProductsResponse;
  getOmniChannelOrder: GetOmniChannelOrderResponse;
  getOmniChannelOrderV2: GetOmniChannelOrderResponse;
  /** @deprecated No longer in use. */
  getOnboardingChecklist: GetOnboardingChecklistResponse;
  getOrder: GetOmniChannelOrderResponse;
  getOrderChanges?: Maybe<OrderChange>;
  /** @deprecated Use getContactInfos query with contactType: Supplier instead */
  getOrderChannelContactInfos: GetOrderChannelContactInfosResponse;
  /** Fetch entire delivery check */
  getOrderDeliveryCheck?: Maybe<GetOrderDeliveryCheckResponse>;
  getOrderExcelUrl?: Maybe<Scalars['String']['output']>;
  /** For internal use, retrieves the order preference of a supplier */
  getOrderPreference?: Maybe<OrderPreference>;
  /** @deprecated Does not work anymore. Use `vendorItemUnits` instead */
  getProductsForChat: GetProductsForChatResponse;
  getQboCustomersAndOrderGuidesToImport: GetQboCustomersAndOrderGuidesToImportResponse;
  getReconciliationRequestPlanBySupplierId?: Maybe<GetReconciliationRequestPlanBySupplierIdResponse>;
  getReferral?: Maybe<GetReferralResponse>;
  getRequestsToJoin: GetRequestsToJoinResponse;
  getSalesFunnelDefinition?: Maybe<GetSalesFunnelDefinitionQueryResponse>;
  getSalesFunnelLead?: Maybe<GetSalesFunnelLeadQueryResponse>;
  getSalesFunnelLeadTransitions?: Maybe<GetSalesFunnelLeadTransitionsQueryResponse>;
  getSalesFunnelLeads?: Maybe<GetSalesFunnelLeadsQueryResponse>;
  getSalesFunnelLeadsForMap?: Maybe<GetSalesFunnelLeadsForMapQueryResponse>;
  /** Get a prospect from a place ID. */
  getSalesFunnelProspectFromPlaceId?: Maybe<GetSalesFunnelProspectsFromPlaceIdQueryResponse>;
  /** Get prospects from a free text query. */
  getSalesFunnelProspectsFromFreeText?: Maybe<GetSalesFunnelProspectsFromFreeTextQueryResponse>;
  getSalesFunnelStatistics?: Maybe<GetSalesFunnelStatisticsQueryResponse>;
  getSalesFunnelStatisticsHistory?: Maybe<GetSalesFunnelStatisticsHistoryQueryResponse>;
  getSalesFunnelTotalsHistory?: Maybe<GetSalesFunnelTotalsHistoryQueryResponse>;
  getSalesFunnels?: Maybe<GetSalesFunnelsQueryResponse>;
  /**
   * Retrieve the leads which are nearby a given location. The
   * definition of nearby is left to policy on the backend.
   */
  getSimilarSalesFunnelLeads?: Maybe<GetSimilarSalesFunnelLeadsConnection>;
  getSmsMessageByMessageSid: GetSmsMessageByMessageSidResponse;
  getSmsMessagesFromPhoneNumber: GetSmsMessagesFromPhoneNumberResponse;
  /**
   * Returns information of a given Custom Catalog.
   * Can be called by: Choco Admin or user of a Supplier to whom the Custom Catalog belongs
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Use `customCatalogs` instead
   */
  getSubCatalog?: Maybe<GetSubCatalogResponse>;
  /**
   * Returns Custom Catalogs assigned to a given Chat
   * Can be called by: Choco Admin, Supplier User
   * Supplier user must be in the Chat
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this query.
   */
  getSubCatalogsForChat: GetSubCatalogsForChatResponse;
  getSupplierApplications: GetSupplierApplicationsResponse;
  /**
   * Returns specific Catalog Products by their IDs for a given Supplier.
   * Can be called by: Choco Admin, Supplier User
   * Supplier must own the Products
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Use `vendorItemUnits` instead
   */
  getSupplierProducts: GetSupplierProductsResponse;
  getTransmission?: Maybe<GetTransmissionResponse>;
  getTransmissionBySesMessageId: GetTransmissionBySesMessageIdResponse;
  /**
   * For internal use, submit list of buyer ids and a supplier id
   * Returns which buyers the supplier does not have a chat with
   */
  getUnconnectedBuyerIds: GetUnconnectedBuyerIdsResult;
  getUploadedOrder: GetUploadedOrderResponse;
  getUserIntercomCredentials: UserIntercomCredentialsResponse;
  /** Get welcome banner promotions from Dx for display in buyer apps (whitelabel only) */
  getWelcomeBannerPromos: GetWelcomeBannerPromosResponse;
  getWhatsAppMessageByMessageSid: GetWhatsAppMessageByMessageSidResponse;
  hasUserCompletedDeliveryCheck: HasUserCompletedDeliveryCheckResponse;
  /**
   * Returns the current status of a historicalOrdersPurge job.
   * Use to poll the lifecycle of a job started via
   * `historicalOrdersPurgeStart`.
   *
   * Can be called by: Choco Admin.
   */
  historicalOrdersPurgeStatus: HistoricalOrdersPurgeStatusResponse;
  isUserInChat: Scalars['Boolean']['output'];
  itemReplacementRecommendations: ItemReplacementRecommendationsResponse;
  listMasterProductUnits: MasterProductUnitConnection;
  listProcessingTransmissions: ListProcessingTransmissionsResponse;
  /**
   * Returns products in a given Custom Catalog.
   * Can be called by: Choco Admin, user of a Supplier to whom that Custom Catalog belongs
   * @deprecated This endpoint is in the maintenance mode. It works partially, but won't get new features. Avoid using in the new code. Use `vendorItemsForVendor` or `vendorItemUnitsForVendorSearch` instead
   */
  listSubCatalogProducts?: Maybe<ListSubCatalogProductsResponse>;
  /**
   * Returns the available Custom Catalogs for a given Supplier.
   * Can be called by: Choco Admin, user of a Supplier whose catalogs are requested
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Use `customCatalogsForVendor` instead
   */
  listSubCatalogs?: Maybe<ListSubCatalogsResponse>;
  listTransmissions: ListTransmissionsResponse;
  lookupPhoneNumbers: LookupPhoneNumbersResponse;
  loyaltyGet: LoyaltyGetResponse;
  loyaltyPointsEstimationForCart: LoyaltyPointsEstimationForCartResponse;
  loyaltyRedemptionsGet: LoyaltyRedemptionsGetResponse;
  loyaltyRewardsCatalogGet: LoyaltyRewardsCatalogGetResponse;
  /** Retrieve all marketing campaigns of a supplier, categorized by states such as draft, active, and finished */
  marketingCampaignList: MarketingCampaignListResponse;
  message?: Maybe<Message>;
  messages: ChatMessageConnection;
  /**
   * For internal use,
   * - fetch list of messages which are not sent via email and chat
   * - fetch last messages from chat
   * This two queries are executed from choco-notification only
   * Return type is kept exactly similar to the table schema since it is used as is in choco-notification
   */
  messagesNotSentViaEmailAndChat: Array<MessagesFromChatResult>;
  metaLobby?: Maybe<MetaLobbyResponse>;
  /**
   * Every workspace the calling user is a member of. Scoped to the caller, so a
   * Choco admin — who holds no membership anywhere — gets an empty list.
   */
  myWorkspaces: MyWorkspacesResponse;
  /** Loyalty notifications for a buyer, newest first, cursor-paginated. */
  notificationInboxList: NotificationInboxListResponse;
  /** Whether the current user has unread loyalty notifications for a buyer (drives the unread dot). */
  notificationInboxUnreadGet: NotificationInboxUnreadGetResponse;
  /**
   * Get individual order by id or referenceId
   * Only one identifier should be provided
   */
  order?: Maybe<Order>;
  /**
   * Admin-only search for custom products (buyer-created units that exist only in the order-guide
   * index, never the catalog index) — the gap `vendorItemUnitsForAdminSearch` can't cover. Reuses
   * its response shape as well as its filter/sort semantics. One edge per (orderGuideId,
   * vendorItemUnitId) document — no cross-order-guide dedup, so a custom product in multiple order
   * guides is returned as multiple edges.
   * Can be called by: Choco Admins.
   */
  orderGuideCustomItemUnitsForAdminSearch: VendorItemUnitsForAdminSearchResponse;
  /**
   * Browses order guide item units (no text query), applying the given facet
   * filters and sort, and returning the available facet values alongside the
   * results.
   * Can be called by: Choco Admins, Buyer and Supplier users from the chat the
   * order guide is assigned to.
   */
  orderGuideItemUnitsBrowse: OrderGuideItemUnitsBrowseResponse;
  orderGuideV2Categories: OrderGuideV2CategoriesResponse;
  orderGuideV2ItemUnits: OrderGuideV2ItemUnitsResponse;
  ordersToReview: OrdersToReviewResponse;
  paymentCustomerDirectPay: PaymentCustomerDirectPayResponse;
  paymentCustomerSearch: PaymentCustomerSearchResponse;
  paymentVendor: PaymentVendorResponse;
  paymentsFeaturesConfig: PaymentsFeaturesConfigResponse;
  /** @deprecated Use transmissions instead. */
  pendingOrders: OrdersToReviewResponse;
  /**
   * Returns the details of the provided Catalog or Custom Product.
   * Can be called by: Choco Admin, Supplier User, Buyer User
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this query.
   */
  product?: Maybe<Product>;
  /** @deprecated Does not work anymore. Use `orderGuideV2Categories` instead */
  productListCategories?: Maybe<Array<ProductCategory>>;
  /**
   * API for Choco admins to inspect the product match cache entries of a supplier,
   * most recently updated first.
   */
  productMatchCacheEntries: ProductMatchCacheEntriesResponse;
  /** Returns margin data for a list of VendorItemUnit IDs in the context of a quote. */
  quoteDetailItemMarginDataGet: QuoteDetailItemMarginDataGetResponse;
  /** Returns the current execution status for a given list of QuoteGenerationJob IDs. */
  quoteGenerationJobStatuses: QuoteGenerationJobStatusesResponse;
  /** Returns the full detail of a single Quote by ID. */
  quoteGet: QuoteGetResponse;
  /**
   * Returns a combined list of Quotes and QuoteGenerationJobs for the supplier
   * derived from the auth identity.
   * QuoteGenerationJobs are only included when filter.archived is absent or false.
   */
  quoteList: QuoteListResponse;
  refundsList: RefundsListResponse;
  /** @deprecated use searchProducts/supplierSearch/userSearch query instead */
  search: SearchResult;
  /**
   * Query used to detect existing buyers.
   * Returns a list of buyers based on the provided criteria.
   * Does not support pagination - input parameter "first" will be ignored.
   */
  searchBuyer: SearchBuyerResponse;
  /** Internal use only */
  searchCustomerChats: SearchCustomerChats;
  searchCustomerV2: SearchCustomerResponse;
  searchOrder: SearchOrderResponse;
  /** @deprecated Chat indexing to Elasticsearch has been removed. Use searchCustomerV2. */
  searchOrderDeskCustomer: SearchOrderDeskCustomerResponse;
  /** @deprecated Does not work anymore. Use browseCatalog query instead */
  searchProducts?: Maybe<SearchProductsResponse>;
  /** @deprecated Does not work. The feature is no longer maintained */
  searchTaxonomyLabels?: Maybe<SearchTaxonomyLabelsResponse>;
  sendSampleSmsMessage: SendSampleSmsMessageResponse;
  settlementReport: SettlementReportResponse;
  /** @deprecated Does not work anymore. Use `BroadcastAttachment.products` instead */
  sharedBroadcastProducts?: Maybe<SharedBroadcastProducts>;
  signupFormConfig?: Maybe<SignupFormConfig>;
  /** Returns a paginated list of suppliers that have Choco AI enabled. */
  smartOrderSuppliers: SmartOrderSuppliersResponse;
  /** Every user of one SSO connection. Not paginated. */
  ssoConnectionUsers: SsoConnectionUsersResponse;
  /** All SSO connections visible to the caller. */
  ssoConnections: SsoConnectionsResponse;
  /**
   * Every email domain of one SSO connection that Choco holds an exclusivity
   * flag for. A domain Cognito routes to the connection but nobody has flagged
   * is absent, which reads as exclusiveFederatedLogin false.
   */
  ssoEmailDomains: SsoEmailDomainsResponse;
  /** Every role mapping of one SSO connection. Not paginated. */
  ssoRoleMappings: SsoRoleMappingsResponse;
  supplier?: Maybe<Supplier>;
  /**
   * Get supplier agent settings for a specific supplier and agent profile type.
   * Returns null supplierAgentSettings within the success response if no configuration exists yet.
   */
  supplierAgentSettingsGet: SupplierAgentSettingsGetResponse;
  supplierAssortments: SupplierAssortments;
  supplierChatLabels?: Maybe<Array<ChatLabelsResult>>;
  /** Returns the available delivery dates, used in the checkout process when creating an order. */
  supplierDeliveryDateSettings?: Maybe<SupplierDeliveryDateSettingsResponse>;
  /** Returns the delivery fee configurations for a supplier: the SUPPLIER_DEFAULT one and, when buyerId is provided, the CUSTOMER override. */
  supplierDeliveryFees: SupplierDeliveryFeesResponse;
  /**
   * Returns the deliverySetting for a supplier.
   * The input can be a chat- or supplier-id.
   * If the input is a chatId, the return value will be a chat-setting or null.
   */
  supplierDeliverySetting?: Maybe<SupplierDeliverySetting>;
  /**
   * Every supplier of one multi-entity hierarchy, flat and ordered by id.
   * The tree can be reconstructed via `parent.id` references.
   *
   * Admin only.
   */
  supplierHierarchyList: SupplierHierarchyListResponse;
  /**
   * Get the list of validation rules that this user can override when reviewing orders for a specific supplier.
   * Returns an empty array if no override permissions are configured.
   */
  supplierOrderOverridePermissions: SupplierOrderOverridePermissionsResponse;
  supplierSearch: SupplierSearchResponse;
  supplierSearchV2: SupplierSearchResponse;
  /**
   * The support code in effect now. Admin-only. The service sets how long a code
   * lasts, so read expiresAt rather than assuming a daily rotation.
   */
  supportCodeGet: SupportCodeGetResponse;
  switchAndSaveMappingGet: SwitchAndSaveMappingGetResponse;
  switchAndSaveRecommendationPreview: SwitchAndSaveRecommendationPreviewResponse;
  switchAndSaveRecommendations: SwitchAndSaveRecommendationsResponse;
  /**
   * Lists a vendor's tax jurisdictions with their rates.
   * Can be called by: Choco admins.
   */
  taxJurisdictionList: TaxJurisdictionListResponse;
  /**
   * Every location in the workspace where the caller may assign roles, each with
   * the roles assignable there.
   */
  teamAssignableLocationRolesList: TeamAssignableLocationRolesListResponse;
  /** Find the members of one workspace by name. Every member may discover every other. */
  teamDirectorySearch: TeamDirectorySearchResponse;
  /**
   * Every role one member holds, bounded by the caller's shared scope. A member
   * the caller shares no location with reads as not found.
   */
  teamMemberGet: TeamMemberGetResponse;
  /**
   * Every member the caller shares a location with, each with the roles they hold
   * inside that shared scope.
   */
  teamMembersInSharedLocationsList: TeamMembersInSharedLocationsListResponse;
  /**
   * Team notification preferences for the supplier account.
   * Any supplier user may read (so the UI can show what opt-in uses).
   * Admins write.
   */
  teamNotificationPreferences: TeamNotificationPreferencesResponse;
  topUpEligibleDeliveryDates?: Maybe<TopUpEligibleDeliveryDatesResponse>;
  /** Get all transmission events of an order (ofId=orderId). Sorted by timestamp (descending). */
  transmissionEvents: Array<TransmissionEvent>;
  transmissions: TransmissionsResponse;
  user?: Maybe<User>;
  /** The query will currently be used to obtain chats for both buyer chats and user chats */
  userChats: UserChatsResponse;
  userCognitoState: UserCognitoStateResponse;
  /**
   * Choco staff only. Shows what deleting the user would do, without changing
   * anything. Every phone number, email and login is masked.
   */
  userDeletionPreview: UserDeletionPreviewResponse;
  /** Profile-level personal notification preferences for the current user. */
  userNotificationPreferences: UserNotificationPreferencesResponse;
  /** Personal notification preferences for a customer/chat (override + global). */
  userNotificationPreferencesForChat: UserNotificationPreferencesForChatResponse;
  userSearch: UserSearchResponse;
  /** Whether the signed-in supplier user has opted in to team chat notifications. */
  userTeamChatNotificationsOptIn: UserTeamChatNotificationsOptInResponse;
  /** @deprecated Twilio changed the behaviour of a dependency endpoint; it no longer accurate reflects the user's Twilio state */
  userTwilioState: UserTwilioStateResponse;
  /**
   * Checks if the Products are available in the given Chat.
   * Can be called by: Choco Admin, Supplier User or Buyer User
   * Supplier/Buyer users must be in the Chat
   * @deprecated This endpoint is in the maintenance mode. It works correctly, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this query.
   */
  validateProductsAvailability: ValidateProductsAvailabilityResponse;
  /** Resolve list of catalog vendor item categories from their ids */
  vendorItemCategories: VendorItemCategoriesResponse;
  /**
   * Looks up vendor catalog categories for a given chat based on the provided filters.
   * This query returns only the categories that are visible to the buyer and have at least one item available for this chat.
   * The results are ordered by the translated category name.
   * Maximum and default page size is 200 items.
   * Can be called by: Choco Admins, Supplier and Buyer users from the chat.
   */
  vendorItemCategoriesForChat: VendorItemCategoriesForChatResponse;
  /**
   * Looks up vendor catalog categories for a given vendor based on the provided filters.
   * This query returns only the categories that have at least one item available for this vendor.
   * The results are ordered by the translated category name.
   * Maximum and default page size is 200 items.
   * Can be called by: Choco Admins, users of this Supplier.
   */
  vendorItemCategoriesForVendor: VendorItemCategoriesForVendorResponse;
  /**
   * Get vendor item units by ids or legacyIds (e.g. for cart).
   * Maximum 50 ids can be provided at once.
   * Can be called by: Any user.
   */
  vendorItemUnits: VendorItemUnitsResponse;
  /**
   * Browses vendor items in the context of a chat (no text query), applying the
   * given facet filters and returning the available facet values alongside the
   * results.
   * Can be called by: Choco Admins, Buyer and Supplier users from the chat.
   */
  vendorItemUnitsBrowse: VendorItemUnitsBrowseResponse;
  /**
   * Admin-only general-purpose catalog product search — not vendor-scoped by default, no implicit
   * baseline filtering (callers reconstruct whatever default filtering they need via `filter`).
   * Supports both ranked keyword search and unranked lookup-by-id (via a VENDOR_ITEM_UNIT_ID IN
   * filter + an explicit sort). Powers internal/admin tooling such as the Ads segmentation tool; not
   * specific to any one consumer.
   * Can be called by: Choco Admins.
   */
  vendorItemUnitsForAdminSearch: VendorItemUnitsForAdminSearchResponse;
  /**
   * Typeahead search optimized for low-latency search-as-you-type.
   * Uses lightweight prefix matching for short queries; adds cross-field
   * matching and ML reranking for queries of 5+ characters.
   * Returns results in chat context (respects custom catalog visibility).
   */
  vendorItemUnitsForChatTypeahead: VendorItemsForChatResponse;
  /**
   * Searches vendor items in the context of a Supplier catalog.
   * All units are returned in a flattened list.
   * Can be called by: Choco Admins, Supplier users.
   */
  vendorItemUnitsForVendorSearch: VendorItemsForVendorResponse;
  /**
   * Returns vendor items by their ids.
   * Can be called by: Any user.
   */
  vendorItems: VendorItemsResponse;
  /**
   * Returns count of vendor items for a given chat based on the provided filters.
   * Note that only one item per variant group is considered.
   * This corresponds to the result of the `vendorItemsForChat` query.
   * Can be called by: Choco Admins, Supplier and Buyer users from the chat.
   */
  vendorItemsCountForChat: VendorItemsCountForChatResponse;
  /**
   * Looks up vendor items for a given chat based on the provided filters.
   * This query returns only the default units for each item, and only the default item variant for each variant group.
   * The results are ordered by the translated item name.
   * Maximum page size is 50 items. Default page size is 20 items.
   * Can be called by: Choco Admins, Supplier and Buyer users from the chat.
   */
  vendorItemsForChat: VendorItemsForChatResponse;
  /**
   * Searches vendor items in the context of a chat.
   * Only the most relevant unit will be returned for each item.
   * Other units are available in the `vendorItem.units` field.
   * Can be called by: Choco Admins, Buyer and Supplier users from the chat.
   */
  vendorItemsForChatSearch: VendorItemsForChatResponse;
  /**
   * Looks up vendor items for a given vendor based on the provided filters.
   * This query returns all units for each item without the grouping by variantGroupCode or id.
   * Can be called by: Choco Admins, users of this Supplier.
   */
  vendorItemsForVendor: VendorItemsForVendorResponse;
  /**
   * Lists every brand in the vendor's catalog with its boost status, in one
   * response. Takes no pagination, search or filter arguments.
   * Can be called by supplier admins associated with the vendor.
   */
  vendorPreferredBrands: VendorPreferredBrandsResponse;
  /** Returns buyer-visible product units eligible for a promotion. */
  vendorPromotionEligibleUnits: VendorPromotionEligibleUnitsResponse;
  /**
   * Lists a vendor's promotions as configured.
   * Can be called by: Choco admins.
   */
  vendorPromotionList: VendorPromotionListResponse;
  /** Returns promotions visible to a buyer, optionally scoped to a vendor and chat. */
  vendorPromotionsForBuyer: VendorPromotionsForBuyerResponse;
  /**
   * Lists the custom search synonym rules configured for a vendor.
   * Can be called by supplier admins associated with the vendor.
   */
  vendorSearchSynonyms: Array<VendorSearchSynonym>;
  voiceCallTransmissions: TransmissionsResponse;
  webshopConfig?: Maybe<WebshopConfig>;
  webshopMetadata?: Maybe<WebshopMetadata>;
  /**
   * List all product collections for a vendor's webshop.
   * Returns collections ordered by display_order (ascending).
   * Each collection includes its full products array.
   *
   * UI USAGE:
   * - Called on page load for Product collections screen
   * - Use returned data to render collection list
   * - If empty array, show empty state with "+ ADD MORE" button
   *
   * Can be called by: Choco Admins, Supplier Users
   */
  webshopProductCollections: WebshopProductCollectionsResponse;
  /**
   * Get the welcome banner for a vendor's webshop.
   * Returns null if no banner has been created yet.
   *
   * UI USAGE:
   * - Called on page load for Welcome banner screen
   * - Use returned data to populate form fields
   * - If null, show empty form
   *
   * Can be called by: Choco Admins, Supplier Users
   */
  webshopWelcomeBanner: WebshopWelcomeBannerResponse;
  /**
   * Get a list of wholesale customers available for the user.
   * For white label applications, returns only customers associated with the white label vendor.
   */
  wholesailCustomers: WholesailCustomersResponse;
  /** Every workspace, each with all of its hierarchy roots. Choco admin only. */
  workspaceList: WorkspaceListResponse;
};


export type QueryAcceptedOrderSearchArgs = {
  input: AcceptedOrderSearchInput;
};


export type QueryAgentSessionGetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgentSessionsListArgs = {
  input: AgentSessionListInput;
};


export type QueryBillingDocumentDownloadUrlArgs = {
  input: BillingDocumentDownloadUrlInput;
};


export type QueryBillingDocumentExportStatusArgs = {
  input: BillingDocumentExportStatusInput;
};


export type QueryBillingDocumentSearchArgs = {
  input: BillingDocumentSearchInput;
};


export type QueryBillingStatementSearchArgs = {
  input: BillingStatementSearchInput;
};


export type QueryBlockedEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryBlockedEmailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBroadcastArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryBrowseCatalogArgs = {
  input: BrowseCatalogInput;
};


export type QueryBrowseCatalogForChatArgs = {
  input: BrowseCatalogForChatInput;
};


export type QueryBulkOrderPdfArgs = {
  downloadable?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  orderIds: Array<Scalars['ID']['input']>;
};


export type QueryBuyerArgs = {
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBuyerBillingDocumentSearchArgs = {
  input: BuyerBillingDocumentSearchInput;
};


export type QueryBuyerStockCountArgs = {
  input: GetBuyerStockCountInput;
};


export type QueryBuyerStockCountsArgs = {
  input: GetBuyerStockCountsInput;
};


export type QueryBuyerStockInventoryArgs = {
  filter: GetBuyerStockInventoryProductsFilterInput;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<Sort>;
};


export type QueryBuyerStockInventoryExportUrlArgs = {
  input: GetBuyerStockInventoryExportUrlInput;
};


export type QueryBuyerUserArgs = {
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryBuyerUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCartArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryCartRecommendationsArgs = {
  input: CartRecommendationsInput;
};


export type QueryCatalogAttributeValuesArgs = {
  input: CatalogAttributeValuesInput;
};


export type QueryCatalogAttributesArgs = {
  input: CatalogAttributesInput;
};


export type QueryCatalogExportStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryCatalogImportStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryCatalogImportsArgs = {
  input: CatalogImportsInput;
};


export type QueryCategoryProductsArgs = {
  chatId: Scalars['ID']['input'];
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryChatArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QueryChatHasSupplierEmailSupportArgs = {
  chatId: Scalars['ID']['input'];
  checkExcludedSupplier?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryChatMessageReadersArgs = {
  input: ChatMessageReadersInput;
};


export type QueryChatNotificationPreferencesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatNotificationPreferencesV2Args = {
  id: Scalars['ID']['input'];
};


export type QueryChatPricesVisibilityArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryChatProductsArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryChatSubCatalogProductsArgs = {
  input?: InputMaybe<ChatSubCatalogProductsInput>;
};


export type QueryChatTaxProfileListArgs = {
  input: ChatTaxProfileListInput;
};


export type QueryChatUsersArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ignoreChatsWithStatus?: InputMaybe<Array<InputMaybe<ChatStatus>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryChatsInboxArgs = {
  input: ChatsInboxInput;
};


export type QueryCheckInviteeGooglePlaceArgs = {
  googlePlaceId: Scalars['String']['input'];
};


export type QueryCheckSupplierPhoneNumberConflictArgs = {
  input: CheckSupplierPhoneNumberConflictInput;
};


export type QueryCompanyDetailsTwoIncProxyArgs = {
  lookupId: Scalars['String']['input'];
};


export type QueryComplementaryRecommendationsArgs = {
  input: ComplementaryRecommendationsInput;
};


export type QueryCountSupplierChatsArgs = {
  chatStatus?: InputMaybe<ChatStatus>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierEntityId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCreditCheckArgs = {
  input: CreditCheckInput;
};


export type QueryCustomCatalogChatsArgs = {
  input: CustomCatalogChatsInput;
};


export type QueryCustomCatalogFullImportStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryCustomCatalogsArgs = {
  input: CustomCatalogsInput;
};


export type QueryCustomCatalogsForVendorArgs = {
  input: CustomCatalogsForVendorInput;
};


export type QueryCustomerMatchCacheEntriesArgs = {
  input: CustomerMatchCacheEntriesInput;
};


export type QueryDataWidgetDataArgs = {
  input: DataWidgetDataInput;
};


export type QueryDataWidgetsArgs = {
  input: DataWidgetsInput;
};


export type QueryEchoArgs = {
  input: EchoInput;
};


export type QueryErpSftpUserArgs = {
  input: ErpSftpUsersInput;
};


export type QueryEstimatedDeliveryFeeArgs = {
  input: EstimatedDeliveryFeeInput;
};


export type QueryExportSupplierProductsArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryFeatureFlagControlFlagsArgs = {
  input: FeatureFlagControlFlagsInput;
};


export type QueryFetchBuyerReportDownloadUrlArgs = {
  input: FetchBuyerReportDownloadUrlInput;
};


export type QueryFetchCatalogCategoriesArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryFetchCatalogCategoriesForChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryFetchOrderGuideArgs = {
  chatId: Scalars['ID']['input'];
  product: OrderGuideProductArgs;
};


export type QueryFetchProductVariantsForBuyerArgs = {
  chatId: Scalars['ID']['input'];
  productId: Scalars['String']['input'];
};


export type QueryGetAdContextArgs = {
  input: GetAdContextInput;
};


export type QueryGetAllBuyerReportSchedulesArgs = {
  input: GetAllBuyerReportSchedulesInput;
};


export type QueryGetAllChatsByBuyerArgs = {
  input: GetAllChatsByBuyerInput;
};


export type QueryGetAllChatsBySupplierArgs = {
  input: GetAllChatsBySupplierInput;
};


export type QueryGetAppliedChatDeliverySettingArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryGetBroadcastProductsSuggestionsArgs = {
  text: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBuyerContactInfosArgs = {
  input: GetBuyerContactInfosInput;
};


export type QueryGetBuyerSegmentContentByChatArgs = {
  input: GetBuyerSegmentContentByChatInput;
};


export type QueryGetCatalogUploadUrlArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryGetChatCountByCcEmailArgs = {
  email: Scalars['AWSEmail']['input'];
};


export type QueryGetChatSuppliersByLocationsArgs = {
  input: GetChatSuppliersByLocationsInput;
};


export type QueryGetChatsByChatIdsArgs = {
  chatIds: Array<Scalars['ID']['input']>;
};


export type QueryGetChatsForSubCatalogArgs = {
  subCatalogId: Scalars['ID']['input'];
};


export type QueryGetConnectedAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<ConnectedAccountInput>;
};


export type QueryGetConnectedIntegrationAdaptersArgs = {
  input: GetConnectedIntegrationAdaptersInput;
};


export type QueryGetContactInfosArgs = {
  input: ContactInfosInput;
};


export type QueryGetCustomerImportJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCustomerInsightsArgs = {
  input: GetCustomerInsightsInput;
};


export type QueryGetCustomerInsightsNotificationArgs = {
  input?: InputMaybe<GetCustomerInsightsNotificationInput>;
};


export type QueryGetCustomerInsightsNotificationsArgs = {
  input: GetCustomerInsightsNotificationsInput;
};


export type QueryGetCustomerLabelsV2Args = {
  input: GetCustomerLabelsV2Input;
};


export type QueryGetCustomerOrdersInsightsArgs = {
  input: CustomerOrdersInsightsInput;
};


export type QueryGetCustomerOrdersInsightsV2Args = {
  input: CustomerOrdersInsightsInputV2;
};


export type QueryGetCustomerOrdersInsightsV3Args = {
  input: CustomerOrdersInsightsInputV3;
};


export type QueryGetDistributorNoteArgs = {
  input: GetDistributorNoteQueryInput;
};


export type QueryGetDistributorNotesArgs = {
  input: GetDistributorNotesQueryInput;
};


export type QueryGetDistributorPromotedContentArgs = {
  input: GetDistributorPromotedContentInput;
};


export type QueryGetDistributorTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDistributorTasksArgs = {
  input: GetDistributorTasksInput;
};


export type QueryGetDocumentScanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDocumentScanAttachmentUploadLinkArgs = {
  input: GetDocumentScanAttachmentUploadLinkInput;
};


export type QueryGetDocumentScanListArgs = {
  input: GetDocumentScanListInput;
};


export type QueryGetEmailEditorStateArgs = {
  input: GetEmailEditorStateInput;
};


export type QueryGetEmailListsArgs = {
  input: GetEmailListsInput;
};


export type QueryGetIntegrationAdaptersArgs = {
  input: GetIntegrationAdaptersInput;
};


export type QueryGetInviteTransmissionStatusArgs = {
  input: GetInviteTransmissionStatus;
};


export type QueryGetInviteeBuyersArgs = {
  phone: Scalars['String']['input'];
};


export type QueryGetInvoiceAttachmentArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryGetLastMessageFromChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryGetLocationsBySupplierArgs = {
  supplierEntityId: Scalars['ID']['input'];
};


export type QueryGetMarketingCampaignArgs = {
  input: GetMarketingCampaignInput;
};


export type QueryGetMarketingCampaignContentUploadLinkArgs = {
  input: GetMarketingCampaignContentUploadLinkInput;
};


export type QueryGetMarketingCampaignMediaUploadLinkArgs = {
  input: GetMediaUploadLinkInput;
};


export type QueryGetMarketingMessageSuggestionsArgs = {
  currentMessage: Scalars['String']['input'];
};


export type QueryGetMenuScanArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMenuScanAttachmentUploadLinkArgs = {
  input: GetMenuScanAttachmentUploadLinkInput;
};


export type QueryGetMenuScanListArgs = {
  input: GetMenuScanListInput;
};


export type QueryGetOcoRerankedProductsArgs = {
  input: GetOcoRerankedProductsInput;
};


export type QueryGetOmniChannelOrderArgs = {
  input: GetOmniChannelOrderInput;
};


export type QueryGetOmniChannelOrderV2Args = {
  input: GetOmniChannelOrderInput;
};


export type QueryGetOnboardingChecklistArgs = {
  buyerId: Scalars['ID']['input'];
};


export type QueryGetOrderArgs = {
  input: GetOrderInput;
};


export type QueryGetOrderChangesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrderChannelContactInfosArgs = {
  input: GetOrderChannelContactInfosInput;
};


export type QueryGetOrderDeliveryCheckArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryGetOrderExcelUrlArgs = {
  filename?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};


export type QueryGetOrderPreferenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetProductsForChatArgs = {
  input: GetProductsForChatInput;
};


export type QueryGetQboCustomersAndOrderGuidesToImportArgs = {
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetReconciliationRequestPlanBySupplierIdArgs = {
  supplierId: Scalars['ID']['input'];
};


export type QueryGetReferralArgs = {
  input: GetReferralInput;
};


export type QueryGetRequestsToJoinArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  query: GetRequestsToJoinInput;
};


export type QueryGetSalesFunnelDefinitionArgs = {
  input: GetSalesFunnelDefinitionInput;
};


export type QueryGetSalesFunnelLeadArgs = {
  input: GetSalesFunnelLeadQueryInput;
};


export type QueryGetSalesFunnelLeadTransitionsArgs = {
  input: GetSalesFunnelLeadTransitionsQueryInput;
};


export type QueryGetSalesFunnelLeadsArgs = {
  input: GetSalesFunnelLeadsQueryInput;
};


export type QueryGetSalesFunnelLeadsForMapArgs = {
  input: GetSalesFunnelLeadsQueryInput;
};


export type QueryGetSalesFunnelProspectFromPlaceIdArgs = {
  input: GetSalesFunnelProspectFromPlaceIdQueryInput;
};


export type QueryGetSalesFunnelProspectsFromFreeTextArgs = {
  input: GetSalesFunnelProspectsFromFreeTextQueryInput;
};


export type QueryGetSalesFunnelStatisticsArgs = {
  input: GetSalesFunnelStatisticsQueryInput;
};


export type QueryGetSalesFunnelStatisticsHistoryArgs = {
  input: GetSalesFunnelStatisticsHistoryQueryInput;
};


export type QueryGetSalesFunnelTotalsHistoryArgs = {
  input: GetSalesFunnelTotalsHistoryQueryInput;
};


export type QueryGetSalesFunnelsArgs = {
  input: GetSalesFunnelsQueryInput;
};


export type QueryGetSimilarSalesFunnelLeadsArgs = {
  input: GetSimilarSalesFunnelLeadsQueryInput;
};


export type QueryGetSmsMessageByMessageSidArgs = {
  messageSid: Scalars['String']['input'];
};


export type QueryGetSmsMessagesFromPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
  sort?: InputMaybe<Sort>;
};


export type QueryGetSubCatalogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSubCatalogsForChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryGetSupplierApplicationsArgs = {
  query?: InputMaybe<GetSupplierApplicationsInput>;
};


export type QueryGetSupplierProductsArgs = {
  input: GetSupplierProductsInput;
};


export type QueryGetTransmissionArgs = {
  input: GetTransmissionInput;
};


export type QueryGetTransmissionBySesMessageIdArgs = {
  input?: InputMaybe<GetTransmissionBySesMessageIdInput>;
};


export type QueryGetUnconnectedBuyerIdsArgs = {
  buyerIds: Array<Scalars['String']['input']>;
  ignoreDisabledChats?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId: Scalars['String']['input'];
};


export type QueryGetUploadedOrderArgs = {
  uploadedOrderId: Scalars['ID']['input'];
};


export type QueryGetWelcomeBannerPromosArgs = {
  input: GetWelcomeBannerPromosInput;
};


export type QueryGetWhatsAppMessageByMessageSidArgs = {
  messageSid: Scalars['String']['input'];
};


export type QueryHasUserCompletedDeliveryCheckArgs = {
  chatId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryHistoricalOrdersPurgeStatusArgs = {
  jobId: Scalars['ID']['input'];
};


export type QueryIsUserInChatArgs = {
  chatId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type QueryItemReplacementRecommendationsArgs = {
  input: ItemReplacementRecommendationsInput;
};


export type QueryListMasterProductUnitsArgs = {
  input: ListMasterProductUnitsInput;
};


export type QueryListProcessingTransmissionsArgs = {
  input: ListProcessingTransmissionsInput;
};


export type QueryListSubCatalogProductsArgs = {
  input: ListSubCatalogProductsInput;
};


export type QueryListSubCatalogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  supplierEntityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListTransmissionsArgs = {
  input: ListTransmissionsInput;
};


export type QueryLookupPhoneNumbersArgs = {
  phoneNumbers: Array<Scalars['String']['input']>;
};


export type QueryLoyaltyGetArgs = {
  input: LoyaltyGetInput;
};


export type QueryLoyaltyPointsEstimationForCartArgs = {
  input: LoyaltyPointsEstimationForCartInput;
};


export type QueryLoyaltyRedemptionsGetArgs = {
  input: LoyaltyRedemptionsGetInput;
};


export type QueryLoyaltyRewardsCatalogGetArgs = {
  input: LoyaltyRewardsCatalogGetInput;
};


export type QueryMarketingCampaignListArgs = {
  input: MarketingCampaignListInput;
};


export type QueryMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  chatId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy?: InputMaybe<MessageGroupFilter>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMessagesNotSentViaEmailAndChatArgs = {
  chatId: Scalars['ID']['input'];
  isSupplier: Scalars['Boolean']['input'];
};


export type QueryMetaLobbyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNotificationInboxListArgs = {
  input: NotificationInboxListInput;
};


export type QueryNotificationInboxUnreadGetArgs = {
  input: NotificationInboxUnreadGetInput;
};


export type QueryOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrderGuideCustomItemUnitsForAdminSearchArgs = {
  input: OrderGuideCustomItemUnitsForAdminSearchInput;
};


export type QueryOrderGuideItemUnitsBrowseArgs = {
  input: OrderGuideItemUnitsBrowseInput;
};


export type QueryOrderGuideV2CategoriesArgs = {
  input: OrderGuideV2CategoriesInput;
};


export type QueryOrderGuideV2ItemUnitsArgs = {
  input: OrderGuideV2ItemUnitsInput;
};


export type QueryOrdersToReviewArgs = {
  input: OrdersToReviewInput;
};


export type QueryPaymentCustomerDirectPayArgs = {
  input: PaymentCustomerDirectPayInput;
};


export type QueryPaymentCustomerSearchArgs = {
  input: PaymentCustomerSearchInput;
};


export type QueryPaymentVendorArgs = {
  input: PaymentVendorInput;
};


export type QueryPendingOrdersArgs = {
  input: PendingOrdersInput;
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductListCategoriesArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryProductMatchCacheEntriesArgs = {
  input: ProductMatchCacheEntriesInput;
};


export type QueryQuoteDetailItemMarginDataGetArgs = {
  input: QuoteDetailItemMarginDataGetInput;
};


export type QueryQuoteGenerationJobStatusesArgs = {
  input: QuoteGenerationJobStatusesInput;
};


export type QueryQuoteGetArgs = {
  input: QuoteGetInput;
};


export type QueryQuoteListArgs = {
  input: QuoteListInput;
};


export type QueryRefundsListArgs = {
  input: RefundsListInput;
};


export type QuerySearchArgs = {
  query: SearchInput;
};


export type QuerySearchBuyerArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  query: SearchBuyerInput;
};


export type QuerySearchCustomerChatsArgs = {
  input: SearchCustomerChatsInput;
};


export type QuerySearchCustomerV2Args = {
  input: SearchCustomerV2Input;
};


export type QuerySearchOrderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query: SearchOrderInput;
  sort?: InputMaybe<Sort>;
};


export type QuerySearchOrderDeskCustomerArgs = {
  input: SearchOrderDeskCustomerInput;
};


export type QuerySearchProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: SearchProductsInput;
};


export type QuerySearchTaxonomyLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: SearchTaxonomyLabelsInput;
};


export type QuerySendSampleSmsMessageArgs = {
  input: SendSampleSmsMessageInput;
};


export type QuerySettlementReportArgs = {
  input: SettlementReportInput;
};


export type QuerySharedBroadcastProductsArgs = {
  broadcastId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
};


export type QuerySignupFormConfigArgs = {
  vendorId: Scalars['ID']['input'];
};


export type QuerySmartOrderSuppliersArgs = {
  input: SmartOrderSuppliersInput;
};


export type QuerySsoConnectionUsersArgs = {
  input: SsoConnectionUsersInput;
};


export type QuerySsoEmailDomainsArgs = {
  input: SsoEmailDomainsInput;
};


export type QuerySsoRoleMappingsArgs = {
  input: SsoRoleMappingsInput;
};


export type QuerySupplierArgs = {
  botUserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierAgentSettingsGetArgs = {
  agentProfileType: AgentProfileType;
  supplierId: Scalars['ID']['input'];
};


export type QuerySupplierChatLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  asBotUser?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupplierDeliveryDateSettingsArgs = {
  chatId: Scalars['ID']['input'];
  context?: InputMaybe<DeliveryDateContext>;
};


export type QuerySupplierDeliveryFeesArgs = {
  input: SupplierDeliveryFeesInput;
};


export type QuerySupplierDeliverySettingArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierHierarchyListArgs = {
  input: SupplierHierarchyListInput;
};


export type QuerySupplierOrderOverridePermissionsArgs = {
  input: SupplierOrderOverridePermissionsInput;
};


export type QuerySupplierSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query: SupplierSearchInput;
};


export type QuerySupplierSearchV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coordinates: CoordinateInput;
  filter?: InputMaybe<SupplierSearchV2Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySwitchAndSaveMappingGetArgs = {
  input: SwitchAndSaveMappingGetInput;
};


export type QuerySwitchAndSaveRecommendationPreviewArgs = {
  input: SwitchAndSaveRecommendationPreviewInput;
};


export type QuerySwitchAndSaveRecommendationsArgs = {
  input: SwitchAndSaveRecommendationsInput;
};


export type QueryTaxJurisdictionListArgs = {
  input: TaxJurisdictionListInput;
};


export type QueryTeamAssignableLocationRolesListArgs = {
  input: TeamAssignableLocationRolesListInput;
};


export type QueryTeamDirectorySearchArgs = {
  input: TeamDirectorySearchInput;
};


export type QueryTeamMemberGetArgs = {
  input: TeamMemberGetInput;
};


export type QueryTeamMembersInSharedLocationsListArgs = {
  input: TeamMembersInSharedLocationsListInput;
};


export type QueryTopUpEligibleDeliveryDatesArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryTransmissionEventsArgs = {
  ofId: Scalars['ID']['input'];
};


export type QueryTransmissionsArgs = {
  input: ListTransmissionsInput;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserCognitoStateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserDeletionPreviewArgs = {
  input: UserDeletionPreviewInput;
};


export type QueryUserNotificationPreferencesForChatArgs = {
  input: UserNotificationPreferencesForChatInput;
};


export type QueryUserSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query: UserSearchInput;
};


export type QueryUserTwilioStateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryValidateProductsAvailabilityArgs = {
  input: ValidateProductsAvailabilityInput;
};


export type QueryVendorItemCategoriesArgs = {
  input: VendorItemCategoriesInput;
};


export type QueryVendorItemCategoriesForChatArgs = {
  input: VendorItemCategoriesForChatInput;
};


export type QueryVendorItemCategoriesForVendorArgs = {
  input: VendorItemCategoriesForVendorInput;
};


export type QueryVendorItemUnitsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryVendorItemUnitsBrowseArgs = {
  input: VendorItemUnitsBrowseInput;
};


export type QueryVendorItemUnitsForAdminSearchArgs = {
  input: VendorItemUnitsForAdminSearchInput;
};


export type QueryVendorItemUnitsForChatTypeaheadArgs = {
  input: VendorItemUnitsForChatTypeaheadInput;
};


export type QueryVendorItemUnitsForVendorSearchArgs = {
  input: VendorItemUnitsForVendorSearchInput;
};


export type QueryVendorItemsArgs = {
  input: VendorItemsInput;
};


export type QueryVendorItemsCountForChatArgs = {
  input: VendorItemsCountForChatInput;
};


export type QueryVendorItemsForChatArgs = {
  input: VendorItemsForChatInput;
};


export type QueryVendorItemsForChatSearchArgs = {
  input: VendorItemsForChatSearchInput;
};


export type QueryVendorItemsForVendorArgs = {
  input: VendorItemsForVendorInput;
};


export type QueryVendorPreferredBrandsArgs = {
  input: VendorPreferredBrandsInput;
};


export type QueryVendorPromotionEligibleUnitsArgs = {
  input: VendorPromotionEligibleUnitsInput;
};


export type QueryVendorPromotionListArgs = {
  input: VendorPromotionListInput;
};


export type QueryVendorPromotionsForBuyerArgs = {
  input: VendorPromotionsForBuyerInput;
};


export type QueryVendorSearchSynonymsArgs = {
  input: VendorSearchSynonymsInput;
};


export type QueryVoiceCallTransmissionsArgs = {
  input: ListTransmissionsInput;
};


export type QueryWebshopConfigArgs = {
  vendorId: Scalars['ID']['input'];
};


export type QueryWebshopMetadataArgs = {
  vendorId: Scalars['ID']['input'];
};


export type QueryWebshopProductCollectionsArgs = {
  input: WebshopProductCollectionsInput;
};


export type QueryWebshopWelcomeBannerArgs = {
  input: WebshopWelcomeBannerInput;
};


export type QueryWorkspaceListArgs = {
  input: WorkspaceListInput;
};

/**
 * Contains aggregate information about the QuoteItems with in a Quote.
 * Even when quote validation fails, this will contain a best-effort result.
 */
export type QuoteAggregationData = {
  __typename?: 'QuoteAggregationData';
  /** Total gross profit for the quote. */
  grossProfit?: Maybe<MoneyV2>;
  /** Total margin for the quote. */
  margin?: Maybe<Decimal>;
  /** Grouped counts of quote items by margin classification. */
  marginItemCounts?: Maybe<QuoteMarginItemCounts>;
  /**
   * Sum value of all items in the proposal. Note that a given QuoteItem has a value equal
   * to the price * quantity.
   */
  sum: MoneyV2;
  /**
   * Quote-level target gross profit derived from the target margins of quote items
   * that can participate in margin aggregation. Null when no usable target-margin
   * data is available.
   */
  targetGrossProfit?: Maybe<MoneyV2>;
  /**
   * Quote-level target margin derived from the target margins of quote items that
   * can participate in margin aggregation. Null when no usable target-margin data
   * is available.
   */
  targetMargin?: Maybe<Decimal>;
  /**
   * All VendorItemUnits referenced by items in this quote. Not paginated — returned in full
   * regardless of the items cursor. In most cases only the IDs are needed to cross-reference
   * against the items list, but full node resolvers are available for convenience.
   */
  vendorItemUnits: Array<VendorItemUnitRef>;
};

/** Returned when an approval-only mutation is called for a quote without approvals enabled. */
export type QuoteApprovalNotEnabledError = {
  __typename?: 'QuoteApprovalNotEnabledError';
  /** Quote that does not have approvals enabled. */
  quoteId: Scalars['ID']['output'];
  /** Response type. */
  responseType: ResponseType | '%future added value';
};

/** Describes whether the approval flow is active for this quote. */
export type QuoteApprovalSettings = QuoteApprovalsActive | QuoteApprovalsDisabled;

/** Approval flow is enabled for this quote. */
export type QuoteApprovalsActive = {
  __typename?: 'QuoteApprovalsActive';
  /** Always true because GraphQL object types cannot be empty. Use __typename as the settings discriminator. */
  active: Scalars['Boolean']['output'];
};

/** Approval flow is disabled for this quote. */
export type QuoteApprovalsDisabled = {
  __typename?: 'QuoteApprovalsDisabled';
  /** Always true because GraphQL object types cannot be empty. Use __typename as the settings discriminator. */
  disabled: Scalars['Boolean']['output'];
};

export type QuoteArchiveInput = {
  quoteIds: Array<Scalars['ID']['input']>;
};

export type QuoteArchiveResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteArchiveResult;

export type QuoteArchiveResult = {
  __typename?: 'QuoteArchiveResult';
  responseType: ResponseType | '%future added value';
};

/** Returned when an approval mutation is called for an archived quote. */
export type QuoteArchivedError = {
  __typename?: 'QuoteArchivedError';
  /** Archived quote that cannot be modified. */
  quoteId: Scalars['ID']['output'];
  /** Response type. */
  responseType: ResponseType | '%future added value';
};

export type QuoteAttachment = Node & {
  __typename?: 'QuoteAttachment';
  /** Attachment MIME type e.g. application/pdf, image/jpeg etc. */
  contentType: Scalars['String']['output'];
  /** URL to download the attachment */
  downloadUrl: Scalars['AWSURL']['output'];
  /** Attachment file name */
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type QuoteAttachmentTypeNotSupportedError = {
  __typename?: 'QuoteAttachmentTypeNotSupportedError';
  /** The MIME type that is not supported (e.g. video/mp4). */
  contentType: Scalars['String']['output'];
};

/**
 * A comment attached to a single quote row (item or placeholder), authored
 * under a single role. At least one of `reason` or `freeText` is always
 * non-null (empty comments are rejected at write time).
 */
export type QuoteComment = Node & {
  __typename?: 'QuoteComment';
  createdAt: Scalars['AWSTimestamp']['output'];
  /** User who authored the comment. */
  createdBy: UserRef;
  /**
   * Voice under which the comment was written. Controls the same-role rule
   * on update and delete.
   */
  createdByRole: QuoteCommentRole | '%future added value';
  /**
   * Free-text content (up to 1024 characters). Null when the comment carries
   * no free text. Empty strings are normalized to null on write.
   */
  freeText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * Reason chosen from the role's reasonOptions at write time. Null when
   * the comment carries no reason (e.g. FreeTextOnly variant, or
   * ReasonAndFreeText with reason Optional and not submitted).
   */
  reason?: Maybe<QuoteCommentReason>;
  updatedAt: Scalars['AWSTimestamp']['output'];
  /**
   * User who most recently wrote the comment. Equal to `createdBy` until the
   * first edit. Use `updatedAt > createdAt` to detect whether the comment has
   * been edited.
   */
  updatedBy: UserRef;
};

export type QuoteCommentAddInput = {
  /** Content to submit. Validated against the role's active RoleCommentSettings. */
  content: QuoteCommentContentInput;
  /** Quote row (item or placeholder) the comment attaches to. */
  quoteItemId: Scalars['ID']['input'];
  /**
   * Voice under which the comment is written. The actor must satisfy the
   * matching role policy on the parent quote.
   */
  role: QuoteCommentRole | '%future added value';
};

export type QuoteCommentAddResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteArchivedError | QuoteCommentAddResult | QuoteCommentContentInvalidError | QuoteCommentRoleDisabledError;

/** Successful comment add result. */
export type QuoteCommentAddResult = {
  __typename?: 'QuoteCommentAddResult';
  /** The newly created comment. */
  comment: QuoteComment;
  responseType: ResponseType | '%future added value';
};

/**
 * Comment content payload. Whether each field is accepted, required, or
 * forbidden is governed by the role's active RoleCommentSettings:
 *
 * - `RoleCommentsReasonAndFreeText` — both fields accepted, each Required or
 *   Optional. When both fields are Optional, at-least-one must be non-empty.
 * - `RoleCommentsReasonOnly` — only `reasonKey` accepted (required);
 *   `freeText` must be null.
 * - `RoleCommentsFreeTextOnly` — only `freeText` accepted (required);
 *   `reasonKey` must be null.
 *
 * A submission with both fields null is always rejected.
 */
export type QuoteCommentContentInput = {
  /**
   * Free-text content (up to 1024 characters). Empty strings are normalized
   * to null on the server. Null when no free text is submitted.
   */
  freeText?: InputMaybe<Scalars['String']['input']>;
  /**
   * Stable reason key from the role's current reasonOptions. Null when no
   * reason is submitted.
   */
  reasonKey?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Returned when the submitted content does not satisfy the role's active
 * RoleCommentSettings: a Required field is missing, a Disallowed field is
 * present, both fields are null, or `reasonKey` is not in the role's
 * current `reasonOptions`.
 */
export type QuoteCommentContentInvalidError = {
  __typename?: 'QuoteCommentContentInvalidError';
  quoteId: Scalars['ID']['output'];
  responseType: ResponseType | '%future added value';
  /** Role under which the comment was submitted. */
  role: QuoteCommentRole | '%future added value';
};

/**
 * Returned when an update or delete is attempted under a role that does
 * not match the comment's `createdByRole`. Cross-role edits are never
 * allowed: an editor cannot touch a reviewer comment and vice versa.
 */
export type QuoteCommentCrossRoleEditError = {
  __typename?: 'QuoteCommentCrossRoleEditError';
  commentId: Scalars['ID']['output'];
  /** Role under which the comment was originally authored. */
  createdByRole: QuoteCommentRole | '%future added value';
  /** Role the caller acted under on the mutation input. */
  requestedRole: QuoteCommentRole | '%future added value';
  responseType: ResponseType | '%future added value';
};

export type QuoteCommentDeleteInput = {
  /** Comment to delete. Must have been authored under `role` (same-role rule). */
  commentId: Scalars['ID']['input'];
  /** Voice the caller is acting under. Must match the comment's createdByRole. */
  role: QuoteCommentRole | '%future added value';
};

export type QuoteCommentDeleteResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteArchivedError | QuoteCommentCrossRoleEditError | QuoteCommentDeleteResult | QuoteCommentRoleDisabledError;

/** Successful comment delete result. */
export type QuoteCommentDeleteResult = {
  __typename?: 'QuoteCommentDeleteResult';
  responseType: ResponseType | '%future added value';
};

/**
 * Reason carried by a comment. The `key` is the stable identifier the
 * comment was written against; `displayName` is the current label for that
 * key under the role's active reasonOptions, and may be null if the key is
 * no longer in the active options.
 */
export type QuoteCommentReason = {
  __typename?: 'QuoteCommentReason';
  /**
   * Current display label for the reason. Null when the key is no longer
   * present in the role's active reasonOptions; clients should fall back
   * to rendering the raw key.
   */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Stable supplier- and role-scoped identifier of the reason. */
  key: Scalars['String']['output'];
};

/**
 * A reason option exposed inside an active RoleCommentSettings. The `key`
 * is what gets persisted on a comment; the `displayName` is what the FE
 * renders.
 */
export type QuoteCommentReasonOption = {
  __typename?: 'QuoteCommentReasonOption';
  displayName: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

/**
 * Voice under which a comment is written. Selected explicitly on every
 * mutation input. A `SalesAdmin` who satisfies both editor and reviewer
 * policies chooses their voice here, rather than at the mutation-name level.
 */
export const QuoteCommentRole = {
  Editor: 'Editor',
  Reviewer: 'Reviewer'
} as const;

export type QuoteCommentRole = typeof QuoteCommentRole[keyof typeof QuoteCommentRole];
/**
 * Returned when a comment mutation is attempted under a role whose current
 * RoleCommentSettings on the quote are `RoleCommentsDisabled`.
 */
export type QuoteCommentRoleDisabledError = {
  __typename?: 'QuoteCommentRoleDisabledError';
  quoteId: Scalars['ID']['output'];
  responseType: ResponseType | '%future added value';
  /**
   * Role under which the mutation was attempted and which is currently
   * disabled on the quote.
   */
  role: QuoteCommentRole | '%future added value';
};

/**
 * Quote-scoped comment configuration. Editor and reviewer are configured
 * independently and may use different content shapes and different reason
 * taxonomies. Settings are resolved from supplier-level config at quote
 * read time.
 */
export type QuoteCommentSettings = {
  __typename?: 'QuoteCommentSettings';
  editor: RoleCommentSettings;
  reviewer: RoleCommentSettings;
};

export type QuoteCommentUpdateInput = {
  /** Comment to update. Must have been authored under `role` (same-role rule). */
  commentId: Scalars['ID']['input'];
  /**
   * Full replacement content. Both fields are always submitted (each may
   * be null); the resulting pair is re-validated against the role's current
   * RoleCommentSettings.
   */
  content: QuoteCommentContentInput;
  /** Voice the caller is acting under. Must match the comment's createdByRole. */
  role: QuoteCommentRole | '%future added value';
};

export type QuoteCommentUpdateResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteArchivedError | QuoteCommentContentInvalidError | QuoteCommentCrossRoleEditError | QuoteCommentRoleDisabledError | QuoteCommentUpdateResult;

/** Successful comment update result. */
export type QuoteCommentUpdateResult = {
  __typename?: 'QuoteCommentUpdateResult';
  /** The updated comment. */
  comment: QuoteComment;
  responseType: ResponseType | '%future added value';
};

export type QuoteConflictResolutionInput = {
  /** The quoteItemId to retain. All other items with the same vendorItemUnitId are removed. */
  quoteItemIdToKeep: Scalars['ID']['input'];
  /** The vendorItemUnitId identifying the duplicate group. */
  vendorItemUnitId: Scalars['ID']['input'];
};

export type QuoteConflictsResolveInput = {
  etag: Scalars['String']['input'];
  quoteId: Scalars['ID']['input'];
  resolutions: Array<QuoteConflictResolutionInput>;
};

export type QuoteConflictsResolveResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteConflictsResolveSuccessResult | QuoteConflictsResolveValidationError | QuoteUpdateEtagMismatchError;

export type QuoteConflictsResolveSuccessResult = {
  __typename?: 'QuoteConflictsResolveSuccessResult';
  responseType: ResponseType | '%future added value';
};

export type QuoteConflictsResolveValidationError = {
  __typename?: 'QuoteConflictsResolveValidationError';
  responseType: ResponseType | '%future added value';
  validationResult: QuoteConflictsResolveValidationFailedResult;
};

export type QuoteConflictsResolveValidationFailedResult = {
  __typename?: 'QuoteConflictsResolveValidationFailedResult';
  errors: Array<QuoteContainsDuplicateVendorItemsError>;
};

export type QuoteContainsDuplicateVendorItemsError = {
  __typename?: 'QuoteContainsDuplicateVendorItemsError';
  duplicates: Array<DuplicateVendorItemError>;
};

export type QuoteContainsMultipleCurrenciesError = {
  __typename?: 'QuoteContainsMultipleCurrenciesError';
  currencyCodes: Array<Scalars['String']['output']>;
};

/** Returned when quote submission is blocked by items that are still rejected. */
export type QuoteContainsRejectedItemsError = {
  __typename?: 'QuoteContainsRejectedItemsError';
  /** Quote that contains rejected items. */
  quoteId: Scalars['ID']['output'];
  /** Rejected quote items that must be edited before resubmission. */
  quoteItemIds: Array<Scalars['ID']['output']>;
  /** Response type. */
  responseType: ResponseType | '%future added value';
};

export type QuoteContainsUnmatchedQuoteItemsError = {
  __typename?: 'QuoteContainsUnmatchedQuoteItemsError';
  quoteItemPlaceholderIds: Array<Scalars['ID']['output']>;
};

export type QuoteCreateInput = {
  /** @deprecated Unused. Friendly name is generated server-side. */
  friendlyName?: InputMaybe<Scalars['String']['input']>;
  subject: QuoteCreateSubjectInput;
};

export type QuoteCreateResponse = AuthorizationFailure | InputValidationFailure | QuoteDetail;

export type QuoteCreateSubjectInput = {
  subjectId: Scalars['ID']['input'];
  subjectType: QuoteSubjectType | '%future added value';
};

export type QuoteCreatedByContext = QuoteCreatedByQuotingAi | QuoteCreatedByUser;

export type QuoteCreatedByQuotingAi = {
  __typename?: 'QuoteCreatedByQuotingAI';
  /** Reference to the QuotingAI job which created the quote. */
  jobId: Scalars['ID']['output'];
  /** Quoting AI extraction mode used to generate the quote. */
  quoteExtractionMode: QuoteExtractionMode | '%future added value';
};

export type QuoteCreatedByUser = {
  __typename?: 'QuoteCreatedByUser';
  /** Reference to the user which created this item. */
  userId: Scalars['ID']['output'];
};

export type QuoteDetail = Node & {
  __typename?: 'QuoteDetail';
  /** Approval flow availability for this quote. */
  approvalSettings: QuoteApprovalSettings;
  archived: Scalars['Boolean']['output'];
  attachments: Array<QuoteAttachment>;
  comment?: Maybe<Scalars['String']['output']>;
  /**
   * Per-role comment configuration for this quote. Resolved at read time
   * from supplier-level configuration and not versioned by the quote's etag:
   * config changes upstream are visible on the next read of existing quotes.
   */
  commentSettings: QuoteCommentSettings;
  createdByContext: QuoteCreatedByContext;
  /** Optimistic concurrency token. Must be supplied to quoteEditsSubmit and quoteConflictsResolve. */
  etag: Scalars['String']['output'];
  friendlyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: QuoteDetailItems;
  /**
   * Reviewer who most recently submitted review for this quote.
   * Absent until the first review submission.
   */
  lastReviewer?: Maybe<UserRef>;
  /** Absent if the quote has never been user-edited. */
  lastUserEditAt?: Maybe<TimestampAndTimezone>;
  /** Margin data availability for this quote. */
  marginSettings: QuoteMarginSettings;
  origin: QuoteOrigin | '%future added value';
  quoteAggregationData: QuoteAggregationData;
  state: QuoteState | '%future added value';
  /** Point of extensibility. Supports both lead and customer subjects. */
  subject: QuoteSubjectRef;
  supplierId: Scalars['ID']['output'];
  validationResult: QuoteValidationResult;
};

export type QuoteDetailItem = Node & {
  __typename?: 'QuoteDetailItem';
  /**
   * Comments attached to this row across both roles, ordered ascending by
   * createdAt. Returned in full — no pagination, no per-row cap. Soft-deleted
   * comments are filtered out.
   */
  comments: Array<QuoteComment>;
  /** Cost used for quoting calculations for this item. */
  cost?: Maybe<MoneyV2>;
  /** Point of extensibility. Consumers should process the type explicitly. */
  createdByContext: QuoteItemCreatedByContext;
  id: Scalars['ID']['output'];
  linePrice: MoneyV2;
  /** Minimum margin configured for this item. */
  minMargin?: Maybe<Decimal>;
  quantity: Decimal;
  /** Approval state for this item. Null when quote approvals are disabled. */
  state?: Maybe<QuoteItemState | '%future added value'>;
  /** Target margin configured for this item. */
  targetMargin?: Maybe<Decimal>;
  unit: Scalars['String']['output'];
  vendorItemUnit: VendorItemUnitRef;
};

export type QuoteDetailItemMarginData = {
  __typename?: 'QuoteDetailItemMarginData';
  /**
   * Cost used for quoting calculations for the requested product in the context
   * of the requested quote.
   */
  cost?: Maybe<MoneyV2>;
  /** Minimum margin configured for the requested product. */
  minMargin?: Maybe<Decimal>;
  /** Target margin configured for the requested product. */
  targetMargin?: Maybe<Decimal>;
  vendorItemUnitId: Scalars['ID']['output'];
};

export type QuoteDetailItemMarginDataGetInput = {
  quoteId: Scalars['ID']['input'];
  vendorItemUnitIds: Array<Scalars['ID']['input']>;
};

export type QuoteDetailItemMarginDataGetResponse = AuthorizationFailure | InputValidationFailure | QuoteDetailItemMarginDataGetResult;

export type QuoteDetailItemMarginDataGetResult = {
  __typename?: 'QuoteDetailItemMarginDataGetResult';
  /**
   * Ordered to match the requested VendorItemUnit IDs so clients can merge the
   * response back into unsaved editor rows for the given quote without additional
   * bookkeeping.
   */
  marginData: Array<QuoteDetailItemMarginData>;
};

export type QuoteDetailItemPlaceholder = Node & {
  __typename?: 'QuoteDetailItemPlaceholder';
  /**
   * Comments attached to this row across both roles, ordered ascending by
   * createdAt. Returned in full — no pagination, no per-row cap. Soft-deleted
   * comments are filtered out.
   */
  comments: Array<QuoteComment>;
  /** Point of extensibility. Consumers should process the type explicitly. */
  createdByContext: QuoteItemCreatedByQuotingAi;
  id: Scalars['ID']['output'];
};

export type QuoteDetailItems = {
  __typename?: 'QuoteDetailItems';
  items: Array<QuoteDetailRow>;
};

export type QuoteDetailRow = QuoteDetailItem | QuoteDetailItemPlaceholder;

/** Exactly one field must be non-null, identifying which command variant to apply. */
export type QuoteEditCommandInput = {
  add?: InputMaybe<AddQuoteItemCommandInput>;
  remove?: InputMaybe<RemoveQuoteItemCommandInput>;
  update?: InputMaybe<UpdateQuoteItemCommandInput>;
  updateComment?: InputMaybe<UpdateQuoteCommentCommandInput>;
};

export type QuoteEditsEvaluateInput = {
  edits: Array<QuoteEditCommandInput>;
  etag: Scalars['String']['input'];
  quoteId: Scalars['ID']['input'];
};

export type QuoteEditsEvaluateResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteEditsEvaluateResult | QuoteUpdateEtagMismatchError;

export type QuoteEditsEvaluateResult = {
  __typename?: 'QuoteEditsEvaluateResult';
  quoteAggregationData: QuoteAggregationData;
  responseType: ResponseType | '%future added value';
  validationResult: QuoteValidationResult;
};

export type QuoteEditsSubmitInput = {
  edits: Array<QuoteEditCommandInput>;
  etag: Scalars['String']['input'];
  quoteId: Scalars['ID']['input'];
};

export type QuoteEditsSubmitResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteEditsSubmitResult | QuoteUpdateEtagMismatchError;

export type QuoteEditsSubmitResult = {
  __typename?: 'QuoteEditsSubmitResult';
  quoteAggregationData: QuoteAggregationData;
  responseType: ResponseType | '%future added value';
  validationResult: QuoteEditsSubmitValidationResult;
};

export type QuoteEditsSubmitValidationFailedResult = {
  __typename?: 'QuoteEditsSubmitValidationFailedResult';
  errors: Array<QuoteContainsDuplicateVendorItemsError>;
};

export type QuoteEditsSubmitValidationResult = QuoteEditsSubmitValidationFailedResult | QuoteValidationSuccessResult;

/** Returned when quote submission is attempted for a quote with no items. */
export type QuoteEmptyError = {
  __typename?: 'QuoteEmptyError';
  /** Empty quote that cannot be submitted. */
  quoteId: Scalars['ID']['output'];
  /** Response type. */
  responseType: ResponseType | '%future added value';
};

/**
 * Currency conversion parameters for a quote export. All three fields are required
 * together. Currencies are ISO 4217 codes; `exchangeRate` is a decimal string.
 */
export type QuoteExportCurrencyConversionInput = {
  exchangeRate: Scalars['String']['input'];
  sourceCurrency: Scalars['String']['input'];
  targetCurrency: Scalars['String']['input'];
};

/** Quote export output format. */
export const QuoteExportFormat = {
  Csv: 'Csv',
  /**
   * Upsert quote line prices as customer-specific prices and emit catalog
   * price-change events for successfully written prices.
   */
  Erp: 'Erp',
  Pdf: 'Pdf'
} as const;

export type QuoteExportFormat = typeof QuoteExportFormat[keyof typeof QuoteExportFormat];
/** Quoting AI extraction mode used to generate a quote. */
export const QuoteExtractionMode = {
  /** Extract products from a document (e.g. invoice) and match with product catalog. */
  Document: 'Document',
  /** Extract ingredients from a menu and match with product catalog. */
  Menu: 'Menu'
} as const;

export type QuoteExtractionMode = typeof QuoteExtractionMode[keyof typeof QuoteExtractionMode];
export type QuoteGenerationAttachmentDetail = Node & {
  __typename?: 'QuoteGenerationAttachmentDetail';
  /** Attachment MIME type e.g. application/pdf, image/jpeg etc. */
  contentType: Scalars['String']['output'];
  /** URL to download the attachment */
  downloadUrl: Scalars['AWSURL']['output'];
  /** Attachment file name */
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/**
 * Returned when one or more attachment uploads have not completed before calling
 * quoteGenerationJobStart. The client should retry uploading the listed files
 * and call quoteGenerationJobStart again.
 */
export type QuoteGenerationAttachmentUploadIncompleteError = {
  __typename?: 'QuoteGenerationAttachmentUploadIncompleteError';
  /** The fileIds for which no completed upload was found in S3. */
  fileIds: Array<Scalars['ID']['output']>;
};

/** Returned when quoteGenerationJobAttachmentUploadLinkCreate is called on a job that has already been started. */
export type QuoteGenerationJobAlreadyStartedError = {
  __typename?: 'QuoteGenerationJobAlreadyStartedError';
  jobId: Scalars['ID']['output'];
};

export type QuoteGenerationJobAttachmentUploadLink = {
  __typename?: 'QuoteGenerationJobAttachmentUploadLink';
  /**
   * Server-generated S3 key token. Not a domain entity ID.
   * Pass this to quoteGenerationJobStart after uploading.
   */
  fileId: Scalars['ID']['output'];
  uploadUrl: Scalars['AWSURL']['output'];
};

export type QuoteGenerationJobAttachmentUploadLinkCreateInput = {
  attachments: Array<QuoteGenerationJobAttachmentUploadLinkItemInput>;
  jobId: Scalars['ID']['input'];
};

export type QuoteGenerationJobAttachmentUploadLinkCreateResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteAttachmentTypeNotSupportedError | QuoteGenerationJobAlreadyStartedError | QuoteGenerationJobAttachmentUploadLinkCreateResult | QuoteGenerationJobAttachmentsAlreadySpecifiedError;

export type QuoteGenerationJobAttachmentUploadLinkCreateResult = {
  __typename?: 'QuoteGenerationJobAttachmentUploadLinkCreateResult';
  /** One entry per requested attachment, in input order. */
  links: Array<QuoteGenerationJobAttachmentUploadLink>;
};

export type QuoteGenerationJobAttachmentUploadLinkItemInput = {
  /** Attachment MIME type e.g. application/pdf, image/jpeg etc. */
  contentType: Scalars['String']['input'];
  /** Attachment file name */
  fileName: Scalars['String']['input'];
};

/** Returned when quoteGenerationJobStart is called more than once for the same job. */
export type QuoteGenerationJobAttachmentsAlreadySpecifiedError = {
  __typename?: 'QuoteGenerationJobAttachmentsAlreadySpecifiedError';
  jobId: Scalars['ID']['output'];
};

export type QuoteGenerationJobCreateInput = {
  /** Quoting AI extraction mode. When omitted, the server defaults to Document. */
  quoteExtractionMode?: InputMaybe<QuoteExtractionMode | '%future added value'>;
  subject: QuoteGenerationJobSubjectInput;
};

export type QuoteGenerationJobCreateResponse = AuthorizationFailure | InputValidationFailure | QuoteGenerationJobCreateResult;

export type QuoteGenerationJobCreateResult = {
  __typename?: 'QuoteGenerationJobCreateResult';
  jobId: Scalars['ID']['output'];
};

export type QuoteGenerationJobDetail = Node & {
  __typename?: 'QuoteGenerationJobDetail';
  attachments: Array<QuoteGenerationAttachmentDetail>;
  friendlyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: QuoteGenerationJobDetailStatus | '%future added value';
  /** Point of extensibility. Supports both lead and customer subjects. */
  subject: QuoteSubjectRef;
};

export const QuoteGenerationJobDetailStatus = {
  Draft: 'Draft',
  Failed: 'Failed',
  PermanentlyFailed: 'PermanentlyFailed',
  Running: 'Running',
  Succeeded: 'Succeeded'
} as const;

export type QuoteGenerationJobDetailStatus = typeof QuoteGenerationJobDetailStatus[keyof typeof QuoteGenerationJobDetailStatus];
export type QuoteGenerationJobFailedStatus = QuoteGenerationJobStatusCommon & {
  __typename?: 'QuoteGenerationJobFailedStatus';
  errors: Array<QuoteGenerationJobStatusError>;
  jobId: Scalars['ID']['output'];
};

export type QuoteGenerationJobPermanentlyFailedStatus = QuoteGenerationJobStatusCommon & {
  __typename?: 'QuoteGenerationJobPermanentlyFailedStatus';
  errors: Array<QuoteGenerationJobStatusError>;
  jobId: Scalars['ID']['output'];
};

export type QuoteGenerationJobRemoveInput = {
  jobId: Scalars['ID']['input'];
};

export type QuoteGenerationJobRemoveResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteGenerationJobRemoveResult;

export type QuoteGenerationJobRemoveResult = {
  __typename?: 'QuoteGenerationJobRemoveResult';
  responseType: ResponseType | '%future added value';
};

export type QuoteGenerationJobRetryInput = {
  jobId: Scalars['ID']['input'];
};

export type QuoteGenerationJobRetryResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteGenerationJobRetryResult;

export type QuoteGenerationJobRetryResult = {
  __typename?: 'QuoteGenerationJobRetryResult';
  responseType: ResponseType | '%future added value';
};

export type QuoteGenerationJobRunningStatus = QuoteGenerationJobStatusCommon & {
  __typename?: 'QuoteGenerationJobRunningStatus';
  jobId: Scalars['ID']['output'];
};

export type QuoteGenerationJobStartInput = {
  /**
   * All fileIds issued for this job via quoteGenerationJobAttachmentUploadLinkCreate.
   * Must be non-empty. This mutation may only be called once per job.
   */
  attachmentFileIds: Array<Scalars['ID']['input']>;
  jobId: Scalars['ID']['input'];
};

export type QuoteGenerationJobStartResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteGenerationAttachmentUploadIncompleteError | QuoteGenerationJobAlreadyStartedError | QuoteGenerationJobDetail;

export type QuoteGenerationJobStatus = QuoteGenerationJobFailedStatus | QuoteGenerationJobPermanentlyFailedStatus | QuoteGenerationJobRunningStatus | QuoteGenerationJobSucceededStatus;

/** Every status variant carries the jobId that it corresponds to. */
export type QuoteGenerationJobStatusCommon = {
  jobId: Scalars['ID']['output'];
};

export type QuoteGenerationJobStatusError = {
  __typename?: 'QuoteGenerationJobStatusError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type QuoteGenerationJobStatusesInput = {
  jobIds: Array<Scalars['ID']['input']>;
};

export type QuoteGenerationJobStatusesResponse = AuthorizationFailure | InputValidationFailure | QuoteGenerationJobStatusesResult;

export type QuoteGenerationJobStatusesResult = {
  __typename?: 'QuoteGenerationJobStatusesResult';
  jobStatuses: Array<QuoteGenerationJobStatus>;
};

export type QuoteGenerationJobSubjectInput = {
  subjectId: Scalars['ID']['input'];
  subjectType: QuoteGenerationJobSubjectType | '%future added value';
};

export const QuoteGenerationJobSubjectType = {
  Customer: 'Customer',
  Lead: 'Lead'
} as const;

export type QuoteGenerationJobSubjectType = typeof QuoteGenerationJobSubjectType[keyof typeof QuoteGenerationJobSubjectType];
export type QuoteGenerationJobSucceededStatus = QuoteGenerationJobStatusCommon & {
  __typename?: 'QuoteGenerationJobSucceededStatus';
  jobId: Scalars['ID']['output'];
  quoteId: Scalars['ID']['output'];
};

export type QuoteGetInput = {
  quoteId: Scalars['ID']['input'];
};

export type QuoteGetResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteDetail;

export type QuoteItemCreatedByContext = QuoteItemCreatedByQuotingAi | QuoteItemCreatedByUser;

export type QuoteItemCreatedByQuotingAi = {
  __typename?: 'QuoteItemCreatedByQuotingAI';
  /** Reference to the QuotingAI job which created this item. */
  jobId: Scalars['ID']['output'];
  /** Point of extensibility. Consumers should process the type explicitly. */
  quoteItemMatchMetadata: QuoteItemTextMatchMetadata;
};

export type QuoteItemCreatedByUser = {
  __typename?: 'QuoteItemCreatedByUser';
  userId: Scalars['ID']['output'];
};

/** Approval lifecycle state for a quote item. */
export const QuoteItemState = {
  /** Item was approved by automatic evaluation. */
  Approved: 'Approved',
  /** Item was approved by a reviewer despite requiring review. */
  ApprovedWithOverride: 'ApprovedWithOverride',
  /** Item has not been submitted into the approval flow. */
  Draft: 'Draft',
  /** Item is waiting for a review decision. */
  Pending: 'Pending',
  /** Item was rejected by a reviewer. */
  Rejected: 'Rejected'
} as const;

export type QuoteItemState = typeof QuoteItemState[keyof typeof QuoteItemState];
export type QuoteItemTextMatchMetadata = {
  __typename?: 'QuoteItemTextMatchMetadata';
  extractedText: Scalars['String']['output'];
  /**
   * The list of source menu items that were matched to create this quote item.
   * Populated only for menu-scan originated quote items (quote.origin === QuoteOrigin.MenuScan).
   */
  sourceMenuItems?: Maybe<Array<Scalars['String']['output']>>;
};

export type QuoteListConnection = Connection & {
  __typename?: 'QuoteListConnection';
  edges: Array<QuoteListEdge>;
  total: Scalars['Int']['output'];
};

export type QuoteListEdge = Edge & {
  __typename?: 'QuoteListEdge';
  cursor: Scalars['String']['output'];
  node: QuoteListItemNode;
};

export type QuoteListFilter = {
  /**
   * Filter quotes by archived status.
   * When absent, only non-archived quotes are returned.
   * QuoteGenerationJobs are only included when this value is absent or false.
   */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional scope to filter by assignee, i.e. only quotes/jobs scoped to
   * the provided user.
   * null indicates no filtering.
   * must be provided by supplier sales reps and set to their own userId
   */
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Allows filtering quotes by state, i.e. only quotes in a specified list of
   * states. Supports multiselect. Both no value and an empty array indicate no
   * filtering. QuoteGenerationJobs are excluded when this filter is provided.
   */
  stateFilter?: InputMaybe<Array<QuoteState | '%future added value'>>;
  /**
   * Optional scope to filter by a specific subject (lead or customer).
   * When set, only quotes/jobs for that exact subject are returned.
   */
  subject?: InputMaybe<QuoteListSubjectFilter>;
  /** Optional scope to filter by quote/job subject type. */
  subjectType?: InputMaybe<QuoteSubjectType | '%future added value'>;
};

export type QuoteListInput = {
  filter?: InputMaybe<QuoteListFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
};

export type QuoteListItem = QuoteListJobFailedEntry | QuoteListJobPermanentlyFailedEntry | QuoteListJobRunningEntry | QuoteListQuoteEntry;

export type QuoteListItemNode = Node & {
  __typename?: 'QuoteListItemNode';
  id: Scalars['ID']['output'];
  item: QuoteListItem;
};

/** Fields common to all job list entry variants. */
export type QuoteListJobEntry = {
  friendlyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Point of extensibility. Supports both lead and customer subjects. */
  subject: QuoteSubjectRef;
};

export type QuoteListJobEntryError = {
  __typename?: 'QuoteListJobEntryError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type QuoteListJobFailedEntry = Node & QuoteListJobEntry & {
  __typename?: 'QuoteListJobFailedEntry';
  errors: Array<QuoteListJobEntryError>;
  friendlyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Point of extensibility. Supports both lead and customer subjects. */
  subject: QuoteSubjectRef;
};

export type QuoteListJobPermanentlyFailedEntry = Node & QuoteListJobEntry & {
  __typename?: 'QuoteListJobPermanentlyFailedEntry';
  errors: Array<QuoteListJobEntryError>;
  friendlyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Point of extensibility. Supports both lead and customer subjects. */
  subject: QuoteSubjectRef;
};

export type QuoteListJobRunningEntry = Node & QuoteListJobEntry & {
  __typename?: 'QuoteListJobRunningEntry';
  friendlyName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Point of extensibility. Supports both lead and customer subjects. */
  subject: QuoteSubjectRef;
};

/**
 * Any entry of this type is considered "Ready" by the frontend — the presence of
 * QuoteListQuoteEntry in the union is itself the status discriminator.
 */
export type QuoteListQuoteEntry = Node & {
  __typename?: 'QuoteListQuoteEntry';
  archived: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  friendlyName: Scalars['String']['output'];
  /** Total gross profit for the quote. */
  grossProfit?: Maybe<MoneyV2>;
  id: Scalars['ID']['output'];
  /** Total number of quote items in the quote. */
  itemsCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Reviewer who most recently submitted review for this quote.
   * Absent until the first review submission.
   */
  lastReviewer?: Maybe<UserRef>;
  /** Absent if the quote has never been user-edited. */
  lastUserEditAt?: Maybe<TimestampAndTimezone>;
  /** Total margin for the quote. */
  margin?: Maybe<Decimal>;
  state: QuoteState | '%future added value';
  /** Point of extensibility. Supports both lead and customer subjects. */
  subject: QuoteSubjectRef;
};

export type QuoteListResponse = AuthorizationFailure | InputValidationFailure | QuoteListConnection;

export type QuoteListSubjectFilter = {
  subjectId: Scalars['ID']['input'];
  subjectType: QuoteSubjectType | '%future added value';
};

export type QuoteMarginItemCounts = {
  __typename?: 'QuoteMarginItemCounts';
  /** Number of quote items at or above target margin. */
  aboveTargetMargin: Scalars['Int']['output'];
  /** Number of quote items below target margin. */
  belowTargetMargin: Scalars['Int']['output'];
  /** Number of quote items without matched product or margin data. */
  unavailable: Scalars['Int']['output'];
};

/** Margin kinds that can be available for a quote. */
export const QuoteMarginKind = {
  /** Minimum margin. */
  MinMargin: 'MinMargin',
  /** Target margin. */
  TargetMargin: 'TargetMargin'
} as const;

export type QuoteMarginKind = typeof QuoteMarginKind[keyof typeof QuoteMarginKind];
/** Describes whether margin data is available for this quote. */
export type QuoteMarginSettings = QuoteMarginsActive | QuoteMarginsDisabled;

/** Margin data is enabled for this quote. */
export type QuoteMarginsActive = {
  __typename?: 'QuoteMarginsActive';
  /** Margin kinds with data available for this quote. */
  availableMargins: Array<QuoteMarginKind | '%future added value'>;
};

/** Margin data is disabled for this quote. */
export type QuoteMarginsDisabled = {
  __typename?: 'QuoteMarginsDisabled';
  /** Always true because GraphQL object types cannot be empty. Use __typename as the settings discriminator. */
  disabled: Scalars['Boolean']['output'];
};

/** Origin shows which API was used to create the quote. */
export const QuoteOrigin = {
  /** Quote was created via the legacy Document Scan API. */
  DocumentScan: 'DocumentScan',
  /** Quote was created via the legacy Menu Scan API. */
  MenuScan: 'MenuScan',
  /** Quote was created via the Quoting API . */
  Quoting: 'Quoting'
} as const;

export type QuoteOrigin = typeof QuoteOrigin[keyof typeof QuoteOrigin];
export type QuoteReviewApproveInput = {
  /** Quote item to approve with a reviewer override. */
  quoteItemId: Scalars['ID']['input'];
};

/** Exactly one field must be non-null, identifying which review decision to apply. */
export type QuoteReviewDecisionInput = {
  /** Approves the item with a reviewer override. */
  approve?: InputMaybe<QuoteReviewApproveInput>;
  /** Rejects the item with a supplier-configured reason. */
  reject?: InputMaybe<QuoteReviewRejectInput>;
};

/** Returned when review is submitted before all pending items have decisions. */
export type QuoteReviewIncompleteError = {
  __typename?: 'QuoteReviewIncompleteError';
  /** Pending quote items that still need a review decision. */
  pendingQuoteItemIds: Array<Scalars['ID']['output']>;
  /** Quote whose review is incomplete. */
  quoteId: Scalars['ID']['output'];
  /** Response type. */
  responseType: ResponseType | '%future added value';
};

export type QuoteReviewRejectInput = {
  /** Quote item to reject. */
  quoteItemId: Scalars['ID']['input'];
};

export type QuoteReviewSubmitInput = {
  /** Reviewer decisions to apply when review is submitted. */
  decisions: Array<QuoteReviewDecisionInput>;
  /** Optimistic concurrency token from the latest quote read. */
  etag: Scalars['String']['input'];
  /** Quote whose reviewer decisions are being submitted. */
  quoteId: Scalars['ID']['input'];
};

/** Returned when the quote state does not allow submitting review decisions. */
export type QuoteReviewSubmitInvalidStateError = {
  __typename?: 'QuoteReviewSubmitInvalidStateError';
  /** States from which review submission is allowed. */
  allowedStates: Array<QuoteState | '%future added value'>;
  /** Current quote state. */
  currentState: QuoteState | '%future added value';
  /** Quote that is in an invalid state for review submission. */
  quoteId: Scalars['ID']['output'];
  /** Response type. */
  responseType: ResponseType | '%future added value';
};

/** Response returned after submitting review for a quote. */
export type QuoteReviewSubmitResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteApprovalNotEnabledError | QuoteArchivedError | QuoteReviewIncompleteError | QuoteReviewSubmitInvalidStateError | QuoteReviewSubmitResult | QuoteUpdateEtagMismatchError;

/** Successful review submission result. */
export type QuoteReviewSubmitResult = {
  __typename?: 'QuoteReviewSubmitResult';
  /** Updated quote after review submission. */
  quote: QuoteDetail;
  /** Response type. */
  responseType: ResponseType | '%future added value';
};

/** Approval lifecycle state for a quote. */
export const QuoteState = {
  /** Quote is approved and ready for export. */
  Approved: 'Approved',
  /** Sales rep can edit the quote before submission. */
  Draft: 'Draft',
  /** Review rejected at least one item and the quote needs rep edits. */
  PendingEdits: 'PendingEdits',
  /** Quote has been submitted and is waiting for review. */
  PendingReview: 'PendingReview'
} as const;

export type QuoteState = typeof QuoteState[keyof typeof QuoteState];
export type QuoteSubjectRef = ChatRef | SalesFunnelLeadRef;

export const QuoteSubjectType = {
  Customer: 'Customer',
  Lead: 'Lead'
} as const;

export type QuoteSubjectType = typeof QuoteSubjectType[keyof typeof QuoteSubjectType];
export type QuoteSubmitForReviewInput = {
  /** Optimistic concurrency token from the latest quote read. */
  etag: Scalars['String']['input'];
  /** Quote to submit into the approval flow. */
  quoteId: Scalars['ID']['input'];
};

/** Returned when the quote state does not allow submitting the quote for review. */
export type QuoteSubmitForReviewInvalidStateError = {
  __typename?: 'QuoteSubmitForReviewInvalidStateError';
  /** States from which quote submission for review is allowed. */
  allowedStates: Array<QuoteState | '%future added value'>;
  /** Current quote state. */
  currentState: QuoteState | '%future added value';
  /** Quote that is in an invalid state for review submission. */
  quoteId: Scalars['ID']['output'];
  /** Response type. */
  responseType: ResponseType | '%future added value';
};

/** Response returned after submitting a quote into the approval flow. */
export type QuoteSubmitForReviewResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteApprovalNotEnabledError | QuoteArchivedError | QuoteContainsRejectedItemsError | QuoteEmptyError | QuoteSubmitForReviewInvalidStateError | QuoteSubmitForReviewResult | QuoteUpdateEtagMismatchError | QuoteValidationFailedResult;

/** Successful quote submission result. */
export type QuoteSubmitForReviewResult = {
  __typename?: 'QuoteSubmitForReviewResult';
  /** Updated quote after submission. */
  quote: QuoteDetail;
  /** Response type. */
  responseType: ResponseType | '%future added value';
};

export type QuoteUnarchiveInput = {
  quoteIds: Array<Scalars['ID']['input']>;
};

export type QuoteUnarchiveResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteUnarchiveResult;

export type QuoteUnarchiveResult = {
  __typename?: 'QuoteUnarchiveResult';
  responseType: ResponseType | '%future added value';
};

export type QuoteUpdateEtagMismatchError = {
  __typename?: 'QuoteUpdateEtagMismatchError';
  latestEtag: Scalars['String']['output'];
  submittedEtag: Scalars['String']['output'];
};

export type QuoteValidationError = QuoteContainsDuplicateVendorItemsError | QuoteContainsMultipleCurrenciesError | QuoteContainsUnmatchedQuoteItemsError;

export type QuoteValidationFailedResult = {
  __typename?: 'QuoteValidationFailedResult';
  errors: Array<QuoteValidationError>;
};

export type QuoteValidationResult = QuoteValidationFailedResult | QuoteValidationSuccessResult;

export type QuoteValidationSuccessResult = {
  __typename?: 'QuoteValidationSuccessResult';
  responseType: ResponseType | '%future added value';
};

/**
 * Exactly represents mathematical fraction: numerator/denominator.
 * Compared to Float does not have the precision issues when dealing with exact fractions.
 */
export type Rational = {
  __typename?: 'Rational';
  denominator: Scalars['Int']['output'];
  numerator: Scalars['Int']['output'];
};

export type ReconciliationRequestConfirmed = {
  __typename?: 'ReconciliationRequestConfirmed';
  name?: Maybe<Scalars['String']['output']>;
};

export type ReconciliationRequestPlan = {
  __typename?: 'ReconciliationRequestPlan';
  name: Scalars['String']['output'];
  plan: ReconciliationRequestPlanType | '%future added value';
  supplierId: Scalars['ID']['output'];
};

export type ReconciliationRequestPlanBySupplierIdNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'ReconciliationRequestPlanBySupplierIdNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export const ReconciliationRequestPlanType = {
  Free: 'free',
  Premium: 'premium'
} as const;

export type ReconciliationRequestPlanType = typeof ReconciliationRequestPlanType[keyof typeof ReconciliationRequestPlanType];
/** Represents a rectangular geometry defined by two cartesian coordinate points. */
export type RectangleGeometry = {
  __typename?: 'RectangleGeometry';
  /** The "top right" coordinate of the rectangle. */
  northeast: Coordinate;
  /** The "bottom left" coordinate of the rectangle. */
  southwest: Coordinate;
};

export const RedemptionStatus = {
  Failed: 'FAILED',
  Pending: 'PENDING',
  PointsDeducted: 'POINTS_DEDUCTED',
  Redeemed: 'REDEEMED',
  ReversalFailed: 'REVERSAL_FAILED',
  Reversed: 'REVERSED'
} as const;

export type RedemptionStatus = typeof RedemptionStatus[keyof typeof RedemptionStatus];
/**
 * This interface defines a common schema for the reference objects.
 * A reference object can be used when there is a many-to-one relationship between entities,
 * and only the ID of the referenced object is known.
 *
 * For example:
 * If a Chat entity has a link to a Supplier, the Chat type could have
 * a field "supplier: SupplierRef" where "SupplierRef implements RefEdge".
 * The query that returns a Chat will only return "supplier: { id: chat.supplierId }" and not the full Supplier object.
 * The full Supplier object can be queried through "node" field of the "SupplierRef".
 * The resolver for the "node" field would be implemented in the supplier service.
 *
 * Using this pattern brings two benefits:
 * 1. Performance control. If the client only needs Id, it can decide not to query the "node" field.
 * 2. Domain separation. We don't need to implement the "Chat.supplier" resolver in the supplier service,
 *   and therefore keep the Supplier service unaware of the existence of the Chat›.
 */
export type RefEdge = {
  /** The ID of the referenced object */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<Node>;
};

export type ReferUserChatExists = AppsyncError & AppsyncResponse & {
  __typename?: 'ReferUserChatExists';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type ReferUserInput = {
  chat: ChatCreateInput;
  referralCode: Scalars['String']['input'];
};

export type ReferUserReferralCodeNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'ReferUserReferralCodeNotFound';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type ReferUserResponse = AuthorizationFailure | InputValidationFailure | ReferUserChatExists | ReferUserReferralCodeNotFound | ReferUserResult;

export type ReferUserResult = {
  __typename?: 'ReferUserResult';
  chat: Chat;
  cursor: Scalars['String']['output'];
  referralCode: Scalars['String']['output'];
  referredUserId: Scalars['ID']['output'];
  referrerUserId: Scalars['ID']['output'];
};

export type Referral = {
  __typename?: 'Referral';
  referralCode: Scalars['String']['output'];
  referralLink: Scalars['String']['output'];
  referrerUserId: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
  supplier?: Maybe<Supplier>;
};

export type ReferralCodeGenerationError = AppsyncError & AppsyncResponse & {
  __typename?: 'ReferralCodeGenerationError';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type Refund = {
  __typename?: 'Refund';
  amount: MoneyV2;
  invoiceId: Scalars['ID']['output'];
  refundType: RefundType | '%future added value';
};

export const RefundType = {
  Full: 'full',
  Partial: 'partial'
} as const;

export type RefundType = typeof RefundType[keyof typeof RefundType];
export type RefundsListFailure = {
  __typename?: 'RefundsListFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type RefundsListInput = {
  invoiceIds: Array<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type RefundsListResponse = AuthorizationFailure | InputValidationFailure | RefundsListFailure | RefundsListSuccess;

export type RefundsListSuccess = {
  __typename?: 'RefundsListSuccess';
  refunds: Array<Refund>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type RejectOrderInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type RejectOrderResponse = AuthorizationFailure | InputValidationFailure | OrderRejected;

export type RejectOrdersByIdInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type RejectOrdersByIdResponse = AuthorizationFailure | InputValidationFailure | OrdersRejected;

export type RemoveCcEmailFromChatsReport = {
  __typename?: 'RemoveCCEmailFromChatsReport';
  numberOfChatsUpdated: Scalars['Int']['output'];
};

export type RemoveEmailFromBuyerReportScheduleResponse = AuthorizationFailure | BuyerReportScheduleNotFound | EmailFromBuyerReportScheduleRemoved | EmailInBuyerReportScheduleNotFound | InputValidationFailure;

export type RemoveOrderDeskEmail = {
  email: Scalars['String']['input'];
  supplierId: Scalars['ID']['input'];
  type: OrderDestEmailListType | '%future added value';
};

export type RemoveProductsFromOrderGuidesInput = {
  chatIds: Array<Scalars['ID']['input']>;
  productIds: Array<Scalars['ID']['input']>;
  sourceChatId: Scalars['ID']['input'];
};

export type RemoveProductsFromOrderGuidesResponse = AuthorizationFailure | InputValidationFailure | RemoveProductsFromOrderGuidesResult;

export type RemoveProductsFromOrderGuidesResult = AppsyncResponse & {
  __typename?: 'RemoveProductsFromOrderGuidesResult';
  locations: Array<LocationProductsResult>;
  responseType: ResponseType | '%future added value';
  transactionId: Scalars['String']['output'];
};

export type RemoveQuoteItemCommandInput = {
  quoteItemId: Scalars['ID']['input'];
};

export type RemoveSupplierBuyerMovInput = {
  buyerId: Scalars['String']['input'];
  supplierEntityId: Scalars['String']['input'];
};

export type RenameSalesFunnelStateInput = {
  newName: Scalars['String']['input'];
  salesFunnelStateId: Scalars['ID']['input'];
};

export type RenameSalesFunnelStateResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | SalesFunnelDefinition;

export type ReopenQuoteInput = {
  /** Optimistic concurrency token from the latest quote read. */
  etag: Scalars['String']['input'];
  /** Settled quote to reopen for edits. */
  quoteId: Scalars['ID']['input'];
};

/** Returned when the quote state does not allow reopening the quote. */
export type ReopenQuoteInvalidStateError = {
  __typename?: 'ReopenQuoteInvalidStateError';
  /** States from which reopening is allowed. */
  allowedStates: Array<QuoteState | '%future added value'>;
  /** Current quote state. */
  currentState: QuoteState | '%future added value';
  /** Quote that is in an invalid state for reopening. */
  quoteId: Scalars['ID']['output'];
  /** Response type. */
  responseType: ResponseType | '%future added value';
};

/** Response returned after reopening a settled quote for edits. */
export type ReopenQuoteResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | QuoteApprovalNotEnabledError | QuoteArchivedError | QuoteUpdateEtagMismatchError | ReopenQuoteInvalidStateError | ReopenQuoteResult;

/** Successful quote reopen result. */
export type ReopenQuoteResult = {
  __typename?: 'ReopenQuoteResult';
  /** Updated quote after reopening. */
  quote: QuoteDetail;
  /** Response type. */
  responseType: ResponseType | '%future added value';
};

export type ReplacedProduct = {
  __typename?: 'ReplacedProduct';
  chatProduct?: Maybe<Product>;
  vendorItemUnit?: Maybe<VendorItemUnitRef>;
};

export type ReprocessTransmissionInput = {
  id: Scalars['ID']['input'];
};

export type ReprocessTransmissionResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | TransmissionReprocessStarted;

export type RequestToJoinBuyerError = AppsyncError & AppsyncResponse & {
  __typename?: 'RequestToJoinBuyerError';
  errorCode?: Maybe<RequestToJoinBuyerErrorCode | '%future added value'>;
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export const RequestToJoinBuyerErrorCode = {
  BuyerNotFoundError: 'buyerNotFoundError',
  GenericError: 'genericError',
  UserIsAlreadyConnectedToBuyerError: 'userIsAlreadyConnectedToBuyerError'
} as const;

export type RequestToJoinBuyerErrorCode = typeof RequestToJoinBuyerErrorCode[keyof typeof RequestToJoinBuyerErrorCode];
export type RequestToJoinBuyerResponse = AuthorizationFailure | RequestToJoinBuyerError | UserRequestToJoin;

export type RequestedChatActivated = {
  __typename?: 'RequestedChatActivated';
  name?: Maybe<Scalars['String']['output']>;
};

export type RequestedChatCreated = {
  __typename?: 'RequestedChatCreated';
  name?: Maybe<Scalars['String']['output']>;
};

export type RequestsToJoinConnection = Connection & {
  __typename?: 'RequestsToJoinConnection';
  edges: Array<UserRequestToJoinEdge>;
  total: Scalars['Int']['output'];
};

export type RerankedLineItemProducts = {
  __typename?: 'RerankedLineItemProducts';
  lineItemId: Scalars['ID']['output'];
  products: Array<RerankedProduct>;
};

export type RerankedProduct = {
  __typename?: 'RerankedProduct';
  /** @deprecated Not returned anymore. Use `vendorItemUnit` instead */
  product?: Maybe<Product>;
  rankedOrder: Scalars['Int']['output'];
  vendorItemUnit?: Maybe<VendorItemUnitRef>;
};

export const ResponseType = {
  Error: 'error',
  Success: 'success'
} as const;

export type ResponseType = typeof ResponseType[keyof typeof ResponseType];
export type RetryOrderProcessingResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | OrderProcessingRetrying;

export const ReviewReason = {
  AutoPilotDisabledForCustomer: 'autoPilotDisabledForCustomer',
  AutoPilotDisabledForSupplier: 'autoPilotDisabledForSupplier',
  AutoPilotNotEnabled: 'autoPilotNotEnabled',
  AutopilotThresholdNotSet: 'autopilotThresholdNotSet',
  ChatMatching: 'chatMatching',
  CustomFeatureFlag: 'customFeatureFlag',
  CustomerMatching: 'customerMatching',
  CutOffTimeMatching: 'cutOffTimeMatching',
  DeliveryDateMatching: 'deliveryDateMatching',
  InternalError: 'internalError',
  IsDuplicateOrder: 'isDuplicateOrder',
  IsMultiOrder: 'isMultiOrder',
  IsReprocessedOrder: 'isReprocessedOrder',
  LowConfidenceLevel: 'lowConfidenceLevel',
  MinimumOrderQuantityConstraint: 'minimumOrderQuantityConstraint',
  MinimumOrderValueConstraint: 'minimumOrderValueConstraint',
  OrderMissingVoiceCallConfirmation: 'orderMissingVoiceCallConfirmation',
  ProductAvailability: 'productAvailability',
  ProductMatching: 'productMatching',
  ReviewRequired: 'reviewRequired',
  SelectedForCalibration: 'selectedForCalibration',
  Unexpected: 'unexpected',
  UnexpectedlyHighProductQuantity: 'unexpectedlyHighProductQuantity'
} as const;

export type ReviewReason = typeof ReviewReason[keyof typeof ReviewReason];
export const Role = {
  SupplierAdmins: 'supplierAdmins',
  SupplierSalesReps: 'supplierSalesReps'
} as const;

export type Role = typeof Role[keyof typeof Role];
/**
 * Whether a field must be supplied on a comment under the
 * `RoleCommentsReasonAndFreeText` variant.
 */
export const RoleCommentFieldRequirement = {
  Optional: 'Optional',
  Required: 'Required'
} as const;

export type RoleCommentFieldRequirement = typeof RoleCommentFieldRequirement[keyof typeof RoleCommentFieldRequirement];
/**
 * Settings for a single role on a single quote. Use __typename to discriminate:
 *
 * - `RoleCommentsDisabled` — the role has no comment surface; mutations under
 *   this role are rejected, but existing comments authored while the role
 *   was active still surface in reads.
 * - `RoleCommentsReasonAndFreeText` — both `reason` and `freeText` are accepted
 *   on comments. Each is independently Required or Optional. When both are
 *   Optional, at-least-one of the two must still be non-empty at submission.
 * - `RoleCommentsReasonOnly` — only `reason` is accepted (required); `freeText`
 *   on submissions is rejected.
 * - `RoleCommentsFreeTextOnly` — only `freeText` is accepted (required); `reason`
 *   on submissions is rejected.
 *
 * The active variants are conceptually grouped as "RoleCommentsActive"; the
 * union is flat at the wire level because GraphQL unions cannot contain other
 * unions.
 */
export type RoleCommentSettings = RoleCommentsDisabled | RoleCommentsFreeTextOnly | RoleCommentsReasonAndFreeText | RoleCommentsReasonOnly;

/**
 * The role has no comment surface on this quote. All add/update/delete
 * mutations under this role are rejected; existing comments still surface
 * in reads.
 */
export type RoleCommentsDisabled = {
  __typename?: 'RoleCommentsDisabled';
  /** Always true because GraphQL object types cannot be empty. Use __typename as the settings discriminator. */
  disabled: Scalars['Boolean']['output'];
};

/** Comments under this role must carry free text and must not carry a reason. */
export type RoleCommentsFreeTextOnly = {
  __typename?: 'RoleCommentsFreeTextOnly';
  /** Always true because GraphQL object types cannot be empty. Use __typename as the settings discriminator. */
  freeTextOnly: Scalars['Boolean']['output'];
};

/**
 * Both reason and free text are accepted on comments under this role.
 * Each field is independently Required or Optional. When both are Optional,
 * the universal at-least-one content rule still applies (empty comments
 * are rejected).
 */
export type RoleCommentsReasonAndFreeText = {
  __typename?: 'RoleCommentsReasonAndFreeText';
  freeTextRequirement: RoleCommentFieldRequirement | '%future added value';
  /** Non-empty list of reason options the comment author may pick from. */
  reasonOptions: Array<QuoteCommentReasonOption>;
  reasonRequirement: RoleCommentFieldRequirement | '%future added value';
};

/**
 * Comments under this role must carry a reason from `reasonOptions` and
 * must not carry free text.
 */
export type RoleCommentsReasonOnly = {
  __typename?: 'RoleCommentsReasonOnly';
  /** Non-empty list of reason options the comment author may pick from. */
  reasonOptions: Array<QuoteCommentReasonOption>;
};

export type SafelistTwilioUserFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'SafelistTwilioUserFailure';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type SafelistTwilioUserResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | SafelistTwilioUserFailure | SafelistTwilioUserSuccess;

export type SafelistTwilioUserSuccess = {
  __typename?: 'SafelistTwilioUserSuccess';
  message: Scalars['String']['output'];
};

export type SalesFunnelAlreadyExistsError = {
  __typename?: 'SalesFunnelAlreadyExistsError';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type SalesFunnelDefinition = {
  __typename?: 'SalesFunnelDefinition';
  /** ID of the sales funnel */
  id: Scalars['ID']['output'];
  /** Definition of the state in which a new lead is created. */
  initialSalesFunnelState: SalesFunnelState;
  /** Display name of the sales funnel */
  name: Scalars['String']['output'];
  states: Array<SalesFunnelState>;
};

/** A lead in the sales funnel */
export type SalesFunnelLead = Node & {
  __typename?: 'SalesFunnelLead';
  /** The sales rep assigned to this lead */
  assignee?: Maybe<User>;
  /** The user ID of the sales rep assigned to this lead */
  assigneeUserId?: Maybe<Scalars['ID']['output']>;
  /** Business address for the lead. */
  businessAddress: Scalars['String']['output'];
  /** The name of the contact person at the business */
  businessContactName?: Maybe<Scalars['String']['output']>;
  /** The email of the business */
  businessEmail?: Maybe<Scalars['String']['output']>;
  /** The name of the business */
  businessName: Scalars['String']['output'];
  /** The phone number of the business */
  businessPhoneNumber?: Maybe<Scalars['String']['output']>;
  /**
   * The latest version of the comment on the lead.
   * Can be updated by anyone.
   */
  comment?: Maybe<SalesFunnelLeadComment>;
  /** The date the lead was created */
  createdAt: Scalars['AWSTimestamp']['output'];
  /** The name for the lead which should be displayed to the user */
  displayName: Scalars['String']['output'];
  /** Document scans associated with the lead, if they exist. */
  documentScans?: Maybe<DocumentScanConnection>;
  id: Scalars['ID']['output'];
  /** Whether the lead is archived or not */
  isArchived: Scalars['Boolean']['output'];
  /** Location data for the lead */
  location: SalesFunnelLeadLocation;
  /** Menu scans associated with the lead, if they exist. */
  menuScans?: Maybe<MenuScanConnection>;
  /**
   * A note associated with the lead. It is up to backend policy to determine
   * which note this is. Null if and only if there is no note attached to the
   * lead.
   */
  note?: Maybe<DistributorNote>;
  /** The revenue of the lead */
  revenue?: Maybe<MoneyV2>;
  /** The associated sales funnel. */
  salesFunnel?: Maybe<SalesFunnelDefinition>;
  /** The ID of the sales funnel this lead is in */
  salesFunnelId: Scalars['ID']['output'];
  /** The current state of the lead */
  salesFunnelState: SalesFunnelState;
  /** The unique identifier for the lead's current state. */
  salesFunnelStateId: Scalars['ID']['output'];
  /**
   * A task associated with the lead. It is up to backend policy to determine
   * which task this is.
   */
  task?: Maybe<DistributorTask>;
  /** The date the lead was last updated */
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type SalesFunnelLeadComment = {
  __typename?: 'SalesFunnelLeadComment';
  /** The date the comment was created. */
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  /** The comment text. */
  text: Scalars['String']['output'];
  /** The date the comment was last updated. */
  updatedAt: Scalars['AWSTimestamp']['output'];
  /** The user who last updated the comment. */
  updatedBy: User;
};

/** Columns available for a sales funnel lead export. */
export const SalesFunnelLeadExportColumn = {
  Assignee: 'Assignee',
  BusinessAddress: 'BusinessAddress',
  BusinessContactName: 'BusinessContactName',
  BusinessEmail: 'BusinessEmail',
  BusinessName: 'BusinessName',
  BusinessPhoneNumber: 'BusinessPhoneNumber',
  Comment: 'Comment',
  CreatedAt: 'CreatedAt',
  DistributorNotes: 'DistributorNotes',
  LastActivityAt: 'LastActivityAt',
  LeadRevenue: 'LeadRevenue',
  SalesFunnelState: 'SalesFunnelState',
  Tasks: 'Tasks',
  UpdatedAt: 'UpdatedAt'
} as const;

export type SalesFunnelLeadExportColumn = typeof SalesFunnelLeadExportColumn[keyof typeof SalesFunnelLeadExportColumn];
/** File format for a sales funnel lead export. */
export const SalesFunnelLeadExportFormat = {
  Csv: 'Csv',
  Xlsx: 'Xlsx'
} as const;

export type SalesFunnelLeadExportFormat = typeof SalesFunnelLeadExportFormat[keyof typeof SalesFunnelLeadExportFormat];
/**
 * Filters for sales funnel leads. Fields are combined with AND. Values within an
 * array are combined with OR. An omitted field or empty array does not filter.
 */
export type SalesFunnelLeadFilterInput = {
  /**
   * Filter by assignee. Supplier sales representatives may only request their own
   * user ID; omitting this field also limits them to their own leads.
   */
  assigneeFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by geographic criteria. */
  geographicFilter?: InputMaybe<SalesFunnelLeadGeographicFilterInput>;
  /** Filter by the lead's archive status. */
  isArchivedFilter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by free-text search. */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** Filter by sales funnel state. */
  stateIdFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A lead in the sales funnel for the map. Contains a reduced set of fields which are visible to all sales */
export type SalesFunnelLeadForMap = Node & {
  __typename?: 'SalesFunnelLeadForMap';
  /** The user ID of the sales rep assigned to this lead */
  assigneeUserId?: Maybe<Scalars['ID']['output']>;
  /** Business address for the lead. */
  businessAddress: Scalars['String']['output'];
  /** The name for the lead which should be displayed to the user */
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Whether the lead is archived or not */
  isArchived: Scalars['Boolean']['output'];
  /** Location data for the lead */
  location: SalesFunnelLeadLocation;
};

/**
 * Encapsulates input for filtering leads by geographic location.
 * Exactly one of the fields must be provided.
 */
export type SalesFunnelLeadGeographicFilterInput = {
  /** Filter to limit leads to those within a bounding circle. */
  boundingCircleInput?: InputMaybe<BoundingCircleInput>;
  /** Filter to limit leads to those within a bounding rectangle. */
  boundingRectangleInput?: InputMaybe<BoundingRectangleInput>;
};

export type SalesFunnelLeadGeographicIdentifier = SalesFunnelLeadGooglePlace;

export type SalesFunnelLeadGeographicIdentifierInput = {
  type: GeographicIdentifierInputType | '%future added value';
  value: Scalars['String']['input'];
};

export type SalesFunnelLeadGooglePlace = {
  __typename?: 'SalesFunnelLeadGooglePlace';
  googlePlaceId: Scalars['String']['output'];
};

/** Location data for a lead. */
export type SalesFunnelLeadLocation = {
  __typename?: 'SalesFunnelLeadLocation';
  /** Coordinates of the lead */
  coordinates: Coordinate;
  /** The external geographic identifier with which the lead was made. */
  geographicIdentifier: SalesFunnelLeadGeographicIdentifier;
};

/** A reference to a sales funnel lead. */
export type SalesFunnelLeadRef = Node & RefEdge & {
  __typename?: 'SalesFunnelLeadRef';
  /** Id of the referenced sales funnel lead */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual sales funnel lead by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<SalesFunnelLead>;
};

/** Represents a state transition for a lead in the sales funnel. */
export type SalesFunnelLeadTransition = Node & {
  __typename?: 'SalesFunnelLeadTransition';
  /** The sales rep who performed the transition. */
  assignee?: Maybe<User>;
  /** The user ID of the sales rep who performed the transition. */
  assigneeUserId?: Maybe<Scalars['ID']['output']>;
  /** The date of the transition. */
  date: Scalars['AWSTimestamp']['output'];
  /** The state the lead transitioned to. */
  endSalesFunnelState: SalesFunnelState;
  /** The ID of the lead transition. */
  id: Scalars['ID']['output'];
  /** The lead that transitioned. */
  lead: SalesFunnelLeadTransitionLead;
  /** The state the lead was in before the transition. */
  startSalesFunnelState?: Maybe<SalesFunnelState>;
};

/** A minimal representation of a lead for transitions. */
export type SalesFunnelLeadTransitionLead = {
  __typename?: 'SalesFunnelLeadTransitionLead';
  /** Business address for the lead. */
  businessAddress: Scalars['String']['output'];
  /** The name for the lead which should be displayed to the user. */
  displayName: Scalars['String']['output'];
  /** The ID of the lead. */
  id: Scalars['ID']['output'];
};

/** Represents an prospect in the prospect search response. */
export type SalesFunnelProspect = {
  __typename?: 'SalesFunnelProspect';
  /** Attribution data for the prospect. If this is non-empty, it MUST be shown. */
  attributions?: Maybe<Array<Maybe<SalesFunnelProspectDataAttribution>>>;
  /** Business status of the prospect. */
  businessStatus?: Maybe<BusinessStatus | '%future added value'>;
  /** The existing account that is associated with the prospect, if it exists. */
  connectedBuyer?: Maybe<SalesFunnelProspectConnectedBuyer>;
  /** The existing lead that is associated with the prospect, if it exists. */
  connectedLead?: Maybe<SalesFunnelProspectConnectedLead>;
  displayName: Scalars['String']['output'];
  /** Localized address of the prospect */
  formattedAddress?: Maybe<Scalars['String']['output']>;
  /** Place ID from Google Places API. */
  googlePlaceId: Scalars['String']['output'];
  /**
   * Name of the place resource from Google Places API. Has format 'places/{placeId}'.
   * This is not the display name.
   */
  googlePlaceName: Scalars['String']['output'];
  /** International phone number of the prospect. Localized. */
  internationalPhoneNumber?: Maybe<Scalars['String']['output']>;
  location: Coordinate;
  /** Open now status of the prospect */
  openNow?: Maybe<Scalars['Boolean']['output']>;
  /** Contains details about opening hours. */
  openingHours?: Maybe<OpeningHours>;
  /** Photos of the prospect. */
  photos?: Maybe<Array<Maybe<SalesFunnelProspectPhoto>>>;
  /** Price level of the prospect. */
  priceLevel?: Maybe<PriceLevel | '%future added value'>;
  /** An element of the types array that is considered the primary type. This is not localized. */
  primaryType?: Maybe<Scalars['String']['output']>;
  /** Localized display name of the primary type. */
  primaryTypeDisplayName?: Maybe<Scalars['String']['output']>;
  /** Aggregate rating of the prospect. */
  rating?: Maybe<Scalars['Float']['output']>;
  /** Summary of the prospect. Localized. */
  summary?: Maybe<Scalars['String']['output']>;
  /** Types of the prospect. These are not localized. */
  types: Array<Scalars['String']['output']>;
  /** Number of user ratings for the prospect. */
  userRatingCount?: Maybe<Scalars['Int']['output']>;
  /** The viewport that contains the prospect. */
  viewport?: Maybe<RectangleGeometry>;
  /** Website of the prospect. */
  website?: Maybe<Scalars['String']['output']>;
};

/** Represents an existing account in the prospect search response. */
export type SalesFunnelProspectConnectedBuyer = {
  __typename?: 'SalesFunnelProspectConnectedBuyer';
  /** The buyer ID of the existing account. */
  buyerId: Scalars['ID']['output'];
};

/** Represents an existing lead in the prospect search response. */
export type SalesFunnelProspectConnectedLead = {
  __typename?: 'SalesFunnelProspectConnectedLead';
  /** The supplier ID of the existing lead. */
  lead: SalesFunnelLeadForMap;
  /** The lead ID of the existing lead. */
  leadId: Scalars['ID']['output'];
};

/** Represents the attribution data for an prospect. */
export type SalesFunnelProspectDataAttribution = {
  __typename?: 'SalesFunnelProspectDataAttribution';
  /** The name of the provider of the prospect. */
  provider?: Maybe<Scalars['String']['output']>;
  /** The URI of the provider. */
  providerUri?: Maybe<Scalars['String']['output']>;
};

/** Represents a photo of an prospect. */
export type SalesFunnelProspectPhoto = {
  __typename?: 'SalesFunnelProspectPhoto';
  /** The attribution data for the photo. */
  attributions?: Maybe<Array<Maybe<SalesFunnelProspectPhotoAttribution>>>;
  /** The height of the photo in pixels. */
  heightPx?: Maybe<Scalars['Int']['output']>;
  resource: GoogleProspectPhotoDetails;
  /** The width of the photo in pixels. */
  widthPx?: Maybe<Scalars['Int']['output']>;
};

/** Represents the attribution data for an prospect photo. */
export type SalesFunnelProspectPhotoAttribution = {
  __typename?: 'SalesFunnelProspectPhotoAttribution';
  /** The name of the provider. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The URI of the profile photo of the provider. */
  photoUri?: Maybe<Scalars['String']['output']>;
  /** The URI of the provider. */
  uri?: Maybe<Scalars['String']['output']>;
};

export type SalesFunnelProspectsMetadata = {
  __typename?: 'SalesFunnelProspectsMetadata';
  /** The boundingRectangle that contains all the prospects. */
  boundingRectangle?: Maybe<RectangleGeometry>;
};

/** Represents the response for a prospect search query. */
export type SalesFunnelProspectsResults = {
  __typename?: 'SalesFunnelProspectsResults';
  /** Metadata about the prospects. */
  metadata?: Maybe<SalesFunnelProspectsMetadata>;
  /** The prospects that match the query. */
  prospects: Array<SalesFunnelProspect>;
};

/** A state in the sales funnel */
export type SalesFunnelState = {
  __typename?: 'SalesFunnelState';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** The style of the state as it is displayed on the frontend. */
  style: SalesFunnelStyle;
  /**
   * Thin-client version - tell clients what next valid state is so
   * they don't have to implicitly compute it based on order of states
   * on the Funnel definition.
   */
  validNextStates: Array<Scalars['ID']['output']>;
};

/** Defines the color of the chip (RGBA in hex) used to display the sales funnel state. */
export type SalesFunnelStateHexColor = {
  __typename?: 'SalesFunnelStateHexColor';
  /** The background color of the chip in hex format. */
  color: Scalars['String']['output'];
};

/** Returned when a state cannot be deactivated because it still holds leads. */
export type SalesFunnelStateNotEmptyError = {
  __typename?: 'SalesFunnelStateNotEmptyError';
  /** Number of leads currently in the state. */
  leadCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

/** The statistics for a sales funnel state. */
export type SalesFunnelStateStatistics = {
  __typename?: 'SalesFunnelStateStatistics';
  /** The number of leads in this state. */
  count: Scalars['Int']['output'];
  /** The ID of the state. */
  id: Scalars['ID']['output'];
  /** The name of the state. */
  name: Scalars['String']['output'];
  /** The total revenue value for leads in this state. */
  revenueValue?: Maybe<MoneyV2>;
  /** The style of the state as it is displayed on the frontend. */
  style: SalesFunnelStyle;
};

/** The statistics for a sales funnel state in the history response. */
export type SalesFunnelStateStatisticsHistory = {
  __typename?: 'SalesFunnelStateStatisticsHistory';
  /** The number of leads in this state. */
  count: Scalars['Int']['output'];
  /** The ID of the state. */
  id: Scalars['ID']['output'];
  /** The name of the state. */
  name: Scalars['String']['output'];
  /** The style of the state as it is displayed on the frontend. */
  style: SalesFunnelStyle;
};

/** The statistics for a sales funnel. */
export type SalesFunnelStatistics = {
  __typename?: 'SalesFunnelStatistics';
  /** The number of leads in each state of the sales funnel. */
  salesFunnelStateStatistics: Array<SalesFunnelStateStatistics>;
};

/** The statistics history for a sales funnel. */
export type SalesFunnelStatisticsHistory = {
  __typename?: 'SalesFunnelStatisticsHistory';
  /** The number of leads in each state of the sales funnel. */
  salesFunnelStateStatistics: Array<SalesFunnelStateStatisticsHistory>;
};

/** Defines the style of the sales funnel as it is displayed on the frontend. */
export type SalesFunnelStyle = {
  __typename?: 'SalesFunnelStyle';
  /** The background color of the state. */
  backgroundColor: SalesFunnelStateHexColor;
};

/** The totals history for a sales funnel. */
export type SalesFunnelTotalsHistory = {
  __typename?: 'SalesFunnelTotalsHistory';
  /** The number of leads that did not have their status updated within the date range. */
  statusUnchangedCount: Scalars['Int']['output'];
  /** The number of leads that had their status updated within the date range. */
  statusUpdatedCount: Scalars['Int']['output'];
};

export type SalesRepDetails = {
  __typename?: 'SalesRepDetails';
  chatId: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderPreference: Array<AddSalesRepOrderPref | '%future added value'>;
  phoneNumber: Scalars['String']['output'];
};

export const ScheduledBuyerReportFrequency = {
  Daily: 'daily',
  Monthly: 'monthly',
  Weekly: 'weekly'
} as const;

export type ScheduledBuyerReportFrequency = typeof ScheduledBuyerReportFrequency[keyof typeof ScheduledBuyerReportFrequency];
export const ScheduledBuyerReportTimeframeType = {
  Absolute: 'absolute',
  Relative: 'relative'
} as const;

export type ScheduledBuyerReportTimeframeType = typeof ScheduledBuyerReportTimeframeType[keyof typeof ScheduledBuyerReportTimeframeType];
export type SearchBuyerConnection = Connection & {
  __typename?: 'SearchBuyerConnection';
  edges: Array<BuyerEdge>;
  total: Scalars['Int']['output'];
};

export type SearchBuyerFilter = {
  googlePlaceAddressId: Scalars['String']['input'];
  googlePlaceEstablishment?: InputMaybe<GooglePlaceEstablishment>;
};

export type SearchBuyerFilterV2 = {
  /** Buyers will be filtered by distance to a reference coordinate */
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name: Scalars['String']['input'];
};

export type SearchBuyerInput = {
  /** @deprecated use filterV2 instead */
  filter?: InputMaybe<SearchBuyerFilter>;
  filterV2?: InputMaybe<SearchBuyerFilterV2>;
};

export type SearchBuyerResponse = AuthorizationFailure | InputValidationFailure | SearchBuyerConnection;

export type SearchCustomerChats = AuthorizationFailure | CustomerChatsConnection | InputValidationFailure;

export type SearchCustomerChatsInput = {
  filter?: InputMaybe<SearchCustomerV2Filter>;
  pagination?: InputMaybe<SearchCustomerV2Pagination>;
  searchTerm: Scalars['String']['input'];
  sort?: InputMaybe<SearchCustomerV2Sort>;
  supplierId: Scalars['String']['input'];
};

export type SearchCustomerResponse = AuthorizationFailure | CustomerChatsConnection | InputValidationFailure;

/**
 * Account owner filter options. When type is ASSIGNED, ownerUserIds must be provided.
 * When type is UNASSIGNED, ownerUserIds must not be provided.
 */
export type SearchCustomerV2AccountOwnerFilter = {
  /** List of owner user IDs. Required when type is ASSIGNED, will be ignored when type is UNASSIGNED. */
  ownerUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Type of account owner filter to apply. */
  type: SearchCustomerV2AccountOwnerFilterType | '%future added value';
};

/** Owner filter type - determines how to filter by owner assignment. */
export const SearchCustomerV2AccountOwnerFilterType = {
  /** Filter by specific owner user IDs. */
  Assigned: 'ASSIGNED',
  /** Filter for customers with no owner assigned. */
  Unassigned: 'UNASSIGNED'
} as const;

export type SearchCustomerV2AccountOwnerFilterType = typeof SearchCustomerV2AccountOwnerFilterType[keyof typeof SearchCustomerV2AccountOwnerFilterType];
export type SearchCustomerV2DateRange = {
  end?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  start?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type SearchCustomerV2Filter = {
  /** Filter by owner assignment. Specify type and (if ASSIGNED) provide ownerUserIds. */
  accountOwner?: InputMaybe<SearchCustomerV2AccountOwnerFilter>;
  churnStatus?: InputMaybe<Array<ChatChurnStatus | '%future added value'>>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  lastOrderDate?: InputMaybe<SearchCustomerV2DateRange>;
  maxOneChatPerBuyer?: InputMaybe<Scalars['Boolean']['input']>;
  orderFrequency?: InputMaybe<Array<ChatChurnOrderFrequency | '%future added value'>>;
  orderingTrend?: InputMaybe<Array<ChatChurnOrdersTrend | '%future added value'>>;
  status?: InputMaybe<SearchCustomerV2FilterStatus>;
  /** Filter by task status. Allows filtering customers by outstanding tasks, completed tasks, or no tasks. */
  taskStatus?: InputMaybe<TaskStatus | '%future added value'>;
  withBuyerUserEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchCustomerV2FilterStatus = {
  exclude?: InputMaybe<Array<ChatStatus | '%future added value'>>;
  include?: InputMaybe<Array<ChatStatus | '%future added value'>>;
};

export type SearchCustomerV2Input = {
  filter?: InputMaybe<SearchCustomerV2Filter>;
  pagination?: InputMaybe<SearchCustomerV2Pagination>;
  searchTerm: Scalars['String']['input'];
  sort?: InputMaybe<SearchCustomerV2Sort>;
};

export type SearchCustomerV2Pagination = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchCustomerV2Sort = {
  field: SearchCustomerV2SortField | '%future added value';
  order: SortOrder | '%future added value';
};

export const SearchCustomerV2SortField = {
  LastOrderDate: 'lastOrderDate',
  Name: 'name'
} as const;

export type SearchCustomerV2SortField = typeof SearchCustomerV2SortField[keyof typeof SearchCustomerV2SortField];
export type SearchEntity = Broadcast | Buyer | Chat | Message | Order | Product | Supplier | User;

export const SearchEntityType = {
  Broadcast: 'broadcast',
  Buyer: 'buyer',
  Chat: 'chat',
  Message: 'message',
  Order: 'order',
  Product: 'product',
  Supplier: 'supplier',
  User: 'user'
} as const;

export type SearchEntityType = typeof SearchEntityType[keyof typeof SearchEntityType];
export type SearchFilter = {
  broadcast?: InputMaybe<BroadcastFilter>;
  buyer?: InputMaybe<BuyerFilter>;
  chat?: InputMaybe<ChatFilter>;
  order?: InputMaybe<OrderFilter>;
  product?: InputMaybe<ProductFilter>;
  supplier?: InputMaybe<SupplierFilter>;
  user?: InputMaybe<UserFilter>;
};

export type SearchInput = {
  filter?: InputMaybe<SearchFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  type?: InputMaybe<SearchEntityType | '%future added value'>;
};

export type SearchItem = {
  __typename?: 'SearchItem';
  description?: Maybe<Scalars['String']['output']>;
  entity?: Maybe<SearchEntity>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: SearchEntityType | '%future added value';
};

export type SearchOrderConnection = Connection & {
  __typename?: 'SearchOrderConnection';
  edges: Array<SearchOrderEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type SearchOrderDeskCustomerInput = {
  paginationInput?: InputMaybe<PaginationInput>;
  searchTerm: Scalars['String']['input'];
  supplierId: Scalars['ID']['input'];
};

export type SearchOrderDeskCustomerResponse = AuthorizationFailure | InputValidationFailure | OrderDeskChatsConnection;

export type SearchOrderEdge = Edge & {
  __typename?: 'SearchOrderEdge';
  cursor: Scalars['String']['output'];
  node: Order;
};

export type SearchOrderInput = {
  acceptedByContext?: InputMaybe<Scalars['String']['input']>;
  /** Filter orders by whether they were accepted with exceptions */
  acceptedWithExceptions?: InputMaybe<Scalars['Boolean']['input']>;
  buyerId?: InputMaybe<Scalars['String']['input']>;
  chatIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  chatLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter orders by the UUID of the user that confirmed the order. */
  confirmedBy?: InputMaybe<Scalars['String']['input']>;
  /** Filter orders by the UUID of the user that created the order. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  deliveryFromTime?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  deliveryToTime?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  externalCustomerNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fromTime?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  hasDeliveryComment?: InputMaybe<Scalars['Boolean']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  orderedVia?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Filter orders by PO number */
  poNumber?: InputMaybe<Scalars['String']['input']>;
  /** Filter orders received after this timestamp */
  receivedAfter?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** Filter orders received before this timestamp */
  receivedBefore?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrderStatus | '%future added value'>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  supplierIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  supplierRefId?: InputMaybe<Scalars['String']['input']>;
  toTime?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type SearchOrderResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | SearchOrderConnection;

export type SearchProductsConnection = Connection & {
  __typename?: 'SearchProductsConnection';
  edges: Array<SearchProductsEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type SearchProductsEdge = Edge & {
  __typename?: 'SearchProductsEdge';
  cursor: Scalars['String']['output'];
  node: Product;
};

export type SearchProductsError = AppsyncError & AppsyncResponse & {
  __typename?: 'SearchProductsError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type SearchProductsInput = {
  filter?: InputMaybe<ProductFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
};

export type SearchProductsResponse = SearchProductsConnection | SearchProductsError;

export type SearchResult = {
  __typename?: 'SearchResult';
  hits: Array<SearchItem>;
  total: Scalars['Int']['output'];
};

export type SearchSupplierConnection = Connection & {
  __typename?: 'SearchSupplierConnection';
  edges: Array<SupplierSearchEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type SearchTaxonomyLabelsConnection = Connection & {
  __typename?: 'SearchTaxonomyLabelsConnection';
  edges: Array<SearchTaxonomyLabelsEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type SearchTaxonomyLabelsEdge = Edge & {
  __typename?: 'SearchTaxonomyLabelsEdge';
  cursor: Scalars['String']['output'];
  node: TaxonomyLabel;
};

export type SearchTaxonomyLabelsError = AppsyncError & AppsyncResponse & {
  __typename?: 'SearchTaxonomyLabelsError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type SearchTaxonomyLabelsInput = {
  locale: Scalars['String']['input'];
  search: Scalars['String']['input'];
};

export type SearchTaxonomyLabelsResponse = SearchTaxonomyLabelsConnection | SearchTaxonomyLabelsError;

export type SelectProductForOrderGuideInput = {
  buyerProduct?: InputMaybe<BuyerProductInput>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  chatId: Scalars['ID']['input'];
  productId: Scalars['ID']['input'];
};

export type SelectProductForOrderGuideResponse = AuthorizationFailure | InputValidationFailure | SelectProductForOrderGuideSuccess;

export type SelectProductForOrderGuideSuccess = AppsyncResponse & {
  __typename?: 'SelectProductForOrderGuideSuccess';
  /** Always ResponseType.success */
  responseType: ResponseType | '%future added value';
};

export type SelectProductsForOrderGuideInput = {
  chatId: Scalars['ID']['input'];
  products: Array<OrderGuideProductInput>;
};

export type SelectProductsForOrderGuideResponse = AuthorizationFailure | SelectProductsForOrderGuideSuccess;

export type SelectProductsForOrderGuideSuccess = AppsyncResponse & {
  __typename?: 'SelectProductsForOrderGuideSuccess';
  invalidProducts?: Maybe<Array<Scalars['String']['output']>>;
  /** Always ResponseType.success */
  responseType: ResponseType | '%future added value';
};

/** Input type for sending email marketing campaign to all contacts of a supplier */
export type SendEmailCampaignToAllInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
};

/** Input type for sending email marketing campaign to all contacts of specific chats */
export type SendEmailCampaignToChatsInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Chat IDs to send the email campaign to */
  chatIds: Array<Scalars['String']['input']>;
};

export type SendInviteTransmissionRequest = {
  channel: InviteChannel | '%future added value';
  invitedToEntityId: Scalars['String']['input'];
  inviteeEntityId?: InputMaybe<Scalars['String']['input']>;
  inviteeEntityName?: InputMaybe<Scalars['String']['input']>;
  inviteeId: Scalars['String']['input'];
  inviteeName?: InputMaybe<Scalars['String']['input']>;
  invitorEntityName: Scalars['String']['input'];
  invitorId: Scalars['String']['input'];
  invitorUserName: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type SendInviteTransmissionResponse = AuthorizationFailure | InputValidationFailure | InviteTransmission;

/** Input type for sending marketing campaign to different channels */
export type SendMarketingCampaignInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Target rules to be used for the marketing campaign recipients */
  target: MarketingCampaignTargetInput;
};

/** Input type for sending marketing campaign to different channels */
export type SendMarketingCampaignInputV2 = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Target rules to be used for the marketing campaign recipients */
  target: MarketingCampaignTargetInputV2;
};

export type SendSampleSmsMessageFailure = AppsyncResponse & {
  __typename?: 'SendSampleSmsMessageFailure';
  errorMessage: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

/** Input to sendSampleSmsMessage */
export type SendSampleSmsMessageInput = {
  /** Optional media attachments */
  mediaUrls?: InputMaybe<Array<SendSampleSmsMessageMediaInput>>;
  /** Body of the sms to send. */
  messageBody: Scalars['String']['input'];
  /**
   * Recipient phone number. Must be in format '+<Country_Code><Phone_Number>'
   * with no non-numeric characters.
   */
  to: Scalars['String']['input'];
};

export type SendSampleSmsMessageMediaInput = {
  mediaUrl: Scalars['String']['input'];
};

export type SendSampleSmsMessageResponse = AuthorizationFailure | InputValidationFailure | SendSampleSmsMessageFailure | SendSampleSmsMessageSuccess;

export type SendSampleSmsMessageSuccess = AppsyncResponse & {
  __typename?: 'SendSampleSmsMessageSuccess';
  messageSid: Scalars['String']['output'];
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type SendSyntheticSmsMessageInput = {
  /** AccountSid number */
  accountSid?: InputMaybe<Scalars['String']['input']>;
  /** Body of the sms to send. */
  body: Scalars['String']['input'];
  /** Sender phone number */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Optional media attachments */
  media?: InputMaybe<Array<SendSyntheticSmsMessageMediaInput>>;
  /** The messageSid of the sms message to send a synthetic response to */
  messageSid?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recipient phone number. Must be in format '+<Country_Code><Phone_Number>'
   * with no non-numeric characters.
   */
  to: Scalars['String']['input'];
};

export type SendSyntheticSmsMessageMediaInput = {
  mediaContentType: Scalars['String']['input'];
  mediaUrl: Scalars['String']['input'];
};

export type SendSyntheticSmsMessageResponse = AuthorizationFailure | InputValidationFailure | SendSyntheticSmsMessageSuccess;

export type SendSyntheticSmsMessageSuccess = AppsyncResponse & {
  __typename?: 'SendSyntheticSmsMessageSuccess';
  messageSid: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type SendSyntheticWhatsAppMessageInput = {
  /** Body of the WhatsApp message to send. */
  body: Scalars['String']['input'];
  /** Sender phone number */
  from: Scalars['String']['input'];
  /** Optional media attachments */
  media?: InputMaybe<Array<SendSyntheticWhatsAppMessageMediaInput>>;
  /**
   * The messageSid of the WhatsApp message message to send a synthetic response to.
   * Must begin with prefix TEST_.
   */
  messageSid: Scalars['String']['input'];
  /**
   * Recipient phone number. Must be in format '+<Country_Code><Phone_Number>'
   * with no non-numeric characters.
   */
  to: Scalars['String']['input'];
};

export type SendSyntheticWhatsAppMessageMediaInput = {
  contentType: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SendSyntheticWhatsAppMessageResponse = AuthorizationFailure | InputValidationFailure | SendSyntheticWhatsAppMessageSuccess;

export type SendSyntheticWhatsAppMessageSuccess = AppsyncResponse & {
  __typename?: 'SendSyntheticWhatsAppMessageSuccess';
  messageSid: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type SessionLoyaltyPoints = {
  __typename?: 'SessionLoyaltyPoints';
  /** Stable session-level reward key from Talon `props.name`, reused as the Crowdin translation key. Useful for debugging and analytics; clients must not map UI copy from it. */
  code: Scalars['String']['output'];
  /** Localized user-facing description resolved from Crowdin via Accept-Language, supplier locale, and English fallback. */
  message: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  /** Unrounded amount for this session award (Talon effect or backend `rounding_bonus`). */
  pointsDecimal: Decimal;
};

/** Input type for setting marketing email sender configuration */
export type SetMarketingEmailSenderInput = {
  /** The company details including name and address for legal compliance */
  companyDetails: Scalars['String']['input'];
  /** Footer links for email templates (up to 4 links) */
  footerLinks?: InputMaybe<Array<MarketingEmailSenderFooterLinkInput>>;
  /** The email address for reply-to field */
  replyToEmail: Scalars['AWSEmail']['input'];
  /** The display name for reply-to field */
  replyToName: Scalars['String']['input'];
  /** The display name of the sender */
  senderName: Scalars['String']['input'];
};

/** Response type for setting a marketing email sender */
export type SetMarketingEmailSenderResponse = AuthorizationFailure | InputValidationFailure | SetMarketingEmailSenderResult;

/** Success result for setting marketing email sender */
export type SetMarketingEmailSenderResult = AppsyncResponse & {
  __typename?: 'SetMarketingEmailSenderResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** The created or updated email sender configuration */
  sender: MarketingCampaignEmailSender;
};

export type SetOrderAsTestResponse = InputValidationFailure | TestOrderResponse;

export type SetUserOrderOverridePermissionsInput = {
  /** The ID of the supplier context where these permissions apply */
  supplierId: Scalars['ID']['input'];
  /** The ID of the user to set override permissions for */
  userId: Scalars['ID']['input'];
  /**
   * The list of validation rules this user can override.
   * Pass an empty array to remove all override permissions for this user-supplier combination.
   */
  validationRules: Array<ValidationRule | '%future added value'>;
};

export type SetUserOrderOverridePermissionsResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | UserOrderOverridePermissions;

export type SettlementReportCreateInput = {
  endDate: Scalars['AWSDate']['input'];
  startDate: Scalars['AWSDate']['input'];
};

export type SettlementReportCreateResponse = AuthorizationFailure | InputValidationFailure | SettlementReportCreateSuccess;

export type SettlementReportCreateSuccess = {
  __typename?: 'SettlementReportCreateSuccess';
  reportId: Scalars['ID']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type SettlementReportInput = {
  reportId: Scalars['ID']['input'];
};

export type SettlementReportResponse = AuthorizationFailure | InputValidationFailure | SettlementReportSuccess;

export type SettlementReportSuccess = {
  __typename?: 'SettlementReportSuccess';
  /** Empty if the report is not ready yet */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type SharedBroadcastProducts = {
  __typename?: 'SharedBroadcastProducts';
  categories?: Maybe<Array<ProductCategory>>;
  productCountInProductList?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Product>>;
};

export type ShippingAddressInput = {
  city: Scalars['String']['input'];
  /** 2-letter country code as per ISO 3166 */
  countryCode: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  streetAddress: Scalars['String']['input'];
};

export type SignupFormConfig = {
  __typename?: 'SignupFormConfig';
  /** Array of action buttons displayed on the signup form. */
  actionButtons: Array<ActionButton>;
  /** The signup form config ID. */
  id: Scalars['ID']['output'];
  /** Intro message displayed on the signup form. */
  introMessage: Scalars['String']['output'];
  /** The vendor ID this config belongs to. */
  vendorId: Scalars['ID']['output'];
};

export type SignupFormConfigUpdateInput = {
  /** Array of action buttons. Replaces all existing buttons atomically. */
  actionButtons: Array<ActionButtonInput>;
  /** Intro message for the signup form. Max 200 characters. */
  introMessage: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

export type SignupFormConfigUpdateResponse = AuthorizationFailure | InputValidationFailure | SignupFormConfigUpdateResult;

export type SignupFormConfigUpdateResult = AppsyncResponse & {
  __typename?: 'SignupFormConfigUpdateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** The updated signup form config. */
  signupFormConfig: SignupFormConfig;
};

export const SingleDayDeliveryExceptionType = {
  SingleDayDeliveryException: 'singleDayDeliveryException'
} as const;

export type SingleDayDeliveryExceptionType = typeof SingleDayDeliveryExceptionType[keyof typeof SingleDayDeliveryExceptionType];
export type SingleDayDeliveryExceptionWithCutoff = {
  __typename?: 'SingleDayDeliveryExceptionWithCutoff';
  cutoffType: WithCutoffType | '%future added value';
  date: Scalars['AWSDate']['output'];
  leadTimeAdjustedCutoff: Scalars['AWSDateTime']['output'];
  type: SingleDayDeliveryExceptionType | '%future added value';
  updateBehavior: DeliverySettingExceptionUpdateBehavior | '%future added value';
};

export type SingleDayDeliveryExceptionWithoutCutoff = {
  __typename?: 'SingleDayDeliveryExceptionWithoutCutoff';
  cutoffType: NoCutoffType | '%future added value';
  date: Scalars['AWSDate']['output'];
  type: SingleDayDeliveryExceptionType | '%future added value';
  updateBehavior: DeliverySettingExceptionUpdateBehavior | '%future added value';
};

export type SmartOrderSuppliersConnection = {
  __typename?: 'SmartOrderSuppliersConnection';
  edges: Array<SmartOrderSuppliersEdge>;
  pageInfo: PageInfo;
};

export type SmartOrderSuppliersEdge = {
  __typename?: 'SmartOrderSuppliersEdge';
  cursor: Scalars['String']['output'];
  node: SupplierRef;
};

export type SmartOrderSuppliersInput = {
  pagination?: InputMaybe<PaginationInputV2>;
};

export type SmartOrderSuppliersResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | SmartOrderSuppliersConnection;

export type SmsMessage = {
  __typename?: 'SmsMessage';
  accountSid: Scalars['String']['output'];
  apiVersion?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  createdAt: Scalars['AWSTimestamp']['output'];
  from: Scalars['String']['output'];
  fromCity?: Maybe<Scalars['String']['output']>;
  fromCountry?: Maybe<Scalars['String']['output']>;
  fromState?: Maybe<Scalars['String']['output']>;
  fromZip?: Maybe<Scalars['String']['output']>;
  mediaElements?: Maybe<Array<SmsMessageMedia>>;
  messageSid: Scalars['String']['output'];
  messagingServiceSid?: Maybe<Scalars['String']['output']>;
  numMedia: Scalars['Int']['output'];
  numSegments: Scalars['Int']['output'];
  provider: Scalars['String']['output'];
  serviceApiVersion: Scalars['String']['output'];
  smsMessageId: Scalars['String']['output'];
  smsStatus?: Maybe<Scalars['String']['output']>;
  to: Scalars['String']['output'];
  toCity?: Maybe<Scalars['String']['output']>;
  toCountry?: Maybe<Scalars['String']['output']>;
  toState?: Maybe<Scalars['String']['output']>;
  toZip?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSTimestamp']['output'];
};

export type SmsMessageMedia = {
  __typename?: 'SmsMessageMedia';
  contentType: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
};

export type SocialLink = {
  __typename?: 'SocialLink';
  platform: SocialPlatform | '%future added value';
  url: Scalars['String']['output'];
};

export type SocialLinkInput = {
  platform: SocialPlatform | '%future added value';
  url: Scalars['String']['input'];
};

export const SocialPlatform = {
  Facebook: 'FACEBOOK',
  Instagram: 'INSTAGRAM',
  Linkedin: 'LINKEDIN',
  Twitter: 'TWITTER',
  Youtube: 'YOUTUBE'
} as const;

export type SocialPlatform = typeof SocialPlatform[keyof typeof SocialPlatform];
export type Sort = {
  field: Scalars['String']['input'];
  order: SortOrder | '%future added value';
};

export const SortCartBy = {
  Alphabetical: 'alphabetical',
  OrderGuide: 'orderGuide'
} as const;

export type SortCartBy = typeof SortCartBy[keyof typeof SortCartBy];
export const SortDirection = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type SortDirection = typeof SortDirection[keyof typeof SortDirection];
export const SortOrder = {
  Asc: 'asc',
  Desc: 'desc'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
/** A single identity-provider attribute mapped onto a Cognito user attribute. */
export type SsoAttributeMapping = {
  __typename?: 'SsoAttributeMapping';
  cognitoAttribute: Scalars['String']['output'];
  idpAttribute: Scalars['String']['output'];
};

/**
 * A customer-facing view of one SSO connection. Secret provider details, such as
 * an OIDC client secret, are deliberately not exposed.
 */
export type SsoConnection = {
  __typename?: 'SsoConnection';
  attributeMappings: Array<SsoAttributeMapping>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /**
   * The same domains as emailDomains, each carrying the exclusivity flag Choco
   * holds for it. One entry per domain, flagged or not.
   */
  emailDomainDetails: Array<SsoEmailDomain>;
  /** Email domains that route to this connection */
  emailDomains: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  signOutEnabled: Scalars['Boolean']['output'];
  type: SsoConnectionType | '%future added value';
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type SsoConnectionList = {
  __typename?: 'SsoConnectionList';
  connections: Array<SsoConnection>;
};

/**
 * The connection holds more users than a single unpaginated response supports.
 * Returned instead of a truncated list.
 */
export type SsoConnectionTooLarge = AppsyncError & AppsyncResponse & {
  __typename?: 'SsoConnectionTooLarge';
  limit: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export const SsoConnectionType = {
  Oidc: 'oidc',
  Other: 'other',
  Saml: 'saml',
  Social: 'social'
} as const;

export type SsoConnectionType = typeof SsoConnectionType[keyof typeof SsoConnectionType];
export type SsoConnectionUser = {
  __typename?: 'SsoConnectionUser';
  /** The same user as chocoUserId, expandable through node. */
  chocoAccount?: Maybe<UserRef>;
  /** The Choco user id, when the user has a Choco user record */
  chocoUserId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  /** Roles asserted by the identity provider */
  federatedRoles: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /**
   * One entry per attribute the connection maps, carrying the value this user
   * currently has. Mirrors SsoConnection.attributeMappings, so it names both
   * sides of the mapping.
   */
  mappedAttributes: Array<SsoConnectionUserAttribute>;
  /**
   * One entry per role in federatedRoles. A null mapping is a role the connection
   * does not map, so its holder resolves to no supplier.
   */
  mappedFederatedRoles: Array<SsoConnectionUserRole>;
  status: SsoConnectionUserStatus | '%future added value';
};

/** A single mapped attribute and the value held for one user. */
export type SsoConnectionUserAttribute = {
  __typename?: 'SsoConnectionUserAttribute';
  /** Attribute name on the Choco side, e.g. family_name */
  cognitoAttribute: Scalars['String']['output'];
  /** Attribute name on the identity provider side, e.g. lastName */
  idpAttribute: Scalars['String']['output'];
  /** Absent when the identity provider sent nothing for this attribute */
  value?: Maybe<Scalars['String']['output']>;
};

export type SsoConnectionUserList = {
  __typename?: 'SsoConnectionUserList';
  connectionId: Scalars['ID']['output'];
  /** Every user of the connection. Never a partial list. */
  users: Array<SsoConnectionUser>;
};

export type SsoConnectionUserRole = {
  __typename?: 'SsoConnectionUserRole';
  federatedRole: Scalars['String']['output'];
  /** Null when the connection maps no such role. */
  mapping?: Maybe<SsoRoleMapping>;
};

export const SsoConnectionUserStatus = {
  Confirmed: 'confirmed',
  Disabled: 'disabled',
  ExternalProvider: 'externalProvider',
  Unknown: 'unknown'
} as const;

export type SsoConnectionUserStatus = typeof SsoConnectionUserStatus[keyof typeof SsoConnectionUserStatus];
export type SsoConnectionUsersInput = {
  connectionId: Scalars['ID']['input'];
};

export type SsoConnectionUsersResponse = AuthorizationFailure | NotFoundError | SsoConnectionTooLarge | SsoConnectionUserList;

export type SsoConnectionsResponse = AuthorizationFailure | SsoConnectionList;

/**
 * One email domain of an SSO connection, with the exclusivity flag Choco holds
 * for it. Cognito owns which domains route to a connection; Choco owns only the
 * flag.
 */
export type SsoEmailDomain = {
  __typename?: 'SsoEmailDomain';
  connectionId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  emailDomain: Scalars['String']['output'];
  /** True when the domain federates only, so local sign-up on it is refused. */
  exclusiveFederatedLogin: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type SsoEmailDomainExclusivitySetInput = {
  connectionId: Scalars['ID']['input'];
  /** A domain Cognito already routes to the connection. Choco does not add domains. */
  emailDomain: Scalars['String']['input'];
  exclusiveFederatedLogin: Scalars['Boolean']['input'];
};

export type SsoEmailDomainExclusivitySetResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | SsoEmailDomain;

export type SsoEmailDomainList = {
  __typename?: 'SsoEmailDomainList';
  emailDomains: Array<SsoEmailDomain>;
};

export type SsoEmailDomainsInput = {
  connectionId: Scalars['ID']['input'];
};

export type SsoEmailDomainsResponse = AuthorizationFailure | NotFoundError | SsoEmailDomainList;

/**
 * One role a customer's directory asserts in custom:federatedRoles, and the
 * supplier and Choco role a user holding it is given. Resolution takes the first
 * role that resolves, so mappings carry no priority and no ordering.
 */
export type SsoRoleMapping = {
  __typename?: 'SsoRoleMapping';
  /** The bot user a holder of the role sends messages as. */
  botUser: UserRef;
  chocoSupplierRole: Role | '%future added value';
  connectionId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** e.g. app.choprd.halperns_admin */
  federatedRole: Scalars['String']['output'];
  supplier: SupplierRef;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

/** The connection already maps this federated role. One mapping per federated role. */
export type SsoRoleMappingAlreadyExists = AppsyncError & AppsyncResponse & {
  __typename?: 'SsoRoleMappingAlreadyExists';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type SsoRoleMappingCreateInput = {
  connectionId: Scalars['ID']['input'];
  federatedRole: Scalars['String']['input'];
  /**
   * The supplier a holder of the role is given access to. Nullable so that a
   * second target, such as a buyer, can be added beside it without a breaking
   * change. Exactly one target must be supplied, so today this is always
   * required in practice and omitting it is an InputValidationFailure.
   */
  supplier?: InputMaybe<SsoSupplierDataInput>;
};

export type SsoRoleMappingCreateResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | SsoRoleMapping | SsoRoleMappingAlreadyExists;

export type SsoRoleMappingDeleteInput = {
  connectionId: Scalars['ID']['input'];
  federatedRole: Scalars['String']['input'];
};

export type SsoRoleMappingDeleteResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | SsoRoleMappingDeleteSuccess;

export type SsoRoleMappingDeleteSuccess = {
  __typename?: 'SsoRoleMappingDeleteSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type SsoRoleMappingList = {
  __typename?: 'SsoRoleMappingList';
  /** Every role mapping of the connection. Never a partial list. */
  roleMappings: Array<SsoRoleMapping>;
};

export type SsoRoleMappingsInput = {
  connectionId: Scalars['ID']['input'];
};

export type SsoRoleMappingsResponse = AuthorizationFailure | NotFoundError | SsoRoleMappingList;

/**
 * The supplier side of a role mapping. The bot user is not supplied — it is
 * derived from supplierId when the mapping is created, and returned on
 * SsoRoleMapping.botUser.
 */
export type SsoSupplierDataInput = {
  chocoSupplierRole: Role | '%future added value';
  supplierId: Scalars['ID']['input'];
};

export type StartDocumentScanInput = {
  documentScanId: Scalars['ID']['input'];
};

export type StartMenuScanInput = {
  menuScanId: Scalars['ID']['input'];
};

export type StartOffSet = {
  __typename?: 'StartOffSet';
  milliseconds: Scalars['Int']['output'];
};

export const StockValidationCode = {
  /** Paid line discontinued from catalog/product availability. Blocks commit. */
  Discontinued: 'DISCONTINUED',
  /** Paid line unavailable from catalog/product availability. Blocks commit. */
  OutOfStock: 'OUT_OF_STOCK'
} as const;

export type StockValidationCode = typeof StockValidationCode[keyof typeof StockValidationCode];
export type StockValidationResult = CartValidationResult & {
  __typename?: 'StockValidationResult';
  /** Stock availability failure code. */
  code: StockValidationCode | '%future added value';
  overriddenBy?: Maybe<Scalars['String']['output']>;
  overrideable: Scalars['Boolean']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  source: ValidationSource | '%future added value';
  status: ValidationStatus | '%future added value';
  /** Cart line vendorItemUnitId (join key). */
  vendorItemUnitId: Scalars['ID']['output'];
};

export type SubCatalog = Node & {
  __typename?: 'SubCatalog';
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  supplierEntityId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type SubCatalogChat = {
  __typename?: 'SubCatalogChat';
  chatId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdBy?: Maybe<EntityIdentity>;
  subCatalogId: Scalars['ID']['output'];
};

export type SubCatalogChatInput = {
  chatId: Scalars['ID']['input'];
  subCatalogId: Scalars['ID']['input'];
};

export type SubCatalogConnection = Connection & {
  __typename?: 'SubCatalogConnection';
  edges: Array<SubCatalogEdge>;
};

export type SubCatalogEdge = Edge & {
  __typename?: 'SubCatalogEdge';
  cursor: Scalars['String']['output'];
  node: SubCatalog;
};

export type SubCatalogNotFoundError = AppsyncError & AppsyncResponse & {
  __typename?: 'SubCatalogNotFoundError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type SubmitBuyerStockCountInput = {
  buyerId: Scalars['ID']['input'];
};

export type SubmitMagicCodeInput = {
  /** The magic code entered by the user (case-insensitive). */
  code: Scalars['String']['input'];
};

export type SubmitMagicCodeResponse = AuthorizationFailure | InputValidationFailure | MagicCodeExpiredError | MagicCodeInvalidatedError | MagicCodeMaxUsesReachedError | MagicCodeNotFoundError | MagicCodeNotWhitelabelAppError | MagicCodeSupplierNotAllowedError | MagicCodeUnexpectedError | MagicCodeUserAlreadyInChatError | SubmitMagicCodeResult;

export type SubmitMagicCodeResult = AppsyncResponse & {
  __typename?: 'SubmitMagicCodeResult';
  /** The ID of the buyer the user was added to or is already part of */
  buyerId: Scalars['ID']['output'];
  /** The ID of the chat the user was added to */
  chatId: Scalars['ID']['output'];
  /** Response type will always be set to success */
  responseType: ResponseType | '%future added value';
};

export type SubmitOrderDeliveryCheckInput = {
  deliveryCheckReconciliationRequest?: InputMaybe<DeliveryCheckReconciliationRequestInput>;
  deliveryNote?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};

export type SubmitOrderedProductDeliveryCheckInput = {
  /** @deprecated use deliveryCheckProblems[<item.amountDelivered>] instead */
  amountDelivered?: InputMaybe<Scalars['Float']['input']>;
  amountOrdered?: InputMaybe<Scalars['Float']['input']>;
  deliveryCheckProblems?: InputMaybe<Array<InputMaybe<DeliveryCheckProblemInput>>>;
  imageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  orderId: Scalars['ID']['input'];
  orderedProductMetadata?: InputMaybe<OrderedProductMetadataInput>;
  productId: Scalars['ID']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  autopilotSubscription?: Maybe<AutopilotSubscriptionResponse>;
  chatUpdateSubscription?: Maybe<ChatUpdateSubscriptionResponse>;
  omnichannelOrderStatusSubscription?: Maybe<OmnichannelOrderStatusSubscriptionResponse>;
  omnichannelOrdersSubcription?: Maybe<OmnichannelOrdersSubcriptionResponse>;
  onCustomerInsightsNotificationSubscription?: Maybe<CustomerInsightsNotificationSubscriptionResponse>;
  onNotificationCreate?: Maybe<Notification>;
  /** Inbox updates for the authenticated user across all their buyers. Users can only subscribe to their own `userId`. */
  onNotificationInboxUpdateSubscription?: Maybe<NotificationInboxUpdate>;
  transmissionEventSubscription?: Maybe<TransmissionEventSubscriptionResponse>;
  transmissionV2Subscription?: Maybe<TransmissionV2SubscriptionResponse>;
};


export type SubscriptionAutopilotSubscriptionArgs = {
  supplierId: Scalars['ID']['input'];
};


export type SubscriptionChatUpdateSubscriptionArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionOmnichannelOrderStatusSubscriptionArgs = {
  supplierId: Scalars['ID']['input'];
};


export type SubscriptionOmnichannelOrdersSubcriptionArgs = {
  supplierId: Scalars['ID']['input'];
};


export type SubscriptionOnCustomerInsightsNotificationSubscriptionArgs = {
  userId: Scalars['String']['input'];
};


export type SubscriptionOnNotificationCreateArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionOnNotificationInboxUpdateSubscriptionArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionTransmissionEventSubscriptionArgs = {
  supplierId: Scalars['ID']['input'];
};


export type SubscriptionTransmissionV2SubscriptionArgs = {
  supplierId: Scalars['ID']['input'];
};

export type SuggestedProduct = Node & {
  __typename?: 'SuggestedProduct';
  id: Scalars['ID']['output'];
  /** @deprecated This endpoint is in the maintenance mode. It works, but won't get new features. Avoid using in the new code. Reach out to the owner team if you have a new use case for this field. */
  product?: Maybe<Product>;
};

export type SuggestedProductConnection = Connection & {
  __typename?: 'SuggestedProductConnection';
  edges?: Maybe<Array<SuggestedProductEdge>>;
  total: Scalars['Int']['output'];
};

export type SuggestedProductEdge = Edge & {
  __typename?: 'SuggestedProductEdge';
  cursor: Scalars['String']['output'];
  node: SuggestedProduct;
};

export type SuggestedProductResult = AuthorizationFailure | GetSuggestedProductsErrorResponse | InputValidationFailure | SuggestedProductSuccessResponse;

export type SuggestedProductSuccessResponse = AppsyncResponse & {
  __typename?: 'SuggestedProductSuccessResponse';
  products: SuggestedProductConnection;
  responseType: ResponseType | '%future added value';
};

export type Supplier = Node & {
  __typename?: 'Supplier';
  accessPackage: AccessPackage | '%future added value';
  /** allow buyer to add product-level comment to ordered products */
  allowBuyerComment?: Maybe<Scalars['Boolean']['output']>;
  allowCustomProducts: Scalars['Boolean']['output'];
  allowCustomerAcquisition?: Maybe<Scalars['Boolean']['output']>;
  allowEcommercePoNumber?: Maybe<Scalars['Boolean']['output']>;
  allowInvoiceOrderGuidePhotoUpload?: Maybe<Scalars['Boolean']['output']>;
  allowOnlyOneActiveVariant?: Maybe<Scalars['Boolean']['output']>;
  allowOrderedProductMerging?: Maybe<Scalars['Boolean']['output']>;
  /** Returns Supplier Level or Buyer Level MOV */
  appliedMinimumOrderValue?: Maybe<MinimumOrderValueResponse>;
  botUser?: Maybe<User>;
  botUserId?: Maybe<Scalars['String']['output']>;
  /**
   * Which stock statuses are visible to buyers when browsing the catalog in chat/ecommerce.
   * When null, only in-stock products are shown to buyers.
   * The list must always include `InStock`.
   * Note that buyers may still see units with other stock statuses via the Order Guide or Units Of Measure screen.
   */
  buyerVisibleStockStatuses?: Maybe<Array<VendorItemUnitStockStatus | '%future added value'>>;
  /** decimal places used when computing prices/taxes (defaults to the currency's minor units) */
  calculationPrecision?: Maybe<Scalars['Int']['output']>;
  /**
   * Number of Products in the catalog of this Supplier
   * @deprecated This endpoint is in the maintenance mode. It works partially, but won't get new features. Avoid using in the new code. Use `Chat.hasVendorCatalog` or `vendorItemsForVendor` instead.
   */
  catalogProductsCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The direct children of this supplier in the multi-entity hierarchy.
   * Returns at most `input.limit` children, 500 by default.
   *
   * Prefer using `supplierHierarchyList` query to load the whole hierarchy.
   *
   * Admin only.
   */
  children?: Maybe<Array<Supplier>>;
  chocoAiSupplierSetting?: Maybe<SupplierSetting>;
  /** vendor's own identifier for this supplier, used for integration and reference lookups */
  code?: Maybe<Scalars['String']['output']>;
  contactEmails?: Maybe<Array<Scalars['AWSEmail']['output']>>;
  coverPhoto?: Maybe<ProfileImage>;
  customerNumberMandatory?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use `SupplierDeliverySetting.cutOffTime` instead */
  cutOffTime?: Maybe<Scalars['String']['output']>;
  /** supplier's default ISO 4217 currency code (e.g. EUR) */
  defaultCurrency?: Maybe<Scalars['String']['output']>;
  defaultSubCatalog?: Maybe<Scalars['String']['output']>;
  deliveryCosts?: Maybe<Scalars['String']['output']>;
  deliveryDateMandatory: Scalars['Boolean']['output'];
  /**
   * Delivery fee tiers that apply to the buyer: the buyer's CUSTOMER override when one exists,
   * otherwise the SUPPLIER_DEFAULT tiers. Empty when neither is configured.
   * `buyerId` defaults to the chat's buyer when the supplier is resolved through `Chat.supplierEntity`.
   */
  deliveryFeeTiers: Array<DeliveryFeeTier>;
  /** delivery settings of suppliers which was previously used from supplierDeliverySetting query */
  deliverySetting?: Maybe<SupplierDeliverySetting>;
  deliveryZones?: Maybe<Array<DeliveryZone>>;
  /** short description of supplier to be shown during supplier discovery */
  description?: Maybe<Scalars['String']['output']>;
  disableCustomerNumberEdits?: Maybe<Scalars['Boolean']['output']>;
  /** enable ecommerce products grid view in catalog and order guide */
  enableEcommerceProductGridView?: Maybe<Scalars['Boolean']['output']>;
  /** gate the checkout promotion engine for this supplier (unset = disabled) */
  enablePromotions?: Maybe<Scalars['Boolean']['output']>;
  /** gate the checkout tax engine for this supplier (unset = disabled) */
  enableTaxes?: Maybe<Scalars['Boolean']['output']>;
  hasCoverPhoto?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This endpoint is in the maintenance mode. It works partially, but won't get new features. Avoid using in the new code. Use `vendorItemsForVendor` instead */
  hasEnabledCatalogProducts?: Maybe<Scalars['Boolean']['output']>;
  hasEnabledFractionalUnits?: Maybe<Scalars['Boolean']['output']>;
  hasProfilePhoto?: Maybe<Scalars['Boolean']['output']>;
  /** this value is duplicate of hasEnabledCatalogProducts, added for data analysis */
  hasValidCatalogProducts?: Maybe<Scalars['Boolean']['output']>;
  hideMyPrice?: Maybe<Scalars['Boolean']['output']>;
  /** the topmost ancestor of this supplier, null for a standalone supplier */
  hierarchyRoot?: Maybe<SupplierRef>;
  /** place of this supplier in the multi-entity hierarchy (a supplier with no stored hierarchy reads as Warehouse) */
  hierarchyType?: Maybe<SupplierHierarchyType | '%future added value'>;
  id: Scalars['ID']['output'];
  integration: Array<IntegrationOption>;
  /** indicates whether a supplier can be discovered via search */
  isDiscoverable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated we no longer support it */
  isInstantInvoiceEnabled: Scalars['Boolean']['output'];
  isIntegrated?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated we no longer support it */
  isPaymentEnabled: Scalars['Boolean']['output'];
  /** True if supplier is a test supplier on Choco's Dogfood programme */
  isPuppy?: Maybe<Scalars['Boolean']['output']>;
  isTest?: Maybe<Scalars['Boolean']['output']>;
  locale: Scalars['String']['output'];
  minOrder?: Maybe<MinOrder>;
  minOrderAmount?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  noDefaultCatalog?: Maybe<Scalars['Boolean']['output']>;
  /** the direct parent supplier, null for a hierarchy root and for a standalone supplier */
  parent?: Maybe<SupplierRef>;
  /** every ancestor of this supplier, from the direct parent up to the hierarchy root */
  parentChain?: Maybe<Array<SupplierRef>>;
  phone?: Maybe<Scalars['String']['output']>;
  /** settings that determine the display of price in catalog products to (potential) buyer(s) */
  priceSetting?: Maybe<PriceSetting>;
  /** which date drives ordering-stage price/promotion/tax evaluation (defaults to ORDER_DATE) */
  pricingDateSource?: Maybe<PricingDateSource | '%future added value'>;
  primaryAssortment?: Maybe<Scalars['String']['output']>;
  referenceId: Scalars['String']['output'];
  secondaryAssortments?: Maybe<Array<Scalars['String']['output']>>;
  sortCartBy?: Maybe<SortCartBy | '%future added value'>;
  /** IANA timezone code, e.g: Europe/Berlin */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Paginated list of users connected to the supplier */
  users?: Maybe<SupplierUserConnection>;
};


export type SupplierAppliedMinimumOrderValueArgs = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
};


export type SupplierChildrenArgs = {
  input?: InputMaybe<SupplierChildrenInput>;
};


export type SupplierDeliveryFeeTiersArgs = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
};


export type SupplierUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierAgentSettings = {
  __typename?: 'SupplierAgentSettings';
  agentProfileType: AgentProfileType | '%future added value';
  createdAt: Scalars['AWSTimestamp']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /**
   * Inbound numbers routed to this supplier's agent, oldest first. Read-only:
   * numbers are provisioned by Choco admins. Shadow (test) numbers are excluded.
   * Empty when no number is provisioned.
   */
  phoneNumbers: Array<AgentPhoneNumber>;
  /** Profile-specific settings. Null if no settings have been configured yet. */
  settings?: Maybe<SupplierAgentSettingsData>;
  supplierId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
};

/** Profile-specific settings. Exactly one field should be provided, matching the agentProfileType. */
export type SupplierAgentSettingsData = {
  __typename?: 'SupplierAgentSettingsData';
  voiceOrderAgent?: Maybe<VoiceOrderAgentSettings>;
};

/** Profile-specific settings input. Exactly one field should be provided, matching the agentProfileType. */
export type SupplierAgentSettingsDataInput = {
  voiceOrderAgent?: InputMaybe<VoiceOrderAgentSettingsInput>;
};

export type SupplierAgentSettingsGetError = {
  __typename?: 'SupplierAgentSettingsGetError';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type SupplierAgentSettingsGetResponse = AuthorizationFailure | InputValidationFailure | SupplierAgentSettingsGetError | SupplierAgentSettingsGetSuccess;

export type SupplierAgentSettingsGetSuccess = {
  __typename?: 'SupplierAgentSettingsGetSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  supplierAgentSettings?: Maybe<SupplierAgentSettings>;
};

export type SupplierAgentSettingsUpsertError = {
  __typename?: 'SupplierAgentSettingsUpsertError';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type SupplierAgentSettingsUpsertInput = {
  agentProfileType: AgentProfileType | '%future added value';
  enabled: Scalars['Boolean']['input'];
  /**
   * Profile-specific settings. Exactly one field should be provided, matching the agentProfileType.
   * Validated server-side.
   */
  settings?: InputMaybe<SupplierAgentSettingsDataInput>;
  supplierId: Scalars['ID']['input'];
};

export type SupplierAgentSettingsUpsertResponse = AuthorizationFailure | InputValidationFailure | SupplierAgentSettingsUpsertError | SupplierAgentSettingsUpsertSuccess;

export type SupplierAgentSettingsUpsertSuccess = {
  __typename?: 'SupplierAgentSettingsUpsertSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  supplierAgentSettings: SupplierAgentSettings;
};

export type SupplierApplications = {
  __typename?: 'SupplierApplications';
  apps: Array<ApplicationData>;
};

/**
 * Batch upsert of customer (supplier × buyer) level delivery-fee configurations.
 * The batch is atomic (all-or-nothing). For each rule, a non-empty `tiers` list
 * fully overwrites that buyer's configuration and an empty `tiers` list clears
 * (deletes) it. `deliveryFeesRules` must contain 1–50 rules with no duplicate
 * `buyerId`.
 */
export type SupplierBuyerDeliveryFeeUpsertInput = {
  deliveryFeesRules: Array<BuyerDeliveryFeesInput>;
  supplierEntityId: Scalars['String']['input'];
};

export type SupplierBuyerDeliveryFeeUpsertResponse = AuthorizationFailure | InputValidationFailure | SupplierBuyerDeliveryFeeUpsertSuccess;

export type SupplierBuyerDeliveryFeeUpsertSuccess = {
  __typename?: 'SupplierBuyerDeliveryFeeUpsertSuccess';
  /** One entry per input rule, in input order. A cleared buyer is returned as a SupplierDeliveryFee with empty `tiers` and an empty-string `id`. */
  fees: Array<SupplierDeliveryFee>;
  supplierEntityId: Scalars['String']['output'];
};

export type SupplierChatVendorItemUnitVariant = {
  __typename?: 'SupplierChatVendorItemUnitVariant';
  /** ID of the chat context */
  chatId: Scalars['ID']['output'];
  /** The specific ID of this product variant from this supplier in this chat */
  featuredVendorItemUnitId: Scalars['ID']['output'];
  /** Priority order for this variant, the lower the number, the higher the priority (1 is the highest prio) */
  priority: Scalars['Int']['output'];
  /** ID of the supplier */
  supplierId: Scalars['ID']['output'];
};

export type SupplierChatsConnection = {
  __typename?: 'SupplierChatsConnection';
  /** Null cursor indicates the end of the list. */
  cursor?: Maybe<Scalars['String']['output']>;
  edges: Array<SupplierChatsEdge>;
};

export type SupplierChatsEdge = {
  __typename?: 'SupplierChatsEdge';
  node: Chat;
};

export type SupplierChildrenInput = {
  /** Largest number of children to return. Defaults to 500, which is also the most that may be asked for. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SupplierContact = {
  __typename?: 'SupplierContact';
  phoneNumber: Scalars['String']['output'];
  requireOrderReview?: Maybe<Scalars['Boolean']['output']>;
  supplierEntityId: Scalars['ID']['output'];
};

export type SupplierCreateInput = {
  /** allow buyer to add product-level comment to ordered products */
  allowBuyerComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowCustomProducts?: InputMaybe<Scalars['Boolean']['input']>;
  allowEcommercePoNumber?: InputMaybe<Scalars['Boolean']['input']>;
  allowInvoiceOrderGuidePhotoUpload?: InputMaybe<Scalars['Boolean']['input']>;
  allowOnlyOneActiveVariant?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderedProductMerging?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Which stock statuses are visible to buyers when browsing the catalog in chat/ecommerce.
   * When not provided, defaults to in-stock only.
   * The list must always include `InStock`; omitting it or passing an empty list will result in a validation error.
   * Note that buyers may still see units with other stock statuses via the Order Guide or Units Of Measure screen.
   * Duplicate values are silently deduplicated.
   */
  buyerVisibleStockStatuses?: InputMaybe<Array<VendorItemUnitStockStatus | '%future added value'>>;
  /** decimal places used when computing prices/taxes (defaults to the currency's minor units) */
  calculationPrecision?: InputMaybe<Scalars['Int']['input']>;
  /** vendor's own identifier for this supplier, used for integration and reference lookups */
  code?: InputMaybe<Scalars['String']['input']>;
  /**
   * multiple email addresses which will be used when sending the new chat
   * created email via the “Add your suppliers” page.
   */
  contactEmails?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  customerNumberMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use SupplierDeliverySetting { cutOffTime } instead */
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  /** supplier's default ISO 4217 currency code (e.g. EUR) */
  defaultCurrency?: InputMaybe<Scalars['String']['input']>;
  defaultSubCatalog?: InputMaybe<Scalars['String']['input']>;
  deliveryCosts?: InputMaybe<Scalars['String']['input']>;
  deliveryDateMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryZones?: InputMaybe<Array<DeliveryZoneInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  disableCustomerNumberEdits?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable ecommerce products grid view in catalog and order guide */
  enableEcommerceProductGridView?: InputMaybe<Scalars['Boolean']['input']>;
  enableFractionalUnits?: InputMaybe<Scalars['Boolean']['input']>;
  /** gate the checkout promotion engine for this supplier (unset = disabled) */
  enablePromotions?: InputMaybe<Scalars['Boolean']['input']>;
  /** gate the checkout tax engine for this supplier (unset = disabled) */
  enableTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  hasCoverPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfilePhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasValidCatalogProducts?: InputMaybe<Scalars['Boolean']['input']>;
  hideMyPrice?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Type of this supplier in the multi-entity hierarchy.
   * Omitting it creates a Warehouse.
   *
   * An Organization and a Distributor are created with no bot user.
   */
  hierarchyType?: InputMaybe<SupplierHierarchyType | '%future added value'>;
  id: Scalars['String']['input'];
  integration: Array<IntegrationOptionInput>;
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated we no longer support it */
  isInstantInvoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIntegrated?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated we no longer support it */
  isPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** set this flag to enroll this supplier as a test supplier on Choco's Dogfood programme */
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  locale: Scalars['String']['input'];
  minOrder?: InputMaybe<MinOrderInput>;
  minOrderAmount?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  noDefaultCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Direct parent of the new supplier. An Organization must have none, a
   * Distributor may name an Organization, a Warehouse may name a Distributor.
   * Omitting it creates a hierarchy root.
   */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** settings that determine the display of price in catalog products to (potential) buyer(s) */
  priceSetting?: InputMaybe<PriceSettingInput>;
  /** which date drives ordering-stage price/promotion/tax evaluation (defaults to ORDER_DATE) */
  pricingDateSource?: InputMaybe<PricingDateSource | '%future added value'>;
  primaryAssortment?: InputMaybe<Scalars['String']['input']>;
  secondaryAssortments?: InputMaybe<Array<Scalars['String']['input']>>;
  sortCartBy?: InputMaybe<SortCartBy | '%future added value'>;
  /** IANA timezone code, e.g: Europe/Berlin */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierDeliveryDateSettings = {
  __typename?: 'SupplierDeliveryDateSettings';
  availableDeliveryDates: Array<AvailableDeliveryDate>;
  /**
   * CutOffTime configuration for supplier
   * @deprecated Use 'availableDeliveryDates'
   */
  cutOffTime?: Maybe<CutOffTime>;
  /**
   * Available delivery dates for supplier within the next 30 days in UTC && YYYY-MM-DD format
   * @deprecated Use 'availableDeliveryDates'
   */
  deliveryDates?: Maybe<Array<Scalars['AWSDate']['output']>>;
  /**
   * delivery days of the week -> Sunday - Saturday : 0 - 6
   * @deprecated Use 'availableDeliveryDates'
   */
  deliveryDays?: Maybe<Array<Scalars['Int']['output']>>;
  /** Supplier time zone, defaults to America/Los_Angeles */
  timezone: Scalars['String']['output'];
};

export type SupplierDeliveryDateSettingsResponse = SupplierDeliveryDateSettings | SupplierDeliverySettingsNotFound | SupplierNotFound;

export type SupplierDeliveryFee = {
  __typename?: 'SupplierDeliveryFee';
  /** Null for SUPPLIER_DEFAULT (supplier-level) configurations. */
  buyerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  tiers: Array<DeliveryFeeTier>;
  type: SupplierDeliveryFeeType | '%future added value';
};

export const SupplierDeliveryFeeType = {
  Customer: 'CUSTOMER',
  SupplierDefault: 'SUPPLIER_DEFAULT'
} as const;

export type SupplierDeliveryFeeType = typeof SupplierDeliveryFeeType[keyof typeof SupplierDeliveryFeeType];
/**
 * Upsert of the supplier (Dx default) level delivery fee configuration.
 * Providing a non-empty `tiers` list fully overwrites the existing configuration.
 * Providing an empty `tiers` list clears (deletes) the configuration — there is no
 * separate delete mutation.
 */
export type SupplierDeliveryFeeUpsertInput = {
  supplierEntityId: Scalars['String']['input'];
  /** Non-empty: replaces the configuration. Empty: clears (deletes) it. */
  tiers: Array<DeliveryFeeTierInput>;
};

export type SupplierDeliveryFeeUpsertResponse = AuthorizationFailure | InputValidationFailure | SupplierDeliveryFeeUpsertSuccess;

export type SupplierDeliveryFeeUpsertSuccess = {
  __typename?: 'SupplierDeliveryFeeUpsertSuccess';
  /** The resulting configuration. When the configuration was cleared, `fee.tiers` is an empty list and `fee.id` is an empty string. */
  fee: SupplierDeliveryFee;
  supplierEntityId: Scalars['String']['output'];
};

export type SupplierDeliveryFees = {
  __typename?: 'SupplierDeliveryFees';
  fees: Array<SupplierDeliveryFee>;
  supplierEntityId: Scalars['String']['output'];
};

export type SupplierDeliveryFeesInput = {
  buyerId?: InputMaybe<Scalars['String']['input']>;
  supplierEntityId: Scalars['String']['input'];
};

export type SupplierDeliveryFeesResponse = AuthorizationFailure | InputValidationFailure | SupplierDeliveryFees;

export type SupplierDeliverySetting = {
  __typename?: 'SupplierDeliverySetting';
  /** Buffer time in minutes to extend cutoff time for OrderAgent orders. Range: 0-1440 minutes (24 hours). */
  bufferInMinutes?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use cutoffTimes & cutoffType */
  cutOffTime?: Maybe<CutOffTime>;
  cutoffTimes: WeekdayBasedCutoffSettings;
  /** This field aggregates the cutoffType for each provided day. If the type is not the same for all the provided days, it will be null. */
  cutoffType?: Maybe<CutOffTimeType | '%future added value'>;
  /**
   * Sunday - Saturday : 0 - 6
   * @deprecated Use cutoffTimes
   */
  deliveryDays?: Maybe<Array<Scalars['Int']['output']>>;
  exceptions?: Maybe<Array<DeliverySettingException>>;
  /** supplier entity ID or chat ID */
  id: Scalars['ID']['output'];
  /** Whether the supplier has enabled the OrderAgent smart cutoff feature */
  orderAgentSmartCutoff?: Maybe<Scalars['Boolean']['output']>;
  scope: SupplierDeliverySettingScope | '%future added value';
  /** Supplier time zone, defaults to America/Los_Angeles */
  timezone: Scalars['String']['output'];
  /** @deprecated Use scope */
  type: SupplierDeliverySettingType | '%future added value';
};

export type SupplierDeliverySettingInput = {
  /** Buffer time in minutes to extend cutoff time for OrderAgent orders. Range: 0-1440 minutes (24 hours). */
  bufferInMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Use cutoffTimes & cutoffType */
  cutOffTime?: InputMaybe<CutOffTimeInput>;
  /** Please provide either cutoffTimes or exceptions */
  cutoffTimes?: InputMaybe<WeekdayBasedCutoffSettingsInput>;
  /**
   * Sunday - Saturday : 0 - 6
   * @deprecated Use cutoffTimes
   */
  deliveryDays?: InputMaybe<Array<Scalars['Int']['input']>>;
  exceptions?: InputMaybe<Array<DeliveryExceptionInput>>;
  /** supplier entity ID or chat ID */
  id: Scalars['ID']['input'];
  /** Whether the supplier has enabled the OrderAgent smart cutoff feature */
  orderAgentSmartCutoff?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<SupplierDeliverySettingScope | '%future added value'>;
  type: SupplierDeliverySettingType | '%future added value';
};

export const SupplierDeliverySettingScope = {
  Chat: 'chat',
  Supplier: 'supplier'
} as const;

export type SupplierDeliverySettingScope = typeof SupplierDeliverySettingScope[keyof typeof SupplierDeliverySettingScope];
export const SupplierDeliverySettingType = {
  Chat: 'chat',
  Supplier: 'supplier'
} as const;

export type SupplierDeliverySettingType = typeof SupplierDeliverySettingType[keyof typeof SupplierDeliverySettingType];
export type SupplierDeliverySettingsNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'SupplierDeliverySettingsNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type SupplierDetails = {
  __typename?: 'SupplierDetails';
  supplier?: Maybe<Supplier>;
};

export type SupplierFilter = {
  coordinates?: InputMaybe<CoordinateInput>;
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierGetInTouchRequestError = AppsyncError & AppsyncResponse & {
  __typename?: 'SupplierGetInTouchRequestError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type SupplierGetInTouchRequestInput = {
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierGetInTouchRequestResponse = SupplierGetInTouchRequestError | SupplierGetInTouchRequestSuccess;

export type SupplierGetInTouchRequestSuccess = AppsyncResponse & {
  __typename?: 'SupplierGetInTouchRequestSuccess';
  errors: Array<SupplierUpdateError>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type SupplierHierarchyListEdge = Edge & {
  __typename?: 'SupplierHierarchyListEdge';
  cursor: Scalars['String']['output'];
  node: Supplier;
};

export type SupplierHierarchyListFilter = {
  /** Return only suppliers with one of the provided types. */
  hierarchyType?: InputMaybe<Array<SupplierHierarchyType | '%future added value'>>;
};

export type SupplierHierarchyListInput = {
  filter?: InputMaybe<SupplierHierarchyListFilter>;
  /** Id of the hierarchy root entity */
  hierarchyRootId: Scalars['ID']['input'];
  /** Defaults to the first 200 forward; 500 is the largest page that may be asked for. */
  pagination?: InputMaybe<PaginationInputV2>;
};

export type SupplierHierarchyListResponse = AuthorizationFailure | InputValidationFailure | SupplierHierarchyListResult | SupplierNotAHierarchyRoot;

export type SupplierHierarchyListResult = AppsyncResponse & Connection & Page & {
  __typename?: 'SupplierHierarchyListResult';
  edges: Array<SupplierHierarchyListEdge>;
  pageInfo: PageInfo;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

/** Place of a supplier in the multi-entity hierarchy. */
export const SupplierHierarchyType = {
  Distributor: 'Distributor',
  Organization: 'Organization',
  Warehouse: 'Warehouse'
} as const;

export type SupplierHierarchyType = typeof SupplierHierarchyType[keyof typeof SupplierHierarchyType];
/**
 * The supplier has a parent or children, so its `hierarchyType` cannot change.
 * Detach it from both first.
 */
export type SupplierHierarchyTypeNotChangeable = AppsyncError & AppsyncResponse & {
  __typename?: 'SupplierHierarchyTypeNotChangeable';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type SupplierHierarchyUpdateInput = {
  /**
   * New type for the supplier. Omitting it keeps the stored one.
   * Only changeable while the supplier has no parent and no children.
   */
  hierarchyType?: InputMaybe<SupplierHierarchyType | '%future added value'>;
  /** The new direct parent. Null detaches the supplier, which becomes its own hierarchy root */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** The supplier to move. Its `hierarchyType` decides which parents are legal */
  supplierId: Scalars['ID']['input'];
};

export type SupplierHierarchyUpdateResponse = AuthorizationFailure | InputValidationFailure | SupplierHierarchyTypeNotChangeable | SupplierHierarchyUpdateResult | SupplierInvalidHierarchyParent | SupplierNotFound;

export type SupplierHierarchyUpdateResult = AppsyncResponse & {
  __typename?: 'SupplierHierarchyUpdateResult';
  /**
   * Every supplier this call rewrote: the moved supplier first, then each
   * affected descendant.
   */
  affectedSuppliers: Array<SupplierRef>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  /** The moved supplier, with its derived hierarchy fields already rewritten */
  supplier: Supplier;
};

/**
 * The proposed parent cannot hold this supplier: an Organization is always a root,
 * a Distributor belongs under an Organization, a Warehouse belongs under a
 * Distributor, and no supplier may be its own parent.
 */
export type SupplierInvalidHierarchyParent = AppsyncError & AppsyncResponse & {
  __typename?: 'SupplierInvalidHierarchyParent';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type SupplierInviteError = AppsyncError & AppsyncResponse & {
  __typename?: 'SupplierInviteError';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

/** ORDER EXPORT CONFIG ENDS HERE ......... */
export type SupplierInviteResponseEntity = Chat | InvalidInvitedPhoneNumber | SupplierInviteError | User;

export type SupplierInviteUserResponse = {
  __typename?: 'SupplierInviteUserResponse';
  chatUsers: Array<Maybe<ChatUser>>;
  inviteResponse: Array<Maybe<SupplierInviteResponseEntity>>;
};

export type SupplierLabelsList = {
  __typename?: 'SupplierLabelsList';
  labels: Array<ChatLabel>;
};

export type SupplierLabelsResponse = AuthorizationFailure | InputValidationFailure | SupplierLabelsList;

export type SupplierNegotiatedPrice = {
  __typename?: 'SupplierNegotiatedPrice';
  createdAt: Scalars['AWSTimestamp']['output'];
  price: Money;
  updatedAt: Scalars['AWSTimestamp']['output'];
  versionTimestamp: Scalars['AWSTimestamp']['output'];
};

/** The listed supplier exists but it is not a root of the hierarchy. */
export type SupplierNotAHierarchyRoot = AppsyncError & AppsyncResponse & {
  __typename?: 'SupplierNotAHierarchyRoot';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type SupplierNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'SupplierNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export const SupplierOrderChannel = {
  App: 'app',
  EasyUpload: 'easyUpload',
  Email: 'email',
  Sms: 'sms',
  Upload: 'upload',
  VoiceCall: 'voiceCall',
  WhatsApp: 'whatsApp',
  Whatsapp: 'whatsapp'
} as const;

export type SupplierOrderChannel = typeof SupplierOrderChannel[keyof typeof SupplierOrderChannel];
export type SupplierOrderOverridePermissionsInput = {
  supplierId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type SupplierOrderOverridePermissionsResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | UserOrderOverridePermissions;

export type SupplierPhoneNumberConflictResult = {
  __typename?: 'SupplierPhoneNumberConflictResult';
  hasConflict: Scalars['Boolean']['output'];
  phoneNumber: Scalars['String']['output'];
  supplierCount: Scalars['Int']['output'];
};

export type SupplierProductInput = {
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  baseUnit?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Price in ¢
   *
   * have in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = 135
   *    currency = 'USD'
   *
   * 1.35 € ->
   *    cost = 135
   *    currency = 'EUR'
   *
   * 1.3 CLF ->
   *    cost = 1300
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = 135
   *    currency = 'GNF'
   */
  cost?: InputMaybe<Scalars['Int']['input']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code */
  currency?: InputMaybe<Scalars['String']['input']>;
  cutOffTime?: InputMaybe<Scalars['AWSTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with UPC */
  ean?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId: Scalars['String']['input'];
  invoiceUnit?: InputMaybe<Scalars['String']['input']>;
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  minimumFractionalAmount?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  /** Country code in ISO alpha2Code e.g. DE for Germany */
  origin?: InputMaybe<Scalars['String']['input']>;
  packSize?: InputMaybe<Scalars['String']['input']>;
  /** ExternalId of parent product */
  parentId?: InputMaybe<Scalars['String']['input']>;
  primaryCatalogCategory?: InputMaybe<Scalars['String']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  supplierId: Scalars['ID']['input'];
  unit: Scalars['String']['input'];
  /** Product bar code; should not be provided with EAN */
  upc?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A lightweight reference to a Supplier entity.
 * Use the `node` field to resolve the full Supplier object when needed.
 */
export type SupplierRef = RefEdge & {
  __typename?: 'SupplierRef';
  /** The ID of the referenced supplier */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the full Supplier object by its ID.
   * Note that the reference might be stale and therefore the supplier might not exist.
   */
  node?: Maybe<Supplier>;
};

export type SupplierSearchEdge = Edge & {
  __typename?: 'SupplierSearchEdge';
  cursor: Scalars['String']['output'];
  node: Supplier;
};

export type SupplierSearchFilter = {
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupplierSearchInput = {
  filter?: InputMaybe<SupplierSearchFilter>;
  keywords?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierSearchResponse = AuthorizationFailure | InputValidationFailure | SearchSupplierConnection;

export type SupplierSearchV2Filter = {
  assortments?: InputMaybe<Array<Scalars['String']['input']>>;
  hasCompanyName?: InputMaybe<Scalars['Boolean']['input']>;
  hasCoverPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasLocale?: InputMaybe<Scalars['Boolean']['input']>;
  hasOrderTransmission?: InputMaybe<Scalars['Boolean']['input']>;
  hasPrimaryAssortment?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfilePhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  hasValidCatalogProducts?: InputMaybe<Scalars['Boolean']['input']>;
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  searchKeyword?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierSetting = {
  __typename?: 'SupplierSetting';
  allowedAutoPilotCustomers: AllowedAutoPilotCustomersConnection;
  allowedCustomerCount: Scalars['Int']['output'];
  autoPilotDefaultMode: AutoPilotDefaultMode | '%future added value';
  autoPilotEnabled?: Maybe<Scalars['Boolean']['output']>;
  automaticProductReplacementEnabled?: Maybe<Scalars['Boolean']['output']>;
  autopilotThreshold?: Maybe<AutopilotThreshold>;
  blockedAutoPilotCustomers: BlockedAutoPilotCustomersConnection;
  blockedCustomerCount: Scalars['Int']['output'];
  isOnboarded?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Indicates whether ChocoAI/OrderAgent is enabled for this supplier.
   * When true, the supplier can receive and process orders.
   */
  isOrderAgentEnabled: Scalars['Boolean']['output'];
  markDuplicateOrdersEnabled?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  prepMethods?: Maybe<Array<Scalars['String']['output']>>;
  supplierId: Scalars['ID']['output'];
};


export type SupplierSettingAllowedAutoPilotCustomersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type SupplierSettingBlockedAutoPilotCustomersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type SupplierSettingInput = {
  autoPilotDefaultMode?: InputMaybe<AutoPilotDefaultMode | '%future added value'>;
  autopilotThreshold?: InputMaybe<AutomationLevel | '%future added value'>;
  enableAutoPilot?: InputMaybe<Scalars['Boolean']['input']>;
  enableAutoPilotForCustomers?: InputMaybe<Array<Scalars['ID']['input']>>;
  enableAutomaticProductReplacement?: InputMaybe<Scalars['Boolean']['input']>;
  enableMarkDuplicateOrders?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Indicates whether ChocoAI/OrderAgent is enabled for this supplier.
   * When true, the supplier can receive and process orders.
   */
  isOrderAgentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  prepMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  requireOrderReviewForCustomers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Will be set to true for onboarding purspose
   * All IDs sent will updated based on mode
   * All others will be set to the inverse value
   */
  resetAutopilotEnabledSettingForAllCustomers?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId: Scalars['ID']['input'];
};

export type SupplierSettingResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | NotFoundError | SupplierSetting;

export type SupplierUpdateAccessPackageError = AppsyncError & AppsyncResponse & {
  __typename?: 'SupplierUpdateAccessPackageError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type SupplierUpdateAccessPackageInput = {
  accessPackage: AccessPackage | '%future added value';
  supplierId: Scalars['String']['input'];
};

export type SupplierUpdateAccessPackageResponse = SupplierUpdateAccessPackageError | SupplierUpdateAccessPackageSuccess;

export type SupplierUpdateAccessPackageSuccess = AppsyncResponse & {
  __typename?: 'SupplierUpdateAccessPackageSuccess';
  errors: Array<SupplierUpdateError>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type SupplierUpdateError = {
  __typename?: 'SupplierUpdateError';
  message: Scalars['String']['output'];
  supplierId: Scalars['String']['output'];
};

export type SupplierUpdateInput = {
  /** allow buyer to add product-level comment to ordered products */
  allowBuyerComment?: InputMaybe<Scalars['Boolean']['input']>;
  allowCustomProducts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only definable for Premium and LeadGen suppliers */
  allowCustomerAcquisition?: InputMaybe<Scalars['Boolean']['input']>;
  allowEcommercePoNumber?: InputMaybe<Scalars['Boolean']['input']>;
  allowInvoiceOrderGuidePhotoUpload?: InputMaybe<Scalars['Boolean']['input']>;
  allowOnlyOneActiveVariant?: InputMaybe<Scalars['Boolean']['input']>;
  allowOrderedProductMerging?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Which stock statuses are visible to buyers when browsing the catalog in chat/ecommerce.
   * - If not provided, the existing value is preserved.
   * - If set to null, the setting is reset to the default (in-stock only).
   * - The list must always include `InStock`; omitting it or passing an empty list will result in a validation error.
   * - Note that buyers may still see units with other stock statuses via the Order Guide or Units Of Measure screen.
   * - Duplicate values are silently deduplicated.
   */
  buyerVisibleStockStatuses?: InputMaybe<Array<VendorItemUnitStockStatus | '%future added value'>>;
  /** decimal places used when computing prices/taxes (defaults to the currency's minor units) */
  calculationPrecision?: InputMaybe<Scalars['Int']['input']>;
  /**
   * vendor's own identifier for this supplier, used for integration and reference lookups.
   * - If not provided, the existing value is preserved.
   * - If set to null, the value is cleared.
   * - An empty string will result in a validation error.
   */
  code?: InputMaybe<Scalars['String']['input']>;
  /**
   * multiple email addresses which will be used when sending the new chat
   * created email via the “Add your suppliers” page.
   */
  contactEmails?: InputMaybe<Array<Scalars['AWSEmail']['input']>>;
  customerNumberMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use SupplierDeliverySetting { cutOffTime } instead */
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  /** supplier's default ISO 4217 currency code (e.g. EUR) */
  defaultCurrency?: InputMaybe<Scalars['String']['input']>;
  defaultSubCatalog?: InputMaybe<Scalars['String']['input']>;
  deliveryCosts?: InputMaybe<Scalars['String']['input']>;
  deliveryDateMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryZones?: InputMaybe<Array<DeliveryZoneInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  disableCustomerNumberEdits?: InputMaybe<Scalars['Boolean']['input']>;
  /** enable ecommerce products grid view in catalog and order guide */
  enableEcommerceProductGridView?: InputMaybe<Scalars['Boolean']['input']>;
  enableFractionalUnits?: InputMaybe<Scalars['Boolean']['input']>;
  /** gate the checkout promotion engine for this supplier (unset = disabled) */
  enablePromotions?: InputMaybe<Scalars['Boolean']['input']>;
  /** gate the checkout tax engine for this supplier (unset = disabled) */
  enableTaxes?: InputMaybe<Scalars['Boolean']['input']>;
  hasCoverPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfilePhoto?: InputMaybe<Scalars['Boolean']['input']>;
  hasValidCatalogProducts?: InputMaybe<Scalars['Boolean']['input']>;
  hideMyPrice?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  integration?: InputMaybe<Array<IntegrationOptionInput>>;
  isDiscoverable?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated we no longer support it */
  isInstantInvoiceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIntegrated?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated we no longer support it */
  isPaymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  minOrder?: InputMaybe<MinOrderInput>;
  minOrderAmount?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  noDefaultCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** settings that determine the display of price in catalog products to (potential) buyer(s) */
  priceSetting?: InputMaybe<PriceSettingInput>;
  /** which date drives ordering-stage price/promotion/tax evaluation (defaults to ORDER_DATE) */
  pricingDateSource?: InputMaybe<PricingDateSource | '%future added value'>;
  primaryAssortment?: InputMaybe<Scalars['String']['input']>;
  secondaryAssortments?: InputMaybe<Array<Scalars['String']['input']>>;
  sortCartBy?: InputMaybe<SortCartBy | '%future added value'>;
  /** IANA timezone code, e.g: Europe/Berlin */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type SupplierUserConnection = Connection & {
  __typename?: 'SupplierUserConnection';
  edges?: Maybe<Array<SupplierUserEdge>>;
};

export type SupplierUserCreateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type SupplierUserEdge = Edge & {
  __typename?: 'SupplierUserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type SupplierUserRemoveInput = {
  userId: Scalars['String']['input'];
};

export type SupplierUserRemoveResponse = AppsyncResponse & {
  __typename?: 'SupplierUserRemoveResponse';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type SupplierUserUpdateChatsInput = {
  addTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeFrom?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId: Scalars['String']['input'];
};

export type SupplierUserUpdateChatsResponse = {
  __typename?: 'SupplierUserUpdateChatsResponse';
  addedTo: Array<Maybe<Scalars['String']['output']>>;
  removedFrom: Array<Maybe<Scalars['String']['output']>>;
  userId: Scalars['String']['output'];
};

export type SupplierVendorItemUnitVariant = SupplierChatVendorItemUnitVariant;

export type SupportCode = {
  __typename?: 'SupportCode';
  code: Scalars['String']['output'];
  /**
   * When the code expires and the next one takes over. The service can still
   * accept this code for a short grace period after this, so a code read just
   * before it expires still works.
   */
  expiresAt: Scalars['AWSDateTime']['output'];
};

export type SupportCodeGetResponse = AuthorizationFailure | SupportCode;

export const SwitchAndSaveCandidateUnavailableReason = {
  CandidateNotCheaper: 'CANDIDATE_NOT_CHEAPER',
  NotVisibleToChat: 'NOT_VISIBLE_TO_CHAT',
  NotVisibleToUserRole: 'NOT_VISIBLE_TO_USER_ROLE'
} as const;

export type SwitchAndSaveCandidateUnavailableReason = typeof SwitchAndSaveCandidateUnavailableReason[keyof typeof SwitchAndSaveCandidateUnavailableReason];
export type SwitchAndSaveHint = {
  __typename?: 'SwitchAndSaveHint';
  /** The candidate unit ID to fetch full details for in Phase 2. */
  candidateUnitId: Scalars['ID']['output'];
};

/** A distributor-configured substitute mapping between one source unit and one candidate unit. */
export type SwitchAndSaveMapping = {
  __typename?: 'SwitchAndSaveMapping';
  /** The product suggested as the substitute. */
  candidateVendorItemUnit: VendorItemUnitRef;
  /** Normalization factor used during price comparison. */
  conversionFactor: Scalars['Float']['output'];
  /** Stable mapping record ID. */
  id: Scalars['ID']['output'];
  /** The product currently being substituted. */
  sourceVendorItemUnit: VendorItemUnitRef;
};

/** Legacy conflict type kept temporarily for migration. M1 write contracts now use generic failures instead. */
export type SwitchAndSaveMappingAlreadyExists = {
  __typename?: 'SwitchAndSaveMappingAlreadyExists';
  candidateVendorItemUnitId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  sourceVendorItemUnitId: Scalars['ID']['output'];
};

/** Legacy create-only input. Use `SwitchAndSaveMappingUpsertInput` instead. */
export type SwitchAndSaveMappingCreateInput = {
  candidateVendorItemUnitId: Scalars['ID']['input'];
  conversionFactor: Scalars['Float']['input'];
  sourceVendorItemUnitId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

/** Legacy create-only response. Use `SwitchAndSaveMappingUpsertResponse` instead. */
export type SwitchAndSaveMappingCreateResponse = AuthorizationFailure | InputValidationFailure | SwitchAndSaveMappingCreateResult;

/** Legacy success result for the create-only mutation. */
export type SwitchAndSaveMappingCreateResult = {
  __typename?: 'SwitchAndSaveMappingCreateResult';
  mapping: SwitchAndSaveMapping;
};

export type SwitchAndSaveMappingDeleteInput = {
  id: Scalars['ID']['input'];
};

export type SwitchAndSaveMappingDeleteResponse = AuthorizationFailure | InputValidationFailure | SwitchAndSaveMappingDeleteResult;

export type SwitchAndSaveMappingDeleteResult = {
  __typename?: 'SwitchAndSaveMappingDeleteResult';
  id: Scalars['ID']['output'];
};

export type SwitchAndSaveMappingGetInput = {
  sourceVendorItemUnitId: Scalars['ID']['input'];
};

export type SwitchAndSaveMappingGetResponse = AuthorizationFailure | InputValidationFailure | SwitchAndSaveMappingGetResult;

export type SwitchAndSaveMappingGetResult = {
  __typename?: 'SwitchAndSaveMappingGetResult';
  mappings: Array<SwitchAndSaveMapping>;
};

/** Creates a new mapping when `id` is omitted, otherwise updates the existing mapping. */
export type SwitchAndSaveMappingUpsertInput = {
  /** Existing mapping ID to update. Omit to create. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Full mapping payload written on create or update. */
  mapping: SwitchAndSaveMappingWriteInput;
  /**
   * Optional for supplier callers; defaults to identity.supplierId.
   * Required for choco-admin callers without supplier context.
   */
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type SwitchAndSaveMappingUpsertResponse = AuthorizationFailure | InputValidationFailure | SwitchAndSaveMappingUpsertResult;

/** Successful create or update result for a mapping write. */
export type SwitchAndSaveMappingUpsertResult = {
  __typename?: 'SwitchAndSaveMappingUpsertResult';
  mapping: SwitchAndSaveMapping;
};

/** Full write payload for a mapping record. */
export type SwitchAndSaveMappingWriteInput = {
  /** The candidate unit suggested as replacement. */
  candidateVendorItemUnitId: Scalars['ID']['input'];
  /** Normalization factor used during price comparison. */
  conversionFactor: Scalars['Float']['input'];
  /** The source unit being substituted. */
  sourceVendorItemUnitId: Scalars['ID']['input'];
};

export type SwitchAndSaveRecommendation = {
  __typename?: 'SwitchAndSaveRecommendation';
  /** Full product details for the candidate, sufficient to render a product card. */
  candidateProduct?: Maybe<VendorItemUnitForChat>;
  candidateUnavailableReason?: Maybe<SwitchAndSaveCandidateUnavailableReason | '%future added value'>;
  /** The recommended alternative's unit ID. */
  candidateUnitId: Scalars['ID']['output'];
  /** Normalized savings percentage after applying conversion factor. */
  savingsPercentage?: Maybe<Scalars['Float']['output']>;
  /** The original product's unit ID. */
  sourceUnitId: Scalars['ID']['output'];
};

export type SwitchAndSaveRecommendationPreview = {
  __typename?: 'SwitchAndSaveRecommendationPreview';
  candidateVendorItemUnit: VendorItemUnitRef;
  conversionFactorUsed?: Maybe<Scalars['Float']['output']>;
  conversionRatioReason?: Maybe<Scalars['String']['output']>;
  savingsPercentage?: Maybe<Scalars['Float']['output']>;
  savingsPercentageReason?: Maybe<Scalars['String']['output']>;
  sourceVendorItemUnit: VendorItemUnitRef;
  unavailableReason?: Maybe<SwitchAndSaveRecommendationPreviewUnavailableReason | '%future added value'>;
};

export type SwitchAndSaveRecommendationPreviewInput = {
  mapping: SwitchAndSaveRecommendationPreviewMappingInput;
  /**
   * Optional for supplier-admin callers; defaults to identity.supplierId.
   * Required for choco-admin callers.
   */
  vendorId?: InputMaybe<Scalars['ID']['input']>;
};

export type SwitchAndSaveRecommendationPreviewMappingInput = {
  candidateVendorItemUnitId: Scalars['ID']['input'];
  /**
   * Optional in the contract for future compatibility.
   * Interim behavior: omission returns InputValidationFailure.
   */
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  sourceVendorItemUnitId: Scalars['ID']['input'];
};

export type SwitchAndSaveRecommendationPreviewResponse = AuthorizationFailure | InputValidationFailure | SwitchAndSaveRecommendationPreviewResult;

export type SwitchAndSaveRecommendationPreviewResult = {
  __typename?: 'SwitchAndSaveRecommendationPreviewResult';
  preview: SwitchAndSaveRecommendationPreview;
};

export const SwitchAndSaveRecommendationPreviewUnavailableReason = {
  InvalidSwitchAndSaveMapping: 'INVALID_SWITCH_AND_SAVE_MAPPING'
} as const;

export type SwitchAndSaveRecommendationPreviewUnavailableReason = typeof SwitchAndSaveRecommendationPreviewUnavailableReason[keyof typeof SwitchAndSaveRecommendationPreviewUnavailableReason];
export type SwitchAndSaveRecommendationsInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  /** Source unit IDs collected from Phase 1 hints (where switchAndSaveHint was non-null). */
  sourceUnitIds: Array<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type SwitchAndSaveRecommendationsResponse = AuthorizationFailure | InputValidationFailure | SwitchAndSaveRecommendationsResult;

export type SwitchAndSaveRecommendationsResult = {
  __typename?: 'SwitchAndSaveRecommendationsResult';
  /**
   * Contains one entry per requested sourceUnitId. Entries where candidateProduct
   * is null carry candidateUnavailableReason instead; clients use both IDs on the
   * wrapper to match responses back to their request.
   */
  recommendations: Array<SwitchAndSaveRecommendation>;
};

export type SyncCognitoUserFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'SyncCognitoUserFailure';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type SyncCognitoUserResponse = AuthorizationFailure | NotFoundError | SyncCognitoUserFailure | SyncCognitoUserSuccess;

export type SyncCognitoUserSuccess = {
  __typename?: 'SyncCognitoUserSuccess';
  state: UserCognitoState;
};

export const SyncSource = {
  AutoSync: 'AUTO_SYNC',
  TriggeredByUser: 'TRIGGERED_BY_USER'
} as const;

export type SyncSource = typeof SyncSource[keyof typeof SyncSource];
export const SyncStatus = {
  Failed: 'FAILED',
  InProgress: 'IN_PROGRESS',
  Success: 'SUCCESS'
} as const;

export type SyncStatus = typeof SyncStatus[keyof typeof SyncStatus];
/** Rule to target all contacts of a supplier */
export type TargetAll = {
  __typename?: 'TargetAll';
  /** Type rule to target all contact channels of the supplier (value e.g.: contactEmails) */
  type: Scalars['String']['output'];
};

/** Rule to target specific chat users of the supplier */
export type TargetChatUsers = {
  __typename?: 'TargetChatUsers';
  /** Chat users target for the campaign */
  chatUsers: Array<ChatUsers>;
};

/** Rule to target specific chats of the supplier */
export type TargetChats = {
  __typename?: 'TargetChats';
  /** Chat IDs to target for the campaign */
  chatIds: Array<Scalars['String']['output']>;
};

/** Task status for filtering customers by their task completion state. */
export const TaskStatus = {
  /** Customer has only completed tasks */
  Completed: 'COMPLETED',
  /** Customer has no tasks */
  NoTasks: 'NO_TASKS',
  /** Customer has at least one outstanding task */
  Outstanding: 'OUTSTANDING'
} as const;

export type TaskStatus = typeof TaskStatus[keyof typeof TaskStatus];
export const TaxBehavior = {
  /** The stored price is net; the tax is added on top (B2B default). */
  Exclusive: 'EXCLUSIVE',
  /** The stored price is gross; the tax is embedded and back-calculated out. */
  Inclusive: 'INCLUSIVE'
} as const;

export type TaxBehavior = typeof TaxBehavior[keyof typeof TaxBehavior];
export type TaxJurisdiction = Node & {
  __typename?: 'TaxJurisdiction';
  code: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rates: Array<TaxRate>;
  subdivisionCode?: Maybe<Scalars['String']['output']>;
};

export type TaxJurisdictionListInput = {
  pagination?: InputMaybe<PaginationInputV2>;
  vendorId: Scalars['ID']['input'];
};

export type TaxJurisdictionListResponse = AuthorizationFailure | InputValidationFailure | TaxJurisdictionListResult;

export type TaxJurisdictionListResult = AppsyncResponse & Connection & Page & {
  __typename?: 'TaxJurisdictionListResult';
  edges: Array<TaxJurisdictionListResultEdge>;
  pageInfo: PageInfo;
  responseType: ResponseType | '%future added value';
};

export type TaxJurisdictionListResultEdge = Edge & {
  __typename?: 'TaxJurisdictionListResultEdge';
  cursor: Scalars['String']['output'];
  node: TaxJurisdiction;
};

export type TaxJurisdictionRef = {
  __typename?: 'TaxJurisdictionRef';
  id: Scalars['ID']['output'];
  /** Null when the jurisdiction was deleted after the profile was set. */
  node?: Maybe<TaxJurisdiction>;
};

/** Tax enabled without a chat profile. Does not block. */
export type TaxNotApplicableResult = {
  __typename?: 'TaxNotApplicableResult';
  issues: Array<CartEvaluationIssue>;
};

/**
 * Tax disabled or not requested (EDIT / CANCEL, or supplier Tax off).
 * Does not block.
 */
export type TaxNotEvaluatedResult = {
  __typename?: 'TaxNotEvaluatedResult';
  issues: Array<CartEvaluationIssue>;
};

export type TaxRate = {
  __typename?: 'TaxRate';
  appliesToFreeProducts: Scalars['Boolean']['output'];
  category: TaxRateCategory | '%future added value';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Resolved to the caller's locale when a translation exists. */
  label?: Maybe<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  rateValue: TaxRateValue;
  taxBehavior: TaxBehavior | '%future added value';
  /** First day the rate applies, inclusive. Null means no lower bound. */
  validFrom?: Maybe<Scalars['AWSDate']['output']>;
  /** First day the rate no longer applies, exclusive. Null means no upper bound. */
  validTo?: Maybe<Scalars['AWSDate']['output']>;
};

export const TaxRateCategory = {
  /** Returnable per-unit deposit, such as a bottle deposit. */
  EmptyDeposit: 'EMPTY_DEPOSIT',
  Exempt: 'EXEMPT',
  Reduced: 'REDUCED',
  Standard: 'STANDARD',
  Zero: 'ZERO'
} as const;

export type TaxRateCategory = typeof TaxRateCategory[keyof typeof TaxRateCategory];
/**
 * The value of a tax rate. Exactly one variant applies, resolved via
 * `__typename`.
 */
export type TaxRateValue = FixedAmountTaxRate | PercentageTaxRate;

/**
 * Tax domain outcome. Switch on __typename.
 *
 * Tax disabled is NOT_EVALUATED. Tax enabled without a chat profile is
 * NOT_APPLICABLE and does not block. Evaluation failures are UNAVAILABLE and
 * block commit.
 */
export type TaxResult = TaxNotApplicableResult | TaxNotEvaluatedResult | TaxSuccessResult | TaxUnavailableResult;

/** Complete Tax calculation for REVIEW / create. */
export type TaxSuccessResult = {
  __typename?: 'TaxSuccessResult';
  issues: Array<CartEvaluationIssue>;
  value: TaxValue;
};

export type TaxSummaryLine = {
  __typename?: 'TaxSummaryLine';
  /** Optional locale-resolved rate label for display. */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * Rate value from taxService: PercentageTaxRate | FixedAmountTaxRate
   * (discriminated via __typename). Reuses the union TaxRateValue owned by
   * spaces/erp/services/taxServiceK8s/schema.graphql; not redeclared here, it
   * resolves through the merged AppSync schema. Changing it there changes this
   * contract, so coordinate with Integrations.
   */
  rateValue: TaxRateValue;
  /** Cart-level tax for this rate. */
  taxAmount: MoneyV2;
  /** Tax rate definition id. */
  taxRateId: Scalars['ID']['output'];
  /** Cart-level taxable base for this rate. */
  taxableAmount: MoneyV2;
};

/** Tax evaluation failed or could not complete. Blocks commit. */
export type TaxUnavailableResult = {
  __typename?: 'TaxUnavailableResult';
  issues: Array<CartEvaluationIssue>;
};

export type TaxValue = {
  __typename?: 'TaxValue';
  /**
   * Per-rate tax roll-up for the cart. Tax is cart-level only in v1: there is no
   * per-line tax field and no lineTaxes join on EvaluatedLine / LinePricing.
   * Line money stays net of tax; every gross/tax figure the client renders comes
   * from CartPricing plus this per-rate summary. Per-line tax would be additive
   * later (a tax field on EvaluatedLine) and is not a breaking change.
   * Review primarily uses CartPricing.totalTaxAmount / totalGrossAmount /
   * totalPayableAmount; taxSummary is optional detail when useful.
   */
  taxSummary: Array<TaxSummaryLine>;
};

export type TaxonomyLabel = Node & {
  __typename?: 'TaxonomyLabel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TeamAssignableLocationRoles = {
  __typename?: 'TeamAssignableLocationRoles';
  location: SupplierRef;
  roles: Array<TeamRole>;
};

export type TeamAssignableLocationRolesListInput = {
  workspaceId: Scalars['ID']['input'];
};

export type TeamAssignableLocationRolesListResponse = AuthorizationFailure | InputValidationFailure | TeamAssignableLocationRolesListResult | WorkspaceNotFound;

export type TeamAssignableLocationRolesListResult = AppsyncResponse & {
  __typename?: 'TeamAssignableLocationRolesListResult';
  /** Hierarchy order (depth-first, siblings alphabetical). Empty when the caller can assign nowhere. */
  assignableLocationRoles: Array<TeamAssignableLocationRoles>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type TeamCartExists = {
  __typename?: 'TeamCartExists';
  /** The current team cart for this chat, including updated item counts */
  cart: Cart;
};

export type TeamCartNotFound = {
  __typename?: 'TeamCartNotFound';
  /** Dummy message to make type nonempty, can be ignored */
  dummyMessage?: Maybe<Scalars['String']['output']>;
};

/**
 * Two commands name the same member and location, asking for two contradictory
 * end states. A member holds at most one role per location.
 */
export type TeamConflictingLocationCommands = AppsyncError & AppsyncResponse & {
  __typename?: 'TeamConflictingLocationCommands';
  location: SupplierRef;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  user: UserRef;
};

export type TeamDirectoryEntry = {
  __typename?: 'TeamDirectoryEntry';
  user: UserRef;
};

export type TeamDirectorySearchInput = {
  /** Resume token from a previous page. Omit for the first page. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Page size, counted in members. At most 200. */
  limit: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type TeamDirectorySearchResponse = AuthorizationFailure | InputValidationFailure | TeamDirectorySearchResult | WorkspaceNotFound;

export type TeamDirectorySearchResult = AppsyncResponse & {
  __typename?: 'TeamDirectorySearchResult';
  /** Resume token for the next page. Null once the last member has been returned. */
  cursor?: Maybe<Scalars['String']['output']>;
  entries: Array<TeamDirectoryEntry>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  /** How many members match, across every page. */
  totalCount: ApproximateCount;
};

/** A role held at a location. A member holds at most one role per location. */
export type TeamLocationAssignment = {
  __typename?: 'TeamLocationAssignment';
  location: SupplierRef;
  teamRole: TeamRole;
};

export type TeamLocationAssignmentCommandError = {
  __typename?: 'TeamLocationAssignmentCommandError';
  cause: TeamLocationAssignmentCommandFailure;
  /** Zero-based index into the input commands array. */
  commandIndex: Scalars['Int']['output'];
};

/** A domain validation failure associated with a command in the batch. */
export type TeamLocationAssignmentCommandFailure = TeamConflictingLocationCommands | TeamLocationRoleTypeMismatch | TeamLocationsNotFound | TeamMemberNotFound | TeamRoleNotAssignedAtLocation | TeamRolesNotFound;

/** The location does not resolve, or it sits in a workspace the caller cannot see. */
export type TeamLocationNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'TeamLocationNotFound';
  location: SupplierRef;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

/**
 * The role does not apply at the hierarchy tier of the location it was assigned
 * at.
 */
export type TeamLocationRoleTypeMismatch = AppsyncError & AppsyncResponse & {
  __typename?: 'TeamLocationRoleTypeMismatch';
  locationType: SupplierHierarchyType | '%future added value';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  roleLocationType: SupplierHierarchyType | '%future added value';
};

/**
 * One or more locations do not resolve in the workspace. Every bad id is reported
 * together. A location in another workspace is folded in here rather than
 * revealed.
 */
export type TeamLocationsNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'TeamLocationsNotFound';
  locationIds: Array<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

/** A user's membership of one workspace, with every role they hold in it. */
export type TeamMember = {
  __typename?: 'TeamMember';
  /** Ordered by the location's position in the hierarchy (depth-first, siblings alphabetical). */
  assignedLocationRoles: Array<TeamLocationAssignment>;
  id: Scalars['ID']['output'];
  user: UserRef;
};

export type TeamMemberAddInput = {
  /** The user must already exist in Choco. Creating a new user is an invite, not an add. */
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type TeamMemberAddResponse = AuthorizationFailure | InputValidationFailure | TeamMemberAddResult | TeamMemberAlreadyExists | TeamUserNotFound | WorkspaceNotFound;

export type TeamMemberAddResult = AppsyncResponse & {
  __typename?: 'TeamMemberAddResult';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  /** Added with no roles. Granting roles is teamMemberSetLocationAssignments. */
  teamMember: TeamMember;
};

/** The user is already a member of the workspace. */
export type TeamMemberAlreadyExists = AppsyncError & AppsyncResponse & {
  __typename?: 'TeamMemberAlreadyExists';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  user: UserRef;
};

/**
 * Narrows the members listed to those holding a matching assignment inside the
 * caller's shared scope.
 */
export type TeamMemberFilterInput = {
  locationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamRoleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TeamMemberGetInput = {
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type TeamMemberGetResponse = AuthorizationFailure | InputValidationFailure | TeamMemberGetResult | TeamMemberNotFound | WorkspaceNotFound;

export type TeamMemberGetResult = AppsyncResponse & {
  __typename?: 'TeamMemberGetResult';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  teamMember: TeamMember;
};

/**
 * A member the caller shares at least one location with, and the roles they hold
 * inside the caller's slice.
 */
export type TeamMemberInSharedLocations = {
  __typename?: 'TeamMemberInSharedLocations';
  /** Ordered by the location's position in the hierarchy (depth-first, siblings alphabetical). */
  assignedLocationRoles: Array<TeamLocationAssignment>;
  user: UserRef;
};

/**
 * One explicit change. Assignments at locations not named in the batch are
 * unchanged. A member holds at most one role per location.
 */
export type TeamMemberLocationAssignmentsBatchCommandInput = {
  locationId: Scalars['ID']['input'];
  operation: TeamMemberLocationAssignmentsBatchOperation | '%future added value';
  /** The role to assign for Upsert, or the expected currently assigned role for Delete. */
  roleId: Scalars['ID']['input'];
  /** The existing workspace member whose assignment is changed. */
  userId: Scalars['ID']['input'];
};

/**
 * Validation failed. No commands in the batch are applied. At least one of errors
 * and unapprovedUserRemovals is non-empty. A TeamConflictingLocationCommands
 * failure is decided from the request alone and is returned before workspace
 * access and authorization are checked; every other failure here is reported only
 * after both pass.
 */
export type TeamMemberLocationAssignmentsBatchMutateFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'TeamMemberLocationAssignmentsBatchMutateFailure';
  /**
   * Failures attributable to one command, ordered by commandIndex. A command may
   * have more than one entry when multiple causes are detected.
   */
  errors: Array<TeamLocationAssignmentCommandError>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  /**
   * Members the batch would leave with no roles who were not listed in
   * approvedUserRemovals. Once each, in no particular order.
   */
  unapprovedUserRemovals: Array<UserRef>;
};

export type TeamMemberLocationAssignmentsBatchMutateInput = {
  /**
   * Users the caller approves removing from the workspace, should the batch leave
   * them with no roles. A user left with no roles who is not listed here is
   * reported in unapprovedUserRemovals and no command applies.
   * Evaluated against the final assignments, including Upsert commands, regardless
   * of command order.
   */
  approvedUserRemovals?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Non-empty batch, applied in one transaction. All commands apply, or none do.
   * Commands are a set, not a sequence: the result does not depend on their order.
   * Repeating a userId/locationId pair is a TeamConflictingLocationCommands
   * failure, even across different operations. The same location may appear for
   * different users.
   */
  commands: Array<TeamMemberLocationAssignmentsBatchCommandInput>;
  /** Every command targets a member and location in this workspace. */
  workspaceId: Scalars['ID']['input'];
};

export type TeamMemberLocationAssignmentsBatchMutateResponse = AuthorizationFailure | InputValidationFailure | TeamMemberLocationAssignmentsBatchMutateFailure | TeamMemberLocationAssignmentsBatchMutateResult | WorkspaceNotFound;

export type TeamMemberLocationAssignmentsBatchMutateResult = AppsyncResponse & {
  __typename?: 'TeamMemberLocationAssignmentsBatchMutateResult';
  /** Users removed from the workspace after losing their last role, once each in no particular order. */
  removedUsers: Array<UserRef>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  /** Affected members who remain in the workspace, once each in no particular order, with their final assignments. */
  teamMembers: Array<TeamMember>;
};

/** The change to make to one member's role assignment at one location. */
export const TeamMemberLocationAssignmentsBatchOperation = {
  /** Remove the named role. Fails if the member does not hold it at this location. */
  Delete: 'Delete',
  /** Assign the role, replacing any role the member holds at this location. */
  Upsert: 'Upsert'
} as const;

export type TeamMemberLocationAssignmentsBatchOperation = typeof TeamMemberLocationAssignmentsBatchOperation[keyof typeof TeamMemberLocationAssignmentsBatchOperation];
/**
 * A role granted at a location. Replace semantics: a role already held at this
 * location is replaced, because a member holds one role per location. Repeating a
 * location within a single call is an input error.
 */
export type TeamMemberLocationRoleInput = {
  locationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

/** The subject of the call is not a member of the workspace. */
export type TeamMemberNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'TeamMemberNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  user: UserRef;
};

export type TeamMemberRemoveLocationAssignmentInput = {
  /**
   * Acknowledges that dropping the member's last role removes them from the
   * workspace. Defaults to false, which fails instead so the client can confirm.
   */
  allowRemoveUserFromWorkspace?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  /**
   * The workspace the caller believes the location belongs to. The location alone
   * determines it, so this is not how the workspace is found — it is how the
   * caller says which one it meant, and a location that belongs to another
   * reads as a workspace that does not exist.
   */
  workspaceId: Scalars['ID']['input'];
};

export type TeamMemberRemoveLocationAssignmentResponse = AuthorizationFailure | InputValidationFailure | TeamLocationNotFound | TeamMemberNotFound | TeamMemberRemoveLocationAssignmentResult | TeamMemberWouldBeRemovedFromWorkspace | TeamRoleNotAssignedAtLocation | WorkspaceNotFound;

export type TeamMemberRemoveLocationAssignmentResult = AppsyncResponse & {
  __typename?: 'TeamMemberRemoveLocationAssignmentResult';
  /** True when that was the member's last role, so they left the workspace. */
  removedFromWorkspace: Scalars['Boolean']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type TeamMemberRevokeAllWorkspaceAccessInput = {
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type TeamMemberRevokeAllWorkspaceAccessResponse = AuthorizationFailure | InputValidationFailure | TeamMemberNotFound | TeamMemberRevokeAllWorkspaceAccessResult | WorkspaceNotFound;

export type TeamMemberRevokeAllWorkspaceAccessResult = AppsyncResponse & {
  __typename?: 'TeamMemberRevokeAllWorkspaceAccessResult';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  user: UserRef;
};

export type TeamMemberSetLocationAssignmentsInput = {
  /** Applied in one transaction. All assignments apply, or none do. */
  assignments: Array<TeamMemberLocationRoleInput>;
  userId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type TeamMemberSetLocationAssignmentsResponse = AuthorizationFailure | InputValidationFailure | TeamLocationRoleTypeMismatch | TeamLocationsNotFound | TeamMemberNotFound | TeamMemberSetLocationAssignmentsResult | TeamRolesNotFound | WorkspaceNotFound;

export type TeamMemberSetLocationAssignmentsResult = AppsyncResponse & {
  __typename?: 'TeamMemberSetLocationAssignmentsResult';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  teamMember: TeamMember;
};

/**
 * Removing this role would drop the member's last role, which removes them from
 * the workspace. Returned when the caller did not opt in, so the client can
 * confirm and retry.
 */
export type TeamMemberWouldBeRemovedFromWorkspace = AppsyncError & AppsyncResponse & {
  __typename?: 'TeamMemberWouldBeRemovedFromWorkspace';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  user: UserRef;
};

export type TeamMembersInSharedLocationsListInput = {
  /** Resume token from a previous page. Omit for the first page. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Narrows the members listed, not the assignments each one is listed with.
   * `locationIds` restricts the shared scope to those locations; omit for every
   * location the caller shares.
   */
  filter?: InputMaybe<TeamMemberFilterInput>;
  /** Page size, counted in members. At most 200. */
  limit: Scalars['Int']['input'];
  /** Free-text match over member name. Omit to list every member in the shared scope. */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /**
   * Answer for this member's shared scope instead of the caller's. Choco admin
   * only, whose scope is the whole workspace already, so it only ever narrows what
   * the caller may see. A member who sends it gets AuthorizationFailure.
   */
  viewAsUserId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId: Scalars['ID']['input'];
};

export type TeamMembersInSharedLocationsListResponse = AuthorizationFailure | InputValidationFailure | TeamMembersInSharedLocationsListResult | WorkspaceNotFound;

export type TeamMembersInSharedLocationsListResult = AppsyncResponse & {
  __typename?: 'TeamMembersInSharedLocationsListResult';
  /** Resume token for the next page. Null once the last member has been returned. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  /** Ordered alphabetically by user name. */
  teamMembers: Array<TeamMemberInSharedLocations>;
  /** How many members match, across every page. */
  totalCount: ApproximateCount;
};

/**
 * Per-category team notification toggles for the supplier account
 * (Text and media messages / New orders / Order confirmations).
 * Independent booleans. Same shape as personal prefs; Campaigns is not configurable.
 */
export type TeamNotificationCategorySetting = {
  __typename?: 'TeamNotificationCategorySetting';
  /** Ordinary chat messages (text, media, email-originated, and similar). */
  messages: Scalars['Boolean']['output'];
  /** Order confirmation events in chat. */
  orderConfirmation: Scalars['Boolean']['output'];
  /** Order events in chat. */
  orders: Scalars['Boolean']['output'];
};

/**
 * Partial update of team category toggles.
 * Omitted fields are left unchanged.
 */
export type TeamNotificationCategorySettingInput = {
  messages?: InputMaybe<Scalars['Boolean']['input']>;
  orderConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeamNotificationPreferencesResponse = AuthorizationFailure | InputValidationFailure | TeamNotificationPreferencesResult;

/**
 * Team notification preferences for the supplier account.
 * Missing stored row uses defaults: messages/orders/orderConfirmation true.
 */
export type TeamNotificationPreferencesResult = AppsyncResponse & {
  __typename?: 'TeamNotificationPreferencesResult';
  responseType: ResponseType | '%future added value';
  setting: TeamNotificationCategorySetting;
};

export type TeamNotificationPreferencesUpdateInput = {
  setting: TeamNotificationCategorySettingInput;
};

/**
 * A role a member may hold at one location. Roles are a fixed system catalog;
 * `displayName` and `description` are placeholder copy until the role catalog is real.
 */
export type TeamRole = {
  __typename?: 'TeamRole';
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The hierarchy tier this role may be assigned at. */
  locationType: SupplierHierarchyType | '%future added value';
};

/** The member holds no such role at the location, so there is nothing to remove. */
export type TeamRoleNotAssignedAtLocation = AppsyncError & AppsyncResponse & {
  __typename?: 'TeamRoleNotAssignedAtLocation';
  location: SupplierRef;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  roleId: Scalars['ID']['output'];
};

/** One or more roles do not resolve. Every bad id is reported together. */
export type TeamRolesNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'TeamRolesNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  roleIds: Array<Scalars['ID']['output']>;
};

/** The user does not exist in Choco, so they cannot be added. */
export type TeamUserNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'TeamUserNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  userId: Scalars['ID']['output'];
};

export type TestOrderResponse = {
  __typename?: 'TestOrderResponse';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type TextAttachmentRef = {
  __typename?: 'TextAttachmentRef';
  omnichannelOrderId: Scalars['ID']['output'];
  textRange: TextBlockLocator;
  transmissionAttachmentId?: Maybe<Scalars['ID']['output']>;
  transmissionId?: Maybe<Scalars['ID']['output']>;
};

export type TextBlockLocator = {
  __typename?: 'TextBlockLocator';
  end: TextCursor;
  start: TextCursor;
};

export type TextCursor = {
  __typename?: 'TextCursor';
  column: Scalars['Int']['output'];
  line: Scalars['Int']['output'];
};

export type TimestampAndTimezone = {
  __typename?: 'TimestampAndTimezone';
  /** IANA timezone identifier (e.g. 'Europe/Berlin'). Use this to format the timestamp for display. */
  displayTimezoneHint: Scalars['String']['output'];
  timestamp: Scalars['AWSTimestamp']['output'];
};

export type TopUpEligibleDeliveryDate = {
  __typename?: 'TopUpEligibleDeliveryDate';
  deliveryDate: Scalars['AWSDate']['output'];
};

export type TopUpEligibleDeliveryDatesResponse = AuthorizationFailure | InputValidationFailure | TopUpEligibleDeliveryDatesSuccess;

export type TopUpEligibleDeliveryDatesSuccess = AppsyncResponse & {
  __typename?: 'TopUpEligibleDeliveryDatesSuccess';
  deliveryDates: Array<TopUpEligibleDeliveryDate>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type Transmission = Node & {
  __typename?: 'Transmission';
  attachmentOrderRefs?: Maybe<Array<Maybe<AttachmentOrderRef>>>;
  attachments?: Maybe<Array<TransmissionAttachment>>;
  createdAt: Scalars['AWSTimestamp']['output'];
  /**
   * Whether this transmission's orders are dry-run (test) orders, isolated from
   * the ERP. A voice transmission with no recorded mode counts as a dry run;
   * transmissions from other sources are always `false`.
   */
  dryRun: Scalars['Boolean']['output'];
  executionUrl?: Maybe<ExecutionUrlOutput>;
  forwarder: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  omniChannelOrderIds?: Maybe<Array<Scalars['ID']['output']>>;
  omnichannelOrders: Array<OmnichannelOrder>;
  originalMediaLink: Scalars['String']['output'];
  processorInformation: TransmissionProcessorInformation;
  progressStatus: TransmissionProgressStatus | '%future added value';
  providerId: Scalars['ID']['output'];
  receivedAt: Scalars['String']['output'];
  sender: Scalars['String']['output'];
  status: TransmissionStatus | '%future added value';
  voiceCallMetadata?: Maybe<VoiceCallMetadata>;
};

export type TransmissionAttachment = Node & {
  __typename?: 'TransmissionAttachment';
  contentType: Scalars['String']['output'];
  conversationTranscript?: Maybe<ConversationTranscript>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  omnichannelOrderId?: Maybe<Scalars['ID']['output']>;
  ordersRefs?: Maybe<Array<Maybe<AttachmentOrderRef>>>;
  transcript?: Maybe<AudioTranscript>;
  url: Scalars['String']['output'];
};

/**
 * Classifier verdict for a transmission, including any user-initiated reprocess
 * outcome. Set by the order-classifier step in the smart order processor
 * workflow and updated by `confirmTransmissionNotAnOrder` / `reprocessTransmission`.
 */
export const TransmissionClassification = {
  /**
   * A user reviewed a `notAnOrder` transmission and confirmed it is not an order.
   * Terminal state; no reprocessing was triggered.
   */
  ConfirmedNotAnOrder: 'confirmedNotAnOrder',
  /** The classifier extracted two or more orders. */
  MultiOrder: 'multiOrder',
  /**
   * The classifier determined the transmission does not contain an order.
   * Awaits user action (confirm or contest).
   */
  NotAnOrder: 'notAnOrder',
  /**
   * A user contested a `notAnOrder` classification; reprocessing extracted
   * two or more orders.
   */
  ReprocessedToMultiOrder: 'reprocessedToMultiOrder',
  /**
   * A user contested a `notAnOrder` classification; reprocessing still did not
   * extract any order.
   */
  ReprocessedToNotAnOrder: 'reprocessedToNotAnOrder',
  /**
   * A user contested a `notAnOrder` classification; reprocessing extracted
   * exactly one order.
   */
  ReprocessedToSingleOrder: 'reprocessedToSingleOrder',
  /** The classifier extracted exactly one order. */
  SingleOrder: 'singleOrder',
  /**
   * A voice call ended with nothing to order: the cart was empty or the caller
   * was never identified. Set by the voice agent; unlike `notAnOrder` it creates
   * no placeholder order and awaits no user action.
   */
  VoiceCallNotAnOrder: 'voiceCallNotAnOrder'
} as const;

export type TransmissionClassification = typeof TransmissionClassification[keyof typeof TransmissionClassification];
export type TransmissionConfirmedNotAnOrder = {
  __typename?: 'TransmissionConfirmedNotAnOrder';
  id: Scalars['ID']['output'];
};

export type TransmissionConnection = Connection & {
  __typename?: 'TransmissionConnection';
  edges: Array<TransmissionEdge>;
  pageInfo: PageInfo;
};

export type TransmissionCreatedNotification = {
  __typename?: 'TransmissionCreatedNotification';
  supplierId: Scalars['ID']['output'];
  transmission: Transmission;
};

export type TransmissionEdge = Edge & {
  __typename?: 'TransmissionEdge';
  cursor: Scalars['String']['output'];
  node: Transmission;
};

export type TransmissionEvent = Node & {
  __typename?: 'TransmissionEvent';
  /** A concatenation of ofId:timestamp:toType:to:newState (NOT a UUID), which uniquely IDs every transmission */
  id: Scalars['ID']['output'];
  isDeliveryEvent?: Maybe<Scalars['Boolean']['output']>;
  isFailureEvent?: Maybe<Scalars['Boolean']['output']>;
  /** arbitrary metadata, e.g. email bounce details */
  metaData?: Maybe<Scalars['AWSJSON']['output']>;
  /** e.g. Send, Delivery, Bounce, Read, ... */
  newState: Scalars['String']['output'];
  /** e.g. an orderId for ofIdType: order */
  ofId: Scalars['ID']['output'];
  ofIdType: TransmissionOfType | '%future added value';
  timestamp: Scalars['AWSDateTime']['output'];
  /** e.g. an email address for toType: email */
  to: Scalars['String']['output'];
  toType: TransmissionToType | '%future added value';
};

export type TransmissionEventCreatedNotification = {
  __typename?: 'TransmissionEventCreatedNotification';
  supplierId: Scalars['ID']['output'];
  /** Echoed from the mutation input. The order id is `transmissionEvent.ofId`. */
  transmissionEvent: TransmissionEvent;
};

export type TransmissionEventsInput = {
  /** Maximum number of transmission events to return per recipient */
  limitPerTo?: InputMaybe<Scalars['Int']['input']>;
  /** Filter transmission events by the type of recipient */
  toType?: InputMaybe<TransmissionToType | '%future added value'>;
};

export type TransmissionFilter = {
  /** Filter by classifier verdict. Multi-select; values are OR'd within this field. */
  classifications?: InputMaybe<Array<TransmissionClassification | '%future added value'>>;
  customerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  customerNotMatched?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryDate?: InputMaybe<DateRange>;
  /**
   * Filter by dry-run mode. `true` returns only dry-run (test) transmissions,
   * `false` only real ones; omit for both. A voice transmission with no recorded
   * mode counts as a dry run. Only supported by `voiceCallTransmissions`.
   */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  forwardedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  hasOrderWithComment?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use classifications instead. */
  orderClass?: InputMaybe<OrderClass | '%future added value'>;
  originalSender?: InputMaybe<Array<Scalars['String']['input']>>;
  processingStatus?: InputMaybe<Array<InputMaybe<TransmissionProcessingStatus | '%future added value'>>>;
  receivedAt?: InputMaybe<DateRange>;
  /** Filter by review reason. Multi-select; values are OR'd within this field. */
  reviewReason?: InputMaybe<Array<ReviewReason | '%future added value'>>;
  status?: InputMaybe<TransmissionStatus | '%future added value'>;
  supplierOrderChannel?: InputMaybe<Array<SupplierOrderChannel | '%future added value'>>;
  totalProductsCount?: InputMaybe<Scalars['Int']['input']>;
};

export const TransmissionOfType = {
  Order: 'order'
} as const;

export type TransmissionOfType = typeof TransmissionOfType[keyof typeof TransmissionOfType];
export const TransmissionProcessingStatus = {
  AllPendingReview: 'allPendingReview',
  AllReviewed: 'allReviewed',
  Mixed: 'mixed'
} as const;

export type TransmissionProcessingStatus = typeof TransmissionProcessingStatus[keyof typeof TransmissionProcessingStatus];
export type TransmissionProcessorInformation = {
  __typename?: 'TransmissionProcessorInformation';
  lastProcessedAt: Scalars['AWSTimestamp']['output'];
  processedCount: Scalars['Int']['output'];
};

export const TransmissionProgressStatus = {
  Failed: 'failed',
  PartiallyFailed: 'partiallyFailed',
  Processed: 'processed',
  Processing: 'processing'
} as const;

export type TransmissionProgressStatus = typeof TransmissionProgressStatus[keyof typeof TransmissionProgressStatus];
export type TransmissionReceivedNotification = {
  __typename?: 'TransmissionReceivedNotification';
  supplierId: Scalars['ID']['output'];
  transmission: Transmission;
};

export type TransmissionReprocessStarted = {
  __typename?: 'TransmissionReprocessStarted';
  id: Scalars['ID']['output'];
};

export const TransmissionSortFields = {
  /** Sort by the timestamp when the transmission was created in the system */
  CreatedAt: 'createdAt',
  /** Sort by the customer ID associated with the transmission */
  CustomerId: 'customerId',
  /** Sort by the customer name associated with the transmission */
  CustomerName: 'customerName',
  /** Sort by the earliest delivery date across all orders in the transmission */
  EarliestDeliveryDate: 'earliestDeliveryDate',
  /** When 'Multiple', transmissions will be sorted according to the number of orders in the transmission */
  OrderClass: 'orderClass',
  /** Sort by the original sender of the transmission */
  OriginalSender: 'originalSender',
  /** Sort by the purchase order number associated with the transmission */
  PoNumber: 'poNumber',
  /** Sort by the timestamp when the transmission was received by the system */
  ReceivedAt: 'receivedAt',
  /** Sort by the total count of products across all orders in the transmission */
  TotalProductsCount: 'totalProductsCount'
} as const;

export type TransmissionSortFields = typeof TransmissionSortFields[keyof typeof TransmissionSortFields];
export const TransmissionStatus = {
  Allowed: 'allowed',
  Blocked: 'blocked'
} as const;

export type TransmissionStatus = typeof TransmissionStatus[keyof typeof TransmissionStatus];
export const TransmissionToType = {
  Email: 'email',
  Integrations: 'integrations',
  Lobster: 'lobster',
  Sms: 'sms',
  Whatsapp: 'whatsapp'
} as const;

export type TransmissionToType = typeof TransmissionToType[keyof typeof TransmissionToType];
export type TransmissionV2 = Node & {
  __typename?: 'TransmissionV2';
  /** Attachments included with this transmission, such as files, documents, media or transcripts. */
  attachments?: Maybe<Array<TransmissionAttachment>>;
  /**
   * The classifier verdict for this transmission, including any reprocess
   * outcome. NULL for legacy transmissions processed before the classifier
   * was deployed.
   */
  classification?: Maybe<TransmissionClassification | '%future added value'>;
  /**
   * Whether this transmission's orders are dry-run (test) orders, isolated from
   * the ERP.
   */
  dryRun: Scalars['Boolean']['output'];
  /** The earliest requested delivery date across all the orders within this transmission, in ISO 8601 format. */
  earliestDeliveryDate?: Maybe<Scalars['String']['output']>;
  /** The URL of the execution workflow */
  executionUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The intermediary or service that forwarded this transmission on behalf of the sender.
   * In most cases, it is the source DX used to proxy the requests.
   * Eg: customer@cx.com -> order@dx.com -> od-<supplierId>@choco.app
   */
  forwarder: Scalars['String']['output'];
  /**
   * Id of the transmission.
   * A transmission is a unit of ordering request. A single transmission can result in one or more others.
   */
  id: Scalars['ID']['output'];
  /** The total number of orders in this transmission. */
  numberOfOrders: Scalars['Int']['output'];
  /** Minor details about the order used for displaying preview banner in the order review screen. */
  omnichannelOrderDetails: Array<OmnichannelOrderDetail>;
  /** A link to the original media content associated with this transmission. */
  originalMediaLink: Scalars['String']['output'];
  /** PO (Purchase Order) numbers from all orders within this transmission. */
  poNumbers?: Maybe<Array<Scalars['String']['output']>>;
  /** Information about how many times the transmission has been processed and the last time it was processed. */
  processorInformation: TransmissionProcessorInformation;
  /** The progress state of the transmission, detailing its processing phase. */
  progressStatus: TransmissionProgressStatus | '%future added value';
  /** Id of the source of the transmission. E.g.: Message ID for email (SES). */
  providerId: Scalars['ID']['output'];
  /** The ISO 8601 datetime when this transmission was received by the system (the executor). */
  receivedAt: Scalars['String']['output'];
  /** The original sender of this transmission. */
  sender: Scalars['String']['output'];
  /** The block state of the transmission in the processing workflow. */
  status: TransmissionStatus | '%future added value';
  /** The channel through which the order was received. E.g.: email, sms, whatsapp, voiceCall. */
  supplierOrderChannel?: Maybe<SupplierOrderChannel | '%future added value'>;
  /** The aggregate count of products across all orders in this transmission. */
  totalNumberOfProducts: Scalars['Int']['output'];
};

export type TransmissionV2Connection = Connection & {
  __typename?: 'TransmissionV2Connection';
  edges: Array<TransmissionV2Edge>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type TransmissionV2Edge = Edge & {
  __typename?: 'TransmissionV2Edge';
  cursor: Scalars['String']['output'];
  node: TransmissionV2;
};

export type TransmissionV2OrdersFullyProcessedNotification = {
  __typename?: 'TransmissionV2OrdersFullyProcessedNotification';
  supplierId: Scalars['ID']['output'];
  transmissionIds: Array<Scalars['ID']['output']>;
};

export type TransmissionV2ProcessedNotification = {
  __typename?: 'TransmissionV2ProcessedNotification';
  supplierId: Scalars['ID']['output'];
  transmission: TransmissionV2;
};

export type TransmissionV2ReceivedNotification = {
  __typename?: 'TransmissionV2ReceivedNotification';
  supplierId: Scalars['ID']['output'];
  transmission: TransmissionV2;
};

export type TransmissionsResponse = AuthorizationFailure | InputValidationFailure | InternalServerError | TransmissionV2Connection;

export type TriggerProductMatchingInput = {
  chatId: Scalars['ID']['input'];
  omnichannelOrderId: Scalars['ID']['input'];
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type TriggerProductMatchingResponse = AuthorizationFailure | InputValidationFailure | OmnichannelOrder;

/**
 * The status of the user in Twilio.
 *   Ok - User's phone number is not geo blocked
 *   GeoBlocked - User's phone number belongs to a country that is blocked by VerifyV2 GeoPermissions
 *
 * Note: Right now Twilio's API does not support checking if a number was blocked by FraudGuard.
 * So even if the status returns Ok, it's possible that the number is blocked and can only be checked on Twilio's dashboard.
 */
export const TwilioStatus = {
  GeoBlocked: 'GeoBlocked',
  Ok: 'Ok'
} as const;

export type TwilioStatus = typeof TwilioStatus[keyof typeof TwilioStatus];
export type UnassignUserFromOrderToReviewInput = {
  omnichannelOrderId: Scalars['ID']['input'];
};

export type UnassignUserFromOrderToReviewResponse = InputValidationFailure | InternalServerError | UnassignUserFromOrderToReviewResponseError | UnassignUserFromOrderToReviewResponseSuccess;

export type UnassignUserFromOrderToReviewResponseError = AppsyncError & AppsyncResponse & {
  __typename?: 'UnassignUserFromOrderToReviewResponseError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type UnassignUserFromOrderToReviewResponseSuccess = {
  __typename?: 'UnassignUserFromOrderToReviewResponseSuccess';
  omnichannelOrderId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type UnavailableProductType = {
  __typename?: 'UnavailableProductType';
  availability?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  vendorItemUnit?: Maybe<VendorItemUnitRef>;
};

export type UnconnectedBuyers = {
  __typename?: 'UnconnectedBuyers';
  /** List of buyer ids supplier is not connected with */
  buyerIds: Array<Scalars['String']['output']>;
};

export type UndoMultiLocationOrderGuideTransactionInput = {
  transactionId: Scalars['ID']['input'];
};

export type UndoMultiLocationOrderGuideTransactionResponse = AuthorizationFailure | InputValidationFailure | UndoMultiLocationOrderGuideTransactionResult;

export type UndoMultiLocationOrderGuideTransactionResult = AppsyncResponse & {
  __typename?: 'UndoMultiLocationOrderGuideTransactionResult';
  failedLocationIds: Array<Maybe<Scalars['ID']['output']>>;
  responseType: ResponseType | '%future added value';
  succeededLocationIds: Array<Maybe<Scalars['ID']['output']>>;
};

export const UnitDimension = {
  Count: 'count',
  Logistic: 'logistic',
  Mass: 'mass',
  Volume: 'volume'
} as const;

export type UnitDimension = typeof UnitDimension[keyof typeof UnitDimension];
export type UnitLoyaltyPoints = {
  __typename?: 'UnitLoyaltyPoints';
  /** Null when this line has no points estimate (ineligible item, or no estimate available). Distinct from earning 0 points. */
  points?: Maybe<Scalars['Int']['output']>;
  /** Unrounded Talon amount for this line. Null iff `points` is null. */
  pointsDecimal?: Maybe<Decimal>;
  vendorItemUnitId: Scalars['ID']['output'];
};

export type UnknownFailure = {
  __typename?: 'UnknownFailure';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type UnsupportedIntegrationAdapterType = AppsyncError & AppsyncResponse & {
  __typename?: 'UnsupportedIntegrationAdapterType';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type UpdateBuyerInventoryProductInput = {
  chatId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<MoneyInput>;
  productId: Scalars['ID']['input'];
};

export type UpdateBuyerInventoryProductResponse = AuthorizationFailure | BuyerInventoryProduct | InputValidationFailure;

export type UpdateBuyerStockInventoryProductFailure = {
  __typename?: 'UpdateBuyerStockInventoryProductFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type UpdateBuyerStockInventoryProductInput = {
  buyerId: Scalars['ID']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<MoneyInput>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBuyerStockInventoryProductResponse = AuthorizationFailure | BuyerStockInventoryProduct | InputValidationFailure | ProductNotFoundError | SupplierNotFound | UpdateBuyerStockInventoryProductFailure;

export type UpdateBuyerUserChatsError = AppsyncError & AppsyncResponse & {
  __typename?: 'UpdateBuyerUserChatsError';
  errorCode?: Maybe<UpdateBuyerUserChatsErrorCode | '%future added value'>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export const UpdateBuyerUserChatsErrorCode = {
  GenericError: 'genericError'
} as const;

export type UpdateBuyerUserChatsErrorCode = typeof UpdateBuyerUserChatsErrorCode[keyof typeof UpdateBuyerUserChatsErrorCode];
export type UpdateBuyerUserChatsInput = {
  addTo?: InputMaybe<Array<Scalars['String']['input']>>;
  buyerId: Scalars['String']['input'];
  removeFrom?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};

export type UpdateBuyerUserChatsResponse = AuthorizationFailure | InputValidationFailure | UpdateBuyerUserChatsError | UpdateBuyerUserChatsSuccess;

export type UpdateBuyerUserChatsSuccess = {
  __typename?: 'UpdateBuyerUserChatsSuccess';
  addedTo: Array<Maybe<Scalars['String']['output']>>;
  removedFrom: Array<Maybe<Scalars['String']['output']>>;
  userId: Scalars['String']['output'];
};

/** Input type for updating attachments for a marketing campaign */
export type UpdateCampaignAttachmentInput = {
  /** Marketing campaign attachments */
  attachments: Array<CampaignAttachmentInput>;
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
};

/**
 * Input for updating an existing note.
 * Note, this upsert operation updates all parameters provided. There are no partial updates.
 * Note: target entity is not needed as the note already contains this information.
 */
export type UpdateDistributorNoteInput = {
  /** New plain-text content for the note */
  noteBody: Scalars['String']['input'];
  /** The ID of the note to update */
  noteId: Scalars['ID']['input'];
  /** Title for the note. Null indicates that the title should be removed. */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDistributorNoteResponse = AuthorizationFailure | DistributorNoteUpdateResult | InputValidationFailure | NotFoundError;

/** Input for updating an existing distributor task */
export type UpdateDistributorTaskInput = {
  /** Optional objective/goal */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** When the task is due */
  dueAt: DistributorTaskDueAtInput;
  /** ID of task to update */
  id: Scalars['ID']['input'];
  /** Title of the task */
  title: Scalars['String']['input'];
};

export type UpdateDistributorTaskResponse = AuthorizationFailure | DistributorTask | InputValidationFailure | NotFoundError;

/** Input for updating the status of an existing distributor task */
export type UpdateDistributorTaskStatusInput = {
  /** ID of task to update */
  id: Scalars['ID']['input'];
  /** New status for the task */
  status: DistributorTaskStatus | '%future added value';
};

export type UpdateDistributorTaskStatusResponse = AuthorizationFailure | DistributorTask | InputValidationFailure | NotFoundError;

export type UpdateDocumentScanAttachmentsInput = {
  attachments: Array<DocumentScanAttachmentInput>;
  documentScanId: Scalars['ID']['input'];
};

export type UpdateDocumentScanResponse = AuthorizationFailure | DocumentScanUpdateResult | InputValidationFailure | NotFoundError;

/** Input type for updating email content for a marketing campaign */
export type UpdateEmailContentInput = {
  /** Email body message */
  bodyMessage: Scalars['String']['input'];
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Email image URL */
  imageURL?: InputMaybe<Scalars['String']['input']>;
  /** Email subject */
  subject: Scalars['String']['input'];
  /** Email title */
  title: Scalars['String']['input'];
};

/** Input type for updating the email template and HTML URI. Info is used by the backend for email compilation. */
export type UpdateEmailTemplateUriInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** S3 URI for the email HTML content */
  htmlUri: Scalars['String']['input'];
};

export type UpdateInvoicedProductResponse = AuthorizationFailure | InputValidationFailure | InvoicedProducts;

export type UpdateJoinRequestError = AppsyncError & AppsyncResponse & {
  __typename?: 'UpdateJoinRequestError';
  errorCode?: Maybe<UpdateJoinRequestErrorCode | '%future added value'>;
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export const UpdateJoinRequestErrorCode = {
  GenericError: 'genericError',
  NotAllowedJoinRequestUpdate: 'notAllowedJoinRequestUpdate',
  NotFoundJoinRequest: 'notFoundJoinRequest'
} as const;

export type UpdateJoinRequestErrorCode = typeof UpdateJoinRequestErrorCode[keyof typeof UpdateJoinRequestErrorCode];
export type UpdateJoinRequestInput = {
  id: Scalars['ID']['input'];
  status: JoinRequestAllowedUpdateStatus | '%future added value';
};

export type UpdateJoinRequestResponse = AuthorizationFailure | InputValidationFailure | UpdateJoinRequestError | UpdateJoinRequestSuccess;

export type UpdateJoinRequestSuccess = {
  __typename?: 'UpdateJoinRequestSuccess';
  id: Scalars['String']['output'];
  status: JoinRequestAllowedUpdateStatus | '%future added value';
};

export type UpdateLoyaltySettingsInput = {
  allowNonAdminLoyaltyAccess: Scalars['Boolean']['input'];
  buyerId: Scalars['ID']['input'];
};

export type UpdateLoyaltySettingsResponse = AuthorizationFailure | InputValidationFailure | LoyaltyProviderTemporarilyUnavailable | UpdateLoyaltySettingsSuccess;

export type UpdateLoyaltySettingsSuccess = {
  __typename?: 'UpdateLoyaltySettingsSuccess';
  settings: LoyaltySettings;
};

/** Input type for updating email chat message content for a marketing campaign */
export type UpdateMarketingCampaignChatMessageContentInput = {
  /** Email image URL */
  attachments?: InputMaybe<Array<CampaignAttachmentInput>>;
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Chat Message */
  message: Scalars['String']['input'];
};

/** Input type for setting or clearing the end date of a DRAFT marketing campaign */
export type UpdateMarketingCampaignEndDateInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** End date as an ISO 8601 date string (e.g. "2025-01-15"), interpreted as end-of-day UTC. Omit or pass null to run the campaign indefinitely. */
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

/** Input type for updating home promo content for a marketing campaign */
export type UpdateMarketingCampaignHomePromoContentInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Home promo display image for the banner */
  displayImage?: InputMaybe<CampaignAttachmentInput>;
  /** Home promo display title shown to buyers */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  /** Home promo ordering image for the detail page */
  orderingImage?: InputMaybe<CampaignAttachmentInput>;
  /** Home promo ordering message for the detail page */
  orderingMessage?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for updating a marketing campaign title and channels */
export type UpdateMarketingCampaignInfoInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Channels to be used for the marketing campaign */
  channels: Array<CampaignChannel | '%future added value'>;
  /** Title of the marketing campaign as seen by the supplier */
  title: Scalars['String']['input'];
};

/** Input type for updating preferred products content for a marketing campaign */
export type UpdateMarketingCampaignPreferredProductsContentInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Preferred products title shown to buyers */
  title: Scalars['String']['input'];
};

/** Input type for updating welcome banner content for a marketing campaign */
export type UpdateMarketingCampaignWelcomeBannerContentInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /**
   * Image displayed on the welcome banner detail screen.
   * it is optional, because we allow updating the draft campaigns with incomplete content,
   * but before sending the campaign, we need to have the image.
   * - send null to clear the value
   * - omit or send undefined to keep the existing value
   * - send valid campaign attachment input to update the value
   */
  detailsImage?: InputMaybe<CampaignAttachmentInput>;
  /**
   * Message displayed on the campaign detail screen
   * - send null to clear the value
   * - omit or send undefined to keep the existing value
   * - send valid string to update the value
   */
  detailsMessage?: InputMaybe<Scalars['String']['input']>;
  /**
   * welcome banner image displayed on the home screen.
   * it is optional, because we allow updating the draft campaigns with incomplete content,
   * but before sending the campaign, we need to have the image.
   * - send null to clear the value
   * - omit or send undefined to keep the existing value
   * - send valid campaign attachment input to update the value
   */
  displayImage?: InputMaybe<CampaignAttachmentInput>;
  /**
   * Title displayed over the banner image on the home screen
   * - send null to clear the value
   * - omit or send undefined to keep the existing value
   * - send valid string to update the value
   */
  displayTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMenuScanAttachmentsInput = {
  attachments: Array<MenuScanAttachmentInput>;
  menuScanId: Scalars['ID']['input'];
};

export type UpdateMenuScanResponse = AuthorizationFailure | InputValidationFailure | MenuScanUpdateResult | NotFoundError;

export type UpdateOmnichannelOrderCustomerInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['ID']['input'];
  omnichannelOrderId: Scalars['ID']['input'];
};

export type UpdateOmnichannelOrderCustomerResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | UpdateOmnichannelOrderCustomerSuccess;

export type UpdateOmnichannelOrderCustomerSuccess = {
  __typename?: 'UpdateOmnichannelOrderCustomerSuccess';
  order: OmnichannelOrder;
};

export type UpdateOmnichannelOrderDeliveryDateInput = {
  deliveryTimezone?: InputMaybe<Scalars['String']['input']>;
  omnichannelOrderId: Scalars['ID']['input'];
  requestedDeliveryDate: Scalars['String']['input'];
};

export type UpdateOmnichannelOrderDeliveryDateResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | UpdateOmnichannelOrderDeliveryDateSuccess;

export type UpdateOmnichannelOrderDeliveryDateSuccess = {
  __typename?: 'UpdateOmnichannelOrderDeliveryDateSuccess';
  order: OmnichannelOrder;
};

export type UpdateOmnichannelOrderProductsInput = {
  mode?: InputMaybe<OmnichannelOrderProductsUpdateMode | '%future added value'>;
  omnichannelOrderId: Scalars['ID']['input'];
  products: Array<OmnichannelOrderProductDraftInput>;
  syncToken?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOmnichannelOrderProductsResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | UpdateOmnichannelOrderProductsSuccess;

export type UpdateOmnichannelOrderProductsSuccess = {
  __typename?: 'UpdateOmnichannelOrderProductsSuccess';
  order: OmnichannelOrder;
  syncToken?: Maybe<Scalars['String']['output']>;
};

export type UpdatePendingUserInput = {
  chatId: Scalars['String']['input'];
  user: PendingUserInput;
};

export type UpdatePendingUserResponse = AuthorizationFailure | User;

export type UpdateProductVariantsInOrderGuideInput = {
  categoryId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  selectedVariantIds: Array<Scalars['ID']['input']>;
  /** The variant which the user was navigated from while changing the unit in OG */
  sourceVariantId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateProductVariantsInOrderGuideResponse = AuthorizationFailure | InputValidationFailure | UpdateProductVariantsInOrderGuideSuccess;

export type UpdateProductVariantsInOrderGuideSuccess = AppsyncResponse & {
  __typename?: 'UpdateProductVariantsInOrderGuideSuccess';
  invalidProducts?: Maybe<Array<Scalars['String']['output']>>;
  responseType: ResponseType | '%future added value';
};

export type UpdateQuoteCommentCommandInput = {
  commentText: Scalars['String']['input'];
};

/**
 * At least one of
 * - vendorItemUnitId
 * - quantity
 * - price
 * must be provided.
 */
export type UpdateQuoteItemCommandInput = {
  price?: InputMaybe<MoneyV2Input>;
  quantity?: InputMaybe<DecimalInput>;
  quoteItemId: Scalars['ID']['input'];
  vendorItemUnitId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for the updateSalesFunnelLeadArchiveStatus mutation. */
export type UpdateSalesFunnelLeadArchiveStatusInput = {
  /** True to archive the lead, false to unarchive it */
  isArchived: Scalars['Boolean']['input'];
  /** The ID of the lead to archive or unarchive */
  leadId: Scalars['ID']['input'];
};

export type UpdateSalesFunnelLeadArchiveStatusResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelLead;

export type UpdateSalesFunnelStateOrderInput = {
  salesFunnelId: Scalars['ID']['input'];
  /** The new order of the sales funnel states. Must contain all states. */
  salesFunnelStateIdOrder: Array<Scalars['ID']['input']>;
};

export type UpdateSalesFunnelStateOrderResponse = AuthorizationFailure | InputValidationFailure | SalesFunnelDefinition;

export type UpdateSubCatalogChatsResponse = AuthorizationFailure | UpdateSubCatalogChatsResult;

export type UpdateSubCatalogChatsResult = {
  __typename?: 'UpdateSubCatalogChatsResult';
  errors: Array<InvalidSubCatalogChat>;
  subCatalogChats?: Maybe<UpdateSubCatalogChatsSummary>;
};

export type UpdateSubCatalogChatsSummary = {
  __typename?: 'UpdateSubCatalogChatsSummary';
  created: Array<SubCatalogChat>;
  removed: Array<SubCatalogChat>;
};

export type UpdateSubCatalogError = AppsyncError & AppsyncResponse & {
  __typename?: 'UpdateSubCatalogError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type UpdateSupplierBuyerMovInput = {
  amount: Scalars['Int']['input'];
  buyerId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  /** Whether ordering below the customer MOV is blocked. If unset, the supplier-level strict setting is inherited. */
  strict?: InputMaybe<Scalars['Boolean']['input']>;
  supplierEntityId: Scalars['String']['input'];
};

export type UpdateSupplierContactInput = {
  onboarded?: InputMaybe<Scalars['Boolean']['input']>;
  requireOrderReview?: InputMaybe<Scalars['Boolean']['input']>;
  supplierEntityId: Scalars['ID']['input'];
};

export type UpdateSupplierContactResponse = AuthorizationFailure | InputValidationFailure | SupplierContact;

export type UpdateSupplierProductV2Input = {
  /** @deprecated This field is ignored. Set `cost` and `conversionFactor` and the `basePrice` will be calculated automatically */
  basePrice?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated This field is ignored. Set `invoiceUit` */
  baseUnit?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** How many invoiceUnits are in the main unit. Not touched if not provided */
  conversionFactor?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Price in ¢
   *
   * Keep in mind that different currencies might have different number of
   * significant digits (0, 2, 3, 4). Number represent the cost of the
   * smallest currency denominators
   *
   * 1.35 $ ->
   *    cost = 135
   *    currency = 'USD'
   *
   * 1.3 CLF ->
   *    cost = 1300
   *    currency = 'CLF'
   *
   * 135 GNF ->
   *    cost = 135
   *    currency = 'GNF'
   *
   * Not touched if not provided
   */
  cost?: InputMaybe<Scalars['Int']['input']>;
  /** [ISO-4217](https://en.wikipedia.org/wiki/ISO_4217) currency code. Not touched if not provided */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided. Set to 00:00 to unset */
  cutOffTime?: InputMaybe<Scalars['AWSTime']['input']>;
  /** Not touched if not provided */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with UPC. Not touched if not provided. Set to an empty string to unset */
  ean?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not touched if not provided */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** Not touched if not provided. Set to an empty string to unset */
  invoiceUnit?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided. Set to 0 to unset */
  leadTime?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum ordering quantity, i.e. how many units of the Product should be ordered for the order to be allowed. Not touched if not provided. Set to 0 to unset. */
  minimumFractionalAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Not touched if not provided */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Country code in ISO alpha2Code e.g. DE for Germany. Not touched if not provided */
  origin?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided */
  packSize?: InputMaybe<Scalars['String']['input']>;
  /**
   * Arbitrary code that combines Products as unit variants.
   * All products with the same `parentId` are considered unit variants.
   */
  parentId?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided. Set to an empty string to unset */
  primaryCatalogCategory?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided. Set to an empty string to unset */
  subCategory?: InputMaybe<Scalars['String']['input']>;
  /** Not touched if not provided */
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Product bar code; should not be provided with EAN. Not touched if not provided. Set to an empty string to unset */
  upc?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSupplierUserRolesInput = {
  /** Only one role is allowed. */
  rolesToAdd: Array<Role | '%future added value'>;
  /**
   * All existing roles are overridden by the one specified in rolesToAdd.
   * @deprecated this property is ignored because a supplier user can only have one role.
   */
  rolesToRemove?: InputMaybe<Array<Role | '%future added value'>>;
  userId: Scalars['String']['input'];
};

export type UpdateTransmissionProgressStatusInput = {
  progressStatus: TransmissionProgressStatus | '%future added value';
  transmissionIds: Array<Scalars['String']['input']>;
};

/** Input type for updating vendor item units for a marketing campaign */
export type UpdateVendorItemUnitsInput = {
  /** Marketing campaign id */
  campaignId: Scalars['String']['input'];
  /** Product vendorItemUnitIds */
  vendorItemUnitIds: Array<Scalars['String']['input']>;
};

export type UpdatedCategoryProduct = {
  __typename?: 'UpdatedCategoryProduct';
  categoryId: Scalars['ID']['output'];
  productId: Scalars['ID']['output'];
};

export type UploadSubCatalogProductsError = AppsyncError & AppsyncResponse & {
  __typename?: 'UploadSubCatalogProductsError';
  /** Human readable error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type UploadSubCatalogProductsResponse = UploadSubCatalogProductsError | UploadSubCatalogProductsResult;

export type UploadSubCatalogProductsResult = {
  __typename?: 'UploadSubCatalogProductsResult';
  submittedProductsCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type UploadedOrder = {
  __typename?: 'UploadedOrder';
  chatId?: Maybe<Scalars['ID']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  mediaElements: Array<UploadedOrderMediaElement>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['AWSTimestamp']['output'];
  uploadedOrderId: Scalars['ID']['output'];
  uploaderUserId: Scalars['ID']['output'];
};

export type UploadedOrderMediaElement = {
  __typename?: 'UploadedOrderMediaElement';
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type User = Node & {
  __typename?: 'User';
  birthdate?: Maybe<Scalars['AWSDate']['output']>;
  botUser?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated user {Query.buyerUsers} relationship instead */
  businessName?: Maybe<Scalars['String']['output']>;
  buyers?: Maybe<UserBuyerConnection>;
  challengeByEmail?: Maybe<Scalars['Boolean']['output']>;
  chats: UserChatConnection;
  /** To enable user login with daily code */
  chocoUser?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use user { paginatedContacts } instead */
  contacts?: Maybe<Array<Maybe<User>>>;
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  createdContext?: Maybe<UserCreatedContext | '%future added value'>;
  cutOffTime?: Maybe<Scalars['String']['output']>;
  deliveryCosts?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hasAcceptedTermsAndConditions: Scalars['Boolean']['output'];
  hasRequestedToBeDeleted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** filename of image for internal use only */
  image?: Maybe<Scalars['String']['output']>;
  /** @deprecated not supported due to the migration to Invite Flow V2 */
  inviteData?: Maybe<InviteInfo>;
  inviteTransmissions?: Maybe<Array<InviteTransmission>>;
  /** set this flag to enroll the user as a test user on Choco's Dogfood programme */
  isPuppy: Scalars['Boolean']['output'];
  /** this flag is to enable proper data report on a user */
  isTest?: Maybe<Scalars['Boolean']['output']>;
  linkedSupplier?: Maybe<Supplier>;
  locale?: Maybe<Scalars['String']['output']>;
  loginEmail?: Maybe<Scalars['String']['output']>;
  loginMethod?: Maybe<LoginMethod | '%future added value'>;
  minOrderAmount?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Get the list of validation rules that this user can override when reviewing orders for a specific supplier.
   * Returns an empty array if no override permissions are configured.
   */
  orderOverridePermissions?: Maybe<Array<ValidationRule | '%future added value'>>;
  orderPreference?: Maybe<OrderPreference>;
  paginatedContacts: UserUserConnection;
  paginatedSuppliers: UserUserConnection;
  pending?: Maybe<Scalars['Boolean']['output']>;
  phone: Scalars['String']['output'];
  phoneNumberType?: Maybe<UserPhoneType | '%future added value'>;
  position?: Maybe<Scalars['String']['output']>;
  profileImage?: Maybe<ProfileImage>;
  referral?: Maybe<GetReferralResponse>;
  role?: Maybe<Array<Maybe<Role | '%future added value'>>>;
  /** submittedGetIntouchRequest: always false if the user is a buyer user, and true if the user is a supplier user and has made a request to be contacted for premium details at least once */
  submittedGetIntouchRequest?: Maybe<Scalars['Boolean']['output']>;
  supplier: Scalars['Boolean']['output'];
  supplierId?: Maybe<Scalars['String']['output']>;
  suppliers?: Maybe<Array<Maybe<User>>>;
  translationLanguage?: Maybe<Scalars['String']['output']>;
};


export type UserBuyersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type UserChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ignoreChatsWithStatus?: InputMaybe<Array<InputMaybe<ChatStatus>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserOrderOverridePermissionsArgs = {
  supplierId: Scalars['ID']['input'];
};


export type UserPaginatedContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type UserPaginatedSuppliersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type UserAddedToChat = {
  __typename?: 'UserAddedToChat';
  name?: Maybe<Scalars['String']['output']>;
};

export type UserBuyerConnection = Connection & {
  __typename?: 'UserBuyerConnection';
  edges: Array<UserBuyerEdge>;
};

export type UserBuyerEdge = Edge & {
  __typename?: 'UserBuyerEdge';
  cursor: Scalars['String']['output'];
  node: Buyer;
  role?: Maybe<Scalars['String']['output']>;
};

export const UserCartAction = {
  Add: 'add',
  Cancel: 'cancel',
  Create: 'create',
  Remove: 'remove',
  Submit: 'submit',
  /**
   * update the buyer comment for a line item.
   * if you are adding/removing a product item with a comment, you should use the add/remove action instead.
   */
  UpdateBuyerComment: 'updateBuyerComment'
} as const;

export type UserCartAction = typeof UserCartAction[keyof typeof UserCartAction];
export type UserCartItemOperation = {
  __typename?: 'UserCartItemOperation';
  action: UserCartAction | '%future added value';
  orderId?: Maybe<Scalars['String']['output']>;
};

export type UserChatConnection = Connection & {
  __typename?: 'UserChatConnection';
  edges?: Maybe<Array<UserChatEdge>>;
};

export type UserChatEdge = Edge & {
  __typename?: 'UserChatEdge';
  cursor: Scalars['String']['output'];
  node: Chat;
};

/**
 * Errors thrown by userChats
 * Be sure to always implement AppsyncError when creating
 * Error type
 */
export type UserChatsError = AppsyncError & AppsyncResponse & {
  __typename?: 'UserChatsError';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type UserChatsResponse = UserChatConnection | UserChatsError;

export type UserCognitoState = {
  __typename?: 'UserCognitoState';
  cognitoUsers?: Maybe<CognitoStateUsers>;
  status: CognitoSyncStatus | '%future added value';
};

export type UserCognitoStateResponse = AuthorizationFailure | NotFoundError | UserCognitoState;

export type UserCreateInput = {
  birthdate?: InputMaybe<Scalars['AWSDate']['input']>;
  botUser?: InputMaybe<Scalars['Boolean']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  chocoUser: Scalars['Boolean']['input'];
  createdContext?: InputMaybe<UserCreatedContext | '%future added value'>;
  /** @deprecated use SupplierDeliverySetting { cutOffTime } instead */
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  deliveryCosts?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** @deprecated use profileImage { uploadUrl } from type User */
  image?: InputMaybe<Scalars['String']['input']>;
  /** set this flag to enroll the user as a test user on Choco's Dogfood programme */
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  loginEmail?: InputMaybe<Scalars['String']['input']>;
  loginMethod?: InputMaybe<LoginMethod | '%future added value'>;
  minOrderAmount?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orderPreference?: InputMaybe<OrderPreferenceInput>;
  pending?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  supplier: Scalars['Boolean']['input'];
  supplierId?: InputMaybe<Scalars['String']['input']>;
  translationLanguage?: InputMaybe<Scalars['String']['input']>;
};

export const UserCreatedContext = {
  AddSalesRep: 'addSalesRep',
  BuyerConcierge: 'buyerConcierge',
  BuyerInviteTeam: 'buyerInviteTeam',
  CustomerMassAccountCreator: 'customerMassAccountCreator',
  Federated: 'federated',
  OrganicSignUp: 'organicSignUp',
  SupplierInviteTeam: 'supplierInviteTeam',
  SupplierInvitesBuyer: 'supplierInvitesBuyer',
  UserCreatedFromAdmin: 'userCreatedFromAdmin'
} as const;

export type UserCreatedContext = typeof UserCreatedContext[keyof typeof UserCreatedContext];
/**
 * Why the user must not be deleted.
 *   FEDERATED_USER - the user signs in only through an external identity provider (SSO)
 */
export const UserDeletionBlocker = {
  FederatedUser: 'FEDERATED_USER'
} as const;

export type UserDeletionBlocker = typeof UserDeletionBlocker[keyof typeof UserDeletionBlocker];
/**
 * What deletion does with a login. A login is removed exactly when it belongs to
 * the user.
 */
export const UserDeletionLoginAction = {
  Remove: 'REMOVE',
  Skip: 'SKIP'
} as const;

export type UserDeletionLoginAction = typeof UserDeletionLoginAction[keyof typeof UserDeletionLoginAction];
/** The user's profile identifier a login was found by. */
export const UserDeletionLoginIdentifier = {
  Email: 'EMAIL',
  LoginEmail: 'LOGIN_EMAIL',
  Phone: 'PHONE'
} as const;

export type UserDeletionLoginIdentifier = typeof UserDeletionLoginIdentifier[keyof typeof UserDeletionLoginIdentifier];
export const UserDeletionLoginKind = {
  Email: 'EMAIL',
  Phone: 'PHONE',
  Provider: 'PROVIDER'
} as const;

export type UserDeletionLoginKind = typeof UserDeletionLoginKind[keyof typeof UserDeletionLoginKind];
/**
 * The Cognito user pool holding a login. V3 is the current pool; V1 and V2 still
 * hold logins from before it.
 */
export const UserDeletionLoginPool = {
  V1: 'V1',
  V2: 'V2',
  V3: 'V3'
} as const;

export type UserDeletionLoginPool = typeof UserDeletionLoginPool[keyof typeof UserDeletionLoginPool];
/**
 * Why a login is removed or skipped.
 * For REMOVE:
 *   USER_ID_MATCH - the login carries this user's ID
 *   IDENTIFIER_MATCH_WITHOUT_USER_ID - no user ID is recorded, but its phone or email is this user's
 * For SKIP:
 *   OTHER_USER_ID - the login carries another user's ID
 *   NO_USER_ID_AND_NO_IDENTIFIER_MATCH - no user ID is recorded and its phone or email is not this user's
 *   IDENTIFIER_SHARED_WITH_OTHER_USER - no user ID is recorded and its phone or email is this user's,
 *     but another active user holds the same one
 *   EXTERNAL_PROVIDER_LOGIN - an external identity provider login, which can't be shown to belong to the user
 */
export const UserDeletionLoginReason = {
  ExternalProviderLogin: 'EXTERNAL_PROVIDER_LOGIN',
  IdentifierMatchWithoutUserId: 'IDENTIFIER_MATCH_WITHOUT_USER_ID',
  IdentifierSharedWithOtherUser: 'IDENTIFIER_SHARED_WITH_OTHER_USER',
  NoUserIdAndNoIdentifierMatch: 'NO_USER_ID_AND_NO_IDENTIFIER_MATCH',
  OtherUserId: 'OTHER_USER_ID',
  UserIdMatch: 'USER_ID_MATCH'
} as const;

export type UserDeletionLoginReason = typeof UserDeletionLoginReason[keyof typeof UserDeletionLoginReason];
/**
 * What deleting a user would do. Built by the same planning step as the deletion
 * itself, so it shows exactly what deletion will do.
 */
export type UserDeletionPreview = {
  __typename?: 'UserDeletionPreview';
  /** Whether the user is already flagged deleted. */
  alreadyDeleted: Scalars['Boolean']['output'];
  /** Deletion is refused while there are any. */
  blockers: Array<UserDeletionBlocker | '%future added value'>;
  /** When the user was flagged deleted (epoch ms), if they already are. */
  deletedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** Profile fields deletion clears or replaces. */
  fieldsToAnonymise: Array<UserDeletionPreviewField>;
  /** The phone and emails the deletion record keeps, masked. */
  identifiers: UserDeletionPreviewIdentifiers;
  /** Test users get no deletion record; every other step still runs. */
  isTestUser: Scalars['Boolean']['output'];
  /** Every login found for the user, with what deletion does with it. */
  logins: Array<UserDeletionPreviewLogin>;
  /** The surviving user, when reason is ACCOUNT_MERGE. */
  mergedToUserId?: Maybe<Scalars['ID']['output']>;
  reason: UserDeletionReason | '%future added value';
  /** The user's deletion record, if deletion has started. */
  request?: Maybe<UserDeletionPreviewRequest>;
  userId: Scalars['ID']['output'];
};

export type UserDeletionPreviewField = {
  __typename?: 'UserDeletionPreviewField';
  /** The profile field, as `record.attribute`, e.g. `user.phone` or `orderPreferences.sms`. */
  field: Scalars['String']['output'];
  /** The current value, masked. */
  maskedValue: Scalars['String']['output'];
};

export type UserDeletionPreviewIdentifiers = {
  __typename?: 'UserDeletionPreviewIdentifiers';
  maskedEmail?: Maybe<Scalars['String']['output']>;
  maskedLoginEmail?: Maybe<Scalars['String']['output']>;
  maskedPhone?: Maybe<Scalars['String']['output']>;
};

export type UserDeletionPreviewInput = {
  userId: Scalars['ID']['input'];
};

export type UserDeletionPreviewLogin = {
  __typename?: 'UserDeletionPreviewLogin';
  action: UserDeletionLoginAction | '%future added value';
  foundBy: Array<UserDeletionLoginIdentifier | '%future added value'>;
  kind: UserDeletionLoginKind | '%future added value';
  /** The login username, masked. In V1 and V2 the username is an ID, not the phone or email. */
  maskedUsername: Scalars['String']['output'];
  pool: UserDeletionLoginPool | '%future added value';
  reason: UserDeletionLoginReason | '%future added value';
};

export type UserDeletionPreviewRequest = {
  __typename?: 'UserDeletionPreviewRequest';
  /** When the last deletion step finished (epoch ms), if it has. */
  completedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** When deletion was requested (epoch ms). */
  requestedAt: Scalars['AWSTimestamp']['output'];
  status: UserDeletionRequestStatus | '%future added value';
};

export type UserDeletionPreviewResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | UserDeletionPreview;

/**
 * Why the user is deleted.
 *   REQUESTED_DELETION - the user, Choco staff or a service asked for it
 *   ACCOUNT_MERGE - the user was retired as the duplicate in an account merge
 */
export const UserDeletionReason = {
  AccountMerge: 'ACCOUNT_MERGE',
  RequestedDeletion: 'REQUESTED_DELETION'
} as const;

export type UserDeletionReason = typeof UserDeletionReason[keyof typeof UserDeletionReason];
/**
 * Status of the user's deletion record.
 *   IN_PROGRESS - deletion started but has not finished all its steps
 *   COMPLETED - every deletion step finished
 */
export const UserDeletionRequestStatus = {
  Completed: 'COMPLETED',
  InProgress: 'IN_PROGRESS'
} as const;

export type UserDeletionRequestStatus = typeof UserDeletionRequestStatus[keyof typeof UserDeletionRequestStatus];
export type UserFilter = {
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  isSupplier?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserHasReferralCode = AppsyncError & AppsyncResponse & {
  __typename?: 'UserHasReferralCode';
  message?: Maybe<Scalars['String']['output']>;
  responseType: ResponseType | '%future added value';
};

export type UserIntercomCredentialsFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'UserIntercomCredentialsFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type UserIntercomCredentialsResponse = UserIntercomCredentialsFailure | UserIntercomCredentialsSuccess;

export type UserIntercomCredentialsSuccess = {
  __typename?: 'UserIntercomCredentialsSuccess';
  androidHash: Scalars['String']['output'];
  iosHash: Scalars['String']['output'];
  webHash: Scalars['String']['output'];
};

export type UserLead = {
  __typename?: 'UserLead';
  phoneNumber: Scalars['String']['output'];
  requestCount?: Maybe<Scalars['Int']['output']>;
  requests?: Maybe<Array<Maybe<UserLeadRequest>>>;
};

export type UserLeadInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  referrer?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type UserLeadRequest = {
  __typename?: 'UserLeadRequest';
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  referrer?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type UserLobbyBuyerConnection = Connection & {
  __typename?: 'UserLobbyBuyerConnection';
  edges?: Maybe<Array<UserLobbyBuyerEdge>>;
};

export type UserLobbyBuyerEdge = Edge & {
  __typename?: 'UserLobbyBuyerEdge';
  cursor: Scalars['String']['output'];
  node: LobbyBuyer;
};

/**
 * Marketing preferences for the current user. Profile-level and independent of the
 * per-chat override.
 */
export type UserMarketingPreferences = {
  __typename?: 'UserMarketingPreferences';
  /**
   * Whether the user agreed to receive marketing messages in chat.
   * When false, campaign messages are hidden from the chat and no campaign
   * notification is sent.
   */
  marketingMessagesInChat: Scalars['Boolean']['output'];
};

/** Partial update of marketing preferences. Omitted fields are left unchanged. */
export type UserMarketingPreferencesInput = {
  marketingMessagesInChat?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Per-category personal notification toggles for a Dx and Buyer user
 * (Text and media messages / New orders / Order confirmations / Campaigns).
 * Independent booleans.
 */
export type UserNotificationCategorySetting = {
  __typename?: 'UserNotificationCategorySetting';
  /** Campaign/broadcast notifications. */
  campaigns: Scalars['Boolean']['output'];
  /**
   * Loyalty push notifications. This preference is profile-level and cannot be
   * overridden for an individual chat.
   */
  loyalty: Scalars['Boolean']['output'];
  /** Ordinary chat messages (text, media, email-originated, and similar). */
  messages: Scalars['Boolean']['output'];
  /** Order confirmation events in chat. */
  orderConfirmation: Scalars['Boolean']['output'];
  /** Order events in chat. */
  orders: Scalars['Boolean']['output'];
};

/**
 * Partial update of category toggles (profile-level updates).
 * Omitted fields are left unchanged.
 */
export type UserNotificationCategorySettingInput = {
  campaigns?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether loyalty push notifications are enabled. Omit to leave unchanged. */
  loyalty?: InputMaybe<Scalars['Boolean']['input']>;
  messages?: InputMaybe<Scalars['Boolean']['input']>;
  orderConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  orders?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Full configurable-category set for a per-chat override (create or replace).
 * All fields required — no omitted-field defaults.
 */
export type UserNotificationCategorySettingReplaceInput = {
  messages: Scalars['Boolean']['input'];
  orderConfirmation: Scalars['Boolean']['input'];
  orders: Scalars['Boolean']['input'];
};

export type UserNotificationPreferencesForChatClearInput = {
  chatId: Scalars['ID']['input'];
};

export type UserNotificationPreferencesForChatInput = {
  chatId: Scalars['ID']['input'];
};

export type UserNotificationPreferencesForChatResponse = AuthorizationFailure | InputValidationFailure | UserNotificationPreferencesForChatResult;

/**
 * Personal notification preferences for a customer/chat (current user).
 * chatSetting is null when the chat inherits the profile-level setting.
 */
export type UserNotificationPreferencesForChatResult = AppsyncResponse & {
  __typename?: 'UserNotificationPreferencesForChatResult';
  /** Per-chat override; null when inheriting global. */
  chatSetting?: Maybe<UserNotificationCategorySetting>;
  /**
   * Profile-level toggles (always present).
   * Missing stored row: messages/orders/orderConfirmation true.
   */
  globalSetting: UserNotificationCategorySetting;
  responseType: ResponseType | '%future added value';
};

export type UserNotificationPreferencesForChatUpdateInput = {
  chatId: Scalars['ID']['input'];
  /**
   * Full configurable-category override for this chat (creates or replaces the override).
   * All category fields are required.
   */
  setting: UserNotificationCategorySettingReplaceInput;
};

export type UserNotificationPreferencesResponse = AuthorizationFailure | InputValidationFailure | UserNotificationPreferencesResult;

/**
 * Profile-level (global) personal notification preferences for the current user.
 * Missing stored row uses defaults: messages/orders/orderConfirmation true.
 */
export type UserNotificationPreferencesResult = AppsyncResponse & {
  __typename?: 'UserNotificationPreferencesResult';
  /** Profile-level marketing preferences (always present). */
  marketingPreferences: UserMarketingPreferences;
  responseType: ResponseType | '%future added value';
  setting: UserNotificationCategorySetting;
};

export type UserNotificationPreferencesUpdateInput = {
  /** Optional; omit to leave marketing preferences unchanged. */
  marketingPreferences?: InputMaybe<UserMarketingPreferencesInput>;
  /** Optional; omit to change marketing preferences alone. At least one of setting or marketingPreferences must be provided. */
  setting?: InputMaybe<UserNotificationCategorySettingInput>;
};

export type UserOrderOverridePermissions = {
  __typename?: 'UserOrderOverridePermissions';
  message?: Maybe<Scalars['String']['output']>;
  supplierId: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
  validationRules: Array<ValidationRule | '%future added value'>;
};

export const UserPhoneType = {
  Landline: 'landline',
  Mobile: 'mobile',
  Noinfo: 'noinfo',
  Voip: 'voip'
} as const;

export type UserPhoneType = typeof UserPhoneType[keyof typeof UserPhoneType];
export type UserRef = RefEdge & {
  __typename?: 'UserRef';
  /** Id of the referenced user */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual user by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<User>;
};

export type UserRemovedFromChat = {
  __typename?: 'UserRemovedFromChat';
  name?: Maybe<Scalars['String']['output']>;
};

export type UserRequestToDeleteDetails = {
  __typename?: 'UserRequestToDeleteDetails';
  success: Scalars['Boolean']['output'];
};

export type UserRequestToDeleteInput = {
  /**
   * Optional free text from Choco staff, e.g. why the user is being deleted or a
   * link to the support ticket with the request. Stored with the deletion record.
   */
  comment?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type UserRequestToDeleteResponse = AuthorizationFailure | UserRequestToDeleteDetails;

export type UserRequestToJoin = Node & {
  __typename?: 'UserRequestToJoin';
  buyerId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  id: Scalars['ID']['output'];
  isReviewerAdmin?: Maybe<Scalars['Boolean']['output']>;
  requestType?: Maybe<UserRequestToJoinType | '%future added value'>;
  requestedBy: Scalars['String']['output'];
  reviewerUserId?: Maybe<Scalars['String']['output']>;
  salesRepInput?: Maybe<SalesRepDetails>;
  status: JoinRequestStatus | '%future added value';
  supplierEntityId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  user: User;
  userId: Scalars['String']['output'];
};

export type UserRequestToJoinEdge = Edge & {
  __typename?: 'UserRequestToJoinEdge';
  cursor: Scalars['String']['output'];
  node: UserRequestToJoin;
};

export const UserRequestToJoinType = {
  AddSalesRep: 'addSalesRep',
  JoinBuyer: 'joinBuyer'
} as const;

export type UserRequestToJoinType = typeof UserRequestToJoinType[keyof typeof UserRequestToJoinType];
export type UserSearchConnection = Connection & {
  __typename?: 'UserSearchConnection';
  edges: Array<UserSearchEdge>;
  /** All new connections must require it */
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type UserSearchEdge = Edge & {
  __typename?: 'UserSearchEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UserSearchFilter = {
  isPuppy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter users by how they sign in (e.g. federated = SSO) */
  loginMethod?: InputMaybe<LoginMethod | '%future added value'>;
};

export type UserSearchInput = {
  filter?: InputMaybe<UserSearchFilter>;
  keywords?: InputMaybe<Scalars['String']['input']>;
};

export type UserSearchResponse = AuthorizationFailure | InputValidationFailure | UserSearchConnection;

/**
 * Team chat notification opt-in for the current supplier user.
 * Applies to the whole supplier, not one chat. Default off.
 */
export type UserTeamChatNotificationsOptIn = {
  __typename?: 'UserTeamChatNotificationsOptIn';
  /** When true, this user uses team unread and team notification preferences. */
  enabled: Scalars['Boolean']['output'];
};

export type UserTeamChatNotificationsOptInResponse = AuthorizationFailure | InputValidationFailure | UserTeamChatNotificationsOptInResult;

export type UserTeamChatNotificationsOptInResult = AppsyncResponse & {
  __typename?: 'UserTeamChatNotificationsOptInResult';
  responseType: ResponseType | '%future added value';
  setting: UserTeamChatNotificationsOptIn;
};

export type UserTeamChatNotificationsOptInUpdateInput = {
  enabled: Scalars['Boolean']['input'];
};

export type UserTwilioState = {
  __typename?: 'UserTwilioState';
  status?: Maybe<TwilioStatus | '%future added value'>;
};

export type UserTwilioStateError = AppsyncError & AppsyncResponse & {
  __typename?: 'UserTwilioStateError';
  message: Scalars['String']['output'];
  responseType: ResponseType | '%future added value';
};

export type UserTwilioStateResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | UserTwilioState | UserTwilioStateError;

export type UserUpdateInput = {
  birthdate?: InputMaybe<Scalars['AWSDate']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  challengeByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  chocoUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated use SupplierDeliverySetting { cutOffTime } instead */
  cutOffTime?: InputMaybe<Scalars['String']['input']>;
  deliveryCosts?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasAcceptedTermsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  /** @deprecated use profileImage { uploadUrl } from type User */
  image?: InputMaybe<Scalars['String']['input']>;
  isTest?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  loginEmail?: InputMaybe<Scalars['String']['input']>;
  minOrderAmount?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderPreference?: InputMaybe<OrderPreferenceInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['Boolean']['input']>;
  supplierId?: InputMaybe<Scalars['String']['input']>;
  translationLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type UserUserConnection = Connection & {
  __typename?: 'UserUserConnection';
  edges?: Maybe<Array<UserUserEdge>>;
};

export type UserUserEdge = Edge & {
  __typename?: 'UserUserEdge';
  cursor: Scalars['String']['output'];
  node: User;
};

export type UsersList = {
  __typename?: 'UsersList';
  userIds: Array<Scalars['String']['output']>;
};

export type ValidateProductsAvailabilityInput = {
  chatId: Scalars['String']['input'];
  productIds: Array<Scalars['String']['input']>;
};

export type ValidateProductsAvailabilityResponse = AuthorizationFailure | ChatNotFoundError | InputValidationFailure | SupplierNotFound | ValidateProductsAvailabilityResult;

export type ValidateProductsAvailabilityResult = {
  __typename?: 'ValidateProductsAvailabilityResult';
  notFound?: Maybe<Array<Scalars['String']['output']>>;
  unavailableForChat?: Maybe<Array<Scalars['ID']['output']>>;
  unavailableForSupplier?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ValidationError = AppsyncError & AppsyncResponse & {
  __typename?: 'ValidationError';
  invalidFields?: Maybe<Array<FieldValidationError>>;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

/**
 * Validation rules that can be overridden by users with special permissions.
 * These represent order validation checks that normally prevent order processing.
 */
export const ValidationRule = {
  DeliveryDateAvailability: 'deliveryDateAvailability',
  DeliveryDateCutoffTime: 'deliveryDateCutoffTime',
  InvalidProduct: 'invalidProduct',
  MinimumOrderValue: 'minimumOrderValue',
  MinimumOrderableAmount: 'minimumOrderableAmount',
  ProductAvailability: 'productAvailability',
  ProductCutoffTime: 'productCutoffTime',
  ProductLeadTime: 'productLeadTime'
} as const;

export type ValidationRule = typeof ValidationRule[keyof typeof ValidationRule];
export const ValidationSource = {
  /**
   * Outcome driven by authenticated channel policy (createdByContext matrix).
   * Forward-compat / audit; the buyer path may only ever emit
   * SUPPLIER_CAPABILITY today.
   */
  ChannelPolicy: 'CHANNEL_POLICY',
  /**
   * Outcome driven by supplier capability or configuration.
   * Example: resolved MOV amount; stock from product snapshot.
   * Missing capability → SKIPPED.
   */
  SupplierCapability: 'SUPPLIER_CAPABILITY'
} as const;

export type ValidationSource = typeof ValidationSource[keyof typeof ValidationSource];
export const ValidationStatus = {
  /**
   * Policy does not permit the condition. Blocks commit unless overrideable
   * and overridden. Example: unmet MOV on buyer web/app → BLOCKED.
   */
  Blocked: 'BLOCKED',
  /**
   * A BLOCKED check was explicitly overridden by an authorized actor or
   * channel; does not block commit; persist audit (overriddenBy).
   * Buyer GraphQL does not send override intent. Cart repair = new evaluate,
   * not OVERRIDDEN. Successful top-up path = PASSED + decision, not OVERRIDDEN.
   */
  Overridden: 'OVERRIDDEN',
  /**
   * Configured check passed; does not block.
   * Example: MOV met (decision PASSED), or isTopUp requested and eligible
   * (decision TOP_UP_SATISFIABLE or PASSED per resolver, status PASSED).
   */
  Passed: 'PASSED',
  /**
   * Check not configured or not applicable.
   * Example: supplier has no MOV amount/currency → SKIPPED.
   */
  Skipped: 'SKIPPED',
  /**
   * Concern exists; policy allows commit to continue.
   * Example: flexible-MOV channel surfaces unmet MOV as WARNING.
   * Gift soft-fails (PROMOTION_EXPIRED / FREE_LINE_CHANGED) → WARNING.
   */
  Warning: 'WARNING'
} as const;

export type ValidationStatus = typeof ValidationStatus[keyof typeof ValidationStatus];
/** Vendor brand type */
export type VendorBrand = {
  __typename?: 'VendorBrand';
  /** Translated name of the brand */
  name: Scalars['String']['output'];
};

/** Represents a specific item in a vendor catalog. */
export type VendorItem = Node & {
  __typename?: 'VendorItem';
  /**
   * Brand name of the item.
   * Can be stored in multiple languages. The returned language is determined by the Accept-Language header, Supplier's default translation and available translations.
   */
  brand?: Maybe<Scalars['String']['output']>;
  /**
   * Returns the most nested categories that this item belongs to.
   * E.g. the sub-category if the item is assigned to a sub-category.
   */
  categories: Array<VendorItemCategory>;
  /** @deprecated Use the `categories` field instead */
  category?: Maybe<VendorItemCategory>;
  /**
   * Extended description of the item.
   * Can be stored in multiple languages. The returned language is determined by the Accept-Language header, Supplier's default translation and available translations.
   */
  description: Scalars['String']['output'];
  /**
   * Set to true if the item has more variants.
   * This field is not used yet.
   */
  hasVariants: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Set to true if the item was created by the buyer, not vendor. */
  isCustomVendorItem: Scalars['Boolean']['output'];
  /**
   * Name of the item.
   * Can be stored in multiple languages. The returned language is determined by the Accept-Language header, Supplier's default translation and available translations.
   */
  name: Scalars['String']['output'];
  /** ISO 3166 alpha-2 country code of the country where the item came from. */
  originCountryCode?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `VendorItemUnit.productCode` instead */
  productCode?: Maybe<Scalars['String']['output']>;
  /**
   * Sub-brand name of the item.
   * Can be stored in multiple languages. The returned language is determined by the Accept-Language header, Supplier's default translation and available translations.
   */
  subBrand?: Maybe<Scalars['String']['output']>;
  /** Returns the units of the item according to the provided filter */
  units: Array<VendorItemUnit>;
  /** Count of units that this item has */
  unitsCount: Scalars['Int']['output'];
  /**
   * Variant group that this item belongs to as an item variant.
   * This field is not used yet.
   */
  variantGroup?: Maybe<VendorItemVariantGroup>;
};


/** Represents a specific item in a vendor catalog. */
export type VendorItemUnitsArgs = {
  filter?: InputMaybe<VendorItemUnitsFilter>;
};


/** Represents a specific item in a vendor catalog. */
export type VendorItemUnitsCountArgs = {
  filter?: InputMaybe<VendorItemUnitsFilter>;
};

/** Filter input for the `vendorItemCategoriesForChat` query */
export type VendorItemCategoriesForChatFilter = {
  /**
   * If provided, only categories of the items that have the given stock status will be returned. By default, out-of-stock or discontinued items are excluded.
   * @deprecated Units will be filtered based on supplier.buyerVisibleStockStatuses (defaults to InStock if not configured by the supplier).
   * @deprecated Units will be filtered based on supplier.buyerVisibleStockStatuses (defaults to InStock if not configured by the supplier).
   */
  availabilityStatus?: InputMaybe<Array<VendorItemUnitAvailabilityStatus | '%future added value'>>;
  /**
   * If provided, only returns categories which are the direct children of the provided category.
   * If the value is "00000000-0000-0000-0000-000000000000", then behaves the same as "rootCategories: true".
   */
  parentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If provided and set to true, only returns top-level categories, i.e. the ones which do not have a parent.
   * If set to false, does nothing.
   */
  rootCategories?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If provided, only returns categories that have items assigned directly to them or assigned to any of the child/nested categories.
   * @deprecated This is now the default behavior for this query
   */
  withItemsNested?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input parameters for the `vendorItemCategoriesForChat` query */
export type VendorItemCategoriesForChatInput = {
  /**
   * Chat determines the context of the query.
   * Only the categories that have at least one visible item for a given chat
   * via a custom catalog or default catalog relationship will be returned.
   */
  chatId: Scalars['ID']['input'];
  /** Additional filter to narrow down the list of the returned categories */
  filter?: InputMaybe<VendorItemCategoriesForChatFilter>;
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
  /** Id of the vendor whose catalog categories are being queried */
  vendorId: Scalars['ID']['input'];
};

export type VendorItemCategoriesForChatResponse = AuthorizationFailure | InputValidationFailure | VendorItemCategoriesForChatSuccess;

/** One category of the `vendorItemCategoriesForChat` query result page */
export type VendorItemCategoriesForChatResultEdge = Edge & {
  __typename?: 'VendorItemCategoriesForChatResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorItemCategory;
};

/** Success response of the `vendorItemCategoriesForChat` query */
export type VendorItemCategoriesForChatSuccess = AppsyncResponse & Connection & Page & {
  __typename?: 'VendorItemCategoriesForChatSuccess';
  edges: Array<VendorItemCategoriesForChatResultEdge>;
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

/** Filter input for the `vendorItemCategoriesForVendor` query */
export type VendorItemCategoriesForVendorFilter = {
  /** If provided, only returns categories which are the direct children of the provided category. */
  parentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If provided and set to true, only returns top-level categories, i.e. the ones which do not have a parent.
   * If set to false, does nothing.
   */
  rootCategories?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VendorItemCategoriesForVendorInput = {
  /** Additional filter to narrow down the list of the returned categories */
  filter?: InputMaybe<VendorItemCategoriesForVendorFilter>;
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
  /** Id of the vendor whose catalog categories are being queried */
  vendorId: Scalars['ID']['input'];
};

export type VendorItemCategoriesForVendorResponse = AuthorizationFailure | InputValidationFailure | VendorItemCategoriesForVendorSuccess;

export type VendorItemCategoriesForVendorResultEdge = Edge & {
  __typename?: 'VendorItemCategoriesForVendorResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorItemCategory;
};

export type VendorItemCategoriesForVendorSuccess = AppsyncResponse & Connection & Page & {
  __typename?: 'VendorItemCategoriesForVendorSuccess';
  edges: Array<VendorItemCategoriesForVendorResultEdge>;
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type VendorItemCategoriesImagesUploadInput = {
  categoryIds: Array<Scalars['ID']['input']>;
};

export type VendorItemCategoriesImagesUploadResponse = AuthorizationFailure | InputValidationFailure | VendorItemCategoriesImagesUploadResult;

export type VendorItemCategoriesImagesUploadResult = AppsyncResponse & {
  __typename?: 'VendorItemCategoriesImagesUploadResult';
  categories: Array<VendorItemCategoriesImagesUploadResultCategory>;
  responseType: ResponseType | '%future added value';
};

export type VendorItemCategoriesImagesUploadResultCategory = {
  __typename?: 'VendorItemCategoriesImagesUploadResultCategory';
  category: VendorItemCategoryRef;
  image: VendorItemCategoriesImagesUploadResultImage;
};

export type VendorItemCategoriesImagesUploadResultImage = {
  __typename?: 'VendorItemCategoriesImagesUploadResultImage';
  /**
   * ID of the image. Use this to associate the image with the vendor item unit
   * by calling the `vendorItemCategoriesUpdate` mutation after the image is uploaded.
   */
  imageId: Scalars['ID']['output'];
  /**
   * URL where the image file should be uploaded to.
   * To upload the file, make the `POST` request to this URL.
   * Use `Content-Type: multipart/form-data`. Provide body in the `FormData` format.
   * There should only be a single binary field named `file` in the form data content.
   *
   * @example
   * ```typescript
   * const formData = new FormData();
   * formData.append('file', file); // where `file` is a File object
   * const response = await fetch(uploadUrl, {
   * method: 'POST',
   * body: formData,
   * });
   * ```
   */
  uploadUrl: Scalars['String']['output'];
};

export type VendorItemCategoriesInput = {
  /**
   * Ids to fetch catalog categories for.
   * Max-length: 200
   */
  ids: Array<Scalars['ID']['input']>;
  /** Id of the vendor whose categories are being fetched */
  vendorId: Scalars['ID']['input'];
};

export type VendorItemCategoriesResponse = AuthorizationFailure | InputValidationFailure | VendorItemCategoriesResult;

export type VendorItemCategoriesResult = {
  __typename?: 'VendorItemCategoriesResult';
  categories: Array<VendorItemCategory>;
  responseType: ResponseType | '%future added value';
};

export type VendorItemCategoriesUpdateInput = {
  categories: Array<VendorItemCategoryUpdateInput>;
};

export type VendorItemCategoriesUpdateResponse = AuthorizationFailure | InputValidationFailure | VendorItemCategoriesUpdateResult;

export type VendorItemCategoriesUpdateResult = AppsyncResponse & {
  __typename?: 'VendorItemCategoriesUpdateResult';
  categories: Array<VendorItemCategoryRef>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

/** Represents a category in a vendor catalog. */
export type VendorItemCategory = Node & {
  __typename?: 'VendorItemCategory';
  /**
   * Reference to the The list of all direct children belonging current category.
   * If chatId is passed, only direct children assigned to items available to the chat
   * will be returned.
   */
  children?: Maybe<Array<VendorItemCategory>>;
  id: Scalars['ID']['output'];
  /** The image associated with the vendor item category. */
  image?: Maybe<VendorItemCategoryImage>;
  /**
   * The number of category items including the items of all nested subcategories.
   * Only one item from each variant group is counted which corresponds
   * to the result of the vendorItemsForChat query.
   */
  itemsCountForChat: Scalars['Int']['output'];
  /**
   * Name of the category.
   * Can be stored in multiple languages. The returned language is determined by the Accept-Language header, Supplier's default translation and available translations.
   */
  name: Scalars['String']['output'];
  /** Reference to the direct parent category in case of the nested category structure. */
  parentCategory?: Maybe<VendorItemCategoryRef>;
  /**
   * Reference to the The list of all parents of the current category up to the root category,
   * starting from the direct parent.
   */
  parentCategoryChain: Array<VendorItemCategory>;
};


/** Represents a category in a vendor catalog. */
export type VendorItemCategoryChildrenArgs = {
  chatId?: InputMaybe<Scalars['ID']['input']>;
};


/** Represents a category in a vendor catalog. */
export type VendorItemCategoryItemsCountForChatArgs = {
  chatId: Scalars['ID']['input'];
};

/**
 * VendorItemCategoryImage represents VendorItemCategory image that can be returned with the dynamic size.
 * Images are immutable, the same image ID within the given type is always linked to the same image file.
 */
export type VendorItemCategoryImage = {
  __typename?: 'VendorItemCategoryImage';
  /** The image asset that provides the read URL. */
  asset: ImageAsset;
  /** The ID of the image asset to be retrieved */
  id: Scalars['ID']['output'];
};

/**
 * Reference to the VendorItemCategory.
 * This type is returned when only the ID of the referenced object is known without additional querying.
 * If the object fields are needed, they can be fetched using the `node` field.
 */
export type VendorItemCategoryRef = RefEdge & {
  __typename?: 'VendorItemCategoryRef';
  /** Id of the referenced object */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<VendorItemCategory>;
};

export type VendorItemCategoryUpdateInput = {
  categoryId: Scalars['ID']['input'];
  /**
   * ID of the main category image.
   *
   * To create an image, use the `vendorItemCategoriesImagesUpload` mutation.
   * Image must be dedicated to this category.
   *
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as an empty string, it will be deleted
   * If sent as a non-empty string, it will be updated
   */
  imageId?: InputMaybe<Scalars['ID']['input']>;
};

export type VendorItemCustomBuyerPropertiesInput = {
  chatId: Scalars['ID']['input'];
  /**
   * If sent as null/undefined, it won't be touched/updated
   * If sent as { value: null/undefined }, it will be deleted
   * If sent as { value: MoneyV2Input }, it will be updated
   */
  myPrice?: InputMaybe<NullableMoneyV2Input>;
  /**
   * If sent as null/undefined, it won't be touched/updated
   * If sent as an empty string, it will be deleted
   * If sent as a non-empty string, it will be updated
   */
  par?: InputMaybe<Scalars['String']['input']>;
};

export type VendorItemCustomCreateInput = {
  /** ID of the Buyer that manages the item */
  buyerId: Scalars['ID']['input'];
  /** Additional buyer properties */
  buyerProperties?: InputMaybe<VendorItemCustomBuyerPropertiesInput>;
  /** Name of the item */
  name: Scalars['String']['input'];
  /** Product code of the item */
  productCode?: InputMaybe<Scalars['String']['input']>;
  /** Name of the item unit */
  unit: Scalars['String']['input'];
  /** ID of the Supplier with which the item will be associated */
  vendorId: Scalars['ID']['input'];
};

export type VendorItemCustomCreateResponse = AuthorizationFailure | InputValidationFailure | VendorItemCustomCreateResult;

export type VendorItemCustomCreateResult = AppsyncResponse & {
  __typename?: 'VendorItemCustomCreateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  unit: VendorItemUnit;
};

export type VendorItemCustomUpdateInput = {
  buyerProperties?: InputMaybe<VendorItemCustomBuyerPropertiesInput>;
  /**
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as valid value, it will be updated
   * Empty string is not allowed
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as an empty string, it will be deleted
   * If sent as a non-empty string, it will be updated
   */
  productCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as valid value, it will be updated
   * Empty string is not allowed
   */
  unit?: InputMaybe<Scalars['String']['input']>;
  vendorItemId: Scalars['ID']['input'];
};

export type VendorItemCustomUpdateResponse = AuthorizationFailure | InputValidationFailure | VendorItemCustomUpdateResult;

export type VendorItemCustomUpdateResult = AppsyncResponse & {
  __typename?: 'VendorItemCustomUpdateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  unit: VendorItemUnit;
};

/**
 * Reference to the VendorItem.
 * This type is returned when only the ID of the referenced object is known without additional querying.
 * If the object fields are needed, they can be fetched using the `node` field.
 */
export type VendorItemRef = RefEdge & {
  __typename?: 'VendorItemRef';
  /** Id of the referenced object */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<VendorItem>;
};

/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnit = Node & {
  __typename?: 'VendorItemUnit';
  /** The assets associated with the vendor item unit */
  assets?: Maybe<VendorItemUnitAssets>;
  /** The product attributes (allergens and dietary preferences) associated with the vendor item unit. */
  attributes?: Maybe<Array<VendorItemUnitAttribute>>;
  /**
   * Intended for buyer facing frontends:
   * Frontend-specific availability/orderability status of the unit in the context of a given chat.
   * Can be called by: Choco Admins, Supplier and Buyer users from the chat.
   */
  availability?: Maybe<VendorItemUnitAvailability>;
  /**
   * Intended for buyer facing frontends:
   * Frontend-specific availability/orderability status of the unit.
   * @deprecated Use the `availability` field instead
   */
  availabilityStatus: VendorItemUnitAvailabilityStatus | '%future added value';
  /** The base unit of item. */
  baseUnit?: Maybe<VendorItemUnit>;
  /**
   * The buyer properties of the vendor item unit.
   * `null` is returned if the vendorItemUnit has no buyer properties.
   * Can be called by: Choco Admins, users of the Buyer to whom the properties belong and related Supplier users.
   */
  buyerProperties?: Maybe<VendorItemUnitBuyerProperties>;
  /** Customer specific information about the product resolved by the Smart Order Service */
  chatProductFeatures?: Maybe<ChatProductFeatures>;
  /**
   * Short code of the unit that is used for matching units during imports.
   * Usually will be set to either `productCode` or `productCode#name` combination,
   * or an internal identifier from the Supplier's ERP.
   */
  code: Scalars['String']['output'];
  /**
   * The display properties of the vendor item unit.
   * These properties are computed out of other properties of the unit and are intended for display purposes.
   * Can be called by: Choco Admins, Supplier and Buyer users from the chat.
   */
  displayProperties?: Maybe<VendorItemUnitDisplayProperties>;
  /** European Article Number (EAN) barcode of this unit. */
  ean?: Maybe<Scalars['String']['output']>;
  /** The external links associated with the vendor item unit. */
  externalLinks?: Maybe<Array<VendorItemUnitExternalLink>>;
  /**
   * Conversion factor of this unit to its base unit.
   * E.g. if base unit is "g" and this unit is "kg" with a factor "1000", then 1 kg is 1000 g.
   */
  factor: Rational;
  id: Scalars['ID']['output'];
  /**
   * The images associated with the vendor item unit.
   * First image is the main image.
   */
  images: Array<VendorItemUnitImage>;
  /**
   * The information about the inventory of this vendor item unit in the Supplier's warehouse.
   * `null` is returned if the Vendor Item Unit has no inventory data.
   * Can be called by: Choco Admins, users of Supplier owning the unit.
   */
  inventoryData?: Maybe<VendorItemUnitInventoryData>;
  /** Flags if the unit is the base unit for the vendor item */
  isBase: Scalars['Boolean']['output'];
  /**
   * Intended for vendor facing frontends:
   * If `true`, then the unit is not visible in a Chat unless added to a Custom Catalog assigned to it.
   */
  isHiddenByDefault?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Queries the given order guide by Id to determine if the unit is added to it.
   * Can be called by: Choco Admins, Supplier and Buyer users from the chat to which the OG is assigned.
   */
  isInOrderGuide: Scalars['Boolean']['output'];
  /** Flags if the unit is available for ordering by buyers. */
  isOrdering: Scalars['Boolean']['output'];
  /** Unit-level override for the item description. If this is set it should be displayed instead of the `VendorItem.description` */
  itemDescriptionOverride?: Maybe<Scalars['String']['output']>;
  /** Unit-level override for the item name. If this is set it should be displayed instead of the `VendorItem.name` */
  itemNameOverride?: Maybe<Scalars['String']['output']>;
  /**
   * Unique identifier of the Product connected to this unit in the old catalog system.
   * Use this when coordinating data with the old catalog queries and mutations.
   * May be an arbitrary string. If not set, fallback to the `id` field, like this: `legacyId ?? id`.
   */
  legacyId?: Maybe<Scalars['String']['output']>;
  /** Per-product loyalty point estimation for browse contexts (PDP, PLP, promotions). Null if browse estimation is unavailable or no loyalty program applies in this context. */
  loyalty?: Maybe<LoyaltyPoints>;
  /**
   * Name of the unit intended for display to buyers.
   * Can be stored in multiple languages. The returned language is determined by the `Accept-Language` header and available translations.
   */
  name: Scalars['String']['output'];
  orderGuideItemUnit?: Maybe<OrderGuideV2ItemUnit>;
  /**
   * Returns all order guide item units for this vendor item unit
   * in the context of the specified chat.
   */
  orderGuideItemUnits?: Maybe<Array<OrderGuideV2ItemUnit>>;
  /**
   * The ordering properties of the vendor item unit.
   * `null` is returned if the vendorItemUnit has no ordering properties.
   */
  orderingProperties?: Maybe<VendorItemUnitOrderingProperties>;
  /**
   * Describes the content of one unit in more detail.
   * Can be stored in multiple languages. The returned language is determined by the `Accept-Language` header and available translations.
   * Formerly called "packSize".
   */
  packagingDescription: Scalars['String']['output'];
  /**
   * The price of the unit.
   * `null` can be returned if the price is not defined or the user do not have access to it.
   */
  price?: Maybe<VendorItemUnitPriceSet>;
  /**
   * The product's price enriched with tax, for the product-details screen.
   *
   * Composes the net price set (the same shape as `VendorItemUnit.price`, resolved
   * from the catalog) with a server-side tax computation that grosses the display
   * price up. `input.chatId` scopes both the customer's prices and the tax
   * jurisdiction/exemptions. Resolved by aggregating the catalog and tax services,
   * so the whole field is nullable and each part resolves independently.
   */
  pricesV2?: Maybe<VendorItemUnitPricesV2>;
  /**
   * This is a short code for the item which is meaningful to the vendor.
   * This field is commonly displayed in Choco as "Product ID", however it is not guaranteed to be unique.
   * It is intended to be consumed by humans and not for technical reasons such as matching.
   * Formerly called "externalId".
   */
  productCode?: Maybe<Scalars['String']['output']>;
  /** Active promotions applicable to this unit in the chat context. */
  promotions?: Maybe<Array<VendorPromotion>>;
  /** Returns the distinct root categories of the categories assigned to the vendor item. */
  rootCategories?: Maybe<Array<VendorItemCategory>>;
  /**
   * Intended for vendor facing frontends: The stock status of the unit.
   * Note that the stock status is not automatically connected to the inventory data.
   */
  stockStatus: VendorItemUnitStockStatus | '%future added value';
  /** Switch & Save hint. Null if no mapping exists. */
  switchAndSaveHint?: Maybe<SwitchAndSaveHint>;
  /**
   * The tax rates assigned to this product via its tax classifications.
   *
   * When `input.chatId` is provided, the rates are scoped to that customer's tax
   * jurisdiction and any customer-specific exemptions are removed. Without a
   * `chatId` (e.g. admin/catalog views) every rate classified on the product is
   * returned. Products with no tax classifications return an empty list.
   */
  taxes?: Maybe<Array<VendorItemUnitTax>>;
  /** Count of units under the same vendor item for this unit according to the provided filter. */
  unitsCount?: Maybe<Scalars['Int']['output']>;
  /** Universal Product Code (UPC) barcode of this unit. */
  upc?: Maybe<Scalars['String']['output']>;
  /** Vendor owning this unit. Will always be populated. Property is nullable for schema backwards compatability. */
  vendorId?: Maybe<Scalars['ID']['output']>;
  /** Reference to a vendor item that this unit belongs to. */
  vendorItem: VendorItemRef;
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitAvailabilityArgs = {
  chatId: Scalars['ID']['input'];
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitBuyerPropertiesArgs = {
  input: VendorItemUnitBuyerPropertiesInput;
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitChatProductFeaturesArgs = {
  chatId?: InputMaybe<Scalars['String']['input']>;
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitDisplayPropertiesArgs = {
  input: VendorItemUnitDisplayPropertiesInput;
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitIsInOrderGuideArgs = {
  orderGuideId: Scalars['ID']['input'];
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitLoyaltyArgs = {
  input: VendorItemUnitLoyaltyInput;
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitOrderGuideItemUnitArgs = {
  orderGuideId: Scalars['ID']['input'];
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitOrderGuideItemUnitsArgs = {
  chatId: Scalars['ID']['input'];
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitPriceArgs = {
  input?: InputMaybe<VendorItemUnitPriceInput>;
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitPricesV2Args = {
  input: VendorItemUnitPricesV2Input;
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitPromotionsArgs = {
  input: VendorItemUnitPromotionsInput;
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitTaxesArgs = {
  input?: InputMaybe<VendorItemUnitTaxInput>;
};


/** Represents a specific unit of a specific item in a vendor catalog. */
export type VendorItemUnitUnitsCountArgs = {
  filter?: InputMaybe<VendorItemUnitsFilter>;
};

/** Assets grouped by type for a vendor item unit. */
export type VendorItemUnitAssets = {
  __typename?: 'VendorItemUnitAssets';
  /** List of PDF assets */
  pdfs?: Maybe<Array<VendorItemUnitPdfAsset>>;
};

export type VendorItemUnitAttribute = {
  __typename?: 'VendorItemUnitAttribute';
  /**
   * Unique identifier of the attribute. Always equal to the value of the `attribute` field.
   * Included for compatibility; do not use if not required.
   */
  id: Scalars['ID']['output'];
  type: CatalogAttributeType | '%future added value';
  values: Array<CatalogAttributeValue>;
};

/**
 * Input for specifying attribute values for a vendor item unit.
 * Exactly one of `valueCodes` or `valueIds` must be provided, not both or neither.
 */
export type VendorItemUnitAttributeInput = {
  type: CatalogAttributeType | '%future added value';
  /**
   * List of value codes for the attribute.
   * Exactly one of `valueCodes` or `valueIds` must be provided.
   */
  valueCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * List of value IDs for the attribute.
   * Exactly one of `valueCodes` or `valueIds` must be provided.
   */
  valueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VendorItemUnitAvailability = {
  __typename?: 'VendorItemUnitAvailability';
  /**
   * The date at which the order will be available for ordering again.
   * It will be populated under the following conditions:
   *  - The unit has availableToOrderDate.
   *  - The status is OutOfStock.
   *  - The date is in the future.
   */
  availableToOrderDate?: Maybe<Scalars['AWSDate']['output']>;
  status: VendorItemUnitAvailabilityStatus | '%future added value';
};

/** Computed availability status for the VendorItemUnit that is intended for buyer facing frontends */
export const VendorItemUnitAvailabilityStatus = {
  /** This unit is available for ordering but the stock status is unknown */
  Available: 'Available',
  /**
   * This unit is not available for ordering because it is discontinued
   * and will not return to the catalog in the observable future.
   */
  Discontinued: 'Discontinued',
  /** This unit is available for ordering and is in stock */
  InStock: 'InStock',
  /** This unit is not available for ordering because it is out of stock */
  OutOfStock: 'OutOfStock',
  /** This unit is not available for ordering for the unknown reason */
  Unavailable: 'Unavailable'
} as const;

export type VendorItemUnitAvailabilityStatus = typeof VendorItemUnitAvailabilityStatus[keyof typeof VendorItemUnitAvailabilityStatus];
export type VendorItemUnitBuyerProperties = {
  __typename?: 'VendorItemUnitBuyerProperties';
  /** Override for the name of the item that only this Buyer will see. */
  displayItemName?: Maybe<Scalars['String']['output']>;
  /**
   * This ID filed is computed as `${vendorItemUnitId}:${buyerId}:${chatId}`.
   * Only intended for the frontend caching and watching.
   */
  id: Scalars['ID']['output'];
  /** Free-form text value specifying how many units of the item Buyer wants to keep in stock. */
  par?: Maybe<Scalars['String']['output']>;
};

export type VendorItemUnitBuyerPropertiesInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
};

export type VendorItemUnitBuyerPropertiesUpdateBatchResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitBuyerPropertiesUpdateBatchResult;

export type VendorItemUnitBuyerPropertiesUpdateBatchResult = AppsyncResponse & {
  __typename?: 'VendorItemUnitBuyerPropertiesUpdateBatchResult';
  /** The updated buyer properties of the vendor item unit in the order there were sent. */
  buyerProperties: Array<VendorItemUnitBuyerProperties>;
  /** Response type will will be `success` if all updates succeeded, otherwise it will be `failure` */
  responseType: ResponseType | '%future added value';
};

/**
 * Input for updating buyer properties of a vendor item unit.
 * Check the `VendorItemUnitBuyerProperties` type for more details on the fields.
 */
export type VendorItemUnitBuyerPropertiesUpdateInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  /**
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as an empty string, it will be deleted
   * If sent as a non-empty string, it will be updated
   */
  displayItemName?: InputMaybe<Scalars['String']['input']>;
  /**
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as `{ value: null | undefined }`, it will be deleted
   * If sent as `{ value : MoneyV2Input }`, it will be updated
   */
  myPrice?: InputMaybe<NullableMoneyV2Input>;
  /**
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as an empty string, it will be deleted
   * If sent as a non-empty string, it will be updated
   */
  par?: InputMaybe<Scalars['String']['input']>;
  vendorItemUnitId: Scalars['ID']['input'];
};

export type VendorItemUnitBuyerPropertiesUpdateResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitBuyerPropertiesUpdateResult;

export type VendorItemUnitBuyerPropertiesUpdateResult = AppsyncResponse & {
  __typename?: 'VendorItemUnitBuyerPropertiesUpdateResult';
  /** The updated buyer properties of the vendor item unit */
  buyerProperties: VendorItemUnitBuyerProperties;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

/**
 * This type is created to bundle buyer price with buyer properties
 * It is intended to phase out VendorItemUnitBuyerProperties in favor of this type
 * and return this whenever the buyer properties is requested.
 */
export type VendorItemUnitBuyerPropertiesWithPrice = {
  __typename?: 'VendorItemUnitBuyerPropertiesWithPrice';
  displayItemName?: Maybe<Scalars['String']['output']>;
  myPrice?: Maybe<MoneyV2>;
  par?: Maybe<Scalars['String']['output']>;
};

export type VendorItemUnitCustomerSpecificPriceUpdateInput = {
  buyerId: Scalars['ID']['input'];
  /**
   * If sent as `null`/`undefined`, it won't be touched/updated
   * If sent as `{ value: null | undefined }`, it will be deleted
   * If sent as `{ value : MoneyV2Input }`, it will be updated
   */
  price?: InputMaybe<NullableMoneyV2Input>;
  vendorItemUnitId: Scalars['ID']['input'];
};

export type VendorItemUnitCustomerSpecificPriceUpdateResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitCustomerSpecificPriceUpdateResult;

export type VendorItemUnitCustomerSpecificPriceUpdateResult = AppsyncResponse & {
  __typename?: 'VendorItemUnitCustomerSpecificPriceUpdateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  vendorItemUnit: VendorItemUnitRef;
};

export type VendorItemUnitDisplayProperties = {
  __typename?: 'VendorItemUnitDisplayProperties';
  /**
   * The description of the item unit.
   * This field will be `VendorItemUnit.itemDescriptionOverride` || `VendorItem.description`.
   */
  itemDescription: Scalars['String']['output'];
  /**
   * The display name of the item unit.
   * If the user is a buyer user, this field will be `vendorItemUnit.buyerProperties.displayItemName` || `VendorItemUnit.itemNameOverride` || `VendorItem.name`.
   * If the user is a supplier user, this field will be `VendorItemUnit.itemNameOverride` || `VendorItem.name`.
   */
  itemName: Scalars['String']['output'];
};

export type VendorItemUnitDisplayPropertiesInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

/** External link for a vendor item unit */
export type VendorItemUnitExternalLink = {
  __typename?: 'VendorItemUnitExternalLink';
  /** Unique identifier of the external link */
  id: Scalars['ID']['output'];
  /** Title of the external link */
  title: Scalars['String']['output'];
  /** Translations for the external link title */
  translations?: Maybe<Array<VendorItemUnitExternalLinkTranslation>>;
  /** URL of the external link */
  url: Scalars['String']['output'];
};

/** Input for creating or updating an external link */
export type VendorItemUnitExternalLinkInput = {
  /** Translations for the external link title */
  translations?: InputMaybe<Array<VendorItemUnitExternalLinkTranslationInput>>;
  /** URL of the external link */
  url: Scalars['String']['input'];
};

/** External link translation */
export type VendorItemUnitExternalLinkTranslation = {
  __typename?: 'VendorItemUnitExternalLinkTranslation';
  /** Locale code (e.g., "en-US", "fr-FR") */
  locale: Scalars['String']['output'];
  /** Title in the specified locale */
  title: Scalars['String']['output'];
};

/** Input for external link translation */
export type VendorItemUnitExternalLinkTranslationInput = {
  /** Locale code (e.g., "en-US", "fr-FR") */
  locale: Scalars['String']['input'];
  /** Title in the specified locale */
  title: Scalars['String']['input'];
};

/**
 * A VendorItemUnit resolved in a chat (buyer + supplier) context: prices, display strings,
 * order-guide membership, and per-buyer overrides are applied server-side and returned inline.
 * Composes by value the same per-buyer/per-display sub-types used on `VendorItemUnit`,
 * but without `Ref`/`.node` hops, so a single request returns a card-ready payload.
 */
export type VendorItemUnitForChat = {
  __typename?: 'VendorItemUnitForChat';
  baseUnitName?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  /**
   * Raw per-buyer overrides (par, displayItemName). Null unless needed — most card surfaces
   * only want the resolved strings on displayProperties.
   */
  buyerProperties?: Maybe<VendorItemUnitBuyerProperties>;
  catalogCategoryId?: Maybe<Scalars['String']['output']>;
  catalogCategoryName?: Maybe<Scalars['String']['output']>;
  /** Per-base-unit price (e.g. price per kg). Null if no base unit. */
  displayBasePrice?: Maybe<MoneyV2>;
  displayBasePriceBeforeDiscount?: Maybe<MoneyV2>;
  /** Display price for the unit (amount + currency). */
  displayPrice?: Maybe<MoneyV2>;
  /** Display price before discount, if discounted. Null if no discount. */
  displayPriceBeforeDiscount?: Maybe<MoneyV2>;
  /**
   * Chat-display-resolved item name and description. Unlike VendorItemUnit.displayProperties
   * (a field-resolver hop), this is populated inline by the parent resolver at no extra cost —
   * request it directly instead of a separate catalog-level name.
   */
  displayProperties: VendorItemUnitDisplayProperties;
  /** VendorItemUnit ID — needed for add-to-cart action. */
  id: Scalars['ID']['output'];
  images: Array<Scalars['String']['output']>;
  loyalty?: Maybe<LoyaltyPoints>;
  orderGuideItemUnits?: Maybe<Array<OrderGuideV2ItemUnit>>;
  orderingProperties?: Maybe<VendorItemUnitOrderingProperties>;
  packagingDescription: Scalars['String']['output'];
  productCode?: Maybe<Scalars['String']['output']>;
  /** Active promotions applicable to this unit in the chat context. */
  promotions?: Maybe<Array<VendorPromotion>>;
  /**
   * IDs of the other chat-visible, orderable units of the same parent vendor item,
   * excluding this unit itself. A non-empty array means this unit has variants.
   */
  siblingUnitIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Localized sub-brand from the parent VendorItem translation. */
  subBrand?: Maybe<Scalars['String']['output']>;
  unitName: Scalars['String']['output'];
  /** Vendor owning this unit. Will always be populated. Property is nullable for schema backwards compatability. */
  vendorId?: Maybe<Scalars['ID']['output']>;
  vendorItemId: Scalars['ID']['output'];
};


/**
 * A VendorItemUnit resolved in a chat (buyer + supplier) context: prices, display strings,
 * order-guide membership, and per-buyer overrides are applied server-side and returned inline.
 * Composes by value the same per-buyer/per-display sub-types used on `VendorItemUnit`,
 * but without `Ref`/`.node` hops, so a single request returns a card-ready payload.
 */
export type VendorItemUnitForChatPromotionsArgs = {
  input: VendorItemUnitPromotionsInput;
};

/**
 * VendorItemUnitImage represents VendorItemUnit image that can be returned with the dynamic size.
 * Images are immutable, the same image ID within the given type is always linked to the same image file.
 */
export type VendorItemUnitImage = {
  __typename?: 'VendorItemUnitImage';
  /** The image asset that provides the read URL. */
  asset: ImageAsset;
  /** The ID of the image asset to be retrieved */
  id: Scalars['ID']['output'];
};

export type VendorItemUnitImagesUploadInput = {
  /**
   * Number of images to create for the unit.
   * If not provided, the default value is 1
   */
  imagesCount?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the vendor item unit for which images are requested. */
  vendorItemUnitId: Scalars['ID']['input'];
};

/** Inventory data for a VendorItemUnit, with stock quantities. */
export type VendorItemUnitInventoryData = {
  __typename?: 'VendorItemUnitInventoryData';
  /**
   * Computed field representing the total available stock that can be allocated or promised.
   * If the `onPurchaseOrderDeliveryDate` is set, then the quantity is in this field is assumed to be at that date.
   */
  availableStock?: Maybe<Decimal>;
  id: Scalars['ID']['output'];
  /** Timestamp of the latest inventory update */
  lastUpdatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** The physical quantity of the item unit currently available in the warehouse as of now. */
  onHandQuantity?: Maybe<Decimal>;
  /** The quantity of the vendor item unit that has been ordered but has not yet been deducted from on-hand stock. */
  onOrderQuantity?: Maybe<Decimal>;
  /**
   * Expected delivery date for the current purchase order from the producer.
   * If null, the delivery date is unknown.
   */
  onPurchaseOrderDeliveryDate?: Maybe<Scalars['AWSDateTime']['output']>;
  /**
   * The quantity of the vendor item unit that has been ordered by the distributor
   * and is being delivered by the producer.
   */
  onPurchaseOrderQuantity?: Maybe<Decimal>;
  vendorItemUnitId: Scalars['ID']['output'];
};

export type VendorItemUnitLoyaltyInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

export type VendorItemUnitOrderingProperties = {
  __typename?: 'VendorItemUnitOrderingProperties';
  /**
   * The time of day that the item unit should be ordered by in order to be delivered on the same day
   * or on the closest day according to the lead time.
   * This is always returned in a Supplier Timezone.
   * If unset then there is no limitation.
   */
  cutOffTime?: Maybe<Scalars['AWSTime']['output']>;
  /**
   * `deliveryDateConditions` retrieves the earliest possible delivery date for a product and determines whether this date should be displayed to clients. This is calculated based on several factors:
   * - `leadTime`: The amount of time for a product to be ready for delivery.
   * - `cutoffTime`: The latest time an order can be placed to be shipped on the same day.
   * - `supplier delivery settings`: These settings may include factors like supplier's working days, holidays, and other conditions that could affect the delivery date.
   */
  deliveryDateConditions?: Maybe<ProductDeliveryDateCondition>;
  id: Scalars['ID']['output'];
  /**
   * The number of days this item unit should be ordered in advance.
   * If unset then the item unit can be ordered on the same day.
   */
  leadTimeDays?: Maybe<Scalars['Int']['output']>;
  /**
   * The minimum fraction step that the item unit can be ordered in,
   * e.g. 0.05 would mean that the item unit can be ordered in increments of 0.05.
   * If unset then the item unit can only be ordered in whole numbers.
   */
  minimumFractionalQuantity?: Maybe<Decimal>;
  /**
   * The minimum quantity of the item unit that can be ordered.
   * This value represents the smallest amount that a customer can purchase.
   * For example, if set to 5, customers must order at least 5 units of this item.
   * If unset, there is no minimum ordering quantity enforced.
   */
  minimumOrderingQuantity?: Maybe<Decimal>;
  vendorItemUnitId: Scalars['ID']['output'];
};


export type VendorItemUnitOrderingPropertiesDeliveryDateConditionsArgs = {
  chatId: Scalars['ID']['input'];
};

/** PDF asset for a vendor item unit. */
export type VendorItemUnitPdfAsset = {
  __typename?: 'VendorItemUnitPdfAsset';
  /** Timestamp when the asset was created */
  createdAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** Pre-signed URL to download the asset */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Original file name */
  fileName: Scalars['String']['output'];
  /** Unique identifier of the asset */
  id: Scalars['ID']['output'];
  /** Timestamp when the asset was last updated */
  updatedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type VendorItemUnitPriceInput = {
  /**
   * If the price is queried by a buyer user, this field must be populated with the buyer ID, otherwise the price will be returned as null
   * If the price is queried by a vendor user in context of a chat, this field must be populated with the buyer ID
   */
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  /** A chat in which context the price is requested. If the chatId is not provided, the price will be returned as null for buyer users. */
  chatId?: InputMaybe<Scalars['ID']['input']>;
  /** If provided, only returns prices which are valid at the requested datetime, if not provided, only the prices valid now are returned */
  validityDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type VendorItemUnitPriceSet = Node & {
  __typename?: 'VendorItemUnitPriceSet';
  /** The buyer price for the unit */
  buyerPrice?: Maybe<MoneyV2>;
  /** The display base price for the unit */
  displayBasePrice?: Maybe<MoneyV2>;
  /** The display base price before applying the discount */
  displayBasePriceBeforeDiscount?: Maybe<MoneyV2>;
  /** The display catalog price for the unit */
  displayCatalogPrice?: Maybe<MoneyV2>;
  /** The display catalog price before applying the discount */
  displayCatalogPriceBeforeDiscount?: Maybe<MoneyV2>;
  /** The display price for the unit */
  displayPrice: MoneyV2;
  /** The display price before applying the discount */
  displayPriceBeforeDiscount?: Maybe<MoneyV2>;
  /** VendorItemUnitPriceSet ID */
  id: Scalars['ID']['output'];
};

export type VendorItemUnitPricesV2 = {
  __typename?: 'VendorItemUnitPricesV2';
  /** Stable id for caching (the vendor item unit id). */
  id: Scalars['ID']['output'];
  /**
   * The net (tax-exclusive) price set — identical in shape to
   * `VendorItemUnit.price`. Null when the product has no visible price.
   */
  price?: Maybe<VendorItemUnitPriceSet>;
  /**
   * The tax computation grossing the display price up, plus the applicable tax
   * breakdown. Null when the chat has no tax profile configured (the caller then
   * shows the net price only).
   */
  tax?: Maybe<VendorItemUnitTaxComputation>;
};

export type VendorItemUnitPricesV2Input = {
  /**
   * Buyer to resolve customer-specific prices for, authorized against the caller's
   * identity. Required — the catalog price lookup is buyer-scoped.
   */
  buyerId: Scalars['ID']['input'];
  /**
   * Scopes the customer's prices and resolves the tax jurisdiction + any
   * customer-specific exemptions for this chat.
   */
  chatId: Scalars['ID']['input'];
};

export type VendorItemUnitPromotionsInput = {
  chatId: Scalars['ID']['input'];
  referenceDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

/**
 * Reference to the VendorItemUnit.
 * This type is returned when only the ID of the referenced object is known without additional querying.
 * If the object fields are needed, they can be fetched using the `node` field.
 */
export type VendorItemUnitRef = {
  __typename?: 'VendorItemUnitRef';
  /** Id of the referenced object */
  id: Scalars['ID']['output'];
  /**
   * When requested, resolves the actual object by its Id and allows to get its properties.
   * Note that the reference might be stale and therefore the object might not exist.
   */
  node?: Maybe<VendorItemUnit>;
};

/**
 * Stock status of the vendor item unit.
 * Determines whether the item unit is available for ordering on a catalog level.
 * Availability may be further restricted by the supplier, chat or custom catalog settings.
 */
export const VendorItemUnitStockStatus = {
  Discontinued: 'Discontinued',
  InStock: 'InStock',
  OutOfStock: 'OutOfStock'
} as const;

export type VendorItemUnitStockStatus = typeof VendorItemUnitStockStatus[keyof typeof VendorItemUnitStockStatus];
export type VendorItemUnitTax = {
  __typename?: 'VendorItemUnitTax';
  /**
   * Whether this rate still applies when the product's price is zero (e.g. a
   * fixed per-unit excise tax on a free product).
   */
  appliesToFreeProducts: Scalars['Boolean']['output'];
  /**
   * Internal UUID of the product tax classification linking this product to the
   * rate.
   */
  id: Scalars['ID']['output'];
  /** Code of the tax jurisdiction the rate belongs to, e.g. 'FR', 'TR', 'UK'. */
  jurisdictionCode: Scalars['String']['output'];
  /**
   * Supplier-provided display label, resolved to the caller's preferred locale
   * when a translation exists (e.g. 'TVA 20%'). Null when the supplier provided
   * none.
   */
  label?: Maybe<Scalars['String']['output']>;
  taxBehavior: TaxBehavior | '%future added value';
  /**
   * The rate's value, discriminated by its type: either a percentage of the
   * taxed amount or a fixed per-unit amount.
   */
  value: TaxRateValue;
};

export type VendorItemUnitTaxAmount = {
  __typename?: 'VendorItemUnitTaxAmount';
  /** The tax rate id. */
  id: Scalars['ID']['output'];
  /**
   * Supplier-provided display label, resolved to the caller's preferred locale
   * (e.g. 'TVA 20%'). Null when the supplier provided none.
   */
  label?: Maybe<Scalars['String']['output']>;
  /** The computed tax amount this rate contributes to the unit. */
  taxAmount: MoneyV2;
  taxBehavior: TaxBehavior | '%future added value';
  /** The amount this tax was computed on (net for exclusive, gross for inclusive). */
  taxableAmount: MoneyV2;
  /**
   * The rate's value, discriminated by its type: either a percentage or a fixed
   * per-unit amount.
   */
  value: TaxRateValue;
};

export type VendorItemUnitTaxComputation = {
  __typename?: 'VendorItemUnitTaxComputation';
  /** The gross (tax-inclusive) display unit price shown to the buyer. */
  grossUnitPrice: MoneyV2;
  /**
   * The net (tax-exclusive) display unit price, after backing out any inclusive
   * taxes.
   */
  netUnitPrice: MoneyV2;
  /** The total tax applied to the display unit (`grossUnitPrice - netUnitPrice`). */
  taxAmount: MoneyV2;
  /** The applicable tax rates, one entry per rate, with the amount each contributes. */
  taxes: Array<VendorItemUnitTaxAmount>;
};

export type VendorItemUnitTaxInput = {
  /**
   * Resolves the tax jurisdiction and customer-specific exemptions for this
   * customer relationship (chat). Optional — omitted for jurisdiction-agnostic
   * views such as the admin catalog.
   */
  chatId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Date (YYYY-MM-DD) used to pick the rates valid at delivery time. Optional —
   * defaults to today, which is sufficient for display and for tax computed at
   * order date.
   */
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type VendorItemUnitUpdateFailure = {
  __typename?: 'VendorItemUnitUpdateFailure';
  failureType: VendorItemUnitUpdateFailureType;
  vendorItemUnitId: Scalars['ID']['output'];
};

export type VendorItemUnitUpdateFailureType = AuthorizationFailure | InputValidationFailure | UnknownFailure;

/**
 * Changes that will be applied to the vendor item unit.
 * If a field is omitted, it will not be touched.
 * Check the `VendorItemUnit` type for documentation of the fields.
 */
export type VendorItemUnitUpdateInput = {
  /**
   * List of attributes to update for the vendor item unit.
   * If the field is not provided or the list is empty, the existing attributes will not be changed.
   * If the list is not empty, the assigned values for provided attributes will be completely replaced with the new ones, but attributes which are not provided will not be changed.
   */
  attributes?: InputMaybe<Array<VendorItemUnitAttributeInput>>;
  /**
   * List of external links to update for the vendor item unit.
   * If the field is not provided, the existing external links will not be changed.
   * If the list is empty, all external links will be removed.
   * If the list is not empty, the existing external links will be completely replaced with the new ones.
   */
  externalLinks?: InputMaybe<Array<VendorItemUnitExternalLinkInput>>;
  /**
   * List of image IDs that should be associated with the item unit.
   * First image in the list is considered the main image.
   * To create an image, use the `vendorItemUnitsImagesUpload` mutation.
   * Image must be dedicated to this vendor item unit.
   *
   * If the field is not provided, the existing images will not be changed.
   * If the list is empty, all images will be removed.
   * If the list is not empty, the existing images will be completely replaced with the new ones.
   */
  images?: InputMaybe<Array<Scalars['ID']['input']>>;
  stockStatus?: InputMaybe<VendorItemUnitStockStatus | '%future added value'>;
  /** ID of the vendor item unit to update. */
  vendorItemUnitId: Scalars['ID']['input'];
};

export type VendorItemUnitUpdateResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitUpdateResult;

export type VendorItemUnitUpdateResult = AppsyncResponse & {
  __typename?: 'VendorItemUnitUpdateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  unit: VendorItemUnit;
};

export type VendorItemUnitsBrowseInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  filter?: InputMaybe<BrowseFilterInput>;
  pagination?: InputMaybe<PaginationInputV2>;
  vendorId: Scalars['ID']['input'];
};

export type VendorItemUnitsBrowseResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitsBrowseSuccess;

export type VendorItemUnitsBrowseResultEdge = Edge & {
  __typename?: 'VendorItemUnitsBrowseResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorItemUnit;
};

export type VendorItemUnitsBrowseSuccess = AppsyncResponse & Connection & Page & {
  __typename?: 'VendorItemUnitsBrowseSuccess';
  edges: Array<VendorItemUnitsBrowseResultEdge>;
  facets: Array<FacetGroup>;
  pageInfo: PageInfo;
  responseType: ResponseType | '%future added value';
};

/** Filter input for the `VendorItem.units` field */
export type VendorItemUnitsFilter = {
  /**
   * When provided and set to true, returns only the units that are available for ordering.
   * Does nothing if set to false.
   */
  isOrdering?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Catalog fields that can be filtered/sorted by the admin search queries. Every field is both
 * filterable and sortable (the flat catalog index has no parent/child split, unlike the legacy tool
 * this replicates, which could not sort by brand/type).
 */
export const VendorItemUnitsForAdminSearchField = {
  Brand: 'BRAND',
  Description: 'DESCRIPTION',
  Hidden: 'HIDDEN',
  IsOrdering: 'IS_ORDERING',
  LegacyId: 'LEGACY_ID',
  Name: 'NAME',
  PackSize: 'PACK_SIZE',
  ProductCode: 'PRODUCT_CODE',
  Status: 'STATUS',
  Type: 'TYPE',
  Unit: 'UNIT',
  VendorId: 'VENDOR_ID',
  VendorItemId: 'VENDOR_ITEM_ID',
  VendorItemUnitId: 'VENDOR_ITEM_UNIT_ID'
} as const;

export type VendorItemUnitsForAdminSearchField = typeof VendorItemUnitsForAdminSearchField[keyof typeof VendorItemUnitsForAdminSearchField];
export type VendorItemUnitsForAdminSearchFilterCondition = {
  field: VendorItemUnitsForAdminSearchField | '%future added value';
  operator: VendorItemUnitsForAdminSearchFilterOperator | '%future added value';
  /** Used by every operator except IN / NOT_IN / IS_EMPTY / IS_NOT_EMPTY. */
  value?: InputMaybe<Scalars['String']['input']>;
  /** Used only by IN / NOT_IN — capped server-side to bound query cost. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Recursive filter tree, mirroring an AND/OR-of-conditions-or-groups filter builder shape.
 * Depth, condition/group counts, and IN/NOT_IN value-list length are capped server-side to bound
 * query cost.
 */
export type VendorItemUnitsForAdminSearchFilterGroup = {
  conditions?: InputMaybe<Array<VendorItemUnitsForAdminSearchFilterCondition>>;
  groups?: InputMaybe<Array<VendorItemUnitsForAdminSearchFilterGroup>>;
  operator?: VendorItemUnitsForAdminSearchFilterLogicalOperator | '%future added value';
};

export const VendorItemUnitsForAdminSearchFilterLogicalOperator = {
  And: 'AND',
  Or: 'OR'
} as const;

export type VendorItemUnitsForAdminSearchFilterLogicalOperator = typeof VendorItemUnitsForAdminSearchFilterLogicalOperator[keyof typeof VendorItemUnitsForAdminSearchFilterLogicalOperator];
export const VendorItemUnitsForAdminSearchFilterOperator = {
  Contains: 'CONTAINS',
  DoesNotContain: 'DOES_NOT_CONTAIN',
  Equals: 'EQUALS',
  GreaterThan: 'GREATER_THAN',
  GreaterThanOrEqual: 'GREATER_THAN_OR_EQUAL',
  In: 'IN',
  IsEmpty: 'IS_EMPTY',
  IsNotEmpty: 'IS_NOT_EMPTY',
  LessThan: 'LESS_THAN',
  LessThanOrEqual: 'LESS_THAN_OR_EQUAL',
  NotEquals: 'NOT_EQUALS',
  NotIn: 'NOT_IN',
  StartsWith: 'STARTS_WITH'
} as const;

export type VendorItemUnitsForAdminSearchFilterOperator = typeof VendorItemUnitsForAdminSearchFilterOperator[keyof typeof VendorItemUnitsForAdminSearchFilterOperator];
export type VendorItemUnitsForAdminSearchInput = {
  /**
   * No implicit filtering is applied (not vendor-scoped, no in-stock/orderable default) — this is a
   * generic, reusable search/lookup capability, not specific to any one consumer. Callers reconstruct
   * whatever default filtering they need (vendor scoping via VENDOR_ID, availability via
   * STATUS/IS_ORDERING, id inclusion/exclusion via VENDOR_ITEM_UNIT_ID IN/NOT_IN, etc.) via `filter`.
   */
  filter?: InputMaybe<VendorItemUnitsForAdminSearchFilterGroup>;
  pagination?: InputMaybe<PaginationInputV2>;
  /**
   * Free-text keyword search. When omitted, results are unranked (match_all) and ordered by `sort`
   * or relevance-independent default order — useful for pure filter/browse use cases, including
   * lookup by a known set of ids (VENDOR_ITEM_UNIT_ID IN filter + an explicit sort).
   */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<VendorItemUnitsForAdminSearchSort>>;
};

export type VendorItemUnitsForAdminSearchResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitsForAdminSearchResult;

export type VendorItemUnitsForAdminSearchResult = AppsyncResponse & Connection & Page & {
  __typename?: 'VendorItemUnitsForAdminSearchResult';
  edges: Array<VendorItemUnitsForAdminSearchResultEdge>;
  pageInfo: PageInfo;
  responseType: ResponseType | '%future added value';
  /** Metadata related to the result set. Will only be present on search endpoints. */
  searchMetadata?: Maybe<CatalogSearchMetadata>;
  totalCount: Scalars['Int']['output'];
};

export type VendorItemUnitsForAdminSearchResultEdge = Edge & {
  __typename?: 'VendorItemUnitsForAdminSearchResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorItemUnit;
};

export type VendorItemUnitsForAdminSearchSort = {
  field: VendorItemUnitsForAdminSearchField | '%future added value';
  order: SortOrder | '%future added value';
};

export type VendorItemUnitsForChatTypeaheadFilter = {
  /**
   * If provided, only items that have the given availability status will be returned. By default, out-of-stock or discontinued items are excluded.
   * @deprecated Units will be filtered based on supplier.buyerVisibleStockStatuses (defaults to InStock if not configured by the supplier).
   * @deprecated Units will be filtered based on supplier.buyerVisibleStockStatuses (defaults to InStock if not configured by the supplier).
   */
  availabilityStatus?: InputMaybe<Array<VendorItemUnitAvailabilityStatus | '%future added value'>>;
  /**
   * If multiple categories are provided, items from all of them are returned.
   * Can be set to 0-uuid to get "uncategorized"
   */
  vendorItemCategoryAncestorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VendorItemUnitsForChatTypeaheadInput = {
  chatId: Scalars['ID']['input'];
  filter?: InputMaybe<VendorItemUnitsForChatTypeaheadFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  searchQuery: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

export type VendorItemUnitsForVendorSearchFilter = {
  /** If provided, only items that have the given brand will be returned. */
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If provided, only items that contain the given catalog attributes (allergens and diertary preferences) will be returned. */
  catalogAttributes?: InputMaybe<Array<CatalogAttributeFilterItem>>;
  /** When specified, only items that are linked to the given custom catalog will be returned, */
  customCatalogId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * When specified, only items that are assigned to the provided custom catalogs will be returned.
   * If null or empty array, no filtering by custom catalogs is applied.
   */
  customCatalogIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When specified, returns items based on their hidden by default status, including those hidden or not hidden depending on the value provided. */
  isHiddenByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** When specified, only items that have the given stock status will be returned. */
  stockStatus?: InputMaybe<VendorItemUnitStockStatus | '%future added value'>;
  /**
   * If multiple categories are provided, items from all of them are returned.
   * Can be set to 0-uuid to get "uncategorized"
   */
  vendorItemCategoryAncestorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VendorItemUnitsForVendorSearchInput = {
  filter?: InputMaybe<VendorItemUnitsForVendorSearchFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  /**
   * When true, searchQuery will only match product code prefixes.
   * Optimized for fast product code lookups with minimal latency.
   * Default: false (full-text search across all fields).
   */
  productCodePrefixOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

export type VendorItemUnitsImagesUploadInput = {
  /** Units for which images are requested. */
  units: Array<VendorItemUnitImagesUploadInput>;
};

export type VendorItemUnitsImagesUploadResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitsImagesUploadResult;

export type VendorItemUnitsImagesUploadResult = AppsyncResponse & {
  __typename?: 'VendorItemUnitsImagesUploadResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  units: Array<VendorItemUnitsImagesUploadResultUnit>;
};

export type VendorItemUnitsImagesUploadResultImage = {
  __typename?: 'VendorItemUnitsImagesUploadResultImage';
  /**
   * ID of the image. Use this to associate the image with the vendor item unit
   * by calling the `vendorItemUnitsUpdate` mutation after the image is uploaded.
   */
  imageId: Scalars['ID']['output'];
  /**
   * URL where the image file should be uploaded to.
   * To upload the file, make the `POST` request to this URL.
   * Use `Content-Type: multipart/form-data`. Provide body in the `FormData` format.
   * There should only be a single binary field named `file` in the form data content.
   *
   * @example
   * ```typescript
   * const formData = new FormData();
   * formData.append('file', file); // where `file` is a File object
   * const response = await fetch(uploadUrl, {
   *   method: 'POST',
   *   body: formData,
   * });
   * ```
   */
  uploadUrl: Scalars['String']['output'];
};

export type VendorItemUnitsImagesUploadResultUnit = {
  __typename?: 'VendorItemUnitsImagesUploadResultUnit';
  images: Array<VendorItemUnitsImagesUploadResultImage>;
  vendorItemUnit: VendorItemUnitRef;
};

export type VendorItemUnitsResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitsResult;

export type VendorItemUnitsResult = AppsyncResponse & {
  __typename?: 'VendorItemUnitsResult';
  itemUnits: Array<VendorItemUnit>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type VendorItemUnitsUpdateInput = {
  units: Array<VendorItemUnitUpdateInput>;
};

export type VendorItemUnitsUpdateResponse = AuthorizationFailure | InputValidationFailure | VendorItemUnitsUpdateResult;

export type VendorItemUnitsUpdateResult = {
  __typename?: 'VendorItemUnitsUpdateResult';
  failures?: Maybe<Array<VendorItemUnitUpdateFailure>>;
  updatedUnits?: Maybe<Array<VendorItemUnit>>;
};

/** A variant group is a set of items that are similar to each other but have different properties. */
export type VendorItemVariantGroup = Node & {
  __typename?: 'VendorItemVariantGroup';
  /**
   * Code of the variant group that is meaningful to the vendor.
   * Note that this is not a technical property and it can be filled by humans.
   */
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** Filter input for the `vendorItemsCountForChat` query */
export type VendorItemsCountForChatFilter = {
  /**
   * If provided, only items that have the given stock status will be counted. By default, out-of-stock or discontinued items are excluded.
   * @deprecated Units will be filtered based on supplier.buyerVisibleStockStatuses (defaults to InStock if not configured by the supplier).
   * @deprecated Units will be filtered based on supplier.buyerVisibleStockStatuses (defaults to InStock if not configured by the supplier).
   */
  availabilityStatus?: InputMaybe<Array<VendorItemUnitAvailabilityStatus | '%future added value'>>;
  /**
   * if true only counts items without a category
   * if false returns the total count of vendor items in the chat
   */
  uncategorized?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input parameters for the `vendorItemsCountForChat` query */
export type VendorItemsCountForChatInput = {
  /**
   * Chat determines the context of the query.
   * Only the items that are visible for a given chat
   * via a custom catalog or default catalog relationship are counted.
   */
  chatId: Scalars['ID']['input'];
  filter?: InputMaybe<VendorItemsCountForChatFilter>;
  /** Id of the vendor whose catalog items are being counted */
  vendorId: Scalars['ID']['input'];
};

export type VendorItemsCountForChatResponse = AuthorizationFailure | InputValidationFailure | VendorItemsCountForChatSuccess;

/** Success response of the `vendorItemsCountForChat` query */
export type VendorItemsCountForChatSuccess = AppsyncResponse & {
  __typename?: 'VendorItemsCountForChatSuccess';
  count: Scalars['Int']['output'];
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

/**
 * Filter input for the `vendorItemsForChat` query
 * Note: If both "vendorItemCategoryId" and "vendorItemCategoryAncestorId" filters are provided, they are both applied independently and combined with an "AND"
 */
export type VendorItemsForChatFilterInput = {
  /** Filter by product attributes (allergens and dietary preferences). */
  attributes?: InputMaybe<Array<CatalogAttributeFilterItem>>;
  /**
   * If provided, only items that have the given stock status will be returned.
   * @deprecated Units will be filtered based on supplier.buyerVisibleStockStatuses (defaults to InStock if not configured by the supplier).
   * @deprecated Units will be filtered based on supplier.buyerVisibleStockStatuses (defaults to InStock if not configured by the supplier).
   */
  availabilityStatus?: InputMaybe<Array<VendorItemUnitAvailabilityStatus | '%future added value'>>;
  /**
   * If provided, only items that have the given barcode (EAN or UPC) will be returned.
   * The barcode should be valid EAN or UPC, otherwise a validation error will be returned.
   */
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** If provided, only items with the given `variantGroupCode` will be returned. */
  variantGroupCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * If the value is "00000000-0000-0000-0000-000000000000", only items that are not linked to any category are returned;
   * else only items belonging to the category with a given ID or any of its subcategories will be returned.
   */
  vendorItemCategoryAncestorId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * If the value is "00000000-0000-0000-0000-000000000000", only items that are not linked to any category are returned;
   * else only items directly linked to this category will be returned.
   * if not provided, all items are returned.
   * Note: Nested categories are not considered.
   */
  vendorItemCategoryId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input parameters for the `vendorItemsForChat` query */
export type VendorItemsForChatInput = {
  /**
   * Chat determines the context of the query.
   * Only the items that are visible for a given chat via a custom catalog or default catalog relationship will be returned.
   */
  chatId: Scalars['ID']['input'];
  /** Additional filters for the items to narrow down the output */
  filter?: InputMaybe<VendorItemsForChatFilterInput>;
  /** Pagination parameters */
  pagination?: InputMaybe<PaginationInputV2>;
  /** Id of the vendor whose items are being queried */
  vendorId: Scalars['ID']['input'];
};

export type VendorItemsForChatResponse = AuthorizationFailure | InputValidationFailure | VendorItemsForChatSuccess;

/** One item of the `vendorItemsForChat` query result page */
export type VendorItemsForChatResultEdge = Edge & {
  __typename?: 'VendorItemsForChatResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorItemUnit;
};

export type VendorItemsForChatSearchFilter = {
  /**
   * If provided, only items that have the given stock status will be returned. By default, out-of-stock or discontinued items are excluded.
   * @deprecated Units will be filtered based on supplier.buyerVisibleStockStatuses (defaults to InStock if not configured by the supplier).
   * @deprecated Units will be filtered based on supplier.buyerVisibleStockStatuses (defaults to InStock if not configured by the supplier).
   */
  availabilityStatus?: InputMaybe<Array<VendorItemUnitAvailabilityStatus | '%future added value'>>;
  /** If provided, only items that have the given brand will be returned. */
  brand?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If provided, only items that contain the given catalog attributes (allergens and diertary preferences) will be returned. */
  catalogAttributes?: InputMaybe<Array<CatalogAttributeFilterItem>>;
  /**
   * Generic facet selections, the same shape browse takes through
   * `BrowseFilterInput`. Selections of different types are combined with AND; the
   * combination within one selection is governed by its `mode`. This is the only
   * way to filter by `PROMOTION`.
   *
   * Selections are merged with the dimension-specific fields above rather than
   * replacing them, so a client can migrate one dimension at a time.
   */
  facets?: InputMaybe<Array<FacetSelection>>;
  /**
   * The ID of the order guide category to filter by.
   * If provided, only items in the specified category will be returned.
   * Used together with orderGuideIds to scope the category search within the specified order guides.
   * Requires orderGuideIds to be provided.
   */
  orderGuideCategoryId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the order guide to get the items for. */
  orderGuideId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The IDs of the order guides to get the items for.
   * Takes precedence over orderGuideId if both are provided.
   * Required when orderGuideCategoryId is provided.
   */
  orderGuideIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * If multiple categories are provided, items from all of them are returned.
   * Can be set to 0-uuid to get "uncategorized"
   */
  vendorItemCategoryAncestorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VendorItemsForChatSearchInput = {
  chatId: Scalars['ID']['input'];
  filter?: InputMaybe<VendorItemsForChatSearchFilter>;
  orderAgent?: InputMaybe<VendorItemsForChatSearchOrderAgentInput>;
  pagination?: InputMaybe<PaginationInputV2>;
  /** @Deprecated: filter moved to orderAgent.productCodePrefixOnly */
  productCodePrefixOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchQuery: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

export type VendorItemsForChatSearchOrderAgentInput = {
  /**
   * When true, the search ignores the Dx's buyer-visible stock statuses,
   * so units of every stock status match.
   * Can only be enabled by a Dx admin user.
   * Default: false.
   */
  ignoreStockStatus?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When true, searchQuery will only match product code prefixes.
   * Optimized for fast product code lookups with minimal latency.
   * Default: false (full-text search across all fields).
   */
  productCodePrefixOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Success response of the `vendorItemsForChat` query */
export type VendorItemsForChatSuccess = AppsyncResponse & Connection & Page & {
  __typename?: 'VendorItemsForChatSuccess';
  edges: Array<VendorItemsForChatResultEdge>;
  /**
   * Available facet values for the current search, in the same shape browse
   * returns. Carries every dimension `facets` carries, plus `PROMOTION`. Empty
   * groups are omitted, so a missing group means the client hides that control.
   * Null for non-search endpoints that reuse this type.
   */
  facetGroups?: Maybe<Array<FacetGroup>>;
  /**
   * Faceted filter values with counts for the current search (brands, allergens,
   * dietary attributes, categories). Populated only when the client selects this
   * field — a search that omits `facets` pays no aggregation cost in OpenSearch.
   * Null for non-search endpoints that reuse this type.
   * @deprecated Use facetGroups, which carries every dimension including PROMOTION.
   */
  facets?: Maybe<CatalogSearchFacets>;
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** Metadata related to the result set. Will only be present on search endpoints. */
  searchMetadata?: Maybe<CatalogSearchMetadata>;
};

/**
 * The filter can be applied to vendor items.
 * Note: If both "vendorItemCategoryIds" and "vendorItemCategoryAncestorIds" filters are provided, they are both applied independently and combined with an "AND"
 */
export type VendorItemsForVendorFilter = {
  /** Filter by product attributes (allergens and dietary preferences). */
  attributes?: InputMaybe<Array<CatalogAttributeFilterItem>>;
  /** When specified, only items that are linked to the given custom catalog will be returned. */
  customCatalogId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * When specified, only items that are assigned to the provided custom catalogs will be returned.
   * If null or empty array, no filtering by custom catalogs is applied.
   */
  customCatalogIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When specified, returns items based on their hidden by default status, including those hidden or not hidden depending on the value provided. */
  isHiddenByDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** When specified, only items that have the given stock status will be returned. */
  status?: InputMaybe<VendorItemUnitStockStatus | '%future added value'>;
  /** When specified, only items belonging to the given category or its descendants will be returned. */
  vendorItemCategoryAncestorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * If the array has the value "00000000-0000-0000-0000-000000000000", items that are not linked to any category are also returned;
   * else only items directly linked to the given categories will be returned.
   * if not provided, all items are returned.
   * Note: Nested categories are not considered.
   */
  vendorItemCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Input parameters for the `vendorItemsForVendor` query */
export type VendorItemsForVendorInput = {
  filter?: InputMaybe<VendorItemsForVendorFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  sort?: InputMaybe<VendorItemsForVendorSort>;
  vendorId: Scalars['ID']['input'];
};

export type VendorItemsForVendorResponse = AuthorizationFailure | InputValidationFailure | VendorItemsForVendorResult;

/** Success response of the `vendorItemsForVendor` query */
export type VendorItemsForVendorResult = AppsyncResponse & Connection & Page & {
  __typename?: 'VendorItemsForVendorResult';
  edges: Array<VendorItemsForVendorResultEdge>;
  pageInfo: PageInfo;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** Metadata related to the result set. Will only be present on search endpoints. */
  searchMetadata?: Maybe<CatalogSearchMetadata>;
  /** The total number of items matching the filter criteria. */
  totalCount: Scalars['Int']['output'];
};

export type VendorItemsForVendorResultEdge = Edge & {
  __typename?: 'VendorItemsForVendorResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorItemUnit;
};

/** Sorting parameters for VendorItems, indicating the field and the direction of order. */
export type VendorItemsForVendorSort = {
  field: VendorItemsForVendorSortField | '%future added value';
  order: SortOrder | '%future added value';
};

/** Sort fields available for organizing VendorItems results. */
export const VendorItemsForVendorSortField = {
  Name: 'name',
  ProductCode: 'productCode',
  UnitName: 'unitName'
} as const;

export type VendorItemsForVendorSortField = typeof VendorItemsForVendorSortField[keyof typeof VendorItemsForVendorSortField];
/** Input parameters for the `vendorItems` query */
export type VendorItemsInput = {
  /** An array of the item ids to fetch. Maximum 50 items can be fetched at a time. */
  ids: Array<Scalars['ID']['input']>;
};

export type VendorItemsResponse = AuthorizationFailure | InputValidationFailure | VendorItemsSuccess;

/** Success response of the `vendorItems` query */
export type VendorItemsSuccess = AppsyncResponse & {
  __typename?: 'VendorItemsSuccess';
  /**
   * Items that are fetched.
   * If the item is not found, it is not included in the list.
   */
  items: Array<VendorItem>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type VendorNotConfiguredForWebshopError = AppsyncError & AppsyncResponse & {
  __typename?: 'VendorNotConfiguredForWebshopError';
  /** Error message indicating the vendor is not configured for web shop functionality */
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

/** One brand in a vendor's catalog, with its product count and boost status. */
export type VendorPreferredBrand = {
  __typename?: 'VendorPreferredBrand';
  boostStatus: VendorPreferredBrandBoostStatus | '%future added value';
  /** Brand name. Same string as `brandKey`. */
  brand: VendorBrand;
  /**
   * The brand string as the vendor's catalog holds it, in their default locale.
   * Both the identifier to pass back on update and the display name. Brands match
   * by exact string, so a catalog holding several spellings of one brand yields
   * several rows.
   */
  brandKey: Scalars['ID']['output'];
  /**
   * Distinct products (vendor items) of this brand, counted once per product and NOT
   * multiplied by its unit variants. Exact unless `productCountCapped` is true, in
   * which case it reports the 999 cap — never an estimate.
   *
   * `0` means the brand is no longer in the vendor's catalog; the row remains
   * because the vendor has a boost decision on record for it, and it may still be
   * `BOOSTED`. A brand present in the catalog always counts at least 1.
   */
  productCount: Scalars['Int']['output'];
  /** True when the brand holds more products than `productCount` reports. */
  productCountCapped: Scalars['Boolean']['output'];
};

/**
 * Boost status of a brand. Additive: further values may be introduced, so treat any
 * value other than `NONE` as boosted.
 */
export const VendorPreferredBrandBoostStatus = {
  Boosted: 'BOOSTED',
  None: 'NONE'
} as const;

export type VendorPreferredBrandBoostStatus = typeof VendorPreferredBrandBoostStatus[keyof typeof VendorPreferredBrandBoostStatus];
/** One brand's new boost status. */
export type VendorPreferredBrandUpdateItemInput = {
  boostStatus: VendorPreferredBrandBoostStatus | '%future added value';
  /**
   * The brand string exactly as `VendorPreferredBrand.brandKey` returned it, stored
   * verbatim. Matching is exact, so `kerrygold` and `Kerrygold` are two different
   * brands. Non-empty, at most 200 characters.
   */
  brandKey: Scalars['ID']['input'];
};

/**
 * One brand as stored by `vendorPreferredBrandsUpdate`. No product count — counts
 * are derived from the vendor's catalog, which the write does not read.
 */
export type VendorPreferredBrandUpdated = {
  __typename?: 'VendorPreferredBrandUpdated';
  boostStatus: VendorPreferredBrandBoostStatus | '%future added value';
  /** The brand string as stored — byte for byte what the input carried. */
  brandKey: Scalars['ID']['output'];
};

/** Input for the `vendorPreferredBrands` query. */
export type VendorPreferredBrandsInput = {
  vendorId: Scalars['ID']['input'];
};

export type VendorPreferredBrandsResponse = AuthorizationFailure | InputValidationFailure | VendorPreferredBrandsResult;

/** Success result of the `vendorPreferredBrands` query. */
export type VendorPreferredBrandsResult = AppsyncResponse & {
  __typename?: 'VendorPreferredBrandsResult';
  /**
   * Every brand for the vendor, ordered alphabetically by `brand.name`. Truncated
   * only for a vendor holding more than 10 000 distinct brands.
   */
  brands: Array<VendorPreferredBrand>;
  responseType: ResponseType | '%future added value';
};

/** Input for the `vendorPreferredBrandsUpdate` mutation. */
export type VendorPreferredBrandsUpdateInput = {
  /** The brands to set. Must be unique by `brandKey`; at most 500 entries. */
  brands: Array<VendorPreferredBrandUpdateItemInput>;
  vendorId: Scalars['ID']['input'];
};

export type VendorPreferredBrandsUpdateResponse = AuthorizationFailure | InputValidationFailure | VendorPreferredBrandsUpdateResult;

/** Success result of the `vendorPreferredBrandsUpdate` mutation. */
export type VendorPreferredBrandsUpdateResult = AppsyncResponse & {
  __typename?: 'VendorPreferredBrandsUpdateResult';
  /** The rows carried in the input, as stored. Never the vendor's full set. */
  brands: Array<VendorPreferredBrandUpdated>;
  responseType: ResponseType | '%future added value';
};

/** Buyer-facing promotion summary. */
export type VendorPromotion = Node & {
  __typename?: 'VendorPromotion';
  /**
   * Epoch milliseconds, not the seconds the scalar implies. Buyer apps read
   * milliseconds, so the value stays until a replacement field is introduced.
   */
  beginAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  /** Eligible chats for this promotion in the buyer context. */
  chats?: Maybe<Array<ChatRef>>;
  /** Locale-resolved longer promotion description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Epoch milliseconds, see `beginAt`. */
  endAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<VendorPromotionImage>>;
  /** Locale-resolved promotion title. */
  name: Scalars['String']['output'];
  primaryImage?: Maybe<VendorPromotionImage>;
  /** Locale-resolved badge or hero copy. */
  shortDescription?: Maybe<Scalars['String']['output']>;
  tierMode: VendorPromotionTierMode | '%future added value';
  /** Tier tree used by promotion detail surfaces. */
  tiers?: Maybe<Array<VendorPromotionTier>>;
  /** Supplier/vendor reference for this promotion. */
  vendor?: Maybe<SupplierRef>;
  /** Supplier/vendor that owns this promotion. */
  vendorId: Scalars['ID']['output'];
};


/** Buyer-facing promotion summary. */
export type VendorPromotionChatsArgs = {
  buyerId: Scalars['ID']['input'];
};

export type VendorPromotionCartDiscountPercentageOffer = VendorPromotionTierOffer & {
  __typename?: 'VendorPromotionCartDiscountPercentageOffer';
  discountPercentage: Decimal;
  type: VendorPromotionTierOfferType | '%future added value';
};

export type VendorPromotionCartFreeExtraUnitsOffer = VendorPromotionTierOffer & {
  __typename?: 'VendorPromotionCartFreeExtraUnitsOffer';
  offeredUnits: Array<VendorItemUnitRef>;
  quantityOffered: Decimal;
  type: VendorPromotionTierOfferType | '%future added value';
};

export type VendorPromotionCartReducedPriceOffer = VendorPromotionTierOffer & {
  __typename?: 'VendorPromotionCartReducedPriceOffer';
  priceReduction: MoneyV2;
  type: VendorPromotionTierOfferType | '%future added value';
};

export type VendorPromotionDiscountPercentageOffer = VendorPromotionTierOffer & {
  __typename?: 'VendorPromotionDiscountPercentageOffer';
  discountPercentage: Decimal;
  type: VendorPromotionTierOfferType | '%future added value';
};

export type VendorPromotionEligibleUnitsInput = {
  buyerId: Scalars['ID']['input'];
  chatId: Scalars['ID']['input'];
  pagination: PaginationInputV2;
  promotionId: Scalars['ID']['input'];
  referenceDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type VendorPromotionEligibleUnitsResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | VendorPromotionEligibleUnitsResult;

export type VendorPromotionEligibleUnitsResult = AppsyncResponse & {
  __typename?: 'VendorPromotionEligibleUnitsResult';
  edges: Array<VendorPromotionEligibleUnitsResultEdge>;
  pageInfo: PageInfo;
  responseType: ResponseType | '%future added value';
};

export type VendorPromotionEligibleUnitsResultEdge = {
  __typename?: 'VendorPromotionEligibleUnitsResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorItemUnitRef;
};

export type VendorPromotionFixedPriceOffer = VendorPromotionTierOffer & {
  __typename?: 'VendorPromotionFixedPriceOffer';
  price: MoneyV2;
  type: VendorPromotionTierOfferType | '%future added value';
};

export type VendorPromotionFreeUnitsIncludedOffer = VendorPromotionTierOffer & {
  __typename?: 'VendorPromotionFreeUnitsIncludedOffer';
  quantityOffered: Decimal;
  type: VendorPromotionTierOfferType | '%future added value';
};

export type VendorPromotionImage = {
  __typename?: 'VendorPromotionImage';
  /** The image asset that provides the read URL. */
  asset: ImageAsset;
  /** The ID of the promotion image asset. */
  id: Scalars['ID']['output'];
};

export type VendorPromotionListFilter = {
  /** Epoch milliseconds, like `VendorPromotion.beginAt`. */
  beginAtMin?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  /** Epoch milliseconds, like `VendorPromotion.endAt`. */
  endAtMax?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VendorPromotionListInput = {
  filter?: InputMaybe<VendorPromotionListFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  vendorId: Scalars['ID']['input'];
};

export type VendorPromotionListResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | VendorPromotionListResult;

export type VendorPromotionListResult = AppsyncResponse & Connection & Page & {
  __typename?: 'VendorPromotionListResult';
  edges: Array<VendorPromotionListResultEdge>;
  pageInfo: PageInfo;
  responseType: ResponseType | '%future added value';
};

export type VendorPromotionListResultEdge = Edge & {
  __typename?: 'VendorPromotionListResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorPromotionRecord;
};

export type VendorPromotionMarketingTranslationInput = {
  displayDescription?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  /**
   * When true, clears both overrides of this locale so buyers see the ERP copy
   * again. `displayName` and `displayDescription` must be omitted with it.
   */
  reset?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VendorPromotionMarketingUpdateInput = {
  promotionId: Scalars['ID']['input'];
  /**
   * One entry per locale to change. A null or empty value clears that override,
   * an omitted field leaves the stored one alone.
   */
  translations: Array<VendorPromotionMarketingTranslationInput>;
  vendorId: Scalars['ID']['input'];
};

export type VendorPromotionMarketingUpdateResponse = AuthorizationFailure | InputValidationFailure | NotFoundError | VendorPromotionMarketingUpdateResult;

export type VendorPromotionMarketingUpdateResult = AppsyncResponse & {
  __typename?: 'VendorPromotionMarketingUpdateResult';
  record: VendorPromotionRecord;
  responseType: ResponseType | '%future added value';
};

/** A promotion as the supplier configured it. `promotion` is the buyer-facing view. */
export type VendorPromotionRecord = Node & {
  __typename?: 'VendorPromotionRecord';
  categoryCode?: Maybe<Scalars['String']['output']>;
  /** Empty when `isAppliedToAllChats` is true. */
  chats: Array<ChatRef>;
  /** Supplier-provided code. Null for promotions imported without one. */
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** The supplier's switch. Dates are not considered; see `status`. */
  isActive: Scalars['Boolean']['output'];
  isAppliedToAllChats: Scalars['Boolean']['output'];
  /** Higher weight applies first when promotions overlap. */
  priorityWeight?: Maybe<Scalars['Int']['output']>;
  promotion: VendorPromotion;
  /**
   * Evaluated at request time from `isActive`, `promotion.beginAt` and
   * `promotion.endAt`.
   */
  status: VendorPromotionRecordStatus | '%future added value';
  /**
   * Copy per locale: what the ERP sent and the Choco-side override, if any.
   * The buyer sees the override when it is set.
   */
  translations: Array<VendorPromotionRecordTranslation>;
};

/**
 * Where a promotion stands right now. `isActive` is the supplier's switch; the
 * dates decide the rest.
 */
export const VendorPromotionRecordStatus = {
  /** Disabled by the supplier, whatever the dates say. */
  Disabled: 'DISABLED',
  /** Enabled, `endAt` is in the past. */
  Expired: 'EXPIRED',
  /** Enabled and inside the date window, or with no dates set. */
  Live: 'LIVE',
  /** Enabled, `beginAt` is in the future. */
  Scheduled: 'SCHEDULED'
} as const;

export type VendorPromotionRecordStatus = typeof VendorPromotionRecordStatus[keyof typeof VendorPromotionRecordStatus];
export type VendorPromotionRecordTranslation = {
  __typename?: 'VendorPromotionRecordTranslation';
  description: Scalars['String']['output'];
  /** Choco-side override of `description`. Null when none is set. */
  displayDescription?: Maybe<Scalars['String']['output']>;
  /** Choco-side override of `name`. Null when none is set. */
  displayName?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortDescription?: Maybe<Scalars['String']['output']>;
};

export type VendorPromotionReducedPriceOffer = VendorPromotionTierOffer & {
  __typename?: 'VendorPromotionReducedPriceOffer';
  priceReduction: MoneyV2;
  type: VendorPromotionTierOfferType | '%future added value';
};

export type VendorPromotionRef = {
  __typename?: 'VendorPromotionRef';
  id: Scalars['ID']['output'];
};

export type VendorPromotionTier = {
  __typename?: 'VendorPromotionTier';
  conditions: Array<VendorPromotionTierCondition>;
  id: Scalars['ID']['output'];
  /** Maximum number of times this tier can apply for stackable promotions. */
  maxApplications?: Maybe<Scalars['Int']['output']>;
  /** Locale-resolved tier title. */
  name: Scalars['String']['output'];
  offers: Array<VendorPromotionTierOffer>;
};

export type VendorPromotionTierCondition = {
  __typename?: 'VendorPromotionTierCondition';
  maximumAmount?: Maybe<MoneyV2>;
  maximumQuantity?: Maybe<Decimal>;
  metric: VendorPromotionTierConditionMetric | '%future added value';
  /** Populated when metric is AMOUNT. */
  minimumAmount?: Maybe<MoneyV2>;
  /** Populated when metric is QUANTITY. */
  minimumQuantity?: Maybe<Decimal>;
};

export const VendorPromotionTierConditionMetric = {
  Amount: 'AMOUNT',
  Quantity: 'QUANTITY'
} as const;

export type VendorPromotionTierConditionMetric = typeof VendorPromotionTierConditionMetric[keyof typeof VendorPromotionTierConditionMetric];
export const VendorPromotionTierMode = {
  Exclusive: 'EXCLUSIVE',
  Stackable: 'STACKABLE'
} as const;

export type VendorPromotionTierMode = typeof VendorPromotionTierMode[keyof typeof VendorPromotionTierMode];
export type VendorPromotionTierOffer = {
  type: VendorPromotionTierOfferType | '%future added value';
};

export const VendorPromotionTierOfferType = {
  CartDiscountPercentage: 'CART_DISCOUNT_PERCENTAGE',
  CartFreeExtraUnits: 'CART_FREE_EXTRA_UNITS',
  CartReducedPrice: 'CART_REDUCED_PRICE',
  DiscountPercentage: 'DISCOUNT_PERCENTAGE',
  FixedPrice: 'FIXED_PRICE',
  FreeUnitsIncluded: 'FREE_UNITS_INCLUDED',
  ReducedPrice: 'REDUCED_PRICE'
} as const;

export type VendorPromotionTierOfferType = typeof VendorPromotionTierOfferType[keyof typeof VendorPromotionTierOfferType];
export type VendorPromotionsForBuyerFilter = {
  /** Optional single chat scope when the UI has a selected customer context. */
  chatId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional promotion scope. */
  promotionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Optional vendor scope for white-label apps. */
  vendorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type VendorPromotionsForBuyerInput = {
  buyerId: Scalars['ID']['input'];
  filter?: InputMaybe<VendorPromotionsForBuyerFilter>;
  pagination?: InputMaybe<PaginationInputV2>;
  referenceDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type VendorPromotionsForBuyerResponse = AuthorizationFailure | InputValidationFailure | VendorPromotionsForBuyerSuccess;

export type VendorPromotionsForBuyerResultEdge = Edge & {
  __typename?: 'VendorPromotionsForBuyerResultEdge';
  cursor: Scalars['String']['output'];
  node: VendorPromotion;
};

export type VendorPromotionsForBuyerSuccess = AppsyncResponse & Connection & Page & {
  __typename?: 'VendorPromotionsForBuyerSuccess';
  edges: Array<VendorPromotionsForBuyerResultEdge>;
  pageInfo: PageInfo;
  responseType: ResponseType | '%future added value';
};

/**
 * A per-vendor, one-way search synonym rule (`rootTerm` → `mappedTerm`). When a
 * search query contains the `rootTerm`, the search additionally runs the
 * `mappedTerm` so that abbreviations resolve to real products, without removing
 * any baseline results.
 */
export type VendorSearchSynonym = {
  __typename?: 'VendorSearchSynonym';
  id: Scalars['ID']['output'];
  /** The full term the `rootTerm` expands to. Stored normalized. 1–100 characters. */
  mappedTerm: Scalars['String']['output'];
  /**
   * The root term representing terms on the search query, typically an abbreviation
   * or shorthand. Stored normalized (lowercased, trimmed). 2–100 characters.
   */
  rootTerm: Scalars['String']['output'];
  vendorId: Scalars['ID']['output'];
};

/**
 * Input for the `vendorSearchSynonymCreate` mutation. `rootTerm`/`mappedTerm` are
 * normalized (lowercased, trimmed) at write time; a duplicate `rootTerm` for
 * the vendor is rejected.
 */
export type VendorSearchSynonymCreateInput = {
  /** The full term the `rootTerm` expands to. Stored normalized. 1–100 characters. */
  mappedTerm: Scalars['String']['input'];
  /**
   * The root term representing terms on the search query, typically an abbreviation
   * or shorthand. Stored normalized (lowercased, trimmed). 2–100 characters.
   * Unique per vendor.
   */
  rootTerm: Scalars['String']['input'];
  vendorId: Scalars['ID']['input'];
};

/**
 * A rule with the same `rootTerm` already exists for the vendor. `rootTerm` is
 * unique per vendor, so the existing rule has to be updated or deleted instead.
 */
export type VendorSearchSynonymDuplicateFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'VendorSearchSynonymDuplicateFailure';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.error */
  responseType: ResponseType | '%future added value';
  /** The normalized `rootTerm` that is already taken. */
  rootTerm: Scalars['String']['output'];
};

/**
 * The vendor already holds the maximum number of synonym rules, so no further rule
 * can be created. An existing rule has to be deleted to make room.
 */
export type VendorSearchSynonymLimitExceededFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'VendorSearchSynonymLimitExceededFailure';
  /** The maximum number of synonym rules a single vendor may hold. */
  limit: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.error */
  responseType: ResponseType | '%future added value';
};

/** No synonym rule with the given id exists for the vendor. */
export type VendorSearchSynonymNotFoundFailure = AppsyncError & AppsyncResponse & {
  __typename?: 'VendorSearchSynonymNotFoundFailure';
  /** Id of the rule that could not be found. */
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.error */
  responseType: ResponseType | '%future added value';
};

/**
 * Response of the `vendorSearchSynonymCreate` / `vendorSearchSynonymUpdate`
 * mutations. `VendorSearchSynonymLimitExceededFailure` is only ever returned by
 * create, and `VendorSearchSynonymNotFoundFailure` only by update.
 */
export type VendorSearchSynonymResponse = AuthorizationFailure | InputValidationFailure | VendorSearchSynonymDuplicateFailure | VendorSearchSynonymLimitExceededFailure | VendorSearchSynonymNotFoundFailure | VendorSearchSynonymResult;

/**
 * Success result of the `vendorSearchSynonymCreate` / `vendorSearchSynonymUpdate`
 * mutations. Returns the created/updated rule.
 */
export type VendorSearchSynonymResult = AppsyncResponse & {
  __typename?: 'VendorSearchSynonymResult';
  responseType: ResponseType | '%future added value';
  synonym: VendorSearchSynonym;
};

/**
 * Input for the `vendorSearchSynonymUpdate` mutation. Omitted fields are left
 * unchanged.
 */
export type VendorSearchSynonymUpdateInput = {
  id: Scalars['ID']['input'];
  mappedTerm?: InputMaybe<Scalars['String']['input']>;
  rootTerm?: InputMaybe<Scalars['String']['input']>;
  vendorId: Scalars['ID']['input'];
};

/** Input for the `vendorSearchSynonymsDelete` mutation. */
export type VendorSearchSynonymsDeleteInput = {
  ids: Array<Scalars['ID']['input']>;
  vendorId: Scalars['ID']['input'];
};

export type VendorSearchSynonymsDeleteResponse = AuthorizationFailure | InputValidationFailure | VendorSearchSynonymsDeleteResult;

/** Success result of the `vendorSearchSynonymsDelete` mutation. */
export type VendorSearchSynonymsDeleteResult = AppsyncResponse & {
  __typename?: 'VendorSearchSynonymsDeleteResult';
  /** Ids of the synonym rules that were deleted. */
  deletedIds: Array<Scalars['ID']['output']>;
  responseType: ResponseType | '%future added value';
};

/** Input for the `vendorSearchSynonyms` query. */
export type VendorSearchSynonymsInput = {
  vendorId: Scalars['ID']['input'];
};

export type VoiceAgentProfileInput = {
  /** The type of the voice agent profile. */
  type: VoiceAgentProfileType | '%future added value';
  /** The variant of the voice agent profile, used for testing different configurations of the same profile. Will use the [main] variant if not specified. */
  variant?: InputMaybe<Scalars['String']['input']>;
  /** The version of the voice agent profile. Will use the latest version if not specified. */
  version?: InputMaybe<Scalars['String']['input']>;
};

export const VoiceAgentProfileType = {
  VoiceOrderAgent: 'VoiceOrderAgent'
} as const;

export type VoiceAgentProfileType = typeof VoiceAgentProfileType[keyof typeof VoiceAgentProfileType];
export type VoiceAgentSessionContextInput = {
  buyerId?: InputMaybe<Scalars['ID']['input']>;
  chatId?: InputMaybe<Scalars['ID']['input']>;
  supplierId?: InputMaybe<Scalars['ID']['input']>;
};

export type VoiceAgentWebRtcSessionStartError = {
  __typename?: 'VoiceAgentWebRTCSessionStartError';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type VoiceAgentWebRtcSessionStartInput = {
  agentProfile: VoiceAgentProfileInput;
  /**
   * Session context. Admin-only apart from `buyerId`: a supplier user's session
   * always runs against the supplier on their own identity, so `supplierId` may
   * be omitted (and, when sent, must match it), and a `chatId` they cannot be
   * shown to own is ignored rather than rejected — the chat is resolved in-call
   * by customer matching.
   */
  context: VoiceAgentSessionContextInput;
  /**
   * Optional runtime configuration overrides for the voice agent session, applied
   * to this call only and never saved as supplier settings. JSON string validated
   * server-side. Supplier users may send `supplierAgentSettings` — the unsaved
   * settings draft — and nothing else; every other override is admin-only.
   */
  overrides?: InputMaybe<Scalars['AWSJSON']['input']>;
  /** The SDP offer from the client to establish the WebRTC connection. */
  sdp: Scalars['String']['input'];
  /**
   * Opt the session into shadow mode: real reads against the supplier (catalog, prices, OrderGuide)
   * but no supplier-visible writes (no Transmission, no Order, no audio upload). Admin-only.
   * Defaults to false when absent.
   */
  shadow?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VoiceAgentWebRtcSessionStartResponse = AuthorizationFailure | InputValidationFailure | VoiceAgentWebRtcSessionStartError | VoiceAgentWebRtcSessionStartSuccess;

export type VoiceAgentWebRtcSessionStartSuccess = {
  __typename?: 'VoiceAgentWebRTCSessionStartSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  /** The SDP answer from the voice agent to establish the WebRTC connection. */
  sdp: Scalars['String']['output'];
  /** The unique identifier of the WebRTC session. Used for tracking and managing the session. */
  sessionId: Scalars['ID']['output'];
};

export type VoiceCallMetadata = {
  __typename?: 'VoiceCallMetadata';
  agentUserId?: Maybe<Scalars['ID']['output']>;
  buyerContactId?: Maybe<Scalars['ID']['output']>;
  callSessionId: Scalars['ID']['output'];
  endedAt?: Maybe<Scalars['AWSTimestamp']['output']>;
  externalConversationId?: Maybe<Scalars['ID']['output']>;
  startedAt: Scalars['AWSTimestamp']['output'];
};

export type VoiceCallMetadataInput = {
  agentUserId?: InputMaybe<Scalars['ID']['input']>;
  buyerContactId?: InputMaybe<Scalars['ID']['input']>;
  callSessionId: Scalars['ID']['input'];
  endedAt?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  externalConversationId?: InputMaybe<Scalars['ID']['input']>;
  startedAt: Scalars['AWSTimestamp']['input'];
};

export const VoiceCallSpeaker = {
  Agent: 'agent',
  System: 'system',
  Unknown: 'unknown',
  User: 'user'
} as const;

export type VoiceCallSpeaker = typeof VoiceCallSpeaker[keyof typeof VoiceCallSpeaker];
/** How the caller-id agent asks inbound callers to identify themselves. */
export const VoiceOrderAgentBuyerIdentificationMethod = {
  /** Caller identifies by business name */
  BusinessName: 'BusinessName',
  /** Caller identifies by customer number */
  CustomerNumber: 'CustomerNumber'
} as const;

export type VoiceOrderAgentBuyerIdentificationMethod = typeof VoiceOrderAgentBuyerIdentificationMethod[keyof typeof VoiceOrderAgentBuyerIdentificationMethod];
/** Controls whether a voice-placed order is auto-approved or requires manual review. */
export const VoiceOrderAgentOrderReviewDirective = {
  /** Order is flagged for manual review before approval. */
  RequireReview: 'RequireReview',
  /** Order goes through minimal checks and is auto-approved. */
  SkipReview: 'SkipReview'
} as const;

export type VoiceOrderAgentOrderReviewDirective = typeof VoiceOrderAgentOrderReviewDirective[keyof typeof VoiceOrderAgentOrderReviewDirective];
export type VoiceOrderAgentSettings = {
  __typename?: 'VoiceOrderAgentSettings';
  additionalInstructions: Scalars['String']['output'];
  agentDisplayName: Scalars['String']['output'];
  closingSentence: Scalars['String']['output'];
  defaultLanguage: Scalars['String']['output'];
  greetingSentence: Scalars['String']['output'];
  identificationMethod?: Maybe<VoiceOrderAgentBuyerIdentificationMethod | '%future added value'>;
  orderReviewDirective?: Maybe<VoiceOrderAgentOrderReviewDirective | '%future added value'>;
  /** @deprecated Use speedMultiplier instead. */
  speed?: Maybe<VoiceOrderAgentSpeed | '%future added value'>;
  /**
   * Talking speed as a multiplier of the normal pace (0.25 to 1.5). When omitted,
   * the profile's default speed is used.
   */
  speedMultiplier?: Maybe<Scalars['Float']['output']>;
  tone: VoiceOrderAgentTone | '%future added value';
  verbosity: VoiceOrderAgentVerbosity | '%future added value';
  voiceId: VoiceOrderAgentVoiceId | '%future added value';
};

export type VoiceOrderAgentSettingsInput = {
  additionalInstructions: Scalars['String']['input'];
  agentDisplayName: Scalars['String']['input'];
  closingSentence: Scalars['String']['input'];
  defaultLanguage: Scalars['String']['input'];
  greetingSentence: Scalars['String']['input'];
  identificationMethod?: InputMaybe<VoiceOrderAgentBuyerIdentificationMethod | '%future added value'>;
  orderReviewDirective?: InputMaybe<VoiceOrderAgentOrderReviewDirective | '%future added value'>;
  /** @deprecated Use speedMultiplier instead. */
  speed?: InputMaybe<VoiceOrderAgentSpeed | '%future added value'>;
  /**
   * Talking speed as a multiplier of the normal pace (0.25 to 1.5). When both
   * speed and speedMultiplier are sent, speedMultiplier wins.
   */
  speedMultiplier?: InputMaybe<Scalars['Float']['input']>;
  tone: VoiceOrderAgentTone | '%future added value';
  verbosity: VoiceOrderAgentVerbosity | '%future added value';
  voiceId: VoiceOrderAgentVoiceId | '%future added value';
};

/**
 * Controls how fast the voice agent speaks. When omitted, the profile's
 * default speed is used.
 */
export const VoiceOrderAgentSpeed = {
  Fast: 'Fast',
  Normal: 'Normal',
  Slow: 'Slow'
} as const;

export type VoiceOrderAgentSpeed = typeof VoiceOrderAgentSpeed[keyof typeof VoiceOrderAgentSpeed];
export const VoiceOrderAgentTone = {
  Formal: 'Formal',
  Friendly: 'Friendly',
  Neutral: 'Neutral'
} as const;

export type VoiceOrderAgentTone = typeof VoiceOrderAgentTone[keyof typeof VoiceOrderAgentTone];
export const VoiceOrderAgentVerbosity = {
  Comprehensive: 'Comprehensive',
  Medium: 'Medium',
  Short: 'Short'
} as const;

export type VoiceOrderAgentVerbosity = typeof VoiceOrderAgentVerbosity[keyof typeof VoiceOrderAgentVerbosity];
/** Available voice identities for the voice order agent. */
export const VoiceOrderAgentVoiceId = {
  /** Friendly, engaging, relaxed */
  FriendlyRelaxed: 'FriendlyRelaxed',
  /** Professional, calm, grounded */
  ProfessionalCalm: 'ProfessionalCalm',
  /** Supports UK British accent */
  Voice3: 'Voice3'
} as const;

export type VoiceOrderAgentVoiceId = typeof VoiceOrderAgentVoiceId[keyof typeof VoiceOrderAgentVoiceId];
export type WebHomePageBannerInfoFullWidthContent = {
  __typename?: 'WebHomePageBannerInfoFullWidthContent';
  ctaBackgroundColor: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaLink: Scalars['String']['output'];
  horizontalBannerImageUrl: Scalars['String']['output'];
  squareBannerImageUrl: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type WebHomePageBannerInfoHalfWidthContent = {
  __typename?: 'WebHomePageBannerInfoHalfWidthContent';
  ctaBackgroundColor: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaLink: Scalars['String']['output'];
  horizontalBannerImageUrl: Scalars['String']['output'];
};

export type WebHomePageBannerShoppableFullWidthContent = {
  __typename?: 'WebHomePageBannerShoppableFullWidthContent';
  chat?: Maybe<Chat>;
  horizontalBannerImageUrl: Scalars['String']['output'];
  promoPageContent: PromoPageContent;
  squareBannerImageUrl: Scalars['String']['output'];
  supplier: Supplier;
  unitVariants: Array<SupplierVendorItemUnitVariant>;
};

export type WebHomePageBannerShoppableHalfWidthContent = {
  __typename?: 'WebHomePageBannerShoppableHalfWidthContent';
  chat?: Maybe<Chat>;
  promoPageContent: PromoPageContent;
  squareBannerImageUrl: Scalars['String']['output'];
  supplier: Supplier;
  unitVariants: Array<SupplierVendorItemUnitVariant>;
};

export type WebHomePagePopupInfoFullPageContent = {
  __typename?: 'WebHomePagePopupInfoFullPageContent';
  ctaBackgroundColor: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaLink: Scalars['String']['output'];
  fullPageImageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type WebPostOrderPopupInfoFullPageContent = {
  __typename?: 'WebPostOrderPopupInfoFullPageContent';
  ctaBackgroundColor: Scalars['String']['output'];
  ctaLabel: Scalars['String']['output'];
  ctaLink: Scalars['String']['output'];
  fullPageImageUrl: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type WebhookAuthenticationInput = {
  type: WebhookAuthenticationType | '%future added value';
};

export const WebhookAuthenticationType = {
  Basic: 'BASIC',
  Signature: 'SIGNATURE'
} as const;

export type WebhookAuthenticationType = typeof WebhookAuthenticationType[keyof typeof WebhookAuthenticationType];
export type WebshopCatalogSyncInput = {
  vendorId: Scalars['ID']['input'];
};

export type WebshopCatalogSyncResponse = AuthorizationFailure | InputValidationFailure | WebshopCatalogSyncResult;

export type WebshopCatalogSyncResult = AppsyncResponse & {
  __typename?: 'WebshopCatalogSyncResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** The state of the webshop catalog sync. */
  syncState: WebshopSyncState;
};

/** Product within a collection */
export type WebshopCollectionProduct = {
  __typename?: 'WebshopCollectionProduct';
  displayOrder: Scalars['Int']['output'];
  /** False if the product is not assigned to the webshop anymore, so the user can see a warning */
  isAssignedToWebshop: Scalars['Boolean']['output'];
  vendorItemUnit?: Maybe<VendorItemUnitRef>;
  vendorItemUnitId: Scalars['ID']['output'];
};

/**
 * Product to include in a collection.
 *
 * UI MAPPING:
 * - productId: Selected via checkbox in product table
 * - displayOrder: Order in which product appears (1, 2, 3, etc.), automatically assigned based on position in array
 */
export type WebshopCollectionProductInput = {
  /**
   * ID of the product (vendorItemUnitId from catalog).
   * User selects this by checking the checkbox in the product table.
   * displayOrder automatically assigned based on position in array (1, 2, 3, etc.)
   */
  vendorItemUnitId: Scalars['ID']['input'];
};

export type WebshopConfig = {
  __typename?: 'WebshopConfig';
  bundleId: Scalars['String']['output'];
  companyAddress?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  copyrightText?: Maybe<Scalars['String']['output']>;
  footerSections: Array<FooterSection>;
  isEnabled: Scalars['Boolean']['output'];
  socialLinks: Array<SocialLink>;
  vendorId: Scalars['ID']['output'];
};

export type WebshopConfigUpdateInput = {
  companyDetails?: InputMaybe<CompanyDetailsInput>;
  footerSections?: InputMaybe<Array<FooterSectionInput>>;
  socialLinks?: InputMaybe<Array<SocialLinkInput>>;
  vendorId: Scalars['ID']['input'];
};

export type WebshopConfigUpdateResponse = AuthorizationFailure | InputValidationFailure | VendorNotConfiguredForWebshopError | WebshopConfigUpdateResult;

export type WebshopConfigUpdateResult = AppsyncResponse & {
  __typename?: 'WebshopConfigUpdateResult';
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
  /** The updated webshop config. */
  webshopConfig: WebshopConfig;
};

export type WebshopMetadata = {
  __typename?: 'WebshopMetadata';
  companyAddress?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  copyrightText?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  nextAutomaticSync?: Maybe<Scalars['AWSDateTime']['output']>;
  syncState?: Maybe<WebshopSyncState>;
  totalItemsCount: Scalars['Int']['output'];
  vendorId: Scalars['ID']['output'];
  webshopUrl: Scalars['String']['output'];
};

/** Product collection displayed on webshop storefront */
export type WebshopProductCollection = {
  __typename?: 'WebshopProductCollection';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Products in this collection (max 15) */
  products?: Maybe<Array<WebshopCollectionProduct>>;
  /** Should be unique in the provided list (validated in Zod schema). */
  title: Scalars['String']['output'];
  vendorId: Scalars['ID']['output'];
};

/** Error during collection update operation */
export type WebshopProductCollectionUpdateError = {
  __typename?: 'WebshopProductCollectionUpdateError';
  /**
   * ID of the collection that caused the error.
   * null for create operations (new collections don't have IDs yet).
   */
  collectionId?: Maybe<Scalars['ID']['output']>;
  collectionTitle?: Maybe<Scalars['String']['output']>;
  /** Error code indicating the type of error */
  errorCode: WebshopProductCollectionUpdateErrorCode | '%future added value';
  /** Human-readable error message to display in the UI */
  errorMessage: Scalars['String']['output'];
  /** Product IDs that caused the error, only populated if the error is on the product-level */
  vendorItemUnitIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export const WebshopProductCollectionUpdateErrorCode = {
  /** Failed to save the collection due to internal server error */
  InternalServerError: 'INTERNAL_SERVER_ERROR',
  /** Product is not assigned to the web shop's custom catalogs */
  ProductNotAssignedToWebshop: 'PRODUCT_NOT_ASSIGNED_TO_WEBSHOP',
  /** Webshop is not configured for the provided vendorId */
  WebshopConfigNotFound: 'WEBSHOP_CONFIG_NOT_FOUND'
} as const;

export type WebshopProductCollectionUpdateErrorCode = typeof WebshopProductCollectionUpdateErrorCode[keyof typeof WebshopProductCollectionUpdateErrorCode];
/**
 * Single collection to create or update.
 *
 * UI MAPPING:
 * - id: null → Creating new collection (user clicked "+ ADD MORE")
 * - id: provided → Updating existing collection
 * - id: was existing before, but not provided in the list -> delete existing collection
 */
export type WebshopProductCollectionUpdateItem = {
  /**
   * To control the order of the collections.
   * Should be unique in the provided list (validated in Zod schema).
   */
  displayOrder: Scalars['Int']['input'];
  /**
   * ID of the collection to update.
   * - null: Creates new collection
   * - UUID: Updates existing collection with this ID
   * Should be unique in the provided list (validated in Zod schema).
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Whether the collection is active (visible on storefront).
   * Controlled by the toggle switch in the UI.
   */
  isActive: Scalars['Boolean']['input'];
  /**
   * Full list of products in the collection.
   * Maximum 15 products allowed per collection.
   * Display order is automatically assigned based on array position.
   *
   * IMPORTANT: This replaces ALL existing products in the collection.
   * - To add product: Include it in this array
   * - To remove product: Omit it from this array
   * - To reorder products: Change the product's position in the list
   * - Empty array = collection has no products
   *
   * UI shows "3 of 15 selected" based on this array length.
   */
  products: Array<WebshopCollectionProductInput>;
  /**
   * Collection title (max 50 characters).
   * Displayed in the collapsible header in the UI.
   * Should be unique in the provided list (validated in Zod schema).
   */
  title: Scalars['String']['input'];
};

/** Input for batch creating or updating product collections */
export type WebshopProductCollectionsBatchUpdateInput = {
  /**
   * Array of collections to create or update.
   * Maximum 50 collections can be updated at once.
   *
   * IMPORTANT: This is a declarative update. Send the complete desired state.
   * - Existing collections (with id): Will be updated with provided data
   * - New collections (id: null): Will be created
   * - Collections with existing IDs omitted from this array: Will be DELETED
   */
  collections: Array<WebshopProductCollectionUpdateItem>;
  /** ID of the vendor */
  vendorId: Scalars['ID']['input'];
};

export type WebshopProductCollectionsBatchUpdateResponse = AuthorizationFailure | InputValidationFailure | WebshopProductCollectionsBatchUpdateResult;

/** Successful batch update result */
export type WebshopProductCollectionsBatchUpdateResult = AppsyncResponse & {
  __typename?: 'WebshopProductCollectionsBatchUpdateResult';
  /**
   * Errors that occurred during the operation.
   * Allows partial success (some collections update, others fail).
   * UI should display these errors to the user.
   * null if no errors occurred.
   */
  errors?: Maybe<Array<WebshopProductCollectionUpdateError>>;
  /**
   * Collections that were successfully created or updated.
   * UI should refresh with these updated collections.
   */
  productCollections: Array<WebshopProductCollection>;
  responseType: ResponseType | '%future added value';
};

/** Input for querying product collections */
export type WebshopProductCollectionsInput = {
  /**
   * Filter by active status.
   * - null: Returns all collections (active and inactive)
   * - true: Returns only active collections
   * - false: Returns only inactive collections
   *
   * For admin UI, typically pass null to show all collections.
   */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the vendor */
  vendorId: Scalars['ID']['input'];
};

export type WebshopProductCollectionsResponse = AuthorizationFailure | InputValidationFailure | WebshopProductCollectionsResult;

/** Successful product collections query result */
export type WebshopProductCollectionsResult = AppsyncResponse & {
  __typename?: 'WebshopProductCollectionsResult';
  /**
   * List of product collections, ordered by display_order ascending.
   * Each collection includes its products array.
   * Returns empty array if no collections exist yet.
   */
  productCollections?: Maybe<Array<WebshopProductCollection>>;
  responseType: ResponseType | '%future added value';
};

export type WebshopSyncState = {
  __typename?: 'WebshopSyncState';
  isSyncInProgress: Scalars['Boolean']['output'];
  lastSyncCompletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastSyncErrorMessage?: Maybe<Scalars['String']['output']>;
  lastSyncSource?: Maybe<SyncSource | '%future added value'>;
  lastSyncStartedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastSyncStatus?: Maybe<SyncStatus | '%future added value'>;
};

/** Welcome banner configuration for a webshop storefront */
export type WebshopWelcomeBanner = {
  __typename?: 'WebshopWelcomeBanner';
  /** Call-to-action button label, null if no button is configured. */
  buttonLabel?: Maybe<Scalars['String']['output']>;
  /** ID of the product collection to link to. */
  buttonLinkedCollectionId?: Maybe<Scalars['ID']['output']>;
  /**
   * The user can link either a URL or a product collection.
   * One of buttonUrl or buttonLinkedCollectionId will be returned if the button is configured.
   */
  buttonUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: WebshopWelcomeBannerImage;
  /** Whether the banner is visible on the storefront. */
  isActive: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  vendorId: Scalars['ID']['output'];
};

export type WebshopWelcomeBannerImage = {
  __typename?: 'WebshopWelcomeBannerImage';
  imageId: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
};

export type WebshopWelcomeBannerImageUploadInput = {
  /**
   * Array of vendor IDs to generate upload URLs for.
   * Maximum 50 vendors can be processed at a time.
   */
  vendorIds: Array<Scalars['ID']['input']>;
};

export type WebshopWelcomeBannerImageUploadResponse = AuthorizationFailure | InputValidationFailure | WebshopWelcomeBannerImageUploadResult;

export type WebshopWelcomeBannerImageUploadResult = AppsyncResponse & {
  __typename?: 'WebshopWelcomeBannerImageUploadResult';
  images: Array<WebshopWelcomeBannerImageUploadResultItem>;
  /** Response type will always be set to `success` */
  responseType: ResponseType | '%future added value';
};

export type WebshopWelcomeBannerImageUploadResultItem = {
  __typename?: 'WebshopWelcomeBannerImageUploadResultItem';
  /**
   * ID of the image. Use this to associate the image with the vendor welcome banner
   * by calling the `WebshopWelcomeBannerUpdate` mutation after the image is uploaded.
   */
  imageId: Scalars['ID']['output'];
  /**
   * URL where the image file should be uploaded to.
   * To upload the file, make the `POST` request to this URL.
   * Use `Content-Type: multipart/form-data`. Provide body in the `FormData` format.
   * There should only be a single binary field named `file` in the form data content.
   *
   * @example
   * ```typescript
   * const formData = new FormData();
   * formData.append('file', file); // where `file` is a File object
   * const response = await fetch(uploadUrl, {
   *   method: 'POST',
   *   body: formData,
   * });
   * ```
   */
  uploadUrl: Scalars['String']['output'];
  /** ID of the vendor this image belongs to */
  vendorId: Scalars['ID']['output'];
};

export type WebshopWelcomeBannerInput = {
  /** ID of the vendor */
  vendorId: Scalars['ID']['input'];
};

export type WebshopWelcomeBannerResponse = AuthorizationFailure | InputValidationFailure | WebshopWelcomeBannerResult;

export type WebshopWelcomeBannerResult = AppsyncResponse & {
  __typename?: 'WebshopWelcomeBannerResult';
  responseType: ResponseType | '%future added value';
  /**
   * Welcome banner for the vendor.
   * Returns null if no banner has been created yet.
   * UI should show empty form if null.
   */
  welcomeBanner?: Maybe<WebshopWelcomeBanner>;
};

/** Input for creating or updating a welcome banner */
export type WebshopWelcomeBannerUpdateInput = {
  /**
   * Call-to-action button configuration.
   * If provided, both buttonLabel and buttonUrl must be included.
   * If omitted or null, no button will be displayed.
   */
  button?: InputMaybe<WebshopWelcomeBannerUpdateInputButton>;
  /** Banner description (max 120 characters) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID of the banner image, check webshopWelcomeBannerImageUpload mutation */
  imageId: Scalars['ID']['input'];
  /** Whether the banner is visible on the storefront */
  isActive: Scalars['Boolean']['input'];
  /** Banner title (max 60 characters) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** ID of the vendor */
  vendorId: Scalars['ID']['input'];
};

/**
 * The user can link either a URL or a product collection.
 * One of buttonUrl or buttonLinkedCollectionId must be provided.
 */
export type WebshopWelcomeBannerUpdateInputButton = {
  /**
   * Call-to-action button label (max 20 characters).
   * Required if buttonUrl is provided.
   * Both buttonLabel and buttonUrl must be provided together, or both must be null/omitted.
   */
  buttonLabel: Scalars['String']['input'];
  /** ID of the product collection to link to. */
  buttonLinkedCollectionId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The user can link either a URL or a product collection.
   * One of buttonUrl or buttonLinkedCollectionId must be provided.
   * Call-to-action button URL (max 500 characters).
   */
  buttonUrl?: InputMaybe<Scalars['String']['input']>;
};

export type WebshopWelcomeBannerUpdateResponse = AuthorizationFailure | InputValidationFailure | WebshopWelcomeBannerUpdateResult;

export type WebshopWelcomeBannerUpdateResult = AppsyncResponse & {
  __typename?: 'WebshopWelcomeBannerUpdateResult';
  responseType: ResponseType | '%future added value';
  welcomeBanner: WebshopWelcomeBanner;
};

export type WeekdayBasedCutoffSettings = {
  __typename?: 'WeekdayBasedCutoffSettings';
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  fri?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  mon?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  sat?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  sun?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  thu?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  tue?: Maybe<CutoffSetting>;
  /** CutoffSettings are nullable. If there is no setting for a specific day, it must not be regarded as a possible delivery date. */
  wed?: Maybe<CutoffSetting>;
};

export type WeekdayBasedCutoffSettingsInput = {
  fri?: InputMaybe<CutoffSettingInput>;
  mon?: InputMaybe<CutoffSettingInput>;
  sat?: InputMaybe<CutoffSettingInput>;
  sun?: InputMaybe<CutoffSettingInput>;
  thu?: InputMaybe<CutoffSettingInput>;
  tue?: InputMaybe<CutoffSettingInput>;
  wed?: InputMaybe<CutoffSettingInput>;
};

/** Returned when no welcome banner promotions are found for the buyer */
export type WelcomeBannerPromosNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'WelcomeBannerPromosNotFound';
  /** Optional message explaining why no promotions were found */
  message?: Maybe<Scalars['String']['output']>;
  /** Type of response returned */
  responseType: ResponseType | '%future added value';
};

export type WhatsAppMessage = {
  __typename?: 'WhatsAppMessage';
  accountSid: Scalars['String']['output'];
  apiVersion?: Maybe<Scalars['String']['output']>;
  body: Scalars['String']['output'];
  buttonText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSTimestamp']['output'];
  forwarded?: Maybe<Scalars['Boolean']['output']>;
  frequentlyForwarded?: Maybe<Scalars['Boolean']['output']>;
  from: Scalars['String']['output'];
  fromCity?: Maybe<Scalars['String']['output']>;
  fromCountry?: Maybe<Scalars['String']['output']>;
  fromState?: Maybe<Scalars['String']['output']>;
  fromZip?: Maybe<Scalars['String']['output']>;
  mediaElements?: Maybe<Array<WhatsAppMessageMedia>>;
  messageSid: Scalars['String']['output'];
  messagingServiceSid?: Maybe<Scalars['String']['output']>;
  numMedia: Scalars['Int']['output'];
  numSegments: Scalars['Int']['output'];
  originalRepliedMessageSender?: Maybe<Scalars['String']['output']>;
  originalRepliedMessageSid?: Maybe<Scalars['String']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  serviceApiVersion: Scalars['String']['output'];
  to: Scalars['String']['output'];
  toCity?: Maybe<Scalars['String']['output']>;
  toCountry?: Maybe<Scalars['String']['output']>;
  toState?: Maybe<Scalars['String']['output']>;
  toZip?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSTimestamp']['output'];
  whatsAppMessageId: Scalars['String']['output'];
  whatsAppStatus?: Maybe<Scalars['String']['output']>;
  whatsappId?: Maybe<Scalars['String']['output']>;
};

export type WhatsAppMessageMedia = {
  __typename?: 'WhatsAppMessageMedia';
  contentType: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
};

export type WholesailBuyerSessionMissingEmailFailure = {
  __typename?: 'WholesailBuyerSessionMissingEmailFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type WholesailBuyerSessionStartFailure = {
  __typename?: 'WholesailBuyerSessionStartFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type WholesailBuyerSessionStartInput = {
  buyerId: Scalars['ID']['input'];
  vendorId: Scalars['ID']['input'];
};

export type WholesailBuyerSessionStartResponse = AuthorizationFailure | InputValidationFailure | WholesailBuyerSessionMissingEmailFailure | WholesailBuyerSessionStartFailure | WholesailBuyerSessionStartSuccess;

export type WholesailBuyerSessionStartSuccess = {
  __typename?: 'WholesailBuyerSessionStartSuccess';
  embedUri: Scalars['String']['output'];
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type WholesailCustomer = {
  __typename?: 'WholesailCustomer';
  buyerId: Scalars['ID']['output'];
  vendorId: Scalars['ID']['output'];
};

export type WholesailCustomersFailure = {
  __typename?: 'WholesailCustomersFailure';
  message: Scalars['String']['output'];
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
};

export type WholesailCustomersResponse = AuthorizationFailure | WholesailCustomersFailure | WholesailCustomersSuccess;

export type WholesailCustomersSuccess = {
  __typename?: 'WholesailCustomersSuccess';
  customers: Array<WholesailCustomer>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
};

export type WholesailVendor = {
  __typename?: 'WholesailVendor';
  id: Scalars['ID']['output'];
  /** Choco supplier ID of the vendor */
  vendorId: Scalars['ID']['output'];
  /** Wholesail seller ID, from the vendor config */
  wholesailSellerId: Scalars['String']['output'];
};

export type WholesailVendorCreateInput = {
  /** Choco supplier ID of the vendor */
  vendorId: Scalars['ID']['input'];
  /** Wholesail seller ID, stored in the vendor config */
  wholesailSellerId: Scalars['String']['input'];
};

export type WholesailVendorCreateResponse = AuthorizationFailure | InputValidationFailure | WholesailVendorCreateSuccess;

export type WholesailVendorCreateSuccess = {
  __typename?: 'WholesailVendorCreateSuccess';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  vendor: WholesailVendor;
};

export type WithCutoffSetting = {
  __typename?: 'WithCutoffSetting';
  /** An extended ISO 8601 time string in the format hh:mm. Times are in supplier timezones. */
  cutoffTime: Scalars['AWSTime']['output'];
  /** in days */
  leadTime: Scalars['Int']['output'];
  type: WithCutoffType | '%future added value';
};

export const WithCutoffType = {
  Flexible: 'flexible',
  Strict: 'strict'
} as const;

export type WithCutoffType = typeof WithCutoffType[keyof typeof WithCutoffType];
export type Word = {
  __typename?: 'Word';
  start: StartOffSet;
  word: Scalars['String']['output'];
};

export type Workspace = {
  __typename?: 'Workspace';
  id: Scalars['ID']['output'];
  /** Names the workspace for the admin plane. Not translated and not unique. */
  name: Scalars['String']['output'];
  /** Every hierarchy root this workspace holds. A root belongs to exactly one workspace. */
  roots: Array<SupplierRef>;
};

export type WorkspaceCreateInput = {
  name: Scalars['String']['input'];
  /** The workspace's first hierarchy root. A workspace is never created rootless. */
  rootLocationId: Scalars['ID']['input'];
};

export type WorkspaceCreateResponse = AuthorizationFailure | InputValidationFailure | WorkspaceCreateResult | WorkspaceRootLocationAlreadyClaimed | WorkspaceRootLocationNotAHierarchyRoot | WorkspaceRootLocationNotFound;

export type WorkspaceCreateResult = AppsyncResponse & {
  __typename?: 'WorkspaceCreateResult';
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  workspace: Workspace;
};

export type WorkspaceListInput = {
  /** Resume token from a previous page. Omit for the first page. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Page size, counted in workspaces. At most 200. */
  limit: Scalars['Int']['input'];
};

export type WorkspaceListResponse = AuthorizationFailure | InputValidationFailure | WorkspaceListResult;

export type WorkspaceListResult = AppsyncResponse & {
  __typename?: 'WorkspaceListResult';
  /** Resume token for the next page. Null once the last workspace has been returned. */
  cursor?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Success */
  responseType: ResponseType | '%future added value';
  /** How many workspaces exist, across every page. */
  totalCount: ApproximateCount;
  workspaces: Array<Workspace>;
};

/**
 * The workspace does not exist, or the caller is not a member of it. The two are
 * deliberately indistinguishable, so the call never reveals a workspace outside
 * the caller's scope.
 */
export type WorkspaceNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'WorkspaceNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  workspaceId: Scalars['ID']['output'];
};

/**
 * Another workspace already holds this root. A root belongs to exactly one
 * workspace, so the caller must pick a different root rather than retry.
 */
export type WorkspaceRootLocationAlreadyClaimed = AppsyncError & AppsyncResponse & {
  __typename?: 'WorkspaceRootLocationAlreadyClaimed';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  rootLocation: SupplierRef;
};

/**
 * The location sits under another supplier, so it is not the top of anything. A
 * workspace covers a root and everything beneath it, so rooting one mid-tree
 * would leave the branch above it outside the workspace.
 */
export type WorkspaceRootLocationNotAHierarchyRoot = AppsyncError & AppsyncResponse & {
  __typename?: 'WorkspaceRootLocationNotAHierarchyRoot';
  /** The supplier that is the root of the slice this location sits in. */
  hierarchyRoot: SupplierRef;
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  rootLocation: SupplierRef;
};

/** The location does not resolve in the supplier hierarchy. */
export type WorkspaceRootLocationNotFound = AppsyncError & AppsyncResponse & {
  __typename?: 'WorkspaceRootLocationNotFound';
  message?: Maybe<Scalars['String']['output']>;
  /** Always ResponseType.Error */
  responseType: ResponseType | '%future added value';
  rootLocationId: Scalars['ID']['output'];
};

export type XlsxAttachmentRef = {
  __typename?: 'XlsxAttachmentRef';
  omnichannelOrderId: Scalars['ID']['output'];
  sheetName?: Maybe<Scalars['String']['output']>;
  transmissionAttachmentId?: Maybe<Scalars['ID']['output']>;
  transmissionId?: Maybe<Scalars['ID']['output']>;
};

export type AutopilotSubscriptionResponse = AuthorizationFailure | AutopilotOrderCreatedNotification | InternalServerError;

export type CreateSubCatalogResponse = CreateSubCatalogError | SubCatalog;

export type DeleteSubCatalogResponse = DeleteSubCatalogError | DeleteSubCatalogSuccess;

export type InviteNonChocoUserToBuyerResponse = BuyerNotFound | BuyerUser | ExistingInvitedUser | InvitorNotFound | PuppyValidationFailure;

export type OmnichannelOrderStatusSubscriptionResponse = AuthorizationFailure | BulkOrderRejectedNotification | InternalServerError | OmnichannelOrderCreatedNotification | OmnichannelOrderDraftUpdatedNotification | OrderAcceptedNotification | OrderConfirmedNotification | OrderRejectedNotification | TransmissionCreatedNotification | TransmissionReceivedNotification;

export type SupplierAssortments = {
  __typename?: 'supplierAssortments';
  assortments: Array<Scalars['String']['output']>;
};

export type TransmissionEventSubscriptionResponse = AuthorizationFailure | InternalServerError | TransmissionEventCreatedNotification;

export type TransmissionV2SubscriptionResponse = AuthorizationFailure | InternalServerError | TransmissionV2OrdersFullyProcessedNotification | TransmissionV2ProcessedNotification | TransmissionV2ReceivedNotification;

export type UpdateSubCatalogResponse = SubCatalog | UpdateSubCatalogError;

export type HeaderSupportCodeQueryVariables = Exact<{ [key: string]: never; }>;


export type HeaderSupportCodeQuery = { __typename?: 'Query', supportCodeGet: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'SupportCode', code: string, expiresAt: string } };

export type BuyerDetailsBaseFragmentFragment = { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, addressSource: AddressSource, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, latitude?: number | null, longitude?: number | null, country?: string | null, city?: string | null, utcOffset?: number | null, isTest?: boolean | null, isPuppy?: boolean | null, displayName?: string | null, addressComment?: string | null, profileImage?: { __typename?: 'ProfileImage', uploadUrl?: string | null, url?: string | null } | null };

export type BuyerDetailsFragmentFragment = { __typename?: 'Buyer', rolesEnabled?: boolean | null, status?: BuyerStatus | null, createdContext?: BuyerCreatedContext | null, id: string, name: string, referenceId?: string | null, fullAddress: string, addressSource: AddressSource, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, latitude?: number | null, longitude?: number | null, country?: string | null, city?: string | null, utcOffset?: number | null, isTest?: boolean | null, isPuppy?: boolean | null, displayName?: string | null, addressComment?: string | null, profileImage?: { __typename?: 'ProfileImage', uploadUrl?: string | null, url?: string | null } | null };

export type BuyerSearchFragmentFragment = { __typename?: 'Buyer', id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, city?: string | null, country?: string | null };

export type BuyerSearchItemFragmentFragment = { __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer', id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, city?: string | null, country?: string | null } | { __typename?: 'Chat' } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null };

export type BuyersPageBuyerFragmentFragment = { __typename?: 'Buyer', id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, deliveryComment?: string | null, city?: string | null, country?: string | null, isTest?: boolean | null, isPuppy?: boolean | null, rolesEnabled?: boolean | null, createdAt: number, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null };

export type BuyersPageBuyerDetailsFragmentFragment = { __typename?: 'Buyer', addressSource: AddressSource, createdContext?: BuyerCreatedContext | null, id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, deliveryComment?: string | null, city?: string | null, country?: string | null, isTest?: boolean | null, isPuppy?: boolean | null, rolesEnabled?: boolean | null, createdAt: number, addressLatitude?: number | null, addressLongitude?: number | null, addressUTCOffset?: number | null, addressGooglePlaceId?: string | null, addressGoogleAddressId?: string | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null };

export type UserRequestToJoinFragmentFragment = { __typename?: 'UserRequestToJoin', id: string, supplierEntityId?: string | null, status: JoinRequestStatus, user: { __typename?: 'User', name?: string | null, email?: string | null, phone: string, id: string } };

export type AddUserToChatsMutationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  chatIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddUserToChatsMutationMutation = { __typename?: 'Mutation', addUserToChats: boolean };

export type BuyerAddUserMutationMutationVariables = Exact<{
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  buyerUserInput?: InputMaybe<BuyerUserInput>;
}>;


export type BuyerAddUserMutationMutation = { __typename?: 'Mutation', buyerAddUser: { __typename?: 'BuyerUser', buyerId: string, userId: string, role?: string | null } };

export type BuyerDisableRolesMutationMutationVariables = Exact<{
  buyerId: Scalars['ID']['input'];
}>;


export type BuyerDisableRolesMutationMutation = { __typename?: 'Mutation', buyerDisableRoles: { __typename?: 'Buyer', id: string, rolesEnabled?: boolean | null } | { __typename?: 'NotFoundError', responseType: ResponseType, message?: string | null } };

export type BuyerRemoveUserMutationMutationVariables = Exact<{
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type BuyerRemoveUserMutationMutation = { __typename?: 'Mutation', buyerRemoveUser: { __typename?: 'BuyerUser', buyerId: string, userId: string, buyer?: { __typename?: 'Buyer', rolesEnabled?: boolean | null } | null } };

export type BuyersPageCreateBuyerMutationVariables = Exact<{
  buyerInput: BuyerCreateInput;
}>;


export type BuyersPageCreateBuyerMutation = { __typename?: 'Mutation', buyerCreate: { __typename?: 'Buyer', addressSource: AddressSource, createdContext?: BuyerCreatedContext | null, id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, deliveryComment?: string | null, city?: string | null, country?: string | null, isTest?: boolean | null, isPuppy?: boolean | null, rolesEnabled?: boolean | null, createdAt: number, addressLatitude?: number | null, addressLongitude?: number | null, addressUTCOffset?: number | null, addressGooglePlaceId?: string | null, addressGoogleAddressId?: string | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } };

export type BuyersPageUpdateBuyerMutationVariables = Exact<{
  buyerId: Scalars['ID']['input'];
  buyerInput: BuyerUpdateInput;
}>;


export type BuyersPageUpdateBuyerMutation = { __typename?: 'Mutation', buyerUpdate: { __typename?: 'Buyer', addressSource: AddressSource, createdContext?: BuyerCreatedContext | null, id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, deliveryComment?: string | null, city?: string | null, country?: string | null, isTest?: boolean | null, isPuppy?: boolean | null, rolesEnabled?: boolean | null, createdAt: number, addressLatitude?: number | null, addressLongitude?: number | null, addressUTCOffset?: number | null, addressGooglePlaceId?: string | null, addressGoogleAddressId?: string | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } };

export type CreateBuyerMutationMutationVariables = Exact<{
  buyerCreateInput: BuyerCreateInput;
}>;


export type CreateBuyerMutationMutation = { __typename?: 'Mutation', buyerCreate: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, addressSource: AddressSource, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, latitude?: number | null, longitude?: number | null, country?: string | null, city?: string | null, utcOffset?: number | null, isTest?: boolean | null, isPuppy?: boolean | null, displayName?: string | null, addressComment?: string | null, profileImage?: { __typename?: 'ProfileImage', uploadUrl?: string | null, url?: string | null } | null } };

export type CreateUserMutationMutationVariables = Exact<{
  userInput: UserCreateInput;
}>;


export type CreateUserMutationMutation = { __typename?: 'Mutation', userCreate?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, locale?: string | null, phone: string, isTest?: boolean | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, fax?: string | null, sms?: string | null, whatsApp?: string | null } | null } | null };

export type CreateUserFragmentFragment = { __typename?: 'User', id: string, name?: string | null, email?: string | null, locale?: string | null, phone: string, isTest?: boolean | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, fax?: string | null, sms?: string | null, whatsApp?: string | null } | null };

export type RemoveUserFromChatsMutationMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  chatIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveUserFromChatsMutationMutation = { __typename?: 'Mutation', removeUserFromChats: boolean };

export type EditBuyerMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  buyerUpdateInput: BuyerUpdateInput;
}>;


export type EditBuyerMutationMutation = { __typename?: 'Mutation', buyerUpdate: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, addressSource: AddressSource, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, latitude?: number | null, longitude?: number | null, country?: string | null, city?: string | null, utcOffset?: number | null, isTest?: boolean | null, isPuppy?: boolean | null, displayName?: string | null, addressComment?: string | null, profileImage?: { __typename?: 'ProfileImage', uploadUrl?: string | null, url?: string | null } | null } };

export type UpdateRequestToJoinMutationMutationVariables = Exact<{
  input: UpdateJoinRequestInput;
}>;


export type UpdateRequestToJoinMutationMutation = { __typename?: 'Mutation', updateRequestToJoin: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null } | { __typename?: 'UpdateJoinRequestError', message?: string | null } | { __typename: 'UpdateJoinRequestSuccess', id: string, status: JoinRequestAllowedUpdateStatus } };

export type UpdateJoinRequestSuccessFragmentFragment = { __typename: 'UpdateJoinRequestSuccess', id: string, status: JoinRequestAllowedUpdateStatus };

export type BuyersPageGetBuyerDetailsQueryVariables = Exact<{
  buyerId: Scalars['ID']['input'];
}>;


export type BuyersPageGetBuyerDetailsQuery = { __typename?: 'Query', buyer?: { __typename?: 'Buyer', addressSource: AddressSource, createdContext?: BuyerCreatedContext | null, id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, deliveryComment?: string | null, city?: string | null, country?: string | null, isTest?: boolean | null, isPuppy?: boolean | null, rolesEnabled?: boolean | null, createdAt: number, addressLatitude?: number | null, addressLongitude?: number | null, addressUTCOffset?: number | null, addressGooglePlaceId?: string | null, addressGoogleAddressId?: string | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } | null };

export type BuyersPageSearchBuyersQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type BuyersPageSearchBuyersQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', total: number, hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer', id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, deliveryComment?: string | null, city?: string | null, country?: string | null, isTest?: boolean | null, isPuppy?: boolean | null, rolesEnabled?: boolean | null, createdAt: number, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } | { __typename?: 'Chat' } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null }> } };

export type GetBuyerDetailsQueryQueryVariables = Exact<{
  buyerId: Scalars['ID']['input'];
}>;


export type GetBuyerDetailsQueryQuery = { __typename?: 'Query', buyer?: { __typename?: 'Buyer', rolesEnabled?: boolean | null, status?: BuyerStatus | null, createdContext?: BuyerCreatedContext | null, id: string, name: string, referenceId?: string | null, fullAddress: string, addressSource: AddressSource, googlePlaceId?: string | null, googlePlaceAddressId?: string | null, latitude?: number | null, longitude?: number | null, country?: string | null, city?: string | null, utcOffset?: number | null, isTest?: boolean | null, isPuppy?: boolean | null, displayName?: string | null, addressComment?: string | null, profileImage?: { __typename?: 'ProfileImage', uploadUrl?: string | null, url?: string | null } | null } | null };

export type GetBuyerEntityChatsQueryQueryVariables = Exact<{
  buyerEntityId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type GetBuyerEntityChatsQueryQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', total: number, hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer' } | { __typename?: 'Chat', id: string, chatName?: string | null, isUserInChat?: boolean | null, supplier?: { __typename?: 'User', id: string, name?: string | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } | null } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null }> } };

export type BuyerSearchChatItemFragmentFragment = { __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer' } | { __typename?: 'Chat', id: string, chatName?: string | null, isUserInChat?: boolean | null, supplier?: { __typename?: 'User', id: string, name?: string | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } | null } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null };

export type BuyerSearchChatFragmentFragment = { __typename?: 'Chat', id: string, chatName?: string | null, isUserInChat?: boolean | null, supplier?: { __typename?: 'User', id: string, name?: string | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } | null };

export type GetBuyerFacetsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBuyerFacetsQueryQuery = { __typename?: 'Query', buyerFacets?: Array<{ __typename?: 'BuyerFacetsResponse', country?: string | null, cities?: Array<{ __typename?: 'CityWithOffsets', city?: string | null, utcOffsets?: Array<number | null> | null }> | null }> | null };

export type BuyerFacetFragmentFragment = { __typename?: 'BuyerFacetsResponse', country?: string | null, cities?: Array<{ __typename?: 'CityWithOffsets', city?: string | null, utcOffsets?: Array<number | null> | null }> | null };

export type GetBuyerUsersQueryQueryVariables = Exact<{
  buyerId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetBuyerUsersQueryQuery = { __typename?: 'Query', buyer?: { __typename?: 'Buyer', id: string, rolesEnabled?: boolean | null, users?: { __typename?: 'BuyerUserConnection', edges: Array<{ __typename?: 'BuyerUserEdge', role?: string | null, node: { __typename?: 'User', id: string, name?: string | null, phone: string, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } }> } | null } | null };

export type BuyerUsersBuyerFragmentFragment = { __typename?: 'Buyer', id: string, rolesEnabled?: boolean | null, users?: { __typename?: 'BuyerUserConnection', edges: Array<{ __typename?: 'BuyerUserEdge', role?: string | null, node: { __typename?: 'User', id: string, name?: string | null, phone: string, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } }> } | null };

export type BuyerUserEdgeFragmentFragment = { __typename?: 'BuyerUserEdge', role?: string | null, node: { __typename?: 'User', id: string, name?: string | null, phone: string, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } };

export type BuyerUserFragmentFragment = { __typename?: 'User', id: string, name?: string | null, phone: string, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null };

export type GetRequestsToJoinQueryVariables = Exact<{
  buyerId: Scalars['String']['input'];
  statusFilter?: InputMaybe<JoinRequestStatus>;
}>;


export type GetRequestsToJoinQuery = { __typename?: 'Query', getRequestsToJoin: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null } | { __typename?: 'RequestsToJoinConnection', edges: Array<{ __typename?: 'UserRequestToJoinEdge', cursor: string, node: { __typename?: 'UserRequestToJoin', id: string, supplierEntityId?: string | null, status: JoinRequestStatus, user: { __typename?: 'User', name?: string | null, email?: string | null, phone: string, id: string } } }> } };

export type RequestsToJoinConnectionFragmentFragment = { __typename?: 'RequestsToJoinConnection', edges: Array<{ __typename?: 'UserRequestToJoinEdge', cursor: string, node: { __typename?: 'UserRequestToJoin', id: string, supplierEntityId?: string | null, status: JoinRequestStatus, user: { __typename?: 'User', name?: string | null, email?: string | null, phone: string, id: string } } }> };

export type RequestToJoinEdgeFragmentFragment = { __typename?: 'UserRequestToJoinEdge', cursor: string, node: { __typename?: 'UserRequestToJoin', id: string, supplierEntityId?: string | null, status: JoinRequestStatus, user: { __typename?: 'User', name?: string | null, email?: string | null, phone: string, id: string } } };

export type GetBuyersQueryQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type GetBuyersQueryQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', total: number, hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer', id: string, name: string, status?: BuyerStatus | null, referenceId?: string | null, displayName?: string | null, fullAddress: string, city?: string | null, country?: string | null } | { __typename?: 'Chat' } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null }> } };

export type UserSearchQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  query: UserSearchInput;
}>;


export type UserSearchQueryQuery = { __typename?: 'Query', userSearch: { __typename?: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'InputValidationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'UserSearchConnection', total: number, edges: Array<{ __typename?: 'UserSearchEdge', node: { __typename?: 'User', id: string, name?: string | null, phone: string, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string } | null } }> } };

export type UserSearchConnectionFragmentFragment = { __typename?: 'UserSearchConnection', total: number, edges: Array<{ __typename?: 'UserSearchEdge', node: { __typename?: 'User', id: string, name?: string | null, phone: string, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string } | null } }> };

export type UserSearchEdgeFragmentFragment = { __typename?: 'UserSearchEdge', node: { __typename?: 'User', id: string, name?: string | null, phone: string, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string } | null } };

export type UserSearchUserFragmentFragment = { __typename?: 'User', id: string, name?: string | null, phone: string, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string } | null };

export type UserSearchInputValidationFailureFragment = { __typename?: 'InputValidationFailure', message?: string | null, responseType: ResponseType };

export type UserSearchAuthorizationFailureFragment = { __typename?: 'AuthorizationFailure', message?: string | null, responseType: ResponseType };

export type ChatDetailsFragmentFragment = { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, customerNumber?: string | null, additionalEmails?: Array<string | null> | null, enabled: boolean, status: ChatStatus, type?: ChatType | null, supplier?: { __typename?: 'User', id: string, name?: string | null, locale?: string | null, phone: string, chocoUser?: boolean | null, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, customerNumberMandatory?: boolean | null, referenceId: string, name: string, hasEnabledCatalogProducts?: boolean | null, allowCustomProducts: boolean, accessPackage: AccessPackage, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null } | null };

export type ChatSupplierUserFragmentFragment = { __typename?: 'User', id: string, name?: string | null, locale?: string | null, phone: string, chocoUser?: boolean | null, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, customerNumberMandatory?: boolean | null, referenceId: string, name: string, hasEnabledCatalogProducts?: boolean | null, allowCustomProducts: boolean, accessPackage: AccessPackage, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null };

export type ChatUsersFragmentFragment = { __typename?: 'Chat', id: string, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null } };

export type ChatUserEdgeFragmentFragment = { __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } };

export type ChatUserFragmentFragment = { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null };

export type DeliverySettingFragmentFragment = { __typename?: 'SupplierDeliverySetting', id: string, cutoffType?: CutOffTimeType | null, cutoffTimes: { __typename?: 'WeekdayBasedCutoffSettings', mon?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, tue?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, wed?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, thu?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, fri?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sat?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sun?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null } };

export type HistoryUserFragmentFragment = { __typename?: 'User', name?: string | null, phone: string };

export type ChatIntegrationEmailOptionFragmentFragment = { __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null };

export type OrderPreferenceFragmentFragment = { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null };

export type ChatProductFragmentFragment = { __typename?: 'Product', id: string, unit?: string | null, name: string, par?: string | null, price?: string | null, externalId?: string | null, supplierId?: string | null, buyerInventoryProduct?: { __typename?: 'BuyerInventoryProduct', name?: string | null, price?: { __typename?: 'Money', currency?: string | null, amount?: number | null } | null } | null, supplierNegotiatedPrice?: { __typename?: 'SupplierNegotiatedPrice', price: { __typename?: 'Money', amount?: number | null, currency?: string | null } } | null };

export type SubCatalogsForChatFragmentFragment = { __typename?: 'GetSubCatalogsForChatResult', subCatalogs: Array<{ __typename?: 'SubCatalog', id: string, name: string }> };

export type SubCatalogForChatDataFragmentFragment = { __typename?: 'SubCatalog', id: string, name: string };

export type AddChatUsersDataMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  withAllUserFields?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddChatUsersDataMutationMutation = { __typename?: 'Mutation', chatInviteUsers: { __typename: 'Chat', id: string, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null } } };

export type UpdateChatOrderingSettingsMutationVariables = Exact<{
  input: ChatOrderingSettingsInput;
}>;


export type UpdateChatOrderingSettingsMutation = { __typename?: 'Mutation', updateChatOrderingSettings?: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'ChatOrderingSettings', isEcommercePoNumberEnabled: boolean, isEcommercePoNumberRequired: boolean } | { __typename: 'InputValidationFailure', message?: string | null } | null };

export type ChatPricesVisibilityUpdateMutationVariables = Exact<{
  input: ChatPricesVisibilityUpdateInput;
}>;


export type ChatPricesVisibilityUpdateMutation = { __typename?: 'Mutation', chatPricesVisibilityUpdate: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'ChatPricesVisibilitySuccess', displayPricesOverride?: boolean | null } | { __typename?: 'InputValidationFailure', message?: string | null } };

export type AddChatUsersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  withAllUserFields?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddChatUsersMutation = { __typename?: 'Mutation', chatInviteUsers: { __typename?: 'Chat', id: string, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null } } };

export type RemoveChatUsersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  withAllUserFields?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RemoveChatUsersMutation = { __typename?: 'Mutation', chatRemoveUsers: { __typename?: 'Chat', id: string, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null } } };

export type UpdateDeliverySettingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  cutoffTimes: WeekdayBasedCutoffSettingsInput;
}>;


export type UpdateDeliverySettingMutation = { __typename?: 'Mutation', updateSupplierDeliverySetting?: { __typename?: 'SupplierDeliverySetting', id: string } | null };

export type DeleteChatDeliverySettingMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;


export type DeleteChatDeliverySettingMutation = { __typename?: 'Mutation', deleteChatDeliverySetting?: { __typename?: 'DeletedChatSetting', id: string } | null };

export type RemoveCcEmailFromChatsDataMutationVariables = Exact<{
  email: Scalars['AWSEmail']['input'];
}>;


export type RemoveCcEmailFromChatsDataMutation = { __typename?: 'Mutation', removeCCEmailFromChats: { __typename?: 'RemoveCCEmailFromChatsReport', numberOfChatsUpdated: number } };

export type UpdateSubCatalogChatsMutationVariables = Exact<{
  create: Array<SubCatalogChatInput> | SubCatalogChatInput;
  remove: Array<SubCatalogChatInput> | SubCatalogChatInput;
}>;


export type UpdateSubCatalogChatsMutation = { __typename?: 'Mutation', updateSubCatalogChats: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'UpdateSubCatalogChatsResult', errors: Array<{ __typename?: 'InvalidSubCatalogChat', subCatalogId: string, reason?: string | null }> } };

export type UpdateSubCatalogChatsResultFragmentFragment = { __typename?: 'UpdateSubCatalogChatsResult', errors: Array<{ __typename?: 'InvalidSubCatalogChat', subCatalogId: string, reason?: string | null }> };

export type UpdateSupplierBuyerMovMutationVariables = Exact<{
  input: Array<UpdateSupplierBuyerMovInput> | UpdateSupplierBuyerMovInput;
}>;


export type UpdateSupplierBuyerMovMutation = { __typename?: 'Mutation', updateSupplierBuyerMov?: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'InputValidationFailure', message?: string | null } | { __typename: 'MinimumOrderValueFailure', message?: string | null } | { __typename: 'MinimumOrderValueUpdate', success: boolean } | null };

export type RemoveSupplierBuyerMovMutationVariables = Exact<{
  input: Array<RemoveSupplierBuyerMovInput> | RemoveSupplierBuyerMovInput;
}>;


export type RemoveSupplierBuyerMovMutation = { __typename?: 'Mutation', removeSupplierBuyerMov?: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'InputValidationFailure', message?: string | null } | { __typename: 'MinimumOrderValueFailure', message?: string | null } | { __typename: 'MinimumOrderValueUpdate', success: boolean } | null };

export type ChatUpdateDataMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  chat: ChatUpdateInput;
}>;


export type ChatUpdateDataMutationMutation = { __typename?: 'Mutation', chatUpdate: { __typename: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, customerNumber?: string | null, additionalEmails?: Array<string | null> | null, enabled: boolean, status: ChatStatus, type?: ChatType | null, supplier?: { __typename?: 'User', id: string, name?: string | null, locale?: string | null, phone: string, chocoUser?: boolean | null, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, customerNumberMandatory?: boolean | null, referenceId: string, name: string, hasEnabledCatalogProducts?: boolean | null, allowCustomProducts: boolean, accessPackage: AccessPackage, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null } | null } };

export type UpdateChatDataMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  chat: ChatUpdateInput;
}>;


export type UpdateChatDataMutation = { __typename?: 'Mutation', chatUpdate: { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, customerNumber?: string | null, additionalEmails?: Array<string | null> | null, enabled: boolean, status: ChatStatus, type?: ChatType | null, supplier?: { __typename?: 'User', id: string, name?: string | null, locale?: string | null, phone: string, chocoUser?: boolean | null, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, customerNumberMandatory?: boolean | null, referenceId: string, name: string, hasEnabledCatalogProducts?: boolean | null, allowCustomProducts: boolean, accessPackage: AccessPackage, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null } | null } };

export type UpdateChatBasicMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  chat: ChatUpdateInput;
}>;


export type UpdateChatBasicMutation = { __typename?: 'Mutation', chatUpdate: { __typename?: 'Chat', id: string } };

export type UpdateChatEnabledDataMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateChatEnabledDataMutationMutation = { __typename?: 'Mutation', updateChatEnabled: boolean };

export type UpdateChatNotificationPreferencesDataMutationMutationVariables = Exact<{
  input?: InputMaybe<ChatNotificationInput>;
}>;


export type UpdateChatNotificationPreferencesDataMutationMutation = { __typename?: 'Mutation', updateChatNotificationPreferences?: { __typename: 'ChatNotificationPreferences', id: string, newOrder?: { __typename: 'ChatNotificationUserLists', deselectedUsersList: Array<string> } | null } | null };

export type ChatsPageUpdateChatNotificationPreferencesV2MutationVariables = Exact<{
  input?: InputMaybe<ChatNotificationInput>;
}>;


export type ChatsPageUpdateChatNotificationPreferencesV2Mutation = { __typename?: 'Mutation', updateChatNotificationPreferencesV2?: { __typename: 'ChatNotificationPreferences', id: string, newOrder?: { __typename: 'ChatNotificationUserLists', deselectedUsersList: Array<string> } | null } | null };

export type ChatPricesVisibilityUpdateMutationMutationVariables = Exact<{
  input: ChatPricesVisibilityUpdateInput;
}>;


export type ChatPricesVisibilityUpdateMutationMutation = { __typename?: 'Mutation', chatPricesVisibilityUpdate: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'ChatPricesVisibilitySuccess', displayPricesOverride?: boolean | null } | { __typename?: 'InputValidationFailure', message?: string | null } };

export type UpdateChatSettingsDataMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  chat: ChatUpdateInput;
}>;


export type UpdateChatSettingsDataMutationMutation = { __typename?: 'Mutation', chatUpdate: { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, customerNumber?: string | null, additionalEmails?: Array<string | null> | null } };

export type UpdateDeliverySettingMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  cutoffTimes: WeekdayBasedCutoffSettingsInput;
}>;


export type UpdateDeliverySettingMutationMutation = { __typename?: 'Mutation', updateSupplierDeliverySetting?: { __typename: 'SupplierDeliverySetting', id: string } | null };

export type ChatHistoryDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ChatHistoryDataQuery = { __typename?: 'Query', messages: { __typename?: 'ChatMessageConnection', edges?: Array<{ __typename?: 'ChatMessageEdge', node: { __typename?: 'Message', id: string, body: string, createdAt: number, user: { __typename?: 'User', name?: string | null, phone: string }, attachment?: { __typename?: 'BroadcastAttachment' } | { __typename?: 'Event' } | { __typename?: 'Media', url?: string | null } | null, chat: { __typename?: 'Chat', supplier?: { __typename?: 'User', name?: string | null, phone: string } | null }, order?: { __typename?: 'Order', id: string, createdAt: number, body?: string | null, referenceId?: string | null, status?: OrderStatus | null, orderSupplierStatus?: string | null, supplier?: { __typename?: 'User', name?: string | null, phone: string } | null, user?: { __typename?: 'User', name?: string | null, phone: string } | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, unit?: string | null, name: string } } | null> | null } | null } }> | null } };

export type HistoryMessageFragmentFragment = { __typename?: 'Message', id: string, body: string, createdAt: number, user: { __typename?: 'User', name?: string | null, phone: string }, attachment?: { __typename?: 'BroadcastAttachment' } | { __typename?: 'Event' } | { __typename?: 'Media', url?: string | null } | null, chat: { __typename?: 'Chat', supplier?: { __typename?: 'User', name?: string | null, phone: string } | null }, order?: { __typename?: 'Order', id: string, createdAt: number, body?: string | null, referenceId?: string | null, status?: OrderStatus | null, orderSupplierStatus?: string | null, supplier?: { __typename?: 'User', name?: string | null, phone: string } | null, user?: { __typename?: 'User', name?: string | null, phone: string } | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, unit?: string | null, name: string } } | null> | null } | null };

export type HistoryOrderFragmentFragment = { __typename?: 'Order', id: string, createdAt: number, body?: string | null, referenceId?: string | null, status?: OrderStatus | null, orderSupplierStatus?: string | null, supplier?: { __typename?: 'User', name?: string | null, phone: string } | null, user?: { __typename?: 'User', name?: string | null, phone: string } | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, unit?: string | null, name: string } } | null> | null };

export type HistoryOrderProductFragmentFragment = { __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, unit?: string | null, name: string } };

export type HistoryProductFragmentFragment = { __typename?: 'Product', id: string, unit?: string | null, name: string };

export type ChatSearchDataQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  searchEntity?: InputMaybe<SearchEntityType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  withAllUserFields?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type ChatSearchDataQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', total: number, hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer' } | { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, enabled: boolean, type?: ChatType | null, customerNumber?: string | null, buyer?: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string } | null, supplier?: { __typename?: 'User', id: string, name?: string | null, phone: string, botUser?: boolean | null, linkedSupplier?: { __typename?: 'Supplier', id: string, referenceId: string, name: string } | null } | null, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null } } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null }> } };

export type ChatSearchEntityFragmentFragment = { __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer' } | { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, enabled: boolean, type?: ChatType | null, customerNumber?: string | null, buyer?: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string } | null, supplier?: { __typename?: 'User', id: string, name?: string | null, phone: string, botUser?: boolean | null, linkedSupplier?: { __typename?: 'Supplier', id: string, referenceId: string, name: string } | null } | null, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null } } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null };

export type ChatSearchChatFragmentFragment = { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, enabled: boolean, type?: ChatType | null, customerNumber?: string | null, buyer?: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string } | null, supplier?: { __typename?: 'User', id: string, name?: string | null, phone: string, botUser?: boolean | null, linkedSupplier?: { __typename?: 'Supplier', id: string, referenceId: string, name: string } | null } | null, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null } };

export type SearchBuyersForChatQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type SearchBuyersForChatQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, displayName?: string | null, city?: string | null, country?: string | null } | { __typename?: 'Chat' } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null }> } };

export type SearchSuppliersForChatQueryVariables = Exact<{
  keywords?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SupplierSearchFilter>;
}>;


export type SearchSuppliersForChatQuery = { __typename?: 'Query', supplierSearch: { __typename?: 'AuthorizationFailure' } | { __typename?: 'InputValidationFailure' } | { __typename?: 'SearchSupplierConnection', edges: Array<{ __typename?: 'SupplierSearchEdge', node: { __typename?: 'Supplier', id: string, referenceId: string, customerNumberMandatory?: boolean | null, allowEcommercePoNumber?: boolean | null, botUser?: { __typename?: 'User', id: string, name?: string | null, phone: string, supplier: boolean, botUser?: boolean | null, email?: string | null, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null } | null } }> } };

export type SearchUsersForChatQueryVariables = Exact<{
  search: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type SearchUsersForChatQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', total: number, hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer' } | { __typename?: 'Chat' } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User', id: string, name?: string | null, phone: string, supplier: boolean, botUser?: boolean | null, email?: string | null, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, customerNumberMandatory?: boolean | null, botUser?: { __typename?: 'User', id: string, name?: string | null, phone: string, supplier: boolean, botUser?: boolean | null, email?: string | null, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null } | null } | null } | null }> } };

export type GetBuyerUsersQueryVariables = Exact<{
  buyerEntityId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBuyerUsersQuery = { __typename?: 'Query', buyer?: { __typename?: 'Buyer', id: string, users?: { __typename?: 'BuyerUserConnection', edges: Array<{ __typename?: 'BuyerUserEdge', node: { __typename?: 'User', id: string, name?: string | null, phone: string, email?: string | null, supplier: boolean } }> } | null } | null };

export type GetSupplierUsersQueryVariables = Exact<{
  supplierEntityId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSupplierUsersQuery = { __typename?: 'Query', supplier?: { __typename?: 'Supplier', id: string, users?: { __typename?: 'SupplierUserConnection', edges?: Array<{ __typename?: 'SupplierUserEdge', cursor: string, node: { __typename?: 'User', id: string, name?: string | null, phone: string, email?: string | null, supplier: boolean, botUser?: boolean | null } }> | null } | null } | null };

export type CreateChatMutationVariables = Exact<{
  chat: ChatCreateInput;
}>;


export type CreateChatMutation = { __typename?: 'Mutation', chatCreate: { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, status: ChatStatus, enabled: boolean, activatedAt?: number | null, buyer?: { __typename?: 'Buyer', id: string, name: string } | null, supplierEntity?: { __typename?: 'Supplier', id: string, name: string } | null } };

export type ListSubCatalogsQueryVariables = Exact<{
  supplierEntityId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListSubCatalogsQuery = { __typename?: 'Query', listSubCatalogs?: { __typename?: 'SubCatalogConnection', edges: Array<{ __typename?: 'SubCatalogEdge', cursor: string, node: { __typename?: 'SubCatalog', id: string, name: string, supplierEntityId: string } }> } | { __typename?: 'ValidationError' } | null };

export type ChatsPageCustomerNumberUsageQueryVariables = Exact<{
  supplierId: Scalars['String']['input'];
  customerNumber: Scalars['String']['input'];
}>;


export type ChatsPageCustomerNumberUsageQuery = { __typename?: 'Query', searchCustomerChats: { __typename?: 'AuthorizationFailure' } | { __typename?: 'CustomerChatsConnection', edges: Array<{ __typename?: 'CustomerChatsEdge', node: { __typename?: 'Chat', id: string, customerNumber?: string | null, restaurantName?: string | null, chatName?: string | null } }> } | { __typename?: 'InputValidationFailure' } };

export type GetChatCountByCcEmailDataQueryVariables = Exact<{
  email: Scalars['AWSEmail']['input'];
}>;


export type GetChatCountByCcEmailDataQuery = { __typename?: 'Query', getChatCountByCCEmail: { __typename?: 'AuthorizationFailure' } | { __typename?: 'GetChatCountByCCEmailReport', numberOfChats: number } };

export type ChatCountByCcEmailReportFragmentFragment = { __typename?: 'GetChatCountByCCEmailReport', numberOfChats: number };

export type GetChatDataQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  withAllUserFields?: InputMaybe<Scalars['Boolean']['input']>;
  withProducts?: InputMaybe<Scalars['Boolean']['input']>;
  buyerId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetChatDataQuery = { __typename?: 'Query', chat?: { __typename?: 'Chat', subCatalogId?: string | null, isPuppy?: boolean | null, id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, customerNumber?: string | null, additionalEmails?: Array<string | null> | null, enabled: boolean, status: ChatStatus, type?: ChatType | null, createdBy?: { __typename?: 'CreatedBy', createdContext?: CreatedContext | null } | null, buyer?: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string } | null, supplierEntity?: { __typename?: 'Supplier', id: string, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }>, appliedMinimumOrderValue?: { __typename?: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'InputValidationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'MinimumOrderValue', type?: MinimumOrderValueType | null, formattedMinimumOrderValue?: string | null, minimumOrderValue?: { __typename?: 'MinOrder', price?: { __typename?: 'Money', amount?: number | null, currency?: string | null, decimalPlaces?: number | null } | null } | null } | { __typename?: 'MinimumOrderValueFailure', message?: string | null, responseType: ResponseType } | null } | null, supplier?: { __typename?: 'User', id: string, name?: string | null, locale?: string | null, phone: string, chocoUser?: boolean | null, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, customerNumberMandatory?: boolean | null, referenceId: string, name: string, hasEnabledCatalogProducts?: boolean | null, allowCustomProducts: boolean, accessPackage: AccessPackage, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null } | null, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null }, products?: Array<{ __typename?: 'Product', id: string, unit?: string | null, name: string, par?: string | null, price?: string | null, externalId?: string | null, supplierId?: string | null, buyerInventoryProduct?: { __typename?: 'BuyerInventoryProduct', name?: string | null, price?: { __typename?: 'Money', currency?: string | null, amount?: number | null } | null } | null, supplierNegotiatedPrice?: { __typename?: 'SupplierNegotiatedPrice', price: { __typename?: 'Money', amount?: number | null, currency?: string | null } } | null }> | null } | null, getSubCatalogsForChat: { __typename?: 'AuthorizationFailure' } | { __typename?: 'ChatNotFoundError' } | { __typename?: 'GetSubCatalogsForChatResult', subCatalogs: Array<{ __typename?: 'SubCatalog', id: string, name: string }> } };

export type ChatDataFragmentFragment = { __typename?: 'Chat', subCatalogId?: string | null, isPuppy?: boolean | null, id: string, chatName?: string | null, restaurantName?: string | null, deliveryAddress?: string | null, customerNumber?: string | null, additionalEmails?: Array<string | null> | null, enabled: boolean, status: ChatStatus, type?: ChatType | null, createdBy?: { __typename?: 'CreatedBy', createdContext?: CreatedContext | null } | null, buyer?: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string } | null, supplierEntity?: { __typename?: 'Supplier', id: string, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }>, appliedMinimumOrderValue?: { __typename?: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'InputValidationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'MinimumOrderValue', type?: MinimumOrderValueType | null, formattedMinimumOrderValue?: string | null, minimumOrderValue?: { __typename?: 'MinOrder', price?: { __typename?: 'Money', amount?: number | null, currency?: string | null, decimalPlaces?: number | null } | null } | null } | { __typename?: 'MinimumOrderValueFailure', message?: string | null, responseType: ResponseType } | null } | null, supplier?: { __typename?: 'User', id: string, name?: string | null, locale?: string | null, phone: string, chocoUser?: boolean | null, supplier: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, customerNumberMandatory?: boolean | null, referenceId: string, name: string, hasEnabledCatalogProducts?: boolean | null, allowCustomProducts: boolean, accessPackage: AccessPackage, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }> } | null } | null, users: { __typename?: 'ChatUserConnection', edges?: Array<{ __typename?: 'ChatUserEdge', node: { __typename?: 'User', email?: string | null, locale?: string | null, createdAt?: number | null, id: string, name?: string | null, phone: string, botUser?: boolean | null, supplier: boolean, orderPreference?: { __typename?: 'OrderPreference', whatsApp?: string | null, sms?: string | null, fax?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, hasEnabledCatalogProducts?: boolean | null } | null } }> | null }, products?: Array<{ __typename?: 'Product', id: string, unit?: string | null, name: string, par?: string | null, price?: string | null, externalId?: string | null, supplierId?: string | null, buyerInventoryProduct?: { __typename?: 'BuyerInventoryProduct', name?: string | null, price?: { __typename?: 'Money', currency?: string | null, amount?: number | null } | null } | null, supplierNegotiatedPrice?: { __typename?: 'SupplierNegotiatedPrice', price: { __typename?: 'Money', amount?: number | null, currency?: string | null } } | null }> | null };

export type CustomerDetailsChatSupplierFragment = { __typename?: 'Supplier', id: string, integration: Array<{ __typename?: 'IntegrationEmailOption', complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename?: 'IntegrationFaxOption' } | { __typename?: 'IntegrationSmsOption' } | { __typename?: 'IntegrationWhatsAppOption' }>, appliedMinimumOrderValue?: { __typename?: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'InputValidationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'MinimumOrderValue', type?: MinimumOrderValueType | null, formattedMinimumOrderValue?: string | null, minimumOrderValue?: { __typename?: 'MinOrder', price?: { __typename?: 'Money', amount?: number | null, currency?: string | null, decimalPlaces?: number | null } | null } | null } | { __typename?: 'MinimumOrderValueFailure', message?: string | null, responseType: ResponseType } | null };

export type CreatedContextFragmentFragment = { __typename?: 'CreatedBy', createdContext?: CreatedContext | null };

export type ChatProductsFragmentFragment = { __typename?: 'Chat', products?: Array<{ __typename?: 'Product', id: string, unit?: string | null, name: string, par?: string | null, price?: string | null, externalId?: string | null, supplierId?: string | null, buyerInventoryProduct?: { __typename?: 'BuyerInventoryProduct', name?: string | null, price?: { __typename?: 'Money', currency?: string | null, amount?: number | null } | null } | null, supplierNegotiatedPrice?: { __typename?: 'SupplierNegotiatedPrice', price: { __typename?: 'Money', amount?: number | null, currency?: string | null } } | null }> | null };

export type ChatNotificationPreferencesDataQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;


export type ChatNotificationPreferencesDataQuery = { __typename?: 'Query', chatNotificationPreferences?: { __typename: 'ChatNotificationPreferences', id: string, newOrder?: { __typename: 'ChatNotificationUserLists', deselectedUsersList: Array<string> } | null } | null };

export type ChatsPageGetChatNotificationPreferencesV2QueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;


export type ChatsPageGetChatNotificationPreferencesV2Query = { __typename?: 'Query', chatNotificationPreferencesV2?: { __typename: 'ChatNotificationPreferences', id: string, newOrder?: { __typename: 'ChatNotificationUserLists', deselectedUsersList: Array<string> } | null } | null };

export type ChatPricesVisibilityQueryQueryVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;


export type ChatPricesVisibilityQueryQuery = { __typename?: 'Query', chatPricesVisibility: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'ChatPricesVisibilitySuccess', displayPricesOverride?: boolean | null } | { __typename: 'InputValidationFailure', message?: string | null } };

export type ChatsPageGetSupplierBotUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ChatsPageGetSupplierBotUserQuery = { __typename?: 'Query', supplier?: { __typename?: 'Supplier', id: string, botUser?: { __typename?: 'User', id: string } | null } | null };

export type SupplierDeliverySettingQueryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupplierDeliverySettingQueryQuery = { __typename?: 'Query', supplierDeliverySetting?: { __typename: 'SupplierDeliverySetting', id: string, cutoffType?: CutOffTimeType | null, cutoffTimes: { __typename?: 'WeekdayBasedCutoffSettings', mon?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, tue?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, wed?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, thu?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, fri?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sat?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sun?: { __typename?: 'NoCutoffSetting' } | { __typename?: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null } } | null };

export type OrderGuideUploadPageOrderGuideBatchUpdateMutationVariables = Exact<{
  input: OrderGuideV2BatchUpdateInput;
}>;


export type OrderGuideUploadPageOrderGuideBatchUpdateMutation = { __typename?: 'Mutation', orderGuideV2BatchUpdate: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', responseType: ResponseType, message?: string | null, invalidFields?: Array<{ __typename?: 'FieldValidationError', fieldName: string, reason: string }> | null } | { __typename?: 'OrderGuideV2BatchUpdateResult', responseType: ResponseType, summary: { __typename?: 'OrderGuideV2BatchUpdateSummary', existingOrderGuideItems: number, newOrderGuideItems: number, updatedOrderGuideItems: number, removedOrderGuideItems: number, createdCustomVendorItems: number, errors: Array<{ __typename?: 'OrderGuideV2BatchUpdateInvalidInputItem', index: number, reason: string, errorCode: string, item: { __typename?: 'OrderGuideV2BatchUpdateInvalidInputItemParams', productCode?: string | null, unit: string, name?: string | null } }> } } };

export type OrderGuideUploadPageGetChatOrderGuidesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrderGuideUploadPageGetChatOrderGuidesQuery = { __typename?: 'Query', chat?: { __typename?: 'Chat', id: string, chatName?: string | null, restaurantName?: string | null, supplierEntity?: { __typename?: 'Supplier', id: string, name: string } | null, orderGuides?: Array<{ __typename?: 'OrderGuideV2Ref', id: string, node?: { __typename?: 'OrderGuideV2', id: string, name?: string | null, itemsCount?: number | null } | null }> | null } | null };

export type BlockedEmailNodeFragmentFragment = { __typename?: 'BlockedEmail', id: string, email: string, reason?: string | null, createdAt?: number | null };

export type BlockedEmailEdgeFragmentFragment = { __typename?: 'BlockedEmailEdge', cursor: string, node: { __typename?: 'BlockedEmail', id: string, email: string, reason?: string | null, createdAt?: number | null } };

export type BlockedEmailConnectionFragmentFragment = { __typename?: 'BlockedEmailConnection', edges?: Array<{ __typename?: 'BlockedEmailEdge', cursor: string, node: { __typename?: 'BlockedEmail', id: string, email: string, reason?: string | null, createdAt?: number | null } }> | null };

export type ProductFragmentFragment = { __typename?: 'Product', id: string, externalId?: string | null, unit?: string | null, name: string };

export type OrderProductFragmentFragment = { __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, externalId?: string | null, unit?: string | null, name: string } };

export type OrderDetailsBaseFragmentFragment = { __typename?: 'Order', id: string, referenceId?: string | null, createdAt: number, deliveryDate?: number | null, supplierRefId?: string | null, body?: string | null, isTest?: boolean | null, status?: OrderStatus | null, orderSupplierStatus?: string | null, createdContext?: OrderCreatedContext | null, user?: { __typename?: 'User', id: string, phone: string, name?: string | null } | null, buyer?: { __typename?: 'Buyer', name: string, displayName?: string | null, referenceId?: string | null, fullAddress: string } | null, restaurant?: { __typename?: 'OrderRestaurant', restaurantName?: string | null } | null, supplier?: { __typename?: 'User', phone: string, name?: string | null } | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, externalId?: string | null, unit?: string | null, name: string } } | null> | null };

export type OrderDetailsFragmentFragment = { __typename?: 'Order', pdf?: string | null, id: string, referenceId?: string | null, createdAt: number, deliveryDate?: number | null, supplierRefId?: string | null, body?: string | null, isTest?: boolean | null, status?: OrderStatus | null, orderSupplierStatus?: string | null, createdContext?: OrderCreatedContext | null, chat?: { __typename?: 'Chat', id: string, deliveryAddress?: string | null } | null, user?: { __typename?: 'User', id: string, phone: string, name?: string | null } | null, buyer?: { __typename?: 'Buyer', name: string, displayName?: string | null, referenceId?: string | null, fullAddress: string } | null, restaurant?: { __typename?: 'OrderRestaurant', restaurantName?: string | null } | null, supplier?: { __typename?: 'User', phone: string, name?: string | null } | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, externalId?: string | null, unit?: string | null, name: string } } | null> | null };

export type PageInfoFragmentFragment = { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string, endCursor: string };

export type OrderDetailsSearchFragmentFragment = { __typename?: 'Order', id: string, referenceId?: string | null, createdAt: number, deliveryDate?: number | null, supplierRefId?: string | null, body?: string | null, isTest?: boolean | null, status?: OrderStatus | null, orderSupplierStatus?: string | null, createdContext?: OrderCreatedContext | null, user?: { __typename?: 'User', id: string, phone: string, name?: string | null } | null, buyer?: { __typename?: 'Buyer', name: string, displayName?: string | null, referenceId?: string | null, fullAddress: string } | null, restaurant?: { __typename?: 'OrderRestaurant', restaurantName?: string | null } | null, supplier?: { __typename?: 'User', phone: string, name?: string | null } | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, externalId?: string | null, unit?: string | null, name: string } } | null> | null };

export type SearchOrderEdgeFragmentFragment = { __typename?: 'SearchOrderEdge', cursor: string, node: { __typename?: 'Order', id: string, referenceId?: string | null, createdAt: number, deliveryDate?: number | null, supplierRefId?: string | null, body?: string | null, isTest?: boolean | null, status?: OrderStatus | null, orderSupplierStatus?: string | null, createdContext?: OrderCreatedContext | null, user?: { __typename?: 'User', id: string, phone: string, name?: string | null } | null, buyer?: { __typename?: 'Buyer', name: string, displayName?: string | null, referenceId?: string | null, fullAddress: string } | null, restaurant?: { __typename?: 'OrderRestaurant', restaurantName?: string | null } | null, supplier?: { __typename?: 'User', phone: string, name?: string | null } | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, externalId?: string | null, unit?: string | null, name: string } } | null> | null } };

export type SearchOrderConnectionFragmentFragment = { __typename?: 'SearchOrderConnection', total: number, edges: Array<{ __typename?: 'SearchOrderEdge', cursor: string, node: { __typename?: 'Order', id: string, referenceId?: string | null, createdAt: number, deliveryDate?: number | null, supplierRefId?: string | null, body?: string | null, isTest?: boolean | null, status?: OrderStatus | null, orderSupplierStatus?: string | null, createdContext?: OrderCreatedContext | null, user?: { __typename?: 'User', id: string, phone: string, name?: string | null } | null, buyer?: { __typename?: 'Buyer', name: string, displayName?: string | null, referenceId?: string | null, fullAddress: string } | null, restaurant?: { __typename?: 'OrderRestaurant', restaurantName?: string | null } | null, supplier?: { __typename?: 'User', phone: string, name?: string | null } | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, externalId?: string | null, unit?: string | null, name: string } } | null> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string, endCursor: string } };

export type TransmissionEventsFragmentFragment = { __typename?: 'TransmissionEvent', id: string, ofId: string, ofIdType: TransmissionOfType, to: string, toType: TransmissionToType, newState: string, isDeliveryEvent?: boolean | null, isFailureEvent?: boolean | null, timestamp: string, metaData?: string | null };

export type BatchOrderConfirmMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BatchOrderConfirmMutation = { __typename?: 'Mutation', batchOrderConfirm?: { __typename: 'BatchOrderConfirmError', responseType: ResponseType, message?: string | null } | { __typename: 'BatchOrderConfirmSuccess', responseType: ResponseType } | null };

export type TestOrderResponseFragmentFragment = { __typename?: 'TestOrderResponse', message?: string | null };

export type InputValidationFailureFragmentFragment = { __typename?: 'InputValidationFailure', message?: string | null, responseType: ResponseType };

export type SetOrderAsTestMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type SetOrderAsTestMutation = { __typename?: 'Mutation', setOrderAsTest: { __typename?: 'InputValidationFailure', message?: string | null, responseType: ResponseType } | { __typename?: 'TestOrderResponse', message?: string | null } };

export type GetBlockedEmailsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBlockedEmailsQuery = { __typename?: 'Query', blockedEmails?: { __typename?: 'BlockedEmailConnection', edges?: Array<{ __typename?: 'BlockedEmailEdge', cursor: string, node: { __typename?: 'BlockedEmail', id: string, email: string, reason?: string | null, createdAt?: number | null } }> | null } | null };

export type GetOrderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', pdf?: string | null, id: string, referenceId?: string | null, createdAt: number, deliveryDate?: number | null, supplierRefId?: string | null, body?: string | null, isTest?: boolean | null, status?: OrderStatus | null, orderSupplierStatus?: string | null, createdContext?: OrderCreatedContext | null, chat?: { __typename?: 'Chat', id: string, deliveryAddress?: string | null } | null, user?: { __typename?: 'User', id: string, phone: string, name?: string | null } | null, buyer?: { __typename?: 'Buyer', name: string, displayName?: string | null, referenceId?: string | null, fullAddress: string } | null, restaurant?: { __typename?: 'OrderRestaurant', restaurantName?: string | null } | null, supplier?: { __typename?: 'User', phone: string, name?: string | null } | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, externalId?: string | null, unit?: string | null, name: string } } | null> | null } | null };

export type GetOrdersQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  query: SearchOrderInput;
}>;


export type GetOrdersQuery = { __typename?: 'Query', searchOrder: { __typename?: 'AuthorizationFailure' } | { __typename?: 'InputValidationFailure', message?: string | null } | { __typename?: 'InternalServerError' } | { __typename?: 'SearchOrderConnection', total: number, edges: Array<{ __typename?: 'SearchOrderEdge', cursor: string, node: { __typename?: 'Order', id: string, referenceId?: string | null, createdAt: number, deliveryDate?: number | null, supplierRefId?: string | null, body?: string | null, isTest?: boolean | null, status?: OrderStatus | null, orderSupplierStatus?: string | null, createdContext?: OrderCreatedContext | null, user?: { __typename?: 'User', id: string, phone: string, name?: string | null } | null, buyer?: { __typename?: 'Buyer', name: string, displayName?: string | null, referenceId?: string | null, fullAddress: string } | null, restaurant?: { __typename?: 'OrderRestaurant', restaurantName?: string | null } | null, supplier?: { __typename?: 'User', phone: string, name?: string | null } | null, orderProducts?: Array<{ __typename?: 'OrderProduct', amount: number, product: { __typename?: 'Product', id: string, externalId?: string | null, unit?: string | null, name: string } } | null> | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string, endCursor: string } } };

export type GetTransmissionEventsQueryVariables = Exact<{
  ofId: Scalars['ID']['input'];
}>;


export type GetTransmissionEventsQuery = { __typename?: 'Query', transmissionEvents: Array<{ __typename?: 'TransmissionEvent', id: string, ofId: string, ofIdType: TransmissionOfType, to: string, toType: TransmissionToType, newState: string, isDeliveryEvent?: boolean | null, isFailureEvent?: boolean | null, timestamp: string, metaData?: string | null }> };

export type SsoPageEmailDomainFragmentFragment = { __typename?: 'SsoEmailDomain', connectionId: string, emailDomain: string, exclusiveFederatedLogin: boolean, createdAt?: string | null, updatedAt?: string | null };

export type SsoPageConnectionFragmentFragment = { __typename?: 'SsoConnection', id: string, name: string, type: SsoConnectionType, emailDomains: Array<string>, signOutEnabled: boolean, createdAt?: string | null, updatedAt?: string | null, emailDomainDetails: Array<{ __typename?: 'SsoEmailDomain', connectionId: string, emailDomain: string, exclusiveFederatedLogin: boolean, createdAt?: string | null, updatedAt?: string | null }>, attributeMappings: Array<{ __typename?: 'SsoAttributeMapping', cognitoAttribute: string, idpAttribute: string }> };

export type SsoPageConnectionUserFragmentFragment = { __typename?: 'SsoConnectionUser', id: string, chocoUserId?: string | null, email?: string | null, status: SsoConnectionUserStatus, enabled: boolean, federatedRoles: Array<string>, createdAt?: string | null, lastModifiedAt?: string | null, mappedFederatedRoles: Array<{ __typename?: 'SsoConnectionUserRole', federatedRole: string, mapping?: { __typename?: 'SsoRoleMapping', chocoSupplierRole: Role, supplier: { __typename?: 'SupplierRef', id: string } } | null }>, mappedAttributes: Array<{ __typename?: 'SsoConnectionUserAttribute', idpAttribute: string, cognitoAttribute: string, value?: string | null }> };

export type SsoPageRoleMappingFragmentFragment = { __typename?: 'SsoRoleMapping', connectionId: string, federatedRole: string, chocoSupplierRole: Role, createdAt?: string | null, updatedAt?: string | null, supplier: { __typename?: 'SupplierRef', id: string, node?: { __typename?: 'Supplier', id: string, name: string, referenceId: string } | null } };

export type SsoPageInvalidFieldsFragmentFragment = { __typename?: 'InputValidationFailure', message?: string | null, invalidFields?: Array<{ __typename?: 'FieldValidationError', fieldName: string, reason: string }> | null };

export type SsoPageEmailDomainExclusivitySetMutationVariables = Exact<{
  input: SsoEmailDomainExclusivitySetInput;
}>;


export type SsoPageEmailDomainExclusivitySetMutation = { __typename?: 'Mutation', ssoEmailDomainExclusivitySet: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null, invalidFields?: Array<{ __typename?: 'FieldValidationError', fieldName: string, reason: string }> | null } | { __typename?: 'NotFoundError', message?: string | null } | { __typename?: 'SsoEmailDomain', connectionId: string, emailDomain: string, exclusiveFederatedLogin: boolean, createdAt?: string | null, updatedAt?: string | null } };

export type SsoPageRoleMappingCreateMutationVariables = Exact<{
  input: SsoRoleMappingCreateInput;
}>;


export type SsoPageRoleMappingCreateMutation = { __typename?: 'Mutation', ssoRoleMappingCreate: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null, invalidFields?: Array<{ __typename?: 'FieldValidationError', fieldName: string, reason: string }> | null } | { __typename?: 'NotFoundError', message?: string | null } | { __typename?: 'SsoRoleMapping', connectionId: string, federatedRole: string, chocoSupplierRole: Role, createdAt?: string | null, updatedAt?: string | null, supplier: { __typename?: 'SupplierRef', id: string, node?: { __typename?: 'Supplier', id: string, name: string, referenceId: string } | null } } | { __typename?: 'SsoRoleMappingAlreadyExists', message?: string | null } };

export type SsoPageRoleMappingDeleteMutationVariables = Exact<{
  input: SsoRoleMappingDeleteInput;
}>;


export type SsoPageRoleMappingDeleteMutation = { __typename?: 'Mutation', ssoRoleMappingDelete: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null, invalidFields?: Array<{ __typename?: 'FieldValidationError', fieldName: string, reason: string }> | null } | { __typename?: 'NotFoundError', message?: string | null } | { __typename?: 'SsoRoleMappingDeleteSuccess', responseType: ResponseType } };

export type SsoPageChocoUserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type SsoPageChocoUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name?: string | null, phone: string, locale?: string | null, loginMethod?: LoginMethod | null, createdAt?: number | null, pending?: boolean | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', node: { __typename?: 'Buyer', id: string } }> } | null } | null };

export type SsoPageConnectionUsersQueryVariables = Exact<{
  input: SsoConnectionUsersInput;
}>;


export type SsoPageConnectionUsersQuery = { __typename?: 'Query', ssoConnectionUsers: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'NotFoundError', message?: string | null } | { __typename?: 'SsoConnectionTooLarge', limit: number, message?: string | null } | { __typename?: 'SsoConnectionUserList', connectionId: string, users: Array<{ __typename?: 'SsoConnectionUser', id: string, chocoUserId?: string | null, email?: string | null, status: SsoConnectionUserStatus, enabled: boolean, federatedRoles: Array<string>, createdAt?: string | null, lastModifiedAt?: string | null, mappedFederatedRoles: Array<{ __typename?: 'SsoConnectionUserRole', federatedRole: string, mapping?: { __typename?: 'SsoRoleMapping', chocoSupplierRole: Role, supplier: { __typename?: 'SupplierRef', id: string } } | null }>, mappedAttributes: Array<{ __typename?: 'SsoConnectionUserAttribute', idpAttribute: string, cognitoAttribute: string, value?: string | null }> }> } };

export type SsoPageConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SsoPageConnectionsQuery = { __typename?: 'Query', ssoConnections: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'SsoConnectionList', connections: Array<{ __typename?: 'SsoConnection', id: string, name: string, type: SsoConnectionType, emailDomains: Array<string>, signOutEnabled: boolean, createdAt?: string | null, updatedAt?: string | null, emailDomainDetails: Array<{ __typename?: 'SsoEmailDomain', connectionId: string, emailDomain: string, exclusiveFederatedLogin: boolean, createdAt?: string | null, updatedAt?: string | null }>, attributeMappings: Array<{ __typename?: 'SsoAttributeMapping', cognitoAttribute: string, idpAttribute: string }> }> } };

export type SsoPageEmailDomainsQueryVariables = Exact<{
  input: SsoEmailDomainsInput;
}>;


export type SsoPageEmailDomainsQuery = { __typename?: 'Query', ssoEmailDomains: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'NotFoundError', message?: string | null } | { __typename?: 'SsoEmailDomainList', emailDomains: Array<{ __typename?: 'SsoEmailDomain', connectionId: string, emailDomain: string, exclusiveFederatedLogin: boolean, createdAt?: string | null, updatedAt?: string | null }> } };

export type SsoPageRoleMappingsQueryVariables = Exact<{
  input: SsoRoleMappingsInput;
}>;


export type SsoPageRoleMappingsQuery = { __typename?: 'Query', ssoRoleMappings: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'NotFoundError', message?: string | null } | { __typename?: 'SsoRoleMappingList', roleMappings: Array<{ __typename?: 'SsoRoleMapping', connectionId: string, federatedRole: string, chocoSupplierRole: Role, createdAt?: string | null, updatedAt?: string | null, supplier: { __typename?: 'SupplierRef', id: string, node?: { __typename?: 'Supplier', id: string, name: string, referenceId: string } | null } }> } };

export type SsoPageSearchSuppliersQueryVariables = Exact<{
  keywords?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SupplierSearchFilter>;
}>;


export type SsoPageSearchSuppliersQuery = { __typename?: 'Query', supplierSearch: { __typename?: 'AuthorizationFailure' } | { __typename?: 'InputValidationFailure' } | { __typename?: 'SearchSupplierConnection', edges: Array<{ __typename?: 'SupplierSearchEdge', node: { __typename?: 'Supplier', id: string, name: string, referenceId: string } }> } };

export type SuppliersPageVendorCatalogUnitFragment = { __typename?: 'VendorItemUnit', id: string, name: string, itemNameOverride?: string | null, productCode?: string | null, isOrdering: boolean, stockStatus: VendorItemUnitStockStatus, vendorItem: { __typename?: 'VendorItemRef', node?: { __typename?: 'VendorItem', name: string } | null }, images: Array<{ __typename?: 'VendorItemUnitImage', id: string, asset: { __typename?: 'ImageAsset', url?: { __typename?: 'ImageAssetUrl', url: string } | null } }>, price?: { __typename?: 'VendorItemUnitPriceSet', displayCatalogPrice?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null, displayPrice: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | null };

type SuppliersPageVendorCatalogResponse_AuthorizationFailure_Fragment = { __typename: 'AuthorizationFailure', message?: string | null };

type SuppliersPageVendorCatalogResponse_InputValidationFailure_Fragment = { __typename: 'InputValidationFailure', message?: string | null };

type SuppliersPageVendorCatalogResponse_VendorItemsForVendorResult_Fragment = { __typename: 'VendorItemsForVendorResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename?: 'VendorItemsForVendorResultEdge', cursor: string, node: { __typename?: 'VendorItemUnit', id: string, name: string, itemNameOverride?: string | null, productCode?: string | null, isOrdering: boolean, stockStatus: VendorItemUnitStockStatus, vendorItem: { __typename?: 'VendorItemRef', node?: { __typename?: 'VendorItem', name: string } | null }, images: Array<{ __typename?: 'VendorItemUnitImage', id: string, asset: { __typename?: 'ImageAsset', url?: { __typename?: 'ImageAssetUrl', url: string } | null } }>, price?: { __typename?: 'VendorItemUnitPriceSet', displayCatalogPrice?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null, displayPrice: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | null } }> };

export type SuppliersPageVendorCatalogResponseFragment = SuppliersPageVendorCatalogResponse_AuthorizationFailure_Fragment | SuppliersPageVendorCatalogResponse_InputValidationFailure_Fragment | SuppliersPageVendorCatalogResponse_VendorItemsForVendorResult_Fragment;

export type SuppliersPageVendorCatalogUnitDetailFragment = { __typename?: 'VendorItemUnit', id: string, name: string, itemNameOverride?: string | null, itemDescriptionOverride?: string | null, productCode?: string | null, code: string, legacyId?: string | null, packagingDescription: string, stockStatus: VendorItemUnitStockStatus, isOrdering: boolean, isHiddenByDefault?: boolean | null, vendorItem: { __typename?: 'VendorItemRef', node?: { __typename?: 'VendorItem', name: string, description: string, brand?: string | null, originCountryCode?: string | null, categories: Array<{ __typename?: 'VendorItemCategory', id: string, name: string }> } | null }, baseUnit?: { __typename?: 'VendorItemUnit', id: string, name: string } | null, factor: { __typename?: 'Rational', numerator: number, denominator: number }, images: Array<{ __typename?: 'VendorItemUnitImage', id: string, asset: { __typename?: 'ImageAsset', url?: { __typename?: 'ImageAssetUrl', url: string } | null } }>, price?: { __typename?: 'VendorItemUnitPriceSet', displayCatalogPrice?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null, displayBasePrice?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null, displayPrice: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | null, orderingProperties?: { __typename?: 'VendorItemUnitOrderingProperties', leadTimeDays?: number | null, cutOffTime?: string | null } | null };

type SuppliersPageVendorCatalogUnitDetailResponse_AuthorizationFailure_Fragment = { __typename: 'AuthorizationFailure', message?: string | null };

type SuppliersPageVendorCatalogUnitDetailResponse_InputValidationFailure_Fragment = { __typename: 'InputValidationFailure', message?: string | null };

type SuppliersPageVendorCatalogUnitDetailResponse_VendorItemUnitsResult_Fragment = { __typename: 'VendorItemUnitsResult', itemUnits: Array<{ __typename?: 'VendorItemUnit', id: string, name: string, itemNameOverride?: string | null, itemDescriptionOverride?: string | null, productCode?: string | null, code: string, legacyId?: string | null, packagingDescription: string, stockStatus: VendorItemUnitStockStatus, isOrdering: boolean, isHiddenByDefault?: boolean | null, vendorItem: { __typename?: 'VendorItemRef', node?: { __typename?: 'VendorItem', name: string, description: string, brand?: string | null, originCountryCode?: string | null, categories: Array<{ __typename?: 'VendorItemCategory', id: string, name: string }> } | null }, baseUnit?: { __typename?: 'VendorItemUnit', id: string, name: string } | null, factor: { __typename?: 'Rational', numerator: number, denominator: number }, images: Array<{ __typename?: 'VendorItemUnitImage', id: string, asset: { __typename?: 'ImageAsset', url?: { __typename?: 'ImageAssetUrl', url: string } | null } }>, price?: { __typename?: 'VendorItemUnitPriceSet', displayCatalogPrice?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null, displayBasePrice?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null, displayPrice: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | null, orderingProperties?: { __typename?: 'VendorItemUnitOrderingProperties', leadTimeDays?: number | null, cutOffTime?: string | null } | null }> };

export type SuppliersPageVendorCatalogUnitDetailResponseFragment = SuppliersPageVendorCatalogUnitDetailResponse_AuthorizationFailure_Fragment | SuppliersPageVendorCatalogUnitDetailResponse_InputValidationFailure_Fragment | SuppliersPageVendorCatalogUnitDetailResponse_VendorItemUnitsResult_Fragment;

export type SuppliersPageCustomCatalogsForVendorQueryVariables = Exact<{
  input: CustomCatalogsForVendorInput;
}>;


export type SuppliersPageCustomCatalogsForVendorQuery = { __typename?: 'Query', customCatalogsForVendor: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'CustomCatalogsForVendorResult', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename?: 'CustomCatalogsForVendorResultEdge', node: { __typename?: 'CustomCatalog', id: string, name: string } }> } | { __typename?: 'InputValidationFailure', message?: string | null } };

export type SuppliersPageCustomCatalogsQueryVariables = Exact<{
  input: CustomCatalogsInput;
}>;


export type SuppliersPageCustomCatalogsQuery = { __typename?: 'Query', customCatalogs: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'CustomCatalogsResult', customCatalogs: Array<{ __typename?: 'CustomCatalog', id: string, name: string }> } | { __typename?: 'InputValidationFailure', message?: string | null } };

export type SuppliersPageVendorItemUnitDetailQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SuppliersPageVendorItemUnitDetailQuery = { __typename?: 'Query', vendorItemUnits: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'InputValidationFailure', message?: string | null } | { __typename: 'VendorItemUnitsResult', itemUnits: Array<{ __typename?: 'VendorItemUnit', id: string, name: string, itemNameOverride?: string | null, itemDescriptionOverride?: string | null, productCode?: string | null, code: string, legacyId?: string | null, packagingDescription: string, stockStatus: VendorItemUnitStockStatus, isOrdering: boolean, isHiddenByDefault?: boolean | null, vendorItem: { __typename?: 'VendorItemRef', node?: { __typename?: 'VendorItem', name: string, description: string, brand?: string | null, originCountryCode?: string | null, categories: Array<{ __typename?: 'VendorItemCategory', id: string, name: string }> } | null }, baseUnit?: { __typename?: 'VendorItemUnit', id: string, name: string } | null, factor: { __typename?: 'Rational', numerator: number, denominator: number }, images: Array<{ __typename?: 'VendorItemUnitImage', id: string, asset: { __typename?: 'ImageAsset', url?: { __typename?: 'ImageAssetUrl', url: string } | null } }>, price?: { __typename?: 'VendorItemUnitPriceSet', displayCatalogPrice?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null, displayBasePrice?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null, displayPrice: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | null, orderingProperties?: { __typename?: 'VendorItemUnitOrderingProperties', leadTimeDays?: number | null, cutOffTime?: string | null } | null }> } };

export type SuppliersPageVendorItemUnitsForVendorSearchQueryVariables = Exact<{
  input: VendorItemUnitsForVendorSearchInput;
}>;


export type SuppliersPageVendorItemUnitsForVendorSearchQuery = { __typename?: 'Query', vendorItemUnitsForVendorSearch: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'InputValidationFailure', message?: string | null } | { __typename: 'VendorItemsForVendorResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename?: 'VendorItemsForVendorResultEdge', cursor: string, node: { __typename?: 'VendorItemUnit', id: string, name: string, itemNameOverride?: string | null, productCode?: string | null, isOrdering: boolean, stockStatus: VendorItemUnitStockStatus, vendorItem: { __typename?: 'VendorItemRef', node?: { __typename?: 'VendorItem', name: string } | null }, images: Array<{ __typename?: 'VendorItemUnitImage', id: string, asset: { __typename?: 'ImageAsset', url?: { __typename?: 'ImageAssetUrl', url: string } | null } }>, price?: { __typename?: 'VendorItemUnitPriceSet', displayCatalogPrice?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null, displayPrice: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | null } }> } };

export type SuppliersPageVendorItemsForVendorQueryVariables = Exact<{
  input: VendorItemsForVendorInput;
}>;


export type SuppliersPageVendorItemsForVendorQuery = { __typename?: 'Query', vendorItemsForVendor: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'InputValidationFailure', message?: string | null } | { __typename: 'VendorItemsForVendorResult', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename?: 'VendorItemsForVendorResultEdge', cursor: string, node: { __typename?: 'VendorItemUnit', id: string, name: string, itemNameOverride?: string | null, productCode?: string | null, isOrdering: boolean, stockStatus: VendorItemUnitStockStatus, vendorItem: { __typename?: 'VendorItemRef', node?: { __typename?: 'VendorItem', name: string } | null }, images: Array<{ __typename?: 'VendorItemUnitImage', id: string, asset: { __typename?: 'ImageAsset', url?: { __typename?: 'ImageAssetUrl', url: string } | null } }>, price?: { __typename?: 'VendorItemUnitPriceSet', displayCatalogPrice?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null, displayPrice: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | null } }> } };

export type SuppliersPageOrderAgentSettingUpdateMutationVariables = Exact<{
  input: SupplierSettingInput;
}>;


export type SuppliersPageOrderAgentSettingUpdateMutation = { __typename?: 'Mutation', supplierSetting: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'InputValidationFailure', message?: string | null } | { __typename: 'InternalServerError' } | { __typename: 'NotFoundError', message?: string | null } | { __typename: 'SupplierSetting', supplierId: string, isOrderAgentEnabled: boolean } };

export type SuppliersPageOrderAgentSettingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SuppliersPageOrderAgentSettingQuery = { __typename?: 'Query', supplier?: { __typename?: 'Supplier', id: string, chocoAiSupplierSetting?: { __typename?: 'SupplierSetting', supplierId: string, isOrderAgentEnabled: boolean } | null } | null };

export type SuppliersPageVendorPromotionMarketingUpdateMutationVariables = Exact<{
  input: VendorPromotionMarketingUpdateInput;
}>;


export type SuppliersPageVendorPromotionMarketingUpdateMutation = { __typename?: 'Mutation', vendorPromotionMarketingUpdate: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'InputValidationFailure', message?: string | null } | { __typename: 'NotFoundError', message?: string | null } | { __typename: 'VendorPromotionMarketingUpdateResult', responseType: ResponseType, record: { __typename?: 'VendorPromotionRecord', id: string, code?: string | null, isActive: boolean, status: VendorPromotionRecordStatus, priorityWeight?: number | null, isAppliedToAllChats: boolean, categoryCode?: string | null, chats: Array<{ __typename?: 'ChatRef', id: string }>, translations: Array<{ __typename?: 'VendorPromotionRecordTranslation', locale: string, name: string, description: string, shortDescription?: string | null, displayName?: string | null, displayDescription?: string | null }>, promotion: { __typename?: 'VendorPromotion', id: string, name: string, shortDescription?: string | null, description?: string | null, beginAt?: number | null, endAt?: number | null, tierMode: VendorPromotionTierMode, tiers?: Array<{ __typename?: 'VendorPromotionTier', id: string, name: string, maxApplications?: number | null, conditions: Array<{ __typename?: 'VendorPromotionTierCondition', metric: VendorPromotionTierConditionMetric, minimumQuantity?: { __typename?: 'Decimal', amount: string } | null, maximumQuantity?: { __typename?: 'Decimal', amount: string } | null, minimumAmount?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null, maximumAmount?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null }>, offers: Array<{ __typename: 'VendorPromotionCartDiscountPercentageOffer', type: VendorPromotionTierOfferType, discountPercentage: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionCartFreeExtraUnitsOffer', type: VendorPromotionTierOfferType, quantityOffered: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionCartReducedPriceOffer', type: VendorPromotionTierOfferType, priceReduction: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | { __typename: 'VendorPromotionDiscountPercentageOffer', type: VendorPromotionTierOfferType, discountPercentage: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionFixedPriceOffer', type: VendorPromotionTierOfferType, price: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | { __typename: 'VendorPromotionFreeUnitsIncludedOffer', type: VendorPromotionTierOfferType, quantityOffered: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionReducedPriceOffer', type: VendorPromotionTierOfferType, priceReduction: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } }> }> | null } } } };

export type SuppliersPageVendorPromotionTierFragment = { __typename?: 'VendorPromotionTier', id: string, name: string, maxApplications?: number | null, conditions: Array<{ __typename?: 'VendorPromotionTierCondition', metric: VendorPromotionTierConditionMetric, minimumQuantity?: { __typename?: 'Decimal', amount: string } | null, maximumQuantity?: { __typename?: 'Decimal', amount: string } | null, minimumAmount?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null, maximumAmount?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null }>, offers: Array<{ __typename: 'VendorPromotionCartDiscountPercentageOffer', type: VendorPromotionTierOfferType, discountPercentage: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionCartFreeExtraUnitsOffer', type: VendorPromotionTierOfferType, quantityOffered: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionCartReducedPriceOffer', type: VendorPromotionTierOfferType, priceReduction: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | { __typename: 'VendorPromotionDiscountPercentageOffer', type: VendorPromotionTierOfferType, discountPercentage: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionFixedPriceOffer', type: VendorPromotionTierOfferType, price: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | { __typename: 'VendorPromotionFreeUnitsIncludedOffer', type: VendorPromotionTierOfferType, quantityOffered: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionReducedPriceOffer', type: VendorPromotionTierOfferType, priceReduction: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } }> };

export type SuppliersPageVendorPromotionRecordFragment = { __typename?: 'VendorPromotionRecord', id: string, code?: string | null, isActive: boolean, status: VendorPromotionRecordStatus, priorityWeight?: number | null, isAppliedToAllChats: boolean, categoryCode?: string | null, chats: Array<{ __typename?: 'ChatRef', id: string }>, translations: Array<{ __typename?: 'VendorPromotionRecordTranslation', locale: string, name: string, description: string, shortDescription?: string | null, displayName?: string | null, displayDescription?: string | null }>, promotion: { __typename?: 'VendorPromotion', id: string, name: string, shortDescription?: string | null, description?: string | null, beginAt?: number | null, endAt?: number | null, tierMode: VendorPromotionTierMode, tiers?: Array<{ __typename?: 'VendorPromotionTier', id: string, name: string, maxApplications?: number | null, conditions: Array<{ __typename?: 'VendorPromotionTierCondition', metric: VendorPromotionTierConditionMetric, minimumQuantity?: { __typename?: 'Decimal', amount: string } | null, maximumQuantity?: { __typename?: 'Decimal', amount: string } | null, minimumAmount?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null, maximumAmount?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null }>, offers: Array<{ __typename: 'VendorPromotionCartDiscountPercentageOffer', type: VendorPromotionTierOfferType, discountPercentage: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionCartFreeExtraUnitsOffer', type: VendorPromotionTierOfferType, quantityOffered: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionCartReducedPriceOffer', type: VendorPromotionTierOfferType, priceReduction: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | { __typename: 'VendorPromotionDiscountPercentageOffer', type: VendorPromotionTierOfferType, discountPercentage: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionFixedPriceOffer', type: VendorPromotionTierOfferType, price: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | { __typename: 'VendorPromotionFreeUnitsIncludedOffer', type: VendorPromotionTierOfferType, quantityOffered: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionReducedPriceOffer', type: VendorPromotionTierOfferType, priceReduction: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } }> }> | null } };

export type SuppliersPageVendorPromotionListQueryVariables = Exact<{
  input: VendorPromotionListInput;
}>;


export type SuppliersPageVendorPromotionListQuery = { __typename?: 'Query', vendorPromotionList: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'InputValidationFailure', message?: string | null } | { __typename: 'NotFoundError', message?: string | null } | { __typename: 'VendorPromotionListResult', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename?: 'VendorPromotionListResultEdge', cursor: string, node: { __typename?: 'VendorPromotionRecord', id: string, code?: string | null, isActive: boolean, status: VendorPromotionRecordStatus, priorityWeight?: number | null, isAppliedToAllChats: boolean, categoryCode?: string | null, chats: Array<{ __typename?: 'ChatRef', id: string }>, translations: Array<{ __typename?: 'VendorPromotionRecordTranslation', locale: string, name: string, description: string, shortDescription?: string | null, displayName?: string | null, displayDescription?: string | null }>, promotion: { __typename?: 'VendorPromotion', id: string, name: string, shortDescription?: string | null, description?: string | null, beginAt?: number | null, endAt?: number | null, tierMode: VendorPromotionTierMode, tiers?: Array<{ __typename?: 'VendorPromotionTier', id: string, name: string, maxApplications?: number | null, conditions: Array<{ __typename?: 'VendorPromotionTierCondition', metric: VendorPromotionTierConditionMetric, minimumQuantity?: { __typename?: 'Decimal', amount: string } | null, maximumQuantity?: { __typename?: 'Decimal', amount: string } | null, minimumAmount?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null, maximumAmount?: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } | null }>, offers: Array<{ __typename: 'VendorPromotionCartDiscountPercentageOffer', type: VendorPromotionTierOfferType, discountPercentage: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionCartFreeExtraUnitsOffer', type: VendorPromotionTierOfferType, quantityOffered: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionCartReducedPriceOffer', type: VendorPromotionTierOfferType, priceReduction: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | { __typename: 'VendorPromotionDiscountPercentageOffer', type: VendorPromotionTierOfferType, discountPercentage: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionFixedPriceOffer', type: VendorPromotionTierOfferType, price: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | { __typename: 'VendorPromotionFreeUnitsIncludedOffer', type: VendorPromotionTierOfferType, quantityOffered: { __typename?: 'Decimal', amount: string } } | { __typename: 'VendorPromotionReducedPriceOffer', type: VendorPromotionTierOfferType, priceReduction: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } }> }> | null } } }> } };

export type SuppliersPageChatTaxProfileFragment = { __typename?: 'ChatTaxProfile', id: string, updatedAt: number, chat: { __typename?: 'ChatRef', id: string, node?: { __typename?: 'Chat', id: string, supplierCustomerName?: string | null, restaurantName?: string | null, chatName?: string | null, customerNumber?: string | null } | null }, jurisdiction: { __typename?: 'TaxJurisdictionRef', id: string, node?: { __typename?: 'TaxJurisdiction', id: string, code: string, countryCode: string, subdivisionCode?: string | null, rates: Array<{ __typename?: 'TaxRate', id: string }> } | null } };

export type SuppliersPageChatTaxProfileListQueryVariables = Exact<{
  input: ChatTaxProfileListInput;
}>;


export type SuppliersPageChatTaxProfileListQuery = { __typename?: 'Query', chatTaxProfileList: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'ChatTaxProfileListResult', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename?: 'ChatTaxProfileListResultEdge', cursor: string, node: { __typename?: 'ChatTaxProfile', id: string, updatedAt: number, chat: { __typename?: 'ChatRef', id: string, node?: { __typename?: 'Chat', id: string, supplierCustomerName?: string | null, restaurantName?: string | null, chatName?: string | null, customerNumber?: string | null } | null }, jurisdiction: { __typename?: 'TaxJurisdictionRef', id: string, node?: { __typename?: 'TaxJurisdiction', id: string, code: string, countryCode: string, subdivisionCode?: string | null, rates: Array<{ __typename?: 'TaxRate', id: string }> } | null } } }> } | { __typename: 'InputValidationFailure', message?: string | null } };

export type SuppliersPageTaxJurisdictionFragment = { __typename?: 'TaxJurisdiction', id: string, code: string, countryCode: string, subdivisionCode?: string | null, rates: Array<{ __typename?: 'TaxRate', id: string, code?: string | null, category: TaxRateCategory, label?: string | null, taxBehavior: TaxBehavior, appliesToFreeProducts: boolean, priority: number, validFrom?: string | null, validTo?: string | null, rateValue: { __typename: 'FixedAmountTaxRate', fixedAmount: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | { __typename: 'PercentageTaxRate', percentage: { __typename?: 'Decimal', amount: string } } }> };

export type SuppliersPageTaxJurisdictionListQueryVariables = Exact<{
  input: TaxJurisdictionListInput;
}>;


export type SuppliersPageTaxJurisdictionListQuery = { __typename?: 'Query', taxJurisdictionList: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'InputValidationFailure', message?: string | null } | { __typename: 'TaxJurisdictionListResult', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor: string }, edges: Array<{ __typename?: 'TaxJurisdictionListResultEdge', cursor: string, node: { __typename?: 'TaxJurisdiction', id: string, code: string, countryCode: string, subdivisionCode?: string | null, rates: Array<{ __typename?: 'TaxRate', id: string, code?: string | null, category: TaxRateCategory, label?: string | null, taxBehavior: TaxBehavior, appliesToFreeProducts: boolean, priority: number, validFrom?: string | null, validTo?: string | null, rateValue: { __typename: 'FixedAmountTaxRate', fixedAmount: { __typename?: 'MoneyV2', amount: number, currency: string, decimalPlaces: number } } | { __typename: 'PercentageTaxRate', percentage: { __typename?: 'Decimal', amount: string } } }> } }> } };

export type IntegrationEmailOptionFragmentFragment = { __typename: 'IntegrationEmailOption', type: IntegrationType, emailAddress?: string | null, xlsx: boolean, pdf: boolean, complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null };

export type IntegrationWhatsAppOptionFragmentFragment = { __typename: 'IntegrationWhatsAppOption', type: IntegrationType, phone: string };

export type IntegrationSmsOptionFragmentFragment = { __typename: 'IntegrationSmsOption', type: IntegrationType, phone: string };

export type IntegrationFaxOptionFragmentFragment = { __typename: 'IntegrationFaxOption', type: IntegrationType, phone: string };

export type SupplierPageInfoFragmentFragment = { __typename: 'PageInfo', endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string };

export type SupplierDetailsFragmentFragment = { __typename: 'Supplier', id: string, referenceId: string, sortCartBy?: SortCartBy | null, name: string, description?: string | null, primaryAssortment?: string | null, secondaryAssortments?: Array<string> | null, contactEmails?: Array<string> | null, locale: string, isPuppy?: boolean | null, isTest?: boolean | null, isDiscoverable?: boolean | null, isIntegrated?: boolean | null, deliveryCosts?: string | null, minOrderAmount?: string | null, allowCustomProducts: boolean, allowCustomerAcquisition?: boolean | null, allowOnlyOneActiveVariant?: boolean | null, allowBuyerComment?: boolean | null, allowInvoiceOrderGuidePhotoUpload?: boolean | null, enablePromotions?: boolean | null, enableTaxes?: boolean | null, pricingDateSource?: PricingDateSource | null, calculationPrecision?: number | null, deliveryDateMandatory: boolean, customerNumberMandatory?: boolean | null, timezone?: string | null, hasEnabledCatalogProducts?: boolean | null, hasEnabledFractionalUnits?: boolean | null, hasValidCatalogProducts?: boolean | null, noDefaultCatalog?: boolean | null, defaultSubCatalog?: string | null, accessPackage: AccessPackage, disableCustomerNumberEdits?: boolean | null, allowOrderedProductMerging?: boolean | null, enableEcommerceProductGridView?: boolean | null, allowEcommercePoNumber?: boolean | null, hideMyPrice?: boolean | null, buyerVisibleStockStatuses?: Array<VendorItemUnitStockStatus> | null, deliveryZones?: Array<{ __typename: 'DeliveryZone', name: string, points: Array<{ __typename: 'Coordinate', latitude: number, longitude: number }> }> | null, coverPhoto?: { __typename: 'ProfileImage', url?: string | null, uploadUrl?: string | null, smallRectangle?: string | null, mediumRectangle?: string | null, largeRectangle?: string | null } | null, priceSetting?: { __typename: 'PriceSetting', displayInMarketplace: boolean, displayToCustomers: boolean } | null, integration: Array<{ __typename: 'IntegrationEmailOption', type: IntegrationType, emailAddress?: string | null, xlsx: boolean, pdf: boolean, complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename: 'IntegrationFaxOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationSmsOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationWhatsAppOption', type: IntegrationType, phone: string }>, botUser?: { __typename: 'User', id: string, profileImage?: { __typename: 'ProfileImage', uploadUrl?: string | null, smallSquare?: string | null, mediumSquare?: string | null, largeSquare?: string | null } | null } | null, minOrder?: { __typename: 'MinOrder', strict?: boolean | null, price?: { __typename: 'Money', currency?: string | null, amount?: number | null } | null } | null };

export type SearchSupplierEdgeFragmentFragment = { __typename: 'SupplierSearchEdge', node: { __typename: 'Supplier', id: string, referenceId: string, sortCartBy?: SortCartBy | null, name: string, description?: string | null, primaryAssortment?: string | null, secondaryAssortments?: Array<string> | null, contactEmails?: Array<string> | null, locale: string, isPuppy?: boolean | null, isTest?: boolean | null, isDiscoverable?: boolean | null, isIntegrated?: boolean | null, deliveryCosts?: string | null, minOrderAmount?: string | null, allowCustomProducts: boolean, allowCustomerAcquisition?: boolean | null, allowOnlyOneActiveVariant?: boolean | null, allowBuyerComment?: boolean | null, allowInvoiceOrderGuidePhotoUpload?: boolean | null, enablePromotions?: boolean | null, enableTaxes?: boolean | null, pricingDateSource?: PricingDateSource | null, calculationPrecision?: number | null, deliveryDateMandatory: boolean, customerNumberMandatory?: boolean | null, timezone?: string | null, hasEnabledCatalogProducts?: boolean | null, hasEnabledFractionalUnits?: boolean | null, hasValidCatalogProducts?: boolean | null, noDefaultCatalog?: boolean | null, defaultSubCatalog?: string | null, accessPackage: AccessPackage, disableCustomerNumberEdits?: boolean | null, allowOrderedProductMerging?: boolean | null, enableEcommerceProductGridView?: boolean | null, allowEcommercePoNumber?: boolean | null, hideMyPrice?: boolean | null, buyerVisibleStockStatuses?: Array<VendorItemUnitStockStatus> | null, deliveryZones?: Array<{ __typename: 'DeliveryZone', name: string, points: Array<{ __typename: 'Coordinate', latitude: number, longitude: number }> }> | null, coverPhoto?: { __typename: 'ProfileImage', url?: string | null, uploadUrl?: string | null, smallRectangle?: string | null, mediumRectangle?: string | null, largeRectangle?: string | null } | null, priceSetting?: { __typename: 'PriceSetting', displayInMarketplace: boolean, displayToCustomers: boolean } | null, integration: Array<{ __typename: 'IntegrationEmailOption', type: IntegrationType, emailAddress?: string | null, xlsx: boolean, pdf: boolean, complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename: 'IntegrationFaxOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationSmsOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationWhatsAppOption', type: IntegrationType, phone: string }>, botUser?: { __typename: 'User', id: string, profileImage?: { __typename: 'ProfileImage', uploadUrl?: string | null, smallSquare?: string | null, mediumSquare?: string | null, largeSquare?: string | null } | null } | null, minOrder?: { __typename: 'MinOrder', strict?: boolean | null, price?: { __typename: 'Money', currency?: string | null, amount?: number | null } | null } | null } };

export type SearchSupplierConnectionFragmentFragment = { __typename: 'SearchSupplierConnection', total: number, edges: Array<{ __typename: 'SupplierSearchEdge', node: { __typename: 'Supplier', id: string, referenceId: string, sortCartBy?: SortCartBy | null, name: string, description?: string | null, primaryAssortment?: string | null, secondaryAssortments?: Array<string> | null, contactEmails?: Array<string> | null, locale: string, isPuppy?: boolean | null, isTest?: boolean | null, isDiscoverable?: boolean | null, isIntegrated?: boolean | null, deliveryCosts?: string | null, minOrderAmount?: string | null, allowCustomProducts: boolean, allowCustomerAcquisition?: boolean | null, allowOnlyOneActiveVariant?: boolean | null, allowBuyerComment?: boolean | null, allowInvoiceOrderGuidePhotoUpload?: boolean | null, enablePromotions?: boolean | null, enableTaxes?: boolean | null, pricingDateSource?: PricingDateSource | null, calculationPrecision?: number | null, deliveryDateMandatory: boolean, customerNumberMandatory?: boolean | null, timezone?: string | null, hasEnabledCatalogProducts?: boolean | null, hasEnabledFractionalUnits?: boolean | null, hasValidCatalogProducts?: boolean | null, noDefaultCatalog?: boolean | null, defaultSubCatalog?: string | null, accessPackage: AccessPackage, disableCustomerNumberEdits?: boolean | null, allowOrderedProductMerging?: boolean | null, enableEcommerceProductGridView?: boolean | null, allowEcommercePoNumber?: boolean | null, hideMyPrice?: boolean | null, buyerVisibleStockStatuses?: Array<VendorItemUnitStockStatus> | null, deliveryZones?: Array<{ __typename: 'DeliveryZone', name: string, points: Array<{ __typename: 'Coordinate', latitude: number, longitude: number }> }> | null, coverPhoto?: { __typename: 'ProfileImage', url?: string | null, uploadUrl?: string | null, smallRectangle?: string | null, mediumRectangle?: string | null, largeRectangle?: string | null } | null, priceSetting?: { __typename: 'PriceSetting', displayInMarketplace: boolean, displayToCustomers: boolean } | null, integration: Array<{ __typename: 'IntegrationEmailOption', type: IntegrationType, emailAddress?: string | null, xlsx: boolean, pdf: boolean, complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename: 'IntegrationFaxOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationSmsOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationWhatsAppOption', type: IntegrationType, phone: string }>, botUser?: { __typename: 'User', id: string, profileImage?: { __typename: 'ProfileImage', uploadUrl?: string | null, smallSquare?: string | null, mediumSquare?: string | null, largeSquare?: string | null } | null } | null, minOrder?: { __typename: 'MinOrder', strict?: boolean | null, price?: { __typename: 'Money', currency?: string | null, amount?: number | null } | null } | null } }>, pageInfo: { __typename: 'PageInfo', endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string } };

export type SuppliersPageJoinRequestFragmentFragment = { __typename?: 'UserRequestToJoin', id: string, status: JoinRequestStatus, user: { __typename?: 'User', id: string, name?: string | null, email?: string | null, phone: string } };

export type SuppliersPageCreateSupplierMutationVariables = Exact<{
  supplier: SupplierCreateInput;
}>;


export type SuppliersPageCreateSupplierMutation = { __typename?: 'Mutation', supplierCreate: { __typename: 'Supplier', id: string, referenceId: string, sortCartBy?: SortCartBy | null, name: string, description?: string | null, primaryAssortment?: string | null, secondaryAssortments?: Array<string> | null, contactEmails?: Array<string> | null, locale: string, isPuppy?: boolean | null, isTest?: boolean | null, isDiscoverable?: boolean | null, isIntegrated?: boolean | null, deliveryCosts?: string | null, minOrderAmount?: string | null, allowCustomProducts: boolean, allowCustomerAcquisition?: boolean | null, allowOnlyOneActiveVariant?: boolean | null, allowBuyerComment?: boolean | null, allowInvoiceOrderGuidePhotoUpload?: boolean | null, enablePromotions?: boolean | null, enableTaxes?: boolean | null, pricingDateSource?: PricingDateSource | null, calculationPrecision?: number | null, deliveryDateMandatory: boolean, customerNumberMandatory?: boolean | null, timezone?: string | null, hasEnabledCatalogProducts?: boolean | null, hasEnabledFractionalUnits?: boolean | null, hasValidCatalogProducts?: boolean | null, noDefaultCatalog?: boolean | null, defaultSubCatalog?: string | null, accessPackage: AccessPackage, disableCustomerNumberEdits?: boolean | null, allowOrderedProductMerging?: boolean | null, enableEcommerceProductGridView?: boolean | null, allowEcommercePoNumber?: boolean | null, hideMyPrice?: boolean | null, buyerVisibleStockStatuses?: Array<VendorItemUnitStockStatus> | null, deliveryZones?: Array<{ __typename: 'DeliveryZone', name: string, points: Array<{ __typename: 'Coordinate', latitude: number, longitude: number }> }> | null, coverPhoto?: { __typename: 'ProfileImage', url?: string | null, uploadUrl?: string | null, smallRectangle?: string | null, mediumRectangle?: string | null, largeRectangle?: string | null } | null, priceSetting?: { __typename: 'PriceSetting', displayInMarketplace: boolean, displayToCustomers: boolean } | null, integration: Array<{ __typename: 'IntegrationEmailOption', type: IntegrationType, emailAddress?: string | null, xlsx: boolean, pdf: boolean, complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename: 'IntegrationFaxOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationSmsOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationWhatsAppOption', type: IntegrationType, phone: string }>, botUser?: { __typename: 'User', id: string, profileImage?: { __typename: 'ProfileImage', uploadUrl?: string | null, smallSquare?: string | null, mediumSquare?: string | null, largeSquare?: string | null } | null } | null, minOrder?: { __typename: 'MinOrder', strict?: boolean | null, price?: { __typename: 'Money', currency?: string | null, amount?: number | null } | null } | null } };

export type SuppliersPageUpdateDeliverySettingMutationVariables = Exact<{
  input: SupplierDeliverySettingInput;
}>;


export type SuppliersPageUpdateDeliverySettingMutation = { __typename?: 'Mutation', updateSupplierDeliverySetting?: { __typename: 'SupplierDeliverySetting', id: string } | null };

export type SuppliersPageUpdateRequestToJoinMutationVariables = Exact<{
  input: UpdateJoinRequestInput;
}>;


export type SuppliersPageUpdateRequestToJoinMutation = { __typename?: 'Mutation', updateRequestToJoin: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'InputValidationFailure', message?: string | null } | { __typename: 'UpdateJoinRequestError', errorCode?: UpdateJoinRequestErrorCode | null, message?: string | null } | { __typename: 'UpdateJoinRequestSuccess', id: string, status: JoinRequestAllowedUpdateStatus } };

export type SuppliersPageUpdateSupplierMutationVariables = Exact<{
  supplier: SupplierUpdateInput;
}>;


export type SuppliersPageUpdateSupplierMutation = { __typename?: 'Mutation', supplierUpdate: { __typename: 'Supplier', id: string, referenceId: string, sortCartBy?: SortCartBy | null, name: string, description?: string | null, primaryAssortment?: string | null, secondaryAssortments?: Array<string> | null, contactEmails?: Array<string> | null, locale: string, isPuppy?: boolean | null, isTest?: boolean | null, isDiscoverable?: boolean | null, isIntegrated?: boolean | null, deliveryCosts?: string | null, minOrderAmount?: string | null, allowCustomProducts: boolean, allowCustomerAcquisition?: boolean | null, allowOnlyOneActiveVariant?: boolean | null, allowBuyerComment?: boolean | null, allowInvoiceOrderGuidePhotoUpload?: boolean | null, enablePromotions?: boolean | null, enableTaxes?: boolean | null, pricingDateSource?: PricingDateSource | null, calculationPrecision?: number | null, deliveryDateMandatory: boolean, customerNumberMandatory?: boolean | null, timezone?: string | null, hasEnabledCatalogProducts?: boolean | null, hasEnabledFractionalUnits?: boolean | null, hasValidCatalogProducts?: boolean | null, noDefaultCatalog?: boolean | null, defaultSubCatalog?: string | null, accessPackage: AccessPackage, disableCustomerNumberEdits?: boolean | null, allowOrderedProductMerging?: boolean | null, enableEcommerceProductGridView?: boolean | null, allowEcommercePoNumber?: boolean | null, hideMyPrice?: boolean | null, buyerVisibleStockStatuses?: Array<VendorItemUnitStockStatus> | null, deliveryZones?: Array<{ __typename: 'DeliveryZone', name: string, points: Array<{ __typename: 'Coordinate', latitude: number, longitude: number }> }> | null, coverPhoto?: { __typename: 'ProfileImage', url?: string | null, uploadUrl?: string | null, smallRectangle?: string | null, mediumRectangle?: string | null, largeRectangle?: string | null } | null, priceSetting?: { __typename: 'PriceSetting', displayInMarketplace: boolean, displayToCustomers: boolean } | null, integration: Array<{ __typename: 'IntegrationEmailOption', type: IntegrationType, emailAddress?: string | null, xlsx: boolean, pdf: boolean, complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename: 'IntegrationFaxOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationSmsOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationWhatsAppOption', type: IntegrationType, phone: string }>, botUser?: { __typename: 'User', id: string, profileImage?: { __typename: 'ProfileImage', uploadUrl?: string | null, smallSquare?: string | null, mediumSquare?: string | null, largeSquare?: string | null } | null } | null, minOrder?: { __typename: 'MinOrder', strict?: boolean | null, price?: { __typename: 'Money', currency?: string | null, amount?: number | null } | null } | null } };

export type SuppliersPageUpdateSupplierAccessPackageMutationVariables = Exact<{
  suppliers: Array<SupplierUpdateAccessPackageInput> | SupplierUpdateAccessPackageInput;
}>;


export type SuppliersPageUpdateSupplierAccessPackageMutation = { __typename?: 'Mutation', updateSupplierAccessPackage: { __typename?: 'SupplierUpdateAccessPackageError', responseType: ResponseType, message?: string | null } | { __typename?: 'SupplierUpdateAccessPackageSuccess', responseType: ResponseType, errors: Array<{ __typename?: 'SupplierUpdateError', message: string, supplierId: string }> } };

export type SuppliersPageUpdateSupplierDeliveryZonesMutationVariables = Exact<{
  supplier: SupplierUpdateInput;
}>;


export type SuppliersPageUpdateSupplierDeliveryZonesMutation = { __typename?: 'Mutation', supplierUpdate: { __typename?: 'Supplier', id: string, deliveryZones?: Array<{ __typename?: 'DeliveryZone', name: string, points: Array<{ __typename?: 'Coordinate', latitude: number, longitude: number }> }> | null } };

export type SuppliersPageUpdateSupplierUserRolesMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  rolesToAdd: Array<Role> | Role;
}>;


export type SuppliersPageUpdateSupplierUserRolesMutation = { __typename?: 'Mutation', updateSupplierUserRoles?: { __typename: 'User', id: string, role?: Array<Role | null> | null } | null };

export type SupplierAssortmentsDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SupplierAssortmentsDataQuery = { __typename?: 'Query', supplierAssortments: { __typename: 'supplierAssortments', assortments: Array<string> } };

export type SupplierDeliverySettingFragmentFragment = { __typename: 'SupplierDeliverySetting', id: string, deliveryDays?: Array<number> | null, cutoffType?: CutOffTimeType | null, cutOffTime?: { __typename: 'CutOffTime', time: string, type: CutOffTimeType } | null, cutoffTimes: { __typename: 'WeekdayBasedCutoffSettings', mon?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, tue?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, wed?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, thu?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, fri?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sat?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sun?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null } };

export type SupplierDeliverySettingDataQueryVariables = Exact<{
  supplierId: Scalars['ID']['input'];
}>;


export type SupplierDeliverySettingDataQuery = { __typename?: 'Query', supplierDeliverySetting?: { __typename: 'SupplierDeliverySetting', id: string, deliveryDays?: Array<number> | null, cutoffType?: CutOffTimeType | null, cutOffTime?: { __typename: 'CutOffTime', time: string, type: CutOffTimeType } | null, cutoffTimes: { __typename: 'WeekdayBasedCutoffSettings', mon?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, tue?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, wed?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, thu?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, fri?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sat?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null, sun?: { __typename: 'NoCutoffSetting' } | { __typename: 'WithCutoffSetting', leadTime: number, cutoffTime: string } | null } } | null };

export type GetSupplierDetailsDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSupplierDetailsDataQuery = { __typename?: 'Query', supplier?: { __typename: 'Supplier', id: string, referenceId: string, sortCartBy?: SortCartBy | null, name: string, description?: string | null, primaryAssortment?: string | null, secondaryAssortments?: Array<string> | null, contactEmails?: Array<string> | null, locale: string, isPuppy?: boolean | null, isTest?: boolean | null, isDiscoverable?: boolean | null, isIntegrated?: boolean | null, deliveryCosts?: string | null, minOrderAmount?: string | null, allowCustomProducts: boolean, allowCustomerAcquisition?: boolean | null, allowOnlyOneActiveVariant?: boolean | null, allowBuyerComment?: boolean | null, allowInvoiceOrderGuidePhotoUpload?: boolean | null, enablePromotions?: boolean | null, enableTaxes?: boolean | null, pricingDateSource?: PricingDateSource | null, calculationPrecision?: number | null, deliveryDateMandatory: boolean, customerNumberMandatory?: boolean | null, timezone?: string | null, hasEnabledCatalogProducts?: boolean | null, hasEnabledFractionalUnits?: boolean | null, hasValidCatalogProducts?: boolean | null, noDefaultCatalog?: boolean | null, defaultSubCatalog?: string | null, accessPackage: AccessPackage, disableCustomerNumberEdits?: boolean | null, allowOrderedProductMerging?: boolean | null, enableEcommerceProductGridView?: boolean | null, allowEcommercePoNumber?: boolean | null, hideMyPrice?: boolean | null, buyerVisibleStockStatuses?: Array<VendorItemUnitStockStatus> | null, deliveryZones?: Array<{ __typename: 'DeliveryZone', name: string, points: Array<{ __typename: 'Coordinate', latitude: number, longitude: number }> }> | null, coverPhoto?: { __typename: 'ProfileImage', url?: string | null, uploadUrl?: string | null, smallRectangle?: string | null, mediumRectangle?: string | null, largeRectangle?: string | null } | null, priceSetting?: { __typename: 'PriceSetting', displayInMarketplace: boolean, displayToCustomers: boolean } | null, integration: Array<{ __typename: 'IntegrationEmailOption', type: IntegrationType, emailAddress?: string | null, xlsx: boolean, pdf: boolean, complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename: 'IntegrationFaxOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationSmsOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationWhatsAppOption', type: IntegrationType, phone: string }>, botUser?: { __typename: 'User', id: string, profileImage?: { __typename: 'ProfileImage', uploadUrl?: string | null, smallSquare?: string | null, mediumSquare?: string | null, largeSquare?: string | null } | null } | null, minOrder?: { __typename: 'MinOrder', strict?: boolean | null, price?: { __typename: 'Money', currency?: string | null, amount?: number | null } | null } | null } | null };

export type SuppliersPageGetRequestsToJoinQueryVariables = Exact<{
  supplierEntityId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuppliersPageGetRequestsToJoinQuery = { __typename?: 'Query', getRequestsToJoin: { __typename: 'AuthorizationFailure', message?: string | null } | { __typename: 'InputValidationFailure', message?: string | null } | { __typename: 'RequestsToJoinConnection', edges: Array<{ __typename?: 'UserRequestToJoinEdge', cursor: string, node: { __typename?: 'UserRequestToJoin', id: string, status: JoinRequestStatus, user: { __typename?: 'User', id: string, name?: string | null, email?: string | null, phone: string } } }> } };

export type SuppliersPageGetSupplierUsersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuppliersPageGetSupplierUsersQuery = { __typename?: 'Query', supplier?: { __typename?: 'Supplier', id: string, users?: { __typename?: 'SupplierUserConnection', edges?: Array<{ __typename?: 'SupplierUserEdge', node: { __typename?: 'User', id: string, name?: string | null, email?: string | null, phone: string, role?: Array<Role | null> | null, botUser?: boolean | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null } | null } }> | null } | null } | null };

export type SupplierSearchDataQueryVariables = Exact<{
  search: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SupplierSearchFilter>;
}>;


export type SupplierSearchDataQuery = { __typename?: 'Query', supplierSearch: { __typename: 'AuthorizationFailure' } | { __typename: 'InputValidationFailure' } | { __typename: 'SearchSupplierConnection', total: number, edges: Array<{ __typename: 'SupplierSearchEdge', node: { __typename: 'Supplier', id: string, referenceId: string, sortCartBy?: SortCartBy | null, name: string, description?: string | null, primaryAssortment?: string | null, secondaryAssortments?: Array<string> | null, contactEmails?: Array<string> | null, locale: string, isPuppy?: boolean | null, isTest?: boolean | null, isDiscoverable?: boolean | null, isIntegrated?: boolean | null, deliveryCosts?: string | null, minOrderAmount?: string | null, allowCustomProducts: boolean, allowCustomerAcquisition?: boolean | null, allowOnlyOneActiveVariant?: boolean | null, allowBuyerComment?: boolean | null, allowInvoiceOrderGuidePhotoUpload?: boolean | null, enablePromotions?: boolean | null, enableTaxes?: boolean | null, pricingDateSource?: PricingDateSource | null, calculationPrecision?: number | null, deliveryDateMandatory: boolean, customerNumberMandatory?: boolean | null, timezone?: string | null, hasEnabledCatalogProducts?: boolean | null, hasEnabledFractionalUnits?: boolean | null, hasValidCatalogProducts?: boolean | null, noDefaultCatalog?: boolean | null, defaultSubCatalog?: string | null, accessPackage: AccessPackage, disableCustomerNumberEdits?: boolean | null, allowOrderedProductMerging?: boolean | null, enableEcommerceProductGridView?: boolean | null, allowEcommercePoNumber?: boolean | null, hideMyPrice?: boolean | null, buyerVisibleStockStatuses?: Array<VendorItemUnitStockStatus> | null, deliveryZones?: Array<{ __typename: 'DeliveryZone', name: string, points: Array<{ __typename: 'Coordinate', latitude: number, longitude: number }> }> | null, coverPhoto?: { __typename: 'ProfileImage', url?: string | null, uploadUrl?: string | null, smallRectangle?: string | null, mediumRectangle?: string | null, largeRectangle?: string | null } | null, priceSetting?: { __typename: 'PriceSetting', displayInMarketplace: boolean, displayToCustomers: boolean } | null, integration: Array<{ __typename: 'IntegrationEmailOption', type: IntegrationType, emailAddress?: string | null, xlsx: boolean, pdf: boolean, complaintEmails?: Array<string> | null, orderEmails?: Array<string> | null, messageEmails?: Array<string> | null } | { __typename: 'IntegrationFaxOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationSmsOption', type: IntegrationType, phone: string } | { __typename: 'IntegrationWhatsAppOption', type: IntegrationType, phone: string }>, botUser?: { __typename: 'User', id: string, profileImage?: { __typename: 'ProfileImage', uploadUrl?: string | null, smallSquare?: string | null, mediumSquare?: string | null, largeSquare?: string | null } | null } | null, minOrder?: { __typename: 'MinOrder', strict?: boolean | null, price?: { __typename: 'Money', currency?: string | null, amount?: number | null } | null } | null } }>, pageInfo: { __typename: 'PageInfo', endCursor: string, hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string } } };

export type UsersPageUserSearchConnectionFragmentFragment = { __typename?: 'UserSearchConnection', total: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string, endCursor: string }, edges: Array<{ __typename?: 'UserSearchEdge', cursor: string, node: { __typename?: 'User', id: string, name?: string | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, email?: string | null, locale?: string | null, loginMethod?: LoginMethod | null, phone: string, createdAt?: number | null, supplier: boolean, isPuppy: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null, fax?: string | null, welcomeNotificationSent?: number | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null } }> };

export type UsersPageUserSearchEdgeFragmentFragment = { __typename?: 'UserSearchEdge', cursor: string, node: { __typename?: 'User', id: string, name?: string | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, email?: string | null, locale?: string | null, loginMethod?: LoginMethod | null, phone: string, createdAt?: number | null, supplier: boolean, isPuppy: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null, fax?: string | null, welcomeNotificationSent?: number | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null } };

export type UsersPageUserSearchFragmentFragment = { __typename?: 'User', id: string, name?: string | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, email?: string | null, locale?: string | null, loginMethod?: LoginMethod | null, phone: string, createdAt?: number | null, supplier: boolean, isPuppy: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null, fax?: string | null, welcomeNotificationSent?: number | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null };

export type UsersPageUserDetailsFragmentFragment = { __typename?: 'User', id: string, name?: string | null, email?: string | null, loginEmail?: string | null, challengeByEmail?: boolean | null, locale?: string | null, loginMethod?: LoginMethod | null, createdContext?: UserCreatedContext | null, phone: string, createdAt?: number | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, supplier: boolean, isTest?: boolean | null, chocoUser?: boolean | null, role?: Array<Role | null> | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null, uploadUrl?: string | null, mediumSquare?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string, referenceId: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null, fax?: string | null, welcomeNotificationSent?: number | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null };

export type UsersPageCreateUserFragmentFragment = { __typename?: 'User', isTest?: boolean | null, id: string, name?: string | null, email?: string | null, loginEmail?: string | null, challengeByEmail?: boolean | null, locale?: string | null, loginMethod?: LoginMethod | null, createdContext?: UserCreatedContext | null, phone: string, createdAt?: number | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, supplier: boolean, chocoUser?: boolean | null, role?: Array<Role | null> | null, profileImage?: { __typename?: 'ProfileImage', uploadUrl?: string | null, mediumSquare?: string | null, url?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string, referenceId: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null, fax?: string | null, welcomeNotificationSent?: number | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null };

export type AddUserToChatsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  chatIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddUserToChatsMutation = { __typename?: 'Mutation', addUserToChats: boolean };

export type UsersPageBuyerAddUserMutationVariables = Exact<{
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  input?: InputMaybe<BuyerUserInput>;
}>;


export type UsersPageBuyerAddUserMutation = { __typename?: 'Mutation', buyerAddUser: { __typename?: 'BuyerUser', buyer?: { __typename?: 'Buyer', id: string } | null, user?: { __typename?: 'User', id: string } | null } };

export type UsersPageBuyerRemoveUserMutationVariables = Exact<{
  buyerId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UsersPageBuyerRemoveUserMutation = { __typename?: 'Mutation', buyerRemoveUser: { __typename?: 'BuyerUser', buyer?: { __typename?: 'Buyer', id: string } | null, user?: { __typename?: 'User', id: string } | null } };

export type UsersPageCreateUserMutationVariables = Exact<{
  userInput: UserCreateInput;
}>;


export type UsersPageCreateUserMutation = { __typename?: 'Mutation', userCreate?: { __typename?: 'User', isTest?: boolean | null, id: string, name?: string | null, email?: string | null, loginEmail?: string | null, challengeByEmail?: boolean | null, locale?: string | null, loginMethod?: LoginMethod | null, createdContext?: UserCreatedContext | null, phone: string, createdAt?: number | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, supplier: boolean, chocoUser?: boolean | null, role?: Array<Role | null> | null, profileImage?: { __typename?: 'ProfileImage', uploadUrl?: string | null, mediumSquare?: string | null, url?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string, referenceId: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null, fax?: string | null, welcomeNotificationSent?: number | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null } | null };

export type UsersPageDeleteUserMutationVariables = Exact<{
  input: UserRequestToDeleteInput;
}>;


export type UsersPageDeleteUserMutation = { __typename?: 'Mutation', userRequestToDelete: { __typename?: 'AuthorizationFailure' } | { __typename?: 'UserRequestToDeleteDetails', success: boolean } };

export type UsersPageUserConfirmMutationVariables = Exact<{
  phone: Scalars['String']['input'];
}>;


export type UsersPageUserConfirmMutation = { __typename?: 'Mutation', userConfirm: boolean };

export type RemoveUserFromChatsMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  chatIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveUserFromChatsMutation = { __typename?: 'Mutation', removeUserFromChats: boolean };

export type SafelistTwilioUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SafelistTwilioUserMutation = { __typename?: 'Mutation', safelistTwilioUser: { __typename: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename: 'InputValidationFailure', message?: string | null, responseType: ResponseType, invalidFields?: Array<{ __typename: 'FieldValidationError', fieldName: string, reason: string }> | null } | { __typename: 'NotFoundError', message?: string | null, responseType: ResponseType } | { __typename: 'SafelistTwilioUserFailure', responseType: ResponseType, failureMessage: string } | { __typename: 'SafelistTwilioUserSuccess', successMessage: string } };

export type SupplierAddUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  supplierId?: InputMaybe<Scalars['String']['input']>;
  withRoles: Scalars['Boolean']['input'];
}>;


export type SupplierAddUserMutation = { __typename?: 'Mutation', userUpdate?: { __typename: 'User', id: string, name?: string | null, pending?: boolean | null, locale?: string | null, phone: string, phoneNumberType?: UserPhoneType | null, image?: string | null, loginEmail?: string | null, email?: string | null, supplier: boolean, chocoUser?: boolean | null, createdAt?: number | null, supplierId?: string | null, challengeByEmail?: boolean | null, loginMethod?: LoginMethod | null, role?: Array<Role | null> | null, orderPreference?: { __typename: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null } | null, linkedSupplier?: { __typename: 'Supplier', id: string, name: string, referenceId: string } | null } | null };

export type UserDetailsFragmentFragment = { __typename: 'User', id: string, name?: string | null, pending?: boolean | null, locale?: string | null, phone: string, phoneNumberType?: UserPhoneType | null, image?: string | null, loginEmail?: string | null, email?: string | null, supplier: boolean, chocoUser?: boolean | null, createdAt?: number | null, supplierId?: string | null, challengeByEmail?: boolean | null, loginMethod?: LoginMethod | null, role?: Array<Role | null> | null, orderPreference?: { __typename: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null } | null, linkedSupplier?: { __typename: 'Supplier', id: string, name: string, referenceId: string } | null };

export type SupplierRemoveUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  withRoles: Scalars['Boolean']['input'];
}>;


export type SupplierRemoveUserMutation = { __typename?: 'Mutation', userUpdate?: { __typename: 'User', id: string, name?: string | null, pending?: boolean | null, locale?: string | null, phone: string, phoneNumberType?: UserPhoneType | null, image?: string | null, loginEmail?: string | null, email?: string | null, supplier: boolean, chocoUser?: boolean | null, createdAt?: number | null, supplierId?: string | null, challengeByEmail?: boolean | null, loginMethod?: LoginMethod | null, role?: Array<Role | null> | null, linkedSupplier?: { __typename: 'Supplier', id: string, name: string, referenceId: string } | null } | null };

export type SupplierRemoveUserDetailsFragmentFragment = { __typename: 'User', id: string, name?: string | null, pending?: boolean | null, locale?: string | null, phone: string, phoneNumberType?: UserPhoneType | null, image?: string | null, loginEmail?: string | null, email?: string | null, supplier: boolean, chocoUser?: boolean | null, createdAt?: number | null, supplierId?: string | null, challengeByEmail?: boolean | null, loginMethod?: LoginMethod | null, role?: Array<Role | null> | null, linkedSupplier?: { __typename: 'Supplier', id: string, name: string, referenceId: string } | null };

export type SyncCognitoUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SyncCognitoUserMutation = { __typename?: 'Mutation', syncCognitoUser: { __typename: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename: 'NotFoundError', message?: string | null, responseType: ResponseType } | { __typename: 'SyncCognitoUserFailure', responseType: ResponseType, failureMessage: string } | { __typename: 'SyncCognitoUserSuccess', state: { __typename: 'UserCognitoState', status: CognitoSyncStatus, cognitoUsers?: { __typename?: 'CognitoStateUsers', email?: { __typename?: 'CognitoStateUser', groups: Array<string | null>, status: CognitoSyncStatus, attributes: Array<{ __typename?: 'CognitoAttribute', name: string, value: string } | null> } | null, phone?: { __typename?: 'CognitoStateUser', groups: Array<string | null>, status: CognitoSyncStatus, attributes: Array<{ __typename?: 'CognitoAttribute', name: string, value: string } | null> } | null } | null } } };

export type UsersPageUpdateSupplierUserRolesMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  rolesToAdd: Array<Role> | Role;
}>;


export type UsersPageUpdateSupplierUserRolesMutation = { __typename?: 'Mutation', updateSupplierUserRoles?: { __typename: 'User', id: string, role?: Array<Role | null> | null } | null };

export type UsersPageUpdateUserMutationVariables = Exact<{
  userUpdateInput: UserUpdateInput;
}>;


export type UsersPageUpdateUserMutation = { __typename?: 'Mutation', userUpdate?: { __typename?: 'User', isTest?: boolean | null, id: string, name?: string | null, email?: string | null, loginEmail?: string | null, challengeByEmail?: boolean | null, locale?: string | null, loginMethod?: LoginMethod | null, createdContext?: UserCreatedContext | null, phone: string, createdAt?: number | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, supplier: boolean, chocoUser?: boolean | null, role?: Array<Role | null> | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null, uploadUrl?: string | null, mediumSquare?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string, referenceId: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null, fax?: string | null, welcomeNotificationSent?: number | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null } | null };

export type UserRemoveRoleMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  role: Role;
}>;


export type UserRemoveRoleMutation = { __typename?: 'Mutation', userRemoveRole?: { __typename: 'User', id: string, role?: Array<Role | null> | null } | null };

export type GetBuyerEntityChatsQueryVariables = Exact<{
  buyerEntityId: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type GetBuyerEntityChatsQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', total: number, hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer' } | { __typename?: 'Chat', id: string, chatName?: string | null, isUserInChat?: boolean | null, supplier?: { __typename?: 'User', id: string, name?: string | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null } | null } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null }> } };

export type BuyerEntityChatFragmentFragment = { __typename?: 'Chat', id: string, chatName?: string | null, isUserInChat?: boolean | null, supplier?: { __typename?: 'User', id: string, name?: string | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null } | null };

export type BuyerChatUserFragmentFragment = { __typename?: 'User', id: string, name?: string | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null };

export type UsersPageGetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UsersPageGetUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, loginEmail?: string | null, challengeByEmail?: boolean | null, locale?: string | null, loginMethod?: LoginMethod | null, createdContext?: UserCreatedContext | null, phone: string, createdAt?: number | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, supplier: boolean, isTest?: boolean | null, chocoUser?: boolean | null, role?: Array<Role | null> | null, profileImage?: { __typename?: 'ProfileImage', url?: string | null, uploadUrl?: string | null, mediumSquare?: string | null } | null, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string, referenceId: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null, fax?: string | null, welcomeNotificationSent?: number | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null } | null };

export type CognitoStateFragmentFragment = { __typename: 'UserCognitoState', status: CognitoSyncStatus, cognitoUsers?: { __typename?: 'CognitoStateUsers', email?: { __typename?: 'CognitoStateUser', groups: Array<string | null>, status: CognitoSyncStatus, attributes: Array<{ __typename?: 'CognitoAttribute', name: string, value: string } | null> } | null, phone?: { __typename?: 'CognitoStateUser', groups: Array<string | null>, status: CognitoSyncStatus, attributes: Array<{ __typename?: 'CognitoAttribute', name: string, value: string } | null> } | null } | null };

export type CognitoUserFragmentFragment = { __typename?: 'CognitoStateUser', groups: Array<string | null>, status: CognitoSyncStatus, attributes: Array<{ __typename?: 'CognitoAttribute', name: string, value: string } | null> };

export type GetUserCognitoStateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserCognitoStateQuery = { __typename?: 'Query', userCognitoState: { __typename: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename: 'NotFoundError', message?: string | null, responseType: ResponseType } | { __typename: 'UserCognitoState', status: CognitoSyncStatus, cognitoUsers?: { __typename?: 'CognitoStateUsers', email?: { __typename?: 'CognitoStateUser', groups: Array<string | null>, status: CognitoSyncStatus, attributes: Array<{ __typename?: 'CognitoAttribute', name: string, value: string } | null> } | null, phone?: { __typename?: 'CognitoStateUser', groups: Array<string | null>, status: CognitoSyncStatus, attributes: Array<{ __typename?: 'CognitoAttribute', name: string, value: string } | null> } | null } | null } };

export type GetUserTwilioStateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserTwilioStateQuery = { __typename?: 'Query', userTwilioState: { __typename: 'AuthorizationFailure', message?: string | null, responseType: ResponseType } | { __typename: 'InputValidationFailure', message?: string | null, responseType: ResponseType, invalidFields?: Array<{ __typename: 'FieldValidationError', fieldName: string, reason: string }> | null } | { __typename: 'NotFoundError', message?: string | null, responseType: ResponseType } | { __typename: 'UserTwilioState', status?: TwilioStatus | null } | { __typename: 'UserTwilioStateError', responseType: ResponseType, ErrorMessage: string } };

export type UsersPageSearchBuyerEntityQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SearchFilter>;
}>;


export type UsersPageSearchBuyerEntityQuery = { __typename?: 'Query', search: { __typename?: 'SearchResult', hits: Array<{ __typename?: 'SearchItem', entity?: { __typename?: 'Broadcast' } | { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, rolesEnabled?: boolean | null, fullAddress: string } | { __typename?: 'Chat' } | { __typename?: 'Message' } | { __typename?: 'Order' } | { __typename?: 'Product' } | { __typename?: 'Supplier' } | { __typename?: 'User' } | null }> } };

export type UsersPageBuyerEntityFragmentFragment = { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, rolesEnabled?: boolean | null, fullAddress: string };

export type SearchSuppliersQueryVariables = Exact<{
  keywords: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SupplierSearchFilter>;
}>;


export type SearchSuppliersQuery = { __typename?: 'Query', supplierSearch: { __typename: 'AuthorizationFailure' } | { __typename: 'InputValidationFailure' } | { __typename: 'SearchSupplierConnection', edges: Array<{ __typename: 'SupplierSearchEdge', cursor: string, node: { __typename: 'Supplier', id: string, name: string } }> } };

export type UsersPageSearchSupplierConnectionFragmentFragment = { __typename: 'SearchSupplierConnection', edges: Array<{ __typename: 'SupplierSearchEdge', cursor: string, node: { __typename: 'Supplier', id: string, name: string } }> };

export type UsersPageSupplierSearchEdgeFragmentFragment = { __typename: 'SupplierSearchEdge', cursor: string, node: { __typename: 'Supplier', id: string, name: string } };

export type UsersPageSearchSupplierFragmentFragment = { __typename: 'Supplier', id: string, name: string };

export type UsersPageSearchUsersQueryVariables = Exact<{
  query: UserSearchInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersPageSearchUsersQuery = { __typename?: 'Query', userSearch: { __typename?: 'AuthorizationFailure' } | { __typename?: 'InputValidationFailure' } | { __typename?: 'UserSearchConnection', total: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor: string, endCursor: string }, edges: Array<{ __typename?: 'UserSearchEdge', cursor: string, node: { __typename?: 'User', id: string, name?: string | null, pending?: boolean | null, hasRequestedToBeDeleted?: boolean | null, email?: string | null, locale?: string | null, loginMethod?: LoginMethod | null, phone: string, createdAt?: number | null, supplier: boolean, isPuppy: boolean, linkedSupplier?: { __typename?: 'Supplier', id: string, name: string } | null, orderPreference?: { __typename?: 'OrderPreference', pdf?: boolean | null, xlsx?: boolean | null, sms?: string | null, whatsApp?: string | null, fax?: string | null, welcomeNotificationSent?: number | null } | null, buyers?: { __typename?: 'UserBuyerConnection', edges: Array<{ __typename?: 'UserBuyerEdge', role?: string | null, node: { __typename?: 'Buyer', id: string, name: string, referenceId?: string | null, fullAddress: string, rolesEnabled?: boolean | null } }> } | null } }> } };

export type WorkspacesPageCreateMutationVariables = Exact<{
  input: WorkspaceCreateInput;
}>;


export type WorkspacesPageCreateMutation = { __typename?: 'Mutation', workspaceCreate: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null } | { __typename?: 'WorkspaceCreateResult', workspace: { __typename?: 'Workspace', id: string, name: string, roots: Array<{ __typename?: 'SupplierRef', id: string, node?: { __typename?: 'Supplier', id: string, name: string, hierarchyType?: SupplierHierarchyType | null } | null }> } } | { __typename?: 'WorkspaceRootLocationAlreadyClaimed', message?: string | null, rootLocation: { __typename?: 'SupplierRef', id: string } } | { __typename?: 'WorkspaceRootLocationNotAHierarchyRoot', message?: string | null, rootLocation: { __typename?: 'SupplierRef', id: string }, hierarchyRoot: { __typename?: 'SupplierRef', id: string } } | { __typename?: 'WorkspaceRootLocationNotFound', message?: string | null, rootLocationId: string } };

export type WorkspacesPageAddMemberMutationVariables = Exact<{
  input: TeamMemberAddInput;
}>;


export type WorkspacesPageAddMemberMutation = { __typename?: 'Mutation', teamMemberAdd: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null } | { __typename?: 'TeamMemberAddResult', teamMember: { __typename?: 'TeamMember', id: string, user: { __typename?: 'UserRef', id: string } } } | { __typename?: 'TeamMemberAlreadyExists', message?: string | null, user: { __typename?: 'UserRef', id: string } } | { __typename?: 'TeamUserNotFound', message?: string | null, userId: string } | { __typename?: 'WorkspaceNotFound', message?: string | null } };

export type WorkspacesPageSetAssignmentsMutationVariables = Exact<{
  input: TeamMemberSetLocationAssignmentsInput;
}>;


export type WorkspacesPageSetAssignmentsMutation = { __typename?: 'Mutation', teamMemberSetLocationAssignments: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null } | { __typename?: 'TeamLocationRoleTypeMismatch', message?: string | null, locationType: SupplierHierarchyType, roleLocationType: SupplierHierarchyType } | { __typename?: 'TeamLocationsNotFound', message?: string | null, locationIds: Array<string> } | { __typename?: 'TeamMemberNotFound', message?: string | null, user: { __typename?: 'UserRef', id: string } } | { __typename?: 'TeamMemberSetLocationAssignmentsResult', teamMember: { __typename?: 'TeamMember', id: string } } | { __typename?: 'TeamRolesNotFound', message?: string | null, roleIds: Array<string> } | { __typename?: 'WorkspaceNotFound', message?: string | null } };

export type WorkspacesPageRemoveAssignmentMutationVariables = Exact<{
  input: TeamMemberRemoveLocationAssignmentInput;
}>;


export type WorkspacesPageRemoveAssignmentMutation = { __typename?: 'Mutation', teamMemberRemoveLocationAssignment: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null } | { __typename?: 'TeamLocationNotFound', message?: string | null } | { __typename?: 'TeamMemberNotFound', message?: string | null } | { __typename?: 'TeamMemberRemoveLocationAssignmentResult', removedFromWorkspace: boolean } | { __typename?: 'TeamMemberWouldBeRemovedFromWorkspace', message?: string | null, user: { __typename?: 'UserRef', id: string } } | { __typename?: 'TeamRoleNotAssignedAtLocation', message?: string | null } | { __typename?: 'WorkspaceNotFound', message?: string | null, workspaceId: string } };

export type WorkspacesPageRevokeAllMutationVariables = Exact<{
  input: TeamMemberRevokeAllWorkspaceAccessInput;
}>;


export type WorkspacesPageRevokeAllMutation = { __typename?: 'Mutation', teamMemberRevokeAllWorkspaceAccess: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null } | { __typename?: 'TeamMemberNotFound', message?: string | null } | { __typename?: 'TeamMemberRevokeAllWorkspaceAccessResult', user: { __typename?: 'UserRef', id: string } } | { __typename?: 'WorkspaceNotFound', message?: string | null } };

export type WorkspacesPageDirectoryQueryVariables = Exact<{
  input: TeamDirectorySearchInput;
}>;


export type WorkspacesPageDirectoryQuery = { __typename?: 'Query', teamDirectorySearch: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null } | { __typename?: 'TeamDirectorySearchResult', cursor?: string | null, entries: Array<{ __typename?: 'TeamDirectoryEntry', user: { __typename?: 'UserRef', id: string, node?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, phone: string, profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null } | null } }>, totalCount: { __typename?: 'AtLeastCount', count: number } | { __typename?: 'ExactCount', count: number } } | { __typename?: 'WorkspaceNotFound', message?: string | null, workspaceId: string } };

export type WorkspacesPageAssignableRolesQueryVariables = Exact<{
  input: TeamAssignableLocationRolesListInput;
}>;


export type WorkspacesPageAssignableRolesQuery = { __typename?: 'Query', teamAssignableLocationRolesList: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null } | { __typename?: 'TeamAssignableLocationRolesListResult', assignableLocationRoles: Array<{ __typename?: 'TeamAssignableLocationRoles', location: { __typename?: 'SupplierRef', id: string, node?: { __typename?: 'Supplier', id: string, name: string, hierarchyType?: SupplierHierarchyType | null, parent?: { __typename?: 'SupplierRef', id: string, node?: { __typename?: 'Supplier', id: string, name: string } | null } | null } | null }, roles: Array<{ __typename?: 'TeamRole', id: string, displayName: string, description: string, locationType: SupplierHierarchyType }> }> } | { __typename?: 'WorkspaceNotFound', message?: string | null, workspaceId: string } };

export type WorkspacesPageSharedAssignmentsQueryVariables = Exact<{
  input: TeamMembersInSharedLocationsListInput;
}>;


export type WorkspacesPageSharedAssignmentsQuery = { __typename?: 'Query', teamMembersInSharedLocationsList: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null } | { __typename?: 'TeamMembersInSharedLocationsListResult', cursor?: string | null, teamMembers: Array<{ __typename?: 'TeamMemberInSharedLocations', user: { __typename?: 'UserRef', id: string, node?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, phone: string, profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null } | null }, assignedLocationRoles: Array<{ __typename?: 'TeamLocationAssignment', location: { __typename?: 'SupplierRef', id: string, node?: { __typename?: 'Supplier', id: string, name: string, hierarchyType?: SupplierHierarchyType | null, parent?: { __typename?: 'SupplierRef', id: string, node?: { __typename?: 'Supplier', id: string, name: string } | null } | null } | null }, teamRole: { __typename?: 'TeamRole', id: string, displayName: string, description: string, locationType: SupplierHierarchyType } }> }>, totalCount: { __typename?: 'AtLeastCount', count: number } | { __typename?: 'ExactCount', count: number } } | { __typename?: 'WorkspaceNotFound', message?: string | null, workspaceId: string } };

export type WorkspacesPageListQueryVariables = Exact<{
  input: WorkspaceListInput;
}>;


export type WorkspacesPageListQuery = { __typename?: 'Query', workspaceList: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure' } | { __typename?: 'WorkspaceListResult', workspaces: Array<{ __typename?: 'Workspace', id: string, name: string, roots: Array<{ __typename?: 'SupplierRef', id: string, node?: { __typename?: 'Supplier', id: string, name: string, hierarchyType?: SupplierHierarchyType | null } | null }> }> } };

export type WorkspacesPageMemberQueryVariables = Exact<{
  input: TeamMemberGetInput;
}>;


export type WorkspacesPageMemberQuery = { __typename?: 'Query', teamMemberGet: { __typename?: 'AuthorizationFailure', message?: string | null } | { __typename?: 'InputValidationFailure', message?: string | null } | { __typename?: 'TeamMemberGetResult', teamMember: { __typename?: 'TeamMember', id: string, user: { __typename?: 'UserRef', id: string, node?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, phone: string, profileImage?: { __typename?: 'ProfileImage', smallSquare?: string | null } | null } | null }, assignedLocationRoles: Array<{ __typename?: 'TeamLocationAssignment', location: { __typename?: 'SupplierRef', id: string, node?: { __typename?: 'Supplier', id: string, name: string, hierarchyType?: SupplierHierarchyType | null, parent?: { __typename?: 'SupplierRef', id: string, node?: { __typename?: 'Supplier', id: string, name: string } | null } | null } | null }, teamRole: { __typename?: 'TeamRole', id: string, displayName: string, description: string, locationType: SupplierHierarchyType } }> } } | { __typename?: 'TeamMemberNotFound', message?: string | null, user: { __typename?: 'UserRef', id: string } } | { __typename?: 'WorkspaceNotFound', message?: string | null, workspaceId: string } };

export type WorkspacesPageSearchSuppliersQueryVariables = Exact<{
  keywords?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WorkspacesPageSearchSuppliersQuery = { __typename?: 'Query', supplierSearch: { __typename?: 'AuthorizationFailure' } | { __typename?: 'InputValidationFailure' } | { __typename?: 'SearchSupplierConnection', edges: Array<{ __typename?: 'SupplierSearchEdge', node: { __typename?: 'Supplier', id: string, name: string, referenceId: string, hierarchyType?: SupplierHierarchyType | null } }> } };

export type WorkspacesPageSearchUsersQueryVariables = Exact<{
  query: UserSearchInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WorkspacesPageSearchUsersQuery = { __typename?: 'Query', userSearch: { __typename?: 'AuthorizationFailure' } | { __typename?: 'InputValidationFailure' } | { __typename?: 'UserSearchConnection', edges: Array<{ __typename?: 'UserSearchEdge', node: { __typename?: 'User', id: string, name?: string | null, email?: string | null, phone: string } }> } };

export const BuyerDetailsBaseFragmentFragmentDoc = gql`
    fragment BuyerDetailsBaseFragment on Buyer {
  id
  name
  referenceId
  fullAddress
  addressComment: deliveryComment
  addressSource
  googlePlaceId
  googlePlaceAddressId
  latitude
  longitude
  country
  city
  utcOffset
  isTest
  isPuppy
  displayName
  profileImage {
    uploadUrl
    url
  }
}
    `;
export const BuyerDetailsFragmentFragmentDoc = gql`
    fragment BuyerDetailsFragment on Buyer {
  ...BuyerDetailsBaseFragment
  rolesEnabled
  status
  createdContext
}
    ${BuyerDetailsBaseFragmentFragmentDoc}`;
export const BuyerSearchFragmentFragmentDoc = gql`
    fragment BuyerSearchFragment on Buyer {
  id
  name
  status
  referenceId
  displayName
  fullAddress
  city
  country
}
    `;
export const BuyerSearchItemFragmentFragmentDoc = gql`
    fragment BuyerSearchItemFragment on SearchItem {
  entity {
    ...BuyerSearchFragment
  }
}
    ${BuyerSearchFragmentFragmentDoc}`;
export const BuyersPageBuyerFragmentFragmentDoc = gql`
    fragment BuyersPageBuyerFragment on Buyer {
  id
  name
  status
  referenceId
  displayName
  fullAddress
  deliveryComment
  city
  country
  isTest
  isPuppy
  rolesEnabled
  profileImage {
    url
  }
  createdAt
}
    `;
export const BuyersPageBuyerDetailsFragmentFragmentDoc = gql`
    fragment BuyersPageBuyerDetailsFragment on Buyer {
  ...BuyersPageBuyerFragment
  addressSource
  addressLatitude: latitude
  addressLongitude: longitude
  addressUTCOffset: utcOffset
  addressGooglePlaceId: googlePlaceId
  addressGoogleAddressId: googlePlaceAddressId
  createdContext
}
    ${BuyersPageBuyerFragmentFragmentDoc}`;
export const CreateUserFragmentFragmentDoc = gql`
    fragment CreateUserFragment on User {
  id
  name
  email
  locale
  phone
  isTest
  orderPreference {
    pdf
    xlsx
    fax
    sms
    whatsApp
  }
}
    `;
export const UpdateJoinRequestSuccessFragmentFragmentDoc = gql`
    fragment UpdateJoinRequestSuccessFragment on UpdateJoinRequestSuccess {
  __typename
  id
  status
}
    `;
export const BuyerSearchChatFragmentFragmentDoc = gql`
    fragment BuyerSearchChatFragment on Chat {
  id
  chatName
  supplier {
    id
    name
    linkedSupplier {
      id
      name
    }
    profileImage {
      url
    }
  }
  isUserInChat(userId: $userId)
}
    `;
export const BuyerSearchChatItemFragmentFragmentDoc = gql`
    fragment BuyerSearchChatItemFragment on SearchItem {
  entity {
    ...BuyerSearchChatFragment
  }
}
    ${BuyerSearchChatFragmentFragmentDoc}`;
export const BuyerFacetFragmentFragmentDoc = gql`
    fragment BuyerFacetFragment on BuyerFacetsResponse {
  country
  cities {
    city
    utcOffsets
  }
}
    `;
export const BuyerUserFragmentFragmentDoc = gql`
    fragment BuyerUserFragment on User {
  id
  name
  phone
  profileImage {
    url
  }
}
    `;
export const BuyerUserEdgeFragmentFragmentDoc = gql`
    fragment BuyerUserEdgeFragment on BuyerUserEdge {
  node {
    ...BuyerUserFragment
  }
  role
}
    ${BuyerUserFragmentFragmentDoc}`;
export const BuyerUsersBuyerFragmentFragmentDoc = gql`
    fragment BuyerUsersBuyerFragment on Buyer {
  id
  rolesEnabled
  users(first: $first) {
    edges {
      ...BuyerUserEdgeFragment
    }
  }
}
    ${BuyerUserEdgeFragmentFragmentDoc}`;
export const UserRequestToJoinFragmentFragmentDoc = gql`
    fragment UserRequestToJoinFragment on UserRequestToJoin {
  id
  supplierEntityId
  status
  user {
    name
    email
    phone
    id
  }
}
    `;
export const RequestToJoinEdgeFragmentFragmentDoc = gql`
    fragment RequestToJoinEdgeFragment on UserRequestToJoinEdge {
  cursor
  node {
    ...UserRequestToJoinFragment
  }
}
    ${UserRequestToJoinFragmentFragmentDoc}`;
export const RequestsToJoinConnectionFragmentFragmentDoc = gql`
    fragment RequestsToJoinConnectionFragment on RequestsToJoinConnection {
  edges {
    ...RequestToJoinEdgeFragment
  }
}
    ${RequestToJoinEdgeFragmentFragmentDoc}`;
export const UserSearchUserFragmentFragmentDoc = gql`
    fragment UserSearchUserFragment on User {
  id
  name
  phone
  supplier
  linkedSupplier {
    id
  }
}
    `;
export const UserSearchEdgeFragmentFragmentDoc = gql`
    fragment UserSearchEdgeFragment on UserSearchEdge {
  node {
    ...UserSearchUserFragment
  }
}
    ${UserSearchUserFragmentFragmentDoc}`;
export const UserSearchConnectionFragmentFragmentDoc = gql`
    fragment UserSearchConnectionFragment on UserSearchConnection {
  total
  edges {
    ...UserSearchEdgeFragment
  }
}
    ${UserSearchEdgeFragmentFragmentDoc}`;
export const UserSearchInputValidationFailureFragmentDoc = gql`
    fragment UserSearchInputValidationFailure on InputValidationFailure {
  message
  responseType
}
    `;
export const UserSearchAuthorizationFailureFragmentDoc = gql`
    fragment UserSearchAuthorizationFailure on AuthorizationFailure {
  message
  responseType
}
    `;
export const DeliverySettingFragmentFragmentDoc = gql`
    fragment DeliverySettingFragment on SupplierDeliverySetting {
  id
  cutoffTimes {
    mon {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
      }
    }
    tue {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
      }
    }
    wed {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
      }
    }
    thu {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
      }
    }
    fri {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
      }
    }
    sat {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
      }
    }
    sun {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
      }
    }
  }
  cutoffType
}
    `;
export const SubCatalogForChatDataFragmentFragmentDoc = gql`
    fragment SubCatalogForChatDataFragment on SubCatalog {
  id
  name
}
    `;
export const SubCatalogsForChatFragmentFragmentDoc = gql`
    fragment SubCatalogsForChatFragment on GetSubCatalogsForChatResult {
  subCatalogs {
    ...SubCatalogForChatDataFragment
  }
}
    ${SubCatalogForChatDataFragmentFragmentDoc}`;
export const UpdateSubCatalogChatsResultFragmentFragmentDoc = gql`
    fragment UpdateSubCatalogChatsResultFragment on UpdateSubCatalogChatsResult {
  errors {
    subCatalogId
    reason
  }
}
    `;
export const HistoryUserFragmentFragmentDoc = gql`
    fragment HistoryUserFragment on User {
  name
  phone
}
    `;
export const HistoryProductFragmentFragmentDoc = gql`
    fragment HistoryProductFragment on Product {
  id
  unit
  name
}
    `;
export const HistoryOrderProductFragmentFragmentDoc = gql`
    fragment HistoryOrderProductFragment on OrderProduct {
  amount
  product {
    ...HistoryProductFragment
  }
}
    ${HistoryProductFragmentFragmentDoc}`;
export const HistoryOrderFragmentFragmentDoc = gql`
    fragment HistoryOrderFragment on Order {
  id
  createdAt
  body
  referenceId
  status
  orderSupplierStatus
  supplier {
    ...HistoryUserFragment
  }
  user {
    ...HistoryUserFragment
  }
  orderProducts {
    ...HistoryOrderProductFragment
  }
}
    ${HistoryUserFragmentFragmentDoc}
${HistoryOrderProductFragmentFragmentDoc}`;
export const HistoryMessageFragmentFragmentDoc = gql`
    fragment HistoryMessageFragment on Message {
  id
  body
  createdAt
  user {
    ...HistoryUserFragment
  }
  attachment {
    ... on Media {
      url
    }
  }
  chat {
    supplier {
      ...HistoryUserFragment
    }
  }
  order {
    ...HistoryOrderFragment
  }
}
    ${HistoryUserFragmentFragmentDoc}
${HistoryOrderFragmentFragmentDoc}`;
export const OrderPreferenceFragmentFragmentDoc = gql`
    fragment OrderPreferenceFragment on OrderPreference {
  whatsApp
  sms
  fax
}
    `;
export const ChatUserFragmentFragmentDoc = gql`
    fragment ChatUserFragment on User {
  id
  name
  phone
  botUser
  linkedSupplier {
    id
    hasEnabledCatalogProducts
  }
  supplier
  ... on User @include(if: $withAllUserFields) {
    email
    locale
    createdAt
    orderPreference {
      ...OrderPreferenceFragment
    }
  }
}
    ${OrderPreferenceFragmentFragmentDoc}`;
export const ChatUserEdgeFragmentFragmentDoc = gql`
    fragment ChatUserEdgeFragment on ChatUserEdge {
  node {
    ...ChatUserFragment
  }
}
    ${ChatUserFragmentFragmentDoc}`;
export const ChatUsersFragmentFragmentDoc = gql`
    fragment ChatUsersFragment on Chat {
  id
  users(first: $first) {
    edges {
      ...ChatUserEdgeFragment
    }
  }
}
    ${ChatUserEdgeFragmentFragmentDoc}`;
export const ChatSearchChatFragmentFragmentDoc = gql`
    fragment ChatSearchChatFragment on Chat {
  id
  chatName
  restaurantName
  deliveryAddress
  enabled
  type
  customerNumber
  buyer {
    id
    name
    referenceId
    fullAddress
  }
  supplier {
    id
    name
    phone
    botUser
    linkedSupplier {
      id
      referenceId
      name
    }
  }
  ...ChatUsersFragment
}
    ${ChatUsersFragmentFragmentDoc}`;
export const ChatSearchEntityFragmentFragmentDoc = gql`
    fragment ChatSearchEntityFragment on SearchItem {
  entity {
    ...ChatSearchChatFragment
  }
}
    ${ChatSearchChatFragmentFragmentDoc}`;
export const ChatCountByCcEmailReportFragmentFragmentDoc = gql`
    fragment ChatCountByCcEmailReportFragment on GetChatCountByCCEmailReport {
  numberOfChats
}
    `;
export const ChatIntegrationEmailOptionFragmentFragmentDoc = gql`
    fragment ChatIntegrationEmailOptionFragment on IntegrationEmailOption {
  complaintEmails
  orderEmails
  messageEmails
}
    `;
export const ChatSupplierUserFragmentFragmentDoc = gql`
    fragment ChatSupplierUserFragment on User {
  id
  name
  locale
  phone
  chocoUser
  supplier
  linkedSupplier {
    id
    customerNumberMandatory
    referenceId
    name
    hasEnabledCatalogProducts
    allowCustomProducts
    accessPackage
    integration {
      ...ChatIntegrationEmailOptionFragment
    }
  }
}
    ${ChatIntegrationEmailOptionFragmentFragmentDoc}`;
export const ChatDetailsFragmentFragmentDoc = gql`
    fragment ChatDetailsFragment on Chat {
  id
  chatName
  restaurantName
  deliveryAddress
  customerNumber
  additionalEmails
  enabled
  status
  type
  supplier {
    ...ChatSupplierUserFragment
  }
}
    ${ChatSupplierUserFragmentFragmentDoc}`;
export const ChatProductFragmentFragmentDoc = gql`
    fragment ChatProductFragment on Product {
  id
  unit
  name
  par
  price
  externalId
  supplierId
  buyerInventoryProduct(chatId: $chatId) {
    name
    price {
      currency
      amount
    }
  }
  supplierNegotiatedPrice(buyerId: $buyerId) {
    price {
      amount
      currency
    }
  }
}
    `;
export const ChatProductsFragmentFragmentDoc = gql`
    fragment ChatProductsFragment on Chat {
  products @include(if: $withProducts) {
    ...ChatProductFragment
  }
}
    ${ChatProductFragmentFragmentDoc}`;
export const CreatedContextFragmentFragmentDoc = gql`
    fragment CreatedContextFragment on CreatedBy {
  createdContext
}
    `;
export const CustomerDetailsChatSupplierFragmentDoc = gql`
    fragment CustomerDetailsChatSupplier on Supplier {
  id
  integration {
    ...ChatIntegrationEmailOptionFragment
  }
  appliedMinimumOrderValue {
    ... on MinimumOrderValue {
      type
      minimumOrderValue {
        price {
          amount
          currency
          decimalPlaces
        }
      }
      formattedMinimumOrderValue
    }
    ... on MinimumOrderValueFailure {
      message
      responseType
    }
    ... on AuthorizationFailure {
      message
      responseType
    }
    ... on InputValidationFailure {
      message
      responseType
    }
  }
}
    ${ChatIntegrationEmailOptionFragmentFragmentDoc}`;
export const ChatDataFragmentFragmentDoc = gql`
    fragment ChatDataFragment on Chat {
  ...ChatDetailsFragment
  ...ChatUsersFragment
  ...ChatProductsFragment
  createdBy {
    ...CreatedContextFragment
  }
  subCatalogId
  isPuppy
  buyer {
    id
    name
    referenceId
    fullAddress
  }
  supplierEntity {
    ...CustomerDetailsChatSupplier
  }
}
    ${ChatDetailsFragmentFragmentDoc}
${ChatUsersFragmentFragmentDoc}
${ChatProductsFragmentFragmentDoc}
${CreatedContextFragmentFragmentDoc}
${CustomerDetailsChatSupplierFragmentDoc}`;
export const BlockedEmailNodeFragmentFragmentDoc = gql`
    fragment BlockedEmailNodeFragment on BlockedEmail {
  id
  email
  reason
  createdAt
}
    `;
export const BlockedEmailEdgeFragmentFragmentDoc = gql`
    fragment BlockedEmailEdgeFragment on BlockedEmailEdge {
  cursor
  node {
    ...BlockedEmailNodeFragment
  }
}
    ${BlockedEmailNodeFragmentFragmentDoc}`;
export const BlockedEmailConnectionFragmentFragmentDoc = gql`
    fragment BlockedEmailConnectionFragment on BlockedEmailConnection {
  edges {
    ...BlockedEmailEdgeFragment
  }
}
    ${BlockedEmailEdgeFragmentFragmentDoc}`;
export const ProductFragmentFragmentDoc = gql`
    fragment ProductFragment on Product {
  id
  externalId
  unit
  name
}
    `;
export const OrderProductFragmentFragmentDoc = gql`
    fragment OrderProductFragment on OrderProduct {
  product {
    ...ProductFragment
  }
  amount
}
    ${ProductFragmentFragmentDoc}`;
export const OrderDetailsBaseFragmentFragmentDoc = gql`
    fragment OrderDetailsBaseFragment on Order {
  id
  referenceId
  createdAt
  deliveryDate
  user {
    id
    phone
    name
  }
  buyer {
    name
    displayName
    referenceId
    fullAddress
  }
  restaurant {
    restaurantName
  }
  supplier {
    phone
    name
  }
  orderProducts {
    ...OrderProductFragment
  }
  supplierRefId
  body
  isTest
  status
  orderSupplierStatus
  createdContext
}
    ${OrderProductFragmentFragmentDoc}`;
export const OrderDetailsFragmentFragmentDoc = gql`
    fragment OrderDetailsFragment on Order {
  ...OrderDetailsBaseFragment
  pdf(downloadable: true)
  chat {
    id
    deliveryAddress
  }
}
    ${OrderDetailsBaseFragmentFragmentDoc}`;
export const OrderDetailsSearchFragmentFragmentDoc = gql`
    fragment OrderDetailsSearchFragment on Order {
  ...OrderDetailsBaseFragment
}
    ${OrderDetailsBaseFragmentFragmentDoc}`;
export const SearchOrderEdgeFragmentFragmentDoc = gql`
    fragment SearchOrderEdgeFragment on SearchOrderEdge {
  cursor
  node {
    ...OrderDetailsSearchFragment
  }
}
    ${OrderDetailsSearchFragmentFragmentDoc}`;
export const PageInfoFragmentFragmentDoc = gql`
    fragment PageInfoFragment on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const SearchOrderConnectionFragmentFragmentDoc = gql`
    fragment SearchOrderConnectionFragment on SearchOrderConnection {
  total
  edges {
    ...SearchOrderEdgeFragment
  }
  pageInfo {
    ...PageInfoFragment
  }
}
    ${SearchOrderEdgeFragmentFragmentDoc}
${PageInfoFragmentFragmentDoc}`;
export const TransmissionEventsFragmentFragmentDoc = gql`
    fragment TransmissionEventsFragment on TransmissionEvent {
  id
  ofId
  ofIdType
  to
  toType
  newState
  isDeliveryEvent
  isFailureEvent
  timestamp
  metaData
}
    `;
export const TestOrderResponseFragmentFragmentDoc = gql`
    fragment TestOrderResponseFragment on TestOrderResponse {
  message
}
    `;
export const InputValidationFailureFragmentFragmentDoc = gql`
    fragment InputValidationFailureFragment on InputValidationFailure {
  message
  responseType
}
    `;
export const SsoPageEmailDomainFragmentFragmentDoc = gql`
    fragment SsoPageEmailDomainFragment on SsoEmailDomain {
  connectionId
  emailDomain
  exclusiveFederatedLogin
  createdAt
  updatedAt
}
    `;
export const SsoPageConnectionFragmentFragmentDoc = gql`
    fragment SsoPageConnectionFragment on SsoConnection {
  id
  name
  type
  emailDomains
  emailDomainDetails {
    ...SsoPageEmailDomainFragment
  }
  signOutEnabled
  attributeMappings {
    cognitoAttribute
    idpAttribute
  }
  createdAt
  updatedAt
}
    ${SsoPageEmailDomainFragmentFragmentDoc}`;
export const SsoPageConnectionUserFragmentFragmentDoc = gql`
    fragment SsoPageConnectionUserFragment on SsoConnectionUser {
  id
  chocoUserId
  email
  status
  enabled
  federatedRoles
  mappedFederatedRoles {
    federatedRole
    mapping {
      supplier {
        id
      }
      chocoSupplierRole
    }
  }
  mappedAttributes {
    idpAttribute
    cognitoAttribute
    value
  }
  createdAt
  lastModifiedAt
}
    `;
export const SsoPageRoleMappingFragmentFragmentDoc = gql`
    fragment SsoPageRoleMappingFragment on SsoRoleMapping {
  connectionId
  federatedRole
  supplier {
    id
    node {
      id
      name
      referenceId
    }
  }
  chocoSupplierRole
  createdAt
  updatedAt
}
    `;
export const SsoPageInvalidFieldsFragmentFragmentDoc = gql`
    fragment SsoPageInvalidFieldsFragment on InputValidationFailure {
  message
  invalidFields {
    fieldName
    reason
  }
}
    `;
export const SuppliersPageVendorCatalogUnitFragmentDoc = gql`
    fragment SuppliersPageVendorCatalogUnit on VendorItemUnit {
  id
  name
  itemNameOverride
  vendorItem {
    node {
      name
    }
  }
  productCode
  isOrdering
  stockStatus
  images {
    id
    asset {
      url(width: 96, height: 96) {
        url
      }
    }
  }
  price {
    displayCatalogPrice {
      amount
      currency
      decimalPlaces
    }
    displayPrice {
      amount
      currency
      decimalPlaces
    }
  }
}
    `;
export const SuppliersPageVendorCatalogResponseFragmentDoc = gql`
    fragment SuppliersPageVendorCatalogResponse on VendorItemsForVendorResponse {
  __typename
  ... on VendorItemsForVendorResult {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        ...SuppliersPageVendorCatalogUnit
      }
    }
  }
  ... on InputValidationFailure {
    message
  }
  ... on AuthorizationFailure {
    message
  }
}
    ${SuppliersPageVendorCatalogUnitFragmentDoc}`;
export const SuppliersPageVendorCatalogUnitDetailFragmentDoc = gql`
    fragment SuppliersPageVendorCatalogUnitDetail on VendorItemUnit {
  id
  name
  itemNameOverride
  itemDescriptionOverride
  productCode
  code
  legacyId
  packagingDescription
  stockStatus
  isOrdering
  isHiddenByDefault
  vendorItem {
    node {
      name
      description
      brand
      originCountryCode
      categories {
        id
        name
      }
    }
  }
  baseUnit {
    id
    name
  }
  factor {
    numerator
    denominator
  }
  images {
    id
    asset {
      url(width: 400, height: 400) {
        url
      }
    }
  }
  price {
    displayCatalogPrice {
      amount
      currency
      decimalPlaces
    }
    displayBasePrice {
      amount
      currency
      decimalPlaces
    }
    displayPrice {
      amount
      currency
      decimalPlaces
    }
  }
  orderingProperties {
    leadTimeDays
    cutOffTime
  }
}
    `;
export const SuppliersPageVendorCatalogUnitDetailResponseFragmentDoc = gql`
    fragment SuppliersPageVendorCatalogUnitDetailResponse on VendorItemUnitsResponse {
  __typename
  ... on VendorItemUnitsResult {
    itemUnits {
      ...SuppliersPageVendorCatalogUnitDetail
    }
  }
  ... on InputValidationFailure {
    message
  }
  ... on AuthorizationFailure {
    message
  }
}
    ${SuppliersPageVendorCatalogUnitDetailFragmentDoc}`;
export const SuppliersPageVendorPromotionTierFragmentDoc = gql`
    fragment SuppliersPageVendorPromotionTier on VendorPromotionTier {
  id
  name
  maxApplications
  conditions {
    metric
    minimumQuantity {
      amount
    }
    maximumQuantity {
      amount
    }
    minimumAmount {
      amount
      currency
      decimalPlaces
    }
    maximumAmount {
      amount
      currency
      decimalPlaces
    }
  }
  offers {
    __typename
    type
    ... on VendorPromotionFixedPriceOffer {
      price {
        amount
        currency
        decimalPlaces
      }
    }
    ... on VendorPromotionReducedPriceOffer {
      priceReduction {
        amount
        currency
        decimalPlaces
      }
    }
    ... on VendorPromotionCartReducedPriceOffer {
      priceReduction {
        amount
        currency
        decimalPlaces
      }
    }
    ... on VendorPromotionDiscountPercentageOffer {
      discountPercentage {
        amount
      }
    }
    ... on VendorPromotionCartDiscountPercentageOffer {
      discountPercentage {
        amount
      }
    }
    ... on VendorPromotionCartFreeExtraUnitsOffer {
      quantityOffered {
        amount
      }
    }
    ... on VendorPromotionFreeUnitsIncludedOffer {
      quantityOffered {
        amount
      }
    }
  }
}
    `;
export const SuppliersPageVendorPromotionRecordFragmentDoc = gql`
    fragment SuppliersPageVendorPromotionRecord on VendorPromotionRecord {
  id
  code
  isActive
  status
  priorityWeight
  isAppliedToAllChats
  categoryCode
  chats {
    id
  }
  translations {
    locale
    name
    description
    shortDescription
    displayName
    displayDescription
  }
  promotion {
    id
    name
    shortDescription
    description
    beginAt
    endAt
    tierMode
    tiers {
      ...SuppliersPageVendorPromotionTier
    }
  }
}
    ${SuppliersPageVendorPromotionTierFragmentDoc}`;
export const SuppliersPageChatTaxProfileFragmentDoc = gql`
    fragment SuppliersPageChatTaxProfile on ChatTaxProfile {
  id
  updatedAt
  chat {
    id
    node {
      id
      supplierCustomerName
      restaurantName
      chatName
      customerNumber
    }
  }
  jurisdiction {
    id
    node {
      id
      code
      countryCode
      subdivisionCode
      rates {
        id
      }
    }
  }
}
    `;
export const SuppliersPageTaxJurisdictionFragmentDoc = gql`
    fragment SuppliersPageTaxJurisdiction on TaxJurisdiction {
  id
  code
  countryCode
  subdivisionCode
  rates {
    id
    code
    category
    label
    taxBehavior
    appliesToFreeProducts
    priority
    validFrom
    validTo
    rateValue {
      __typename
      ... on PercentageTaxRate {
        percentage {
          amount
        }
      }
      ... on FixedAmountTaxRate {
        fixedAmount {
          amount
          currency
          decimalPlaces
        }
      }
    }
  }
}
    `;
export const IntegrationEmailOptionFragmentFragmentDoc = gql`
    fragment IntegrationEmailOptionFragment on IntegrationEmailOption {
  type
  emailAddress
  xlsx
  pdf
  complaintEmails
  orderEmails
  messageEmails
  __typename
}
    `;
export const IntegrationWhatsAppOptionFragmentFragmentDoc = gql`
    fragment IntegrationWhatsAppOptionFragment on IntegrationWhatsAppOption {
  type
  phone
  __typename
}
    `;
export const IntegrationSmsOptionFragmentFragmentDoc = gql`
    fragment IntegrationSmsOptionFragment on IntegrationSmsOption {
  type
  phone
  __typename
}
    `;
export const IntegrationFaxOptionFragmentFragmentDoc = gql`
    fragment IntegrationFaxOptionFragment on IntegrationFaxOption {
  type
  phone
  __typename
}
    `;
export const SupplierDetailsFragmentFragmentDoc = gql`
    fragment SupplierDetailsFragment on Supplier {
  id
  referenceId
  sortCartBy
  name
  description
  primaryAssortment
  secondaryAssortments
  contactEmails
  deliveryZones {
    name
    points {
      latitude
      longitude
      __typename
    }
    __typename
  }
  coverPhoto {
    url
    uploadUrl
    smallRectangle
    mediumRectangle
    largeRectangle
    __typename
  }
  locale
  isPuppy
  isTest
  isDiscoverable
  isIntegrated
  deliveryCosts
  minOrderAmount
  allowCustomProducts
  allowCustomerAcquisition
  allowOnlyOneActiveVariant
  allowBuyerComment
  allowInvoiceOrderGuidePhotoUpload
  enablePromotions
  enableTaxes
  pricingDateSource
  calculationPrecision
  deliveryDateMandatory
  customerNumberMandatory
  timezone
  hasEnabledCatalogProducts
  hasEnabledFractionalUnits
  hasValidCatalogProducts
  noDefaultCatalog
  defaultSubCatalog
  accessPackage
  disableCustomerNumberEdits
  allowOrderedProductMerging
  enableEcommerceProductGridView
  allowEcommercePoNumber
  priceSetting {
    displayInMarketplace
    displayToCustomers
    __typename
  }
  integration {
    ...IntegrationEmailOptionFragment
    ...IntegrationWhatsAppOptionFragment
    ...IntegrationSmsOptionFragment
    ...IntegrationFaxOptionFragment
    __typename
  }
  botUser {
    id
    profileImage {
      uploadUrl
      smallSquare
      mediumSquare
      largeSquare
      __typename
    }
    __typename
  }
  minOrder {
    price {
      currency
      amount
      __typename
    }
    strict
    __typename
  }
  hideMyPrice
  buyerVisibleStockStatuses
  __typename
}
    ${IntegrationEmailOptionFragmentFragmentDoc}
${IntegrationWhatsAppOptionFragmentFragmentDoc}
${IntegrationSmsOptionFragmentFragmentDoc}
${IntegrationFaxOptionFragmentFragmentDoc}`;
export const SearchSupplierEdgeFragmentFragmentDoc = gql`
    fragment SearchSupplierEdgeFragment on SupplierSearchEdge {
  node {
    ...SupplierDetailsFragment
    __typename
  }
  __typename
}
    ${SupplierDetailsFragmentFragmentDoc}`;
export const SupplierPageInfoFragmentFragmentDoc = gql`
    fragment SupplierPageInfoFragment on PageInfo {
  endCursor
  hasNextPage
  hasPreviousPage
  startCursor
  __typename
}
    `;
export const SearchSupplierConnectionFragmentFragmentDoc = gql`
    fragment SearchSupplierConnectionFragment on SearchSupplierConnection {
  total
  edges {
    ...SearchSupplierEdgeFragment
    __typename
  }
  pageInfo {
    ...SupplierPageInfoFragment
    __typename
  }
  __typename
}
    ${SearchSupplierEdgeFragmentFragmentDoc}
${SupplierPageInfoFragmentFragmentDoc}`;
export const SuppliersPageJoinRequestFragmentFragmentDoc = gql`
    fragment SuppliersPageJoinRequestFragment on UserRequestToJoin {
  id
  status
  user {
    id
    name
    email
    phone
  }
}
    `;
export const SupplierDeliverySettingFragmentFragmentDoc = gql`
    fragment SupplierDeliverySettingFragment on SupplierDeliverySetting {
  id
  deliveryDays
  cutOffTime {
    time
    type
    __typename
  }
  cutoffType
  cutoffTimes {
    mon {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
        __typename
      }
      __typename
    }
    tue {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
        __typename
      }
      __typename
    }
    wed {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
        __typename
      }
      __typename
    }
    thu {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
        __typename
      }
      __typename
    }
    fri {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
        __typename
      }
      __typename
    }
    sat {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
        __typename
      }
      __typename
    }
    sun {
      ... on WithCutoffSetting {
        leadTime
        cutoffTime
        __typename
      }
      __typename
    }
    __typename
  }
  __typename
}
    `;
export const UsersPageUserSearchFragmentFragmentDoc = gql`
    fragment UsersPageUserSearchFragment on User {
  id
  name
  pending
  hasRequestedToBeDeleted
  email
  locale
  loginMethod
  phone
  createdAt
  supplier
  linkedSupplier {
    id
    name
  }
  isPuppy
  orderPreference {
    pdf
    xlsx
    sms
    whatsApp
    fax
    welcomeNotificationSent
  }
  buyers(first: 30) {
    edges {
      node {
        id
        name
        referenceId
        fullAddress
        rolesEnabled
      }
      role
    }
  }
}
    `;
export const UsersPageUserSearchEdgeFragmentFragmentDoc = gql`
    fragment UsersPageUserSearchEdgeFragment on UserSearchEdge {
  cursor
  node {
    ...UsersPageUserSearchFragment
  }
}
    ${UsersPageUserSearchFragmentFragmentDoc}`;
export const UsersPageUserSearchConnectionFragmentFragmentDoc = gql`
    fragment UsersPageUserSearchConnectionFragment on UserSearchConnection {
  total
  pageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
  edges {
    ...UsersPageUserSearchEdgeFragment
  }
}
    ${UsersPageUserSearchEdgeFragmentFragmentDoc}`;
export const UsersPageUserDetailsFragmentFragmentDoc = gql`
    fragment UsersPageUserDetailsFragment on User {
  id
  name
  email
  loginEmail
  challengeByEmail
  locale
  loginMethod
  createdContext
  phone
  createdAt
  pending
  hasRequestedToBeDeleted
  supplier
  isTest
  chocoUser
  role
  profileImage {
    url
    uploadUrl
    mediumSquare
  }
  linkedSupplier {
    id
    name
    referenceId
  }
  orderPreference {
    pdf
    xlsx
    sms
    whatsApp
    fax
    welcomeNotificationSent
  }
  buyers(first: 30) {
    edges {
      node {
        id
        name
        referenceId
        fullAddress
        rolesEnabled
      }
      role
    }
  }
}
    `;
export const UsersPageCreateUserFragmentFragmentDoc = gql`
    fragment UsersPageCreateUserFragment on User {
  ...UsersPageUserDetailsFragment
  profileImage {
    uploadUrl
    mediumSquare
  }
  isTest
}
    ${UsersPageUserDetailsFragmentFragmentDoc}`;
export const UserDetailsFragmentFragmentDoc = gql`
    fragment UserDetailsFragment on User {
  id
  name
  pending
  locale
  phone
  phoneNumberType
  image
  loginEmail
  email
  supplier
  chocoUser
  createdAt
  supplierId
  challengeByEmail
  loginMethod
  role @include(if: $withRoles)
  orderPreference {
    pdf
    xlsx
    sms
    whatsApp
    __typename
  }
  linkedSupplier {
    id
    name
    referenceId
    __typename
  }
  __typename
}
    `;
export const SupplierRemoveUserDetailsFragmentFragmentDoc = gql`
    fragment SupplierRemoveUserDetailsFragment on User {
  id
  name
  pending
  locale
  phone
  phoneNumberType
  image
  loginEmail
  email
  supplier
  chocoUser
  createdAt
  supplierId
  challengeByEmail
  loginMethod
  role @include(if: $withRoles)
  linkedSupplier {
    id
    name
    referenceId
    __typename
  }
  __typename
}
    `;
export const BuyerChatUserFragmentFragmentDoc = gql`
    fragment BuyerChatUserFragment on User {
  id
  name
  linkedSupplier {
    id
    name
  }
}
    `;
export const BuyerEntityChatFragmentFragmentDoc = gql`
    fragment BuyerEntityChatFragment on Chat {
  id
  chatName
  supplier {
    ...BuyerChatUserFragment
  }
  isUserInChat(userId: $userId)
}
    ${BuyerChatUserFragmentFragmentDoc}`;
export const CognitoUserFragmentFragmentDoc = gql`
    fragment CognitoUserFragment on CognitoStateUser {
  attributes {
    name
    value
  }
  groups
  status
}
    `;
export const CognitoStateFragmentFragmentDoc = gql`
    fragment CognitoStateFragment on UserCognitoState {
  __typename
  status
  cognitoUsers {
    email {
      ...CognitoUserFragment
    }
    phone {
      ...CognitoUserFragment
    }
  }
}
    ${CognitoUserFragmentFragmentDoc}`;
export const UsersPageBuyerEntityFragmentFragmentDoc = gql`
    fragment UsersPageBuyerEntityFragment on Buyer {
  id
  name
  referenceId
  rolesEnabled
  fullAddress
}
    `;
export const UsersPageSearchSupplierFragmentFragmentDoc = gql`
    fragment UsersPageSearchSupplierFragment on Supplier {
  id
  name
  __typename
}
    `;
export const UsersPageSupplierSearchEdgeFragmentFragmentDoc = gql`
    fragment UsersPageSupplierSearchEdgeFragment on SupplierSearchEdge {
  cursor
  node {
    ...UsersPageSearchSupplierFragment
    __typename
  }
  __typename
}
    ${UsersPageSearchSupplierFragmentFragmentDoc}`;
export const UsersPageSearchSupplierConnectionFragmentFragmentDoc = gql`
    fragment UsersPageSearchSupplierConnectionFragment on SearchSupplierConnection {
  edges {
    ...UsersPageSupplierSearchEdgeFragment
    __typename
  }
  __typename
}
    ${UsersPageSupplierSearchEdgeFragmentFragmentDoc}`;
export const HeaderSupportCodeDocument = gql`
    query HeaderSupportCode {
  supportCodeGet {
    ... on SupportCode {
      code
      expiresAt
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;

/**
 * __useHeaderSupportCodeQuery__
 *
 * To run a query within a React component, call `useHeaderSupportCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderSupportCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderSupportCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useHeaderSupportCodeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HeaderSupportCodeQuery, HeaderSupportCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HeaderSupportCodeQuery, HeaderSupportCodeQueryVariables>(HeaderSupportCodeDocument, options);
      }
export function useHeaderSupportCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HeaderSupportCodeQuery, HeaderSupportCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HeaderSupportCodeQuery, HeaderSupportCodeQueryVariables>(HeaderSupportCodeDocument, options);
        }
// @ts-ignore
export function useHeaderSupportCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HeaderSupportCodeQuery, HeaderSupportCodeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HeaderSupportCodeQuery, HeaderSupportCodeQueryVariables>;
export function useHeaderSupportCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HeaderSupportCodeQuery, HeaderSupportCodeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HeaderSupportCodeQuery | undefined, HeaderSupportCodeQueryVariables>;
export function useHeaderSupportCodeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HeaderSupportCodeQuery, HeaderSupportCodeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HeaderSupportCodeQuery, HeaderSupportCodeQueryVariables>(HeaderSupportCodeDocument, options);
        }
export type HeaderSupportCodeQueryHookResult = ReturnType<typeof useHeaderSupportCodeQuery>;
export type HeaderSupportCodeLazyQueryHookResult = ReturnType<typeof useHeaderSupportCodeLazyQuery>;
export type HeaderSupportCodeSuspenseQueryHookResult = ReturnType<typeof useHeaderSupportCodeSuspenseQuery>;
export type HeaderSupportCodeQueryResult = ApolloReactCommon.QueryResult<HeaderSupportCodeQuery, HeaderSupportCodeQueryVariables>;
export const AddUserToChatsMutationDocument = gql`
    mutation AddUserToChatsMutation($userId: ID!, $chatIds: [ID!]!) {
  addUserToChats(userId: $userId, chatIds: $chatIds)
}
    `;
export type AddUserToChatsMutationMutationFn = ApolloReactCommon.MutationFunction<AddUserToChatsMutationMutation, AddUserToChatsMutationMutationVariables>;

/**
 * __useAddUserToChatsMutationMutation__
 *
 * To run a mutation, you first call `useAddUserToChatsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToChatsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToChatsMutationMutation, { data, loading, error }] = useAddUserToChatsMutationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      chatIds: // value for 'chatIds'
 *   },
 * });
 */
export function useAddUserToChatsMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserToChatsMutationMutation, AddUserToChatsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUserToChatsMutationMutation, AddUserToChatsMutationMutationVariables>(AddUserToChatsMutationDocument, options);
      }
export type AddUserToChatsMutationMutationHookResult = ReturnType<typeof useAddUserToChatsMutationMutation>;
export type AddUserToChatsMutationMutationResult = ApolloReactCommon.MutationResult<AddUserToChatsMutationMutation>;
export type AddUserToChatsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<AddUserToChatsMutationMutation, AddUserToChatsMutationMutationVariables>;
export const BuyerAddUserMutationDocument = gql`
    mutation BuyerAddUserMutation($buyerId: ID!, $userId: ID!, $buyerUserInput: BuyerUserInput) {
  buyerAddUser(buyerId: $buyerId, userId: $userId, input: $buyerUserInput) {
    buyerId
    userId
    role
  }
}
    `;
export type BuyerAddUserMutationMutationFn = ApolloReactCommon.MutationFunction<BuyerAddUserMutationMutation, BuyerAddUserMutationMutationVariables>;

/**
 * __useBuyerAddUserMutationMutation__
 *
 * To run a mutation, you first call `useBuyerAddUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerAddUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerAddUserMutationMutation, { data, loading, error }] = useBuyerAddUserMutationMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      userId: // value for 'userId'
 *      buyerUserInput: // value for 'buyerUserInput'
 *   },
 * });
 */
export function useBuyerAddUserMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BuyerAddUserMutationMutation, BuyerAddUserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BuyerAddUserMutationMutation, BuyerAddUserMutationMutationVariables>(BuyerAddUserMutationDocument, options);
      }
export type BuyerAddUserMutationMutationHookResult = ReturnType<typeof useBuyerAddUserMutationMutation>;
export type BuyerAddUserMutationMutationResult = ApolloReactCommon.MutationResult<BuyerAddUserMutationMutation>;
export type BuyerAddUserMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<BuyerAddUserMutationMutation, BuyerAddUserMutationMutationVariables>;
export const BuyerDisableRolesMutationDocument = gql`
    mutation BuyerDisableRolesMutation($buyerId: ID!) {
  buyerDisableRoles(buyerId: $buyerId) {
    ... on Buyer {
      id
      rolesEnabled
    }
    ... on NotFoundError {
      responseType
      message
    }
  }
}
    `;
export type BuyerDisableRolesMutationMutationFn = ApolloReactCommon.MutationFunction<BuyerDisableRolesMutationMutation, BuyerDisableRolesMutationMutationVariables>;

/**
 * __useBuyerDisableRolesMutationMutation__
 *
 * To run a mutation, you first call `useBuyerDisableRolesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerDisableRolesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerDisableRolesMutationMutation, { data, loading, error }] = useBuyerDisableRolesMutationMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *   },
 * });
 */
export function useBuyerDisableRolesMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BuyerDisableRolesMutationMutation, BuyerDisableRolesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BuyerDisableRolesMutationMutation, BuyerDisableRolesMutationMutationVariables>(BuyerDisableRolesMutationDocument, options);
      }
export type BuyerDisableRolesMutationMutationHookResult = ReturnType<typeof useBuyerDisableRolesMutationMutation>;
export type BuyerDisableRolesMutationMutationResult = ApolloReactCommon.MutationResult<BuyerDisableRolesMutationMutation>;
export type BuyerDisableRolesMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<BuyerDisableRolesMutationMutation, BuyerDisableRolesMutationMutationVariables>;
export const BuyerRemoveUserMutationDocument = gql`
    mutation BuyerRemoveUserMutation($buyerId: ID!, $userId: ID!) {
  buyerRemoveUser(buyerId: $buyerId, userId: $userId) {
    buyerId
    userId
    buyer {
      rolesEnabled
    }
  }
}
    `;
export type BuyerRemoveUserMutationMutationFn = ApolloReactCommon.MutationFunction<BuyerRemoveUserMutationMutation, BuyerRemoveUserMutationMutationVariables>;

/**
 * __useBuyerRemoveUserMutationMutation__
 *
 * To run a mutation, you first call `useBuyerRemoveUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyerRemoveUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyerRemoveUserMutationMutation, { data, loading, error }] = useBuyerRemoveUserMutationMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBuyerRemoveUserMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BuyerRemoveUserMutationMutation, BuyerRemoveUserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BuyerRemoveUserMutationMutation, BuyerRemoveUserMutationMutationVariables>(BuyerRemoveUserMutationDocument, options);
      }
export type BuyerRemoveUserMutationMutationHookResult = ReturnType<typeof useBuyerRemoveUserMutationMutation>;
export type BuyerRemoveUserMutationMutationResult = ApolloReactCommon.MutationResult<BuyerRemoveUserMutationMutation>;
export type BuyerRemoveUserMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<BuyerRemoveUserMutationMutation, BuyerRemoveUserMutationMutationVariables>;
export const BuyersPageCreateBuyerDocument = gql`
    mutation BuyersPageCreateBuyer($buyerInput: BuyerCreateInput!) {
  buyerCreate(buyer: $buyerInput) {
    ...BuyersPageBuyerDetailsFragment
  }
}
    ${BuyersPageBuyerDetailsFragmentFragmentDoc}`;
export type BuyersPageCreateBuyerMutationFn = ApolloReactCommon.MutationFunction<BuyersPageCreateBuyerMutation, BuyersPageCreateBuyerMutationVariables>;

/**
 * __useBuyersPageCreateBuyerMutation__
 *
 * To run a mutation, you first call `useBuyersPageCreateBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyersPageCreateBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyersPageCreateBuyerMutation, { data, loading, error }] = useBuyersPageCreateBuyerMutation({
 *   variables: {
 *      buyerInput: // value for 'buyerInput'
 *   },
 * });
 */
export function useBuyersPageCreateBuyerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BuyersPageCreateBuyerMutation, BuyersPageCreateBuyerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BuyersPageCreateBuyerMutation, BuyersPageCreateBuyerMutationVariables>(BuyersPageCreateBuyerDocument, options);
      }
export type BuyersPageCreateBuyerMutationHookResult = ReturnType<typeof useBuyersPageCreateBuyerMutation>;
export type BuyersPageCreateBuyerMutationResult = ApolloReactCommon.MutationResult<BuyersPageCreateBuyerMutation>;
export type BuyersPageCreateBuyerMutationOptions = ApolloReactCommon.BaseMutationOptions<BuyersPageCreateBuyerMutation, BuyersPageCreateBuyerMutationVariables>;
export const BuyersPageUpdateBuyerDocument = gql`
    mutation BuyersPageUpdateBuyer($buyerId: ID!, $buyerInput: BuyerUpdateInput!) {
  buyerUpdate(id: $buyerId, buyer: $buyerInput) {
    ...BuyersPageBuyerDetailsFragment
  }
}
    ${BuyersPageBuyerDetailsFragmentFragmentDoc}`;
export type BuyersPageUpdateBuyerMutationFn = ApolloReactCommon.MutationFunction<BuyersPageUpdateBuyerMutation, BuyersPageUpdateBuyerMutationVariables>;

/**
 * __useBuyersPageUpdateBuyerMutation__
 *
 * To run a mutation, you first call `useBuyersPageUpdateBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuyersPageUpdateBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buyersPageUpdateBuyerMutation, { data, loading, error }] = useBuyersPageUpdateBuyerMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      buyerInput: // value for 'buyerInput'
 *   },
 * });
 */
export function useBuyersPageUpdateBuyerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BuyersPageUpdateBuyerMutation, BuyersPageUpdateBuyerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BuyersPageUpdateBuyerMutation, BuyersPageUpdateBuyerMutationVariables>(BuyersPageUpdateBuyerDocument, options);
      }
export type BuyersPageUpdateBuyerMutationHookResult = ReturnType<typeof useBuyersPageUpdateBuyerMutation>;
export type BuyersPageUpdateBuyerMutationResult = ApolloReactCommon.MutationResult<BuyersPageUpdateBuyerMutation>;
export type BuyersPageUpdateBuyerMutationOptions = ApolloReactCommon.BaseMutationOptions<BuyersPageUpdateBuyerMutation, BuyersPageUpdateBuyerMutationVariables>;
export const CreateBuyerMutationDocument = gql`
    mutation CreateBuyerMutation($buyerCreateInput: BuyerCreateInput!) {
  buyerCreate(buyer: $buyerCreateInput) {
    ...BuyerDetailsBaseFragment
  }
}
    ${BuyerDetailsBaseFragmentFragmentDoc}`;
export type CreateBuyerMutationMutationFn = ApolloReactCommon.MutationFunction<CreateBuyerMutationMutation, CreateBuyerMutationMutationVariables>;

/**
 * __useCreateBuyerMutationMutation__
 *
 * To run a mutation, you first call `useCreateBuyerMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBuyerMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBuyerMutationMutation, { data, loading, error }] = useCreateBuyerMutationMutation({
 *   variables: {
 *      buyerCreateInput: // value for 'buyerCreateInput'
 *   },
 * });
 */
export function useCreateBuyerMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBuyerMutationMutation, CreateBuyerMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBuyerMutationMutation, CreateBuyerMutationMutationVariables>(CreateBuyerMutationDocument, options);
      }
export type CreateBuyerMutationMutationHookResult = ReturnType<typeof useCreateBuyerMutationMutation>;
export type CreateBuyerMutationMutationResult = ApolloReactCommon.MutationResult<CreateBuyerMutationMutation>;
export type CreateBuyerMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBuyerMutationMutation, CreateBuyerMutationMutationVariables>;
export const CreateUserMutationDocument = gql`
    mutation CreateUserMutation($userInput: UserCreateInput!) {
  userCreate(user: $userInput) {
    ...CreateUserFragment
  }
}
    ${CreateUserFragmentFragmentDoc}`;
export type CreateUserMutationMutationFn = ApolloReactCommon.MutationFunction<CreateUserMutationMutation, CreateUserMutationMutationVariables>;

/**
 * __useCreateUserMutationMutation__
 *
 * To run a mutation, you first call `useCreateUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutationMutation, { data, loading, error }] = useCreateUserMutationMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useCreateUserMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserMutationMutation, CreateUserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserMutationMutation, CreateUserMutationMutationVariables>(CreateUserMutationDocument, options);
      }
export type CreateUserMutationMutationHookResult = ReturnType<typeof useCreateUserMutationMutation>;
export type CreateUserMutationMutationResult = ApolloReactCommon.MutationResult<CreateUserMutationMutation>;
export type CreateUserMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserMutationMutation, CreateUserMutationMutationVariables>;
export const RemoveUserFromChatsMutationDocument = gql`
    mutation RemoveUserFromChatsMutation($userId: ID!, $chatIds: [ID!]!) {
  removeUserFromChats(userId: $userId, chatIds: $chatIds)
}
    `;
export type RemoveUserFromChatsMutationMutationFn = ApolloReactCommon.MutationFunction<RemoveUserFromChatsMutationMutation, RemoveUserFromChatsMutationMutationVariables>;

/**
 * __useRemoveUserFromChatsMutationMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromChatsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromChatsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromChatsMutationMutation, { data, loading, error }] = useRemoveUserFromChatsMutationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      chatIds: // value for 'chatIds'
 *   },
 * });
 */
export function useRemoveUserFromChatsMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserFromChatsMutationMutation, RemoveUserFromChatsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserFromChatsMutationMutation, RemoveUserFromChatsMutationMutationVariables>(RemoveUserFromChatsMutationDocument, options);
      }
export type RemoveUserFromChatsMutationMutationHookResult = ReturnType<typeof useRemoveUserFromChatsMutationMutation>;
export type RemoveUserFromChatsMutationMutationResult = ApolloReactCommon.MutationResult<RemoveUserFromChatsMutationMutation>;
export type RemoveUserFromChatsMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUserFromChatsMutationMutation, RemoveUserFromChatsMutationMutationVariables>;
export const EditBuyerMutationDocument = gql`
    mutation EditBuyerMutation($id: ID!, $buyerUpdateInput: BuyerUpdateInput!) {
  buyerUpdate(id: $id, buyer: $buyerUpdateInput) {
    ...BuyerDetailsBaseFragment
  }
}
    ${BuyerDetailsBaseFragmentFragmentDoc}`;
export type EditBuyerMutationMutationFn = ApolloReactCommon.MutationFunction<EditBuyerMutationMutation, EditBuyerMutationMutationVariables>;

/**
 * __useEditBuyerMutationMutation__
 *
 * To run a mutation, you first call `useEditBuyerMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBuyerMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBuyerMutationMutation, { data, loading, error }] = useEditBuyerMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      buyerUpdateInput: // value for 'buyerUpdateInput'
 *   },
 * });
 */
export function useEditBuyerMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditBuyerMutationMutation, EditBuyerMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditBuyerMutationMutation, EditBuyerMutationMutationVariables>(EditBuyerMutationDocument, options);
      }
export type EditBuyerMutationMutationHookResult = ReturnType<typeof useEditBuyerMutationMutation>;
export type EditBuyerMutationMutationResult = ApolloReactCommon.MutationResult<EditBuyerMutationMutation>;
export type EditBuyerMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<EditBuyerMutationMutation, EditBuyerMutationMutationVariables>;
export const UpdateRequestToJoinMutationDocument = gql`
    mutation UpdateRequestToJoinMutation($input: UpdateJoinRequestInput!) {
  updateRequestToJoin(input: $input) {
    ...UpdateJoinRequestSuccessFragment
    ... on AuthorizationFailure {
      message
    }
    ... on InputValidationFailure {
      message
    }
    ... on UpdateJoinRequestError {
      message
    }
  }
}
    ${UpdateJoinRequestSuccessFragmentFragmentDoc}`;
export type UpdateRequestToJoinMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateRequestToJoinMutationMutation, UpdateRequestToJoinMutationMutationVariables>;

/**
 * __useUpdateRequestToJoinMutationMutation__
 *
 * To run a mutation, you first call `useUpdateRequestToJoinMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRequestToJoinMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRequestToJoinMutationMutation, { data, loading, error }] = useUpdateRequestToJoinMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRequestToJoinMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRequestToJoinMutationMutation, UpdateRequestToJoinMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRequestToJoinMutationMutation, UpdateRequestToJoinMutationMutationVariables>(UpdateRequestToJoinMutationDocument, options);
      }
export type UpdateRequestToJoinMutationMutationHookResult = ReturnType<typeof useUpdateRequestToJoinMutationMutation>;
export type UpdateRequestToJoinMutationMutationResult = ApolloReactCommon.MutationResult<UpdateRequestToJoinMutationMutation>;
export type UpdateRequestToJoinMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRequestToJoinMutationMutation, UpdateRequestToJoinMutationMutationVariables>;
export const BuyersPageGetBuyerDetailsDocument = gql`
    query BuyersPageGetBuyerDetails($buyerId: ID!) {
  buyer(id: $buyerId) {
    ...BuyersPageBuyerDetailsFragment
  }
}
    ${BuyersPageBuyerDetailsFragmentFragmentDoc}`;

/**
 * __useBuyersPageGetBuyerDetailsQuery__
 *
 * To run a query within a React component, call `useBuyersPageGetBuyerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyersPageGetBuyerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyersPageGetBuyerDetailsQuery({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *   },
 * });
 */
export function useBuyersPageGetBuyerDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables> & ({ variables: BuyersPageGetBuyerDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>(BuyersPageGetBuyerDetailsDocument, options);
      }
export function useBuyersPageGetBuyerDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>(BuyersPageGetBuyerDetailsDocument, options);
        }
// @ts-ignore
export function useBuyersPageGetBuyerDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>;
export function useBuyersPageGetBuyerDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BuyersPageGetBuyerDetailsQuery | undefined, BuyersPageGetBuyerDetailsQueryVariables>;
export function useBuyersPageGetBuyerDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>(BuyersPageGetBuyerDetailsDocument, options);
        }
export type BuyersPageGetBuyerDetailsQueryHookResult = ReturnType<typeof useBuyersPageGetBuyerDetailsQuery>;
export type BuyersPageGetBuyerDetailsLazyQueryHookResult = ReturnType<typeof useBuyersPageGetBuyerDetailsLazyQuery>;
export type BuyersPageGetBuyerDetailsSuspenseQueryHookResult = ReturnType<typeof useBuyersPageGetBuyerDetailsSuspenseQuery>;
export type BuyersPageGetBuyerDetailsQueryResult = ApolloReactCommon.QueryResult<BuyersPageGetBuyerDetailsQuery, BuyersPageGetBuyerDetailsQueryVariables>;
export const BuyersPageSearchBuyersDocument = gql`
    query BuyersPageSearchBuyers($searchTerm: String!, $size: Int, $offset: Int, $filter: SearchFilter) {
  search(
    query: {search: $searchTerm, type: buyer, size: $size, offset: $offset, filter: $filter}
  ) {
    total
    hits {
      entity {
        ...BuyersPageBuyerFragment
      }
    }
  }
}
    ${BuyersPageBuyerFragmentFragmentDoc}`;

/**
 * __useBuyersPageSearchBuyersQuery__
 *
 * To run a query within a React component, call `useBuyersPageSearchBuyersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuyersPageSearchBuyersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuyersPageSearchBuyersQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      size: // value for 'size'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBuyersPageSearchBuyersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables> & ({ variables: BuyersPageSearchBuyersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>(BuyersPageSearchBuyersDocument, options);
      }
export function useBuyersPageSearchBuyersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>(BuyersPageSearchBuyersDocument, options);
        }
// @ts-ignore
export function useBuyersPageSearchBuyersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>;
export function useBuyersPageSearchBuyersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BuyersPageSearchBuyersQuery | undefined, BuyersPageSearchBuyersQueryVariables>;
export function useBuyersPageSearchBuyersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>(BuyersPageSearchBuyersDocument, options);
        }
export type BuyersPageSearchBuyersQueryHookResult = ReturnType<typeof useBuyersPageSearchBuyersQuery>;
export type BuyersPageSearchBuyersLazyQueryHookResult = ReturnType<typeof useBuyersPageSearchBuyersLazyQuery>;
export type BuyersPageSearchBuyersSuspenseQueryHookResult = ReturnType<typeof useBuyersPageSearchBuyersSuspenseQuery>;
export type BuyersPageSearchBuyersQueryResult = ApolloReactCommon.QueryResult<BuyersPageSearchBuyersQuery, BuyersPageSearchBuyersQueryVariables>;
export const GetBuyerDetailsQueryDocument = gql`
    query GetBuyerDetailsQuery($buyerId: ID!) {
  buyer(id: $buyerId) {
    ...BuyerDetailsFragment
  }
}
    ${BuyerDetailsFragmentFragmentDoc}`;

/**
 * __useGetBuyerDetailsQueryQuery__
 *
 * To run a query within a React component, call `useGetBuyerDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerDetailsQueryQuery({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *   },
 * });
 */
export function useGetBuyerDetailsQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables> & ({ variables: GetBuyerDetailsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>(GetBuyerDetailsQueryDocument, options);
      }
export function useGetBuyerDetailsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>(GetBuyerDetailsQueryDocument, options);
        }
// @ts-ignore
export function useGetBuyerDetailsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>;
export function useGetBuyerDetailsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBuyerDetailsQueryQuery | undefined, GetBuyerDetailsQueryQueryVariables>;
export function useGetBuyerDetailsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>(GetBuyerDetailsQueryDocument, options);
        }
export type GetBuyerDetailsQueryQueryHookResult = ReturnType<typeof useGetBuyerDetailsQueryQuery>;
export type GetBuyerDetailsQueryLazyQueryHookResult = ReturnType<typeof useGetBuyerDetailsQueryLazyQuery>;
export type GetBuyerDetailsQuerySuspenseQueryHookResult = ReturnType<typeof useGetBuyerDetailsQuerySuspenseQuery>;
export type GetBuyerDetailsQueryQueryResult = ApolloReactCommon.QueryResult<GetBuyerDetailsQueryQuery, GetBuyerDetailsQueryQueryVariables>;
export const GetBuyerEntityChatsQueryDocument = gql`
    query GetBuyerEntityChatsQuery($buyerEntityId: String!, $userId: ID!, $offset: Int = 0, $filter: SearchFilter) {
  search(
    query: {search: $buyerEntityId, type: chat, size: 30, offset: $offset, filter: $filter}
  ) {
    hits {
      ...BuyerSearchChatItemFragment
    }
    total
  }
}
    ${BuyerSearchChatItemFragmentFragmentDoc}`;

/**
 * __useGetBuyerEntityChatsQueryQuery__
 *
 * To run a query within a React component, call `useGetBuyerEntityChatsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerEntityChatsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerEntityChatsQueryQuery({
 *   variables: {
 *      buyerEntityId: // value for 'buyerEntityId'
 *      userId: // value for 'userId'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBuyerEntityChatsQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables> & ({ variables: GetBuyerEntityChatsQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>(GetBuyerEntityChatsQueryDocument, options);
      }
export function useGetBuyerEntityChatsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>(GetBuyerEntityChatsQueryDocument, options);
        }
// @ts-ignore
export function useGetBuyerEntityChatsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>;
export function useGetBuyerEntityChatsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBuyerEntityChatsQueryQuery | undefined, GetBuyerEntityChatsQueryQueryVariables>;
export function useGetBuyerEntityChatsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>(GetBuyerEntityChatsQueryDocument, options);
        }
export type GetBuyerEntityChatsQueryQueryHookResult = ReturnType<typeof useGetBuyerEntityChatsQueryQuery>;
export type GetBuyerEntityChatsQueryLazyQueryHookResult = ReturnType<typeof useGetBuyerEntityChatsQueryLazyQuery>;
export type GetBuyerEntityChatsQuerySuspenseQueryHookResult = ReturnType<typeof useGetBuyerEntityChatsQuerySuspenseQuery>;
export type GetBuyerEntityChatsQueryQueryResult = ApolloReactCommon.QueryResult<GetBuyerEntityChatsQueryQuery, GetBuyerEntityChatsQueryQueryVariables>;
export const GetBuyerFacetsQueryDocument = gql`
    query GetBuyerFacetsQuery {
  buyerFacets {
    ...BuyerFacetFragment
  }
}
    ${BuyerFacetFragmentFragmentDoc}`;

/**
 * __useGetBuyerFacetsQueryQuery__
 *
 * To run a query within a React component, call `useGetBuyerFacetsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerFacetsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerFacetsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBuyerFacetsQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>(GetBuyerFacetsQueryDocument, options);
      }
export function useGetBuyerFacetsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>(GetBuyerFacetsQueryDocument, options);
        }
// @ts-ignore
export function useGetBuyerFacetsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>;
export function useGetBuyerFacetsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBuyerFacetsQueryQuery | undefined, GetBuyerFacetsQueryQueryVariables>;
export function useGetBuyerFacetsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>(GetBuyerFacetsQueryDocument, options);
        }
export type GetBuyerFacetsQueryQueryHookResult = ReturnType<typeof useGetBuyerFacetsQueryQuery>;
export type GetBuyerFacetsQueryLazyQueryHookResult = ReturnType<typeof useGetBuyerFacetsQueryLazyQuery>;
export type GetBuyerFacetsQuerySuspenseQueryHookResult = ReturnType<typeof useGetBuyerFacetsQuerySuspenseQuery>;
export type GetBuyerFacetsQueryQueryResult = ApolloReactCommon.QueryResult<GetBuyerFacetsQueryQuery, GetBuyerFacetsQueryQueryVariables>;
export const GetBuyerUsersQueryDocument = gql`
    query GetBuyerUsersQuery($buyerId: ID!, $first: Int = 50) {
  buyer(id: $buyerId) {
    ...BuyerUsersBuyerFragment
  }
}
    ${BuyerUsersBuyerFragmentFragmentDoc}`;

/**
 * __useGetBuyerUsersQueryQuery__
 *
 * To run a query within a React component, call `useGetBuyerUsersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerUsersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerUsersQueryQuery({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetBuyerUsersQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables> & ({ variables: GetBuyerUsersQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>(GetBuyerUsersQueryDocument, options);
      }
export function useGetBuyerUsersQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>(GetBuyerUsersQueryDocument, options);
        }
// @ts-ignore
export function useGetBuyerUsersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>;
export function useGetBuyerUsersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBuyerUsersQueryQuery | undefined, GetBuyerUsersQueryQueryVariables>;
export function useGetBuyerUsersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>(GetBuyerUsersQueryDocument, options);
        }
export type GetBuyerUsersQueryQueryHookResult = ReturnType<typeof useGetBuyerUsersQueryQuery>;
export type GetBuyerUsersQueryLazyQueryHookResult = ReturnType<typeof useGetBuyerUsersQueryLazyQuery>;
export type GetBuyerUsersQuerySuspenseQueryHookResult = ReturnType<typeof useGetBuyerUsersQuerySuspenseQuery>;
export type GetBuyerUsersQueryQueryResult = ApolloReactCommon.QueryResult<GetBuyerUsersQueryQuery, GetBuyerUsersQueryQueryVariables>;
export const GetRequestsToJoinDocument = gql`
    query GetRequestsToJoin($buyerId: String!, $statusFilter: JoinRequestStatus) {
  getRequestsToJoin(
    query: {buyerId: $buyerId, filter: {status: $statusFilter}}
    first: 30
  ) {
    ...RequestsToJoinConnectionFragment
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    ${RequestsToJoinConnectionFragmentFragmentDoc}`;

/**
 * __useGetRequestsToJoinQuery__
 *
 * To run a query within a React component, call `useGetRequestsToJoinQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequestsToJoinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequestsToJoinQuery({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useGetRequestsToJoinQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables> & ({ variables: GetRequestsToJoinQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>(GetRequestsToJoinDocument, options);
      }
export function useGetRequestsToJoinLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>(GetRequestsToJoinDocument, options);
        }
// @ts-ignore
export function useGetRequestsToJoinSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>;
export function useGetRequestsToJoinSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetRequestsToJoinQuery | undefined, GetRequestsToJoinQueryVariables>;
export function useGetRequestsToJoinSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>(GetRequestsToJoinDocument, options);
        }
export type GetRequestsToJoinQueryHookResult = ReturnType<typeof useGetRequestsToJoinQuery>;
export type GetRequestsToJoinLazyQueryHookResult = ReturnType<typeof useGetRequestsToJoinLazyQuery>;
export type GetRequestsToJoinSuspenseQueryHookResult = ReturnType<typeof useGetRequestsToJoinSuspenseQuery>;
export type GetRequestsToJoinQueryResult = ApolloReactCommon.QueryResult<GetRequestsToJoinQuery, GetRequestsToJoinQueryVariables>;
export const GetBuyersQueryDocument = gql`
    query GetBuyersQuery($searchTerm: String!, $size: Int, $offset: Int, $filter: SearchFilter) {
  search(
    query: {search: $searchTerm, type: buyer, size: $size, offset: $offset, filter: $filter}
  ) {
    total
    hits {
      ...BuyerSearchItemFragment
    }
  }
}
    ${BuyerSearchItemFragmentFragmentDoc}`;

/**
 * __useGetBuyersQueryQuery__
 *
 * To run a query within a React component, call `useGetBuyersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyersQueryQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      size: // value for 'size'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBuyersQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBuyersQueryQuery, GetBuyersQueryQueryVariables> & ({ variables: GetBuyersQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>(GetBuyersQueryDocument, options);
      }
export function useGetBuyersQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>(GetBuyersQueryDocument, options);
        }
// @ts-ignore
export function useGetBuyersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>;
export function useGetBuyersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBuyersQueryQuery | undefined, GetBuyersQueryQueryVariables>;
export function useGetBuyersQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>(GetBuyersQueryDocument, options);
        }
export type GetBuyersQueryQueryHookResult = ReturnType<typeof useGetBuyersQueryQuery>;
export type GetBuyersQueryLazyQueryHookResult = ReturnType<typeof useGetBuyersQueryLazyQuery>;
export type GetBuyersQuerySuspenseQueryHookResult = ReturnType<typeof useGetBuyersQuerySuspenseQuery>;
export type GetBuyersQueryQueryResult = ApolloReactCommon.QueryResult<GetBuyersQueryQuery, GetBuyersQueryQueryVariables>;
export const UserSearchQueryDocument = gql`
    query UserSearchQuery($first: Int, $query: UserSearchInput!) {
  userSearch(first: $first, query: $query) {
    ...UserSearchConnectionFragment
    ...UserSearchInputValidationFailure
    ...UserSearchAuthorizationFailure
  }
}
    ${UserSearchConnectionFragmentFragmentDoc}
${UserSearchInputValidationFailureFragmentDoc}
${UserSearchAuthorizationFailureFragmentDoc}`;

/**
 * __useUserSearchQueryQuery__
 *
 * To run a query within a React component, call `useUserSearchQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSearchQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSearchQueryQuery({
 *   variables: {
 *      first: // value for 'first'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useUserSearchQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserSearchQueryQuery, UserSearchQueryQueryVariables> & ({ variables: UserSearchQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserSearchQueryQuery, UserSearchQueryQueryVariables>(UserSearchQueryDocument, options);
      }
export function useUserSearchQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserSearchQueryQuery, UserSearchQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserSearchQueryQuery, UserSearchQueryQueryVariables>(UserSearchQueryDocument, options);
        }
// @ts-ignore
export function useUserSearchQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserSearchQueryQuery, UserSearchQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserSearchQueryQuery, UserSearchQueryQueryVariables>;
export function useUserSearchQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserSearchQueryQuery, UserSearchQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserSearchQueryQuery | undefined, UserSearchQueryQueryVariables>;
export function useUserSearchQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserSearchQueryQuery, UserSearchQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserSearchQueryQuery, UserSearchQueryQueryVariables>(UserSearchQueryDocument, options);
        }
export type UserSearchQueryQueryHookResult = ReturnType<typeof useUserSearchQueryQuery>;
export type UserSearchQueryLazyQueryHookResult = ReturnType<typeof useUserSearchQueryLazyQuery>;
export type UserSearchQuerySuspenseQueryHookResult = ReturnType<typeof useUserSearchQuerySuspenseQuery>;
export type UserSearchQueryQueryResult = ApolloReactCommon.QueryResult<UserSearchQueryQuery, UserSearchQueryQueryVariables>;
export const AddChatUsersDataMutationDocument = gql`
    mutation AddChatUsersDataMutation($id: ID!, $userIds: [ID]!, $first: Int = 50, $withAllUserFields: Boolean = true) {
  chatInviteUsers(id: $id, userIds: $userIds) {
    ...ChatUsersFragment
    __typename
  }
}
    ${ChatUsersFragmentFragmentDoc}`;
export type AddChatUsersDataMutationMutationFn = ApolloReactCommon.MutationFunction<AddChatUsersDataMutationMutation, AddChatUsersDataMutationMutationVariables>;

/**
 * __useAddChatUsersDataMutationMutation__
 *
 * To run a mutation, you first call `useAddChatUsersDataMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChatUsersDataMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChatUsersDataMutationMutation, { data, loading, error }] = useAddChatUsersDataMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userIds: // value for 'userIds'
 *      first: // value for 'first'
 *      withAllUserFields: // value for 'withAllUserFields'
 *   },
 * });
 */
export function useAddChatUsersDataMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddChatUsersDataMutationMutation, AddChatUsersDataMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddChatUsersDataMutationMutation, AddChatUsersDataMutationMutationVariables>(AddChatUsersDataMutationDocument, options);
      }
export type AddChatUsersDataMutationMutationHookResult = ReturnType<typeof useAddChatUsersDataMutationMutation>;
export type AddChatUsersDataMutationMutationResult = ApolloReactCommon.MutationResult<AddChatUsersDataMutationMutation>;
export type AddChatUsersDataMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<AddChatUsersDataMutationMutation, AddChatUsersDataMutationMutationVariables>;
export const UpdateChatOrderingSettingsDocument = gql`
    mutation UpdateChatOrderingSettings($input: ChatOrderingSettingsInput!) {
  updateChatOrderingSettings(input: $input) {
    ... on ChatOrderingSettings {
      isEcommercePoNumberEnabled
      isEcommercePoNumberRequired
      __typename
    }
    ... on InputValidationFailure {
      message
      __typename
    }
    ... on AuthorizationFailure {
      message
      __typename
    }
  }
}
    `;
export type UpdateChatOrderingSettingsMutationFn = ApolloReactCommon.MutationFunction<UpdateChatOrderingSettingsMutation, UpdateChatOrderingSettingsMutationVariables>;

/**
 * __useUpdateChatOrderingSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateChatOrderingSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatOrderingSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatOrderingSettingsMutation, { data, loading, error }] = useUpdateChatOrderingSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChatOrderingSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateChatOrderingSettingsMutation, UpdateChatOrderingSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateChatOrderingSettingsMutation, UpdateChatOrderingSettingsMutationVariables>(UpdateChatOrderingSettingsDocument, options);
      }
export type UpdateChatOrderingSettingsMutationHookResult = ReturnType<typeof useUpdateChatOrderingSettingsMutation>;
export type UpdateChatOrderingSettingsMutationResult = ApolloReactCommon.MutationResult<UpdateChatOrderingSettingsMutation>;
export type UpdateChatOrderingSettingsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChatOrderingSettingsMutation, UpdateChatOrderingSettingsMutationVariables>;
export const ChatPricesVisibilityUpdateDocument = gql`
    mutation ChatPricesVisibilityUpdate($input: ChatPricesVisibilityUpdateInput!) {
  chatPricesVisibilityUpdate(input: $input) {
    ... on ChatPricesVisibilitySuccess {
      displayPricesOverride
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;
export type ChatPricesVisibilityUpdateMutationFn = ApolloReactCommon.MutationFunction<ChatPricesVisibilityUpdateMutation, ChatPricesVisibilityUpdateMutationVariables>;

/**
 * __useChatPricesVisibilityUpdateMutation__
 *
 * To run a mutation, you first call `useChatPricesVisibilityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatPricesVisibilityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatPricesVisibilityUpdateMutation, { data, loading, error }] = useChatPricesVisibilityUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatPricesVisibilityUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChatPricesVisibilityUpdateMutation, ChatPricesVisibilityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChatPricesVisibilityUpdateMutation, ChatPricesVisibilityUpdateMutationVariables>(ChatPricesVisibilityUpdateDocument, options);
      }
export type ChatPricesVisibilityUpdateMutationHookResult = ReturnType<typeof useChatPricesVisibilityUpdateMutation>;
export type ChatPricesVisibilityUpdateMutationResult = ApolloReactCommon.MutationResult<ChatPricesVisibilityUpdateMutation>;
export type ChatPricesVisibilityUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<ChatPricesVisibilityUpdateMutation, ChatPricesVisibilityUpdateMutationVariables>;
export const AddChatUsersDocument = gql`
    mutation AddChatUsers($id: ID!, $userIds: [ID]!, $first: Int = 50, $withAllUserFields: Boolean = true) {
  chatInviteUsers(id: $id, userIds: $userIds) {
    ...ChatUsersFragment
  }
}
    ${ChatUsersFragmentFragmentDoc}`;
export type AddChatUsersMutationFn = ApolloReactCommon.MutationFunction<AddChatUsersMutation, AddChatUsersMutationVariables>;

/**
 * __useAddChatUsersMutation__
 *
 * To run a mutation, you first call `useAddChatUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddChatUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addChatUsersMutation, { data, loading, error }] = useAddChatUsersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userIds: // value for 'userIds'
 *      first: // value for 'first'
 *      withAllUserFields: // value for 'withAllUserFields'
 *   },
 * });
 */
export function useAddChatUsersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddChatUsersMutation, AddChatUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddChatUsersMutation, AddChatUsersMutationVariables>(AddChatUsersDocument, options);
      }
export type AddChatUsersMutationHookResult = ReturnType<typeof useAddChatUsersMutation>;
export type AddChatUsersMutationResult = ApolloReactCommon.MutationResult<AddChatUsersMutation>;
export type AddChatUsersMutationOptions = ApolloReactCommon.BaseMutationOptions<AddChatUsersMutation, AddChatUsersMutationVariables>;
export const RemoveChatUsersDocument = gql`
    mutation RemoveChatUsers($id: ID!, $userIds: [ID!]!, $first: Int = 50, $withAllUserFields: Boolean = true) {
  chatRemoveUsers(id: $id, userIds: $userIds) {
    ...ChatUsersFragment
  }
}
    ${ChatUsersFragmentFragmentDoc}`;
export type RemoveChatUsersMutationFn = ApolloReactCommon.MutationFunction<RemoveChatUsersMutation, RemoveChatUsersMutationVariables>;

/**
 * __useRemoveChatUsersMutation__
 *
 * To run a mutation, you first call `useRemoveChatUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveChatUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeChatUsersMutation, { data, loading, error }] = useRemoveChatUsersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userIds: // value for 'userIds'
 *      first: // value for 'first'
 *      withAllUserFields: // value for 'withAllUserFields'
 *   },
 * });
 */
export function useRemoveChatUsersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveChatUsersMutation, RemoveChatUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveChatUsersMutation, RemoveChatUsersMutationVariables>(RemoveChatUsersDocument, options);
      }
export type RemoveChatUsersMutationHookResult = ReturnType<typeof useRemoveChatUsersMutation>;
export type RemoveChatUsersMutationResult = ApolloReactCommon.MutationResult<RemoveChatUsersMutation>;
export type RemoveChatUsersMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveChatUsersMutation, RemoveChatUsersMutationVariables>;
export const UpdateDeliverySettingDocument = gql`
    mutation UpdateDeliverySetting($id: ID!, $cutoffTimes: WeekdayBasedCutoffSettingsInput!) {
  updateSupplierDeliverySetting(
    input: {id: $id, type: chat, scope: chat, cutoffTimes: $cutoffTimes}
  ) {
    id
  }
}
    `;
export type UpdateDeliverySettingMutationFn = ApolloReactCommon.MutationFunction<UpdateDeliverySettingMutation, UpdateDeliverySettingMutationVariables>;

/**
 * __useUpdateDeliverySettingMutation__
 *
 * To run a mutation, you first call `useUpdateDeliverySettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliverySettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliverySettingMutation, { data, loading, error }] = useUpdateDeliverySettingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cutoffTimes: // value for 'cutoffTimes'
 *   },
 * });
 */
export function useUpdateDeliverySettingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDeliverySettingMutation, UpdateDeliverySettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDeliverySettingMutation, UpdateDeliverySettingMutationVariables>(UpdateDeliverySettingDocument, options);
      }
export type UpdateDeliverySettingMutationHookResult = ReturnType<typeof useUpdateDeliverySettingMutation>;
export type UpdateDeliverySettingMutationResult = ApolloReactCommon.MutationResult<UpdateDeliverySettingMutation>;
export type UpdateDeliverySettingMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDeliverySettingMutation, UpdateDeliverySettingMutationVariables>;
export const DeleteChatDeliverySettingDocument = gql`
    mutation DeleteChatDeliverySetting($chatId: ID!) {
  deleteChatDeliverySetting(chatId: $chatId) {
    id
  }
}
    `;
export type DeleteChatDeliverySettingMutationFn = ApolloReactCommon.MutationFunction<DeleteChatDeliverySettingMutation, DeleteChatDeliverySettingMutationVariables>;

/**
 * __useDeleteChatDeliverySettingMutation__
 *
 * To run a mutation, you first call `useDeleteChatDeliverySettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatDeliverySettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatDeliverySettingMutation, { data, loading, error }] = useDeleteChatDeliverySettingMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useDeleteChatDeliverySettingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteChatDeliverySettingMutation, DeleteChatDeliverySettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteChatDeliverySettingMutation, DeleteChatDeliverySettingMutationVariables>(DeleteChatDeliverySettingDocument, options);
      }
export type DeleteChatDeliverySettingMutationHookResult = ReturnType<typeof useDeleteChatDeliverySettingMutation>;
export type DeleteChatDeliverySettingMutationResult = ApolloReactCommon.MutationResult<DeleteChatDeliverySettingMutation>;
export type DeleteChatDeliverySettingMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteChatDeliverySettingMutation, DeleteChatDeliverySettingMutationVariables>;
export const RemoveCcEmailFromChatsDataDocument = gql`
    mutation RemoveCCEmailFromChatsData($email: AWSEmail!) {
  removeCCEmailFromChats(email: $email) {
    numberOfChatsUpdated
  }
}
    `;
export type RemoveCcEmailFromChatsDataMutationFn = ApolloReactCommon.MutationFunction<RemoveCcEmailFromChatsDataMutation, RemoveCcEmailFromChatsDataMutationVariables>;

/**
 * __useRemoveCcEmailFromChatsDataMutation__
 *
 * To run a mutation, you first call `useRemoveCcEmailFromChatsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCcEmailFromChatsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCcEmailFromChatsDataMutation, { data, loading, error }] = useRemoveCcEmailFromChatsDataMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRemoveCcEmailFromChatsDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveCcEmailFromChatsDataMutation, RemoveCcEmailFromChatsDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveCcEmailFromChatsDataMutation, RemoveCcEmailFromChatsDataMutationVariables>(RemoveCcEmailFromChatsDataDocument, options);
      }
export type RemoveCcEmailFromChatsDataMutationHookResult = ReturnType<typeof useRemoveCcEmailFromChatsDataMutation>;
export type RemoveCcEmailFromChatsDataMutationResult = ApolloReactCommon.MutationResult<RemoveCcEmailFromChatsDataMutation>;
export type RemoveCcEmailFromChatsDataMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveCcEmailFromChatsDataMutation, RemoveCcEmailFromChatsDataMutationVariables>;
export const UpdateSubCatalogChatsDocument = gql`
    mutation UpdateSubCatalogChats($create: [SubCatalogChatInput!]!, $remove: [SubCatalogChatInput!]!) {
  updateSubCatalogChats(create: $create, remove: $remove) {
    ...UpdateSubCatalogChatsResultFragment
    ... on AuthorizationFailure {
      message
    }
  }
}
    ${UpdateSubCatalogChatsResultFragmentFragmentDoc}`;
export type UpdateSubCatalogChatsMutationFn = ApolloReactCommon.MutationFunction<UpdateSubCatalogChatsMutation, UpdateSubCatalogChatsMutationVariables>;

/**
 * __useUpdateSubCatalogChatsMutation__
 *
 * To run a mutation, you first call `useUpdateSubCatalogChatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubCatalogChatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubCatalogChatsMutation, { data, loading, error }] = useUpdateSubCatalogChatsMutation({
 *   variables: {
 *      create: // value for 'create'
 *      remove: // value for 'remove'
 *   },
 * });
 */
export function useUpdateSubCatalogChatsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubCatalogChatsMutation, UpdateSubCatalogChatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubCatalogChatsMutation, UpdateSubCatalogChatsMutationVariables>(UpdateSubCatalogChatsDocument, options);
      }
export type UpdateSubCatalogChatsMutationHookResult = ReturnType<typeof useUpdateSubCatalogChatsMutation>;
export type UpdateSubCatalogChatsMutationResult = ApolloReactCommon.MutationResult<UpdateSubCatalogChatsMutation>;
export type UpdateSubCatalogChatsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSubCatalogChatsMutation, UpdateSubCatalogChatsMutationVariables>;
export const UpdateSupplierBuyerMovDocument = gql`
    mutation UpdateSupplierBuyerMov($input: [UpdateSupplierBuyerMovInput!]!) {
  updateSupplierBuyerMov(input: $input) {
    ... on MinimumOrderValueUpdate {
      __typename
      success
    }
    ... on MinimumOrderValueFailure {
      __typename
      message
    }
    ... on InputValidationFailure {
      __typename
      message
    }
    ... on AuthorizationFailure {
      __typename
      message
    }
  }
}
    `;
export type UpdateSupplierBuyerMovMutationFn = ApolloReactCommon.MutationFunction<UpdateSupplierBuyerMovMutation, UpdateSupplierBuyerMovMutationVariables>;

/**
 * __useUpdateSupplierBuyerMovMutation__
 *
 * To run a mutation, you first call `useUpdateSupplierBuyerMovMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupplierBuyerMovMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupplierBuyerMovMutation, { data, loading, error }] = useUpdateSupplierBuyerMovMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupplierBuyerMovMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSupplierBuyerMovMutation, UpdateSupplierBuyerMovMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSupplierBuyerMovMutation, UpdateSupplierBuyerMovMutationVariables>(UpdateSupplierBuyerMovDocument, options);
      }
export type UpdateSupplierBuyerMovMutationHookResult = ReturnType<typeof useUpdateSupplierBuyerMovMutation>;
export type UpdateSupplierBuyerMovMutationResult = ApolloReactCommon.MutationResult<UpdateSupplierBuyerMovMutation>;
export type UpdateSupplierBuyerMovMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSupplierBuyerMovMutation, UpdateSupplierBuyerMovMutationVariables>;
export const RemoveSupplierBuyerMovDocument = gql`
    mutation RemoveSupplierBuyerMov($input: [RemoveSupplierBuyerMovInput!]!) {
  removeSupplierBuyerMov(input: $input) {
    ... on MinimumOrderValueUpdate {
      __typename
      success
    }
    ... on MinimumOrderValueFailure {
      __typename
      message
    }
    ... on InputValidationFailure {
      __typename
      message
    }
    ... on AuthorizationFailure {
      __typename
      message
    }
  }
}
    `;
export type RemoveSupplierBuyerMovMutationFn = ApolloReactCommon.MutationFunction<RemoveSupplierBuyerMovMutation, RemoveSupplierBuyerMovMutationVariables>;

/**
 * __useRemoveSupplierBuyerMovMutation__
 *
 * To run a mutation, you first call `useRemoveSupplierBuyerMovMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSupplierBuyerMovMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSupplierBuyerMovMutation, { data, loading, error }] = useRemoveSupplierBuyerMovMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveSupplierBuyerMovMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveSupplierBuyerMovMutation, RemoveSupplierBuyerMovMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveSupplierBuyerMovMutation, RemoveSupplierBuyerMovMutationVariables>(RemoveSupplierBuyerMovDocument, options);
      }
export type RemoveSupplierBuyerMovMutationHookResult = ReturnType<typeof useRemoveSupplierBuyerMovMutation>;
export type RemoveSupplierBuyerMovMutationResult = ApolloReactCommon.MutationResult<RemoveSupplierBuyerMovMutation>;
export type RemoveSupplierBuyerMovMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveSupplierBuyerMovMutation, RemoveSupplierBuyerMovMutationVariables>;
export const ChatUpdateDataMutationDocument = gql`
    mutation ChatUpdateDataMutation($id: ID!, $chat: ChatUpdateInput!) {
  chatUpdate(id: $id, chat: $chat) {
    ...ChatDetailsFragment
    __typename
  }
}
    ${ChatDetailsFragmentFragmentDoc}`;
export type ChatUpdateDataMutationMutationFn = ApolloReactCommon.MutationFunction<ChatUpdateDataMutationMutation, ChatUpdateDataMutationMutationVariables>;

/**
 * __useChatUpdateDataMutationMutation__
 *
 * To run a mutation, you first call `useChatUpdateDataMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatUpdateDataMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatUpdateDataMutationMutation, { data, loading, error }] = useChatUpdateDataMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      chat: // value for 'chat'
 *   },
 * });
 */
export function useChatUpdateDataMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChatUpdateDataMutationMutation, ChatUpdateDataMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChatUpdateDataMutationMutation, ChatUpdateDataMutationMutationVariables>(ChatUpdateDataMutationDocument, options);
      }
export type ChatUpdateDataMutationMutationHookResult = ReturnType<typeof useChatUpdateDataMutationMutation>;
export type ChatUpdateDataMutationMutationResult = ApolloReactCommon.MutationResult<ChatUpdateDataMutationMutation>;
export type ChatUpdateDataMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ChatUpdateDataMutationMutation, ChatUpdateDataMutationMutationVariables>;
export const UpdateChatDataDocument = gql`
    mutation UpdateChatData($id: ID!, $chat: ChatUpdateInput!) {
  chatUpdate(id: $id, chat: $chat) {
    ...ChatDetailsFragment
  }
}
    ${ChatDetailsFragmentFragmentDoc}`;
export type UpdateChatDataMutationFn = ApolloReactCommon.MutationFunction<UpdateChatDataMutation, UpdateChatDataMutationVariables>;

/**
 * __useUpdateChatDataMutation__
 *
 * To run a mutation, you first call `useUpdateChatDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatDataMutation, { data, loading, error }] = useUpdateChatDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      chat: // value for 'chat'
 *   },
 * });
 */
export function useUpdateChatDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateChatDataMutation, UpdateChatDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateChatDataMutation, UpdateChatDataMutationVariables>(UpdateChatDataDocument, options);
      }
export type UpdateChatDataMutationHookResult = ReturnType<typeof useUpdateChatDataMutation>;
export type UpdateChatDataMutationResult = ApolloReactCommon.MutationResult<UpdateChatDataMutation>;
export type UpdateChatDataMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChatDataMutation, UpdateChatDataMutationVariables>;
export const UpdateChatBasicDocument = gql`
    mutation UpdateChatBasic($id: ID!, $chat: ChatUpdateInput!) {
  chatUpdate(id: $id, chat: $chat) {
    id
  }
}
    `;
export type UpdateChatBasicMutationFn = ApolloReactCommon.MutationFunction<UpdateChatBasicMutation, UpdateChatBasicMutationVariables>;

/**
 * __useUpdateChatBasicMutation__
 *
 * To run a mutation, you first call `useUpdateChatBasicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatBasicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatBasicMutation, { data, loading, error }] = useUpdateChatBasicMutation({
 *   variables: {
 *      id: // value for 'id'
 *      chat: // value for 'chat'
 *   },
 * });
 */
export function useUpdateChatBasicMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateChatBasicMutation, UpdateChatBasicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateChatBasicMutation, UpdateChatBasicMutationVariables>(UpdateChatBasicDocument, options);
      }
export type UpdateChatBasicMutationHookResult = ReturnType<typeof useUpdateChatBasicMutation>;
export type UpdateChatBasicMutationResult = ApolloReactCommon.MutationResult<UpdateChatBasicMutation>;
export type UpdateChatBasicMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChatBasicMutation, UpdateChatBasicMutationVariables>;
export const UpdateChatEnabledDataMutationDocument = gql`
    mutation UpdateChatEnabledDataMutation($id: ID!, $enabled: Boolean!) {
  updateChatEnabled(id: $id, enabled: $enabled)
}
    `;
export type UpdateChatEnabledDataMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateChatEnabledDataMutationMutation, UpdateChatEnabledDataMutationMutationVariables>;

/**
 * __useUpdateChatEnabledDataMutationMutation__
 *
 * To run a mutation, you first call `useUpdateChatEnabledDataMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatEnabledDataMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatEnabledDataMutationMutation, { data, loading, error }] = useUpdateChatEnabledDataMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateChatEnabledDataMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateChatEnabledDataMutationMutation, UpdateChatEnabledDataMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateChatEnabledDataMutationMutation, UpdateChatEnabledDataMutationMutationVariables>(UpdateChatEnabledDataMutationDocument, options);
      }
export type UpdateChatEnabledDataMutationMutationHookResult = ReturnType<typeof useUpdateChatEnabledDataMutationMutation>;
export type UpdateChatEnabledDataMutationMutationResult = ApolloReactCommon.MutationResult<UpdateChatEnabledDataMutationMutation>;
export type UpdateChatEnabledDataMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChatEnabledDataMutationMutation, UpdateChatEnabledDataMutationMutationVariables>;
export const UpdateChatNotificationPreferencesDataMutationDocument = gql`
    mutation UpdateChatNotificationPreferencesDataMutation($input: ChatNotificationInput) {
  updateChatNotificationPreferences(input: $input) {
    id
    newOrder {
      deselectedUsersList
      __typename
    }
    __typename
  }
}
    `;
export type UpdateChatNotificationPreferencesDataMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateChatNotificationPreferencesDataMutationMutation, UpdateChatNotificationPreferencesDataMutationMutationVariables>;

/**
 * __useUpdateChatNotificationPreferencesDataMutationMutation__
 *
 * To run a mutation, you first call `useUpdateChatNotificationPreferencesDataMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatNotificationPreferencesDataMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatNotificationPreferencesDataMutationMutation, { data, loading, error }] = useUpdateChatNotificationPreferencesDataMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChatNotificationPreferencesDataMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateChatNotificationPreferencesDataMutationMutation, UpdateChatNotificationPreferencesDataMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateChatNotificationPreferencesDataMutationMutation, UpdateChatNotificationPreferencesDataMutationMutationVariables>(UpdateChatNotificationPreferencesDataMutationDocument, options);
      }
export type UpdateChatNotificationPreferencesDataMutationMutationHookResult = ReturnType<typeof useUpdateChatNotificationPreferencesDataMutationMutation>;
export type UpdateChatNotificationPreferencesDataMutationMutationResult = ApolloReactCommon.MutationResult<UpdateChatNotificationPreferencesDataMutationMutation>;
export type UpdateChatNotificationPreferencesDataMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChatNotificationPreferencesDataMutationMutation, UpdateChatNotificationPreferencesDataMutationMutationVariables>;
export const ChatsPageUpdateChatNotificationPreferencesV2Document = gql`
    mutation ChatsPageUpdateChatNotificationPreferencesV2($input: ChatNotificationInput) {
  updateChatNotificationPreferencesV2(input: $input) {
    id
    newOrder {
      deselectedUsersList
      __typename
    }
    __typename
  }
}
    `;
export type ChatsPageUpdateChatNotificationPreferencesV2MutationFn = ApolloReactCommon.MutationFunction<ChatsPageUpdateChatNotificationPreferencesV2Mutation, ChatsPageUpdateChatNotificationPreferencesV2MutationVariables>;

/**
 * __useChatsPageUpdateChatNotificationPreferencesV2Mutation__
 *
 * To run a mutation, you first call `useChatsPageUpdateChatNotificationPreferencesV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatsPageUpdateChatNotificationPreferencesV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatsPageUpdateChatNotificationPreferencesV2Mutation, { data, loading, error }] = useChatsPageUpdateChatNotificationPreferencesV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatsPageUpdateChatNotificationPreferencesV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChatsPageUpdateChatNotificationPreferencesV2Mutation, ChatsPageUpdateChatNotificationPreferencesV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChatsPageUpdateChatNotificationPreferencesV2Mutation, ChatsPageUpdateChatNotificationPreferencesV2MutationVariables>(ChatsPageUpdateChatNotificationPreferencesV2Document, options);
      }
export type ChatsPageUpdateChatNotificationPreferencesV2MutationHookResult = ReturnType<typeof useChatsPageUpdateChatNotificationPreferencesV2Mutation>;
export type ChatsPageUpdateChatNotificationPreferencesV2MutationResult = ApolloReactCommon.MutationResult<ChatsPageUpdateChatNotificationPreferencesV2Mutation>;
export type ChatsPageUpdateChatNotificationPreferencesV2MutationOptions = ApolloReactCommon.BaseMutationOptions<ChatsPageUpdateChatNotificationPreferencesV2Mutation, ChatsPageUpdateChatNotificationPreferencesV2MutationVariables>;
export const ChatPricesVisibilityUpdateMutationDocument = gql`
    mutation ChatPricesVisibilityUpdateMutation($input: ChatPricesVisibilityUpdateInput!) {
  chatPricesVisibilityUpdate(input: $input) {
    ... on ChatPricesVisibilitySuccess {
      displayPricesOverride
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;
export type ChatPricesVisibilityUpdateMutationMutationFn = ApolloReactCommon.MutationFunction<ChatPricesVisibilityUpdateMutationMutation, ChatPricesVisibilityUpdateMutationMutationVariables>;

/**
 * __useChatPricesVisibilityUpdateMutationMutation__
 *
 * To run a mutation, you first call `useChatPricesVisibilityUpdateMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatPricesVisibilityUpdateMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatPricesVisibilityUpdateMutationMutation, { data, loading, error }] = useChatPricesVisibilityUpdateMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChatPricesVisibilityUpdateMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ChatPricesVisibilityUpdateMutationMutation, ChatPricesVisibilityUpdateMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ChatPricesVisibilityUpdateMutationMutation, ChatPricesVisibilityUpdateMutationMutationVariables>(ChatPricesVisibilityUpdateMutationDocument, options);
      }
export type ChatPricesVisibilityUpdateMutationMutationHookResult = ReturnType<typeof useChatPricesVisibilityUpdateMutationMutation>;
export type ChatPricesVisibilityUpdateMutationMutationResult = ApolloReactCommon.MutationResult<ChatPricesVisibilityUpdateMutationMutation>;
export type ChatPricesVisibilityUpdateMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ChatPricesVisibilityUpdateMutationMutation, ChatPricesVisibilityUpdateMutationMutationVariables>;
export const UpdateChatSettingsDataMutationDocument = gql`
    mutation UpdateChatSettingsDataMutation($id: ID!, $chat: ChatUpdateInput!) {
  chatUpdate(id: $id, chat: $chat) {
    id
    chatName
    restaurantName
    deliveryAddress
    customerNumber
    additionalEmails
  }
}
    `;
export type UpdateChatSettingsDataMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateChatSettingsDataMutationMutation, UpdateChatSettingsDataMutationMutationVariables>;

/**
 * __useUpdateChatSettingsDataMutationMutation__
 *
 * To run a mutation, you first call `useUpdateChatSettingsDataMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatSettingsDataMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatSettingsDataMutationMutation, { data, loading, error }] = useUpdateChatSettingsDataMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      chat: // value for 'chat'
 *   },
 * });
 */
export function useUpdateChatSettingsDataMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateChatSettingsDataMutationMutation, UpdateChatSettingsDataMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateChatSettingsDataMutationMutation, UpdateChatSettingsDataMutationMutationVariables>(UpdateChatSettingsDataMutationDocument, options);
      }
export type UpdateChatSettingsDataMutationMutationHookResult = ReturnType<typeof useUpdateChatSettingsDataMutationMutation>;
export type UpdateChatSettingsDataMutationMutationResult = ApolloReactCommon.MutationResult<UpdateChatSettingsDataMutationMutation>;
export type UpdateChatSettingsDataMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateChatSettingsDataMutationMutation, UpdateChatSettingsDataMutationMutationVariables>;
export const UpdateDeliverySettingMutationDocument = gql`
    mutation UpdateDeliverySettingMutation($id: ID!, $cutoffTimes: WeekdayBasedCutoffSettingsInput!) {
  updateSupplierDeliverySetting(
    input: {id: $id, type: chat, scope: chat, cutoffTimes: $cutoffTimes}
  ) {
    id
    __typename
  }
}
    `;
export type UpdateDeliverySettingMutationMutationFn = ApolloReactCommon.MutationFunction<UpdateDeliverySettingMutationMutation, UpdateDeliverySettingMutationMutationVariables>;

/**
 * __useUpdateDeliverySettingMutationMutation__
 *
 * To run a mutation, you first call `useUpdateDeliverySettingMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliverySettingMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliverySettingMutationMutation, { data, loading, error }] = useUpdateDeliverySettingMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cutoffTimes: // value for 'cutoffTimes'
 *   },
 * });
 */
export function useUpdateDeliverySettingMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateDeliverySettingMutationMutation, UpdateDeliverySettingMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateDeliverySettingMutationMutation, UpdateDeliverySettingMutationMutationVariables>(UpdateDeliverySettingMutationDocument, options);
      }
export type UpdateDeliverySettingMutationMutationHookResult = ReturnType<typeof useUpdateDeliverySettingMutationMutation>;
export type UpdateDeliverySettingMutationMutationResult = ApolloReactCommon.MutationResult<UpdateDeliverySettingMutationMutation>;
export type UpdateDeliverySettingMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateDeliverySettingMutationMutation, UpdateDeliverySettingMutationMutationVariables>;
export const ChatHistoryDataDocument = gql`
    query ChatHistoryData($id: ID!) {
  messages(chatId: $id, first: 50) {
    edges {
      node {
        ...HistoryMessageFragment
      }
    }
  }
}
    ${HistoryMessageFragmentFragmentDoc}`;

/**
 * __useChatHistoryDataQuery__
 *
 * To run a query within a React component, call `useChatHistoryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatHistoryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatHistoryDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChatHistoryDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChatHistoryDataQuery, ChatHistoryDataQueryVariables> & ({ variables: ChatHistoryDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>(ChatHistoryDataDocument, options);
      }
export function useChatHistoryDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>(ChatHistoryDataDocument, options);
        }
// @ts-ignore
export function useChatHistoryDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>;
export function useChatHistoryDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatHistoryDataQuery | undefined, ChatHistoryDataQueryVariables>;
export function useChatHistoryDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>(ChatHistoryDataDocument, options);
        }
export type ChatHistoryDataQueryHookResult = ReturnType<typeof useChatHistoryDataQuery>;
export type ChatHistoryDataLazyQueryHookResult = ReturnType<typeof useChatHistoryDataLazyQuery>;
export type ChatHistoryDataSuspenseQueryHookResult = ReturnType<typeof useChatHistoryDataSuspenseQuery>;
export type ChatHistoryDataQueryResult = ApolloReactCommon.QueryResult<ChatHistoryDataQuery, ChatHistoryDataQueryVariables>;
export const ChatSearchDataDocument = gql`
    query ChatSearchData($searchTerm: String!, $searchEntity: SearchEntityType = chat, $first: Int = 50, $size: Int = 50, $offset: Int = 0, $withAllUserFields: Boolean = false, $filter: SearchFilter) {
  search(
    query: {search: $searchTerm, type: $searchEntity, size: $size, offset: $offset, filter: $filter}
  ) {
    total
    hits {
      ...ChatSearchEntityFragment
    }
  }
}
    ${ChatSearchEntityFragmentFragmentDoc}`;

/**
 * __useChatSearchDataQuery__
 *
 * To run a query within a React component, call `useChatSearchDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatSearchDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatSearchDataQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      searchEntity: // value for 'searchEntity'
 *      first: // value for 'first'
 *      size: // value for 'size'
 *      offset: // value for 'offset'
 *      withAllUserFields: // value for 'withAllUserFields'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useChatSearchDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChatSearchDataQuery, ChatSearchDataQueryVariables> & ({ variables: ChatSearchDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatSearchDataQuery, ChatSearchDataQueryVariables>(ChatSearchDataDocument, options);
      }
export function useChatSearchDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatSearchDataQuery, ChatSearchDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatSearchDataQuery, ChatSearchDataQueryVariables>(ChatSearchDataDocument, options);
        }
// @ts-ignore
export function useChatSearchDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChatSearchDataQuery, ChatSearchDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatSearchDataQuery, ChatSearchDataQueryVariables>;
export function useChatSearchDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatSearchDataQuery, ChatSearchDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatSearchDataQuery | undefined, ChatSearchDataQueryVariables>;
export function useChatSearchDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatSearchDataQuery, ChatSearchDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChatSearchDataQuery, ChatSearchDataQueryVariables>(ChatSearchDataDocument, options);
        }
export type ChatSearchDataQueryHookResult = ReturnType<typeof useChatSearchDataQuery>;
export type ChatSearchDataLazyQueryHookResult = ReturnType<typeof useChatSearchDataLazyQuery>;
export type ChatSearchDataSuspenseQueryHookResult = ReturnType<typeof useChatSearchDataSuspenseQuery>;
export type ChatSearchDataQueryResult = ApolloReactCommon.QueryResult<ChatSearchDataQuery, ChatSearchDataQueryVariables>;
export const SearchBuyersForChatDocument = gql`
    query SearchBuyersForChat($searchTerm: String!, $size: Int = 30, $filter: SearchFilter) {
  search(query: {search: $searchTerm, type: buyer, size: $size, filter: $filter}) {
    hits {
      entity {
        ... on Buyer {
          id
          name
          referenceId
          fullAddress
          displayName
          city
          country
        }
      }
    }
  }
}
    `;

/**
 * __useSearchBuyersForChatQuery__
 *
 * To run a query within a React component, call `useSearchBuyersForChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBuyersForChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBuyersForChatQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      size: // value for 'size'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchBuyersForChatQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables> & ({ variables: SearchBuyersForChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>(SearchBuyersForChatDocument, options);
      }
export function useSearchBuyersForChatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>(SearchBuyersForChatDocument, options);
        }
// @ts-ignore
export function useSearchBuyersForChatSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>;
export function useSearchBuyersForChatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchBuyersForChatQuery | undefined, SearchBuyersForChatQueryVariables>;
export function useSearchBuyersForChatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>(SearchBuyersForChatDocument, options);
        }
export type SearchBuyersForChatQueryHookResult = ReturnType<typeof useSearchBuyersForChatQuery>;
export type SearchBuyersForChatLazyQueryHookResult = ReturnType<typeof useSearchBuyersForChatLazyQuery>;
export type SearchBuyersForChatSuspenseQueryHookResult = ReturnType<typeof useSearchBuyersForChatSuspenseQuery>;
export type SearchBuyersForChatQueryResult = ApolloReactCommon.QueryResult<SearchBuyersForChatQuery, SearchBuyersForChatQueryVariables>;
export const SearchSuppliersForChatDocument = gql`
    query SearchSuppliersForChat($keywords: String = "", $filter: SupplierSearchFilter) {
  supplierSearch(query: {keywords: $keywords, filter: $filter}) {
    ... on SearchSupplierConnection {
      edges {
        node {
          id
          referenceId
          customerNumberMandatory
          allowEcommercePoNumber
          botUser {
            id
            name
            phone
            supplier
            botUser
            email
            orderPreference {
              whatsApp
              sms
              fax
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchSuppliersForChatQuery__
 *
 * To run a query within a React component, call `useSearchSuppliersForChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuppliersForChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuppliersForChatQuery({
 *   variables: {
 *      keywords: // value for 'keywords'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchSuppliersForChatQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>(SearchSuppliersForChatDocument, options);
      }
export function useSearchSuppliersForChatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>(SearchSuppliersForChatDocument, options);
        }
// @ts-ignore
export function useSearchSuppliersForChatSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>;
export function useSearchSuppliersForChatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchSuppliersForChatQuery | undefined, SearchSuppliersForChatQueryVariables>;
export function useSearchSuppliersForChatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>(SearchSuppliersForChatDocument, options);
        }
export type SearchSuppliersForChatQueryHookResult = ReturnType<typeof useSearchSuppliersForChatQuery>;
export type SearchSuppliersForChatLazyQueryHookResult = ReturnType<typeof useSearchSuppliersForChatLazyQuery>;
export type SearchSuppliersForChatSuspenseQueryHookResult = ReturnType<typeof useSearchSuppliersForChatSuspenseQuery>;
export type SearchSuppliersForChatQueryResult = ApolloReactCommon.QueryResult<SearchSuppliersForChatQuery, SearchSuppliersForChatQueryVariables>;
export const SearchUsersForChatDocument = gql`
    query SearchUsersForChat($search: String!, $limit: Int = 30, $offset: Int = 0, $filter: SearchFilter) {
  search(
    query: {search: $search, type: user, size: $limit, offset: $offset, filter: $filter}
  ) {
    total
    hits {
      entity {
        ... on User {
          id
          name
          phone
          supplier
          botUser
          email
          orderPreference {
            whatsApp
            sms
            fax
          }
          linkedSupplier {
            id
            customerNumberMandatory
            botUser {
              id
              name
              phone
              supplier
              botUser
              email
              orderPreference {
                whatsApp
                sms
                fax
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchUsersForChatQuery__
 *
 * To run a query within a React component, call `useSearchUsersForChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersForChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersForChatQuery({
 *   variables: {
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchUsersForChatQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchUsersForChatQuery, SearchUsersForChatQueryVariables> & ({ variables: SearchUsersForChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>(SearchUsersForChatDocument, options);
      }
export function useSearchUsersForChatLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>(SearchUsersForChatDocument, options);
        }
// @ts-ignore
export function useSearchUsersForChatSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>;
export function useSearchUsersForChatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchUsersForChatQuery | undefined, SearchUsersForChatQueryVariables>;
export function useSearchUsersForChatSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>(SearchUsersForChatDocument, options);
        }
export type SearchUsersForChatQueryHookResult = ReturnType<typeof useSearchUsersForChatQuery>;
export type SearchUsersForChatLazyQueryHookResult = ReturnType<typeof useSearchUsersForChatLazyQuery>;
export type SearchUsersForChatSuspenseQueryHookResult = ReturnType<typeof useSearchUsersForChatSuspenseQuery>;
export type SearchUsersForChatQueryResult = ApolloReactCommon.QueryResult<SearchUsersForChatQuery, SearchUsersForChatQueryVariables>;
export const GetBuyerUsersDocument = gql`
    query GetBuyerUsers($buyerEntityId: ID!, $first: Int = 150, $after: String) {
  buyer(id: $buyerEntityId) {
    id
    users(first: $first, after: $after) {
      edges {
        node {
          id
          name
          phone
          email
          supplier
        }
      }
    }
  }
}
    `;

/**
 * __useGetBuyerUsersQuery__
 *
 * To run a query within a React component, call `useGetBuyerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerUsersQuery({
 *   variables: {
 *      buyerEntityId: // value for 'buyerEntityId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetBuyerUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBuyerUsersQuery, GetBuyerUsersQueryVariables> & ({ variables: GetBuyerUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>(GetBuyerUsersDocument, options);
      }
export function useGetBuyerUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>(GetBuyerUsersDocument, options);
        }
// @ts-ignore
export function useGetBuyerUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>;
export function useGetBuyerUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBuyerUsersQuery | undefined, GetBuyerUsersQueryVariables>;
export function useGetBuyerUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>(GetBuyerUsersDocument, options);
        }
export type GetBuyerUsersQueryHookResult = ReturnType<typeof useGetBuyerUsersQuery>;
export type GetBuyerUsersLazyQueryHookResult = ReturnType<typeof useGetBuyerUsersLazyQuery>;
export type GetBuyerUsersSuspenseQueryHookResult = ReturnType<typeof useGetBuyerUsersSuspenseQuery>;
export type GetBuyerUsersQueryResult = ApolloReactCommon.QueryResult<GetBuyerUsersQuery, GetBuyerUsersQueryVariables>;
export const GetSupplierUsersDocument = gql`
    query GetSupplierUsers($supplierEntityId: ID!, $first: Int = 100, $after: String) {
  supplier(id: $supplierEntityId) {
    id
    users(first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          name
          phone
          email
          supplier
          botUser
        }
      }
    }
  }
}
    `;

/**
 * __useGetSupplierUsersQuery__
 *
 * To run a query within a React component, call `useGetSupplierUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplierUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplierUsersQuery({
 *   variables: {
 *      supplierEntityId: // value for 'supplierEntityId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetSupplierUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSupplierUsersQuery, GetSupplierUsersQueryVariables> & ({ variables: GetSupplierUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSupplierUsersQuery, GetSupplierUsersQueryVariables>(GetSupplierUsersDocument, options);
      }
export function useGetSupplierUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSupplierUsersQuery, GetSupplierUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSupplierUsersQuery, GetSupplierUsersQueryVariables>(GetSupplierUsersDocument, options);
        }
// @ts-ignore
export function useGetSupplierUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSupplierUsersQuery, GetSupplierUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSupplierUsersQuery, GetSupplierUsersQueryVariables>;
export function useGetSupplierUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSupplierUsersQuery, GetSupplierUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSupplierUsersQuery | undefined, GetSupplierUsersQueryVariables>;
export function useGetSupplierUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSupplierUsersQuery, GetSupplierUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSupplierUsersQuery, GetSupplierUsersQueryVariables>(GetSupplierUsersDocument, options);
        }
export type GetSupplierUsersQueryHookResult = ReturnType<typeof useGetSupplierUsersQuery>;
export type GetSupplierUsersLazyQueryHookResult = ReturnType<typeof useGetSupplierUsersLazyQuery>;
export type GetSupplierUsersSuspenseQueryHookResult = ReturnType<typeof useGetSupplierUsersSuspenseQuery>;
export type GetSupplierUsersQueryResult = ApolloReactCommon.QueryResult<GetSupplierUsersQuery, GetSupplierUsersQueryVariables>;
export const CreateChatDocument = gql`
    mutation CreateChat($chat: ChatCreateInput!) {
  chatCreate(chat: $chat) {
    id
    chatName
    restaurantName
    status
    enabled
    activatedAt
    buyer {
      id
      name
    }
    supplierEntity {
      id
      name
    }
  }
}
    `;
export type CreateChatMutationFn = ApolloReactCommon.MutationFunction<CreateChatMutation, CreateChatMutationVariables>;

/**
 * __useCreateChatMutation__
 *
 * To run a mutation, you first call `useCreateChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatMutation, { data, loading, error }] = useCreateChatMutation({
 *   variables: {
 *      chat: // value for 'chat'
 *   },
 * });
 */
export function useCreateChatMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateChatMutation, CreateChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateChatMutation, CreateChatMutationVariables>(CreateChatDocument, options);
      }
export type CreateChatMutationHookResult = ReturnType<typeof useCreateChatMutation>;
export type CreateChatMutationResult = ApolloReactCommon.MutationResult<CreateChatMutation>;
export type CreateChatMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateChatMutation, CreateChatMutationVariables>;
export const ListSubCatalogsDocument = gql`
    query ListSubCatalogs($supplierEntityId: String, $first: Int, $after: String) {
  listSubCatalogs(
    supplierEntityId: $supplierEntityId
    first: $first
    after: $after
  ) {
    ... on SubCatalogConnection {
      edges {
        cursor
        node {
          id
          name
          supplierEntityId
        }
      }
    }
  }
}
    `;

/**
 * __useListSubCatalogsQuery__
 *
 * To run a query within a React component, call `useListSubCatalogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSubCatalogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSubCatalogsQuery({
 *   variables: {
 *      supplierEntityId: // value for 'supplierEntityId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useListSubCatalogsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>(ListSubCatalogsDocument, options);
      }
export function useListSubCatalogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>(ListSubCatalogsDocument, options);
        }
// @ts-ignore
export function useListSubCatalogsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>;
export function useListSubCatalogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ListSubCatalogsQuery | undefined, ListSubCatalogsQueryVariables>;
export function useListSubCatalogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>(ListSubCatalogsDocument, options);
        }
export type ListSubCatalogsQueryHookResult = ReturnType<typeof useListSubCatalogsQuery>;
export type ListSubCatalogsLazyQueryHookResult = ReturnType<typeof useListSubCatalogsLazyQuery>;
export type ListSubCatalogsSuspenseQueryHookResult = ReturnType<typeof useListSubCatalogsSuspenseQuery>;
export type ListSubCatalogsQueryResult = ApolloReactCommon.QueryResult<ListSubCatalogsQuery, ListSubCatalogsQueryVariables>;
export const ChatsPageCustomerNumberUsageDocument = gql`
    query ChatsPageCustomerNumberUsage($supplierId: String!, $customerNumber: String!) {
  searchCustomerChats(
    input: {searchTerm: $customerNumber, supplierId: $supplierId, pagination: {size: 50, offset: 0}}
  ) {
    ... on CustomerChatsConnection {
      edges {
        node {
          id
          customerNumber
          restaurantName
          chatName
        }
      }
    }
  }
}
    `;

/**
 * __useChatsPageCustomerNumberUsageQuery__
 *
 * To run a query within a React component, call `useChatsPageCustomerNumberUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatsPageCustomerNumberUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatsPageCustomerNumberUsageQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *      customerNumber: // value for 'customerNumber'
 *   },
 * });
 */
export function useChatsPageCustomerNumberUsageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChatsPageCustomerNumberUsageQuery, ChatsPageCustomerNumberUsageQueryVariables> & ({ variables: ChatsPageCustomerNumberUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatsPageCustomerNumberUsageQuery, ChatsPageCustomerNumberUsageQueryVariables>(ChatsPageCustomerNumberUsageDocument, options);
      }
export function useChatsPageCustomerNumberUsageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatsPageCustomerNumberUsageQuery, ChatsPageCustomerNumberUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatsPageCustomerNumberUsageQuery, ChatsPageCustomerNumberUsageQueryVariables>(ChatsPageCustomerNumberUsageDocument, options);
        }
// @ts-ignore
export function useChatsPageCustomerNumberUsageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChatsPageCustomerNumberUsageQuery, ChatsPageCustomerNumberUsageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatsPageCustomerNumberUsageQuery, ChatsPageCustomerNumberUsageQueryVariables>;
export function useChatsPageCustomerNumberUsageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatsPageCustomerNumberUsageQuery, ChatsPageCustomerNumberUsageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatsPageCustomerNumberUsageQuery | undefined, ChatsPageCustomerNumberUsageQueryVariables>;
export function useChatsPageCustomerNumberUsageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatsPageCustomerNumberUsageQuery, ChatsPageCustomerNumberUsageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChatsPageCustomerNumberUsageQuery, ChatsPageCustomerNumberUsageQueryVariables>(ChatsPageCustomerNumberUsageDocument, options);
        }
export type ChatsPageCustomerNumberUsageQueryHookResult = ReturnType<typeof useChatsPageCustomerNumberUsageQuery>;
export type ChatsPageCustomerNumberUsageLazyQueryHookResult = ReturnType<typeof useChatsPageCustomerNumberUsageLazyQuery>;
export type ChatsPageCustomerNumberUsageSuspenseQueryHookResult = ReturnType<typeof useChatsPageCustomerNumberUsageSuspenseQuery>;
export type ChatsPageCustomerNumberUsageQueryResult = ApolloReactCommon.QueryResult<ChatsPageCustomerNumberUsageQuery, ChatsPageCustomerNumberUsageQueryVariables>;
export const GetChatCountByCcEmailDataDocument = gql`
    query GetChatCountByCCEmailData($email: AWSEmail!) {
  getChatCountByCCEmail(email: $email) {
    ...ChatCountByCcEmailReportFragment
  }
}
    ${ChatCountByCcEmailReportFragmentFragmentDoc}`;

/**
 * __useGetChatCountByCcEmailDataQuery__
 *
 * To run a query within a React component, call `useGetChatCountByCcEmailDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatCountByCcEmailDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatCountByCcEmailDataQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetChatCountByCcEmailDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables> & ({ variables: GetChatCountByCcEmailDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>(GetChatCountByCcEmailDataDocument, options);
      }
export function useGetChatCountByCcEmailDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>(GetChatCountByCcEmailDataDocument, options);
        }
// @ts-ignore
export function useGetChatCountByCcEmailDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>;
export function useGetChatCountByCcEmailDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetChatCountByCcEmailDataQuery | undefined, GetChatCountByCcEmailDataQueryVariables>;
export function useGetChatCountByCcEmailDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>(GetChatCountByCcEmailDataDocument, options);
        }
export type GetChatCountByCcEmailDataQueryHookResult = ReturnType<typeof useGetChatCountByCcEmailDataQuery>;
export type GetChatCountByCcEmailDataLazyQueryHookResult = ReturnType<typeof useGetChatCountByCcEmailDataLazyQuery>;
export type GetChatCountByCcEmailDataSuspenseQueryHookResult = ReturnType<typeof useGetChatCountByCcEmailDataSuspenseQuery>;
export type GetChatCountByCcEmailDataQueryResult = ApolloReactCommon.QueryResult<GetChatCountByCcEmailDataQuery, GetChatCountByCcEmailDataQueryVariables>;
export const GetChatDataDocument = gql`
    query GetChatData($chatId: ID!, $first: Int = 50, $withAllUserFields: Boolean = false, $withProducts: Boolean = true, $buyerId: String) {
  chat(id: $chatId) {
    ...ChatDataFragment
  }
  getSubCatalogsForChat(chatId: $chatId) {
    ...SubCatalogsForChatFragment
  }
}
    ${ChatDataFragmentFragmentDoc}
${SubCatalogsForChatFragmentFragmentDoc}`;

/**
 * __useGetChatDataQuery__
 *
 * To run a query within a React component, call `useGetChatDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatDataQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *      first: // value for 'first'
 *      withAllUserFields: // value for 'withAllUserFields'
 *      withProducts: // value for 'withProducts'
 *      buyerId: // value for 'buyerId'
 *   },
 * });
 */
export function useGetChatDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetChatDataQuery, GetChatDataQueryVariables> & ({ variables: GetChatDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetChatDataQuery, GetChatDataQueryVariables>(GetChatDataDocument, options);
      }
export function useGetChatDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetChatDataQuery, GetChatDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetChatDataQuery, GetChatDataQueryVariables>(GetChatDataDocument, options);
        }
// @ts-ignore
export function useGetChatDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetChatDataQuery, GetChatDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetChatDataQuery, GetChatDataQueryVariables>;
export function useGetChatDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetChatDataQuery, GetChatDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetChatDataQuery | undefined, GetChatDataQueryVariables>;
export function useGetChatDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetChatDataQuery, GetChatDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetChatDataQuery, GetChatDataQueryVariables>(GetChatDataDocument, options);
        }
export type GetChatDataQueryHookResult = ReturnType<typeof useGetChatDataQuery>;
export type GetChatDataLazyQueryHookResult = ReturnType<typeof useGetChatDataLazyQuery>;
export type GetChatDataSuspenseQueryHookResult = ReturnType<typeof useGetChatDataSuspenseQuery>;
export type GetChatDataQueryResult = ApolloReactCommon.QueryResult<GetChatDataQuery, GetChatDataQueryVariables>;
export const ChatNotificationPreferencesDataDocument = gql`
    query ChatNotificationPreferencesData($chatId: ID!) {
  chatNotificationPreferences(id: $chatId) {
    id
    newOrder {
      deselectedUsersList
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useChatNotificationPreferencesDataQuery__
 *
 * To run a query within a React component, call `useChatNotificationPreferencesDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatNotificationPreferencesDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatNotificationPreferencesDataQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useChatNotificationPreferencesDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables> & ({ variables: ChatNotificationPreferencesDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>(ChatNotificationPreferencesDataDocument, options);
      }
export function useChatNotificationPreferencesDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>(ChatNotificationPreferencesDataDocument, options);
        }
// @ts-ignore
export function useChatNotificationPreferencesDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>;
export function useChatNotificationPreferencesDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatNotificationPreferencesDataQuery | undefined, ChatNotificationPreferencesDataQueryVariables>;
export function useChatNotificationPreferencesDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>(ChatNotificationPreferencesDataDocument, options);
        }
export type ChatNotificationPreferencesDataQueryHookResult = ReturnType<typeof useChatNotificationPreferencesDataQuery>;
export type ChatNotificationPreferencesDataLazyQueryHookResult = ReturnType<typeof useChatNotificationPreferencesDataLazyQuery>;
export type ChatNotificationPreferencesDataSuspenseQueryHookResult = ReturnType<typeof useChatNotificationPreferencesDataSuspenseQuery>;
export type ChatNotificationPreferencesDataQueryResult = ApolloReactCommon.QueryResult<ChatNotificationPreferencesDataQuery, ChatNotificationPreferencesDataQueryVariables>;
export const ChatsPageGetChatNotificationPreferencesV2Document = gql`
    query ChatsPageGetChatNotificationPreferencesV2($chatId: ID!) {
  chatNotificationPreferencesV2(id: $chatId) {
    id
    newOrder {
      deselectedUsersList
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useChatsPageGetChatNotificationPreferencesV2Query__
 *
 * To run a query within a React component, call `useChatsPageGetChatNotificationPreferencesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useChatsPageGetChatNotificationPreferencesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatsPageGetChatNotificationPreferencesV2Query({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useChatsPageGetChatNotificationPreferencesV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<ChatsPageGetChatNotificationPreferencesV2Query, ChatsPageGetChatNotificationPreferencesV2QueryVariables> & ({ variables: ChatsPageGetChatNotificationPreferencesV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatsPageGetChatNotificationPreferencesV2Query, ChatsPageGetChatNotificationPreferencesV2QueryVariables>(ChatsPageGetChatNotificationPreferencesV2Document, options);
      }
export function useChatsPageGetChatNotificationPreferencesV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatsPageGetChatNotificationPreferencesV2Query, ChatsPageGetChatNotificationPreferencesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatsPageGetChatNotificationPreferencesV2Query, ChatsPageGetChatNotificationPreferencesV2QueryVariables>(ChatsPageGetChatNotificationPreferencesV2Document, options);
        }
// @ts-ignore
export function useChatsPageGetChatNotificationPreferencesV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChatsPageGetChatNotificationPreferencesV2Query, ChatsPageGetChatNotificationPreferencesV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatsPageGetChatNotificationPreferencesV2Query, ChatsPageGetChatNotificationPreferencesV2QueryVariables>;
export function useChatsPageGetChatNotificationPreferencesV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatsPageGetChatNotificationPreferencesV2Query, ChatsPageGetChatNotificationPreferencesV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatsPageGetChatNotificationPreferencesV2Query | undefined, ChatsPageGetChatNotificationPreferencesV2QueryVariables>;
export function useChatsPageGetChatNotificationPreferencesV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatsPageGetChatNotificationPreferencesV2Query, ChatsPageGetChatNotificationPreferencesV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChatsPageGetChatNotificationPreferencesV2Query, ChatsPageGetChatNotificationPreferencesV2QueryVariables>(ChatsPageGetChatNotificationPreferencesV2Document, options);
        }
export type ChatsPageGetChatNotificationPreferencesV2QueryHookResult = ReturnType<typeof useChatsPageGetChatNotificationPreferencesV2Query>;
export type ChatsPageGetChatNotificationPreferencesV2LazyQueryHookResult = ReturnType<typeof useChatsPageGetChatNotificationPreferencesV2LazyQuery>;
export type ChatsPageGetChatNotificationPreferencesV2SuspenseQueryHookResult = ReturnType<typeof useChatsPageGetChatNotificationPreferencesV2SuspenseQuery>;
export type ChatsPageGetChatNotificationPreferencesV2QueryResult = ApolloReactCommon.QueryResult<ChatsPageGetChatNotificationPreferencesV2Query, ChatsPageGetChatNotificationPreferencesV2QueryVariables>;
export const ChatPricesVisibilityQueryDocument = gql`
    query ChatPricesVisibilityQuery($chatId: ID!) {
  chatPricesVisibility(chatId: $chatId) {
    ... on ChatPricesVisibilitySuccess {
      displayPricesOverride
      __typename
    }
    ... on InputValidationFailure {
      message
      __typename
    }
    ... on AuthorizationFailure {
      message
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useChatPricesVisibilityQueryQuery__
 *
 * To run a query within a React component, call `useChatPricesVisibilityQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatPricesVisibilityQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatPricesVisibilityQueryQuery({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useChatPricesVisibilityQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables> & ({ variables: ChatPricesVisibilityQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>(ChatPricesVisibilityQueryDocument, options);
      }
export function useChatPricesVisibilityQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>(ChatPricesVisibilityQueryDocument, options);
        }
// @ts-ignore
export function useChatPricesVisibilityQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>;
export function useChatPricesVisibilityQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatPricesVisibilityQueryQuery | undefined, ChatPricesVisibilityQueryQueryVariables>;
export function useChatPricesVisibilityQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>(ChatPricesVisibilityQueryDocument, options);
        }
export type ChatPricesVisibilityQueryQueryHookResult = ReturnType<typeof useChatPricesVisibilityQueryQuery>;
export type ChatPricesVisibilityQueryLazyQueryHookResult = ReturnType<typeof useChatPricesVisibilityQueryLazyQuery>;
export type ChatPricesVisibilityQuerySuspenseQueryHookResult = ReturnType<typeof useChatPricesVisibilityQuerySuspenseQuery>;
export type ChatPricesVisibilityQueryQueryResult = ApolloReactCommon.QueryResult<ChatPricesVisibilityQueryQuery, ChatPricesVisibilityQueryQueryVariables>;
export const ChatsPageGetSupplierBotUserDocument = gql`
    query ChatsPageGetSupplierBotUser($id: ID!) {
  supplier(id: $id) {
    id
    botUser {
      id
    }
  }
}
    `;

/**
 * __useChatsPageGetSupplierBotUserQuery__
 *
 * To run a query within a React component, call `useChatsPageGetSupplierBotUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatsPageGetSupplierBotUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatsPageGetSupplierBotUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChatsPageGetSupplierBotUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChatsPageGetSupplierBotUserQuery, ChatsPageGetSupplierBotUserQueryVariables> & ({ variables: ChatsPageGetSupplierBotUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChatsPageGetSupplierBotUserQuery, ChatsPageGetSupplierBotUserQueryVariables>(ChatsPageGetSupplierBotUserDocument, options);
      }
export function useChatsPageGetSupplierBotUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChatsPageGetSupplierBotUserQuery, ChatsPageGetSupplierBotUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChatsPageGetSupplierBotUserQuery, ChatsPageGetSupplierBotUserQueryVariables>(ChatsPageGetSupplierBotUserDocument, options);
        }
// @ts-ignore
export function useChatsPageGetSupplierBotUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChatsPageGetSupplierBotUserQuery, ChatsPageGetSupplierBotUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatsPageGetSupplierBotUserQuery, ChatsPageGetSupplierBotUserQueryVariables>;
export function useChatsPageGetSupplierBotUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatsPageGetSupplierBotUserQuery, ChatsPageGetSupplierBotUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChatsPageGetSupplierBotUserQuery | undefined, ChatsPageGetSupplierBotUserQueryVariables>;
export function useChatsPageGetSupplierBotUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChatsPageGetSupplierBotUserQuery, ChatsPageGetSupplierBotUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChatsPageGetSupplierBotUserQuery, ChatsPageGetSupplierBotUserQueryVariables>(ChatsPageGetSupplierBotUserDocument, options);
        }
export type ChatsPageGetSupplierBotUserQueryHookResult = ReturnType<typeof useChatsPageGetSupplierBotUserQuery>;
export type ChatsPageGetSupplierBotUserLazyQueryHookResult = ReturnType<typeof useChatsPageGetSupplierBotUserLazyQuery>;
export type ChatsPageGetSupplierBotUserSuspenseQueryHookResult = ReturnType<typeof useChatsPageGetSupplierBotUserSuspenseQuery>;
export type ChatsPageGetSupplierBotUserQueryResult = ApolloReactCommon.QueryResult<ChatsPageGetSupplierBotUserQuery, ChatsPageGetSupplierBotUserQueryVariables>;
export const SupplierDeliverySettingQueryDocument = gql`
    query SupplierDeliverySettingQuery($id: ID!) {
  supplierDeliverySetting(id: $id) {
    ...DeliverySettingFragment
    __typename
  }
}
    ${DeliverySettingFragmentFragmentDoc}`;

/**
 * __useSupplierDeliverySettingQueryQuery__
 *
 * To run a query within a React component, call `useSupplierDeliverySettingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierDeliverySettingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierDeliverySettingQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSupplierDeliverySettingQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables> & ({ variables: SupplierDeliverySettingQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>(SupplierDeliverySettingQueryDocument, options);
      }
export function useSupplierDeliverySettingQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>(SupplierDeliverySettingQueryDocument, options);
        }
// @ts-ignore
export function useSupplierDeliverySettingQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>;
export function useSupplierDeliverySettingQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SupplierDeliverySettingQueryQuery | undefined, SupplierDeliverySettingQueryQueryVariables>;
export function useSupplierDeliverySettingQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>(SupplierDeliverySettingQueryDocument, options);
        }
export type SupplierDeliverySettingQueryQueryHookResult = ReturnType<typeof useSupplierDeliverySettingQueryQuery>;
export type SupplierDeliverySettingQueryLazyQueryHookResult = ReturnType<typeof useSupplierDeliverySettingQueryLazyQuery>;
export type SupplierDeliverySettingQuerySuspenseQueryHookResult = ReturnType<typeof useSupplierDeliverySettingQuerySuspenseQuery>;
export type SupplierDeliverySettingQueryQueryResult = ApolloReactCommon.QueryResult<SupplierDeliverySettingQueryQuery, SupplierDeliverySettingQueryQueryVariables>;
export const OrderGuideUploadPageOrderGuideBatchUpdateDocument = gql`
    mutation OrderGuideUploadPageOrderGuideBatchUpdate($input: OrderGuideV2BatchUpdateInput!) {
  orderGuideV2BatchUpdate(input: $input) {
    ... on OrderGuideV2BatchUpdateResult {
      responseType
      summary {
        existingOrderGuideItems
        newOrderGuideItems
        updatedOrderGuideItems
        removedOrderGuideItems
        createdCustomVendorItems
        errors {
          index
          reason
          errorCode
          item {
            productCode
            unit
            name
          }
        }
      }
    }
    ... on InputValidationFailure {
      responseType
      message
      invalidFields {
        fieldName
        reason
      }
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;
export type OrderGuideUploadPageOrderGuideBatchUpdateMutationFn = ApolloReactCommon.MutationFunction<OrderGuideUploadPageOrderGuideBatchUpdateMutation, OrderGuideUploadPageOrderGuideBatchUpdateMutationVariables>;

/**
 * __useOrderGuideUploadPageOrderGuideBatchUpdateMutation__
 *
 * To run a mutation, you first call `useOrderGuideUploadPageOrderGuideBatchUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderGuideUploadPageOrderGuideBatchUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderGuideUploadPageOrderGuideBatchUpdateMutation, { data, loading, error }] = useOrderGuideUploadPageOrderGuideBatchUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrderGuideUploadPageOrderGuideBatchUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrderGuideUploadPageOrderGuideBatchUpdateMutation, OrderGuideUploadPageOrderGuideBatchUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrderGuideUploadPageOrderGuideBatchUpdateMutation, OrderGuideUploadPageOrderGuideBatchUpdateMutationVariables>(OrderGuideUploadPageOrderGuideBatchUpdateDocument, options);
      }
export type OrderGuideUploadPageOrderGuideBatchUpdateMutationHookResult = ReturnType<typeof useOrderGuideUploadPageOrderGuideBatchUpdateMutation>;
export type OrderGuideUploadPageOrderGuideBatchUpdateMutationResult = ApolloReactCommon.MutationResult<OrderGuideUploadPageOrderGuideBatchUpdateMutation>;
export type OrderGuideUploadPageOrderGuideBatchUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<OrderGuideUploadPageOrderGuideBatchUpdateMutation, OrderGuideUploadPageOrderGuideBatchUpdateMutationVariables>;
export const OrderGuideUploadPageGetChatOrderGuidesDocument = gql`
    query OrderGuideUploadPageGetChatOrderGuides($id: ID!) {
  chat(id: $id) {
    id
    chatName
    restaurantName
    supplierEntity {
      id
      name
    }
    orderGuides {
      id
      node {
        id
        name
        itemsCount
      }
    }
  }
}
    `;

/**
 * __useOrderGuideUploadPageGetChatOrderGuidesQuery__
 *
 * To run a query within a React component, call `useOrderGuideUploadPageGetChatOrderGuidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderGuideUploadPageGetChatOrderGuidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderGuideUploadPageGetChatOrderGuidesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderGuideUploadPageGetChatOrderGuidesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrderGuideUploadPageGetChatOrderGuidesQuery, OrderGuideUploadPageGetChatOrderGuidesQueryVariables> & ({ variables: OrderGuideUploadPageGetChatOrderGuidesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrderGuideUploadPageGetChatOrderGuidesQuery, OrderGuideUploadPageGetChatOrderGuidesQueryVariables>(OrderGuideUploadPageGetChatOrderGuidesDocument, options);
      }
export function useOrderGuideUploadPageGetChatOrderGuidesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderGuideUploadPageGetChatOrderGuidesQuery, OrderGuideUploadPageGetChatOrderGuidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrderGuideUploadPageGetChatOrderGuidesQuery, OrderGuideUploadPageGetChatOrderGuidesQueryVariables>(OrderGuideUploadPageGetChatOrderGuidesDocument, options);
        }
// @ts-ignore
export function useOrderGuideUploadPageGetChatOrderGuidesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrderGuideUploadPageGetChatOrderGuidesQuery, OrderGuideUploadPageGetChatOrderGuidesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrderGuideUploadPageGetChatOrderGuidesQuery, OrderGuideUploadPageGetChatOrderGuidesQueryVariables>;
export function useOrderGuideUploadPageGetChatOrderGuidesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrderGuideUploadPageGetChatOrderGuidesQuery, OrderGuideUploadPageGetChatOrderGuidesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrderGuideUploadPageGetChatOrderGuidesQuery | undefined, OrderGuideUploadPageGetChatOrderGuidesQueryVariables>;
export function useOrderGuideUploadPageGetChatOrderGuidesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrderGuideUploadPageGetChatOrderGuidesQuery, OrderGuideUploadPageGetChatOrderGuidesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrderGuideUploadPageGetChatOrderGuidesQuery, OrderGuideUploadPageGetChatOrderGuidesQueryVariables>(OrderGuideUploadPageGetChatOrderGuidesDocument, options);
        }
export type OrderGuideUploadPageGetChatOrderGuidesQueryHookResult = ReturnType<typeof useOrderGuideUploadPageGetChatOrderGuidesQuery>;
export type OrderGuideUploadPageGetChatOrderGuidesLazyQueryHookResult = ReturnType<typeof useOrderGuideUploadPageGetChatOrderGuidesLazyQuery>;
export type OrderGuideUploadPageGetChatOrderGuidesSuspenseQueryHookResult = ReturnType<typeof useOrderGuideUploadPageGetChatOrderGuidesSuspenseQuery>;
export type OrderGuideUploadPageGetChatOrderGuidesQueryResult = ApolloReactCommon.QueryResult<OrderGuideUploadPageGetChatOrderGuidesQuery, OrderGuideUploadPageGetChatOrderGuidesQueryVariables>;
export const BatchOrderConfirmDocument = gql`
    mutation BatchOrderConfirm($ids: [ID!]!) {
  batchOrderConfirm(ids: $ids) {
    ... on BatchOrderConfirmSuccess {
      responseType
      __typename
    }
    ... on BatchOrderConfirmError {
      responseType
      message
      __typename
    }
    __typename
  }
}
    `;
export type BatchOrderConfirmMutationFn = ApolloReactCommon.MutationFunction<BatchOrderConfirmMutation, BatchOrderConfirmMutationVariables>;

/**
 * __useBatchOrderConfirmMutation__
 *
 * To run a mutation, you first call `useBatchOrderConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchOrderConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchOrderConfirmMutation, { data, loading, error }] = useBatchOrderConfirmMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useBatchOrderConfirmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<BatchOrderConfirmMutation, BatchOrderConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<BatchOrderConfirmMutation, BatchOrderConfirmMutationVariables>(BatchOrderConfirmDocument, options);
      }
export type BatchOrderConfirmMutationHookResult = ReturnType<typeof useBatchOrderConfirmMutation>;
export type BatchOrderConfirmMutationResult = ApolloReactCommon.MutationResult<BatchOrderConfirmMutation>;
export type BatchOrderConfirmMutationOptions = ApolloReactCommon.BaseMutationOptions<BatchOrderConfirmMutation, BatchOrderConfirmMutationVariables>;
export const SetOrderAsTestDocument = gql`
    mutation SetOrderAsTest($orderId: ID!) {
  setOrderAsTest(orderId: $orderId) {
    ...TestOrderResponseFragment
    ...InputValidationFailureFragment
  }
}
    ${TestOrderResponseFragmentFragmentDoc}
${InputValidationFailureFragmentFragmentDoc}`;
export type SetOrderAsTestMutationFn = ApolloReactCommon.MutationFunction<SetOrderAsTestMutation, SetOrderAsTestMutationVariables>;

/**
 * __useSetOrderAsTestMutation__
 *
 * To run a mutation, you first call `useSetOrderAsTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOrderAsTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOrderAsTestMutation, { data, loading, error }] = useSetOrderAsTestMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSetOrderAsTestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetOrderAsTestMutation, SetOrderAsTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetOrderAsTestMutation, SetOrderAsTestMutationVariables>(SetOrderAsTestDocument, options);
      }
export type SetOrderAsTestMutationHookResult = ReturnType<typeof useSetOrderAsTestMutation>;
export type SetOrderAsTestMutationResult = ApolloReactCommon.MutationResult<SetOrderAsTestMutation>;
export type SetOrderAsTestMutationOptions = ApolloReactCommon.BaseMutationOptions<SetOrderAsTestMutation, SetOrderAsTestMutationVariables>;
export const GetBlockedEmailsDocument = gql`
    query GetBlockedEmails($first: Int, $after: String) {
  blockedEmails(first: $first, after: $after) {
    ...BlockedEmailConnectionFragment
  }
}
    ${BlockedEmailConnectionFragmentFragmentDoc}`;

/**
 * __useGetBlockedEmailsQuery__
 *
 * To run a query within a React component, call `useGetBlockedEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockedEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockedEmailsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetBlockedEmailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBlockedEmailsQuery, GetBlockedEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBlockedEmailsQuery, GetBlockedEmailsQueryVariables>(GetBlockedEmailsDocument, options);
      }
export function useGetBlockedEmailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBlockedEmailsQuery, GetBlockedEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBlockedEmailsQuery, GetBlockedEmailsQueryVariables>(GetBlockedEmailsDocument, options);
        }
// @ts-ignore
export function useGetBlockedEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetBlockedEmailsQuery, GetBlockedEmailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBlockedEmailsQuery, GetBlockedEmailsQueryVariables>;
export function useGetBlockedEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBlockedEmailsQuery, GetBlockedEmailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBlockedEmailsQuery | undefined, GetBlockedEmailsQueryVariables>;
export function useGetBlockedEmailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBlockedEmailsQuery, GetBlockedEmailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBlockedEmailsQuery, GetBlockedEmailsQueryVariables>(GetBlockedEmailsDocument, options);
        }
export type GetBlockedEmailsQueryHookResult = ReturnType<typeof useGetBlockedEmailsQuery>;
export type GetBlockedEmailsLazyQueryHookResult = ReturnType<typeof useGetBlockedEmailsLazyQuery>;
export type GetBlockedEmailsSuspenseQueryHookResult = ReturnType<typeof useGetBlockedEmailsSuspenseQuery>;
export type GetBlockedEmailsQueryResult = ApolloReactCommon.QueryResult<GetBlockedEmailsQuery, GetBlockedEmailsQueryVariables>;
export const GetOrderDocument = gql`
    query GetOrder($id: ID!) {
  order(id: $id) {
    ...OrderDetailsFragment
  }
}
    ${OrderDetailsFragmentFragmentDoc}`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables> & ({ variables: GetOrderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
      }
export function useGetOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
// @ts-ignore
export function useGetOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetOrderQuery, GetOrderQueryVariables>;
export function useGetOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetOrderQuery | undefined, GetOrderQueryVariables>;
export function useGetOrderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderSuspenseQueryHookResult = ReturnType<typeof useGetOrderSuspenseQuery>;
export type GetOrderQueryResult = ApolloReactCommon.QueryResult<GetOrderQuery, GetOrderQueryVariables>;
export const GetOrdersDocument = gql`
    query GetOrders($first: Int, $after: String, $query: SearchOrderInput!) {
  searchOrder(first: $first, after: $after, query: $query) {
    ...SearchOrderConnectionFragment
    ... on InputValidationFailure {
      message
    }
  }
}
    ${SearchOrderConnectionFragmentFragmentDoc}`;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables> & ({ variables: GetOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
// @ts-ignore
export function useGetOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export function useGetOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetOrdersQuery | undefined, GetOrdersQueryVariables>;
export function useGetOrdersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersSuspenseQueryHookResult = ReturnType<typeof useGetOrdersSuspenseQuery>;
export type GetOrdersQueryResult = ApolloReactCommon.QueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export const GetTransmissionEventsDocument = gql`
    query GetTransmissionEvents($ofId: ID!) {
  transmissionEvents(ofId: $ofId) {
    ...TransmissionEventsFragment
  }
}
    ${TransmissionEventsFragmentFragmentDoc}`;

/**
 * __useGetTransmissionEventsQuery__
 *
 * To run a query within a React component, call `useGetTransmissionEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransmissionEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransmissionEventsQuery({
 *   variables: {
 *      ofId: // value for 'ofId'
 *   },
 * });
 */
export function useGetTransmissionEventsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetTransmissionEventsQuery, GetTransmissionEventsQueryVariables> & ({ variables: GetTransmissionEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTransmissionEventsQuery, GetTransmissionEventsQueryVariables>(GetTransmissionEventsDocument, options);
      }
export function useGetTransmissionEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTransmissionEventsQuery, GetTransmissionEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTransmissionEventsQuery, GetTransmissionEventsQueryVariables>(GetTransmissionEventsDocument, options);
        }
// @ts-ignore
export function useGetTransmissionEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetTransmissionEventsQuery, GetTransmissionEventsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetTransmissionEventsQuery, GetTransmissionEventsQueryVariables>;
export function useGetTransmissionEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTransmissionEventsQuery, GetTransmissionEventsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetTransmissionEventsQuery | undefined, GetTransmissionEventsQueryVariables>;
export function useGetTransmissionEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTransmissionEventsQuery, GetTransmissionEventsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTransmissionEventsQuery, GetTransmissionEventsQueryVariables>(GetTransmissionEventsDocument, options);
        }
export type GetTransmissionEventsQueryHookResult = ReturnType<typeof useGetTransmissionEventsQuery>;
export type GetTransmissionEventsLazyQueryHookResult = ReturnType<typeof useGetTransmissionEventsLazyQuery>;
export type GetTransmissionEventsSuspenseQueryHookResult = ReturnType<typeof useGetTransmissionEventsSuspenseQuery>;
export type GetTransmissionEventsQueryResult = ApolloReactCommon.QueryResult<GetTransmissionEventsQuery, GetTransmissionEventsQueryVariables>;
export const SsoPageEmailDomainExclusivitySetDocument = gql`
    mutation SsoPageEmailDomainExclusivitySet($input: SsoEmailDomainExclusivitySetInput!) {
  ssoEmailDomainExclusivitySet(input: $input) {
    ... on SsoEmailDomain {
      ...SsoPageEmailDomainFragment
    }
    ... on NotFoundError {
      message
    }
    ... on InputValidationFailure {
      ...SsoPageInvalidFieldsFragment
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    ${SsoPageEmailDomainFragmentFragmentDoc}
${SsoPageInvalidFieldsFragmentFragmentDoc}`;
export type SsoPageEmailDomainExclusivitySetMutationFn = ApolloReactCommon.MutationFunction<SsoPageEmailDomainExclusivitySetMutation, SsoPageEmailDomainExclusivitySetMutationVariables>;

/**
 * __useSsoPageEmailDomainExclusivitySetMutation__
 *
 * To run a mutation, you first call `useSsoPageEmailDomainExclusivitySetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoPageEmailDomainExclusivitySetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoPageEmailDomainExclusivitySetMutation, { data, loading, error }] = useSsoPageEmailDomainExclusivitySetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSsoPageEmailDomainExclusivitySetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SsoPageEmailDomainExclusivitySetMutation, SsoPageEmailDomainExclusivitySetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SsoPageEmailDomainExclusivitySetMutation, SsoPageEmailDomainExclusivitySetMutationVariables>(SsoPageEmailDomainExclusivitySetDocument, options);
      }
export type SsoPageEmailDomainExclusivitySetMutationHookResult = ReturnType<typeof useSsoPageEmailDomainExclusivitySetMutation>;
export type SsoPageEmailDomainExclusivitySetMutationResult = ApolloReactCommon.MutationResult<SsoPageEmailDomainExclusivitySetMutation>;
export type SsoPageEmailDomainExclusivitySetMutationOptions = ApolloReactCommon.BaseMutationOptions<SsoPageEmailDomainExclusivitySetMutation, SsoPageEmailDomainExclusivitySetMutationVariables>;
export const SsoPageRoleMappingCreateDocument = gql`
    mutation SsoPageRoleMappingCreate($input: SsoRoleMappingCreateInput!) {
  ssoRoleMappingCreate(input: $input) {
    ... on SsoRoleMapping {
      ...SsoPageRoleMappingFragment
    }
    ... on SsoRoleMappingAlreadyExists {
      message
    }
    ... on NotFoundError {
      message
    }
    ... on InputValidationFailure {
      ...SsoPageInvalidFieldsFragment
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    ${SsoPageRoleMappingFragmentFragmentDoc}
${SsoPageInvalidFieldsFragmentFragmentDoc}`;
export type SsoPageRoleMappingCreateMutationFn = ApolloReactCommon.MutationFunction<SsoPageRoleMappingCreateMutation, SsoPageRoleMappingCreateMutationVariables>;

/**
 * __useSsoPageRoleMappingCreateMutation__
 *
 * To run a mutation, you first call `useSsoPageRoleMappingCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoPageRoleMappingCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoPageRoleMappingCreateMutation, { data, loading, error }] = useSsoPageRoleMappingCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSsoPageRoleMappingCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SsoPageRoleMappingCreateMutation, SsoPageRoleMappingCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SsoPageRoleMappingCreateMutation, SsoPageRoleMappingCreateMutationVariables>(SsoPageRoleMappingCreateDocument, options);
      }
export type SsoPageRoleMappingCreateMutationHookResult = ReturnType<typeof useSsoPageRoleMappingCreateMutation>;
export type SsoPageRoleMappingCreateMutationResult = ApolloReactCommon.MutationResult<SsoPageRoleMappingCreateMutation>;
export type SsoPageRoleMappingCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<SsoPageRoleMappingCreateMutation, SsoPageRoleMappingCreateMutationVariables>;
export const SsoPageRoleMappingDeleteDocument = gql`
    mutation SsoPageRoleMappingDelete($input: SsoRoleMappingDeleteInput!) {
  ssoRoleMappingDelete(input: $input) {
    ... on SsoRoleMappingDeleteSuccess {
      responseType
    }
    ... on NotFoundError {
      message
    }
    ... on InputValidationFailure {
      ...SsoPageInvalidFieldsFragment
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    ${SsoPageInvalidFieldsFragmentFragmentDoc}`;
export type SsoPageRoleMappingDeleteMutationFn = ApolloReactCommon.MutationFunction<SsoPageRoleMappingDeleteMutation, SsoPageRoleMappingDeleteMutationVariables>;

/**
 * __useSsoPageRoleMappingDeleteMutation__
 *
 * To run a mutation, you first call `useSsoPageRoleMappingDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSsoPageRoleMappingDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ssoPageRoleMappingDeleteMutation, { data, loading, error }] = useSsoPageRoleMappingDeleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSsoPageRoleMappingDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SsoPageRoleMappingDeleteMutation, SsoPageRoleMappingDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SsoPageRoleMappingDeleteMutation, SsoPageRoleMappingDeleteMutationVariables>(SsoPageRoleMappingDeleteDocument, options);
      }
export type SsoPageRoleMappingDeleteMutationHookResult = ReturnType<typeof useSsoPageRoleMappingDeleteMutation>;
export type SsoPageRoleMappingDeleteMutationResult = ApolloReactCommon.MutationResult<SsoPageRoleMappingDeleteMutation>;
export type SsoPageRoleMappingDeleteMutationOptions = ApolloReactCommon.BaseMutationOptions<SsoPageRoleMappingDeleteMutation, SsoPageRoleMappingDeleteMutationVariables>;
export const SsoPageChocoUserDocument = gql`
    query SsoPageChocoUser($userId: ID!) {
  user(id: $userId) {
    id
    name
    phone
    locale
    loginMethod
    createdAt
    pending
    linkedSupplier {
      id
      name
    }
    buyers(first: 30) {
      edges {
        node {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useSsoPageChocoUserQuery__
 *
 * To run a query within a React component, call `useSsoPageChocoUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoPageChocoUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoPageChocoUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSsoPageChocoUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SsoPageChocoUserQuery, SsoPageChocoUserQueryVariables> & ({ variables: SsoPageChocoUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SsoPageChocoUserQuery, SsoPageChocoUserQueryVariables>(SsoPageChocoUserDocument, options);
      }
export function useSsoPageChocoUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SsoPageChocoUserQuery, SsoPageChocoUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SsoPageChocoUserQuery, SsoPageChocoUserQueryVariables>(SsoPageChocoUserDocument, options);
        }
// @ts-ignore
export function useSsoPageChocoUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SsoPageChocoUserQuery, SsoPageChocoUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoPageChocoUserQuery, SsoPageChocoUserQueryVariables>;
export function useSsoPageChocoUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoPageChocoUserQuery, SsoPageChocoUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoPageChocoUserQuery | undefined, SsoPageChocoUserQueryVariables>;
export function useSsoPageChocoUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoPageChocoUserQuery, SsoPageChocoUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SsoPageChocoUserQuery, SsoPageChocoUserQueryVariables>(SsoPageChocoUserDocument, options);
        }
export type SsoPageChocoUserQueryHookResult = ReturnType<typeof useSsoPageChocoUserQuery>;
export type SsoPageChocoUserLazyQueryHookResult = ReturnType<typeof useSsoPageChocoUserLazyQuery>;
export type SsoPageChocoUserSuspenseQueryHookResult = ReturnType<typeof useSsoPageChocoUserSuspenseQuery>;
export type SsoPageChocoUserQueryResult = ApolloReactCommon.QueryResult<SsoPageChocoUserQuery, SsoPageChocoUserQueryVariables>;
export const SsoPageConnectionUsersDocument = gql`
    query SsoPageConnectionUsers($input: SsoConnectionUsersInput!) {
  ssoConnectionUsers(input: $input) {
    ... on SsoConnectionUserList {
      connectionId
      users {
        ...SsoPageConnectionUserFragment
      }
    }
    ... on SsoConnectionTooLarge {
      limit
      message
    }
    ... on NotFoundError {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    ${SsoPageConnectionUserFragmentFragmentDoc}`;

/**
 * __useSsoPageConnectionUsersQuery__
 *
 * To run a query within a React component, call `useSsoPageConnectionUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoPageConnectionUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoPageConnectionUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSsoPageConnectionUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SsoPageConnectionUsersQuery, SsoPageConnectionUsersQueryVariables> & ({ variables: SsoPageConnectionUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SsoPageConnectionUsersQuery, SsoPageConnectionUsersQueryVariables>(SsoPageConnectionUsersDocument, options);
      }
export function useSsoPageConnectionUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SsoPageConnectionUsersQuery, SsoPageConnectionUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SsoPageConnectionUsersQuery, SsoPageConnectionUsersQueryVariables>(SsoPageConnectionUsersDocument, options);
        }
// @ts-ignore
export function useSsoPageConnectionUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SsoPageConnectionUsersQuery, SsoPageConnectionUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoPageConnectionUsersQuery, SsoPageConnectionUsersQueryVariables>;
export function useSsoPageConnectionUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoPageConnectionUsersQuery, SsoPageConnectionUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoPageConnectionUsersQuery | undefined, SsoPageConnectionUsersQueryVariables>;
export function useSsoPageConnectionUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoPageConnectionUsersQuery, SsoPageConnectionUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SsoPageConnectionUsersQuery, SsoPageConnectionUsersQueryVariables>(SsoPageConnectionUsersDocument, options);
        }
export type SsoPageConnectionUsersQueryHookResult = ReturnType<typeof useSsoPageConnectionUsersQuery>;
export type SsoPageConnectionUsersLazyQueryHookResult = ReturnType<typeof useSsoPageConnectionUsersLazyQuery>;
export type SsoPageConnectionUsersSuspenseQueryHookResult = ReturnType<typeof useSsoPageConnectionUsersSuspenseQuery>;
export type SsoPageConnectionUsersQueryResult = ApolloReactCommon.QueryResult<SsoPageConnectionUsersQuery, SsoPageConnectionUsersQueryVariables>;
export const SsoPageConnectionsDocument = gql`
    query SsoPageConnections {
  ssoConnections {
    ... on SsoConnectionList {
      connections {
        ...SsoPageConnectionFragment
      }
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    ${SsoPageConnectionFragmentFragmentDoc}`;

/**
 * __useSsoPageConnectionsQuery__
 *
 * To run a query within a React component, call `useSsoPageConnectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoPageConnectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoPageConnectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSsoPageConnectionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SsoPageConnectionsQuery, SsoPageConnectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SsoPageConnectionsQuery, SsoPageConnectionsQueryVariables>(SsoPageConnectionsDocument, options);
      }
export function useSsoPageConnectionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SsoPageConnectionsQuery, SsoPageConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SsoPageConnectionsQuery, SsoPageConnectionsQueryVariables>(SsoPageConnectionsDocument, options);
        }
// @ts-ignore
export function useSsoPageConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SsoPageConnectionsQuery, SsoPageConnectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoPageConnectionsQuery, SsoPageConnectionsQueryVariables>;
export function useSsoPageConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoPageConnectionsQuery, SsoPageConnectionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoPageConnectionsQuery | undefined, SsoPageConnectionsQueryVariables>;
export function useSsoPageConnectionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoPageConnectionsQuery, SsoPageConnectionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SsoPageConnectionsQuery, SsoPageConnectionsQueryVariables>(SsoPageConnectionsDocument, options);
        }
export type SsoPageConnectionsQueryHookResult = ReturnType<typeof useSsoPageConnectionsQuery>;
export type SsoPageConnectionsLazyQueryHookResult = ReturnType<typeof useSsoPageConnectionsLazyQuery>;
export type SsoPageConnectionsSuspenseQueryHookResult = ReturnType<typeof useSsoPageConnectionsSuspenseQuery>;
export type SsoPageConnectionsQueryResult = ApolloReactCommon.QueryResult<SsoPageConnectionsQuery, SsoPageConnectionsQueryVariables>;
export const SsoPageEmailDomainsDocument = gql`
    query SsoPageEmailDomains($input: SsoEmailDomainsInput!) {
  ssoEmailDomains(input: $input) {
    ... on SsoEmailDomainList {
      emailDomains {
        ...SsoPageEmailDomainFragment
      }
    }
    ... on NotFoundError {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    ${SsoPageEmailDomainFragmentFragmentDoc}`;

/**
 * __useSsoPageEmailDomainsQuery__
 *
 * To run a query within a React component, call `useSsoPageEmailDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoPageEmailDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoPageEmailDomainsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSsoPageEmailDomainsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SsoPageEmailDomainsQuery, SsoPageEmailDomainsQueryVariables> & ({ variables: SsoPageEmailDomainsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SsoPageEmailDomainsQuery, SsoPageEmailDomainsQueryVariables>(SsoPageEmailDomainsDocument, options);
      }
export function useSsoPageEmailDomainsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SsoPageEmailDomainsQuery, SsoPageEmailDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SsoPageEmailDomainsQuery, SsoPageEmailDomainsQueryVariables>(SsoPageEmailDomainsDocument, options);
        }
// @ts-ignore
export function useSsoPageEmailDomainsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SsoPageEmailDomainsQuery, SsoPageEmailDomainsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoPageEmailDomainsQuery, SsoPageEmailDomainsQueryVariables>;
export function useSsoPageEmailDomainsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoPageEmailDomainsQuery, SsoPageEmailDomainsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoPageEmailDomainsQuery | undefined, SsoPageEmailDomainsQueryVariables>;
export function useSsoPageEmailDomainsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoPageEmailDomainsQuery, SsoPageEmailDomainsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SsoPageEmailDomainsQuery, SsoPageEmailDomainsQueryVariables>(SsoPageEmailDomainsDocument, options);
        }
export type SsoPageEmailDomainsQueryHookResult = ReturnType<typeof useSsoPageEmailDomainsQuery>;
export type SsoPageEmailDomainsLazyQueryHookResult = ReturnType<typeof useSsoPageEmailDomainsLazyQuery>;
export type SsoPageEmailDomainsSuspenseQueryHookResult = ReturnType<typeof useSsoPageEmailDomainsSuspenseQuery>;
export type SsoPageEmailDomainsQueryResult = ApolloReactCommon.QueryResult<SsoPageEmailDomainsQuery, SsoPageEmailDomainsQueryVariables>;
export const SsoPageRoleMappingsDocument = gql`
    query SsoPageRoleMappings($input: SsoRoleMappingsInput!) {
  ssoRoleMappings(input: $input) {
    ... on SsoRoleMappingList {
      roleMappings {
        ...SsoPageRoleMappingFragment
      }
    }
    ... on NotFoundError {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    ${SsoPageRoleMappingFragmentFragmentDoc}`;

/**
 * __useSsoPageRoleMappingsQuery__
 *
 * To run a query within a React component, call `useSsoPageRoleMappingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoPageRoleMappingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoPageRoleMappingsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSsoPageRoleMappingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SsoPageRoleMappingsQuery, SsoPageRoleMappingsQueryVariables> & ({ variables: SsoPageRoleMappingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SsoPageRoleMappingsQuery, SsoPageRoleMappingsQueryVariables>(SsoPageRoleMappingsDocument, options);
      }
export function useSsoPageRoleMappingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SsoPageRoleMappingsQuery, SsoPageRoleMappingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SsoPageRoleMappingsQuery, SsoPageRoleMappingsQueryVariables>(SsoPageRoleMappingsDocument, options);
        }
// @ts-ignore
export function useSsoPageRoleMappingsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SsoPageRoleMappingsQuery, SsoPageRoleMappingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoPageRoleMappingsQuery, SsoPageRoleMappingsQueryVariables>;
export function useSsoPageRoleMappingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoPageRoleMappingsQuery, SsoPageRoleMappingsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoPageRoleMappingsQuery | undefined, SsoPageRoleMappingsQueryVariables>;
export function useSsoPageRoleMappingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoPageRoleMappingsQuery, SsoPageRoleMappingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SsoPageRoleMappingsQuery, SsoPageRoleMappingsQueryVariables>(SsoPageRoleMappingsDocument, options);
        }
export type SsoPageRoleMappingsQueryHookResult = ReturnType<typeof useSsoPageRoleMappingsQuery>;
export type SsoPageRoleMappingsLazyQueryHookResult = ReturnType<typeof useSsoPageRoleMappingsLazyQuery>;
export type SsoPageRoleMappingsSuspenseQueryHookResult = ReturnType<typeof useSsoPageRoleMappingsSuspenseQuery>;
export type SsoPageRoleMappingsQueryResult = ApolloReactCommon.QueryResult<SsoPageRoleMappingsQuery, SsoPageRoleMappingsQueryVariables>;
export const SsoPageSearchSuppliersDocument = gql`
    query SsoPageSearchSuppliers($keywords: String, $limit: Int = 30, $filter: SupplierSearchFilter) {
  supplierSearch(first: $limit, query: {keywords: $keywords, filter: $filter}) {
    ... on SearchSupplierConnection {
      edges {
        node {
          id
          name
          referenceId
        }
      }
    }
  }
}
    `;

/**
 * __useSsoPageSearchSuppliersQuery__
 *
 * To run a query within a React component, call `useSsoPageSearchSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSsoPageSearchSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSsoPageSearchSuppliersQuery({
 *   variables: {
 *      keywords: // value for 'keywords'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSsoPageSearchSuppliersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SsoPageSearchSuppliersQuery, SsoPageSearchSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SsoPageSearchSuppliersQuery, SsoPageSearchSuppliersQueryVariables>(SsoPageSearchSuppliersDocument, options);
      }
export function useSsoPageSearchSuppliersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SsoPageSearchSuppliersQuery, SsoPageSearchSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SsoPageSearchSuppliersQuery, SsoPageSearchSuppliersQueryVariables>(SsoPageSearchSuppliersDocument, options);
        }
// @ts-ignore
export function useSsoPageSearchSuppliersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SsoPageSearchSuppliersQuery, SsoPageSearchSuppliersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoPageSearchSuppliersQuery, SsoPageSearchSuppliersQueryVariables>;
export function useSsoPageSearchSuppliersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoPageSearchSuppliersQuery, SsoPageSearchSuppliersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SsoPageSearchSuppliersQuery | undefined, SsoPageSearchSuppliersQueryVariables>;
export function useSsoPageSearchSuppliersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SsoPageSearchSuppliersQuery, SsoPageSearchSuppliersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SsoPageSearchSuppliersQuery, SsoPageSearchSuppliersQueryVariables>(SsoPageSearchSuppliersDocument, options);
        }
export type SsoPageSearchSuppliersQueryHookResult = ReturnType<typeof useSsoPageSearchSuppliersQuery>;
export type SsoPageSearchSuppliersLazyQueryHookResult = ReturnType<typeof useSsoPageSearchSuppliersLazyQuery>;
export type SsoPageSearchSuppliersSuspenseQueryHookResult = ReturnType<typeof useSsoPageSearchSuppliersSuspenseQuery>;
export type SsoPageSearchSuppliersQueryResult = ApolloReactCommon.QueryResult<SsoPageSearchSuppliersQuery, SsoPageSearchSuppliersQueryVariables>;
export const SuppliersPageCustomCatalogsForVendorDocument = gql`
    query SuppliersPageCustomCatalogsForVendor($input: CustomCatalogsForVendorInput!) {
  customCatalogsForVendor(input: $input) {
    ... on CustomCatalogsForVendorResult {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;

/**
 * __useSuppliersPageCustomCatalogsForVendorQuery__
 *
 * To run a query within a React component, call `useSuppliersPageCustomCatalogsForVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageCustomCatalogsForVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersPageCustomCatalogsForVendorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuppliersPageCustomCatalogsForVendorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuppliersPageCustomCatalogsForVendorQuery, SuppliersPageCustomCatalogsForVendorQueryVariables> & ({ variables: SuppliersPageCustomCatalogsForVendorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuppliersPageCustomCatalogsForVendorQuery, SuppliersPageCustomCatalogsForVendorQueryVariables>(SuppliersPageCustomCatalogsForVendorDocument, options);
      }
export function useSuppliersPageCustomCatalogsForVendorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuppliersPageCustomCatalogsForVendorQuery, SuppliersPageCustomCatalogsForVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuppliersPageCustomCatalogsForVendorQuery, SuppliersPageCustomCatalogsForVendorQueryVariables>(SuppliersPageCustomCatalogsForVendorDocument, options);
        }
// @ts-ignore
export function useSuppliersPageCustomCatalogsForVendorSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageCustomCatalogsForVendorQuery, SuppliersPageCustomCatalogsForVendorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageCustomCatalogsForVendorQuery, SuppliersPageCustomCatalogsForVendorQueryVariables>;
export function useSuppliersPageCustomCatalogsForVendorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageCustomCatalogsForVendorQuery, SuppliersPageCustomCatalogsForVendorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageCustomCatalogsForVendorQuery | undefined, SuppliersPageCustomCatalogsForVendorQueryVariables>;
export function useSuppliersPageCustomCatalogsForVendorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageCustomCatalogsForVendorQuery, SuppliersPageCustomCatalogsForVendorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuppliersPageCustomCatalogsForVendorQuery, SuppliersPageCustomCatalogsForVendorQueryVariables>(SuppliersPageCustomCatalogsForVendorDocument, options);
        }
export type SuppliersPageCustomCatalogsForVendorQueryHookResult = ReturnType<typeof useSuppliersPageCustomCatalogsForVendorQuery>;
export type SuppliersPageCustomCatalogsForVendorLazyQueryHookResult = ReturnType<typeof useSuppliersPageCustomCatalogsForVendorLazyQuery>;
export type SuppliersPageCustomCatalogsForVendorSuspenseQueryHookResult = ReturnType<typeof useSuppliersPageCustomCatalogsForVendorSuspenseQuery>;
export type SuppliersPageCustomCatalogsForVendorQueryResult = ApolloReactCommon.QueryResult<SuppliersPageCustomCatalogsForVendorQuery, SuppliersPageCustomCatalogsForVendorQueryVariables>;
export const SuppliersPageCustomCatalogsDocument = gql`
    query SuppliersPageCustomCatalogs($input: CustomCatalogsInput!) {
  customCatalogs(input: $input) {
    ... on CustomCatalogsResult {
      customCatalogs {
        id
        name
      }
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;

/**
 * __useSuppliersPageCustomCatalogsQuery__
 *
 * To run a query within a React component, call `useSuppliersPageCustomCatalogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageCustomCatalogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersPageCustomCatalogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuppliersPageCustomCatalogsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuppliersPageCustomCatalogsQuery, SuppliersPageCustomCatalogsQueryVariables> & ({ variables: SuppliersPageCustomCatalogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuppliersPageCustomCatalogsQuery, SuppliersPageCustomCatalogsQueryVariables>(SuppliersPageCustomCatalogsDocument, options);
      }
export function useSuppliersPageCustomCatalogsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuppliersPageCustomCatalogsQuery, SuppliersPageCustomCatalogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuppliersPageCustomCatalogsQuery, SuppliersPageCustomCatalogsQueryVariables>(SuppliersPageCustomCatalogsDocument, options);
        }
// @ts-ignore
export function useSuppliersPageCustomCatalogsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageCustomCatalogsQuery, SuppliersPageCustomCatalogsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageCustomCatalogsQuery, SuppliersPageCustomCatalogsQueryVariables>;
export function useSuppliersPageCustomCatalogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageCustomCatalogsQuery, SuppliersPageCustomCatalogsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageCustomCatalogsQuery | undefined, SuppliersPageCustomCatalogsQueryVariables>;
export function useSuppliersPageCustomCatalogsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageCustomCatalogsQuery, SuppliersPageCustomCatalogsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuppliersPageCustomCatalogsQuery, SuppliersPageCustomCatalogsQueryVariables>(SuppliersPageCustomCatalogsDocument, options);
        }
export type SuppliersPageCustomCatalogsQueryHookResult = ReturnType<typeof useSuppliersPageCustomCatalogsQuery>;
export type SuppliersPageCustomCatalogsLazyQueryHookResult = ReturnType<typeof useSuppliersPageCustomCatalogsLazyQuery>;
export type SuppliersPageCustomCatalogsSuspenseQueryHookResult = ReturnType<typeof useSuppliersPageCustomCatalogsSuspenseQuery>;
export type SuppliersPageCustomCatalogsQueryResult = ApolloReactCommon.QueryResult<SuppliersPageCustomCatalogsQuery, SuppliersPageCustomCatalogsQueryVariables>;
export const SuppliersPageVendorItemUnitDetailDocument = gql`
    query SuppliersPageVendorItemUnitDetail($ids: [ID!]!) {
  vendorItemUnits(ids: $ids) {
    ...SuppliersPageVendorCatalogUnitDetailResponse
  }
}
    ${SuppliersPageVendorCatalogUnitDetailResponseFragmentDoc}`;

/**
 * __useSuppliersPageVendorItemUnitDetailQuery__
 *
 * To run a query within a React component, call `useSuppliersPageVendorItemUnitDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageVendorItemUnitDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersPageVendorItemUnitDetailQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSuppliersPageVendorItemUnitDetailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuppliersPageVendorItemUnitDetailQuery, SuppliersPageVendorItemUnitDetailQueryVariables> & ({ variables: SuppliersPageVendorItemUnitDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuppliersPageVendorItemUnitDetailQuery, SuppliersPageVendorItemUnitDetailQueryVariables>(SuppliersPageVendorItemUnitDetailDocument, options);
      }
export function useSuppliersPageVendorItemUnitDetailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuppliersPageVendorItemUnitDetailQuery, SuppliersPageVendorItemUnitDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuppliersPageVendorItemUnitDetailQuery, SuppliersPageVendorItemUnitDetailQueryVariables>(SuppliersPageVendorItemUnitDetailDocument, options);
        }
// @ts-ignore
export function useSuppliersPageVendorItemUnitDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageVendorItemUnitDetailQuery, SuppliersPageVendorItemUnitDetailQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageVendorItemUnitDetailQuery, SuppliersPageVendorItemUnitDetailQueryVariables>;
export function useSuppliersPageVendorItemUnitDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageVendorItemUnitDetailQuery, SuppliersPageVendorItemUnitDetailQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageVendorItemUnitDetailQuery | undefined, SuppliersPageVendorItemUnitDetailQueryVariables>;
export function useSuppliersPageVendorItemUnitDetailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageVendorItemUnitDetailQuery, SuppliersPageVendorItemUnitDetailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuppliersPageVendorItemUnitDetailQuery, SuppliersPageVendorItemUnitDetailQueryVariables>(SuppliersPageVendorItemUnitDetailDocument, options);
        }
export type SuppliersPageVendorItemUnitDetailQueryHookResult = ReturnType<typeof useSuppliersPageVendorItemUnitDetailQuery>;
export type SuppliersPageVendorItemUnitDetailLazyQueryHookResult = ReturnType<typeof useSuppliersPageVendorItemUnitDetailLazyQuery>;
export type SuppliersPageVendorItemUnitDetailSuspenseQueryHookResult = ReturnType<typeof useSuppliersPageVendorItemUnitDetailSuspenseQuery>;
export type SuppliersPageVendorItemUnitDetailQueryResult = ApolloReactCommon.QueryResult<SuppliersPageVendorItemUnitDetailQuery, SuppliersPageVendorItemUnitDetailQueryVariables>;
export const SuppliersPageVendorItemUnitsForVendorSearchDocument = gql`
    query SuppliersPageVendorItemUnitsForVendorSearch($input: VendorItemUnitsForVendorSearchInput!) {
  vendorItemUnitsForVendorSearch(input: $input) {
    ...SuppliersPageVendorCatalogResponse
  }
}
    ${SuppliersPageVendorCatalogResponseFragmentDoc}`;

/**
 * __useSuppliersPageVendorItemUnitsForVendorSearchQuery__
 *
 * To run a query within a React component, call `useSuppliersPageVendorItemUnitsForVendorSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageVendorItemUnitsForVendorSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersPageVendorItemUnitsForVendorSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuppliersPageVendorItemUnitsForVendorSearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuppliersPageVendorItemUnitsForVendorSearchQuery, SuppliersPageVendorItemUnitsForVendorSearchQueryVariables> & ({ variables: SuppliersPageVendorItemUnitsForVendorSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuppliersPageVendorItemUnitsForVendorSearchQuery, SuppliersPageVendorItemUnitsForVendorSearchQueryVariables>(SuppliersPageVendorItemUnitsForVendorSearchDocument, options);
      }
export function useSuppliersPageVendorItemUnitsForVendorSearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuppliersPageVendorItemUnitsForVendorSearchQuery, SuppliersPageVendorItemUnitsForVendorSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuppliersPageVendorItemUnitsForVendorSearchQuery, SuppliersPageVendorItemUnitsForVendorSearchQueryVariables>(SuppliersPageVendorItemUnitsForVendorSearchDocument, options);
        }
// @ts-ignore
export function useSuppliersPageVendorItemUnitsForVendorSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageVendorItemUnitsForVendorSearchQuery, SuppliersPageVendorItemUnitsForVendorSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageVendorItemUnitsForVendorSearchQuery, SuppliersPageVendorItemUnitsForVendorSearchQueryVariables>;
export function useSuppliersPageVendorItemUnitsForVendorSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageVendorItemUnitsForVendorSearchQuery, SuppliersPageVendorItemUnitsForVendorSearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageVendorItemUnitsForVendorSearchQuery | undefined, SuppliersPageVendorItemUnitsForVendorSearchQueryVariables>;
export function useSuppliersPageVendorItemUnitsForVendorSearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageVendorItemUnitsForVendorSearchQuery, SuppliersPageVendorItemUnitsForVendorSearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuppliersPageVendorItemUnitsForVendorSearchQuery, SuppliersPageVendorItemUnitsForVendorSearchQueryVariables>(SuppliersPageVendorItemUnitsForVendorSearchDocument, options);
        }
export type SuppliersPageVendorItemUnitsForVendorSearchQueryHookResult = ReturnType<typeof useSuppliersPageVendorItemUnitsForVendorSearchQuery>;
export type SuppliersPageVendorItemUnitsForVendorSearchLazyQueryHookResult = ReturnType<typeof useSuppliersPageVendorItemUnitsForVendorSearchLazyQuery>;
export type SuppliersPageVendorItemUnitsForVendorSearchSuspenseQueryHookResult = ReturnType<typeof useSuppliersPageVendorItemUnitsForVendorSearchSuspenseQuery>;
export type SuppliersPageVendorItemUnitsForVendorSearchQueryResult = ApolloReactCommon.QueryResult<SuppliersPageVendorItemUnitsForVendorSearchQuery, SuppliersPageVendorItemUnitsForVendorSearchQueryVariables>;
export const SuppliersPageVendorItemsForVendorDocument = gql`
    query SuppliersPageVendorItemsForVendor($input: VendorItemsForVendorInput!) {
  vendorItemsForVendor(input: $input) {
    ...SuppliersPageVendorCatalogResponse
  }
}
    ${SuppliersPageVendorCatalogResponseFragmentDoc}`;

/**
 * __useSuppliersPageVendorItemsForVendorQuery__
 *
 * To run a query within a React component, call `useSuppliersPageVendorItemsForVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageVendorItemsForVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersPageVendorItemsForVendorQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuppliersPageVendorItemsForVendorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuppliersPageVendorItemsForVendorQuery, SuppliersPageVendorItemsForVendorQueryVariables> & ({ variables: SuppliersPageVendorItemsForVendorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuppliersPageVendorItemsForVendorQuery, SuppliersPageVendorItemsForVendorQueryVariables>(SuppliersPageVendorItemsForVendorDocument, options);
      }
export function useSuppliersPageVendorItemsForVendorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuppliersPageVendorItemsForVendorQuery, SuppliersPageVendorItemsForVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuppliersPageVendorItemsForVendorQuery, SuppliersPageVendorItemsForVendorQueryVariables>(SuppliersPageVendorItemsForVendorDocument, options);
        }
// @ts-ignore
export function useSuppliersPageVendorItemsForVendorSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageVendorItemsForVendorQuery, SuppliersPageVendorItemsForVendorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageVendorItemsForVendorQuery, SuppliersPageVendorItemsForVendorQueryVariables>;
export function useSuppliersPageVendorItemsForVendorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageVendorItemsForVendorQuery, SuppliersPageVendorItemsForVendorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageVendorItemsForVendorQuery | undefined, SuppliersPageVendorItemsForVendorQueryVariables>;
export function useSuppliersPageVendorItemsForVendorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageVendorItemsForVendorQuery, SuppliersPageVendorItemsForVendorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuppliersPageVendorItemsForVendorQuery, SuppliersPageVendorItemsForVendorQueryVariables>(SuppliersPageVendorItemsForVendorDocument, options);
        }
export type SuppliersPageVendorItemsForVendorQueryHookResult = ReturnType<typeof useSuppliersPageVendorItemsForVendorQuery>;
export type SuppliersPageVendorItemsForVendorLazyQueryHookResult = ReturnType<typeof useSuppliersPageVendorItemsForVendorLazyQuery>;
export type SuppliersPageVendorItemsForVendorSuspenseQueryHookResult = ReturnType<typeof useSuppliersPageVendorItemsForVendorSuspenseQuery>;
export type SuppliersPageVendorItemsForVendorQueryResult = ApolloReactCommon.QueryResult<SuppliersPageVendorItemsForVendorQuery, SuppliersPageVendorItemsForVendorQueryVariables>;
export const SuppliersPageOrderAgentSettingUpdateDocument = gql`
    mutation SuppliersPageOrderAgentSettingUpdate($input: SupplierSettingInput!) {
  supplierSetting(input: $input) {
    __typename
    ... on SupplierSetting {
      supplierId
      isOrderAgentEnabled
    }
    ... on NotFoundError {
      message
    }
    ... on AuthorizationFailure {
      message
    }
    ... on InputValidationFailure {
      message
    }
  }
}
    `;
export type SuppliersPageOrderAgentSettingUpdateMutationFn = ApolloReactCommon.MutationFunction<SuppliersPageOrderAgentSettingUpdateMutation, SuppliersPageOrderAgentSettingUpdateMutationVariables>;

/**
 * __useSuppliersPageOrderAgentSettingUpdateMutation__
 *
 * To run a mutation, you first call `useSuppliersPageOrderAgentSettingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageOrderAgentSettingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suppliersPageOrderAgentSettingUpdateMutation, { data, loading, error }] = useSuppliersPageOrderAgentSettingUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuppliersPageOrderAgentSettingUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuppliersPageOrderAgentSettingUpdateMutation, SuppliersPageOrderAgentSettingUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuppliersPageOrderAgentSettingUpdateMutation, SuppliersPageOrderAgentSettingUpdateMutationVariables>(SuppliersPageOrderAgentSettingUpdateDocument, options);
      }
export type SuppliersPageOrderAgentSettingUpdateMutationHookResult = ReturnType<typeof useSuppliersPageOrderAgentSettingUpdateMutation>;
export type SuppliersPageOrderAgentSettingUpdateMutationResult = ApolloReactCommon.MutationResult<SuppliersPageOrderAgentSettingUpdateMutation>;
export type SuppliersPageOrderAgentSettingUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<SuppliersPageOrderAgentSettingUpdateMutation, SuppliersPageOrderAgentSettingUpdateMutationVariables>;
export const SuppliersPageOrderAgentSettingDocument = gql`
    query SuppliersPageOrderAgentSetting($id: ID!) {
  supplier(id: $id) {
    id
    chocoAiSupplierSetting {
      supplierId
      isOrderAgentEnabled
    }
  }
}
    `;

/**
 * __useSuppliersPageOrderAgentSettingQuery__
 *
 * To run a query within a React component, call `useSuppliersPageOrderAgentSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageOrderAgentSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersPageOrderAgentSettingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuppliersPageOrderAgentSettingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuppliersPageOrderAgentSettingQuery, SuppliersPageOrderAgentSettingQueryVariables> & ({ variables: SuppliersPageOrderAgentSettingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuppliersPageOrderAgentSettingQuery, SuppliersPageOrderAgentSettingQueryVariables>(SuppliersPageOrderAgentSettingDocument, options);
      }
export function useSuppliersPageOrderAgentSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuppliersPageOrderAgentSettingQuery, SuppliersPageOrderAgentSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuppliersPageOrderAgentSettingQuery, SuppliersPageOrderAgentSettingQueryVariables>(SuppliersPageOrderAgentSettingDocument, options);
        }
// @ts-ignore
export function useSuppliersPageOrderAgentSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageOrderAgentSettingQuery, SuppliersPageOrderAgentSettingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageOrderAgentSettingQuery, SuppliersPageOrderAgentSettingQueryVariables>;
export function useSuppliersPageOrderAgentSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageOrderAgentSettingQuery, SuppliersPageOrderAgentSettingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageOrderAgentSettingQuery | undefined, SuppliersPageOrderAgentSettingQueryVariables>;
export function useSuppliersPageOrderAgentSettingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageOrderAgentSettingQuery, SuppliersPageOrderAgentSettingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuppliersPageOrderAgentSettingQuery, SuppliersPageOrderAgentSettingQueryVariables>(SuppliersPageOrderAgentSettingDocument, options);
        }
export type SuppliersPageOrderAgentSettingQueryHookResult = ReturnType<typeof useSuppliersPageOrderAgentSettingQuery>;
export type SuppliersPageOrderAgentSettingLazyQueryHookResult = ReturnType<typeof useSuppliersPageOrderAgentSettingLazyQuery>;
export type SuppliersPageOrderAgentSettingSuspenseQueryHookResult = ReturnType<typeof useSuppliersPageOrderAgentSettingSuspenseQuery>;
export type SuppliersPageOrderAgentSettingQueryResult = ApolloReactCommon.QueryResult<SuppliersPageOrderAgentSettingQuery, SuppliersPageOrderAgentSettingQueryVariables>;
export const SuppliersPageVendorPromotionMarketingUpdateDocument = gql`
    mutation SuppliersPageVendorPromotionMarketingUpdate($input: VendorPromotionMarketingUpdateInput!) {
  vendorPromotionMarketingUpdate(input: $input) {
    __typename
    ... on VendorPromotionMarketingUpdateResult {
      responseType
      record {
        ...SuppliersPageVendorPromotionRecord
      }
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
    ... on NotFoundError {
      message
    }
  }
}
    ${SuppliersPageVendorPromotionRecordFragmentDoc}`;
export type SuppliersPageVendorPromotionMarketingUpdateMutationFn = ApolloReactCommon.MutationFunction<SuppliersPageVendorPromotionMarketingUpdateMutation, SuppliersPageVendorPromotionMarketingUpdateMutationVariables>;

/**
 * __useSuppliersPageVendorPromotionMarketingUpdateMutation__
 *
 * To run a mutation, you first call `useSuppliersPageVendorPromotionMarketingUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageVendorPromotionMarketingUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suppliersPageVendorPromotionMarketingUpdateMutation, { data, loading, error }] = useSuppliersPageVendorPromotionMarketingUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuppliersPageVendorPromotionMarketingUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuppliersPageVendorPromotionMarketingUpdateMutation, SuppliersPageVendorPromotionMarketingUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuppliersPageVendorPromotionMarketingUpdateMutation, SuppliersPageVendorPromotionMarketingUpdateMutationVariables>(SuppliersPageVendorPromotionMarketingUpdateDocument, options);
      }
export type SuppliersPageVendorPromotionMarketingUpdateMutationHookResult = ReturnType<typeof useSuppliersPageVendorPromotionMarketingUpdateMutation>;
export type SuppliersPageVendorPromotionMarketingUpdateMutationResult = ApolloReactCommon.MutationResult<SuppliersPageVendorPromotionMarketingUpdateMutation>;
export type SuppliersPageVendorPromotionMarketingUpdateMutationOptions = ApolloReactCommon.BaseMutationOptions<SuppliersPageVendorPromotionMarketingUpdateMutation, SuppliersPageVendorPromotionMarketingUpdateMutationVariables>;
export const SuppliersPageVendorPromotionListDocument = gql`
    query SuppliersPageVendorPromotionList($input: VendorPromotionListInput!) {
  vendorPromotionList(input: $input) {
    __typename
    ... on VendorPromotionListResult {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          ...SuppliersPageVendorPromotionRecord
        }
      }
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
    ... on NotFoundError {
      message
    }
  }
}
    ${SuppliersPageVendorPromotionRecordFragmentDoc}`;

/**
 * __useSuppliersPageVendorPromotionListQuery__
 *
 * To run a query within a React component, call `useSuppliersPageVendorPromotionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageVendorPromotionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersPageVendorPromotionListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuppliersPageVendorPromotionListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuppliersPageVendorPromotionListQuery, SuppliersPageVendorPromotionListQueryVariables> & ({ variables: SuppliersPageVendorPromotionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuppliersPageVendorPromotionListQuery, SuppliersPageVendorPromotionListQueryVariables>(SuppliersPageVendorPromotionListDocument, options);
      }
export function useSuppliersPageVendorPromotionListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuppliersPageVendorPromotionListQuery, SuppliersPageVendorPromotionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuppliersPageVendorPromotionListQuery, SuppliersPageVendorPromotionListQueryVariables>(SuppliersPageVendorPromotionListDocument, options);
        }
// @ts-ignore
export function useSuppliersPageVendorPromotionListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageVendorPromotionListQuery, SuppliersPageVendorPromotionListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageVendorPromotionListQuery, SuppliersPageVendorPromotionListQueryVariables>;
export function useSuppliersPageVendorPromotionListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageVendorPromotionListQuery, SuppliersPageVendorPromotionListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageVendorPromotionListQuery | undefined, SuppliersPageVendorPromotionListQueryVariables>;
export function useSuppliersPageVendorPromotionListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageVendorPromotionListQuery, SuppliersPageVendorPromotionListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuppliersPageVendorPromotionListQuery, SuppliersPageVendorPromotionListQueryVariables>(SuppliersPageVendorPromotionListDocument, options);
        }
export type SuppliersPageVendorPromotionListQueryHookResult = ReturnType<typeof useSuppliersPageVendorPromotionListQuery>;
export type SuppliersPageVendorPromotionListLazyQueryHookResult = ReturnType<typeof useSuppliersPageVendorPromotionListLazyQuery>;
export type SuppliersPageVendorPromotionListSuspenseQueryHookResult = ReturnType<typeof useSuppliersPageVendorPromotionListSuspenseQuery>;
export type SuppliersPageVendorPromotionListQueryResult = ApolloReactCommon.QueryResult<SuppliersPageVendorPromotionListQuery, SuppliersPageVendorPromotionListQueryVariables>;
export const SuppliersPageChatTaxProfileListDocument = gql`
    query SuppliersPageChatTaxProfileList($input: ChatTaxProfileListInput!) {
  chatTaxProfileList(input: $input) {
    __typename
    ... on ChatTaxProfileListResult {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          ...SuppliersPageChatTaxProfile
        }
      }
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    ${SuppliersPageChatTaxProfileFragmentDoc}`;

/**
 * __useSuppliersPageChatTaxProfileListQuery__
 *
 * To run a query within a React component, call `useSuppliersPageChatTaxProfileListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageChatTaxProfileListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersPageChatTaxProfileListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuppliersPageChatTaxProfileListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuppliersPageChatTaxProfileListQuery, SuppliersPageChatTaxProfileListQueryVariables> & ({ variables: SuppliersPageChatTaxProfileListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuppliersPageChatTaxProfileListQuery, SuppliersPageChatTaxProfileListQueryVariables>(SuppliersPageChatTaxProfileListDocument, options);
      }
export function useSuppliersPageChatTaxProfileListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuppliersPageChatTaxProfileListQuery, SuppliersPageChatTaxProfileListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuppliersPageChatTaxProfileListQuery, SuppliersPageChatTaxProfileListQueryVariables>(SuppliersPageChatTaxProfileListDocument, options);
        }
// @ts-ignore
export function useSuppliersPageChatTaxProfileListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageChatTaxProfileListQuery, SuppliersPageChatTaxProfileListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageChatTaxProfileListQuery, SuppliersPageChatTaxProfileListQueryVariables>;
export function useSuppliersPageChatTaxProfileListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageChatTaxProfileListQuery, SuppliersPageChatTaxProfileListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageChatTaxProfileListQuery | undefined, SuppliersPageChatTaxProfileListQueryVariables>;
export function useSuppliersPageChatTaxProfileListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageChatTaxProfileListQuery, SuppliersPageChatTaxProfileListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuppliersPageChatTaxProfileListQuery, SuppliersPageChatTaxProfileListQueryVariables>(SuppliersPageChatTaxProfileListDocument, options);
        }
export type SuppliersPageChatTaxProfileListQueryHookResult = ReturnType<typeof useSuppliersPageChatTaxProfileListQuery>;
export type SuppliersPageChatTaxProfileListLazyQueryHookResult = ReturnType<typeof useSuppliersPageChatTaxProfileListLazyQuery>;
export type SuppliersPageChatTaxProfileListSuspenseQueryHookResult = ReturnType<typeof useSuppliersPageChatTaxProfileListSuspenseQuery>;
export type SuppliersPageChatTaxProfileListQueryResult = ApolloReactCommon.QueryResult<SuppliersPageChatTaxProfileListQuery, SuppliersPageChatTaxProfileListQueryVariables>;
export const SuppliersPageTaxJurisdictionListDocument = gql`
    query SuppliersPageTaxJurisdictionList($input: TaxJurisdictionListInput!) {
  taxJurisdictionList(input: $input) {
    __typename
    ... on TaxJurisdictionListResult {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          ...SuppliersPageTaxJurisdiction
        }
      }
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    ${SuppliersPageTaxJurisdictionFragmentDoc}`;

/**
 * __useSuppliersPageTaxJurisdictionListQuery__
 *
 * To run a query within a React component, call `useSuppliersPageTaxJurisdictionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageTaxJurisdictionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersPageTaxJurisdictionListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuppliersPageTaxJurisdictionListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuppliersPageTaxJurisdictionListQuery, SuppliersPageTaxJurisdictionListQueryVariables> & ({ variables: SuppliersPageTaxJurisdictionListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuppliersPageTaxJurisdictionListQuery, SuppliersPageTaxJurisdictionListQueryVariables>(SuppliersPageTaxJurisdictionListDocument, options);
      }
export function useSuppliersPageTaxJurisdictionListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuppliersPageTaxJurisdictionListQuery, SuppliersPageTaxJurisdictionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuppliersPageTaxJurisdictionListQuery, SuppliersPageTaxJurisdictionListQueryVariables>(SuppliersPageTaxJurisdictionListDocument, options);
        }
// @ts-ignore
export function useSuppliersPageTaxJurisdictionListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageTaxJurisdictionListQuery, SuppliersPageTaxJurisdictionListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageTaxJurisdictionListQuery, SuppliersPageTaxJurisdictionListQueryVariables>;
export function useSuppliersPageTaxJurisdictionListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageTaxJurisdictionListQuery, SuppliersPageTaxJurisdictionListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageTaxJurisdictionListQuery | undefined, SuppliersPageTaxJurisdictionListQueryVariables>;
export function useSuppliersPageTaxJurisdictionListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageTaxJurisdictionListQuery, SuppliersPageTaxJurisdictionListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuppliersPageTaxJurisdictionListQuery, SuppliersPageTaxJurisdictionListQueryVariables>(SuppliersPageTaxJurisdictionListDocument, options);
        }
export type SuppliersPageTaxJurisdictionListQueryHookResult = ReturnType<typeof useSuppliersPageTaxJurisdictionListQuery>;
export type SuppliersPageTaxJurisdictionListLazyQueryHookResult = ReturnType<typeof useSuppliersPageTaxJurisdictionListLazyQuery>;
export type SuppliersPageTaxJurisdictionListSuspenseQueryHookResult = ReturnType<typeof useSuppliersPageTaxJurisdictionListSuspenseQuery>;
export type SuppliersPageTaxJurisdictionListQueryResult = ApolloReactCommon.QueryResult<SuppliersPageTaxJurisdictionListQuery, SuppliersPageTaxJurisdictionListQueryVariables>;
export const SuppliersPageCreateSupplierDocument = gql`
    mutation SuppliersPageCreateSupplier($supplier: SupplierCreateInput!) {
  supplierCreate(supplier: $supplier) {
    ...SupplierDetailsFragment
    __typename
  }
}
    ${SupplierDetailsFragmentFragmentDoc}`;
export type SuppliersPageCreateSupplierMutationFn = ApolloReactCommon.MutationFunction<SuppliersPageCreateSupplierMutation, SuppliersPageCreateSupplierMutationVariables>;

/**
 * __useSuppliersPageCreateSupplierMutation__
 *
 * To run a mutation, you first call `useSuppliersPageCreateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageCreateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suppliersPageCreateSupplierMutation, { data, loading, error }] = useSuppliersPageCreateSupplierMutation({
 *   variables: {
 *      supplier: // value for 'supplier'
 *   },
 * });
 */
export function useSuppliersPageCreateSupplierMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuppliersPageCreateSupplierMutation, SuppliersPageCreateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuppliersPageCreateSupplierMutation, SuppliersPageCreateSupplierMutationVariables>(SuppliersPageCreateSupplierDocument, options);
      }
export type SuppliersPageCreateSupplierMutationHookResult = ReturnType<typeof useSuppliersPageCreateSupplierMutation>;
export type SuppliersPageCreateSupplierMutationResult = ApolloReactCommon.MutationResult<SuppliersPageCreateSupplierMutation>;
export type SuppliersPageCreateSupplierMutationOptions = ApolloReactCommon.BaseMutationOptions<SuppliersPageCreateSupplierMutation, SuppliersPageCreateSupplierMutationVariables>;
export const SuppliersPageUpdateDeliverySettingDocument = gql`
    mutation SuppliersPageUpdateDeliverySetting($input: SupplierDeliverySettingInput!) {
  updateSupplierDeliverySetting(input: $input) {
    id
    __typename
  }
}
    `;
export type SuppliersPageUpdateDeliverySettingMutationFn = ApolloReactCommon.MutationFunction<SuppliersPageUpdateDeliverySettingMutation, SuppliersPageUpdateDeliverySettingMutationVariables>;

/**
 * __useSuppliersPageUpdateDeliverySettingMutation__
 *
 * To run a mutation, you first call `useSuppliersPageUpdateDeliverySettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageUpdateDeliverySettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suppliersPageUpdateDeliverySettingMutation, { data, loading, error }] = useSuppliersPageUpdateDeliverySettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuppliersPageUpdateDeliverySettingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuppliersPageUpdateDeliverySettingMutation, SuppliersPageUpdateDeliverySettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuppliersPageUpdateDeliverySettingMutation, SuppliersPageUpdateDeliverySettingMutationVariables>(SuppliersPageUpdateDeliverySettingDocument, options);
      }
export type SuppliersPageUpdateDeliverySettingMutationHookResult = ReturnType<typeof useSuppliersPageUpdateDeliverySettingMutation>;
export type SuppliersPageUpdateDeliverySettingMutationResult = ApolloReactCommon.MutationResult<SuppliersPageUpdateDeliverySettingMutation>;
export type SuppliersPageUpdateDeliverySettingMutationOptions = ApolloReactCommon.BaseMutationOptions<SuppliersPageUpdateDeliverySettingMutation, SuppliersPageUpdateDeliverySettingMutationVariables>;
export const SuppliersPageUpdateRequestToJoinDocument = gql`
    mutation SuppliersPageUpdateRequestToJoin($input: UpdateJoinRequestInput!) {
  updateRequestToJoin(input: $input) {
    __typename
    ... on UpdateJoinRequestSuccess {
      id
      status
    }
    ... on UpdateJoinRequestError {
      errorCode
      message
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;
export type SuppliersPageUpdateRequestToJoinMutationFn = ApolloReactCommon.MutationFunction<SuppliersPageUpdateRequestToJoinMutation, SuppliersPageUpdateRequestToJoinMutationVariables>;

/**
 * __useSuppliersPageUpdateRequestToJoinMutation__
 *
 * To run a mutation, you first call `useSuppliersPageUpdateRequestToJoinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageUpdateRequestToJoinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suppliersPageUpdateRequestToJoinMutation, { data, loading, error }] = useSuppliersPageUpdateRequestToJoinMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuppliersPageUpdateRequestToJoinMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuppliersPageUpdateRequestToJoinMutation, SuppliersPageUpdateRequestToJoinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuppliersPageUpdateRequestToJoinMutation, SuppliersPageUpdateRequestToJoinMutationVariables>(SuppliersPageUpdateRequestToJoinDocument, options);
      }
export type SuppliersPageUpdateRequestToJoinMutationHookResult = ReturnType<typeof useSuppliersPageUpdateRequestToJoinMutation>;
export type SuppliersPageUpdateRequestToJoinMutationResult = ApolloReactCommon.MutationResult<SuppliersPageUpdateRequestToJoinMutation>;
export type SuppliersPageUpdateRequestToJoinMutationOptions = ApolloReactCommon.BaseMutationOptions<SuppliersPageUpdateRequestToJoinMutation, SuppliersPageUpdateRequestToJoinMutationVariables>;
export const SuppliersPageUpdateSupplierDocument = gql`
    mutation SuppliersPageUpdateSupplier($supplier: SupplierUpdateInput!) {
  supplierUpdate(supplier: $supplier) {
    ...SupplierDetailsFragment
    __typename
  }
}
    ${SupplierDetailsFragmentFragmentDoc}`;
export type SuppliersPageUpdateSupplierMutationFn = ApolloReactCommon.MutationFunction<SuppliersPageUpdateSupplierMutation, SuppliersPageUpdateSupplierMutationVariables>;

/**
 * __useSuppliersPageUpdateSupplierMutation__
 *
 * To run a mutation, you first call `useSuppliersPageUpdateSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageUpdateSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suppliersPageUpdateSupplierMutation, { data, loading, error }] = useSuppliersPageUpdateSupplierMutation({
 *   variables: {
 *      supplier: // value for 'supplier'
 *   },
 * });
 */
export function useSuppliersPageUpdateSupplierMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuppliersPageUpdateSupplierMutation, SuppliersPageUpdateSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuppliersPageUpdateSupplierMutation, SuppliersPageUpdateSupplierMutationVariables>(SuppliersPageUpdateSupplierDocument, options);
      }
export type SuppliersPageUpdateSupplierMutationHookResult = ReturnType<typeof useSuppliersPageUpdateSupplierMutation>;
export type SuppliersPageUpdateSupplierMutationResult = ApolloReactCommon.MutationResult<SuppliersPageUpdateSupplierMutation>;
export type SuppliersPageUpdateSupplierMutationOptions = ApolloReactCommon.BaseMutationOptions<SuppliersPageUpdateSupplierMutation, SuppliersPageUpdateSupplierMutationVariables>;
export const SuppliersPageUpdateSupplierAccessPackageDocument = gql`
    mutation SuppliersPageUpdateSupplierAccessPackage($suppliers: [SupplierUpdateAccessPackageInput!]!) {
  updateSupplierAccessPackage(suppliers: $suppliers) {
    ... on SupplierUpdateAccessPackageSuccess {
      responseType
      errors {
        message
        supplierId
      }
    }
    ... on SupplierUpdateAccessPackageError {
      responseType
      message
    }
  }
}
    `;
export type SuppliersPageUpdateSupplierAccessPackageMutationFn = ApolloReactCommon.MutationFunction<SuppliersPageUpdateSupplierAccessPackageMutation, SuppliersPageUpdateSupplierAccessPackageMutationVariables>;

/**
 * __useSuppliersPageUpdateSupplierAccessPackageMutation__
 *
 * To run a mutation, you first call `useSuppliersPageUpdateSupplierAccessPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageUpdateSupplierAccessPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suppliersPageUpdateSupplierAccessPackageMutation, { data, loading, error }] = useSuppliersPageUpdateSupplierAccessPackageMutation({
 *   variables: {
 *      suppliers: // value for 'suppliers'
 *   },
 * });
 */
export function useSuppliersPageUpdateSupplierAccessPackageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuppliersPageUpdateSupplierAccessPackageMutation, SuppliersPageUpdateSupplierAccessPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuppliersPageUpdateSupplierAccessPackageMutation, SuppliersPageUpdateSupplierAccessPackageMutationVariables>(SuppliersPageUpdateSupplierAccessPackageDocument, options);
      }
export type SuppliersPageUpdateSupplierAccessPackageMutationHookResult = ReturnType<typeof useSuppliersPageUpdateSupplierAccessPackageMutation>;
export type SuppliersPageUpdateSupplierAccessPackageMutationResult = ApolloReactCommon.MutationResult<SuppliersPageUpdateSupplierAccessPackageMutation>;
export type SuppliersPageUpdateSupplierAccessPackageMutationOptions = ApolloReactCommon.BaseMutationOptions<SuppliersPageUpdateSupplierAccessPackageMutation, SuppliersPageUpdateSupplierAccessPackageMutationVariables>;
export const SuppliersPageUpdateSupplierDeliveryZonesDocument = gql`
    mutation SuppliersPageUpdateSupplierDeliveryZones($supplier: SupplierUpdateInput!) {
  supplierUpdate(supplier: $supplier) {
    id
    deliveryZones {
      name
      points {
        latitude
        longitude
      }
    }
  }
}
    `;
export type SuppliersPageUpdateSupplierDeliveryZonesMutationFn = ApolloReactCommon.MutationFunction<SuppliersPageUpdateSupplierDeliveryZonesMutation, SuppliersPageUpdateSupplierDeliveryZonesMutationVariables>;

/**
 * __useSuppliersPageUpdateSupplierDeliveryZonesMutation__
 *
 * To run a mutation, you first call `useSuppliersPageUpdateSupplierDeliveryZonesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageUpdateSupplierDeliveryZonesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suppliersPageUpdateSupplierDeliveryZonesMutation, { data, loading, error }] = useSuppliersPageUpdateSupplierDeliveryZonesMutation({
 *   variables: {
 *      supplier: // value for 'supplier'
 *   },
 * });
 */
export function useSuppliersPageUpdateSupplierDeliveryZonesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuppliersPageUpdateSupplierDeliveryZonesMutation, SuppliersPageUpdateSupplierDeliveryZonesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuppliersPageUpdateSupplierDeliveryZonesMutation, SuppliersPageUpdateSupplierDeliveryZonesMutationVariables>(SuppliersPageUpdateSupplierDeliveryZonesDocument, options);
      }
export type SuppliersPageUpdateSupplierDeliveryZonesMutationHookResult = ReturnType<typeof useSuppliersPageUpdateSupplierDeliveryZonesMutation>;
export type SuppliersPageUpdateSupplierDeliveryZonesMutationResult = ApolloReactCommon.MutationResult<SuppliersPageUpdateSupplierDeliveryZonesMutation>;
export type SuppliersPageUpdateSupplierDeliveryZonesMutationOptions = ApolloReactCommon.BaseMutationOptions<SuppliersPageUpdateSupplierDeliveryZonesMutation, SuppliersPageUpdateSupplierDeliveryZonesMutationVariables>;
export const SuppliersPageUpdateSupplierUserRolesDocument = gql`
    mutation SuppliersPageUpdateSupplierUserRoles($userId: String!, $rolesToAdd: [Role!]!) {
  updateSupplierUserRoles(input: {userId: $userId, rolesToAdd: $rolesToAdd}) {
    id
    role
    __typename
  }
}
    `;
export type SuppliersPageUpdateSupplierUserRolesMutationFn = ApolloReactCommon.MutationFunction<SuppliersPageUpdateSupplierUserRolesMutation, SuppliersPageUpdateSupplierUserRolesMutationVariables>;

/**
 * __useSuppliersPageUpdateSupplierUserRolesMutation__
 *
 * To run a mutation, you first call `useSuppliersPageUpdateSupplierUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageUpdateSupplierUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suppliersPageUpdateSupplierUserRolesMutation, { data, loading, error }] = useSuppliersPageUpdateSupplierUserRolesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      rolesToAdd: // value for 'rolesToAdd'
 *   },
 * });
 */
export function useSuppliersPageUpdateSupplierUserRolesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuppliersPageUpdateSupplierUserRolesMutation, SuppliersPageUpdateSupplierUserRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuppliersPageUpdateSupplierUserRolesMutation, SuppliersPageUpdateSupplierUserRolesMutationVariables>(SuppliersPageUpdateSupplierUserRolesDocument, options);
      }
export type SuppliersPageUpdateSupplierUserRolesMutationHookResult = ReturnType<typeof useSuppliersPageUpdateSupplierUserRolesMutation>;
export type SuppliersPageUpdateSupplierUserRolesMutationResult = ApolloReactCommon.MutationResult<SuppliersPageUpdateSupplierUserRolesMutation>;
export type SuppliersPageUpdateSupplierUserRolesMutationOptions = ApolloReactCommon.BaseMutationOptions<SuppliersPageUpdateSupplierUserRolesMutation, SuppliersPageUpdateSupplierUserRolesMutationVariables>;
export const SupplierAssortmentsDataDocument = gql`
    query SupplierAssortmentsData {
  supplierAssortments {
    assortments
    __typename
  }
}
    `;

/**
 * __useSupplierAssortmentsDataQuery__
 *
 * To run a query within a React component, call `useSupplierAssortmentsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierAssortmentsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierAssortmentsDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupplierAssortmentsDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>(SupplierAssortmentsDataDocument, options);
      }
export function useSupplierAssortmentsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>(SupplierAssortmentsDataDocument, options);
        }
// @ts-ignore
export function useSupplierAssortmentsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>;
export function useSupplierAssortmentsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SupplierAssortmentsDataQuery | undefined, SupplierAssortmentsDataQueryVariables>;
export function useSupplierAssortmentsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>(SupplierAssortmentsDataDocument, options);
        }
export type SupplierAssortmentsDataQueryHookResult = ReturnType<typeof useSupplierAssortmentsDataQuery>;
export type SupplierAssortmentsDataLazyQueryHookResult = ReturnType<typeof useSupplierAssortmentsDataLazyQuery>;
export type SupplierAssortmentsDataSuspenseQueryHookResult = ReturnType<typeof useSupplierAssortmentsDataSuspenseQuery>;
export type SupplierAssortmentsDataQueryResult = ApolloReactCommon.QueryResult<SupplierAssortmentsDataQuery, SupplierAssortmentsDataQueryVariables>;
export const SupplierDeliverySettingDataDocument = gql`
    query SupplierDeliverySettingData($supplierId: ID!) {
  supplierDeliverySetting(id: $supplierId) {
    ...SupplierDeliverySettingFragment
    __typename
  }
}
    ${SupplierDeliverySettingFragmentFragmentDoc}`;

/**
 * __useSupplierDeliverySettingDataQuery__
 *
 * To run a query within a React component, call `useSupplierDeliverySettingDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierDeliverySettingDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierDeliverySettingDataQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useSupplierDeliverySettingDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables> & ({ variables: SupplierDeliverySettingDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>(SupplierDeliverySettingDataDocument, options);
      }
export function useSupplierDeliverySettingDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>(SupplierDeliverySettingDataDocument, options);
        }
// @ts-ignore
export function useSupplierDeliverySettingDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>;
export function useSupplierDeliverySettingDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SupplierDeliverySettingDataQuery | undefined, SupplierDeliverySettingDataQueryVariables>;
export function useSupplierDeliverySettingDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>(SupplierDeliverySettingDataDocument, options);
        }
export type SupplierDeliverySettingDataQueryHookResult = ReturnType<typeof useSupplierDeliverySettingDataQuery>;
export type SupplierDeliverySettingDataLazyQueryHookResult = ReturnType<typeof useSupplierDeliverySettingDataLazyQuery>;
export type SupplierDeliverySettingDataSuspenseQueryHookResult = ReturnType<typeof useSupplierDeliverySettingDataSuspenseQuery>;
export type SupplierDeliverySettingDataQueryResult = ApolloReactCommon.QueryResult<SupplierDeliverySettingDataQuery, SupplierDeliverySettingDataQueryVariables>;
export const GetSupplierDetailsDataDocument = gql`
    query GetSupplierDetailsData($id: ID!) {
  supplier(id: $id) {
    ...SupplierDetailsFragment
    __typename
  }
}
    ${SupplierDetailsFragmentFragmentDoc}`;

/**
 * __useGetSupplierDetailsDataQuery__
 *
 * To run a query within a React component, call `useGetSupplierDetailsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupplierDetailsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupplierDetailsDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSupplierDetailsDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables> & ({ variables: GetSupplierDetailsDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>(GetSupplierDetailsDataDocument, options);
      }
export function useGetSupplierDetailsDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>(GetSupplierDetailsDataDocument, options);
        }
// @ts-ignore
export function useGetSupplierDetailsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>;
export function useGetSupplierDetailsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSupplierDetailsDataQuery | undefined, GetSupplierDetailsDataQueryVariables>;
export function useGetSupplierDetailsDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>(GetSupplierDetailsDataDocument, options);
        }
export type GetSupplierDetailsDataQueryHookResult = ReturnType<typeof useGetSupplierDetailsDataQuery>;
export type GetSupplierDetailsDataLazyQueryHookResult = ReturnType<typeof useGetSupplierDetailsDataLazyQuery>;
export type GetSupplierDetailsDataSuspenseQueryHookResult = ReturnType<typeof useGetSupplierDetailsDataSuspenseQuery>;
export type GetSupplierDetailsDataQueryResult = ApolloReactCommon.QueryResult<GetSupplierDetailsDataQuery, GetSupplierDetailsDataQueryVariables>;
export const SuppliersPageGetRequestsToJoinDocument = gql`
    query SuppliersPageGetRequestsToJoin($supplierEntityId: String!, $first: Int) {
  getRequestsToJoin(query: {supplierEntityId: $supplierEntityId}, first: $first) {
    __typename
    ... on RequestsToJoinConnection {
      edges {
        cursor
        node {
          ...SuppliersPageJoinRequestFragment
        }
      }
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    ${SuppliersPageJoinRequestFragmentFragmentDoc}`;

/**
 * __useSuppliersPageGetRequestsToJoinQuery__
 *
 * To run a query within a React component, call `useSuppliersPageGetRequestsToJoinQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageGetRequestsToJoinQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersPageGetRequestsToJoinQuery({
 *   variables: {
 *      supplierEntityId: // value for 'supplierEntityId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSuppliersPageGetRequestsToJoinQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuppliersPageGetRequestsToJoinQuery, SuppliersPageGetRequestsToJoinQueryVariables> & ({ variables: SuppliersPageGetRequestsToJoinQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuppliersPageGetRequestsToJoinQuery, SuppliersPageGetRequestsToJoinQueryVariables>(SuppliersPageGetRequestsToJoinDocument, options);
      }
export function useSuppliersPageGetRequestsToJoinLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuppliersPageGetRequestsToJoinQuery, SuppliersPageGetRequestsToJoinQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuppliersPageGetRequestsToJoinQuery, SuppliersPageGetRequestsToJoinQueryVariables>(SuppliersPageGetRequestsToJoinDocument, options);
        }
// @ts-ignore
export function useSuppliersPageGetRequestsToJoinSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageGetRequestsToJoinQuery, SuppliersPageGetRequestsToJoinQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageGetRequestsToJoinQuery, SuppliersPageGetRequestsToJoinQueryVariables>;
export function useSuppliersPageGetRequestsToJoinSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageGetRequestsToJoinQuery, SuppliersPageGetRequestsToJoinQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageGetRequestsToJoinQuery | undefined, SuppliersPageGetRequestsToJoinQueryVariables>;
export function useSuppliersPageGetRequestsToJoinSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageGetRequestsToJoinQuery, SuppliersPageGetRequestsToJoinQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuppliersPageGetRequestsToJoinQuery, SuppliersPageGetRequestsToJoinQueryVariables>(SuppliersPageGetRequestsToJoinDocument, options);
        }
export type SuppliersPageGetRequestsToJoinQueryHookResult = ReturnType<typeof useSuppliersPageGetRequestsToJoinQuery>;
export type SuppliersPageGetRequestsToJoinLazyQueryHookResult = ReturnType<typeof useSuppliersPageGetRequestsToJoinLazyQuery>;
export type SuppliersPageGetRequestsToJoinSuspenseQueryHookResult = ReturnType<typeof useSuppliersPageGetRequestsToJoinSuspenseQuery>;
export type SuppliersPageGetRequestsToJoinQueryResult = ApolloReactCommon.QueryResult<SuppliersPageGetRequestsToJoinQuery, SuppliersPageGetRequestsToJoinQueryVariables>;
export const SuppliersPageGetSupplierUsersDocument = gql`
    query SuppliersPageGetSupplierUsers($id: ID!, $first: Int) {
  supplier(id: $id) {
    id
    users(first: $first) {
      edges {
        node {
          id
          name
          email
          phone
          role
          botUser
          profileImage {
            url
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSuppliersPageGetSupplierUsersQuery__
 *
 * To run a query within a React component, call `useSuppliersPageGetSupplierUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppliersPageGetSupplierUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppliersPageGetSupplierUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSuppliersPageGetSupplierUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuppliersPageGetSupplierUsersQuery, SuppliersPageGetSupplierUsersQueryVariables> & ({ variables: SuppliersPageGetSupplierUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuppliersPageGetSupplierUsersQuery, SuppliersPageGetSupplierUsersQueryVariables>(SuppliersPageGetSupplierUsersDocument, options);
      }
export function useSuppliersPageGetSupplierUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuppliersPageGetSupplierUsersQuery, SuppliersPageGetSupplierUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuppliersPageGetSupplierUsersQuery, SuppliersPageGetSupplierUsersQueryVariables>(SuppliersPageGetSupplierUsersDocument, options);
        }
// @ts-ignore
export function useSuppliersPageGetSupplierUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageGetSupplierUsersQuery, SuppliersPageGetSupplierUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageGetSupplierUsersQuery, SuppliersPageGetSupplierUsersQueryVariables>;
export function useSuppliersPageGetSupplierUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageGetSupplierUsersQuery, SuppliersPageGetSupplierUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuppliersPageGetSupplierUsersQuery | undefined, SuppliersPageGetSupplierUsersQueryVariables>;
export function useSuppliersPageGetSupplierUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuppliersPageGetSupplierUsersQuery, SuppliersPageGetSupplierUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuppliersPageGetSupplierUsersQuery, SuppliersPageGetSupplierUsersQueryVariables>(SuppliersPageGetSupplierUsersDocument, options);
        }
export type SuppliersPageGetSupplierUsersQueryHookResult = ReturnType<typeof useSuppliersPageGetSupplierUsersQuery>;
export type SuppliersPageGetSupplierUsersLazyQueryHookResult = ReturnType<typeof useSuppliersPageGetSupplierUsersLazyQuery>;
export type SuppliersPageGetSupplierUsersSuspenseQueryHookResult = ReturnType<typeof useSuppliersPageGetSupplierUsersSuspenseQuery>;
export type SuppliersPageGetSupplierUsersQueryResult = ApolloReactCommon.QueryResult<SuppliersPageGetSupplierUsersQuery, SuppliersPageGetSupplierUsersQueryVariables>;
export const SupplierSearchDataDocument = gql`
    query SupplierSearchData($search: String!, $first: Int, $before: String, $after: String, $filter: SupplierSearchFilter) {
  supplierSearch(
    query: {keywords: $search, filter: $filter}
    first: $first
    before: $before
    after: $after
  ) {
    ...SearchSupplierConnectionFragment
    __typename
  }
}
    ${SearchSupplierConnectionFragmentFragmentDoc}`;

/**
 * __useSupplierSearchDataQuery__
 *
 * To run a query within a React component, call `useSupplierSearchDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupplierSearchDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierSearchDataQuery({
 *   variables: {
 *      search: // value for 'search'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSupplierSearchDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SupplierSearchDataQuery, SupplierSearchDataQueryVariables> & ({ variables: SupplierSearchDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>(SupplierSearchDataDocument, options);
      }
export function useSupplierSearchDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>(SupplierSearchDataDocument, options);
        }
// @ts-ignore
export function useSupplierSearchDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>;
export function useSupplierSearchDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SupplierSearchDataQuery | undefined, SupplierSearchDataQueryVariables>;
export function useSupplierSearchDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>(SupplierSearchDataDocument, options);
        }
export type SupplierSearchDataQueryHookResult = ReturnType<typeof useSupplierSearchDataQuery>;
export type SupplierSearchDataLazyQueryHookResult = ReturnType<typeof useSupplierSearchDataLazyQuery>;
export type SupplierSearchDataSuspenseQueryHookResult = ReturnType<typeof useSupplierSearchDataSuspenseQuery>;
export type SupplierSearchDataQueryResult = ApolloReactCommon.QueryResult<SupplierSearchDataQuery, SupplierSearchDataQueryVariables>;
export const AddUserToChatsDocument = gql`
    mutation AddUserToChats($userId: ID!, $chatIds: [ID!]!) {
  addUserToChats(userId: $userId, chatIds: $chatIds)
}
    `;
export type AddUserToChatsMutationFn = ApolloReactCommon.MutationFunction<AddUserToChatsMutation, AddUserToChatsMutationVariables>;

/**
 * __useAddUserToChatsMutation__
 *
 * To run a mutation, you first call `useAddUserToChatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToChatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToChatsMutation, { data, loading, error }] = useAddUserToChatsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      chatIds: // value for 'chatIds'
 *   },
 * });
 */
export function useAddUserToChatsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddUserToChatsMutation, AddUserToChatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddUserToChatsMutation, AddUserToChatsMutationVariables>(AddUserToChatsDocument, options);
      }
export type AddUserToChatsMutationHookResult = ReturnType<typeof useAddUserToChatsMutation>;
export type AddUserToChatsMutationResult = ApolloReactCommon.MutationResult<AddUserToChatsMutation>;
export type AddUserToChatsMutationOptions = ApolloReactCommon.BaseMutationOptions<AddUserToChatsMutation, AddUserToChatsMutationVariables>;
export const UsersPageBuyerAddUserDocument = gql`
    mutation UsersPageBuyerAddUser($buyerId: ID!, $userId: ID!, $input: BuyerUserInput) {
  buyerAddUser(buyerId: $buyerId, userId: $userId, input: $input) {
    buyer {
      id
    }
    user {
      id
    }
  }
}
    `;
export type UsersPageBuyerAddUserMutationFn = ApolloReactCommon.MutationFunction<UsersPageBuyerAddUserMutation, UsersPageBuyerAddUserMutationVariables>;

/**
 * __useUsersPageBuyerAddUserMutation__
 *
 * To run a mutation, you first call `useUsersPageBuyerAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersPageBuyerAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersPageBuyerAddUserMutation, { data, loading, error }] = useUsersPageBuyerAddUserMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUsersPageBuyerAddUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UsersPageBuyerAddUserMutation, UsersPageBuyerAddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UsersPageBuyerAddUserMutation, UsersPageBuyerAddUserMutationVariables>(UsersPageBuyerAddUserDocument, options);
      }
export type UsersPageBuyerAddUserMutationHookResult = ReturnType<typeof useUsersPageBuyerAddUserMutation>;
export type UsersPageBuyerAddUserMutationResult = ApolloReactCommon.MutationResult<UsersPageBuyerAddUserMutation>;
export type UsersPageBuyerAddUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UsersPageBuyerAddUserMutation, UsersPageBuyerAddUserMutationVariables>;
export const UsersPageBuyerRemoveUserDocument = gql`
    mutation UsersPageBuyerRemoveUser($buyerId: ID!, $userId: ID!) {
  buyerRemoveUser(buyerId: $buyerId, userId: $userId) {
    buyer {
      id
    }
    user {
      id
    }
  }
}
    `;
export type UsersPageBuyerRemoveUserMutationFn = ApolloReactCommon.MutationFunction<UsersPageBuyerRemoveUserMutation, UsersPageBuyerRemoveUserMutationVariables>;

/**
 * __useUsersPageBuyerRemoveUserMutation__
 *
 * To run a mutation, you first call `useUsersPageBuyerRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersPageBuyerRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersPageBuyerRemoveUserMutation, { data, loading, error }] = useUsersPageBuyerRemoveUserMutation({
 *   variables: {
 *      buyerId: // value for 'buyerId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUsersPageBuyerRemoveUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UsersPageBuyerRemoveUserMutation, UsersPageBuyerRemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UsersPageBuyerRemoveUserMutation, UsersPageBuyerRemoveUserMutationVariables>(UsersPageBuyerRemoveUserDocument, options);
      }
export type UsersPageBuyerRemoveUserMutationHookResult = ReturnType<typeof useUsersPageBuyerRemoveUserMutation>;
export type UsersPageBuyerRemoveUserMutationResult = ApolloReactCommon.MutationResult<UsersPageBuyerRemoveUserMutation>;
export type UsersPageBuyerRemoveUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UsersPageBuyerRemoveUserMutation, UsersPageBuyerRemoveUserMutationVariables>;
export const UsersPageCreateUserDocument = gql`
    mutation UsersPageCreateUser($userInput: UserCreateInput!) {
  userCreate(user: $userInput) {
    ...UsersPageCreateUserFragment
  }
}
    ${UsersPageCreateUserFragmentFragmentDoc}`;
export type UsersPageCreateUserMutationFn = ApolloReactCommon.MutationFunction<UsersPageCreateUserMutation, UsersPageCreateUserMutationVariables>;

/**
 * __useUsersPageCreateUserMutation__
 *
 * To run a mutation, you first call `useUsersPageCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersPageCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersPageCreateUserMutation, { data, loading, error }] = useUsersPageCreateUserMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *   },
 * });
 */
export function useUsersPageCreateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UsersPageCreateUserMutation, UsersPageCreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UsersPageCreateUserMutation, UsersPageCreateUserMutationVariables>(UsersPageCreateUserDocument, options);
      }
export type UsersPageCreateUserMutationHookResult = ReturnType<typeof useUsersPageCreateUserMutation>;
export type UsersPageCreateUserMutationResult = ApolloReactCommon.MutationResult<UsersPageCreateUserMutation>;
export type UsersPageCreateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UsersPageCreateUserMutation, UsersPageCreateUserMutationVariables>;
export const UsersPageDeleteUserDocument = gql`
    mutation UsersPageDeleteUser($input: UserRequestToDeleteInput!) {
  userRequestToDelete(input: $input) {
    ... on UserRequestToDeleteDetails {
      success
    }
  }
}
    `;
export type UsersPageDeleteUserMutationFn = ApolloReactCommon.MutationFunction<UsersPageDeleteUserMutation, UsersPageDeleteUserMutationVariables>;

/**
 * __useUsersPageDeleteUserMutation__
 *
 * To run a mutation, you first call `useUsersPageDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersPageDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersPageDeleteUserMutation, { data, loading, error }] = useUsersPageDeleteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUsersPageDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UsersPageDeleteUserMutation, UsersPageDeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UsersPageDeleteUserMutation, UsersPageDeleteUserMutationVariables>(UsersPageDeleteUserDocument, options);
      }
export type UsersPageDeleteUserMutationHookResult = ReturnType<typeof useUsersPageDeleteUserMutation>;
export type UsersPageDeleteUserMutationResult = ApolloReactCommon.MutationResult<UsersPageDeleteUserMutation>;
export type UsersPageDeleteUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UsersPageDeleteUserMutation, UsersPageDeleteUserMutationVariables>;
export const UsersPageUserConfirmDocument = gql`
    mutation UsersPageUserConfirm($phone: String!) {
  userConfirm(newUserPool: false, phone: $phone)
}
    `;
export type UsersPageUserConfirmMutationFn = ApolloReactCommon.MutationFunction<UsersPageUserConfirmMutation, UsersPageUserConfirmMutationVariables>;

/**
 * __useUsersPageUserConfirmMutation__
 *
 * To run a mutation, you first call `useUsersPageUserConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersPageUserConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersPageUserConfirmMutation, { data, loading, error }] = useUsersPageUserConfirmMutation({
 *   variables: {
 *      phone: // value for 'phone'
 *   },
 * });
 */
export function useUsersPageUserConfirmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UsersPageUserConfirmMutation, UsersPageUserConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UsersPageUserConfirmMutation, UsersPageUserConfirmMutationVariables>(UsersPageUserConfirmDocument, options);
      }
export type UsersPageUserConfirmMutationHookResult = ReturnType<typeof useUsersPageUserConfirmMutation>;
export type UsersPageUserConfirmMutationResult = ApolloReactCommon.MutationResult<UsersPageUserConfirmMutation>;
export type UsersPageUserConfirmMutationOptions = ApolloReactCommon.BaseMutationOptions<UsersPageUserConfirmMutation, UsersPageUserConfirmMutationVariables>;
export const RemoveUserFromChatsDocument = gql`
    mutation RemoveUserFromChats($userId: ID!, $chatIds: [ID!]!) {
  removeUserFromChats(userId: $userId, chatIds: $chatIds)
}
    `;
export type RemoveUserFromChatsMutationFn = ApolloReactCommon.MutationFunction<RemoveUserFromChatsMutation, RemoveUserFromChatsMutationVariables>;

/**
 * __useRemoveUserFromChatsMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromChatsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromChatsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromChatsMutation, { data, loading, error }] = useRemoveUserFromChatsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      chatIds: // value for 'chatIds'
 *   },
 * });
 */
export function useRemoveUserFromChatsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveUserFromChatsMutation, RemoveUserFromChatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveUserFromChatsMutation, RemoveUserFromChatsMutationVariables>(RemoveUserFromChatsDocument, options);
      }
export type RemoveUserFromChatsMutationHookResult = ReturnType<typeof useRemoveUserFromChatsMutation>;
export type RemoveUserFromChatsMutationResult = ApolloReactCommon.MutationResult<RemoveUserFromChatsMutation>;
export type RemoveUserFromChatsMutationOptions = ApolloReactCommon.BaseMutationOptions<RemoveUserFromChatsMutation, RemoveUserFromChatsMutationVariables>;
export const SafelistTwilioUserDocument = gql`
    mutation SafelistTwilioUser($id: ID!) {
  safelistTwilioUser(id: $id) {
    ... on SafelistTwilioUserSuccess {
      __typename
      successMessage: message
    }
    ... on SafelistTwilioUserFailure {
      __typename
      failureMessage: message
      responseType
    }
    ... on NotFoundError {
      message
      responseType
      __typename
    }
    ... on InputValidationFailure {
      message
      responseType
      invalidFields {
        fieldName
        reason
        __typename
      }
      __typename
    }
    ... on AuthorizationFailure {
      message
      responseType
      __typename
    }
    __typename
  }
}
    `;
export type SafelistTwilioUserMutationFn = ApolloReactCommon.MutationFunction<SafelistTwilioUserMutation, SafelistTwilioUserMutationVariables>;

/**
 * __useSafelistTwilioUserMutation__
 *
 * To run a mutation, you first call `useSafelistTwilioUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSafelistTwilioUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [safelistTwilioUserMutation, { data, loading, error }] = useSafelistTwilioUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSafelistTwilioUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SafelistTwilioUserMutation, SafelistTwilioUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SafelistTwilioUserMutation, SafelistTwilioUserMutationVariables>(SafelistTwilioUserDocument, options);
      }
export type SafelistTwilioUserMutationHookResult = ReturnType<typeof useSafelistTwilioUserMutation>;
export type SafelistTwilioUserMutationResult = ApolloReactCommon.MutationResult<SafelistTwilioUserMutation>;
export type SafelistTwilioUserMutationOptions = ApolloReactCommon.BaseMutationOptions<SafelistTwilioUserMutation, SafelistTwilioUserMutationVariables>;
export const SupplierAddUserDocument = gql`
    mutation SupplierAddUser($userId: String!, $supplierId: String, $withRoles: Boolean!) {
  userUpdate(user: {id: $userId, supplierId: $supplierId}) {
    ...UserDetailsFragment
    __typename
  }
}
    ${UserDetailsFragmentFragmentDoc}`;
export type SupplierAddUserMutationFn = ApolloReactCommon.MutationFunction<SupplierAddUserMutation, SupplierAddUserMutationVariables>;

/**
 * __useSupplierAddUserMutation__
 *
 * To run a mutation, you first call `useSupplierAddUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupplierAddUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supplierAddUserMutation, { data, loading, error }] = useSupplierAddUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      supplierId: // value for 'supplierId'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useSupplierAddUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SupplierAddUserMutation, SupplierAddUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SupplierAddUserMutation, SupplierAddUserMutationVariables>(SupplierAddUserDocument, options);
      }
export type SupplierAddUserMutationHookResult = ReturnType<typeof useSupplierAddUserMutation>;
export type SupplierAddUserMutationResult = ApolloReactCommon.MutationResult<SupplierAddUserMutation>;
export type SupplierAddUserMutationOptions = ApolloReactCommon.BaseMutationOptions<SupplierAddUserMutation, SupplierAddUserMutationVariables>;
export const SupplierRemoveUserDocument = gql`
    mutation SupplierRemoveUser($userId: String!, $withRoles: Boolean!) {
  userUpdate(user: {id: $userId, supplierId: null}) {
    ...SupplierRemoveUserDetailsFragment
    __typename
  }
}
    ${SupplierRemoveUserDetailsFragmentFragmentDoc}`;
export type SupplierRemoveUserMutationFn = ApolloReactCommon.MutationFunction<SupplierRemoveUserMutation, SupplierRemoveUserMutationVariables>;

/**
 * __useSupplierRemoveUserMutation__
 *
 * To run a mutation, you first call `useSupplierRemoveUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupplierRemoveUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supplierRemoveUserMutation, { data, loading, error }] = useSupplierRemoveUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      withRoles: // value for 'withRoles'
 *   },
 * });
 */
export function useSupplierRemoveUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SupplierRemoveUserMutation, SupplierRemoveUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SupplierRemoveUserMutation, SupplierRemoveUserMutationVariables>(SupplierRemoveUserDocument, options);
      }
export type SupplierRemoveUserMutationHookResult = ReturnType<typeof useSupplierRemoveUserMutation>;
export type SupplierRemoveUserMutationResult = ApolloReactCommon.MutationResult<SupplierRemoveUserMutation>;
export type SupplierRemoveUserMutationOptions = ApolloReactCommon.BaseMutationOptions<SupplierRemoveUserMutation, SupplierRemoveUserMutationVariables>;
export const SyncCognitoUserDocument = gql`
    mutation SyncCognitoUser($id: ID!) {
  syncCognitoUser(id: $id) {
    ... on SyncCognitoUserSuccess {
      __typename
      state {
        ...CognitoStateFragment
      }
    }
    ... on SyncCognitoUserFailure {
      __typename
      failureMessage: message
      responseType
    }
    ... on NotFoundError {
      message
      responseType
      __typename
    }
    ... on AuthorizationFailure {
      message
      responseType
      __typename
    }
    __typename
  }
}
    ${CognitoStateFragmentFragmentDoc}`;
export type SyncCognitoUserMutationFn = ApolloReactCommon.MutationFunction<SyncCognitoUserMutation, SyncCognitoUserMutationVariables>;

/**
 * __useSyncCognitoUserMutation__
 *
 * To run a mutation, you first call `useSyncCognitoUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCognitoUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCognitoUserMutation, { data, loading, error }] = useSyncCognitoUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncCognitoUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncCognitoUserMutation, SyncCognitoUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncCognitoUserMutation, SyncCognitoUserMutationVariables>(SyncCognitoUserDocument, options);
      }
export type SyncCognitoUserMutationHookResult = ReturnType<typeof useSyncCognitoUserMutation>;
export type SyncCognitoUserMutationResult = ApolloReactCommon.MutationResult<SyncCognitoUserMutation>;
export type SyncCognitoUserMutationOptions = ApolloReactCommon.BaseMutationOptions<SyncCognitoUserMutation, SyncCognitoUserMutationVariables>;
export const UsersPageUpdateSupplierUserRolesDocument = gql`
    mutation UsersPageUpdateSupplierUserRoles($userId: String!, $rolesToAdd: [Role!]!) {
  updateSupplierUserRoles(input: {userId: $userId, rolesToAdd: $rolesToAdd}) {
    id
    role
    __typename
  }
}
    `;
export type UsersPageUpdateSupplierUserRolesMutationFn = ApolloReactCommon.MutationFunction<UsersPageUpdateSupplierUserRolesMutation, UsersPageUpdateSupplierUserRolesMutationVariables>;

/**
 * __useUsersPageUpdateSupplierUserRolesMutation__
 *
 * To run a mutation, you first call `useUsersPageUpdateSupplierUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersPageUpdateSupplierUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersPageUpdateSupplierUserRolesMutation, { data, loading, error }] = useUsersPageUpdateSupplierUserRolesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      rolesToAdd: // value for 'rolesToAdd'
 *   },
 * });
 */
export function useUsersPageUpdateSupplierUserRolesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UsersPageUpdateSupplierUserRolesMutation, UsersPageUpdateSupplierUserRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UsersPageUpdateSupplierUserRolesMutation, UsersPageUpdateSupplierUserRolesMutationVariables>(UsersPageUpdateSupplierUserRolesDocument, options);
      }
export type UsersPageUpdateSupplierUserRolesMutationHookResult = ReturnType<typeof useUsersPageUpdateSupplierUserRolesMutation>;
export type UsersPageUpdateSupplierUserRolesMutationResult = ApolloReactCommon.MutationResult<UsersPageUpdateSupplierUserRolesMutation>;
export type UsersPageUpdateSupplierUserRolesMutationOptions = ApolloReactCommon.BaseMutationOptions<UsersPageUpdateSupplierUserRolesMutation, UsersPageUpdateSupplierUserRolesMutationVariables>;
export const UsersPageUpdateUserDocument = gql`
    mutation UsersPageUpdateUser($userUpdateInput: UserUpdateInput!) {
  userUpdate(user: $userUpdateInput) {
    ...UsersPageUserDetailsFragment
    isTest
  }
}
    ${UsersPageUserDetailsFragmentFragmentDoc}`;
export type UsersPageUpdateUserMutationFn = ApolloReactCommon.MutationFunction<UsersPageUpdateUserMutation, UsersPageUpdateUserMutationVariables>;

/**
 * __useUsersPageUpdateUserMutation__
 *
 * To run a mutation, you first call `useUsersPageUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUsersPageUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [usersPageUpdateUserMutation, { data, loading, error }] = useUsersPageUpdateUserMutation({
 *   variables: {
 *      userUpdateInput: // value for 'userUpdateInput'
 *   },
 * });
 */
export function useUsersPageUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UsersPageUpdateUserMutation, UsersPageUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UsersPageUpdateUserMutation, UsersPageUpdateUserMutationVariables>(UsersPageUpdateUserDocument, options);
      }
export type UsersPageUpdateUserMutationHookResult = ReturnType<typeof useUsersPageUpdateUserMutation>;
export type UsersPageUpdateUserMutationResult = ApolloReactCommon.MutationResult<UsersPageUpdateUserMutation>;
export type UsersPageUpdateUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UsersPageUpdateUserMutation, UsersPageUpdateUserMutationVariables>;
export const UserRemoveRoleDocument = gql`
    mutation UserRemoveRole($userId: String!, $role: Role!) {
  userRemoveRole(userId: $userId, role: $role) {
    id
    role
    __typename
  }
}
    `;
export type UserRemoveRoleMutationFn = ApolloReactCommon.MutationFunction<UserRemoveRoleMutation, UserRemoveRoleMutationVariables>;

/**
 * __useUserRemoveRoleMutation__
 *
 * To run a mutation, you first call `useUserRemoveRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserRemoveRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userRemoveRoleMutation, { data, loading, error }] = useUserRemoveRoleMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUserRemoveRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserRemoveRoleMutation, UserRemoveRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserRemoveRoleMutation, UserRemoveRoleMutationVariables>(UserRemoveRoleDocument, options);
      }
export type UserRemoveRoleMutationHookResult = ReturnType<typeof useUserRemoveRoleMutation>;
export type UserRemoveRoleMutationResult = ApolloReactCommon.MutationResult<UserRemoveRoleMutation>;
export type UserRemoveRoleMutationOptions = ApolloReactCommon.BaseMutationOptions<UserRemoveRoleMutation, UserRemoveRoleMutationVariables>;
export const GetBuyerEntityChatsDocument = gql`
    query GetBuyerEntityChats($buyerEntityId: String!, $userId: ID!, $offset: Int, $filter: SearchFilter) {
  search(
    query: {search: $buyerEntityId, type: chat, size: 50, offset: $offset, sort: {field: "title.keyword", order: asc}, filter: $filter}
  ) {
    hits {
      entity {
        ...BuyerEntityChatFragment
      }
    }
    total
  }
}
    ${BuyerEntityChatFragmentFragmentDoc}`;

/**
 * __useGetBuyerEntityChatsQuery__
 *
 * To run a query within a React component, call `useGetBuyerEntityChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerEntityChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerEntityChatsQuery({
 *   variables: {
 *      buyerEntityId: // value for 'buyerEntityId'
 *      userId: // value for 'userId'
 *      offset: // value for 'offset'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBuyerEntityChatsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables> & ({ variables: GetBuyerEntityChatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>(GetBuyerEntityChatsDocument, options);
      }
export function useGetBuyerEntityChatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>(GetBuyerEntityChatsDocument, options);
        }
// @ts-ignore
export function useGetBuyerEntityChatsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>;
export function useGetBuyerEntityChatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetBuyerEntityChatsQuery | undefined, GetBuyerEntityChatsQueryVariables>;
export function useGetBuyerEntityChatsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>(GetBuyerEntityChatsDocument, options);
        }
export type GetBuyerEntityChatsQueryHookResult = ReturnType<typeof useGetBuyerEntityChatsQuery>;
export type GetBuyerEntityChatsLazyQueryHookResult = ReturnType<typeof useGetBuyerEntityChatsLazyQuery>;
export type GetBuyerEntityChatsSuspenseQueryHookResult = ReturnType<typeof useGetBuyerEntityChatsSuspenseQuery>;
export type GetBuyerEntityChatsQueryResult = ApolloReactCommon.QueryResult<GetBuyerEntityChatsQuery, GetBuyerEntityChatsQueryVariables>;
export const UsersPageGetUserDocument = gql`
    query UsersPageGetUser($id: ID!) {
  user(id: $id) {
    ...UsersPageUserDetailsFragment
  }
}
    ${UsersPageUserDetailsFragmentFragmentDoc}`;

/**
 * __useUsersPageGetUserQuery__
 *
 * To run a query within a React component, call `useUsersPageGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersPageGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersPageGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUsersPageGetUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsersPageGetUserQuery, UsersPageGetUserQueryVariables> & ({ variables: UsersPageGetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>(UsersPageGetUserDocument, options);
      }
export function useUsersPageGetUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>(UsersPageGetUserDocument, options);
        }
// @ts-ignore
export function useUsersPageGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>;
export function useUsersPageGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersPageGetUserQuery | undefined, UsersPageGetUserQueryVariables>;
export function useUsersPageGetUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>(UsersPageGetUserDocument, options);
        }
export type UsersPageGetUserQueryHookResult = ReturnType<typeof useUsersPageGetUserQuery>;
export type UsersPageGetUserLazyQueryHookResult = ReturnType<typeof useUsersPageGetUserLazyQuery>;
export type UsersPageGetUserSuspenseQueryHookResult = ReturnType<typeof useUsersPageGetUserSuspenseQuery>;
export type UsersPageGetUserQueryResult = ApolloReactCommon.QueryResult<UsersPageGetUserQuery, UsersPageGetUserQueryVariables>;
export const GetUserCognitoStateDocument = gql`
    query GetUserCognitoState($id: ID!) {
  userCognitoState(id: $id) {
    ...CognitoStateFragment
    ... on NotFoundError {
      message
      responseType
      __typename
    }
    ... on AuthorizationFailure {
      message
      responseType
      __typename
    }
    __typename
  }
}
    ${CognitoStateFragmentFragmentDoc}`;

/**
 * __useGetUserCognitoStateQuery__
 *
 * To run a query within a React component, call `useGetUserCognitoStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCognitoStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCognitoStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserCognitoStateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables> & ({ variables: GetUserCognitoStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>(GetUserCognitoStateDocument, options);
      }
export function useGetUserCognitoStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>(GetUserCognitoStateDocument, options);
        }
// @ts-ignore
export function useGetUserCognitoStateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>;
export function useGetUserCognitoStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserCognitoStateQuery | undefined, GetUserCognitoStateQueryVariables>;
export function useGetUserCognitoStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>(GetUserCognitoStateDocument, options);
        }
export type GetUserCognitoStateQueryHookResult = ReturnType<typeof useGetUserCognitoStateQuery>;
export type GetUserCognitoStateLazyQueryHookResult = ReturnType<typeof useGetUserCognitoStateLazyQuery>;
export type GetUserCognitoStateSuspenseQueryHookResult = ReturnType<typeof useGetUserCognitoStateSuspenseQuery>;
export type GetUserCognitoStateQueryResult = ApolloReactCommon.QueryResult<GetUserCognitoStateQuery, GetUserCognitoStateQueryVariables>;
export const GetUserTwilioStateDocument = gql`
    query GetUserTwilioState($id: ID!) {
  userTwilioState(id: $id) {
    ... on UserTwilioState {
      status
      __typename
    }
    ... on UserTwilioStateError {
      __typename
      ErrorMessage: message
      responseType
    }
    ... on NotFoundError {
      message
      responseType
      __typename
    }
    ... on InputValidationFailure {
      message
      responseType
      invalidFields {
        fieldName
        reason
        __typename
      }
      __typename
    }
    ... on AuthorizationFailure {
      message
      responseType
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useGetUserTwilioStateQuery__
 *
 * To run a query within a React component, call `useGetUserTwilioStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTwilioStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTwilioStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserTwilioStateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables> & ({ variables: GetUserTwilioStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>(GetUserTwilioStateDocument, options);
      }
export function useGetUserTwilioStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>(GetUserTwilioStateDocument, options);
        }
// @ts-ignore
export function useGetUserTwilioStateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>;
export function useGetUserTwilioStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserTwilioStateQuery | undefined, GetUserTwilioStateQueryVariables>;
export function useGetUserTwilioStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>(GetUserTwilioStateDocument, options);
        }
export type GetUserTwilioStateQueryHookResult = ReturnType<typeof useGetUserTwilioStateQuery>;
export type GetUserTwilioStateLazyQueryHookResult = ReturnType<typeof useGetUserTwilioStateLazyQuery>;
export type GetUserTwilioStateSuspenseQueryHookResult = ReturnType<typeof useGetUserTwilioStateSuspenseQuery>;
export type GetUserTwilioStateQueryResult = ApolloReactCommon.QueryResult<GetUserTwilioStateQuery, GetUserTwilioStateQueryVariables>;
export const UsersPageSearchBuyerEntityDocument = gql`
    query UsersPageSearchBuyerEntity($searchTerm: String!, $size: Int = 30, $filter: SearchFilter) {
  search(query: {search: $searchTerm, type: buyer, size: $size, filter: $filter}) {
    hits {
      entity {
        ...UsersPageBuyerEntityFragment
      }
    }
  }
}
    ${UsersPageBuyerEntityFragmentFragmentDoc}`;

/**
 * __useUsersPageSearchBuyerEntityQuery__
 *
 * To run a query within a React component, call `useUsersPageSearchBuyerEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersPageSearchBuyerEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersPageSearchBuyerEntityQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      size: // value for 'size'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUsersPageSearchBuyerEntityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables> & ({ variables: UsersPageSearchBuyerEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>(UsersPageSearchBuyerEntityDocument, options);
      }
export function useUsersPageSearchBuyerEntityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>(UsersPageSearchBuyerEntityDocument, options);
        }
// @ts-ignore
export function useUsersPageSearchBuyerEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>;
export function useUsersPageSearchBuyerEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersPageSearchBuyerEntityQuery | undefined, UsersPageSearchBuyerEntityQueryVariables>;
export function useUsersPageSearchBuyerEntitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>(UsersPageSearchBuyerEntityDocument, options);
        }
export type UsersPageSearchBuyerEntityQueryHookResult = ReturnType<typeof useUsersPageSearchBuyerEntityQuery>;
export type UsersPageSearchBuyerEntityLazyQueryHookResult = ReturnType<typeof useUsersPageSearchBuyerEntityLazyQuery>;
export type UsersPageSearchBuyerEntitySuspenseQueryHookResult = ReturnType<typeof useUsersPageSearchBuyerEntitySuspenseQuery>;
export type UsersPageSearchBuyerEntityQueryResult = ApolloReactCommon.QueryResult<UsersPageSearchBuyerEntityQuery, UsersPageSearchBuyerEntityQueryVariables>;
export const SearchSuppliersDocument = gql`
    query SearchSuppliers($keywords: String!, $limit: Int = 30, $filter: SupplierSearchFilter) {
  supplierSearch(first: $limit, query: {keywords: $keywords, filter: $filter}) {
    ...UsersPageSearchSupplierConnectionFragment
    __typename
  }
}
    ${UsersPageSearchSupplierConnectionFragmentFragmentDoc}`;

/**
 * __useSearchSuppliersQuery__
 *
 * To run a query within a React component, call `useSearchSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSuppliersQuery({
 *   variables: {
 *      keywords: // value for 'keywords'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchSuppliersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SearchSuppliersQuery, SearchSuppliersQueryVariables> & ({ variables: SearchSuppliersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchSuppliersQuery, SearchSuppliersQueryVariables>(SearchSuppliersDocument, options);
      }
export function useSearchSuppliersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchSuppliersQuery, SearchSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchSuppliersQuery, SearchSuppliersQueryVariables>(SearchSuppliersDocument, options);
        }
// @ts-ignore
export function useSearchSuppliersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SearchSuppliersQuery, SearchSuppliersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchSuppliersQuery, SearchSuppliersQueryVariables>;
export function useSearchSuppliersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchSuppliersQuery, SearchSuppliersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SearchSuppliersQuery | undefined, SearchSuppliersQueryVariables>;
export function useSearchSuppliersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SearchSuppliersQuery, SearchSuppliersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SearchSuppliersQuery, SearchSuppliersQueryVariables>(SearchSuppliersDocument, options);
        }
export type SearchSuppliersQueryHookResult = ReturnType<typeof useSearchSuppliersQuery>;
export type SearchSuppliersLazyQueryHookResult = ReturnType<typeof useSearchSuppliersLazyQuery>;
export type SearchSuppliersSuspenseQueryHookResult = ReturnType<typeof useSearchSuppliersSuspenseQuery>;
export type SearchSuppliersQueryResult = ApolloReactCommon.QueryResult<SearchSuppliersQuery, SearchSuppliersQueryVariables>;
export const UsersPageSearchUsersDocument = gql`
    query UsersPageSearchUsers($query: UserSearchInput!, $limit: Int, $after: String) {
  userSearch(first: $limit, after: $after, query: $query) {
    ...UsersPageUserSearchConnectionFragment
  }
}
    ${UsersPageUserSearchConnectionFragmentFragmentDoc}`;

/**
 * __useUsersPageSearchUsersQuery__
 *
 * To run a query within a React component, call `useUsersPageSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersPageSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersPageSearchUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUsersPageSearchUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables> & ({ variables: UsersPageSearchUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>(UsersPageSearchUsersDocument, options);
      }
export function useUsersPageSearchUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>(UsersPageSearchUsersDocument, options);
        }
// @ts-ignore
export function useUsersPageSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>;
export function useUsersPageSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersPageSearchUsersQuery | undefined, UsersPageSearchUsersQueryVariables>;
export function useUsersPageSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>(UsersPageSearchUsersDocument, options);
        }
export type UsersPageSearchUsersQueryHookResult = ReturnType<typeof useUsersPageSearchUsersQuery>;
export type UsersPageSearchUsersLazyQueryHookResult = ReturnType<typeof useUsersPageSearchUsersLazyQuery>;
export type UsersPageSearchUsersSuspenseQueryHookResult = ReturnType<typeof useUsersPageSearchUsersSuspenseQuery>;
export type UsersPageSearchUsersQueryResult = ApolloReactCommon.QueryResult<UsersPageSearchUsersQuery, UsersPageSearchUsersQueryVariables>;
export const WorkspacesPageCreateDocument = gql`
    mutation WorkspacesPageCreate($input: WorkspaceCreateInput!) {
  workspaceCreate(input: $input) {
    ... on WorkspaceCreateResult {
      workspace {
        id
        name
        roots {
          id
          node {
            id
            name
            hierarchyType
          }
        }
      }
    }
    ... on WorkspaceRootLocationAlreadyClaimed {
      message
      rootLocation {
        id
      }
    }
    ... on WorkspaceRootLocationNotFound {
      message
      rootLocationId
    }
    ... on WorkspaceRootLocationNotAHierarchyRoot {
      message
      rootLocation {
        id
      }
      hierarchyRoot {
        id
      }
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;
export type WorkspacesPageCreateMutationFn = ApolloReactCommon.MutationFunction<WorkspacesPageCreateMutation, WorkspacesPageCreateMutationVariables>;

/**
 * __useWorkspacesPageCreateMutation__
 *
 * To run a mutation, you first call `useWorkspacesPageCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesPageCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workspacesPageCreateMutation, { data, loading, error }] = useWorkspacesPageCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkspacesPageCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WorkspacesPageCreateMutation, WorkspacesPageCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<WorkspacesPageCreateMutation, WorkspacesPageCreateMutationVariables>(WorkspacesPageCreateDocument, options);
      }
export type WorkspacesPageCreateMutationHookResult = ReturnType<typeof useWorkspacesPageCreateMutation>;
export type WorkspacesPageCreateMutationResult = ApolloReactCommon.MutationResult<WorkspacesPageCreateMutation>;
export type WorkspacesPageCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<WorkspacesPageCreateMutation, WorkspacesPageCreateMutationVariables>;
export const WorkspacesPageAddMemberDocument = gql`
    mutation WorkspacesPageAddMember($input: TeamMemberAddInput!) {
  teamMemberAdd(input: $input) {
    ... on TeamMemberAddResult {
      teamMember {
        id
        user {
          id
        }
      }
    }
    ... on WorkspaceNotFound {
      message
    }
    ... on TeamUserNotFound {
      message
      userId
    }
    ... on TeamMemberAlreadyExists {
      message
      user {
        id
      }
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;
export type WorkspacesPageAddMemberMutationFn = ApolloReactCommon.MutationFunction<WorkspacesPageAddMemberMutation, WorkspacesPageAddMemberMutationVariables>;

/**
 * __useWorkspacesPageAddMemberMutation__
 *
 * To run a mutation, you first call `useWorkspacesPageAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesPageAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workspacesPageAddMemberMutation, { data, loading, error }] = useWorkspacesPageAddMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkspacesPageAddMemberMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WorkspacesPageAddMemberMutation, WorkspacesPageAddMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<WorkspacesPageAddMemberMutation, WorkspacesPageAddMemberMutationVariables>(WorkspacesPageAddMemberDocument, options);
      }
export type WorkspacesPageAddMemberMutationHookResult = ReturnType<typeof useWorkspacesPageAddMemberMutation>;
export type WorkspacesPageAddMemberMutationResult = ApolloReactCommon.MutationResult<WorkspacesPageAddMemberMutation>;
export type WorkspacesPageAddMemberMutationOptions = ApolloReactCommon.BaseMutationOptions<WorkspacesPageAddMemberMutation, WorkspacesPageAddMemberMutationVariables>;
export const WorkspacesPageSetAssignmentsDocument = gql`
    mutation WorkspacesPageSetAssignments($input: TeamMemberSetLocationAssignmentsInput!) {
  teamMemberSetLocationAssignments(input: $input) {
    ... on TeamMemberSetLocationAssignmentsResult {
      teamMember {
        id
      }
    }
    ... on WorkspaceNotFound {
      message
    }
    ... on TeamMemberNotFound {
      message
      user {
        id
      }
    }
    ... on TeamLocationsNotFound {
      message
      locationIds
    }
    ... on TeamRolesNotFound {
      message
      roleIds
    }
    ... on TeamLocationRoleTypeMismatch {
      message
      locationType
      roleLocationType
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;
export type WorkspacesPageSetAssignmentsMutationFn = ApolloReactCommon.MutationFunction<WorkspacesPageSetAssignmentsMutation, WorkspacesPageSetAssignmentsMutationVariables>;

/**
 * __useWorkspacesPageSetAssignmentsMutation__
 *
 * To run a mutation, you first call `useWorkspacesPageSetAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesPageSetAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workspacesPageSetAssignmentsMutation, { data, loading, error }] = useWorkspacesPageSetAssignmentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkspacesPageSetAssignmentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WorkspacesPageSetAssignmentsMutation, WorkspacesPageSetAssignmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<WorkspacesPageSetAssignmentsMutation, WorkspacesPageSetAssignmentsMutationVariables>(WorkspacesPageSetAssignmentsDocument, options);
      }
export type WorkspacesPageSetAssignmentsMutationHookResult = ReturnType<typeof useWorkspacesPageSetAssignmentsMutation>;
export type WorkspacesPageSetAssignmentsMutationResult = ApolloReactCommon.MutationResult<WorkspacesPageSetAssignmentsMutation>;
export type WorkspacesPageSetAssignmentsMutationOptions = ApolloReactCommon.BaseMutationOptions<WorkspacesPageSetAssignmentsMutation, WorkspacesPageSetAssignmentsMutationVariables>;
export const WorkspacesPageRemoveAssignmentDocument = gql`
    mutation WorkspacesPageRemoveAssignment($input: TeamMemberRemoveLocationAssignmentInput!) {
  teamMemberRemoveLocationAssignment(input: $input) {
    ... on TeamMemberRemoveLocationAssignmentResult {
      removedFromWorkspace
    }
    ... on TeamMemberWouldBeRemovedFromWorkspace {
      message
      user {
        id
      }
    }
    ... on TeamRoleNotAssignedAtLocation {
      message
    }
    ... on TeamLocationNotFound {
      message
    }
    ... on WorkspaceNotFound {
      message
      workspaceId
    }
    ... on TeamMemberNotFound {
      message
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;
export type WorkspacesPageRemoveAssignmentMutationFn = ApolloReactCommon.MutationFunction<WorkspacesPageRemoveAssignmentMutation, WorkspacesPageRemoveAssignmentMutationVariables>;

/**
 * __useWorkspacesPageRemoveAssignmentMutation__
 *
 * To run a mutation, you first call `useWorkspacesPageRemoveAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesPageRemoveAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workspacesPageRemoveAssignmentMutation, { data, loading, error }] = useWorkspacesPageRemoveAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkspacesPageRemoveAssignmentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WorkspacesPageRemoveAssignmentMutation, WorkspacesPageRemoveAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<WorkspacesPageRemoveAssignmentMutation, WorkspacesPageRemoveAssignmentMutationVariables>(WorkspacesPageRemoveAssignmentDocument, options);
      }
export type WorkspacesPageRemoveAssignmentMutationHookResult = ReturnType<typeof useWorkspacesPageRemoveAssignmentMutation>;
export type WorkspacesPageRemoveAssignmentMutationResult = ApolloReactCommon.MutationResult<WorkspacesPageRemoveAssignmentMutation>;
export type WorkspacesPageRemoveAssignmentMutationOptions = ApolloReactCommon.BaseMutationOptions<WorkspacesPageRemoveAssignmentMutation, WorkspacesPageRemoveAssignmentMutationVariables>;
export const WorkspacesPageRevokeAllDocument = gql`
    mutation WorkspacesPageRevokeAll($input: TeamMemberRevokeAllWorkspaceAccessInput!) {
  teamMemberRevokeAllWorkspaceAccess(input: $input) {
    ... on TeamMemberRevokeAllWorkspaceAccessResult {
      user {
        id
      }
    }
    ... on WorkspaceNotFound {
      message
    }
    ... on TeamMemberNotFound {
      message
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;
export type WorkspacesPageRevokeAllMutationFn = ApolloReactCommon.MutationFunction<WorkspacesPageRevokeAllMutation, WorkspacesPageRevokeAllMutationVariables>;

/**
 * __useWorkspacesPageRevokeAllMutation__
 *
 * To run a mutation, you first call `useWorkspacesPageRevokeAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesPageRevokeAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [workspacesPageRevokeAllMutation, { data, loading, error }] = useWorkspacesPageRevokeAllMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkspacesPageRevokeAllMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<WorkspacesPageRevokeAllMutation, WorkspacesPageRevokeAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<WorkspacesPageRevokeAllMutation, WorkspacesPageRevokeAllMutationVariables>(WorkspacesPageRevokeAllDocument, options);
      }
export type WorkspacesPageRevokeAllMutationHookResult = ReturnType<typeof useWorkspacesPageRevokeAllMutation>;
export type WorkspacesPageRevokeAllMutationResult = ApolloReactCommon.MutationResult<WorkspacesPageRevokeAllMutation>;
export type WorkspacesPageRevokeAllMutationOptions = ApolloReactCommon.BaseMutationOptions<WorkspacesPageRevokeAllMutation, WorkspacesPageRevokeAllMutationVariables>;
export const WorkspacesPageDirectoryDocument = gql`
    query WorkspacesPageDirectory($input: TeamDirectorySearchInput!) {
  teamDirectorySearch(input: $input) {
    ... on TeamDirectorySearchResult {
      entries {
        user {
          id
          node {
            id
            name
            email
            phone
            profileImage {
              smallSquare
            }
          }
        }
      }
      totalCount {
        ... on ExactCount {
          count
        }
        ... on AtLeastCount {
          count
        }
      }
      cursor
    }
    ... on WorkspaceNotFound {
      message
      workspaceId
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;

/**
 * __useWorkspacesPageDirectoryQuery__
 *
 * To run a query within a React component, call `useWorkspacesPageDirectoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesPageDirectoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesPageDirectoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkspacesPageDirectoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspacesPageDirectoryQuery, WorkspacesPageDirectoryQueryVariables> & ({ variables: WorkspacesPageDirectoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspacesPageDirectoryQuery, WorkspacesPageDirectoryQueryVariables>(WorkspacesPageDirectoryDocument, options);
      }
export function useWorkspacesPageDirectoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspacesPageDirectoryQuery, WorkspacesPageDirectoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspacesPageDirectoryQuery, WorkspacesPageDirectoryQueryVariables>(WorkspacesPageDirectoryDocument, options);
        }
// @ts-ignore
export function useWorkspacesPageDirectorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageDirectoryQuery, WorkspacesPageDirectoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspacesPageDirectoryQuery, WorkspacesPageDirectoryQueryVariables>;
export function useWorkspacesPageDirectorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageDirectoryQuery, WorkspacesPageDirectoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspacesPageDirectoryQuery | undefined, WorkspacesPageDirectoryQueryVariables>;
export function useWorkspacesPageDirectorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageDirectoryQuery, WorkspacesPageDirectoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspacesPageDirectoryQuery, WorkspacesPageDirectoryQueryVariables>(WorkspacesPageDirectoryDocument, options);
        }
export type WorkspacesPageDirectoryQueryHookResult = ReturnType<typeof useWorkspacesPageDirectoryQuery>;
export type WorkspacesPageDirectoryLazyQueryHookResult = ReturnType<typeof useWorkspacesPageDirectoryLazyQuery>;
export type WorkspacesPageDirectorySuspenseQueryHookResult = ReturnType<typeof useWorkspacesPageDirectorySuspenseQuery>;
export type WorkspacesPageDirectoryQueryResult = ApolloReactCommon.QueryResult<WorkspacesPageDirectoryQuery, WorkspacesPageDirectoryQueryVariables>;
export const WorkspacesPageAssignableRolesDocument = gql`
    query WorkspacesPageAssignableRoles($input: TeamAssignableLocationRolesListInput!) {
  teamAssignableLocationRolesList(input: $input) {
    ... on TeamAssignableLocationRolesListResult {
      assignableLocationRoles {
        location {
          id
          node {
            id
            name
            hierarchyType
            parent {
              id
              node {
                id
                name
              }
            }
          }
        }
        roles {
          id
          displayName
          description
          locationType
        }
      }
    }
    ... on WorkspaceNotFound {
      message
      workspaceId
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;

/**
 * __useWorkspacesPageAssignableRolesQuery__
 *
 * To run a query within a React component, call `useWorkspacesPageAssignableRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesPageAssignableRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesPageAssignableRolesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkspacesPageAssignableRolesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspacesPageAssignableRolesQuery, WorkspacesPageAssignableRolesQueryVariables> & ({ variables: WorkspacesPageAssignableRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspacesPageAssignableRolesQuery, WorkspacesPageAssignableRolesQueryVariables>(WorkspacesPageAssignableRolesDocument, options);
      }
export function useWorkspacesPageAssignableRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspacesPageAssignableRolesQuery, WorkspacesPageAssignableRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspacesPageAssignableRolesQuery, WorkspacesPageAssignableRolesQueryVariables>(WorkspacesPageAssignableRolesDocument, options);
        }
// @ts-ignore
export function useWorkspacesPageAssignableRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageAssignableRolesQuery, WorkspacesPageAssignableRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspacesPageAssignableRolesQuery, WorkspacesPageAssignableRolesQueryVariables>;
export function useWorkspacesPageAssignableRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageAssignableRolesQuery, WorkspacesPageAssignableRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspacesPageAssignableRolesQuery | undefined, WorkspacesPageAssignableRolesQueryVariables>;
export function useWorkspacesPageAssignableRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageAssignableRolesQuery, WorkspacesPageAssignableRolesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspacesPageAssignableRolesQuery, WorkspacesPageAssignableRolesQueryVariables>(WorkspacesPageAssignableRolesDocument, options);
        }
export type WorkspacesPageAssignableRolesQueryHookResult = ReturnType<typeof useWorkspacesPageAssignableRolesQuery>;
export type WorkspacesPageAssignableRolesLazyQueryHookResult = ReturnType<typeof useWorkspacesPageAssignableRolesLazyQuery>;
export type WorkspacesPageAssignableRolesSuspenseQueryHookResult = ReturnType<typeof useWorkspacesPageAssignableRolesSuspenseQuery>;
export type WorkspacesPageAssignableRolesQueryResult = ApolloReactCommon.QueryResult<WorkspacesPageAssignableRolesQuery, WorkspacesPageAssignableRolesQueryVariables>;
export const WorkspacesPageSharedAssignmentsDocument = gql`
    query WorkspacesPageSharedAssignments($input: TeamMembersInSharedLocationsListInput!) {
  teamMembersInSharedLocationsList(input: $input) {
    ... on TeamMembersInSharedLocationsListResult {
      teamMembers {
        user {
          id
          node {
            id
            name
            email
            phone
            profileImage {
              smallSquare
            }
          }
        }
        assignedLocationRoles {
          location {
            id
            node {
              id
              name
              hierarchyType
              parent {
                id
                node {
                  id
                  name
                }
              }
            }
          }
          teamRole {
            id
            displayName
            description
            locationType
          }
        }
      }
      totalCount {
        ... on ExactCount {
          count
        }
        ... on AtLeastCount {
          count
        }
      }
      cursor
    }
    ... on WorkspaceNotFound {
      message
      workspaceId
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;

/**
 * __useWorkspacesPageSharedAssignmentsQuery__
 *
 * To run a query within a React component, call `useWorkspacesPageSharedAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesPageSharedAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesPageSharedAssignmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkspacesPageSharedAssignmentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspacesPageSharedAssignmentsQuery, WorkspacesPageSharedAssignmentsQueryVariables> & ({ variables: WorkspacesPageSharedAssignmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspacesPageSharedAssignmentsQuery, WorkspacesPageSharedAssignmentsQueryVariables>(WorkspacesPageSharedAssignmentsDocument, options);
      }
export function useWorkspacesPageSharedAssignmentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspacesPageSharedAssignmentsQuery, WorkspacesPageSharedAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspacesPageSharedAssignmentsQuery, WorkspacesPageSharedAssignmentsQueryVariables>(WorkspacesPageSharedAssignmentsDocument, options);
        }
// @ts-ignore
export function useWorkspacesPageSharedAssignmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageSharedAssignmentsQuery, WorkspacesPageSharedAssignmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspacesPageSharedAssignmentsQuery, WorkspacesPageSharedAssignmentsQueryVariables>;
export function useWorkspacesPageSharedAssignmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageSharedAssignmentsQuery, WorkspacesPageSharedAssignmentsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspacesPageSharedAssignmentsQuery | undefined, WorkspacesPageSharedAssignmentsQueryVariables>;
export function useWorkspacesPageSharedAssignmentsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageSharedAssignmentsQuery, WorkspacesPageSharedAssignmentsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspacesPageSharedAssignmentsQuery, WorkspacesPageSharedAssignmentsQueryVariables>(WorkspacesPageSharedAssignmentsDocument, options);
        }
export type WorkspacesPageSharedAssignmentsQueryHookResult = ReturnType<typeof useWorkspacesPageSharedAssignmentsQuery>;
export type WorkspacesPageSharedAssignmentsLazyQueryHookResult = ReturnType<typeof useWorkspacesPageSharedAssignmentsLazyQuery>;
export type WorkspacesPageSharedAssignmentsSuspenseQueryHookResult = ReturnType<typeof useWorkspacesPageSharedAssignmentsSuspenseQuery>;
export type WorkspacesPageSharedAssignmentsQueryResult = ApolloReactCommon.QueryResult<WorkspacesPageSharedAssignmentsQuery, WorkspacesPageSharedAssignmentsQueryVariables>;
export const WorkspacesPageListDocument = gql`
    query WorkspacesPageList($input: WorkspaceListInput!) {
  workspaceList(input: $input) {
    ... on WorkspaceListResult {
      workspaces {
        id
        name
        roots {
          id
          node {
            id
            name
            hierarchyType
          }
        }
      }
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;

/**
 * __useWorkspacesPageListQuery__
 *
 * To run a query within a React component, call `useWorkspacesPageListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesPageListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesPageListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkspacesPageListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspacesPageListQuery, WorkspacesPageListQueryVariables> & ({ variables: WorkspacesPageListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspacesPageListQuery, WorkspacesPageListQueryVariables>(WorkspacesPageListDocument, options);
      }
export function useWorkspacesPageListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspacesPageListQuery, WorkspacesPageListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspacesPageListQuery, WorkspacesPageListQueryVariables>(WorkspacesPageListDocument, options);
        }
// @ts-ignore
export function useWorkspacesPageListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageListQuery, WorkspacesPageListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspacesPageListQuery, WorkspacesPageListQueryVariables>;
export function useWorkspacesPageListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageListQuery, WorkspacesPageListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspacesPageListQuery | undefined, WorkspacesPageListQueryVariables>;
export function useWorkspacesPageListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageListQuery, WorkspacesPageListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspacesPageListQuery, WorkspacesPageListQueryVariables>(WorkspacesPageListDocument, options);
        }
export type WorkspacesPageListQueryHookResult = ReturnType<typeof useWorkspacesPageListQuery>;
export type WorkspacesPageListLazyQueryHookResult = ReturnType<typeof useWorkspacesPageListLazyQuery>;
export type WorkspacesPageListSuspenseQueryHookResult = ReturnType<typeof useWorkspacesPageListSuspenseQuery>;
export type WorkspacesPageListQueryResult = ApolloReactCommon.QueryResult<WorkspacesPageListQuery, WorkspacesPageListQueryVariables>;
export const WorkspacesPageMemberDocument = gql`
    query WorkspacesPageMember($input: TeamMemberGetInput!) {
  teamMemberGet(input: $input) {
    ... on TeamMemberGetResult {
      teamMember {
        id
        user {
          id
          node {
            id
            name
            email
            phone
            profileImage {
              smallSquare
            }
          }
        }
        assignedLocationRoles {
          location {
            id
            node {
              id
              name
              hierarchyType
              parent {
                id
                node {
                  id
                  name
                }
              }
            }
          }
          teamRole {
            id
            displayName
            description
            locationType
          }
        }
      }
    }
    ... on WorkspaceNotFound {
      message
      workspaceId
    }
    ... on TeamMemberNotFound {
      message
      user {
        id
      }
    }
    ... on InputValidationFailure {
      message
    }
    ... on AuthorizationFailure {
      message
    }
  }
}
    `;

/**
 * __useWorkspacesPageMemberQuery__
 *
 * To run a query within a React component, call `useWorkspacesPageMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesPageMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesPageMemberQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorkspacesPageMemberQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspacesPageMemberQuery, WorkspacesPageMemberQueryVariables> & ({ variables: WorkspacesPageMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspacesPageMemberQuery, WorkspacesPageMemberQueryVariables>(WorkspacesPageMemberDocument, options);
      }
export function useWorkspacesPageMemberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspacesPageMemberQuery, WorkspacesPageMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspacesPageMemberQuery, WorkspacesPageMemberQueryVariables>(WorkspacesPageMemberDocument, options);
        }
// @ts-ignore
export function useWorkspacesPageMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageMemberQuery, WorkspacesPageMemberQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspacesPageMemberQuery, WorkspacesPageMemberQueryVariables>;
export function useWorkspacesPageMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageMemberQuery, WorkspacesPageMemberQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspacesPageMemberQuery | undefined, WorkspacesPageMemberQueryVariables>;
export function useWorkspacesPageMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageMemberQuery, WorkspacesPageMemberQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspacesPageMemberQuery, WorkspacesPageMemberQueryVariables>(WorkspacesPageMemberDocument, options);
        }
export type WorkspacesPageMemberQueryHookResult = ReturnType<typeof useWorkspacesPageMemberQuery>;
export type WorkspacesPageMemberLazyQueryHookResult = ReturnType<typeof useWorkspacesPageMemberLazyQuery>;
export type WorkspacesPageMemberSuspenseQueryHookResult = ReturnType<typeof useWorkspacesPageMemberSuspenseQuery>;
export type WorkspacesPageMemberQueryResult = ApolloReactCommon.QueryResult<WorkspacesPageMemberQuery, WorkspacesPageMemberQueryVariables>;
export const WorkspacesPageSearchSuppliersDocument = gql`
    query WorkspacesPageSearchSuppliers($keywords: String, $limit: Int = 30) {
  supplierSearch(first: $limit, query: {keywords: $keywords}) {
    ... on SearchSupplierConnection {
      edges {
        node {
          id
          name
          referenceId
          hierarchyType
        }
      }
    }
  }
}
    `;

/**
 * __useWorkspacesPageSearchSuppliersQuery__
 *
 * To run a query within a React component, call `useWorkspacesPageSearchSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesPageSearchSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesPageSearchSuppliersQuery({
 *   variables: {
 *      keywords: // value for 'keywords'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useWorkspacesPageSearchSuppliersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WorkspacesPageSearchSuppliersQuery, WorkspacesPageSearchSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspacesPageSearchSuppliersQuery, WorkspacesPageSearchSuppliersQueryVariables>(WorkspacesPageSearchSuppliersDocument, options);
      }
export function useWorkspacesPageSearchSuppliersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspacesPageSearchSuppliersQuery, WorkspacesPageSearchSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspacesPageSearchSuppliersQuery, WorkspacesPageSearchSuppliersQueryVariables>(WorkspacesPageSearchSuppliersDocument, options);
        }
// @ts-ignore
export function useWorkspacesPageSearchSuppliersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageSearchSuppliersQuery, WorkspacesPageSearchSuppliersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspacesPageSearchSuppliersQuery, WorkspacesPageSearchSuppliersQueryVariables>;
export function useWorkspacesPageSearchSuppliersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageSearchSuppliersQuery, WorkspacesPageSearchSuppliersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspacesPageSearchSuppliersQuery | undefined, WorkspacesPageSearchSuppliersQueryVariables>;
export function useWorkspacesPageSearchSuppliersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageSearchSuppliersQuery, WorkspacesPageSearchSuppliersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspacesPageSearchSuppliersQuery, WorkspacesPageSearchSuppliersQueryVariables>(WorkspacesPageSearchSuppliersDocument, options);
        }
export type WorkspacesPageSearchSuppliersQueryHookResult = ReturnType<typeof useWorkspacesPageSearchSuppliersQuery>;
export type WorkspacesPageSearchSuppliersLazyQueryHookResult = ReturnType<typeof useWorkspacesPageSearchSuppliersLazyQuery>;
export type WorkspacesPageSearchSuppliersSuspenseQueryHookResult = ReturnType<typeof useWorkspacesPageSearchSuppliersSuspenseQuery>;
export type WorkspacesPageSearchSuppliersQueryResult = ApolloReactCommon.QueryResult<WorkspacesPageSearchSuppliersQuery, WorkspacesPageSearchSuppliersQueryVariables>;
export const WorkspacesPageSearchUsersDocument = gql`
    query WorkspacesPageSearchUsers($query: UserSearchInput!, $limit: Int = 30) {
  userSearch(first: $limit, query: $query) {
    ... on UserSearchConnection {
      edges {
        node {
          id
          name
          email
          phone
        }
      }
    }
  }
}
    `;

/**
 * __useWorkspacesPageSearchUsersQuery__
 *
 * To run a query within a React component, call `useWorkspacesPageSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspacesPageSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspacesPageSearchUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useWorkspacesPageSearchUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<WorkspacesPageSearchUsersQuery, WorkspacesPageSearchUsersQueryVariables> & ({ variables: WorkspacesPageSearchUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<WorkspacesPageSearchUsersQuery, WorkspacesPageSearchUsersQueryVariables>(WorkspacesPageSearchUsersDocument, options);
      }
export function useWorkspacesPageSearchUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WorkspacesPageSearchUsersQuery, WorkspacesPageSearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<WorkspacesPageSearchUsersQuery, WorkspacesPageSearchUsersQueryVariables>(WorkspacesPageSearchUsersDocument, options);
        }
// @ts-ignore
export function useWorkspacesPageSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageSearchUsersQuery, WorkspacesPageSearchUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspacesPageSearchUsersQuery, WorkspacesPageSearchUsersQueryVariables>;
export function useWorkspacesPageSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageSearchUsersQuery, WorkspacesPageSearchUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<WorkspacesPageSearchUsersQuery | undefined, WorkspacesPageSearchUsersQueryVariables>;
export function useWorkspacesPageSearchUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<WorkspacesPageSearchUsersQuery, WorkspacesPageSearchUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<WorkspacesPageSearchUsersQuery, WorkspacesPageSearchUsersQueryVariables>(WorkspacesPageSearchUsersDocument, options);
        }
export type WorkspacesPageSearchUsersQueryHookResult = ReturnType<typeof useWorkspacesPageSearchUsersQuery>;
export type WorkspacesPageSearchUsersLazyQueryHookResult = ReturnType<typeof useWorkspacesPageSearchUsersLazyQuery>;
export type WorkspacesPageSearchUsersSuspenseQueryHookResult = ReturnType<typeof useWorkspacesPageSearchUsersSuspenseQuery>;
export type WorkspacesPageSearchUsersQueryResult = ApolloReactCommon.QueryResult<WorkspacesPageSearchUsersQuery, WorkspacesPageSearchUsersQueryVariables>;